!function (t) {
  const e = t.en = t.en || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "(may require <kbd>Fn</kbd>)": "(may require <kbd>Fn</kbd>)",
    "%0 of %1": "%0 of %1",
    Accept: "Accept",
    Accessibility: "Accessibility",
    "Accessibility help": "Accessibility help",
    "Align cell text to the bottom": "Align cell text to the bottom",
    "Align cell text to the center": "Align cell text to the center",
    "Align cell text to the left": "Align cell text to the left",
    "Align cell text to the middle": "Align cell text to the middle",
    "Align cell text to the right": "Align cell text to the right",
    "Align cell text to the top": "Align cell text to the top",
    "Align table to the left": "Align table to the left",
    "Align table to the right": "Align table to the right",
    Alignment: "Alignment",
    Aquamarine: "Aquamarine",
    Background: "Background",
    "Below, you can find a list of keyboard shortcuts that can be used in the editor.": "Below, you can find a list of keyboard shortcuts that can be used in the editor.",
    Black: "Black",
    "Block quote": "Block quote",
    Blue: "Blue",
    Bold: "Bold",
    "Bold text": "Bold text",
    Border: "Border",
    "Break text": "Break text",
    "Bulleted List": "Bulleted List",
    "Bulleted list styles toolbar": "Bulleted list styles toolbar",
    Cancel: "Cancel",
    "Cannot access default workspace.": "Cannot access default workspace.",
    "Cannot determine a category for the uploaded file.": "Cannot determine a category for the uploaded file.",
    "Cannot upload file:": "Cannot upload file:",
    "Caption for image: %0": "Caption for image: %0",
    "Caption for the image": "Caption for the image",
    "Cell properties": "Cell properties",
    "Center table": "Center table",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Circle: "Circle",
    Clear: "Clear",
    "Click to edit block": "Click to edit block",
    Close: "Close",
    "Close contextual balloons, dropdowns, and dialogs": "Close contextual balloons, dropdowns, and dialogs",
    Code: "Code",
    Color: "Color",
    "Color picker": "Color picker",
    Column: "Column",
    "Content editing keystrokes": "Content editing keystrokes",
    "Copy selected content": "Copy selected content",
    "Could not insert image at the current position.": "Could not insert image at the current position.",
    "Could not obtain resized image URL.": "Could not obtain resized image URL.",
    "Create link": "Create link",
    Custom: "Custom",
    "Custom image size": "Custom image size",
    Dashed: "Dashed",
    Decimal: "Decimal",
    "Decimal with leading zero": "Decimal with leading zero",
    "Decrease indent": "Decrease indent",
    "Decrease list item indent": "Decrease list item indent",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    "Dim grey": "Dim grey",
    Dimensions: "Dimensions",
    Disc: "Disc",
    Dotted: "Dotted",
    Double: "Double",
    Downloadable: "Downloadable",
    "Drag to move": "Drag to move",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Edit image": "Edit image",
    "Edit link": "Edit link",
    "Editor block content toolbar": "Editor block content toolbar",
    "Editor contextual toolbar": "Editor contextual toolbar",
    "Editor dialog": "Editor dialog",
    "Editor editing area: %0": "Editor editing area: %0",
    "Editor menu bar": "Editor menu bar",
    "Editor toolbar": "Editor toolbar",
    "Enter image caption": "Enter image caption",
    "Enter table caption": "Enter table caption",
    "Entering a to-do list": "Entering a to-do list",
    "Error during image upload": "Error during image upload",
    "Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.": "Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.",
    "Failed to determine category of edited image.": "Failed to determine category of edited image.",
    "Full size image": "Full size image",
    Green: "Green",
    Grey: "Grey",
    Groove: "Groove",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    Height: "Height",
    "Help Contents. To close this dialog press ESC.": "Help Contents. To close this dialog press ESC.",
    HEX: "HEX",
    "Horizontal text alignment toolbar": "Horizontal text alignment toolbar",
    "Image from computer": "Image from computer",
    "Image resize list": "Image resize list",
    "Image toolbar": "Image toolbar",
    "Image upload complete": "Image upload complete",
    "image widget": "image widget",
    "In line": "In line",
    "Increase indent": "Increase indent",
    "Increase list item indent": "Increase list item indent",
    Insert: "Insert",
    "Insert a hard break (a new paragraph)": "Insert a hard break (a new paragraph)",
    "Insert a new paragraph directly after a widget": "Insert a new paragraph directly after a widget",
    "Insert a new paragraph directly before a widget": "Insert a new paragraph directly before a widget",
    "Insert a new table row (when in the last cell of a table)": "Insert a new table row (when in the last cell of a table)",
    "Insert a soft break (a <code>&lt;br&gt;</code> element)": "Insert a soft break (a <code>&lt;br&gt;</code> element)",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert image": "Insert image",
    "Insert image via URL": "Insert image via URL",
    "Insert image with file manager": "Insert image with file manager",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    "Insert with file manager": "Insert with file manager",
    "Inserting image failed": "Inserting image failed",
    Inset: "Inset",
    "Invalid start index value.": "Invalid start index value.",
    Italic: "Italic",
    "Italic text": "Italic text",
    "Justify cell text": "Justify cell text",
    "Keystrokes that can be used in a list": "Keystrokes that can be used in a list",
    "Keystrokes that can be used in a table cell": "Keystrokes that can be used in a table cell",
    "Keystrokes that can be used when a widget is selected (for example: image, table, etc.)": "Keystrokes that can be used when a widget is selected (for example: image, table, etc.)",
    "Leaving a to-do list": "Leaving a to-do list",
    "Left aligned image": "Left aligned image",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Link: "Link",
    "Link image": "Link image",
    "Link URL": "Link URL",
    "Link URL must not be empty.": "Link URL must not be empty.",
    "List properties": "List properties",
    "Lower-latin": "Lower-latin",
    "Lower–roman": "Lower–roman",
    "Media toolbar": "Media toolbar",
    "Media URL": "Media URL",
    "media widget": "media widget",
    MENU_BAR_MENU_EDIT: "Edit",
    MENU_BAR_MENU_FILE: "File",
    MENU_BAR_MENU_FONT: "Font",
    MENU_BAR_MENU_FORMAT: "Format",
    MENU_BAR_MENU_HELP: "Help",
    MENU_BAR_MENU_INSERT: "Insert",
    MENU_BAR_MENU_TEXT: "Text",
    MENU_BAR_MENU_TOOLS: "Tools",
    MENU_BAR_MENU_VIEW: "View",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    "Move focus between form fields (inputs, buttons, etc.)": "Move focus between form fields (inputs, buttons, etc.)",
    "Move focus in and out of an active dialog window": "Move focus in and out of an active dialog window",
    "Move focus to the menu bar, navigate between menu bars": "Move focus to the menu bar, navigate between menu bars",
    "Move focus to the toolbar, navigate between toolbars": "Move focus to the toolbar, navigate between toolbars",
    "Move out of a link": "Move out of a link",
    "Move out of an inline code style": "Move out of an inline code style",
    "Move the caret to allow typing directly after a widget": "Move the caret to allow typing directly after a widget",
    "Move the caret to allow typing directly before a widget": "Move the caret to allow typing directly before a widget",
    "Move the selection to the next cell": "Move the selection to the next cell",
    "Move the selection to the previous cell": "Move the selection to the previous cell",
    "Navigate through the table": "Navigate through the table",
    "Navigate through the toolbar or menu bar": "Navigate through the toolbar or menu bar",
    Next: "Next",
    "No results found": "No results found",
    "No searchable items": "No searchable items",
    None: "None",
    "Numbered List": "Numbered List",
    "Numbered list styles toolbar": "Numbered list styles toolbar",
    "Open file manager": "Open file manager",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    "Open media in new tab": "Open media in new tab",
    "Open the accessibility help dialog": "Open the accessibility help dialog",
    Orange: "Orange",
    Original: "Original",
    Outset: "Outset",
    Padding: "Padding",
    Paragraph: "Paragraph",
    "Paste content": "Paste content",
    "Paste content as plain text": "Paste content as plain text",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    'Please enter a valid color (e.g. "ff0000").': 'Please enter a valid color (e.g. "ff0000").',
    "Press %0 for help.": "Press %0 for help.",
    "Press Enter to type after or press Shift + Enter to type before the widget": "Press Enter to type after or press Shift + Enter to type before the widget",
    Previous: "Previous",
    "Processing the edited image.": "Processing the edited image.",
    Purple: "Purple",
    Red: "Red",
    Redo: "Redo",
    "Remove color": "Remove color",
    "Replace from computer": "Replace from computer",
    "Replace image": "Replace image",
    "Replace image from computer": "Replace image from computer",
    "Replace image with file manager": "Replace image with file manager",
    "Replace with file manager": "Replace with file manager",
    "Resize image": "Resize image",
    "Resize image (in %0)": "Resize image (in %0)",
    "Resize image to %0": "Resize image to %0",
    "Resize image to the original size": "Resize image to the original size",
    "Restore default": "Restore default",
    "Reversed order": "Reversed order",
    "Revert autoformatting action": "Revert autoformatting action",
    "Rich Text Editor": "Rich Text Editor",
    Ridge: "Ridge",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Selecting resized image failed": "Selecting resized image failed",
    "Server failed to process the image.": "Server failed to process the image.",
    "Show more items": "Show more items",
    "Side image": "Side image",
    Solid: "Solid",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    Square: "Square",
    "Start at": "Start at",
    "Start index must be greater than 0.": "Start index must be greater than 0.",
    Strikethrough: "Strikethrough",
    "Strikethrough text": "Strikethrough text",
    Style: "Style",
    Subscript: "Subscript",
    Superscript: "Superscript",
    Table: "Table",
    "Table alignment toolbar": "Table alignment toolbar",
    "Table cell text alignment": "Table cell text alignment",
    "Table properties": "Table properties",
    "Table toolbar": "Table toolbar",
    "Text alternative": "Text alternative",
    'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".': 'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".',
    "The URL must not be empty.": "The URL must not be empty.",
    'The value is invalid. Try "10px" or "2em" or simply "2".': 'The value is invalid. Try "10px" or "2em" or simply "2".',
    "The value must not be empty.": "The value must not be empty.",
    "The value should be a plain number.": "The value should be a plain number.",
    "These keyboard shortcuts allow for quick access to content editing features.": "These keyboard shortcuts allow for quick access to content editing features.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.",
    "To-do List": "To-do List",
    "Toggle caption off": "Toggle caption off",
    "Toggle caption on": "Toggle caption on",
    "Toggle the circle list style": "Toggle the circle list style",
    "Toggle the decimal list style": "Toggle the decimal list style",
    "Toggle the decimal with leading zero list style": "Toggle the decimal with leading zero list style",
    "Toggle the disc list style": "Toggle the disc list style",
    "Toggle the lower–latin list style": "Toggle the lower–latin list style",
    "Toggle the lower–roman list style": "Toggle the lower–roman list style",
    "Toggle the square list style": "Toggle the square list style",
    "Toggle the upper–latin list style": "Toggle the upper–latin list style",
    "Toggle the upper–roman list style": "Toggle the upper–roman list style",
    Turquoise: "Turquoise",
    "Type or paste your content here.": "Type or paste your content here.",
    "Type your title": "Type your title",
    Underline: "Underline",
    "Underline text": "Underline text",
    Undo: "Undo",
    Unlink: "Unlink",
    Update: "Update",
    "Update image URL": "Update image URL",
    "Upload failed": "Upload failed",
    "Upload from computer": "Upload from computer",
    "Upload image from computer": "Upload image from computer",
    "Upload in progress": "Upload in progress",
    "Uploading image": "Uploading image",
    "Upper-latin": "Upper-latin",
    "Upper-roman": "Upper-roman",
    "Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.": "Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.",
    "User interface and content navigation keystrokes": "User interface and content navigation keystrokes",
    "Vertical text alignment toolbar": "Vertical text alignment toolbar",
    White: "White",
    "Widget toolbar": "Widget toolbar",
    Width: "Width",
    "Wrap text": "Wrap text",
    Yellow: "Yellow"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ClassicEditor = e() : t.ClassicEditor = e();
}(self, () => (() => {
  var t = {
      9246: (t, e, n) => {
        const o = n(6931),
          i = {};
        for (const t of Object.keys(o)) i[o[t]] = t;
        const r = {
          rgb: {
            channels: 3,
            labels: "rgb"
          },
          hsl: {
            channels: 3,
            labels: "hsl"
          },
          hsv: {
            channels: 3,
            labels: "hsv"
          },
          hwb: {
            channels: 3,
            labels: "hwb"
          },
          cmyk: {
            channels: 4,
            labels: "cmyk"
          },
          xyz: {
            channels: 3,
            labels: "xyz"
          },
          lab: {
            channels: 3,
            labels: "lab"
          },
          lch: {
            channels: 3,
            labels: "lch"
          },
          hex: {
            channels: 1,
            labels: ["hex"]
          },
          keyword: {
            channels: 1,
            labels: ["keyword"]
          },
          ansi16: {
            channels: 1,
            labels: ["ansi16"]
          },
          ansi256: {
            channels: 1,
            labels: ["ansi256"]
          },
          hcg: {
            channels: 3,
            labels: ["h", "c", "g"]
          },
          apple: {
            channels: 3,
            labels: ["r16", "g16", "b16"]
          },
          gray: {
            channels: 1,
            labels: ["gray"]
          }
        };
        t.exports = r;
        for (const t of Object.keys(r)) {
          if (!("channels" in r[t])) throw new Error("missing channels property: " + t);
          if (!("labels" in r[t])) throw new Error("missing channel labels property: " + t);
          if (r[t].labels.length !== r[t].channels) throw new Error("channel and label counts mismatch: " + t);
          const {
            channels: e,
            labels: n
          } = r[t];
          delete r[t].channels, delete r[t].labels, Object.defineProperty(r[t], "channels", {
            value: e
          }), Object.defineProperty(r[t], "labels", {
            value: n
          });
        }
        r.rgb.hsl = function (t) {
          const e = t[0] / 255,
            n = t[1] / 255,
            o = t[2] / 255,
            i = Math.min(e, n, o),
            r = Math.max(e, n, o),
            s = r - i;
          let a, c;
          r === i ? a = 0 : e === r ? a = (n - o) / s : n === r ? a = 2 + (o - e) / s : o === r && (a = 4 + (e - n) / s), a = Math.min(60 * a, 360), a < 0 && (a += 360);
          const l = (i + r) / 2;
          return c = r === i ? 0 : l <= .5 ? s / (r + i) : s / (2 - r - i), [a, 100 * c, 100 * l];
        }, r.rgb.hsv = function (t) {
          let e, n, o, i, r;
          const s = t[0] / 255,
            a = t[1] / 255,
            c = t[2] / 255,
            l = Math.max(s, a, c),
            d = l - Math.min(s, a, c),
            u = function (t) {
              return (l - t) / 6 / d + .5;
            };
          return 0 === d ? (i = 0, r = 0) : (r = d / l, e = u(s), n = u(a), o = u(c), s === l ? i = o - n : a === l ? i = 1 / 3 + e - o : c === l && (i = 2 / 3 + n - e), i < 0 ? i += 1 : i > 1 && (i -= 1)), [360 * i, 100 * r, 100 * l];
        }, r.rgb.hwb = function (t) {
          const e = t[0],
            n = t[1];
          let o = t[2];
          const i = r.rgb.hsl(t)[0],
            s = 1 / 255 * Math.min(e, Math.min(n, o));
          return o = 1 - 1 / 255 * Math.max(e, Math.max(n, o)), [i, 100 * s, 100 * o];
        }, r.rgb.cmyk = function (t) {
          const e = t[0] / 255,
            n = t[1] / 255,
            o = t[2] / 255,
            i = Math.min(1 - e, 1 - n, 1 - o);
          return [100 * ((1 - e - i) / (1 - i) || 0), 100 * ((1 - n - i) / (1 - i) || 0), 100 * ((1 - o - i) / (1 - i) || 0), 100 * i];
        }, r.rgb.keyword = function (t) {
          const e = i[t];
          if (e) return e;
          let n,
            r = 1 / 0;
          for (const e of Object.keys(o)) {
            const i = o[e],
              c = (a = i, ((s = t)[0] - a[0]) ** 2 + (s[1] - a[1]) ** 2 + (s[2] - a[2]) ** 2);
            c < r && (r = c, n = e);
          }
          var s, a;
          return n;
        }, r.keyword.rgb = function (t) {
          return o[t];
        }, r.rgb.xyz = function (t) {
          let e = t[0] / 255,
            n = t[1] / 255,
            o = t[2] / 255;
          e = e > .04045 ? ((e + .055) / 1.055) ** 2.4 : e / 12.92, n = n > .04045 ? ((n + .055) / 1.055) ** 2.4 : n / 12.92, o = o > .04045 ? ((o + .055) / 1.055) ** 2.4 : o / 12.92;
          return [100 * (.4124 * e + .3576 * n + .1805 * o), 100 * (.2126 * e + .7152 * n + .0722 * o), 100 * (.0193 * e + .1192 * n + .9505 * o)];
        }, r.rgb.lab = function (t) {
          const e = r.rgb.xyz(t);
          let n = e[0],
            o = e[1],
            i = e[2];
          n /= 95.047, o /= 100, i /= 108.883, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, o = o > .008856 ? o ** (1 / 3) : 7.787 * o + 16 / 116, i = i > .008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
          return [116 * o - 16, 500 * (n - o), 200 * (o - i)];
        }, r.hsl.rgb = function (t) {
          const e = t[0] / 360,
            n = t[1] / 100,
            o = t[2] / 100;
          let i, r, s;
          if (0 === n) return s = 255 * o, [s, s, s];
          i = o < .5 ? o * (1 + n) : o + n - o * n;
          const a = 2 * o - i,
            c = [0, 0, 0];
          for (let t = 0; t < 3; t++) r = e + 1 / 3 * -(t - 1), r < 0 && r++, r > 1 && r--, s = 6 * r < 1 ? a + 6 * (i - a) * r : 2 * r < 1 ? i : 3 * r < 2 ? a + (i - a) * (2 / 3 - r) * 6 : a, c[t] = 255 * s;
          return c;
        }, r.hsl.hsv = function (t) {
          const e = t[0];
          let n = t[1] / 100,
            o = t[2] / 100,
            i = n;
          const r = Math.max(o, .01);
          o *= 2, n *= o <= 1 ? o : 2 - o, i *= r <= 1 ? r : 2 - r;
          return [e, 100 * (0 === o ? 2 * i / (r + i) : 2 * n / (o + n)), 100 * ((o + n) / 2)];
        }, r.hsv.rgb = function (t) {
          const e = t[0] / 60,
            n = t[1] / 100;
          let o = t[2] / 100;
          const i = Math.floor(e) % 6,
            r = e - Math.floor(e),
            s = 255 * o * (1 - n),
            a = 255 * o * (1 - n * r),
            c = 255 * o * (1 - n * (1 - r));
          switch (o *= 255, i) {
            case 0:
              return [o, c, s];
            case 1:
              return [a, o, s];
            case 2:
              return [s, o, c];
            case 3:
              return [s, a, o];
            case 4:
              return [c, s, o];
            case 5:
              return [o, s, a];
          }
        }, r.hsv.hsl = function (t) {
          const e = t[0],
            n = t[1] / 100,
            o = t[2] / 100,
            i = Math.max(o, .01);
          let r, s;
          s = (2 - n) * o;
          const a = (2 - n) * i;
          return r = n * i, r /= a <= 1 ? a : 2 - a, r = r || 0, s /= 2, [e, 100 * r, 100 * s];
        }, r.hwb.rgb = function (t) {
          const e = t[0] / 360;
          let n = t[1] / 100,
            o = t[2] / 100;
          const i = n + o;
          let r;
          i > 1 && (n /= i, o /= i);
          const s = Math.floor(6 * e),
            a = 1 - o;
          r = 6 * e - s, 1 & s && (r = 1 - r);
          const c = n + r * (a - n);
          let l, d, u;
          switch (s) {
            default:
            case 6:
            case 0:
              l = a, d = c, u = n;
              break;
            case 1:
              l = c, d = a, u = n;
              break;
            case 2:
              l = n, d = a, u = c;
              break;
            case 3:
              l = n, d = c, u = a;
              break;
            case 4:
              l = c, d = n, u = a;
              break;
            case 5:
              l = a, d = n, u = c;
          }
          return [255 * l, 255 * d, 255 * u];
        }, r.cmyk.rgb = function (t) {
          const e = t[0] / 100,
            n = t[1] / 100,
            o = t[2] / 100,
            i = t[3] / 100;
          return [255 * (1 - Math.min(1, e * (1 - i) + i)), 255 * (1 - Math.min(1, n * (1 - i) + i)), 255 * (1 - Math.min(1, o * (1 - i) + i))];
        }, r.xyz.rgb = function (t) {
          const e = t[0] / 100,
            n = t[1] / 100,
            o = t[2] / 100;
          let i, r, s;
          return i = 3.2406 * e + -1.5372 * n + -.4986 * o, r = -.9689 * e + 1.8758 * n + .0415 * o, s = .0557 * e + -.204 * n + 1.057 * o, i = i > .0031308 ? 1.055 * i ** (1 / 2.4) - .055 : 12.92 * i, r = r > .0031308 ? 1.055 * r ** (1 / 2.4) - .055 : 12.92 * r, s = s > .0031308 ? 1.055 * s ** (1 / 2.4) - .055 : 12.92 * s, i = Math.min(Math.max(0, i), 1), r = Math.min(Math.max(0, r), 1), s = Math.min(Math.max(0, s), 1), [255 * i, 255 * r, 255 * s];
        }, r.xyz.lab = function (t) {
          let e = t[0],
            n = t[1],
            o = t[2];
          e /= 95.047, n /= 100, o /= 108.883, e = e > .008856 ? e ** (1 / 3) : 7.787 * e + 16 / 116, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, o = o > .008856 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
          return [116 * n - 16, 500 * (e - n), 200 * (n - o)];
        }, r.lab.xyz = function (t) {
          let e, n, o;
          n = (t[0] + 16) / 116, e = t[1] / 500 + n, o = n - t[2] / 200;
          const i = n ** 3,
            r = e ** 3,
            s = o ** 3;
          return n = i > .008856 ? i : (n - 16 / 116) / 7.787, e = r > .008856 ? r : (e - 16 / 116) / 7.787, o = s > .008856 ? s : (o - 16 / 116) / 7.787, e *= 95.047, n *= 100, o *= 108.883, [e, n, o];
        }, r.lab.lch = function (t) {
          const e = t[0],
            n = t[1],
            o = t[2];
          let i;
          i = 360 * Math.atan2(o, n) / 2 / Math.PI, i < 0 && (i += 360);
          return [e, Math.sqrt(n * n + o * o), i];
        }, r.lch.lab = function (t) {
          const e = t[0],
            n = t[1],
            o = t[2] / 360 * 2 * Math.PI;
          return [e, n * Math.cos(o), n * Math.sin(o)];
        }, r.rgb.ansi16 = function (t, e = null) {
          const [n, o, i] = t;
          let s = null === e ? r.rgb.hsv(t)[2] : e;
          if (s = Math.round(s / 50), 0 === s) return 30;
          let a = 30 + (Math.round(i / 255) << 2 | Math.round(o / 255) << 1 | Math.round(n / 255));
          return 2 === s && (a += 60), a;
        }, r.hsv.ansi16 = function (t) {
          return r.rgb.ansi16(r.hsv.rgb(t), t[2]);
        }, r.rgb.ansi256 = function (t) {
          const e = t[0],
            n = t[1],
            o = t[2];
          if (e === n && n === o) return e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232;
          return 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(o / 255 * 5);
        }, r.ansi16.rgb = function (t) {
          let e = t % 10;
          if (0 === e || 7 === e) return t > 50 && (e += 3.5), e = e / 10.5 * 255, [e, e, e];
          const n = .5 * (1 + ~~(t > 50));
          return [(1 & e) * n * 255, (e >> 1 & 1) * n * 255, (e >> 2 & 1) * n * 255];
        }, r.ansi256.rgb = function (t) {
          if (t >= 232) {
            const e = 10 * (t - 232) + 8;
            return [e, e, e];
          }
          let e;
          t -= 16;
          return [Math.floor(t / 36) / 5 * 255, Math.floor((e = t % 36) / 6) / 5 * 255, e % 6 / 5 * 255];
        }, r.rgb.hex = function (t) {
          const e = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
          return "000000".substring(e.length) + e;
        }, r.hex.rgb = function (t) {
          const e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!e) return [0, 0, 0];
          let n = e[0];
          3 === e[0].length && (n = n.split("").map(t => t + t).join(""));
          const o = parseInt(n, 16);
          return [o >> 16 & 255, o >> 8 & 255, 255 & o];
        }, r.rgb.hcg = function (t) {
          const e = t[0] / 255,
            n = t[1] / 255,
            o = t[2] / 255,
            i = Math.max(Math.max(e, n), o),
            r = Math.min(Math.min(e, n), o),
            s = i - r;
          let a, c;
          return a = s < 1 ? r / (1 - s) : 0, c = s <= 0 ? 0 : i === e ? (n - o) / s % 6 : i === n ? 2 + (o - e) / s : 4 + (e - n) / s, c /= 6, c %= 1, [360 * c, 100 * s, 100 * a];
        }, r.hsl.hcg = function (t) {
          const e = t[1] / 100,
            n = t[2] / 100,
            o = n < .5 ? 2 * e * n : 2 * e * (1 - n);
          let i = 0;
          return o < 1 && (i = (n - .5 * o) / (1 - o)), [t[0], 100 * o, 100 * i];
        }, r.hsv.hcg = function (t) {
          const e = t[1] / 100,
            n = t[2] / 100,
            o = e * n;
          let i = 0;
          return o < 1 && (i = (n - o) / (1 - o)), [t[0], 100 * o, 100 * i];
        }, r.hcg.rgb = function (t) {
          const e = t[0] / 360,
            n = t[1] / 100,
            o = t[2] / 100;
          if (0 === n) return [255 * o, 255 * o, 255 * o];
          const i = [0, 0, 0],
            r = e % 1 * 6,
            s = r % 1,
            a = 1 - s;
          let c = 0;
          switch (Math.floor(r)) {
            case 0:
              i[0] = 1, i[1] = s, i[2] = 0;
              break;
            case 1:
              i[0] = a, i[1] = 1, i[2] = 0;
              break;
            case 2:
              i[0] = 0, i[1] = 1, i[2] = s;
              break;
            case 3:
              i[0] = 0, i[1] = a, i[2] = 1;
              break;
            case 4:
              i[0] = s, i[1] = 0, i[2] = 1;
              break;
            default:
              i[0] = 1, i[1] = 0, i[2] = a;
          }
          return c = (1 - n) * o, [255 * (n * i[0] + c), 255 * (n * i[1] + c), 255 * (n * i[2] + c)];
        }, r.hcg.hsv = function (t) {
          const e = t[1] / 100,
            n = e + t[2] / 100 * (1 - e);
          let o = 0;
          return n > 0 && (o = e / n), [t[0], 100 * o, 100 * n];
        }, r.hcg.hsl = function (t) {
          const e = t[1] / 100,
            n = t[2] / 100 * (1 - e) + .5 * e;
          let o = 0;
          return n > 0 && n < .5 ? o = e / (2 * n) : n >= .5 && n < 1 && (o = e / (2 * (1 - n))), [t[0], 100 * o, 100 * n];
        }, r.hcg.hwb = function (t) {
          const e = t[1] / 100,
            n = e + t[2] / 100 * (1 - e);
          return [t[0], 100 * (n - e), 100 * (1 - n)];
        }, r.hwb.hcg = function (t) {
          const e = t[1] / 100,
            n = 1 - t[2] / 100,
            o = n - e;
          let i = 0;
          return o < 1 && (i = (n - o) / (1 - o)), [t[0], 100 * o, 100 * i];
        }, r.apple.rgb = function (t) {
          return [t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255];
        }, r.rgb.apple = function (t) {
          return [t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535];
        }, r.gray.rgb = function (t) {
          return [t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255];
        }, r.gray.hsl = function (t) {
          return [0, 0, t[0]];
        }, r.gray.hsv = r.gray.hsl, r.gray.hwb = function (t) {
          return [0, 100, t[0]];
        }, r.gray.cmyk = function (t) {
          return [0, 0, 0, t[0]];
        }, r.gray.lab = function (t) {
          return [t[0], 0, 0];
        }, r.gray.hex = function (t) {
          const e = 255 & Math.round(t[0] / 100 * 255),
            n = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
          return "000000".substring(n.length) + n;
        }, r.rgb.gray = function (t) {
          return [(t[0] + t[1] + t[2]) / 3 / 255 * 100];
        };
      },
      9047: (t, e, n) => {
        const o = n(9246),
          i = n(802),
          r = {};
        Object.keys(o).forEach(t => {
          r[t] = {}, Object.defineProperty(r[t], "channels", {
            value: o[t].channels
          }), Object.defineProperty(r[t], "labels", {
            value: o[t].labels
          });
          const e = i(t);
          Object.keys(e).forEach(n => {
            const o = e[n];
            r[t][n] = function (t) {
              const e = function (...e) {
                const n = e[0];
                if (null == n) return n;
                n.length > 1 && (e = n);
                const o = t(e);
                if ("object" == typeof o) for (let t = o.length, e = 0; e < t; e++) o[e] = Math.round(o[e]);
                return o;
              };
              return "conversion" in t && (e.conversion = t.conversion), e;
            }(o), r[t][n].raw = function (t) {
              const e = function (...e) {
                const n = e[0];
                return null == n ? n : (n.length > 1 && (e = n), t(e));
              };
              return "conversion" in t && (e.conversion = t.conversion), e;
            }(o);
          });
        }), t.exports = r;
      },
      802: (t, e, n) => {
        const o = n(9246);
        function i(t) {
          const e = function () {
              const t = {},
                e = Object.keys(o);
              for (let n = e.length, o = 0; o < n; o++) t[e[o]] = {
                distance: -1,
                parent: null
              };
              return t;
            }(),
            n = [t];
          for (e[t].distance = 0; n.length;) {
            const t = n.pop(),
              i = Object.keys(o[t]);
            for (let o = i.length, r = 0; r < o; r++) {
              const o = i[r],
                s = e[o];
              -1 === s.distance && (s.distance = e[t].distance + 1, s.parent = t, n.unshift(o));
            }
          }
          return e;
        }
        function r(t, e) {
          return function (n) {
            return e(t(n));
          };
        }
        function s(t, e) {
          const n = [e[t].parent, t];
          let i = o[e[t].parent][t],
            s = e[t].parent;
          for (; e[s].parent;) n.unshift(e[s].parent), i = r(o[e[s].parent][s], i), s = e[s].parent;
          return i.conversion = n, i;
        }
        t.exports = function (t) {
          const e = i(t),
            n = {},
            o = Object.keys(e);
          for (let t = o.length, i = 0; i < t; i++) {
            const t = o[i];
            null !== e[t].parent && (n[t] = s(t, e));
          }
          return n;
        };
      },
      6931: t => {
        "use strict";

        t.exports = {
          aliceblue: [240, 248, 255],
          antiquewhite: [250, 235, 215],
          aqua: [0, 255, 255],
          aquamarine: [127, 255, 212],
          azure: [240, 255, 255],
          beige: [245, 245, 220],
          bisque: [255, 228, 196],
          black: [0, 0, 0],
          blanchedalmond: [255, 235, 205],
          blue: [0, 0, 255],
          blueviolet: [138, 43, 226],
          brown: [165, 42, 42],
          burlywood: [222, 184, 135],
          cadetblue: [95, 158, 160],
          chartreuse: [127, 255, 0],
          chocolate: [210, 105, 30],
          coral: [255, 127, 80],
          cornflowerblue: [100, 149, 237],
          cornsilk: [255, 248, 220],
          crimson: [220, 20, 60],
          cyan: [0, 255, 255],
          darkblue: [0, 0, 139],
          darkcyan: [0, 139, 139],
          darkgoldenrod: [184, 134, 11],
          darkgray: [169, 169, 169],
          darkgreen: [0, 100, 0],
          darkgrey: [169, 169, 169],
          darkkhaki: [189, 183, 107],
          darkmagenta: [139, 0, 139],
          darkolivegreen: [85, 107, 47],
          darkorange: [255, 140, 0],
          darkorchid: [153, 50, 204],
          darkred: [139, 0, 0],
          darksalmon: [233, 150, 122],
          darkseagreen: [143, 188, 143],
          darkslateblue: [72, 61, 139],
          darkslategray: [47, 79, 79],
          darkslategrey: [47, 79, 79],
          darkturquoise: [0, 206, 209],
          darkviolet: [148, 0, 211],
          deeppink: [255, 20, 147],
          deepskyblue: [0, 191, 255],
          dimgray: [105, 105, 105],
          dimgrey: [105, 105, 105],
          dodgerblue: [30, 144, 255],
          firebrick: [178, 34, 34],
          floralwhite: [255, 250, 240],
          forestgreen: [34, 139, 34],
          fuchsia: [255, 0, 255],
          gainsboro: [220, 220, 220],
          ghostwhite: [248, 248, 255],
          gold: [255, 215, 0],
          goldenrod: [218, 165, 32],
          gray: [128, 128, 128],
          green: [0, 128, 0],
          greenyellow: [173, 255, 47],
          grey: [128, 128, 128],
          honeydew: [240, 255, 240],
          hotpink: [255, 105, 180],
          indianred: [205, 92, 92],
          indigo: [75, 0, 130],
          ivory: [255, 255, 240],
          khaki: [240, 230, 140],
          lavender: [230, 230, 250],
          lavenderblush: [255, 240, 245],
          lawngreen: [124, 252, 0],
          lemonchiffon: [255, 250, 205],
          lightblue: [173, 216, 230],
          lightcoral: [240, 128, 128],
          lightcyan: [224, 255, 255],
          lightgoldenrodyellow: [250, 250, 210],
          lightgray: [211, 211, 211],
          lightgreen: [144, 238, 144],
          lightgrey: [211, 211, 211],
          lightpink: [255, 182, 193],
          lightsalmon: [255, 160, 122],
          lightseagreen: [32, 178, 170],
          lightskyblue: [135, 206, 250],
          lightslategray: [119, 136, 153],
          lightslategrey: [119, 136, 153],
          lightsteelblue: [176, 196, 222],
          lightyellow: [255, 255, 224],
          lime: [0, 255, 0],
          limegreen: [50, 205, 50],
          linen: [250, 240, 230],
          magenta: [255, 0, 255],
          maroon: [128, 0, 0],
          mediumaquamarine: [102, 205, 170],
          mediumblue: [0, 0, 205],
          mediumorchid: [186, 85, 211],
          mediumpurple: [147, 112, 219],
          mediumseagreen: [60, 179, 113],
          mediumslateblue: [123, 104, 238],
          mediumspringgreen: [0, 250, 154],
          mediumturquoise: [72, 209, 204],
          mediumvioletred: [199, 21, 133],
          midnightblue: [25, 25, 112],
          mintcream: [245, 255, 250],
          mistyrose: [255, 228, 225],
          moccasin: [255, 228, 181],
          navajowhite: [255, 222, 173],
          navy: [0, 0, 128],
          oldlace: [253, 245, 230],
          olive: [128, 128, 0],
          olivedrab: [107, 142, 35],
          orange: [255, 165, 0],
          orangered: [255, 69, 0],
          orchid: [218, 112, 214],
          palegoldenrod: [238, 232, 170],
          palegreen: [152, 251, 152],
          paleturquoise: [175, 238, 238],
          palevioletred: [219, 112, 147],
          papayawhip: [255, 239, 213],
          peachpuff: [255, 218, 185],
          peru: [205, 133, 63],
          pink: [255, 192, 203],
          plum: [221, 160, 221],
          powderblue: [176, 224, 230],
          purple: [128, 0, 128],
          rebeccapurple: [102, 51, 153],
          red: [255, 0, 0],
          rosybrown: [188, 143, 143],
          royalblue: [65, 105, 225],
          saddlebrown: [139, 69, 19],
          salmon: [250, 128, 114],
          sandybrown: [244, 164, 96],
          seagreen: [46, 139, 87],
          seashell: [255, 245, 238],
          sienna: [160, 82, 45],
          silver: [192, 192, 192],
          skyblue: [135, 206, 235],
          slateblue: [106, 90, 205],
          slategray: [112, 128, 144],
          slategrey: [112, 128, 144],
          snow: [255, 250, 250],
          springgreen: [0, 255, 127],
          steelblue: [70, 130, 180],
          tan: [210, 180, 140],
          teal: [0, 128, 128],
          thistle: [216, 191, 216],
          tomato: [255, 99, 71],
          turquoise: [64, 224, 208],
          violet: [238, 130, 238],
          wheat: [245, 222, 179],
          white: [255, 255, 255],
          whitesmoke: [245, 245, 245],
          yellow: [255, 255, 0],
          yellowgreen: [154, 205, 50]
        };
      },
      4199: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content code{background-color:hsla(0,0%,78%,.3);border-radius:2px;padding:.15em}.ck.ck-editor__editable .ck-code_selected{background-color:hsla(0,0%,78%,.5)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-basic-styles/theme/code.css"],
          names: [],
          mappings: "AAKA,iBACC,kCAAuC,CAEvC,iBAAkB,CADlB,aAED,CAEA,0CACC,kCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content code {\n\tbackground-color: hsla(0, 0%, 78%, 0.3);\n\tpadding: .15em;\n\tborder-radius: 2px;\n}\n\n.ck.ck-editor__editable .ck-code_selected  {\n\tbackground-color: hsla(0, 0%, 78%, 0.5);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8708: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-block-quote/theme/blockquote.css"],
          names: [],
          mappings: "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1866: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ':root{--ck-image-processing-highlight-color:#f9fafa;--ck-image-processing-background-color:#e3e5e8}.ck.ck-editor__editable .image.image-processing{position:relative}.ck.ck-editor__editable .image.image-processing:before{animation:ck-image-processing-animation 2s linear infinite;background:linear-gradient(90deg,var(--ck-image-processing-background-color),var(--ck-image-processing-highlight-color),var(--ck-image-processing-background-color));background-size:200% 100%;content:"";height:100%;left:0;position:absolute;top:0;width:100%;z-index:1}.ck.ck-editor__editable .image.image-processing img{height:100%}@keyframes ck-image-processing-animation{0%{background-position:200% 0}to{background-position:-200% 0}}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ckbox/theme/ckboximageedit.css"],
          names: [],
          mappings: "AAKA,MAEC,6CAAyD,CACzD,8CACD,CAIE,gDACC,iBA2BD,CAzBC,uDAmBC,0DAA2D,CAR3D,oKAKC,CACD,yBAA0B,CAhB1B,UAAW,CAOX,WAAY,CAHZ,MAAO,CAFP,iBAAkB,CAClB,KAAM,CAKN,UAAW,CAHX,SAcD,CAEA,oDACC,WACD,CAKH,yCACC,GACC,0BACD,CACA,GACC,2BACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Based on default CKBox theme colors */\n\t--ck-image-processing-highlight-color: hsl(220, 10%, 98%);\n\t--ck-image-processing-background-color: hsl(220, 10%, 90%);\n}\n\n.ck.ck-editor__editable {\n\t& .image {\n\t\t&.image-processing {\n\t\t\tposition: relative;\n\n\t\t\t&:before {\n\t\t\t\tcontent: '';\n\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tz-index: 1;\n\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\n\t\t\t\tbackground: linear-gradient(\n\t\t\t\t\t90deg,\n\t\t\t\t\tvar(--ck-image-processing-background-color),\n\t\t\t\t\tvar(--ck-image-processing-highlight-color),\n\t\t\t\t\tvar(--ck-image-processing-background-color)\n\t\t\t\t);\n\t\t\t\tbackground-size: 200% 100%;\n\n\t\t\t\tanimation: ck-image-processing-animation 2s linear infinite;\n\t\t\t}\n\n\t\t\t& img {\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@keyframes ck-image-processing-animation {\n\t0% {\n\t\tbackground-position: 200% 0;\n\t}\n\t100% {\n\t\tbackground-position: -200% 0;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7793: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}.ck.ck-clipboard-drop-target-line{pointer-events:none;position:absolute}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}.ck.ck-clipboard-drop-target-line{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);height:0;margin-top:-1px}.ck.ck-clipboard-drop-target-line:before{border-style:solid;content:"";height:0;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-width)*-.5);width:0}[dir=ltr] .ck.ck-clipboard-drop-target-line:before{border-color:transparent transparent transparent var(--ck-clipboard-drop-target-color);border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height);left:-1px}[dir=rtl] .ck.ck-clipboard-drop-target-line:before{border-color:transparent var(--ck-clipboard-drop-target-color) transparent transparent;border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0;right:-1px}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-clipboard/theme/clipboard.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"],
          names: [],
          mappings: "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CAIF,kCAEC,mBAAoB,CADpB,iBAED,CC9BA,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CAOF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD,CAGD,kCAGC,gDAAiD,CADjD,sDAAuD,CADvD,QAAS,CAGT,eAwBD,CAtBC,yCAMC,kBAAmB,CALnB,UAAW,CAIX,QAAS,CAHT,iBAAkB,CAClB,uDAA0D,CAC1D,OAiBD,CArBA,mDAYE,sFAAuF,CADvF,+JAAoK,CAFpK,SAYF,CArBA,mDAmBE,sFAAuF,CADvF,+JAAmK,CAFnK,UAKF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\tposition: absolute;\n\tpointer-events: none;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"@ckeditor/ckeditor5-ui/theme/mixins/_dir.css\";\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\theight: 0;\n\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\tbackground: var(--ck-clipboard-drop-target-color);\n\tmargin-top: -1px;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-style: solid;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tleft: -1px;\n\n\t\t\tborder-width: calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height);\n\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tright: -1px;\n\n\t\t\tborder-width:calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0;\n\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7388: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-panel)}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{border:solid var(--ck-color-base-border);border-width:1px 1px 0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content.ck-sticky-panel__content_sticky{border-bottom-width:1px}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content .ck-menu-bar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content .ck-toolbar{border:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,8DCED,eDeC,CAjBA,mKCMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAcF,CAjBA,8DAOC,wCAAsB,CAAtB,sBAUD,CARC,8FACC,uBACD,CAEA,qJAEC,QACD,CAMH,yCAEC,0CAA2C,CCtB3C,eDgCD,CAZA,yHChBE,qCAAsC,CDqBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-panel);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-sticky-panel__content {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\tborder-bottom-width: 0;\n\n\t\t\t&.ck-sticky-panel__content_sticky {\n\t\t\t\tborder-bottom-width: 1px;\n\t\t\t}\n\n\t\t\t& .ck-menu-bar,\n\t\t\t& .ck-toolbar {\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4098: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}@media (forced-colors:active){.ck .ck-placeholder,.ck.ck-placeholder{forced-color-adjust:preserve-parent-color}}.ck .ck-placeholder:before,.ck.ck-placeholder:before{cursor:text}@media (forced-colors:none){.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text)}}@media (forced-colors:active){.ck .ck-placeholder:before,.ck.ck-placeholder:before{font-style:italic;margin-left:1px}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-engine/theme/placeholder.css", "webpack://./../ckeditor5-ui/theme/mixins/_mediacolors.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"],
          names: [],
          mappings: "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC7BC,8BACC,uCCOA,yCDLA,CACD,CCOA,qDACC,WAmBD,CDvBA,4BACC,qDCMC,6CDJD,CACD,CAZA,8BACC,qDCsBC,iBAAkB,CAMlB,eD1BD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t@mixin ck-media-forced-colors {\n\t\t/*\n\t\t * This is needed for Edge on Windows to use the right color for the placeholder content (::before).\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t */\n\t\tforced-color-adjust: preserve-parent-color;\n\t}\n\n\t&::before {\n\t\tcursor: text;\n\n\t\t@mixin ck-media-default-colors {\n\t\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t\t}\n\n\t\t@mixin ck-media-forced-colors {\n\t\t\t/*\n\t\t\t * In the high contrast mode there is no telling between regular and placeholder text. Using\n\t\t\t * italic text to address that issue. See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t\t */\n\t\t\tfont-style: italic;\n\n\t\t\t/*\n\t\t\t * Without this margin, the caret will not show up and blink when the user puts the selection\n\t\t\t * in the placeholder (Edge on Windows). See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t\t */\n\t\t\tmargin-left: 1px;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8264: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-engine/theme/renderer.css"],
          names: [],
          mappings: "AAMA,qDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6269: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-heading/theme/heading.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"],
          names: [],
          mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      265: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;height:auto;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image{z-index:1}.ck.ck-editor__editable .image.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable .image-inline img{height:auto}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/image.css"],
          names: [],
          mappings: "AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBA2BD,CAjBC,uBAEC,aAAc,CAad,WAAY,CAVZ,aAAc,CAGd,cAAe,CAGf,cAKD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAKA,+BACC,SASD,CAHC,kDACC,SACD,CAMD,sCACC,SAkBD,CAZC,yDACC,SAUD,CAHC,qEACC,YACD,CAMF,0CACC,WACD,CAMC,0FACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%;\n\n\t\t\t/* Keep proportions of the block image if the height is set and the image is wider than the editor width.\n\t\t\tSee https://github.com/ckeditor/ckeditor5/issues/14542. */\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t/*\n\t * See https://github.com/ckeditor/ckeditor5/issues/15115.\n\t */\n\t& .image {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the selected image always stays on top of its siblings.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t\t */\n\t\t&.ck-widget_selected {\n\t\t\tz-index: 2;\n\t\t}\n\t}\n\n\t/*\n\t * See https://github.com/ckeditor/ckeditor5/issues/15115.\n\t */\n\t& .image-inline {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the selected inline image always stays on top of its siblings.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t\t */\n\t\t&.ck-widget_selected {\n\t\t\tz-index: 2;\n\n\t\t\t/*\n\t\t\t * Make sure the native browser selection style is not displayed.\n\t\t\t * Inline image widgets have their own styles for the selected state and\n\t\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t\t */\n\t\t\t& ::selection {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Keep proportions of the inline image if the height is set and the image is wider than the editor width.\n\tSee https://github.com/ckeditor/ckeditor5/issues/14542. */\n\t& .image-inline img {\n\t\theight: auto;\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5247: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highlighted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}@media (forced-colors:active){.ck-content .image>figcaption{background-color:unset;color:unset}}@media (forced-colors:none){.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}}@media (prefers-reduced-motion:reduce){.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:none}}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highlighted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imagecaption.css", "webpack://./../ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAOA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,oDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAYD,CAJC,8BAXD,8BAYE,sBAAuB,CACvB,WAEF,CADC,CCdA,4BACC,qEDmBA,iDCjBA,CACD,CDmBA,uCALD,qEAME,cAEF,CADC,CAGD,sCACC,GACC,qEACD,CAEA,GACC,yDACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n\n\t/* Improve placeholder rendering in high-constrast mode (https://github.com/ckeditor/ckeditor5/issues/14907). */\n\t@media (forced-colors: active) {\n\t\tbackground-color: unset;\n\t\tcolor: unset;\n\t}\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\t@mixin ck-media-default-colors {\n\t\tanimation: ck-image-caption-highlight .6s ease-out;\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation: none;\n\t}\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highlighted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4642: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-image-custom-resize-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-image-custom-resize-form .ck-labeled-field-view{display:inline-block}.ck.ck-image-custom-resize-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-image-custom-resize-form{flex-wrap:wrap}.ck.ck-image-custom-resize-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-image-custom-resize-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imagecustomresizeform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,gCAIC,sBAAuB,CAHvB,YAAa,CACb,kBAAmB,CACnB,gBAsBD,CAnBC,uDACC,oBACD,CAEA,0CACC,YACD,CCbA,oCDCD,gCAeE,cAUF,CARE,uDACC,eACD,CAEA,2CACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-image-custom-resize-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: flex-start;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3350: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-image-insert-url .ck-image-insert-url__action-row{display:grid;grid-template-columns:repeat(2,1fr)}:root{--ck-image-insert-insert-by-url-width:250px}.ck.ck-image-insert-url{--ck-input-width:100%}.ck.ck-image-insert-url .ck-image-insert-url__action-row{grid-column-gap:var(--ck-spacing-large);margin-top:var(--ck-spacing-large)}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-cancel,.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-save{justify-content:center;min-width:auto}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}.ck.ck-image-insert-form>.ck.ck-button{display:block;padding:var(--ck-list-button-padding);width:100%}[dir=ltr] .ck.ck-image-insert-form>.ck.ck-button{text-align:left}[dir=rtl] .ck.ck-image-insert-form>.ck.ck-button{text-align:right}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:first-child){border-top:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:last-child){border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible,.ck.ck-image-insert-form>.ck.ck-image-insert-url{min-width:var(--ck-image-insert-insert-by-url-width)}.ck.ck-image-insert-form>.ck.ck-image-insert-url{padding:var(--ck-spacing-large)}.ck.ck-image-insert-form:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imageinsert.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageinsert.css"],
          names: [],
          mappings: "AAMC,yDACC,YAAa,CACb,mCACD,CCFD,MACC,2CACD,CAEA,wBACC,qBAgBD,CAdC,yDACC,uCAAwC,CACxC,kCAWD,CATC,oJAEC,sBAAuB,CACvB,cACD,CAEA,sFACC,0BACD,CAKD,uCACC,aAAc,CAEd,qCAAsC,CADtC,UAUD,CAZA,iDAME,eAMF,CAZA,iDAUE,gBAEF,CAGC,8DACC,gDACD,CAEA,6DACC,mDACD,CAMD,6FAJC,oDAOD,CAHA,iDAEC,+BACD,CAEA,+BACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-image-insert-url {\n\t& .ck-image-insert-url__action-row {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-image-insert-insert-by-url-width: 250px;\n}\n\n.ck.ck-image-insert-url {\n\t--ck-input-width: 100%;\n\n\t& .ck-image-insert-url__action-row {\n\t\tgrid-column-gap: var(--ck-spacing-large);\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n\n.ck.ck-image-insert-form {\n\t& > .ck.ck-button {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tpadding: var(--ck-list-button-padding);\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& > .ck.ck-collapsible {\n\t\t&:not(:first-child) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t&:not(:last-child) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\tmin-width: var(--ck-image-insert-insert-by-url-width);\n\t}\n\n\t/* This is the case when there are no other integrations configured than insert by URL */\n\t& > .ck.ck-image-insert-url {\n\t\tmin-width: var(--ck-image-insert-insert-by-url-width);\n\t\tpadding: var(--ck-spacing-large);\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7378: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-editor__editable img.image_placeholder{background-size:100% 100%}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imageplaceholder.css"],
          names: [],
          mappings: "AAMC,8CACC,yBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& img.image_placeholder {\n\t\tbackground-size: 100% 100%;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3469: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content img.image_resized{height:auto}.ck-content .image.image_resized{box-sizing:border-box;display:block;max-width:100%}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}.ck.ck-editor__editable td .image-inline.image_resized img,.ck.ck-editor__editable th .image-inline.image_resized img{max-width:100%}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imageresize.css"],
          names: [],
          mappings: "AAMA,8BACC,WACD,CAEA,iCAQC,qBAAsB,CADtB,aAAc,CANd,cAkBD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAQC,sHACC,cACD,CAIF,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Preserve aspect ratio of the resized image after introducing image height attribute. */\n.ck-content img.image_resized {\n\theight: auto;\n}\n\n.ck-content .image.image_resized {\n\tmax-width: 100%;\n\t/*\n\tThe `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n\tSee https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n\tFortunately, since we control the width, there is no risk that the image will look bad.\n\t*/\n\tdisplay: block;\n\tbox-sizing: border-box;\n\n\t& img {\n\t\t/* For resized images it is the `<figure>` element that determines the image width. */\n\t\twidth: 100%;\n\t}\n\n\t& > figcaption {\n\t\t/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n\t\tdisplay: block;\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/* The resized inline image nested in the table should respect its parent size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline.image_resized img {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n\twidth: 4em;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6386: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imagestyle.css"],
          names: [],
          mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7693: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@media (prefers-reduced-motion:reduce){.ck-image-upload-complete-icon{animation-duration:0ms}.ck-image-upload-complete-icon:after{animation:none;height:.45em;opacity:1;width:.3em}}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imageuploadicon.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"],
          names: [],
          mappings: "AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFAqCD,CAjCC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAEA,uCA7CD,+BA8CE,sBASF,CAPE,qCACC,cAAe,CAGf,YAAc,CAFd,SAAU,CACV,UAED,CACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation-duration: 0ms;\n\n\t\t&::after {\n\t\t\tanimation: none;\n\t\t\topacity: 1;\n\t\t\twidth: 0.3em;\n\t\t\theight: 0.45em;\n\t\t}\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1559: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid transparent;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imageuploadloader.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"],
          names: [],
          mappings: "AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,kCAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2267: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}@media (prefers-reduced-motion:reduce){.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:none;opacity:1}}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/imageuploadprogress.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"],
          names: [],
          mappings: "AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBAMD,CAJC,uCAHD,yFAKE,cAAe,CADf,SAGF,CADC,CAKF,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\topacity: 1;\n\t\t\t\tanimation: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4062: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-image/theme/textalternativeform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7719: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/link.css"],
          names: [],
          mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8762: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-link/theme/linkactions.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"],
          names: [],
          mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3817: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-link-form{align-items:flex-start;display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-link/theme/linkform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"],
          names: [],
          mappings: "AAOA,iBAEC,sBAAuB,CADvB,YAkBD,CAfC,2BACC,YACD,CCPA,oCDCD,iBASE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CChBD,CDwBD,iCACC,aAYD,CALE,wHAEC,mCACD,CEhCF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4808: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{display:block;position:absolute}:root{--ck-link-image-indicator-icon-size:20;--ck-link-image-indicator-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{background-color:rgba(0,0,0,.4);background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzUuNzUgMCAwIDEtLjIxNy4yMDYgNS4yNTEgNS4yNTEgMCAwIDEtOC41MDMtNS45NTUuNy43IDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NHptNS40OTQtNS4zMzVhLjc1Ljc1IDAgMCAxLS4xMi4yNzRsLTEuMTQ3IDEuNjM5YS43NS43NSAwIDEgMS0xLjIyOC0uODZsLjg2LTEuMjNhMy43NSAzLjc1IDAgMCAwLTYuMTQ0LTQuMzAxbC0uODYgMS4yMjlhLjc1Ljc1IDAgMCAxLTEuMjI5LS44NmwxLjE0OC0xLjY0YS43NS43NSAwIDAgMSAuMjE3LS4yMDYgNS4yNTEgNS4yNTEgMCAwIDEgOC41MDMgNS45NTVtLTQuNTYzLTIuNTMyYS43NS43NSAwIDAgMSAuMTg0IDEuMDQ1bC0zLjE1NSA0LjUwNWEuNzUuNzUgMCAxIDEtMS4yMjktLjg2bDMuMTU1LTQuNTA2YS43NS43NSAwIDAgMSAxLjA0NS0uMTg0Ii8+PC9zdmc+");background-position:50%;background-repeat:no-repeat;background-size:14px;border-radius:100%;content:"";height:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size));overflow:hidden;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);width:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size))}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-link/theme/linkimage.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkimage.css"],
          names: [],
          mappings: "AASE,+FACC,aAAc,CACd,iBACD,CCPF,MAEC,sCAAuC,CACvC,oEACD,CAME,+FAUC,+BAAqC,CACrC,k2BAA+3B,CAG/3B,uBAA2B,CAD3B,2BAA4B,CAD5B,oBAAqB,CAGrB,kBAAmB,CAdnB,UAAW,CAsBX,oGAAuG,CAFvG,eAAgB,CAbhB,sCAAwC,CADxC,oCAAsC,CAetC,mGAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Match the icon size with the upload indicator brought by the image upload feature. */\n\t--ck-link-image-indicator-icon-size: 20;\n\t--ck-link-image-indicator-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tcontent: "";\n\n\t\t\t/*\n\t\t\t * Smaller images should have the icon closer to the border.\n\t\t\t * Match the icon position with the upload indicator brought by the image upload feature.\n\t\t\t */\n\t\t\ttop: min(var(--ck-spacing-medium), 6%);\n\t\t\tright: min(var(--ck-spacing-medium), 6%);\n\n\t\t\tbackground-color: hsla(0, 0%, 0%, .4);\n\t\t\tbackground-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");\n\t\t\tbackground-size: 14px;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tborder-radius: 100%;\n\n\t\t\t/*\n\t\t\t* Use CSS math to simulate container queries.\n\t\t\t* https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t\t\t*/\n\t\t\toverflow: hidden;\n\t\t\twidth: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t\theight: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t}\n\t}\n}\n\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1232: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-editor__editable .ck-list-bogus-paragraph{display:block}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-list/theme/documentlist.css"],
          names: [],
          mappings: "AAKA,8CACC,aACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-editor__editable .ck-list-bogus-paragraph {\n\tdisplay: block;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6903: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content ol{list-style-type:decimal}.ck-content ol ol{list-style-type:lower-latin}.ck-content ol ol ol{list-style-type:lower-roman}.ck-content ol ol ol ol{list-style-type:upper-latin}.ck-content ol ol ol ol ol{list-style-type:upper-roman}.ck-content ul{list-style-type:disc}.ck-content ul ul{list-style-type:circle}.ck-content ul ul ul,.ck-content ul ul ul ul{list-style-type:square}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-list/theme/list.css"],
          names: [],
          mappings: "AAKA,eACC,uBAiBD,CAfC,kBACC,2BAaD,CAXC,qBACC,2BASD,CAPC,wBACC,2BAKD,CAHC,2BACC,2BACD,CAMJ,eACC,oBAaD,CAXC,kBACC,sBASD,CAJE,6CACC,sBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content ol {\n\tlist-style-type: decimal;\n\n\t& ol {\n\t\tlist-style-type: lower-latin;\n\n\t\t& ol {\n\t\t\tlist-style-type: lower-roman;\n\n\t\t\t& ol {\n\t\t\t\tlist-style-type: upper-latin;\n\n\t\t\t\t& ol {\n\t\t\t\t\tlist-style-type: upper-roman;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-content ul {\n\tlist-style-type: disc;\n\n\t& ul {\n\t\tlist-style-type: circle;\n\n\t\t& ul {\n\t\t\tlist-style-type: square;\n\n\t\t\t& ul {\n\t\t\t\tlist-style-type: square;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9968: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-list-properties.ck-list-properties_without-styles{padding:var(--ck-spacing-large)}.ck.ck-list-properties.ck-list-properties_without-styles>*{min-width:14em}.ck.ck-list-properties.ck-list-properties_without-styles>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-list-styles-list{grid-template-columns:repeat(4,auto)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible{border-top:1px solid var(--ck-color-base-border)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*{width:100%}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties .ck.ck-numbered-list-properties__start-index .ck-input{min-width:auto;width:100%}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order{background:transparent;margin-bottom:calc(var(--ck-spacing-tiny)*-1);padding-left:0;padding-right:0}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:active,.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:hover{background:none;border-color:transparent;box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-list/listproperties.css"],
          names: [],
          mappings: "AAOC,yDACC,+BASD,CAPC,2DACC,cAKD,CAHC,6DACC,qCACD,CASD,wFACC,oCACD,CAGA,mFACC,gDAWD,CARE,+GACC,UAKD,CAHC,iHACC,qCACD,CAMJ,8EACC,cAAe,CACf,UACD,CAEA,uEACC,sBAAuB,CAGvB,6CAAgD,CAFhD,cAAe,CACf,eAQD,CALC,2JAGC,eAAgB,CADhB,wBAAyB,CADzB,eAGD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-properties {\n\t/* When there are no list styles and there is no collapsible. */\n\t&.ck-list-properties_without-styles {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * {\n\t\t\tmin-width: 14em;\n\n\t\t\t& + * {\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * When the numbered list property fields (start at, reversed) should be displayed,\n\t * more horizontal space is needed. Reconfigure the style grid to create that space.\n\t */\n\t&.ck-list-properties_with-numbered-properties {\n\t\t& > .ck-list-styles-list {\n\t\t\tgrid-template-columns: repeat( 4, auto );\n\t\t}\n\n\t\t/* When list styles are rendered and property fields are in a collapsible. */\n\t\t& > .ck-collapsible {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t& > .ck-collapsible__children {\n\t\t\t\t& > * {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t& + * {\n\t\t\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-numbered-list-properties__start-index .ck-input {\n\t\tmin-width: auto;\n\t\twidth: 100%;\n\t}\n\n\t& .ck.ck-numbered-list-properties__reversed-order {\n\t\tbackground: transparent;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-bottom: calc(-1 * var(--ck-spacing-tiny));\n\n\t\t&:active, &:hover {\n\t\t\tbox-shadow: none;\n\t\t\tborder-color: transparent;\n\t\t\tbackground: none;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7141: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-list-styles-list{display:grid}:root{--ck-list-style-button-size:44px}.ck.ck-list-styles-list{column-gap:var(--ck-spacing-medium);grid-template-columns:repeat(3,auto);padding:var(--ck-spacing-large);row-gap:var(--ck-spacing-medium)}.ck.ck-list-styles-list .ck-button{box-sizing:content-box;margin:0;padding:0}.ck.ck-list-styles-list .ck-button,.ck.ck-list-styles-list .ck-button .ck-icon{height:var(--ck-list-style-button-size);width:var(--ck-list-style-button-size)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-list/theme/liststyles.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-list/liststyles.css"],
          names: [],
          mappings: "AAKA,wBACC,YACD,CCFA,MACC,gCACD,CAEA,wBAGC,mCAAoC,CAFpC,oCAAwC,CAGxC,+BAAgC,CAFhC,gCA4BD,CAxBC,mCAiBC,sBAAuB,CAPvB,QAAS,CANT,SAmBD,CAJC,+EAhBA,uCAAwC,CADxC,sCAoBA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-styles-list {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-list-style-button-size: 44px;\n}\n\n.ck.ck-list-styles-list {\n\tgrid-template-columns: repeat( 3, auto );\n\trow-gap: var(--ck-spacing-medium);\n\tcolumn-gap: var(--ck-spacing-medium);\n\tpadding: var(--ck-spacing-large);\n\n\t& .ck-button {\n\t\t/* Make the button look like a thumbnail (the icon "takes it all"). */\n\t\twidth: var(--ck-list-style-button-size);\n\t\theight: var(--ck-list-style-button-size);\n\t\tpadding: 0;\n\n\t\t/*\n\t\t * Buttons are aligned by the grid so disable default button margins to not collide with the\n\t\t * gaps in the grid.\n\t\t */\n\t\tmargin: 0;\n\n\t\t/*\n\t\t * Make sure the button border (which is displayed on focus, BTW) does not steal pixels\n\t\t * from the button dimensions and, as a result, decrease the size of the icon\n\t\t * (which becomes blurry as it scales down).\n\t\t */\n\t\tbox-sizing: content-box;\n\n\t\t& .ck-icon {\n\t\t\twidth: var(--ck-list-style-button-size);\n\t\t\theight: var(--ck-list-style-button-size);\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8991: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ':root{--ck-todo-list-checkmark-size:16px}.ck-content .todo-list{list-style:none}.ck-content .todo-list li{margin-bottom:5px;position:relative}.ck-content .todo-list li .todo-list{margin-top:5px}.ck-content .todo-list .todo-list__label>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-content[dir=rtl] .todo-list .todo-list__label>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-content .todo-list .todo-list__label>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}@media (prefers-reduced-motion:reduce){.ck-content .todo-list .todo-list__label>input:before{transition:none}}.ck-content .todo-list .todo-list__label>input:after{border-color:transparent;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:content-box;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-content .todo-list .todo-list__label>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-content .todo-list .todo-list__label>input[checked]:after{border-color:#fff}.ck-content .todo-list .todo-list__label .todo-list__label__description{vertical-align:middle}.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}.ck-editor__editable.ck-content .todo-list .todo-list__label>input,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{cursor:pointer}.ck-editor__editable.ck-content .todo-list .todo-list__label>input:hover:before,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:hover:before{box-shadow:0 0 0 5px rgba(0,0,0,.1)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label>span[contenteditable=false]>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}@media (prefers-reduced-motion:reduce){.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{transition:none}}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:after{border-color:transparent;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:content-box;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:after{border-color:#fff}.ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-list/theme/todolist.css"],
          names: [],
          mappings: "AAKA,MACC,kCACD,CA4EA,uBACC,eAwBD,CAtBC,0BAEC,iBAAkB,CADlB,iBAMD,CAHC,qCACC,cACD,CAIA,+CAtFD,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAqFC,CAFA,wDApEA,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAoEA,CAhED,sDAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UASD,CAHC,uCAXD,sDAYE,eAEF,CADC,CAGD,qDAaC,wBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,sBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+DACC,kBAA8B,CAC9B,oBACD,CAEA,8DACC,iBACD,CAwBA,wEACC,qBACD,CAEA,mGACC,iBACD,CAYD,kKAEC,cAKD,CAHC,4LACC,mCACD,CAMD,+FAxHA,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAuHA,CAFA,wGAtGC,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAsGD,CAlGA,sGAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UASD,CAHC,uCAXD,sGAYE,eAEF,CADC,CAGD,qGAaC,wBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,sBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+GACC,kBAA8B,CAC9B,oBACD,CAEA,8GACC,iBACD,CA2DA,uHACC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-todo-list-checkmark-size: 16px;\n}\n\n@define-mixin todo-list-checkbox {\n\t-webkit-appearance: none;\n\tdisplay: inline-block;\n\tposition: relative;\n\twidth: var(--ck-todo-list-checkmark-size);\n\theight: var(--ck-todo-list-checkmark-size);\n\tvertical-align: middle;\n\n\t/* Needed on iOS */\n\tborder: 0;\n\n\t/* LTR styles */\n\tleft: -25px;\n\tmargin-right: -15px;\n\tright: 0;\n\tmargin-left: 0;\n\n\t/* RTL styles */\n\t@nest [dir=rtl]& {\n\t\tleft: 0;\n\t\tmargin-right: 0;\n\t\tright: -25px;\n\t\tmargin-left: -15px;\n\t}\n\n\t&::before {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: border-box;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid hsl(0, 0%, 20%);\n\t\tborder-radius: 2px;\n\t\ttransition: 250ms ease-in-out box-shadow;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\t}\n\n\t&::after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\tpointer-events: none;\n\t\tcontent: '';\n\n\t\t/* Calculate tick position, size and border-width proportional to the checkmark size. */\n\t\tleft: calc( var(--ck-todo-list-checkmark-size) / 3 );\n\t\ttop: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\twidth: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\theight: calc( var(--ck-todo-list-checkmark-size) / 2.6 );\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&[checked] {\n\t\t&::before {\n\t\t\tbackground: hsl(126, 64%, 41%);\n\t\t\tborder-color: hsl(126, 64%, 41%);\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: hsl(0, 0%, 100%);\n\t\t}\n\t}\n}\n\n/*\n * To-do list content styles.\n */\n.ck-content .todo-list {\n\tlist-style: none;\n\n\t& li {\n\t\tposition: relative;\n\t\tmargin-bottom: 5px;\n\n\t\t& .todo-list {\n\t\t\tmargin-top: 5px;\n\t\t}\n\t}\n\n\t& .todo-list__label {\n\t\t& > input {\n\t\t\t@mixin todo-list-checkbox;\n\t\t}\n\n\t\t& .todo-list__label__description {\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t&.todo-list__label_without-description input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n/*\n * To-do list editing view styles.\n */\n.ck-editor__editable.ck-content .todo-list .todo-list__label {\n\t/*\n\t * To-do list should be interactive only during the editing\n\t * (https://github.com/ckeditor/ckeditor5/issues/2090).\n\t */\n\t& > input,\n\t& > span[contenteditable=false] > input {\n\t\tcursor: pointer;\n\n\t\t&:hover::before {\n\t\t\tbox-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);\n\t\t}\n\t}\n\n\t/*\n\t * Document Lists - editing view has an additional span around checkbox.\n\t */\n\t& > span[contenteditable=false] > input {\n\t\t@mixin todo-list-checkbox;\n\t}\n\n\t&.todo-list__label_without-description {\n\t\t& input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      70: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-media-embed/theme/mediaembed.css"],
          names: [],
          mappings: "AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7048: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDI0IiBoZWlnaHQ9IjEwMjQiPjxwYXRoIGZpbGw9IiNGRkZGRkUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTk2Ny40ODQgMEg1Ni41MTdDMjUuMzA0IDAgMCAyNS4zMDQgMCA1Ni41MTd2OTEwLjk2NkMwIDk5OC42OTQgMjUuMjk3IDEwMjQgNTYuNTIyIDEwMjRINTQ3VjYyOEg0MTRWNDczaDEzM1YzNTkuMDI5YzAtMTMyLjI2MiA4MC43NzMtMjA0LjI4MiAxOTguNzU2LTIwNC4yODIgNTYuNTEzIDAgMTA1LjA4NiA0LjIwOCAxMTkuMjQ0IDYuMDg5VjI5OWwtODEuNjE2LjAzN2MtNjMuOTkzIDAtNzYuMzg0IDMwLjQ5Mi03Ni4zODQgNzUuMjM2VjQ3M2gxNTMuNDg3bC0xOS45ODYgMTU1SDcwN3YzOTZoMjYwLjQ4NGMzMS4yMTMgMCA1Ni41MTYtMjUuMzAzIDU2LjUxNi01Ni41MTZWNTYuNTE1QzEwMjQgMjUuMzAzIDk5OC42OTcgMCA5NjcuNDg0IDAiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwME0xNjMuNCAzMDUuNWM4OC43IDAgMTM3LjItNzMuNSAxMzcuMi0xMzcuMiAwLTIuMSAwLTQuMi0uMS02LjIgOS40LTYuOCAxNy42LTE1LjMgMjQuMS0yNS04LjYgMy44LTE3LjkgNi40LTI3LjcgNy42IDEwLTYgMTcuNi0xNS40IDIxLjItMjYuNy05LjMgNS41LTE5LjYgOS41LTMwLjYgMTEuNy04LjgtOS40LTIxLjMtMTUuMi0zNS4yLTE1LjItMjYuNiAwLTQ4LjIgMjEuNi00OC4yIDQ4LjIgMCAzLjguNCA3LjUgMS4zIDExLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40LTQuMSA3LjEtNi41IDE1LjQtNi41IDI0LjIgMCAxNi43IDguNSAzMS41IDIxLjUgNDAuMS03LjktLjItMTUuMy0yLjQtMjEuOC02di42YzAgMjMuNCAxNi42IDQyLjggMzguNyA0Ny4zLTQgMS4xLTguMyAxLjctMTIuNyAxLjctMy4xIDAtNi4xLS4zLTkuMS0uOSA2LjEgMTkuMiAyMy45IDMzLjEgNDUgMzMuNS0xNi41IDEyLjktMzcuMyAyMC42LTU5LjkgMjAuNi0zLjkgMC03LjctLjItMTEuNS0uNyAyMS4xIDEzLjggNDYuNSAyMS44IDczLjcgMjEuOCIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg==)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"],
          names: [],
          mappings: "AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,goGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,o+GACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,g/BACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAuMzc4IiBoZWlnaHQ9IjI1NC4xNjciIHZpZXdCb3g9IjAgMCA2Ni4yNDYgNjcuMjQ4Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcyLjUzMSAtMjE4LjQ1NSkgc2NhbGUoLjk4MDEyKSI+PHJlY3Qgcnk9IjUuMjM4IiByeD0iNS4yMzgiIHk9IjIzMS4zOTkiIHg9IjE3Ni4wMzEiIGhlaWdodD0iNjAuMDk5IiB3aWR0aD0iNjAuMDk5IiBmaWxsPSIjMzRhNjY4IiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxwYXRoIGQ9Ik0yMDYuNDc3IDI2MC45bC0yOC45ODcgMjguOTg3YTUuMjE4IDUuMjE4IDAgMCAwIDMuNzggMS42MWg0OS42MjFjMS42OTQgMCAzLjE5LS43OTggNC4xNDYtMi4wMzd6IiBmaWxsPSIjNWM4OGM1Ii8+PHBhdGggZD0iTTIyNi43NDIgMjIyLjk4OGMtOS4yNjYgMC0xNi43NzcgNy4xNy0xNi43NzcgMTYuMDE0LjAwNyAyLjc2Mi42NjMgNS40NzQgMi4wOTMgNy44NzUuNDMuNzAzLjgzIDEuNDA4IDEuMTkgMi4xMDcuMzMzLjUwMi42NSAxLjAwNS45NSAxLjUwOC4zNDMuNDc3LjY3My45NTcuOTg4IDEuNDQgMS4zMSAxLjc2OSAyLjUgMy41MDIgMy42MzcgNS4xNjguNzkzIDEuMjc1IDEuNjgzIDIuNjQgMi40NjYgMy45OSAyLjM2MyA0LjA5NCA0LjAwNyA4LjA5MiA0LjYgMTMuOTE0di4wMTJjLjE4Mi40MTIuNTE2LjY2Ni44NzkuNjY3LjQwMy0uMDAxLjc2OC0uMzE0LjkzLS43OTkuNjAzLTUuNzU2IDIuMjM4LTkuNzI5IDQuNTg1LTEzLjc5NC43ODItMS4zNSAxLjY3My0yLjcxNSAyLjQ2NS0zLjk5IDEuMTM3LTEuNjY2IDIuMzI4LTMuNCAzLjYzOC01LjE2OS4zMTUtLjQ4Mi42NDUtLjk2Mi45ODgtMS40MzkuMy0uNTAzLjYxNy0xLjAwNi45NS0xLjUwOC4zNTktLjcuNzYtMS40MDQgMS4xOS0yLjEwNyAxLjQyNi0yLjQwMiAyLTUuMTE0IDIuMDA0LTcuODc1IDAtOC44NDQtNy41MTEtMTYuMDE0LTE2Ljc3Ni0xNi4wMTR6IiBmaWxsPSIjZGQ0YjNlIiBwYWludC1vcmRlcj0ibWFya2VycyBzdHJva2UgZmlsbCIvPjxlbGxpcHNlIHJ5PSI1LjU2NCIgcng9IjUuODI4IiBjeT0iMjM5LjAwMiIgY3g9IjIyNi43NDIiIGZpbGw9IiM4MDJkMjciIHBhaW50LW9yZGVyPSJtYXJrZXJzIHN0cm9rZSBmaWxsIi8+PHBhdGggZD0iTTE5MC4zMDEgMjM3LjI4M2MtNC42NyAwLTguNDU3IDMuODUzLTguNDU3IDguNjA2czMuNzg2IDguNjA3IDguNDU3IDguNjA3YzMuMDQzIDAgNC44MDYtLjk1OCA2LjMzNy0yLjUxNiAxLjUzLTEuNTU3IDIuMDg3LTMuOTEzIDIuMDg3LTYuMjkgMC0uMzYyLS4wMjMtLjcyMi0uMDY0LTEuMDc5aC04LjI1N3YzLjA0M2g0Ljg1Yy0uMTk3Ljc1OS0uNTMxIDEuNDUtMS4wNTggMS45ODYtLjk0Mi45NTgtMi4wMjggMS41NDgtMy45MDEgMS41NDgtMi44NzYgMC01LjIwOC0yLjM3Mi01LjIwOC01LjI5OSAwLTIuOTI2IDIuMzMyLTUuMjk5IDUuMjA4LTUuMjk5IDEuMzk5IDAgMi42MTguNDA3IDMuNTg0IDEuMjkzbDIuMzgxLTIuMzhjMC0uMDAyLS4wMDMtLjAwNC0uMDA0LS4wMDUtMS41ODgtMS41MjQtMy42Mi0yLjIxNS01Ljk1NS0yLjIxNXptNC40MyA1LjY2bC4wMDMuMDA2di0uMDAzeiIgZmlsbD0iI2ZmZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48cGF0aCBkPSJNMjE1LjE4NCAyNTEuOTI5bC03Ljk4IDcuOTc5IDI4LjQ3NyAyOC40NzVjLjI4Ny0uNjQ5LjQ0OS0xLjM2Ni40NDktMi4xMjN2LTMxLjE2NWMtLjQ2OS42NzUtLjkzNCAxLjM0OS0xLjM4MiAyLjAwNS0uNzkyIDEuMjc1LTEuNjgyIDIuNjQtMi40NjUgMy45OS0yLjM0NyA0LjA2NS0zLjk4MiA4LjAzOC00LjU4NSAxMy43OTQtLjE2Mi40ODUtLjUyNy43OTgtLjkzLjc5OS0uMzYzLS4wMDEtLjY5Ny0uMjU1LS44NzktLjY2N3YtLjAxMmMtLjU5My01LjgyMi0yLjIzNy05LjgyLTQuNi0xMy45MTQtLjc4My0xLjM1LTEuNjczLTIuNzE1LTIuNDY2LTMuOTktMS4xMzctMS42NjYtMi4zMjctMy40LTMuNjM3LTUuMTY5bC0uMDAyLS4wMDN6IiBmaWxsPSIjYzNjM2MzIi8+PHBhdGggZD0iTTIxMi45ODMgMjQ4LjQ5NWwtMzYuOTUyIDM2Ljk1M3YuODEyYTUuMjI3IDUuMjI3IDAgMCAwIDUuMjM4IDUuMjM4aDEuMDE1bDM1LjY2Ni0zNS42NjZhMTM2LjI3NSAxMzYuMjc1IDAgMCAwLTIuNzY0LTMuOSAzNy41NzUgMzcuNTc1IDAgMCAwLS45ODktMS40NGMtLjI5OS0uNTAzLS42MTYtMS4wMDYtLjk1LTEuNTA4LS4wODMtLjE2Mi0uMTc2LS4zMjYtLjI2NC0uNDg5eiIgZmlsbD0iI2ZkZGM0ZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48cGF0aCBkPSJNMjExLjk5OCAyNjEuMDgzbC02LjE1MiA2LjE1MSAyNC4yNjQgMjQuMjY0aC43ODFhNS4yMjcgNS4yMjcgMCAwIDAgNS4yMzktNS4yMzh2LTEuMDQ1eiIgZmlsbD0iI2ZmZiIgcGFpbnQtb3JkZXI9Im1hcmtlcnMgc3Ryb2tlIGZpbGwiLz48L2c+PC9zdmc+);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5651: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-media-embed/theme/mediaform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5506: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-input-color{display:flex;flex-direction:row-reverse;width:100%}.ck.ck-input-color>input.ck.ck-input-text{flex-grow:1;min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown{min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown>.ck-input-color__button .ck-dropdown__arrow{display:none}.ck.ck-input-color .ck.ck-input-color__button{display:flex}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview{overflow:hidden;position:relative}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{display:block;position:absolute}[dir=ltr] .ck.ck-input-color>.ck.ck-input-text{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-input-text{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-input-color>.ck.ck-input-text:focus{z-index:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{padding:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-left-radius:0;border-top-left-radius:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-left:1px solid transparent}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-right:1px solid transparent}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button.ck-disabled{background:var(--ck-color-input-disabled-background)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border-radius:0}.ck-rounded-corners .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview,.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border:1px solid var(--ck-color-input-border);height:20px;width:20px}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{background:red;border-radius:2px;height:150%;left:50%;top:-30%;transform:rotate(45deg);transform-origin:50%;width:8%}.ck.ck-input-color .ck.ck-input-color__remove-color{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);width:100%}.ck.ck-input-color .ck.ck-input-color__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-input-border)}[dir=ltr] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-right-radius:0}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-left-radius:0}.ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard);margin-right:0}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/colorinput.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/colorinput.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,mBAEC,YAAa,CACb,0BAA2B,CAF3B,UAgCD,CA5BC,0CAEC,WAAY,CADZ,cAED,CAEA,sCACC,cAMD,CAHC,kFACC,YACD,CAGD,8CAEC,YAWD,CATC,kFAEC,eAAgB,CADhB,iBAOD,CAJC,0IAEC,aAAc,CADd,iBAED,CC1BF,+CAGE,4BAA6B,CAD7B,yBAcF,CAhBA,+CAQE,2BAA4B,CAD5B,wBASF,CAHC,2CACC,SACD,CAIA,wEACC,SA0CD,CA3CA,kFAKE,2BAA4B,CAD5B,wBAuCF,CApCE,8FACC,iCACD,CATF,kFAcE,4BAA6B,CAD7B,yBA8BF,CA3BE,8FACC,kCACD,CAGD,oFACC,oDACD,CAEA,4GC1CF,eD2DE,CAjBA,+PCtCD,qCDuDC,CAjBA,4GAKC,6CAA8C,CAD9C,WAAY,CADZ,UAcD,CAVC,oKAKC,cAA6B,CAC7B,iBAAkB,CAHlB,WAAY,CADZ,QAAS,CADT,QAAS,CAMT,uBAAwB,CACxB,oBAAqB,CAJrB,QAKD,CAKH,oDAIC,2BAA4B,CAC5B,4BAA6B,CAH7B,qEAAwE,CADxE,UA0BD,CApBC,gEACC,oDACD,CATD,8DAYE,yBAeF,CA3BA,8DAgBE,wBAWF,CARC,gEACC,uCAMD,CAPA,0EAKE,sCAAuC,CADvC,cAGF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-input-color {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\n\t& > input.ck.ck-input-text {\n\t\tmin-width: auto;\n\t\tflex-grow: 1;\n\t}\n\n\t& > div.ck.ck-dropdown {\n\t\tmin-width: auto;\n\n\t\t/* This dropdown has no arrow but a color preview instead. */\n\t\t& > .ck-input-color__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__button {\n\t\t/* Resolving issue with misaligned buttons on Safari (see #10589) */\n\t\tdisplay: flex;\n\n\t\t& .ck.ck-input-color__button__preview {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\n\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_rounded.css";\n\n.ck.ck-input-color {\n\t& > .ck.ck-input-text {\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* Make sure the focused input is always on top of the dropdown button so its\n\t\t   outline and border are never cropped (also when the input is read-only). */\n\t\t&:focus {\n\t\t\tz-index: 0;\n\t\t}\n\t}\n\n\t& > .ck.ck-dropdown {\n\t\t& > .ck.ck-button.ck-input-color__button {\n\t\t\tpadding: 0;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-left: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-right: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.ck-disabled {\n\t\t\t\tbackground: var(--ck-color-input-disabled-background);\n\t\t\t}\n\n\t\t\t& > .ck.ck-input-color__button__preview {\n\t\t\t\t@mixin ck-rounded-corners;\n\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder: 1px solid var(--ck-color-input-border);\n\n\t\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\t\ttop: -30%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 150%;\n\t\t\t\t\twidth: 8%;\n\t\t\t\t\tbackground: hsl(0, 100%, 50%);\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\ttransform-origin: 50%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__remove-color {\n\t\twidth: 100%;\n\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-input-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t}\n\n\t\t& .ck.ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4043: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-form{padding:0 0 var(--ck-spacing-large)}.ck.ck-form:focus{outline:none}.ck.ck-form .ck.ck-input-text{min-width:100%;width:0}.ck.ck-form .ck.ck-dropdown{min-width:100%}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button:not(:focus){border:1px solid var(--ck-color-base-border)}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button .ck-button__label{width:100%}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/form.css"],
          names: [],
          mappings: "AAKA,YACC,mCAyBD,CAvBC,kBAEC,YACD,CAEA,8BACC,cAAe,CACf,OACD,CAEA,4BACC,cAWD,CARE,6DACC,4CACD,CAEA,mEACC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form {\n\tpadding: 0 0 var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t& .ck.ck-input-text {\n\t\tmin-width: 100%;\n\t\twidth: 0;\n\t}\n\n\t& .ck.ck-dropdown {\n\t\tmin-width: 100%;\n\n\t\t& .ck-dropdown__button {\n\t\t\t&:not(:focus) {\n\t\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck-button__label {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2655: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-table-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-table-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row{padding:var(--ck-spacing-standard) var(--ck-spacing-large) 0}[dir=ltr] .ck.ck-form__row>:not(.ck-label)+*{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-form__row>:not(.ck-label)+*{margin-right:var(--ck-spacing-large)}.ck.ck-form__row>.ck-label{min-width:100%;width:100%}.ck.ck-form__row.ck-table-form__action-row{margin-top:var(--ck-spacing-large)}.ck.ck-form__row.ck-table-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/formrow.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/formrow.css"],
          names: [],
          mappings: "AAKA,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAaD,CAVC,iCACC,WACD,CAGC,wHAEC,sBACD,CCbF,iBACC,4DA2BD,CAvBE,6CAEE,mCAMF,CARA,6CAME,oCAEF,CAGD,2BAEC,cAAe,CADf,UAED,CAEA,2CACC,kCAKD,CAHC,wEACC,0BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\tflex-grow: 1;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-form__row {\n\tpadding: var(--ck-spacing-standard) var(--ck-spacing-large) 0;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\t& + * {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-label {\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5032: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label,.ck[dir=rtl] .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}@media (prefers-reduced-motion:reduce){.ck .ck-insert-table-dropdown-grid-box{transition:none}}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/inserttable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"],
          names: [],
          mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,mFAEC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAcD,CAZC,uCATD,uCAUE,eAWF,CAVC,CAEA,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label,\n.ck[dir=rtl] .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\tmin-width: var(--ck-insert-table-dropdown-box-width);\n\tmin-height: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\toutline: none;\n\ttransition: none;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2329: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:rgba(0,0,0,.05);font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/table.css"],
          names: [],
          mappings: "AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,0BAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4143: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-color-selector-caption-background:#f7f7f7;--ck-color-selector-caption-text:#333;--ck-color-selector-caption-highlighted-background:#fd0}.ck-content .table>figcaption{background-color:var(--ck-color-selector-caption-background);caption-side:top;color:var(--ck-color-selector-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;text-align:center;word-break:break-word}@media (forced-colors:active){.ck-content .table>figcaption{background-color:unset;color:unset}}@media (forced-colors:none){.ck.ck-editor__editable .table>figcaption.table__caption_highlighted{animation:ck-table-caption-highlight .6s ease-out}}.ck.ck-editor__editable .table>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}@keyframes ck-table-caption-highlight{0%{background-color:var(--ck-color-selector-caption-highlighted-background)}to{background-color:var(--ck-color-selector-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/tablecaption.css", "webpack://./../ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAOA,MACC,8CAAuD,CACvD,qCAAiD,CACjD,uDACD,CAGA,8BAMC,4DAA6D,CAJ7D,gBAAiB,CAGjB,2CAA4C,CAJ5C,qBAAsB,CAOtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,iBAAkB,CADlB,qBAaD,CCxBC,8BACC,8BDoBA,sBAAuB,CACvB,WCnBA,CACD,CAIA,4BDqBC,qEACC,iDACD,CCnBD,CDsBA,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAGD,sCACC,GACC,wEACD,CAEA,GACC,4DACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-selector-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-selector-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-selector-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .table > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: top;\n\tword-break: break-word;\n\ttext-align: center;\n\tcolor: var(--ck-color-selector-caption-text);\n\tbackground-color: var(--ck-color-selector-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n\n\t/* Improve placeholder rendering in high-constrast mode (https://github.com/ckeditor/ckeditor5/issues/14907). */\n\t@mixin ck-media-forced-colors {\n\t\tbackground-color: unset;\n\t\tcolor: unset;\n\t}\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .table > figcaption {\n\t@mixin ck-media-default-colors {\n\t\t&.table__caption_highlighted {\n\t\t\tanimation: ck-table-caption-highlight .6s ease-out;\n\t\t}\n\t}\n\n\t&.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the table caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n}\n\n@keyframes ck-table-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-selector-caption-highlighted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-selector-caption-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8986: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row{flex-wrap:wrap}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:first-of-type{flex-grow:0.57}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:last-of-type{flex-grow:0.43}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar .ck-button{flex-grow:1}.ck.ck-table-cell-properties-form{width:320px}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__padding-row{align-self:flex-end;padding:0;width:25%}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/tablecellproperties.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tablecellproperties.css"],
          names: [],
          mappings: "AAOE,6FACC,cAiBD,CAdE,0HAEC,cACD,CAEA,yHAEC,cACD,CAEA,uHACC,WACD,CClBJ,kCACC,WAkBD,CAfE,2FACC,mBAAoB,CACpB,SAAU,CACV,SACD,CAGC,4GACC,eAAgB,CAGhB,qCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\t&:first-of-type {\n\t\t\t\t\t/* 4 buttons out of 7 (h-alignment + v-alignment) = 0.57 */\n\t\t\t\t\tflex-grow: 0.57;\n\t\t\t\t}\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\t/* 3 buttons out of 7 (h-alignment + v-alignment) = 0.43 */\n\t\t\t\t\tflex-grow: 0.43;\n\t\t\t\t}\n\n\t\t\t\t& .ck-button {\n\t\t\t\t\tflex-grow: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__padding-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\t\t\twidth: 25%;\n\t\t}\n\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8795: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-color-selector-column-resizer-hover:var(--ck-color-base-active);--ck-table-column-resizer-width:7px;--ck-table-column-resizer-position-offset:calc(var(--ck-table-column-resizer-width)*-0.5 - 0.5px)}.ck-content .table .ck-table-resized{table-layout:fixed}.ck-content .table table{overflow:hidden}.ck-content .table td,.ck-content .table th{overflow-wrap:break-word;position:relative}.ck.ck-editor__editable .table .ck-table-column-resizer{bottom:0;cursor:col-resize;position:absolute;right:var(--ck-table-column-resizer-position-offset);top:0;user-select:none;width:var(--ck-table-column-resizer-width);z-index:var(--ck-z-default)}.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer,.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer{display:none}.ck.ck-editor__editable .table .ck-table-column-resizer:hover,.ck.ck-editor__editable .table .ck-table-column-resizer__active{background-color:var(--ck-color-selector-column-resizer-hover);bottom:-999999px;opacity:.25;top:-999999px}.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer{left:var(--ck-table-column-resizer-position-offset);right:unset}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/tablecolumnresize.css"],
          names: [],
          mappings: "AAKA,MACC,oEAAqE,CACrE,mCAAoC,CAIpC,iGACD,CAEA,qCACC,kBACD,CAEA,yBACC,eACD,CAEA,4CAIC,wBAAyB,CACzB,iBACD,CAEA,wDAGC,QAAS,CAGT,iBAAkB,CALlB,iBAAkB,CAGlB,oDAAqD,CAFrD,KAAM,CAKN,gBAAiB,CAFjB,0CAA2C,CAG3C,2BACD,CAQA,qJACC,YACD,CAEA,8HAEC,8DAA+D,CAO/D,gBAAiB,CANjB,WAAa,CAKb,aAED,CAEA,iEACC,mDAAoD,CACpD,WACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-selector-column-resizer-hover: var(--ck-color-base-active);\n\t--ck-table-column-resizer-width: 7px;\n\n\t/* The offset used for absolute positioning of the resizer element, so that it is placed exactly above the cell border.\n\t   The value is: minus half the width of the resizer decreased additionaly by the half the width of the border (0.5px). */\n\t--ck-table-column-resizer-position-offset: calc(var(--ck-table-column-resizer-width) * -0.5 - 0.5px);\n}\n\n.ck-content .table .ck-table-resized {\n\ttable-layout: fixed;\n}\n\n.ck-content .table table {\n\toverflow: hidden;\n}\n\n.ck-content .table td,\n.ck-content .table th {\n\t/* To prevent text overflowing beyond its cell when columns are resized by resize handler\n\t(https://github.com/ckeditor/ckeditor5/pull/14379#issuecomment-1589460978). */\n\toverflow-wrap: break-word;\n\tposition: relative;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tright: var(--ck-table-column-resizer-position-offset);\n\twidth: var(--ck-table-column-resizer-width);\n\tcursor: col-resize;\n\tuser-select: none;\n\tz-index: var(--ck-z-default);\n}\n\n.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer {\n\tdisplay: none;\n}\n\n/* The resizer elements, which are extended to an extremely high height, break the drag & drop feature in Chrome. To make it work again,\n   all resizers must be hidden while the table is dragged. */\n.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer {\n\tdisplay: none;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer:hover,\n.ck.ck-editor__editable .table .ck-table-column-resizer__active {\n\tbackground-color: var(--ck-color-selector-column-resizer-hover);\n\topacity: 0.25;\n\t/* The resizer element resides in each cell so to occupy the entire height of the table, which is unknown from a CSS point of view,\n\t   it is extended to an extremely high height. Even for screens with a very high pixel density, the resizer will fulfill its role as\n\t   it should, i.e. for a screen of 476 ppi the total height of the resizer will take over 350 sheets of A4 format, which is totally\n\t   unrealistic height for a single table. */\n\ttop: -999999px;\n\tbottom: -999999px;\n}\n\n.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer {\n\tleft: var(--ck-table-column-resizer-position-offset);\n\tright: unset;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8137: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-color-selector-focused-cell-background:rgba(158,201,250,.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-selector-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"],
          names: [],
          mappings: "AAKA,MACC,gEACD,CAKE,8QAGC,2DAA4D,CAK5D,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-selector-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-selector-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1623: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck.ck-table-form .ck-form__row.ck-table-form__background-row,.ck.ck-table-form .ck-form__row.ck-table-form__border-row{flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{align-items:center;flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view{align-items:center;display:flex;flex-direction:column-reverse}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view .ck.ck-dropdown,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{flex-grow:0}.ck.ck-table-form .ck.ck-labeled-field-view{position:relative}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{bottom:calc(var(--ck-table-properties-error-arrow-size)*-1);left:50%;position:absolute;transform:translate(-50%,100%);z-index:1}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{content:"";left:50%;position:absolute;top:calc(var(--ck-table-properties-error-arrow-size)*-1);transform:translateX(-50%)}:root{--ck-table-properties-error-arrow-size:6px;--ck-table-properties-min-error-width:150px}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-labeled-field-view>.ck-label{font-size:var(--ck-font-size-tiny);text-align:center}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-style,.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-width{max-width:80px;min-width:80px;width:80px}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{padding:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__height,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__width{margin:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{align-self:flex-end;display:inline-block;height:var(--ck-ui-component-min-height);line-height:var(--ck-ui-component-min-height);margin:0 var(--ck-spacing-small)}.ck.ck-table-form .ck.ck-labeled-field-view{padding-top:var(--ck-spacing-standard)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{border-radius:0}.ck-rounded-corners .ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status,.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{background:var(--ck-color-base-error);color:var(--ck-color-base-background);min-width:var(--ck-table-properties-min-error-width);padding:var(--ck-spacing-small) var(--ck-spacing-medium);text-align:center}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{border-color:transparent transparent var(--ck-color-base-error) transparent;border-style:solid;border-width:0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:ck-table-form-labeled-view-status-appear .15s ease both}@media (prefers-reduced-motion:reduce){.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:none}}.ck.ck-table-form .ck.ck-labeled-field-view .ck-input.ck-error:not(:focus)+.ck.ck-labeled-field-view__status{display:none}@keyframes ck-table-form-labeled-view-status-appear{0%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/tableform.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableform.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAWE,wHACC,cACD,CAEA,8DAEC,kBAAmB,CADnB,cAgBD,CAbC,qFAGC,kBAAmB,CAFnB,YAAa,CACb,6BAMD,CAEA,sMACC,WACD,CAIF,4CAEC,iBAoBD,CAlBC,8EAGC,2DAAgE,CADhE,QAAS,CADT,iBAAkB,CAGlB,8BAA+B,CAG/B,SAUD,CAPC,oFACC,UAAW,CAGX,QAAS,CAFT,iBAAkB,CAClB,wDAA6D,CAE7D,0BACD,CChDH,MACC,0CAA2C,CAC3C,2CACD,CAMI,2FACC,kCAAmC,CACnC,iBACD,CAGD,8KAIC,cAAe,CADf,cAAe,CADf,UAGD,CAGD,8DACC,SAcD,CAZC,yMAEC,QACD,CAEA,iGACC,mBAAoB,CACpB,oBAAqB,CACrB,wCAAyC,CACzC,6CAA8C,CAC9C,gCACD,CAIF,4CACC,sCA6BD,CA3BC,8ECxCD,eD6DC,CArBA,mMCpCA,qCDyDA,CArBA,8EAGC,qCAAsC,CACtC,qCAAsC,CAEtC,oDAAqD,CADrD,wDAAyD,CAEzD,iBAcD,CAXC,oFACC,2EAA4E,CAE5E,kBAAmB,CADnB,kJAED,CAdD,8EAgBC,iEAKD,CAHC,uCAlBD,8EAmBE,cAEF,CADC,CAID,6GACC,YACD,CAIF,oDACC,GACC,SACD,CAEA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__background-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tflex-wrap: wrap;\n\t\t\talign-items: center;\n\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .ck.ck-dropdown {\n\t\t\t\t\tflex-grow: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\tflex-grow: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\t/* Allow absolute positioning of the status (error) balloons. */\n\t\tposition: relative;\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\tbottom: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\ttransform: translate(-50%,100%);\n\n\t\t\t/* Make sure the balloon status stays on top of other form elements. */\n\t\t\tz-index: 1;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translateX( -50% );\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n:root {\n\t--ck-table-properties-error-arrow-size: 6px;\n\t--ck-table-properties-min-error-width: 150px;\n}\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\t& > .ck-label {\n\t\t\t\t\tfont-size: var(--ck-font-size-tiny);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__border-style,\n\t\t\t& .ck-table-form__border-width {\n\t\t\t\twidth: 80px;\n\t\t\t\tmin-width: 80px;\n\t\t\t\tmax-width: 80px;\n\t\t\t}\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tpadding: 0;\n\n\t\t\t& .ck-table-form__dimensions-row__width,\n\t\t\t& .ck-table-form__dimensions-row__height {\n\t\t\t\tmargin: 0\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\talign-self: flex-end;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: var(--ck-ui-component-min-height);\n\t\t\t\tline-height: var(--ck-ui-component-min-height);\n\t\t\t\tmargin: 0 var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: var(--ck-spacing-standard);\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\t@mixin ck-rounded-corners;\n\n\t\t\tbackground: var(--ck-color-base-error);\n\t\t\tcolor: var(--ck-color-base-background);\n\t\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\t\tmin-width: var(--ck-table-properties-min-error-width);\n\t\t\ttext-align: center;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tborder-color: transparent transparent var(--ck-color-base-error) transparent;\n\t\t\t\tborder-width: 0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size);\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\tanimation: ck-table-form-labeled-view-status-appear .15s ease both;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\tanimation: none;\n\t\t\t}\n\t\t}\n\n\t\t/* Hide the error balloon when the field is blurred. Makes the experience much more clear. */\n\t\t& .ck-input.ck-error:not(:focus) + .ck.ck-labeled-field-view__status {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@keyframes ck-table-form-labeled-view-status-appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5562: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-content:baseline;flex-basis:0;flex-wrap:wrap}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items{flex-wrap:nowrap}.ck.ck-table-properties-form{width:320px}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-self:flex-end;padding:0}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items>*{width:40px}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-table/theme/tableproperties.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableproperties.css"],
          names: [],
          mappings: "AAOE,mFAGC,sBAAuB,CADvB,YAAa,CADb,cAOD,CAHC,qHACC,gBACD,CCTH,6BACC,WAmBD,CAhBE,mFACC,mBAAoB,CACpB,SAYD,CAVC,kGACC,eAAgB,CAGhB,qCAKD,CAHC,uHACC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-basis: 0;\n\t\t\talign-content: baseline;\n\n\t\t\t& .ck.ck-toolbar .ck-toolbar__items {\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\n\t\t\t\t& .ck-toolbar__items > * {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8423: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ':root{--ck-table-selected-cell-background:rgba(158,207,250,.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:transparent;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"],
          names: [],
          mappings: "AAKA,MACC,wDACD,CAGC,0IAKC,gBAAiB,CAFjB,uBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,4BACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1801: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-aria-live-announcer{left:-10000px;position:absolute;top:-10000px}.ck.ck-aria-live-region-list{list-style-type:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/arialiveannouncer/arialiveannouncer.css"],
          names: [],
          mappings: "AAKA,2BAEC,aAAc,CADd,iBAAkB,CAElB,YACD,CAEA,6BACC,oBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-aria-live-announcer {\n\tposition: absolute;\n\tleft: -10000px;\n\ttop: -10000px;\n}\n\n.ck.ck-aria-live-region-list {\n\tlist-style-type: none;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5727: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-autocomplete{position:relative}.ck.ck-autocomplete>.ck-search__results{position:absolute;z-index:var(--ck-z-panel)}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{bottom:100%}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{bottom:auto;top:100%}.ck.ck-autocomplete>.ck-search__results{border-radius:0}.ck-rounded-corners .ck.ck-autocomplete>.ck-search__results,.ck.ck-autocomplete>.ck-search__results.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-autocomplete>.ck-search__results{background:var(--ck-color-base-background);border:1px solid var(--ck-color-dropdown-panel-border);box-shadow:var(--ck-drop-shadow),0 0;max-height:200px;min-width:auto;overflow-y:auto}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-1px}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{border-top-left-radius:0;border-top-right-radius:0;margin-top:-1px}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/autocomplete/autocomplete.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/autocomplete/autocomplete.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,oBACC,iBAeD,CAbC,wCACC,iBAAkB,CAClB,yBAUD,CARC,6DACC,WACD,CAEA,6DAEC,WAAY,CADZ,QAED,CCVD,wCCEA,eDuBA,CAzBA,uHCMC,qCDmBD,CAzBA,wCAMC,0CAA2C,CAC3C,sDAAuD,CEPxD,oCAA8B,CFI7B,gBAAiB,CAIjB,cAAe,CAHf,eAoBD,CAfC,6DACC,2BAA4B,CAC5B,4BAA6B,CAG7B,kBACD,CAEA,6DACC,wBAAyB,CACzB,yBAA0B,CAG1B,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-autocomplete {\n\tposition: relative;\n\n\t& > .ck-search__results {\n\t\tposition: absolute;\n\t\tz-index: var(--ck-z-panel);\n\n\t\t&.ck-search__results_n {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck.ck-autocomplete {\n\t& > .ck-search__results {\n\t\t@mixin ck-rounded-corners;\n\t\t@mixin ck-drop-shadow;\n\n\t\tmax-height: 200px;\n\t\toverflow-y: auto;\n\t\tbackground: var(--ck-color-base-background);\n\t\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\t\tmin-width: auto;\n\n\t\t&.ck-search__results_n {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-bottom: -1px;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-top-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-top: -1px;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9715: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}[dir=ltr] .ck.ck-button,[dir=ltr] a.ck.ck-button{justify-content:left}[dir=rtl] .ck.ck-button,[dir=rtl] a.ck.ck-button{justify-content:right}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}@media (prefers-reduced-motion:reduce){.ck.ck-button,a.ck.ck-button{transition:none}}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{opacity:.5}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/button/button.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAQA,6BAMC,kBAAmB,CADnB,mBAAoB,CADpB,iBAAkB,CCHlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD0BD,CA9BA,iDASE,oBAqBF,CA9BA,iDAaE,qBAiBF,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEzBD,6BCAC,oDD+ID,CC5IE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eFgJD,CA/IA,wIEGE,qCF4IF,CA/IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBA0ID,CAhHC,uCA/BD,6BAgCE,eA+GF,CA9GC,CAEA,oFGpCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHyCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAWD,CAZA,6FAIE,mCAQF,CAZA,6FAQE,oCAIF,CAZA,yEAWC,UACD,CAIC,oIIxFD,oDJ4FC,CAOA,gLKnGD,kCLqGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCClIA,+CDsIA,CCnIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDmHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CClJC,mDDuJD,CCpJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDmID,2CAIC,wCACD,CAEA,uCAEC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../../mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\n\t@mixin ck-dir ltr {\n\t\tjustify-content: left;\n\t}\n\n\t@mixin ck-dir rtl {\n\t\tjustify-content: right;\n\t}\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\topacity: .5;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4391: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:transparent;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}@media (prefers-reduced-motion:reduce){.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{transition:none}}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,sBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eDgFA,CA5CA,yIChCC,qCD4ED,CA5CA,2DAKE,gBAuCF,CA5CA,2DAUE,iBAkCF,CA5CA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CA2BD,CAxBC,2ECxDD,eDuEC,CAfA,6LCpDA,qCAAsC,CDsDpC,8CAaF,CAfA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAUD,CAHC,uCAZD,2EAaE,eAEF,CADC,CAGD,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEpFA,kCFsFA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2px /* Border */\n\t);\n\t--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t/* Unlike a regular button, the switch button text color and background should never change.\n\t * Changing toggle switch (background, outline) is enough to carry the information about the\n\t * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n\t */\n\t&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n\t\tcolor: inherit;\n\t\tbackground: transparent;\n\t}\n\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Apply some smooth transition to the box-shadow and border. */\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n\t\tborder: 1px solid transparent;\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: var(--ck-switch-button-inner-hover-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t/* Overriding default .ck-button:focus styles + an outline around the toogle */\n\t&:focus {\n\t\tborder-color: transparent;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\n\t\t& .ck-button__toggle {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n\t\t\toutline-offset: 1px;\n\t\t\toutline: var(--ck-focus-ring);\n\t\t}\n\t}\n\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-on {\n\t\t& .ck-button__toggle {\n\t\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t\t}\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\t/*\n\t\t\t\t* Move the toggle switch to the right. It will be animated.\n\t\t\t\t*/\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      25: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-collapsible.ck-collapsible_collapsed>.ck-collapsible__children{display:none}:root{--ck-collapsible-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-collapsible>.ck.ck-button{border-radius:0;color:inherit;font-weight:700;padding:var(--ck-list-button-padding);width:100%}.ck.ck-collapsible>.ck.ck-button:focus{background:transparent}.ck.ck-collapsible>.ck.ck-button:active,.ck.ck-collapsible>.ck.ck-button:hover:not(:focus),.ck.ck-collapsible>.ck.ck-button:not(:focus){background:transparent;border-color:transparent;box-shadow:none}.ck.ck-collapsible>.ck.ck-button>.ck-icon{margin-right:var(--ck-spacing-medium);width:var(--ck-collapsible-arrow-size)}.ck.ck-collapsible>.ck-collapsible__children{padding:var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large)}.ck.ck-collapsible.ck-collapsible_collapsed>.ck.ck-button .ck-icon{transform:rotate(-90deg)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/collapsible/collapsible.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/collapsible/collapsible.css"],
          names: [],
          mappings: "AAMC,sEACC,YACD,CCHD,MACC,yDACD,CAGC,iCAIC,eAAgB,CAChB,aAAc,CAHd,eAAiB,CACjB,qCAAsC,CAFtC,UAoBD,CAdC,uCACC,sBACD,CAEA,wIACC,sBAAuB,CACvB,wBAAyB,CACzB,eACD,CAEA,0CACC,qCAAsC,CACtC,sCACD,CAGD,6CACC,gFACD,CAGC,mEACC,wBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-collapsible.ck-collapsible_collapsed {\n\t& > .ck-collapsible__children {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-collapsible-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-collapsible {\n\t& > .ck.ck-button {\n\t\twidth: 100%;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-list-button-padding);\n\t\tborder-radius: 0;\n\t\tcolor: inherit;\n\n\t\t&:focus {\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t&:active, &:not(:focus), &:hover:not(:focus) {\n\t\t\tbackground: transparent;\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t& > .ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t\twidth: var(--ck-collapsible-arrow-size);\n\t\t}\n\t}\n\n\t& > .ck-collapsible__children {\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large);\n\t}\n\n\t&.ck-collapsible_collapsed {\n\t\t& > .ck.ck-button .ck-icon {\n\t\t\ttransform: rotate(-90deg);\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7317: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{transition:box-shadow .2s ease}@media (forced-colors:none){.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile.ck-color-selector__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}}@media (forced-colors:active){.ck.ck-color-grid__tile{height:unset;min-height:unset;min-width:unset;padding:0 var(--ck-spacing-small);width:unset}.ck.ck-color-grid__tile .ck-button__label{display:inline-block}}@media (prefers-reduced-motion:reduce){.ck.ck-color-grid__tile{transition:none}}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css", "webpack://./../ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAKA,kBACC,YACD,CCCA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBACC,8BAkED,CC3EC,4BACC,wBDgBA,QAAS,CAJT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CAJV,oCCTA,CDgBA,8HAIC,QACD,CAEA,+DACC,gDACD,CAEA,8BACC,8FACD,CAEA,gGAEC,iGACD,CCjCD,CAZA,8BACC,wBDqDA,YAAa,CAEb,gBAAiB,CADjB,eAAgB,CAEhB,iCAAkC,CAJlC,WClDA,CDwDA,0CACC,oBACD,CCzDD,CD4DA,uCAhDD,wBAiDE,eAkBF,CAjBC,CAEA,oCACC,YAAa,CACb,gBACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAGC,0CACC,aACD,CAIF,yBACC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\ttransition: .2s ease box-shadow;\n\n\t@mixin ck-media-default-colors {\n\t\twidth: var(--ck-color-grid-tile-size);\n\t\theight: var(--ck-color-grid-tile-size);\n\t\tmin-width: var(--ck-color-grid-tile-size);\n\t\tmin-height: var(--ck-color-grid-tile-size);\n\t\tpadding: 0;\n\t\tborder: 0;\n\n\t\t&.ck-on,\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\t/* Disable the default .ck-button\'s border ring. */\n\t\t\tborder: 0;\n\t\t}\n\n\t\t&.ck-color-selector__color-tile_bordered {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\t\t}\n\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t\t}\n\t}\n\n\t/*\n\t * In high contrast mode, the colors are replaced with text labels.\n\t * See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t */\n\t@mixin ck-media-forced-colors {\n\t\twidth: unset;\n\t\theight: unset;\n\t\tmin-width: unset;\n\t\tmin-height: unset;\n\t\tpadding: 0 var(--ck-spacing-small);\n\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1905: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".color-picker-hex-input{width:max-content}.color-picker-hex-input .ck.ck-input{min-width:unset}.ck.ck-color-picker__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;margin:var(--ck-spacing-large) 0 0;width:unset}.ck.ck-color-picker__row .ck.ck-labeled-field-view{padding-top:unset}.ck.ck-color-picker__row .ck.ck-input-text{width:unset}.ck.ck-color-picker__row .ck-color-picker__hash-view{padding-right:var(--ck-spacing-medium);padding-top:var(--ck-spacing-tiny)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/colorpicker/colorpicker.css"],
          names: [],
          mappings: "AAKA,wBACC,iBAKD,CAHC,qCACC,eACD,CAGD,yBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAA8B,CAC9B,kCAAmC,CACnC,WAcD,CAZC,mDACC,iBACD,CAEA,2CACC,WACD,CAEA,qDAEC,sCAAuC,CADvC,kCAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.color-picker-hex-input {\n\twidth: max-content;\n\n\t& .ck.ck-input {\n\t\tmin-width: unset;\n\t}\n}\n\n.ck.ck-color-picker__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\tmargin: var(--ck-spacing-large) 0 0;\n\twidth: unset;\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: unset;\n\t}\n\n\t& .ck.ck-input-text {\n\t\twidth: unset;\n\t}\n\n\t& .ck-color-picker__hash-view {\n\t\tpadding-top: var(--ck-spacing-tiny);\n\t\tpadding-right: var(--ck-spacing-medium);\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6309: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{align-items:center;display:flex}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{justify-content:flex-start}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{display:flex;flex-direction:row;justify-content:space-around}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-cancel,.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-save{flex:1}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{width:100%}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-left:var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment label.ck.ck-color-grid__label{font-weight:unset}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker{padding:8px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker{height:100px;min-width:180px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation){border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue){border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius)}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue-pointer),.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation-pointer){height:15px;width:15px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{padding:0 8px 8px}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/colorselector/colorselector.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorselector/colorselector.css"],
          names: [],
          mappings: "AAUE,oLAGC,kBAAmB,CADnB,YAMD,CARA,wMAME,0BAEF,CAKA,iFACC,YAAa,CACb,kBAAmB,CACnB,4BAMD,CAJC,oMAEC,MACD,CCrBD,oLAEC,UACD,CAEA,0FAEC,2BAA4B,CAC5B,4BAA6B,CAF7B,qEAiBD,CAbC,sGACC,gDACD,CAEA,gHAEE,uCAMF,CARA,gHAME,sCAEF,CAGD,6EACC,iBACD,CAKA,oEACC,WAoBD,CAlBC,sFACC,YAAa,CACb,eAeD,CAbC,wGACC,iEACD,CAEA,iGACC,iEACD,CAEA,yNAGC,WAAY,CADZ,UAED,CAIF,iFACC,iBACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-around;\n\n\t\t\t& .ck-button-save,\n\t\t\t& .ck-button-cancel {\n\t\t\t\tflex: 1\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck.ck-icon {\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& label.ck.ck-color-grid__label {\n\t\t\tfont-weight: unset;\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-picker {\n\t\t\tpadding: 8px;\n\n\t\t\t& .hex-color-picker {\n\t\t\t\theight: 100px;\n\t\t\t\tmin-width: 180px;\n\n\t\t\t\t&::part(saturation) {\n\t\t\t\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\t\t\t\t}\n\n\t\t\t\t&::part(hue) {\n\t\t\t\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\t\t\t}\n\n\t\t\t\t&::part(saturation-pointer),\n\t\t\t\t&::part(hue-pointer) {\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tpadding: 0 8px 8px;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9819: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-dialog-overlay{bottom:0;left:0;overscroll-behavior:none;position:fixed;right:0;top:0;user-select:none}.ck.ck-dialog-overlay.ck-dialog-overlay__transparent{animation:none;background:none;pointer-events:none}.ck.ck-dialog{overscroll-behavior:none;position:absolute;width:fit-content}.ck.ck-dialog .ck.ck-form__header{flex-shrink:0}.ck.ck-dialog .ck.ck-form__header .ck-form__header__label{cursor:grab}.ck.ck-dialog-overlay.ck-dialog-overlay__transparent .ck.ck-dialog{pointer-events:all}:root{--ck-dialog-overlay-background-color:rgba(0,0,0,.5);--ck-dialog-drop-shadow:0px 0px 6px 2px rgba(0,0,0,.15);--ck-dialog-max-width:100vw;--ck-dialog-max-height:90vh;--ck-color-dialog-background:var(--ck-color-base-background);--ck-color-dialog-form-header-border:var(--ck-color-base-border)}.ck.ck-dialog-overlay{animation:ck-dialog-fade-in .3s;background:var(--ck-dialog-overlay-background-color);z-index:var(--ck-z-dialog)}.ck.ck-dialog{border-radius:0}.ck-rounded-corners .ck.ck-dialog,.ck.ck-dialog.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dialog{box-shadow:var(--ck-drop-shadow),0 0;--ck-drop-shadow:var(--ck-dialog-drop-shadow);background:var(--ck-color-dialog-background);border:1px solid var(--ck-color-base-border);max-height:var(--ck-dialog-max-height);max-width:var(--ck-dialog-max-width)}.ck.ck-dialog .ck.ck-form__header{border-bottom:1px solid var(--ck-color-dialog-form-header-border)}@keyframes ck-dialog-fade-in{0%{background:transparent}to{background:var(--ck-dialog-overlay-background-color)}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/dialog/dialog.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dialog/dialog.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,sBAKC,QAAS,CACT,MAAO,CAJP,wBAAyB,CAEzB,cAAe,CAGf,OAAQ,CACR,KAAM,CAPN,gBAcD,CALC,qDAEC,cAAe,CACf,eAAgB,CAFhB,mBAGD,CAGD,cACC,wBAAyB,CAEzB,iBAAkB,CADlB,iBAcD,CAXC,kCACC,aAKD,CAHC,0DACC,WACD,CAVF,mEAcE,kBAEF,CC7BA,MACC,mDAA2D,CAC3D,uDAA8D,CAC9D,2BAA4B,CAC5B,2BAA4B,CAC5B,4DAA6D,CAC7D,gEACD,CAEA,sBACC,+BAAgC,CAChC,oDAAqD,CACrD,0BACD,CAEA,cCbC,eD2BD,CAdA,mECTE,qCDuBF,CAdA,cEfC,oCAA8B,CFmB9B,6CAA8C,CAE9C,4CAA6C,CAG7C,4CAA6C,CAF7C,sCAAuC,CACvC,oCAMD,CAHC,kCACC,iEACD,CAGD,6BACC,GACC,sBACD,CAEA,GACC,oDACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog-overlay {\n\tuser-select: none;\n\toverscroll-behavior: none;\n\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\n\t&.ck-dialog-overlay__transparent {\n\t\tpointer-events: none;\n\t\tanimation: none;\n\t\tbackground: none;\n\t}\n}\n\n.ck.ck-dialog {\n\toverscroll-behavior: none;\n\twidth: fit-content;\n\tposition: absolute;\n\n\t& .ck.ck-form__header  {\n\t\tflex-shrink: 0;\n\n\t\t& .ck-form__header__label {\n\t\t\tcursor: grab;\n\t\t}\n\t}\n\n\t@nest .ck.ck-dialog-overlay.ck-dialog-overlay__transparent & {\n\t\tpointer-events: all;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n:root {\n\t--ck-dialog-overlay-background-color: hsla( 0, 0%, 0%, .5 );\n\t--ck-dialog-drop-shadow: 0px 0px 6px 2px hsl(0deg 0% 0% / 15%);\n\t--ck-dialog-max-width: 100vw;\n\t--ck-dialog-max-height: 90vh;\n\t--ck-color-dialog-background: var(--ck-color-base-background);\n\t--ck-color-dialog-form-header-border: var(--ck-color-base-border);\n}\n\n.ck.ck-dialog-overlay {\n\tanimation: ck-dialog-fade-in .3s;\n\tbackground: var(--ck-dialog-overlay-background-color);\n\tz-index: var(--ck-z-dialog);\n}\n\n.ck.ck-dialog {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\t--ck-drop-shadow: var(--ck-dialog-drop-shadow);\n\n\tbackground: var(--ck-color-dialog-background);\n\tmax-height: var(--ck-dialog-max-height);\n\tmax-width: var(--ck-dialog-max-width);\n\tborder: 1px solid var(--ck-color-base-border);\n\n\t& .ck.ck-form__header {\n\t\tborder-bottom: 1px solid var(--ck-color-dialog-form-header-border);\n\t}\n}\n\n@keyframes ck-dialog-fade-in {\n\t0% {\n\t\tbackground: hsla( 0, 0%, 0%, 0 );\n\t}\n\n\t100% {\n\t\tbackground: var(--ck-dialog-overlay-background-color);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9822: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-dialog .ck.ck-dialog__actions{display:flex;justify-content:flex-end;padding:var(--ck-spacing-large)}.ck.ck-dialog .ck.ck-dialog__actions>*+*{margin-left:var(--ck-spacing-large)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/dialog/dialogactions.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dialog/dialogactions.css"],
          names: [],
          mappings: "AAMC,qCACC,YAAa,CACb,wBAAyB,CCDzB,+BDED,CCAC,yCACC,mCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog {\n\t& .ck.ck-dialog__actions {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog {\n\t& .ck.ck-dialog__actions {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * + * {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8149: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-panel)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-panel) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}.ck.ck-dropdown__panel:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eHkHD,CAhCA,qFG9EE,qCH8GF,CAhCA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAuBD,CAnBC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD,CAEA,6BACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-panel);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-panel) + 1 );\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3629: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-dropdown>.ck-dropdown__panel>.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown > .ck-dropdown__panel > .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child > .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child > .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1792: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* Make sure the divider stretches 100% height of the button\n\thttps://github.com/ckeditor/ckeditor5/issues/10936 */\n\t& > .ck-splitbutton__arrow:not(:focus) {\n\t\tborder-top-width: 0px;\n\t\tborder-bottom-width: 0px;\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t/* Make sure the divider between the buttons looks fine when the button is focused */\n\t\t& > .ck-splitbutton__arrow:focus::after {\n\t\t\t--ck-color-split-button-hover-border: var(--ck-color-focus-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1666: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"],
          names: [],
          mappings: "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8527: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-accessibility-help-dialog-max-width:600px;--ck-accessibility-help-dialog-max-height:400px;--ck-accessibility-help-dialog-border-color:#ccced1;--ck-accessibility-help-dialog-code-background-color:#ededed;--ck-accessibility-help-dialog-kbd-shadow-color:#9c9c9c}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content{border:1px solid transparent;max-height:var(--ck-accessibility-help-dialog-max-height);max-width:var(--ck-accessibility-help-dialog-max-width);overflow:auto;padding:var(--ck-spacing-large);user-select:text}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content{*{white-space:normal}}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content .ck-label{display:none}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h3{font-size:1.2em;font-weight:700}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h4{font-size:1em;font-weight:700}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h3,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h4,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content p,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content table{margin:1em 0}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl{border-bottom:none;border-top:1px solid var(--ck-accessibility-help-dialog-border-color);display:grid;grid-template-columns:2fr 1fr}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dd,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dt{border-bottom:1px solid var(--ck-accessibility-help-dialog-border-color);padding:.4em 0}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dt{grid-column-start:1}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dd{grid-column-start:2;text-align:right}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content code,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd{background:var(--ck-accessibility-help-dialog-code-background-color);border-radius:2px;display:inline-block;font-size:.9em;line-height:1;padding:.4em;text-align:center;vertical-align:middle}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content code{font-family:monospace}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd{box-shadow:0 1px 1px var(--ck-accessibility-help-dialog-kbd-shadow-color);margin:0 1px;min-width:1.8em}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd+kbd{margin-left:2px}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/accessibilityhelp.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAQA,MACC,8CAA+C,CAC/C,+CAAgD,CAChD,mDAA8D,CAC9D,4DAAyE,CACzE,uDACD,CAEA,wEAOC,4BAA6B,CAJ7B,yDAA0D,CAD1D,uDAAwD,CAExD,aAAc,CAHd,+BAAgC,CAIhC,gBAgFD,CA5EC,8ECdA,2BAA2B,CCF3B,2CAA8B,CDC9B,YDkBA,CAZD,wEAcC,EACC,kBACD,CAqED,CAlEC,kFACC,YACD,CAEA,2EAEC,eAAgB,CADhB,eAED,CAEA,2EAEC,aAAc,CADd,eAED,CAEA,8SAIC,YACD,CAEA,2EAIC,kBAAmB,CADnB,qEAAsE,CAFtE,YAAa,CACb,6BAiBD,CAbC,4JACC,wEAAyE,CACzE,cACD,CAEA,8EACC,mBACD,CAEA,8EACC,mBAAoB,CACpB,gBACD,CAGD,yJAEC,oEAAqE,CAIrE,iBAAkB,CALlB,oBAAqB,CAOrB,cAAe,CAHf,aAAc,CAFd,YAAa,CAIb,iBAAkB,CAHlB,qBAKD,CAEA,6EACC,qBACD,CAEA,4EAEC,yEAA4E,CAC5E,YAAa,CAFb,eAOD,CAHC,gFACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-accessibility-help-dialog-max-width: 600px;\n\t--ck-accessibility-help-dialog-max-height: 400px;\n\t--ck-accessibility-help-dialog-border-color: hsl(220, 6%, 81%);\n\t--ck-accessibility-help-dialog-code-background-color: hsl(0deg 0% 92.94%);\n\t--ck-accessibility-help-dialog-kbd-shadow-color: hsl(0deg 0% 61%);\n}\n\n.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content {\n\tpadding: var(--ck-spacing-large);\n\tmax-width: var(--ck-accessibility-help-dialog-max-width);\n\tmax-height: var(--ck-accessibility-help-dialog-max-height);\n\toverflow: auto;\n\tuser-select: text;\n\n\tborder: 1px solid transparent;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t* {\n\t\twhite-space: normal;\n\t}\n\n\t/* Hide the main label of the content container. */\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t& h3 {\n\t\tfont-weight: bold;\n\t\tfont-size: 1.2em;\n\t}\n\n\t& h4 {\n\t\tfont-weight: bold;\n\t\tfont-size: 1em;\n\t}\n\n\t& p,\n\t& h3,\n\t& h4,\n\t& table {\n\t\tmargin: 1em 0;\n\t}\n\n\t& dl {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 2fr 1fr;\n\t\tborder-top: 1px solid var(--ck-accessibility-help-dialog-border-color);\n\t\tborder-bottom: none;\n\n\t\t& dt, & dd {\n\t\t\tborder-bottom: 1px solid var(--ck-accessibility-help-dialog-border-color);\n\t\t\tpadding: .4em 0;\n\t\t}\n\n\t\t& dt {\n\t\t\tgrid-column-start: 1;\n\t\t}\n\n\t\t& dd {\n\t\t\tgrid-column-start: 2;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& kbd, & code {\n\t\tdisplay: inline-block;\n\t\tbackground: var(--ck-accessibility-help-dialog-code-background-color);\n\t\tpadding: .4em;\n\t\tvertical-align: middle;\n\t\tline-height: 1;\n\t\tborder-radius: 2px;\n\t\ttext-align: center;\n\t\tfont-size: .9em;\n\t}\n\n\t& code {\n\t\tfont-family: monospace;\n\t}\n\n\t& kbd {\n\t\tmin-width: 1.8em;\n\t\tbox-shadow: 0px 1px 1px var(--ck-accessibility-help-dialog-kbd-shadow-color);\n\t\tmargin: 0 1px;\n\n\t\t& + kbd {\n\t\t\tmargin-left: 2px;\n\t\t}\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1185: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,oDACD,CAIA,gEACC,iDACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-panel-background);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-panel-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7913: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__header h2.ck-form__header__label{flex-grow:1}:root{--ck-form-header-height:44px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}[dir=ltr] .ck.ck-form__header>.ck-icon{margin-right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-form__header>.ck-icon{margin-left:var(--ck-spacing-medium)}.ck.ck-form__header .ck-form__header__label{--ck-font-size-base:15px;font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"],
          names: [],
          mappings: "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BAKD,CAHC,8CACC,WACD,CCPD,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAmBD,CAdC,uCAEE,qCAMF,CARA,uCAME,oCAEF,CAEA,4CACC,wBAAyB,CACzB,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t& h2.ck-form__header__label {\n\t\tflex-grow: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-form-header-height: 44px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& > .ck-icon {\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: var(--ck-spacing-medium);\n\t\t}\n\t}\n\n\t& .ck-form__header__label {\n\t\t--ck-font-size-base: 15px;\n\t\tfont-weight: bold;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9529: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-highlighted-text mark{background:var(--ck-color-highlight-background);font-size:inherit;font-weight:inherit;line-height:inherit;vertical-align:initial}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/highlightedtext/highlightedtext.css"],
          names: [],
          mappings: "AAKA,6BACC,+CAAgD,CAIhD,iBAAkB,CAFlB,mBAAoB,CACpB,mBAAoB,CAFpB,sBAID",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-highlighted-text mark {\n\tbackground: var(--ck-color-highlight-background);\n\tvertical-align: initial;\n\tfont-weight: inherit;\n\tline-height: inherit;\n\tfont-size: inherit;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7621: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/icon/icon.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"],
          names: [],
          mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\t}\n\n\t/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n\t&.ck-icon_inherit-color {\n\t\tcolor: inherit;\n\n\t\t& * {\n\t\t\tcolor: inherit;\n\n\t\t\t&:not([fill]) {\n\t\t\t\t/* Needed by FF. */\n\t\t\t\tfill: currentColor;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      253: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}@media (prefers-reduced-motion:reduce){.ck.ck-input{transition:none}}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}@media (prefers-reduced-motion:reduce){.ck.ck-input.ck-error{animation:none}}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eDmDD,CA9CA,iECDE,qCD+CF,CA9CA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DAkCD,CAhCC,uCAdD,aAeE,eA+BF,CA9BC,CAEA,mBEvBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YF2BA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BGnCD,oDHsCC,CAGD,sBAEC,sCAAuC,CADvC,+CAUD,CAPC,uCAJD,sBAKE,cAMF,CALC,CAEA,4BGjDD,iDHmDC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\tanimation: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7801: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/label/label.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"],
          names: [],
          mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4962: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0;transform:translate(calc(var(--ck-spacing-medium)*-1),-6px) scale(.75);transform-origin:100% 0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}@media (prefers-reduced-motion:reduce){.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transition:none}}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eDmHD,CA9GA,2FCDE,qCD+GF,CA3GC,mEACC,UAwCD,CAtCC,gFACC,KAoCD,CArCA,0FAIE,MAAS,CAGT,6DAA+D,CAF/D,oBAgCF,CArCA,0FAWE,OAAU,CAEV,sEAA0E,CAD1E,uBAyBF,CArCA,gFAkBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAH9C,mBAAoB,CAQpB,sBAAuB,CAKvB,+JAQD,CAHC,uCAlCD,gFAmCE,eAEF,CADC,CASD,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,2XAGE,+HAYF,CAfA,2XAOE,wIAQF,CAfA,uWAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t\ttransform-origin: 0 0;\n\t\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t\ttransform-origin: 100% 0;\n\t\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), -6px) scale(.75);\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5199: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}:root{--ck-list-button-padding:calc(var(--ck-line-height-base)*0.11*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item>.ck-button{border-radius:0;min-height:unset;width:100%}[dir=ltr] .ck.ck-list__item>.ck-button{text-align:left}[dir=rtl] .ck.ck-list__item>.ck-button{text-align:right}.ck.ck-list__item>.ck-button{padding:var(--ck-list-button-padding)}.ck.ck-list__item>.ck-button:active{box-shadow:none}.ck.ck-list__item>.ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item>.ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item>.ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item>.ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item>.ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item>.ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item>.ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck-list .ck-list__group{padding-top:var(--ck-spacing-medium);:not(.ck-hidden)~&{border-top:1px solid var(--ck-color-base-border)}}.ck-list .ck-list__group>.ck-label{font-size:11px;font-weight:700;padding:var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium)}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/list/list.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEdD,MACC,qJAGD,CAEA,YCLC,eDUD,CALA,+DCDE,qCDMF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAGC,eAAgB,CAFhB,gBAAiB,CACjB,UAwCD,CA1CA,uCAME,eAoCF,CA1CA,uCAUE,gBAgCF,CA1CA,6BAgBC,qCA0BD,CAxBC,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,yBACC,oCAAqC,CAGrC,mBACC,gDACD,CAOD,CALC,mCACC,cAAe,CACf,eAAiB,CACjB,oFACD,CAGD,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-list-button-padding:\n\t\tcalc(.11 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n}\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& > .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\tborder-radius: 0;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding: var(--ck-list-button-padding);\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& > .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-list .ck-list__group {\n\tpadding-top: var(--ck-spacing-medium);\n\n\t/* The group should have a border when it\'s not the first item. */\n\t*:not(.ck-hidden) ~ & {\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& > .ck-label {\n\t\tfont-size: 11px;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium);\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      497: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-menu-bar{background:var(--ck-color-base-background);border:1px solid var(--ck-color-toolbar-border);display:flex;flex-wrap:wrap;gap:var(--ck-spacing-small);justify-content:flex-start;padding:var(--ck-spacing-small);width:100%}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubar.css"],
          names: [],
          mappings: "AAKA,gBAIC,0CAA2C,CAG3C,+CAAgD,CANhD,YAAa,CACb,cAAe,CAIf,2BAA4B,CAH5B,0BAA2B,CAE3B,+BAAgC,CAGhC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-start;\n\tbackground: var(--ck-color-base-background);\n\tpadding: var(--ck-spacing-small);\n\tgap: var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\twidth: 100%;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-menu-bar__menu{display:block;font-size:inherit;position:relative}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level{max-width:100%}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/menubar/menubarmenu.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenu.css"],
          names: [],
          mappings: "AAKA,sBACC,aAAc,CCCd,iBAAkB,CDAlB,iBACD,CCCC,kDACC,cACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\tdisplay: block;\n\tposition: relative;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t&.ck-menu-bar__menu_top-level {\n\t\tmax-width: 100%;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3344: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-menu-bar__menu>.ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button{padding:var(--ck-list-button-padding);width:100%}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button>.ck-button__label{flex-grow:1;overflow:hidden;text-overflow:ellipsis}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button.ck-disabled>.ck-button__label{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-menu-bar__menu>.ck-menu-bar__menu__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-menu-bar__menu>.ck-menu-bar__menu__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button{min-height:unset;padding:var(--ck-spacing-small) var(--ck-spacing-medium)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button .ck-button__label{line-height:unset;width:unset}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button .ck-icon{display:none}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button{border-radius:0}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:focus{border-color:transparent;box-shadow:none}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:focus:not(.ck-on){background:var(--ck-color-button-default-hover-background)}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:not(:has(.ck-button__icon))>.ck-button__label{margin-left:calc(var(--ck-icon-size) - var(--ck-spacing-small))}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{transform:rotate(-90deg)}[dir=rtl] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{transform:rotate(90deg)}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button.ck-disabled>.ck-menu-bar__menu__button__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/menubar/menubarmenubutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenubutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAMC,mFACC,mBAAoB,CACpB,2BACD,CCIA,iDACC,qCAAsC,CACtC,UAuBD,CArBC,mEACC,WAAY,CACZ,eAAgB,CAChB,sBACD,CAEA,+ECdD,kCDgBC,CAGC,qFACC,oCACD,CAIA,qFACC,qCACD,CAOF,6EAEC,gBAAiB,CADjB,wDAgBD,CAbC,+FAEC,iBAAkB,CADlB,WAED,CAEA,mFACC,2BAA4B,CAC5B,4BACD,CAEA,sFACC,YACD,CAMD,mFACC,eAiDD,CA/CC,yFACC,wBAAyB,CACzB,eAKD,CAHC,qGACC,0DACD,CAID,iIACC,+DACD,CAEA,qHACC,mCASD,CAVA,+HAIE,wBAMF,CAVA,+HAQE,uBAEF,CAEA,iICrFD,kCDuFC,CAGC,+HAIC,sCAAuC,CAHvC,gCAID,CAIA,+HACC,+BAAgC,CAGhC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu  {\n\t& > .ck-menu-bar__menu__button > .ck-menu-bar__menu__button__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-menu-bar__menu {\n\t/*\n\t * All menu buttons.\n\t */\n\t& > .ck-menu-bar__menu__button {\n\t\tpadding: var(--ck-list-button-padding);\n\t\twidth: 100%;\n\n\t\t& > .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t&.ck-disabled > .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Top-level menu buttons only.\n\t */\n\t&.ck-menu-bar__menu_top-level > .ck-menu-bar__menu__button {\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tmin-height: unset;\n\n\t\t& .ck-button__label {\n\t\t\twidth: unset;\n\t\t\tline-height: unset;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/*\n\t * Sub-menu buttons.\n\t */\n\t&:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button {\n\t\tborder-radius: 0;\n\n\t\t&:focus {\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\n\t\t\t&:not(.ck-on) {\n\t\t\t\tbackground: var(--ck-color-button-default-hover-background);\n\t\t\t}\n\t\t}\n\n\t\t/* Spacing in buttons that miss the icon. */\n\t\t&:not(:has(.ck-button__icon)) > .ck-button__label {\n\t\t\tmargin-left: calc(var(--ck-icon-size) - var(--ck-spacing-small));\n\t\t}\n\n\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: rotate(-90deg);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: rotate(90deg);\n\t\t\t}\n\t\t}\n\n\t\t&.ck-disabled > .ck-menu-bar__menu__button__arrow {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t\t/* A space to accommodate the triangle. */\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t\t/* A space to accommodate the triangle. */\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9481: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-menu-bar-menu-item-min-width:18em}.ck.ck-menu-bar__menu .ck.ck-menu-bar__menu__item{min-width:var(--ck-menu-bar-menu-item-min-width)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenulistitem.css"],
          names: [],
          mappings: "AAKA,MACC,sCACD,CAEA,kDACC,gDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-menu-bar-menu-item-min-width: 18em;\n}\n\n.ck.ck-menu-bar__menu .ck.ck-menu-bar__menu__item {\n\tmin-width: var(--ck-menu-bar-menu-item-min-width);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      977: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button{border-radius:0}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container,.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container .ck-spinner{--ck-toolbar-spinner-size:20px}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button:focus{border-color:transparent;box-shadow:none}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button:focus:not(.ck-on){background:var(--ck-color-button-default-hover-background)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__panel>ul>.ck-menu-bar__menu__item>.ck-menu-bar__menu__item__button:not(:has(.ck-button__icon))>.ck-button__label{margin-left:calc(var(--ck-icon-size) - var(--ck-spacing-small))}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenulistitembutton.css"],
          names: [],
          mappings: "AASC,iEACC,eA0BD,CAxBC,0LAGC,8BACD,CAEA,uFAEC,4CAA+C,CAC/C,oCACD,CAMA,uEACC,wBAAyB,CACzB,eAKD,CAHC,mFACC,0DACD,CASD,uLACC,+DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\t/*\n\t * List item buttons.\n\t */\n\t& .ck-button.ck-menu-bar__menu__item__button {\n\t\tborder-radius: 0;\n\n\t\t& > .ck-spinner-container,\n\t\t& > .ck-spinner-container .ck-spinner {\n\t\t\t/* These styles correspond to .ck-icon so that the spinner seamlessly replaces the icon. */\n\t\t\t--ck-toolbar-spinner-size: 20px;\n\t\t}\n\n\t\t& > .ck-spinner-container {\n\t\t\t/* These margins are the same as for .ck-icon. */\n\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/*\n\t\t * Hovered items automatically get focused. Default focus styles look odd\n\t\t * while moving across a huge list of items so let's get rid of them\n\t\t */\n\t\t&:focus {\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\n\t\t\t&:not(.ck-on) {\n\t\t\t\tbackground: var(--ck-color-button-default-hover-background);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * First-level sub-menu item buttons.\n\t */\n\t&.ck-menu-bar__menu_top-level > .ck-menu-bar__menu__panel > ul > .ck-menu-bar__menu__item > .ck-menu-bar__menu__item__button {\n\t\t/* Spacing in buttons that miss the icon. */\n\t\t&:not(:has(.ck-button__icon)) > .ck-button__label {\n\t\t\tmargin-left: calc(var(--ck-icon-size) - var(--ck-spacing-small));\n\t\t}\n\t}\n}\n\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9108: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-menu-bar-menu-max-width:75vw;--ck-menu-bar-nested-menu-horizontal-offset:5px}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{max-width:var(--ck-menu-bar-menu-max-width);position:absolute;z-index:var(--ck-z-panel)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw{bottom:100%}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw{bottom:auto;top:100%}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se{left:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw{right:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es{left:calc(100% - var(--ck-menu-bar-nested-menu-horizontal-offset))}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es{top:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en{bottom:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{right:calc(100% - var(--ck-menu-bar-nested-menu-horizontal-offset))}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{top:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn{bottom:0}:root{--ck-menu-bar-menu-panel-max-width:75vw}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{border-radius:0}.ck-rounded-corners .ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;height:fit-content;max-width:var(--ck-menu-bar-menu-panel-max-width)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se{border-top-left-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{border-top-right-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne{border-bottom-left-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn{border-bottom-right-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/menubar/menubarmenupanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenupanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MACC,iCAAkC,CAClC,+CACD,CAEA,mDAEC,2CAA4C,CAC5C,iBAAkB,CAFlB,yBAkDD,CA9CC,gLAEC,WACD,CAEA,gLAGC,WAAY,CADZ,QAED,CAEA,gLAEC,MACD,CAEA,gLAEC,OACD,CAEA,gLAEC,kEACD,CAEA,wFACC,KACD,CAEA,wFACC,QACD,CAEA,gLAEC,mEACD,CAEA,wFACC,KACD,CAEA,wFACC,QACD,CCpDD,MACC,uCACD,CAEA,mDCDC,eDmCD,CAlCA,6ICGE,qCD+BF,CAlCA,mDAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CETT,oCAA8B,CFU9B,kBAAmB,CACnB,iDA0BD,CAvBC,gLAEC,wBACD,CAEA,gLAEC,yBACD,CAEA,gLAEC,2BACD,CAEA,gLAEC,4BACD,CAEA,yDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-menu-bar-menu-max-width: 75vw;\n\t--ck-menu-bar-nested-menu-horizontal-offset: 5px;\n}\n\n.ck.ck-menu-bar__menu > .ck.ck-menu-bar__menu__panel {\n\tz-index: var(--ck-z-panel);\n\tmax-width: var(--ck-menu-bar-menu-max-width);\n\tposition: absolute;\n\n\t&.ck-menu-bar__menu__panel_position_ne,\n\t&.ck-menu-bar__menu__panel_position_nw {\n\t\tbottom: 100%;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_se,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\ttop: 100%;\n\t\tbottom: auto;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ne,\n\t&.ck-menu-bar__menu__panel_position_se {\n\t\tleft: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_nw,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\tright: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_es,\n\t&.ck-menu-bar__menu__panel_position_en {\n\t\tleft: calc( 100% - var(--ck-menu-bar-nested-menu-horizontal-offset) );\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_es {\n\t\ttop: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_en {\n\t\tbottom: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws,\n\t&.ck-menu-bar__menu__panel_position_wn {\n\t\tright: calc( 100% - var(--ck-menu-bar-nested-menu-horizontal-offset) );\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws {\n\t\ttop: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_wn {\n\t\tbottom: 0px;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-menu-bar-menu-panel-max-width: 75vw;\n}\n\n.ck.ck-menu-bar__menu > .ck.ck-menu-bar__menu__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\theight: fit-content;\n\tmax-width: var(--ck-menu-bar-menu-panel-max-width);\n\n\t/* Corner border radius consistent with the button. */\n\t&.ck-menu-bar__menu__panel_position_es,\n\t&.ck-menu-bar__menu__panel_position_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_en,\n\t&.ck-menu-bar__menu__panel_position_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_wn,\n\t&.ck-menu-bar__menu__panel_position_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3710: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-panel)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-panel);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      991: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"],
          names: [],
          mappings: "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5380: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-panel) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-panel) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8298: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-panel)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-panel); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2722: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-number,.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"],
          names: [],
          mappings: "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAoED,CAlEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA+CF,CA7CE,8CACC,wDAYD,CAVC,4HAEC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDrEH",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text,\n\t\t\t& .ck-input-number {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8107: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{position:absolute;top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{left:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{right:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view .ck-search__reset{position:absolute;top:50%;transform:translateY(-50%)}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{display:block}.ck.ck-search>.ck-search__results>.ck-search__info:not(.ck-hidden)~*{display:none}:root{--ck-search-field-view-horizontal-spacing:calc(var(--ck-icon-size) + var(--ck-spacing-medium))}.ck.ck-search>.ck-labeled-field-view .ck-input{width:100%}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon{--ck-labeled-field-label-default-position-x:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon>.ck-labeled-field-view__input-wrapper>.ck-icon{opacity:.5;pointer-events:none}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input,[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input:not(.ck-input-text_empty){padding-left:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset{--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset.ck-labeled-field-view_empty{--ck-labeled-field-empty-unfocused-max-width:100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{background:none;min-height:auto;min-width:auto;opacity:.5;padding:0}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{left:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset:hover{opacity:1}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input:not(.ck-input-text_empty),[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{padding-right:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-search__results{min-width:100%}.ck.ck-search>.ck-search__results>.ck-search__info{padding:var(--ck-spacing-medium) var(--ck-spacing-large);width:100%}.ck.ck-search>.ck-search__results>.ck-search__info *{white-space:normal}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{font-weight:700}.ck.ck-search>.ck-search__results>.ck-search__info>span:last-child{margin-top:var(--ck-spacing-medium)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/search/search.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/search/search.css"],
          names: [],
          mappings: "AASE,oFACC,iBAAkB,CAClB,OAAQ,CACR,0BASD,CAZA,8FAME,6BAMF,CAZA,8FAUE,8BAEF,CAEA,uDACC,iBAAkB,CAClB,OAAQ,CACR,0BACD,CAKC,oEACC,aACD,CAGA,qEACC,YACD,CChCH,MACC,8FACD,CAIE,+CACC,UACD,CAEA,gEACC,0FAoBD,CAlBC,+GACC,UAAW,CACX,mBACD,CAEA,0EACC,UAWD,CAJE,kMACC,2DACD,CAKH,iEACC,sGAwCD,CAtCC,6FACC,6HACD,CAEA,mFAIC,eAAgB,CAFhB,eAAgB,CADhB,cAAe,CAIf,UAAW,CACX,SAaD,CAnBA,6FASE,8BAUF,CAnBA,6FAaE,6BAMF,CAHC,yFACC,SACD,CAGD,2EACC,UAWD,CAZA,oMAUE,4DAEF,CAIF,kCACC,cAkBD,CAhBC,mDAEC,wDAAyD,CADzD,UAcD,CAXC,qDACC,kBACD,CAEA,oEACC,eACD,CAEA,mEACC,mCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\n\t\t& .ck-search__reset {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\t& > .ck-search__info {\n\t\t\t& > span:first-child {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t/* Hide the filtered view when nothing was found */\n\t\t\t&:not(.ck-hidden) ~ * {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-search-field-view-horizontal-spacing: calc(var(--ck-icon-size) + var(--ck-spacing-medium));\n}\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& .ck-input {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&.ck-search__query_with-icon {\n\t\t\t--ck-labeled-field-label-default-position-x: var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\t\topacity: .5;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-search__query_with-reset {\n\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t&.ck-labeled-field-view_empty {\n\t\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t& .ck-search__reset {\n\t\t\t\tmin-width: auto;\n\t\t\t\tmin-height: auto;\n\n\t\t\t\tbackground: none;\n\t\t\t\topacity: .5;\n\t\t\t\tpadding: 0;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\tmin-width: 100%;\n\n\t\t& > .ck-search__info {\n\t\t\twidth: 100%;\n\t\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large);\n\n\t\t\t& * {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\n\t\t\t& > span:first-child {\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t& > span:last-child {\n\t\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\t}\n}\n\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      109: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-spinner-container{display:block;position:relative}.ck.ck-spinner{left:0;margin:0 auto;position:absolute;right:0;top:50%;transform:translateY(-50%);z-index:1}:root{--ck-toolbar-spinner-size:18px}.ck.ck-spinner-container{animation:rotate 1.5s linear infinite;height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}@media (prefers-reduced-motion:reduce){.ck.ck-spinner-container{animation-duration:3s}}.ck.ck-spinner{border:2px solid var(--ck-color-text);border-radius:50%;border-top:2px solid transparent;height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}@keyframes rotate{to{transform:rotate(1turn)}}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/spinner/spinner.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/spinner/spinner.css"],
          names: [],
          mappings: "AASA,yBACC,aAAc,CACd,iBACD,CAEA,eAGC,MAAO,CAEP,aAAc,CAJd,iBAAkB,CAGlB,OAAQ,CAFR,OAAQ,CAIR,0BAA2B,CAC3B,SACD,CCjBA,MACC,8BACD,CAEA,yBAGC,qCAAsC,CADtC,qCAAsC,CADtC,oCAOD,CAHC,uCALD,yBAME,qBAEF,CADC,CAGD,eAKC,qCAA6B,CAF7B,iBAAkB,CAElB,gCAA6B,CAH7B,qCAAsC,CADtC,oCAKD,CAEA,kBACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\tdisplay: block;\n\tposition: relative;\n}\n\n.ck.ck-spinner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\ttransform: translateY(-50%);\n\tz-index: 1;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tanimation: 1.5s infinite rotate linear;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation-duration: 3s;\n\t}\n}\n\n.ck.ck-spinner {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--ck-color-text);\n\tborder-top-color: transparent;\n}\n\n@keyframes rotate {\n\tto {\n\t\ttransform: rotate(360deg)\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1671: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-textarea{overflow-x:hidden}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/textarea/textarea.css"],
          names: [],
          mappings: "AASA,aACC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/*\n * This fixes a problem in Firefox when the initial height of the complement does not match the number of rows.\n * This bug is especially visible when rows=1.\n */\n.ck-textarea {\n\toverflow-x: hidden\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2710: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"],
          names: [],
          mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9677: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck.ck-toolbar:focus{outline:none}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDwGD,CA3GA,qECOE,qCDoGF,CA3GA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAuGD,CApGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAGD,qBACC,YACD,CAtGD,qCAyGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t/* A drop-down containing the nested toolbar with configured items. */\n\t& .ck-toolbar__nested-toolbar-dropdown {\n\t\t/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */\n\t\t& > .ck-dropdown__panel {\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& > .ck-button > .ck-button__label {\n\t\t\tmax-width: 7em;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9205: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck.ck-balloon-panel.ck-tooltip{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;z-index:calc(var(--ck-z-dialog) + 100);--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-tooltip-text-padding:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip.ck-tooltip_multi-line .ck-tooltip__text{display:inline-block;max-width:200px;padding:var(--ck-tooltip-text-padding) 0;white-space:break-spaces}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css"],
          names: [],
          mappings: "AAOA,gCCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,sCAAyC,CEFzC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,6BAA8B,CAC9B,8DAA+D,CAE/D,kCFJD,CEMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAEA,wEAEC,oBAAqB,CAErB,eAAgB,CADhB,wCAAyC,CAFzC,wBAID,CArBD,gCAwBC,eAMD,CAHC,uCACC,YACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t@mixin ck-unselectable;\n\n\tz-index: calc( var(--ck-z-dialog) + 100 );\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-tooltip-text-padding: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t&.ck-tooltip_multi-line .ck-tooltip__text {\n\t\twhite-space: break-spaces;\n\t\tdisplay: inline-block;\n\t\tpadding: var(--ck-tooltip-text-padding) 0;\n\t\tmax-width: 200px;\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7676: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck-hidden{display:none!important}:root{--ck-z-default:1;--ck-z-panel:calc(var(--ck-z-default) + 999);--ck-z-dialog:9999}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-powered-by-line-height:10px;--ck-powered-by-padding-vertical:2px;--ck-powered-by-padding-horizontal:4px;--ck-powered-by-text-color:#4f4f4f;--ck-powered-by-border-radius:var(--ck-border-radius);--ck-powered-by-background:#fff;--ck-powered-by-border-color:var(--ck-color-focus-border)}.ck.ck-balloon-panel.ck-powered-by-balloon{--ck-border-radius:var(--ck-powered-by-border-radius);background:var(--ck-powered-by-background);box-shadow:none;min-height:unset;z-index:calc(var(--ck-z-panel) - 1)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by{line-height:var(--ck-powered-by-line-height)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by a{align-items:center;cursor:pointer;display:flex;filter:grayscale(80%);line-height:var(--ck-powered-by-line-height);opacity:.66;padding:var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-powered-by__label{color:var(--ck-powered-by-text-color);cursor:pointer;font-size:7.5px;font-weight:700;letter-spacing:-.2px;line-height:normal;margin-right:4px;padding-left:2px;text-transform:uppercase}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-icon{cursor:pointer;display:block}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by:hover a{filter:grayscale(0);opacity:1}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_inside]{border-color:transparent}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_border]{border:var(--ck-focus-ring);border-color:var(--ck-powered-by-border-color)}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-dialog-background:var(--ck-custom-background);--ck-color-dialog-form-header-border:var(--ck-custom-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-color-highlight-background:#ff0;--ck-color-light-red:#fcc;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{background:transparent;border:0;box-sizing:border-box;height:auto;margin:0;padding:0;position:static;text-decoration:none;transition:none;vertical-align:middle;width:auto;word-wrap:break-word}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-ui/theme/globals/_hidden.css", "webpack://./../ckeditor5-ui/theme/globals/_zindex.css", "webpack://./../ckeditor5-ui/theme/globals/_transition.css", "webpack://./../ckeditor5-ui/theme/globals/_poweredby.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"],
          names: [],
          mappings: "AAQA,WAGC,sBACD,CCPA,MACC,gBAAiB,CACjB,4CAA+C,CAC/C,kBACD,CCDA,oDAEC,yBACD,CCNA,MACC,gCAAiC,CACjC,oCAAqC,CACrC,sCAAuC,CACvC,kCAA2C,CAC3C,qDAAsD,CACtD,+BAA4C,CAC5C,yDACD,CAEA,2CACC,qDAAsD,CAGtD,0CAA2C,CAD3C,eAAgB,CAEhB,gBAAiB,CACjB,mCAiDD,CA/CC,6DACC,4CAoCD,CAlCC,+DAGC,kBAAmB,CAFnB,cAAe,CACf,YAAa,CAGb,qBAAsB,CACtB,4CAA6C,CAF7C,WAAY,CAGZ,qFACD,CAEA,mFASC,qCAAsC,CAFtC,cAAe,CANf,eAAgB,CAIhB,eAAiB,CAHjB,oBAAqB,CAMrB,kBAAmB,CAFnB,gBAAiB,CAHjB,gBAAiB,CACjB,wBAOD,CAEA,sEAEC,cAAe,CADf,aAED,CAGC,qEACC,mBAAqB,CACrB,SACD,CAIF,mEACC,wBACD,CAEA,mEACC,2BAA4B,CAC5B,8CACD,CChED,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,wDAAiE,CACjE,4DAAmE,CAInE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CAIhE,oCAAyD,CAIzD,yBAAgD,CChHhD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJgHD,CI1GA,2EAYC,sBAAuB,CADvB,QAAS,CART,qBAAsB,CAEtB,WAAY,CAIZ,QAAS,CACT,SAAU,CAJV,eAAgB,CAOhB,oBAAqB,CAErB,eAAgB,CADhB,qBAAsB,CAVtB,UAAW,CAcX,oBACD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCxFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-panel: calc( var(--ck-z-default) + 999 );\n\t--ck-z-dialog: 9999;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-powered-by-line-height: 10px;\n\t--ck-powered-by-padding-vertical: 2px;\n\t--ck-powered-by-padding-horizontal: 4px;\n\t--ck-powered-by-text-color: hsl(0, 0%, 31%);\n\t--ck-powered-by-border-radius: var(--ck-border-radius);\n\t--ck-powered-by-background: hsl(0, 0%, 100%);\n\t--ck-powered-by-border-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-balloon-panel.ck-powered-by-balloon {\n\t--ck-border-radius: var(--ck-powered-by-border-radius);\n\n\tbox-shadow: none;\n\tbackground: var(--ck-powered-by-background);\n\tmin-height: unset;\n\tz-index: calc( var(--ck-z-panel) - 1 );\n\n\t& .ck.ck-powered-by {\n\t\tline-height: var(--ck-powered-by-line-height);\n\n\t\t& a {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\topacity: .66;\n\t\t\tfilter: grayscale(80%);\n\t\t\tline-height: var(--ck-powered-by-line-height);\n\t\t\tpadding: var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal);\n\t\t}\n\n\t\t& .ck-powered-by__label {\n\t\t\tfont-size: 7.5px;\n\t\t\tletter-spacing: -.2px;\n\t\t\tpadding-left: 2px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: bold;\n\t\t\tmargin-right: 4px;\n\t\t\tcursor: pointer;\n\t\t\tline-height: normal;\n\t\t\tcolor: var(--ck-powered-by-text-color);\n\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: block;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&:hover {\n\t\t\t& a {\n\t\t\t\tfilter: grayscale(0%);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[class*="position_inside"] {\n\t\tborder-color: transparent;\n\t}\n\n\t&[class*="position_border"] {\n\t\tborder: var(--ck-focus-ring);\n\t\tborder-color: var(--ck-powered-by-border-color);\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Dialog -------------------------------------------------------------------------------- */\n\n\t--ck-color-dialog-background: \t\t\t\t\t\t\t\tvar(--ck-custom-background);\n\t--ck-color-dialog-form-header-border: \t\t\t\t\t\tvar(--ck-custom-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n\n\t/* -- Search result highlight ---------------------------------------------------------------- */\n\n\t--ck-color-highlight-background:\t\t\t\t\t\t\thsl(60, 100%, 50%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------- */\n\n\t--ck-color-light-red:\t\t\t\t\t\t\t\t\t\thsl(0, 100%, 90%);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      695: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget{transition:none}}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}@media (forced-colors:none){.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background)}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:transparent;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{transition:none}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{transition:none}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-widget/theme/widget.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CChFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAcD,CAZC,uCAND,eAOE,eAWF,CAVC,CAEA,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAYD,CARC,yGCnCA,2BAA2B,CCF3B,qCAA8B,CDC9B,YD2CA,CGvCA,4BACC,yGHoCC,iEGlCD,CACD,CHuCA,4EAKC,4BAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAwCD,CA3BC,uCAzBD,4EA0BE,eA0BF,CAzBC,CAEA,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAeD,CAVC,kHACC,SAAU,CAGV,+DAKD,CAHC,uCAND,kHAOE,eAEF,CADC,CAKF,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t\t@mixin ck-media-default-colors {\n\t\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t\t}\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\n\t\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\t\ttransition: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4095: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-widget/theme/widgetresize.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"],
          names: [],
          mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8508: (t, e, n) => {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var o = n(9372),
          i = n.n(o),
          r = n(935),
          s = n.n(r)()(i());
        s.push([t.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button{transition:none}}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button svg{transition:none}}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button:hover,.ck .ck-widget .ck-widget__type-around__button:hover svg line,.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:none}}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./../ckeditor5-widget/theme/widgettypearound.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"],
          names: [],
          mappings: "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAwED,CAhEC,uCATD,+CAUE,eA+DF,CA9DC,CAEA,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAwBD,CAlBC,uCAPD,mDAQE,eAiBF,CAhBC,CAEA,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DA4BD,CAtBE,kEACC,oDACD,CAEA,8DACC,wDACD,CAGD,uCAQE,qLACC,cACD,CAEF,CASD,uKA7FD,SAAU,CACV,mBA8FC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAxKD,SAAU,CACV,mBAyKC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAxNF,SAAU,CACV,mBAyNE,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\tanimation: none;\n\n\t\t\t\t& svg {\n\t\t\t\t\t& polyline {\n\t\t\t\t\t\tanimation: none;\n\t\t\t\t\t}\n\n\t\t\t\t\t& line {\n\t\t\t\t\t\tanimation: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      935: t => {
        "use strict";

        t.exports = function (t) {
          var e = [];
          return e.toString = function () {
            return this.map(function (e) {
              var n = t(e);
              return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
            }).join("");
          }, e.i = function (t, n, o) {
            "string" == typeof t && (t = [[null, t, ""]]);
            var i = {};
            if (o) for (var r = 0; r < this.length; r++) {
              var s = this[r][0];
              null != s && (i[s] = !0);
            }
            for (var a = 0; a < t.length; a++) {
              var c = [].concat(t[a]);
              o && i[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), e.push(c));
            }
          }, e;
        };
      },
      9372: t => {
        "use strict";

        function e(t, e) {
          return function (t) {
            if (Array.isArray(t)) return t;
          }(t) || function (t, e) {
            var n = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
            if (null == n) return;
            var o,
              i,
              r = [],
              s = !0,
              a = !1;
            try {
              for (n = n.call(t); !(s = (o = n.next()).done) && (r.push(o.value), !e || r.length !== e); s = !0);
            } catch (t) {
              a = !0, i = t;
            } finally {
              try {
                s || null == n.return || n.return();
              } finally {
                if (a) throw i;
              }
            }
            return r;
          }(t, e) || function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return n(t, e);
            var o = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === o && t.constructor && (o = t.constructor.name);
            if ("Map" === o || "Set" === o) return Array.from(t);
            if ("Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return n(t, e);
          }(t, e) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function n(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
          return o;
        }
        t.exports = function (t) {
          var n = e(t, 4),
            o = n[1],
            i = n[3];
          if (!i) return o;
          if ("function" == typeof btoa) {
            var r = btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
              s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),
              a = "/*# ".concat(s, " */"),
              c = i.sources.map(function (t) {
                return "/*# sourceURL=".concat(i.sourceRoot || "").concat(t, " */");
              });
            return [o].concat(c).concat([a]).join("\n");
          }
          return [o].join("\n");
        };
      },
      2591: (t, e, n) => {
        "use strict";

        var o,
          i = function () {
            return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
          },
          r = function () {
            var t = {};
            return function (e) {
              if (void 0 === t[e]) {
                var n = document.querySelector(e);
                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                  n = n.contentDocument.head;
                } catch (t) {
                  n = null;
                }
                t[e] = n;
              }
              return t[e];
            };
          }(),
          s = [];
        function a(t) {
          for (var e = -1, n = 0; n < s.length; n++) if (s[n].identifier === t) {
            e = n;
            break;
          }
          return e;
        }
        function c(t, e) {
          for (var n = {}, o = [], i = 0; i < t.length; i++) {
            var r = t[i],
              c = e.base ? r[0] + e.base : r[0],
              l = n[c] || 0,
              d = "".concat(c, " ").concat(l);
            n[c] = l + 1;
            var u = a(d),
              h = {
                css: r[1],
                media: r[2],
                sourceMap: r[3]
              };
            -1 !== u ? (s[u].references++, s[u].updater(h)) : s.push({
              identifier: d,
              updater: f(h, e),
              references: 1
            }), o.push(d);
          }
          return o;
        }
        function l(t) {
          var e = document.createElement("style"),
            o = t.attributes || {};
          if (void 0 === o.nonce) {
            var i = n.nc;
            i && (o.nonce = i);
          }
          if (Object.keys(o).forEach(function (t) {
            e.setAttribute(t, o[t]);
          }), "function" == typeof t.insert) t.insert(e);else {
            var s = r(t.insert || "head");
            if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            s.appendChild(e);
          }
          return e;
        }
        var d,
          u = (d = [], function (t, e) {
            return d[t] = e, d.filter(Boolean).join("\n");
          });
        function h(t, e, n, o) {
          var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
          if (t.styleSheet) t.styleSheet.cssText = u(e, i);else {
            var r = document.createTextNode(i),
              s = t.childNodes;
            s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
          }
        }
        function g(t, e, n) {
          var o = n.css,
            i = n.media,
            r = n.sourceMap;
          if (i ? t.setAttribute("media", i) : t.removeAttribute("media"), r && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), t.styleSheet) t.styleSheet.cssText = o;else {
            for (; t.firstChild;) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(o));
          }
        }
        var m = null,
          p = 0;
        function f(t, e) {
          var n, o, i;
          if (e.singleton) {
            var r = p++;
            n = m || (m = l(e)), o = h.bind(null, n, r, !1), i = h.bind(null, n, r, !0);
          } else n = l(e), o = g.bind(null, n, e), i = function () {
            !function (t) {
              if (null === t.parentNode) return !1;
              t.parentNode.removeChild(t);
            }(n);
          };
          return o(t), function (e) {
            if (e) {
              if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
              o(t = e);
            } else i();
          };
        }
        t.exports = function (t, e) {
          (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = i());
          var n = c(t = t || [], e);
          return function (t) {
            if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
              for (var o = 0; o < n.length; o++) {
                var i = a(n[o]);
                s[i].references--;
              }
              for (var r = c(t, e), l = 0; l < n.length; l++) {
                var d = a(n[l]);
                0 === s[d].references && (s[d].updater(), s.splice(d, 1));
              }
              n = r;
            }
          };
        };
      }
    },
    e = {};
  function n(o) {
    var i = e[o];
    if (void 0 !== i) return i.exports;
    var r = e[o] = {
      id: o,
      exports: {}
    };
    return t[o](r, r.exports, n), r.exports;
  }
  n.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return n.d(e, {
      a: e
    }), e;
  }, n.d = (t, e) => {
    for (var o in e) n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
      enumerable: !0,
      get: e[o]
    });
  }, n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), n.nc = void 0;
  var o = {};
  return (() => {
    "use strict";

    let t;
    n.d(o, {
      default: () => FM
    });
    try {
      t = {
        window,
        document
      };
    } catch (e) {
      t = {
        window: {},
        document: {}
      };
    }
    const e = t;
    const i = function () {
      try {
        return navigator.userAgent.toLowerCase();
      } catch (t) {
        return "";
      }
    }();
    var r;
    const s = {
      isMac: a(i),
      isWindows: (r = i, r.indexOf("windows") > -1),
      isGecko: function (t) {
        return !!t.match(/gecko\/\d+/);
      }(i),
      isSafari: function (t) {
        return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
      }(i),
      isiOS: function (t) {
        return !!t.match(/iphone|ipad/i) || a(t) && navigator.maxTouchPoints > 0;
      }(i),
      isAndroid: function (t) {
        return t.indexOf("android") > -1;
      }(i),
      isBlink: function (t) {
        return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
      }(i),
      get isMediaForcedColors() {
        return !!e.window.matchMedia && e.window.matchMedia("(forced-colors: active)").matches;
      },
      get isMotionReduced() {
        return !!e.window.matchMedia && e.window.matchMedia("(prefers-reduced-motion)").matches;
      },
      features: {
        isRegExpUnicodePropertySupported: function () {
          let t = !1;
          try {
            t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
          } catch (t) {}
          return t;
        }()
      }
    };
    function a(t) {
      return t.indexOf("macintosh") > -1;
    }
    function c(t, e, n, o) {
      n = n || function (t, e) {
        return t === e;
      };
      const i = Array.isArray(t) ? t : Array.prototype.slice.call(t),
        r = Array.isArray(e) ? e : Array.prototype.slice.call(e),
        s = function (t, e, n) {
          const o = l(t, e, n);
          if (-1 === o) return {
            firstIndex: -1,
            lastIndexOld: -1,
            lastIndexNew: -1
          };
          const i = d(t, o),
            r = d(e, o),
            s = l(i, r, n),
            a = t.length - s,
            c = e.length - s;
          return {
            firstIndex: o,
            lastIndexOld: a,
            lastIndexNew: c
          };
        }(i, r, n),
        a = o ? function (t, e) {
          const {
            firstIndex: n,
            lastIndexOld: o,
            lastIndexNew: i
          } = t;
          if (-1 === n) return Array(e).fill("equal");
          let r = [];
          n > 0 && (r = r.concat(Array(n).fill("equal")));
          i - n > 0 && (r = r.concat(Array(i - n).fill("insert")));
          o - n > 0 && (r = r.concat(Array(o - n).fill("delete")));
          i < e && (r = r.concat(Array(e - i).fill("equal")));
          return r;
        }(s, r.length) : function (t, e) {
          const n = [],
            {
              firstIndex: o,
              lastIndexOld: i,
              lastIndexNew: r
            } = e;
          r - o > 0 && n.push({
            index: o,
            type: "insert",
            values: t.slice(o, r)
          });
          i - o > 0 && n.push({
            index: o + (r - o),
            type: "delete",
            howMany: i - o
          });
          return n;
        }(r, s);
      return a;
    }
    function l(t, e, n) {
      for (let o = 0; o < Math.max(t.length, e.length); o++) if (void 0 === t[o] || void 0 === e[o] || !n(t[o], e[o])) return o;
      return -1;
    }
    function d(t, e) {
      return t.slice(e).reverse();
    }
    function u(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };
      const o = t.length,
        i = e.length;
      if (o > 200 || i > 200 || o + i > 300) return u.fastDiff(t, e, n, !0);
      let r, s;
      if (i < o) {
        const n = t;
        t = e, e = n, r = "delete", s = "insert";
      } else r = "insert", s = "delete";
      const a = t.length,
        c = e.length,
        l = c - a,
        d = {},
        h = {};
      function g(o) {
        const i = (void 0 !== h[o - 1] ? h[o - 1] : -1) + 1,
          l = void 0 !== h[o + 1] ? h[o + 1] : -1,
          u = i > l ? -1 : 1;
        d[o + u] && (d[o] = d[o + u].slice(0)), d[o] || (d[o] = []), d[o].push(i > l ? r : s);
        let g = Math.max(i, l),
          m = g - o;
        for (; m < a && g < c && n(t[m], e[g]);) m++, g++, d[o].push("equal");
        return g;
      }
      let m,
        p = 0;
      do {
        for (m = -p; m < l; m++) h[m] = g(m);
        for (m = l + p; m > l; m--) h[m] = g(m);
        h[l] = g(l), p++;
      } while (h[l] !== c);
      return d[l].slice(1);
    }
    u.fastDiff = c;
    const h = function () {
      return function t() {
        t.called = !0;
      };
    };
    class g {
      constructor(t, e) {
        this.source = t, this.name = e, this.path = [], this.stop = h(), this.off = h();
      }
    }
    const m = new Array(256).fill("").map((t, e) => ("0" + e.toString(16)).slice(-2));
    function p() {
      const t = 4294967296 * Math.random() >>> 0,
        e = 4294967296 * Math.random() >>> 0,
        n = 4294967296 * Math.random() >>> 0,
        o = 4294967296 * Math.random() >>> 0;
      return "e" + m[255 & t] + m[t >> 8 & 255] + m[t >> 16 & 255] + m[t >> 24 & 255] + m[255 & e] + m[e >> 8 & 255] + m[e >> 16 & 255] + m[e >> 24 & 255] + m[255 & n] + m[n >> 8 & 255] + m[n >> 16 & 255] + m[n >> 24 & 255] + m[255 & o] + m[o >> 8 & 255] + m[o >> 16 & 255] + m[o >> 24 & 255];
    }
    const f = {
      get(t = "normal") {
        return "number" != typeof t ? this[t] || this.normal : t;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    function k(t, e) {
      const n = f.get(e.priority);
      for (let o = 0; o < t.length; o++) if (f.get(t[o].priority) < n) return void t.splice(o, 0, e);
      t.push(e);
    }
    const b = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
    class w extends Error {
      constructor(t, e, n) {
        super(function (t, e) {
          const n = new WeakSet(),
            o = (t, e) => {
              if ("object" == typeof e && null !== e) {
                if (n.has(e)) return `[object ${e.constructor.name}]`;
                n.add(e);
              }
              return e;
            },
            i = e ? ` ${JSON.stringify(e, o)}` : "",
            r = C(t);
          return t + i + r;
        }(t, n)), this.name = "CKEditorError", this.context = e, this.data = n;
      }
      is(t) {
        return "CKEditorError" === t;
      }
      static rethrowUnexpectedError(t, e) {
        if (t.is && t.is("CKEditorError")) throw t;
        const n = new w(t.message, e);
        throw n.stack = t.stack, n;
      }
    }
    function A(t, e) {
      console.warn(...v(t, e));
    }
    function _(t, e) {
      console.error(...v(t, e));
    }
    function C(t) {
      return `\nRead more: ${b}#error-${t}`;
    }
    function v(t, e) {
      const n = C(t);
      return e ? [t, e, n] : [t, n];
    }
    const y = "41.4.2",
      x = new Date(2024, 4, 17);
    if (globalThis.CKEDITOR_VERSION) throw new w("ckeditor-duplicated-modules", null);
    globalThis.CKEDITOR_VERSION = y;
    const E = Symbol("listeningTo"),
      D = Symbol("emitterId"),
      I = Symbol("delegations"),
      T = M(Object);
    function M(t) {
      if (!t) return T;
      return class extends t {
        on(t, e, n) {
          this.listenTo(this, t, e, n);
        }
        once(t, e, n) {
          let o = !1;
          this.listenTo(this, t, (t, ...n) => {
            o || (o = !0, t.off(), e.call(this, t, ...n));
          }, n);
        }
        off(t, e) {
          this.stopListening(this, t, e);
        }
        listenTo(t, e, n, o = {}) {
          let i, r;
          this[E] || (this[E] = {});
          const s = this[E];
          B(t) || S(t);
          const a = B(t);
          (i = s[a]) || (i = s[a] = {
            emitter: t,
            callbacks: {}
          }), (r = i.callbacks[e]) || (r = i.callbacks[e] = []), r.push(n), function (t, e, n, o, i) {
            e._addEventListener ? e._addEventListener(n, o, i) : t._addEventListener.call(e, n, o, i);
          }(this, t, e, n, o);
        }
        stopListening(t, e, n) {
          const o = this[E];
          let i = t && B(t);
          const r = o && i ? o[i] : void 0,
            s = r && e ? r.callbacks[e] : void 0;
          if (!(!o || t && !r || e && !s)) if (n) {
            z(this, t, e, n);
            -1 !== s.indexOf(n) && (1 === s.length ? delete r.callbacks[e] : z(this, t, e, n));
          } else if (s) {
            for (; n = s.pop();) z(this, t, e, n);
            delete r.callbacks[e];
          } else if (r) {
            for (e in r.callbacks) this.stopListening(t, e);
            delete o[i];
          } else {
            for (i in o) this.stopListening(o[i].emitter);
            delete this[E];
          }
        }
        fire(t, ...e) {
          try {
            const n = t instanceof g ? t : new g(this, t),
              o = n.name;
            let i = O(this, o);
            if (n.path.push(this), i) {
              const t = [n, ...e];
              i = Array.from(i);
              for (let e = 0; e < i.length && (i[e].callback.apply(this, t), n.off.called && (delete n.off.called, this._removeEventListener(o, i[e].callback)), !n.stop.called); e++);
            }
            const r = this[I];
            if (r) {
              const t = r.get(o),
                i = r.get("*");
              t && L(t, n, e), i && L(i, n, e);
            }
            return n.return;
          } catch (t) {
            w.rethrowUnexpectedError(t, this);
          }
        }
        delegate(...t) {
          return {
            to: (e, n) => {
              this[I] || (this[I] = new Map()), t.forEach(t => {
                const o = this[I].get(t);
                o ? o.set(e, n) : this[I].set(t, new Map([[e, n]]));
              });
            }
          };
        }
        stopDelegating(t, e) {
          if (this[I]) if (t) {
            if (e) {
              const n = this[I].get(t);
              n && n.delete(e);
            } else this[I].delete(t);
          } else this[I].clear();
        }
        _addEventListener(t, e, n) {
          !function (t, e) {
            const n = N(t);
            if (n[e]) return;
            let o = e,
              i = null;
            const r = [];
            for (; "" !== o && !n[o];) n[o] = {
              callbacks: [],
              childEvents: []
            }, r.push(n[o]), i && n[o].childEvents.push(i), i = o, o = o.substr(0, o.lastIndexOf(":"));
            if ("" !== o) {
              for (const t of r) t.callbacks = n[o].callbacks.slice();
              n[o].childEvents.push(i);
            }
          }(this, t);
          const o = P(this, t),
            i = {
              callback: e,
              priority: f.get(n.priority)
            };
          for (const t of o) k(t, i);
        }
        _removeEventListener(t, e) {
          const n = P(this, t);
          for (const t of n) for (let n = 0; n < t.length; n++) t[n].callback == e && (t.splice(n, 1), n--);
        }
      };
    }
    function S(t, e) {
      t[D] || (t[D] = e || p());
    }
    function B(t) {
      return t[D];
    }
    function N(t) {
      return t._events || Object.defineProperty(t, "_events", {
        value: {}
      }), t._events;
    }
    function P(t, e) {
      const n = N(t)[e];
      if (!n) return [];
      let o = [n.callbacks];
      for (let e = 0; e < n.childEvents.length; e++) {
        const i = P(t, n.childEvents[e]);
        o = o.concat(i);
      }
      return o;
    }
    function O(t, e) {
      let n;
      return t._events && (n = t._events[e]) && n.callbacks.length ? n.callbacks : e.indexOf(":") > -1 ? O(t, e.substr(0, e.lastIndexOf(":"))) : null;
    }
    function L(t, e, n) {
      for (let [o, i] of t) {
        i ? "function" == typeof i && (i = i(e.name)) : i = e.name;
        const t = new g(e.source, i);
        t.path = [...e.path], o.fire(t, ...n);
      }
    }
    function z(t, e, n, o) {
      e._removeEventListener ? e._removeEventListener(n, o) : t._removeEventListener.call(e, n, o);
    }
    ["on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(t => {
      M[t] = T.prototype[t];
    });
    const R = function (t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      },
      j = Symbol("observableProperties"),
      F = Symbol("boundObservables"),
      V = Symbol("boundProperties"),
      H = Symbol("decoratedMethods"),
      U = Symbol("decoratedOriginal"),
      q = G(M());
    function G(t) {
      if (!t) return q;
      return class extends t {
        set(t, e) {
          if (R(t)) return void Object.keys(t).forEach(e => {
            this.set(e, t[e]);
          }, this);
          W(this);
          const n = this[j];
          if (t in this && !n.has(t)) throw new w("observable-set-cannot-override", this);
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            get: () => n.get(t),
            set(e) {
              const o = n.get(t);
              let i = this.fire(`set:${t}`, t, e, o);
              void 0 === i && (i = e), o === i && n.has(t) || (n.set(t, i), this.fire(`change:${t}`, t, i, o));
            }
          }), this[t] = e;
        }
        bind(...t) {
          if (!t.length || !Y(t)) throw new w("observable-bind-wrong-properties", this);
          if (new Set(t).size !== t.length) throw new w("observable-bind-duplicate-properties", this);
          W(this);
          const e = this[V];
          t.forEach(t => {
            if (e.has(t)) throw new w("observable-bind-rebind", this);
          });
          const n = new Map();
          return t.forEach(t => {
            const o = {
              property: t,
              to: []
            };
            e.set(t, o), n.set(t, o);
          }), {
            to: K,
            toMany: $,
            _observable: this,
            _bindProperties: t,
            _to: [],
            _bindings: n
          };
        }
        unbind(...t) {
          if (!this[j]) return;
          const e = this[V],
            n = this[F];
          if (t.length) {
            if (!Y(t)) throw new w("observable-unbind-wrong-properties", this);
            t.forEach(t => {
              const o = e.get(t);
              o && (o.to.forEach(([t, e]) => {
                const i = n.get(t),
                  r = i[e];
                r.delete(o), r.size || delete i[e], Object.keys(i).length || (n.delete(t), this.stopListening(t, "change"));
              }), e.delete(t));
            });
          } else n.forEach((t, e) => {
            this.stopListening(e, "change");
          }), n.clear(), e.clear();
        }
        decorate(t) {
          W(this);
          const e = this[t];
          if (!e) throw new w("observablemixin-cannot-decorate-undefined", this, {
            object: this,
            methodName: t
          });
          this.on(t, (t, n) => {
            t.return = e.apply(this, n);
          }), this[t] = function (...e) {
            return this.fire(t, e);
          }, this[t][U] = e, this[H] || (this[H] = []), this[H].push(t);
        }
        stopListening(t, e, n) {
          if (!t && this[H]) {
            for (const t of this[H]) this[t] = this[t][U];
            delete this[H];
          }
          super.stopListening(t, e, n);
        }
      };
    }
    function W(t) {
      t[j] || (Object.defineProperty(t, j, {
        value: new Map()
      }), Object.defineProperty(t, F, {
        value: new Map()
      }), Object.defineProperty(t, V, {
        value: new Map()
      }));
    }
    function K(...t) {
      const e = function (...t) {
          if (!t.length) throw new w("observable-bind-to-parse-error", null);
          const e = {
            to: []
          };
          let n;
          "function" == typeof t[t.length - 1] && (e.callback = t.pop());
          return t.forEach(t => {
            if ("string" == typeof t) n.properties.push(t);else {
              if ("object" != typeof t) throw new w("observable-bind-to-parse-error", null);
              n = {
                observable: t,
                properties: []
              }, e.to.push(n);
            }
          }), e;
        }(...t),
        n = Array.from(this._bindings.keys()),
        o = n.length;
      if (!e.callback && e.to.length > 1) throw new w("observable-bind-to-no-callback", this);
      if (o > 1 && e.callback) throw new w("observable-bind-to-extra-callback", this);
      var i;
      e.to.forEach(t => {
        if (t.properties.length && t.properties.length !== o) throw new w("observable-bind-to-properties-length", this);
        t.properties.length || (t.properties = this._bindProperties);
      }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), i = this._observable, this._to.forEach(t => {
        const e = i[F];
        let n;
        e.get(t.observable) || i.listenTo(t.observable, "change", (o, r) => {
          n = e.get(t.observable)[r], n && n.forEach(t => {
            Q(i, t.property);
          });
        });
      }), function (t) {
        let e;
        t._bindings.forEach((n, o) => {
          t._to.forEach(i => {
            e = i.properties[n.callback ? 0 : t._bindProperties.indexOf(o)], n.to.push([i.observable, e]), function (t, e, n, o) {
              const i = t[F],
                r = i.get(n),
                s = r || {};
              s[o] || (s[o] = new Set());
              s[o].add(e), r || i.set(n, s);
            }(t._observable, n, i.observable, e);
          });
        });
      }(this), this._bindProperties.forEach(t => {
        Q(this._observable, t);
      });
    }
    function $(t, e, n) {
      if (this._bindings.size > 1) throw new w("observable-bind-to-many-not-one-binding", this);
      this.to(...function (t, e) {
        const n = t.map(t => [t, e]);
        return Array.prototype.concat.apply([], n);
      }(t, e), n);
    }
    function Y(t) {
      return t.every(t => "string" == typeof t);
    }
    function Q(t, e) {
      const n = t[V].get(e);
      let o;
      n.callback ? o = n.callback.apply(t, n.to.map(t => t[0][t[1]])) : (o = n.to[0], o = o[0][o[1]]), Object.prototype.hasOwnProperty.call(t, e) ? t[e] = o : t.set(e, o);
    }
    ["set", "bind", "unbind", "decorate", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(t => {
      G[t] = q.prototype[t];
    });
    class Z {
      constructor() {
        this._replacedElements = [];
      }
      replace(t, e) {
        this._replacedElements.push({
          element: t,
          newElement: e
        }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
      }
      restore() {
        this._replacedElements.forEach(({
          element: t,
          newElement: e
        }) => {
          t.style.display = "", e && e.remove();
        }), this._replacedElements = [];
      }
    }
    function J(t) {
      let e = 0;
      for (const n of t) e++;
      return e;
    }
    function X(t, e) {
      const n = Math.min(t.length, e.length);
      for (let o = 0; o < n; o++) if (t[o] != e[o]) return o;
      return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
    }
    function tt(t) {
      return !(!t || !t[Symbol.iterator]);
    }
    const et = "object" == typeof global && global && global.Object === Object && global;
    var nt = "object" == typeof self && self && self.Object === Object && self;
    const ot = et || nt || Function("return this")();
    const it = ot.Symbol;
    var rt = Object.prototype,
      st = rt.hasOwnProperty,
      at = rt.toString,
      ct = it ? it.toStringTag : void 0;
    const lt = function (t) {
      var e = st.call(t, ct),
        n = t[ct];
      try {
        t[ct] = void 0;
        var o = !0;
      } catch (t) {}
      var i = at.call(t);
      return o && (e ? t[ct] = n : delete t[ct]), i;
    };
    var dt = Object.prototype.toString;
    const ut = function (t) {
      return dt.call(t);
    };
    var ht = it ? it.toStringTag : void 0;
    const gt = function (t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : ht && ht in Object(t) ? lt(t) : ut(t);
    };
    const mt = Array.isArray;
    const pt = function (t) {
      return null != t && "object" == typeof t;
    };
    const ft = function (t) {
      return "string" == typeof t || !mt(t) && pt(t) && "[object String]" == gt(t);
    };
    function kt(t, e, n = {}, o = []) {
      const i = n && n.xmlns,
        r = i ? t.createElementNS(i, e) : t.createElement(e);
      for (const t in n) r.setAttribute(t, n[t]);
      !ft(o) && tt(o) || (o = [o]);
      for (let e of o) ft(e) && (e = t.createTextNode(e)), r.appendChild(e);
      return r;
    }
    const bt = function (t, e) {
      return function (n) {
        return t(e(n));
      };
    };
    const wt = bt(Object.getPrototypeOf, Object);
    var At = Function.prototype,
      _t = Object.prototype,
      Ct = At.toString,
      vt = _t.hasOwnProperty,
      yt = Ct.call(Object);
    const xt = function (t) {
      if (!pt(t) || "[object Object]" != gt(t)) return !1;
      var e = wt(t);
      if (null === e) return !0;
      var n = vt.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && Ct.call(n) == yt;
    };
    const Et = function () {
      this.__data__ = [], this.size = 0;
    };
    const Dt = function (t, e) {
      return t === e || t != t && e != e;
    };
    const It = function (t, e) {
      for (var n = t.length; n--;) if (Dt(t[n][0], e)) return n;
      return -1;
    };
    var Tt = Array.prototype.splice;
    const Mt = function (t) {
      var e = this.__data__,
        n = It(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : Tt.call(e, n, 1), --this.size, !0);
    };
    const St = function (t) {
      var e = this.__data__,
        n = It(e, t);
      return n < 0 ? void 0 : e[n][1];
    };
    const Bt = function (t) {
      return It(this.__data__, t) > -1;
    };
    const Nt = function (t, e) {
      var n = this.__data__,
        o = It(n, t);
      return o < 0 ? (++this.size, n.push([t, e])) : n[o][1] = e, this;
    };
    function Pt(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    Pt.prototype.clear = Et, Pt.prototype.delete = Mt, Pt.prototype.get = St, Pt.prototype.has = Bt, Pt.prototype.set = Nt;
    const Ot = Pt;
    const Lt = function () {
      this.__data__ = new Ot(), this.size = 0;
    };
    const zt = function (t) {
      var e = this.__data__,
        n = e.delete(t);
      return this.size = e.size, n;
    };
    const Rt = function (t) {
      return this.__data__.get(t);
    };
    const jt = function (t) {
      return this.__data__.has(t);
    };
    const Ft = function (t) {
      if (!R(t)) return !1;
      var e = gt(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    };
    const Vt = ot["__core-js_shared__"];
    var Ht = function () {
      var t = /[^.]+$/.exec(Vt && Vt.keys && Vt.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();
    const Ut = function (t) {
      return !!Ht && Ht in t;
    };
    var qt = Function.prototype.toString;
    const Gt = function (t) {
      if (null != t) {
        try {
          return qt.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    };
    var Wt = /^\[object .+?Constructor\]$/,
      Kt = Function.prototype,
      $t = Object.prototype,
      Yt = Kt.toString,
      Qt = $t.hasOwnProperty,
      Zt = RegExp("^" + Yt.call(Qt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    const Jt = function (t) {
      return !(!R(t) || Ut(t)) && (Ft(t) ? Zt : Wt).test(Gt(t));
    };
    const Xt = function (t, e) {
      return null == t ? void 0 : t[e];
    };
    const te = function (t, e) {
      var n = Xt(t, e);
      return Jt(n) ? n : void 0;
    };
    const ee = te(ot, "Map");
    const ne = te(Object, "create");
    const oe = function () {
      this.__data__ = ne ? ne(null) : {}, this.size = 0;
    };
    const ie = function (t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    };
    var re = Object.prototype.hasOwnProperty;
    const se = function (t) {
      var e = this.__data__;
      if (ne) {
        var n = e[t];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }
      return re.call(e, t) ? e[t] : void 0;
    };
    var ae = Object.prototype.hasOwnProperty;
    const ce = function (t) {
      var e = this.__data__;
      return ne ? void 0 !== e[t] : ae.call(e, t);
    };
    const le = function (t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = ne && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
    function de(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    de.prototype.clear = oe, de.prototype.delete = ie, de.prototype.get = se, de.prototype.has = ce, de.prototype.set = le;
    const ue = de;
    const he = function () {
      this.size = 0, this.__data__ = {
        hash: new ue(),
        map: new (ee || Ot)(),
        string: new ue()
      };
    };
    const ge = function (t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
    const me = function (t, e) {
      var n = t.__data__;
      return ge(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };
    const pe = function (t) {
      var e = me(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };
    const fe = function (t) {
      return me(this, t).get(t);
    };
    const ke = function (t) {
      return me(this, t).has(t);
    };
    const be = function (t, e) {
      var n = me(this, t),
        o = n.size;
      return n.set(t, e), this.size += n.size == o ? 0 : 1, this;
    };
    function we(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    we.prototype.clear = he, we.prototype.delete = pe, we.prototype.get = fe, we.prototype.has = ke, we.prototype.set = be;
    const Ae = we;
    const _e = function (t, e) {
      var n = this.__data__;
      if (n instanceof Ot) {
        var o = n.__data__;
        if (!ee || o.length < 199) return o.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new Ae(o);
      }
      return n.set(t, e), this.size = n.size, this;
    };
    function Ce(t) {
      var e = this.__data__ = new Ot(t);
      this.size = e.size;
    }
    Ce.prototype.clear = Lt, Ce.prototype.delete = zt, Ce.prototype.get = Rt, Ce.prototype.has = jt, Ce.prototype.set = _e;
    const ve = Ce;
    const ye = function (t, e) {
      for (var n = -1, o = null == t ? 0 : t.length; ++n < o && !1 !== e(t[n], n, t););
      return t;
    };
    const xe = function () {
      try {
        var t = te(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();
    const Ee = function (t, e, n) {
      "__proto__" == e && xe ? xe(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    };
    var De = Object.prototype.hasOwnProperty;
    const Ie = function (t, e, n) {
      var o = t[e];
      De.call(t, e) && Dt(o, n) && (void 0 !== n || e in t) || Ee(t, e, n);
    };
    const Te = function (t, e, n, o) {
      var i = !n;
      n || (n = {});
      for (var r = -1, s = e.length; ++r < s;) {
        var a = e[r],
          c = o ? o(n[a], t[a], a, n, t) : void 0;
        void 0 === c && (c = t[a]), i ? Ee(n, a, c) : Ie(n, a, c);
      }
      return n;
    };
    const Me = function (t, e) {
      for (var n = -1, o = Array(t); ++n < t;) o[n] = e(n);
      return o;
    };
    const Se = function (t) {
      return pt(t) && "[object Arguments]" == gt(t);
    };
    var Be = Object.prototype,
      Ne = Be.hasOwnProperty,
      Pe = Be.propertyIsEnumerable;
    const Oe = Se(function () {
      return arguments;
    }()) ? Se : function (t) {
      return pt(t) && Ne.call(t, "callee") && !Pe.call(t, "callee");
    };
    const Le = function () {
      return !1;
    };
    var ze = "object" == typeof exports && exports && !exports.nodeType && exports,
      Re = ze && "object" == typeof module && module && !module.nodeType && module,
      je = Re && Re.exports === ze ? ot.Buffer : void 0;
    const Fe = (je ? je.isBuffer : void 0) || Le;
    var Ve = /^(?:0|[1-9]\d*)$/;
    const He = function (t, e) {
      var n = typeof t;
      return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && Ve.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
    const Ue = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    };
    var qe = {};
    qe["[object Float32Array]"] = qe["[object Float64Array]"] = qe["[object Int8Array]"] = qe["[object Int16Array]"] = qe["[object Int32Array]"] = qe["[object Uint8Array]"] = qe["[object Uint8ClampedArray]"] = qe["[object Uint16Array]"] = qe["[object Uint32Array]"] = !0, qe["[object Arguments]"] = qe["[object Array]"] = qe["[object ArrayBuffer]"] = qe["[object Boolean]"] = qe["[object DataView]"] = qe["[object Date]"] = qe["[object Error]"] = qe["[object Function]"] = qe["[object Map]"] = qe["[object Number]"] = qe["[object Object]"] = qe["[object RegExp]"] = qe["[object Set]"] = qe["[object String]"] = qe["[object WeakMap]"] = !1;
    const Ge = function (t) {
      return pt(t) && Ue(t.length) && !!qe[gt(t)];
    };
    const We = function (t) {
      return function (e) {
        return t(e);
      };
    };
    var Ke = "object" == typeof exports && exports && !exports.nodeType && exports,
      $e = Ke && "object" == typeof module && module && !module.nodeType && module,
      Ye = $e && $e.exports === Ke && et.process;
    const Qe = function () {
      try {
        var t = $e && $e.require && $e.require("util").types;
        return t || Ye && Ye.binding && Ye.binding("util");
      } catch (t) {}
    }();
    var Ze = Qe && Qe.isTypedArray;
    const Je = Ze ? We(Ze) : Ge;
    var Xe = Object.prototype.hasOwnProperty;
    const tn = function (t, e) {
      var n = mt(t),
        o = !n && Oe(t),
        i = !n && !o && Fe(t),
        r = !n && !o && !i && Je(t),
        s = n || o || i || r,
        a = s ? Me(t.length, String) : [],
        c = a.length;
      for (var l in t) !e && !Xe.call(t, l) || s && ("length" == l || i && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || He(l, c)) || a.push(l);
      return a;
    };
    var en = Object.prototype;
    const nn = function (t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || en);
    };
    const on = bt(Object.keys, Object);
    var rn = Object.prototype.hasOwnProperty;
    const sn = function (t) {
      if (!nn(t)) return on(t);
      var e = [];
      for (var n in Object(t)) rn.call(t, n) && "constructor" != n && e.push(n);
      return e;
    };
    const an = function (t) {
      return null != t && Ue(t.length) && !Ft(t);
    };
    const cn = function (t) {
      return an(t) ? tn(t) : sn(t);
    };
    const ln = function (t, e) {
      return t && Te(e, cn(e), t);
    };
    const dn = function (t) {
      var e = [];
      if (null != t) for (var n in Object(t)) e.push(n);
      return e;
    };
    var un = Object.prototype.hasOwnProperty;
    const hn = function (t) {
      if (!R(t)) return dn(t);
      var e = nn(t),
        n = [];
      for (var o in t) ("constructor" != o || !e && un.call(t, o)) && n.push(o);
      return n;
    };
    const gn = function (t) {
      return an(t) ? tn(t, !0) : hn(t);
    };
    const mn = function (t, e) {
      return t && Te(e, gn(e), t);
    };
    var pn = "object" == typeof exports && exports && !exports.nodeType && exports,
      fn = pn && "object" == typeof module && module && !module.nodeType && module,
      kn = fn && fn.exports === pn ? ot.Buffer : void 0,
      bn = kn ? kn.allocUnsafe : void 0;
    const wn = function (t, e) {
      if (e) return t.slice();
      var n = t.length,
        o = bn ? bn(n) : new t.constructor(n);
      return t.copy(o), o;
    };
    const An = function (t, e) {
      var n = -1,
        o = t.length;
      for (e || (e = Array(o)); ++n < o;) e[n] = t[n];
      return e;
    };
    const _n = function (t, e) {
      for (var n = -1, o = null == t ? 0 : t.length, i = 0, r = []; ++n < o;) {
        var s = t[n];
        e(s, n, t) && (r[i++] = s);
      }
      return r;
    };
    const Cn = function () {
      return [];
    };
    var vn = Object.prototype.propertyIsEnumerable,
      yn = Object.getOwnPropertySymbols;
    const xn = yn ? function (t) {
      return null == t ? [] : (t = Object(t), _n(yn(t), function (e) {
        return vn.call(t, e);
      }));
    } : Cn;
    const En = function (t, e) {
      return Te(t, xn(t), e);
    };
    const Dn = function (t, e) {
      for (var n = -1, o = e.length, i = t.length; ++n < o;) t[i + n] = e[n];
      return t;
    };
    const In = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) Dn(e, xn(t)), t = wt(t);
      return e;
    } : Cn;
    const Tn = function (t, e) {
      return Te(t, In(t), e);
    };
    const Mn = function (t, e, n) {
      var o = e(t);
      return mt(t) ? o : Dn(o, n(t));
    };
    const Sn = function (t) {
      return Mn(t, cn, xn);
    };
    const Bn = function (t) {
      return Mn(t, gn, In);
    };
    const Nn = te(ot, "DataView");
    const Pn = te(ot, "Promise");
    const On = te(ot, "Set");
    const Ln = te(ot, "WeakMap");
    var zn = "[object Map]",
      Rn = "[object Promise]",
      jn = "[object Set]",
      Fn = "[object WeakMap]",
      Vn = "[object DataView]",
      Hn = Gt(Nn),
      Un = Gt(ee),
      qn = Gt(Pn),
      Gn = Gt(On),
      Wn = Gt(Ln),
      Kn = gt;
    (Nn && Kn(new Nn(new ArrayBuffer(1))) != Vn || ee && Kn(new ee()) != zn || Pn && Kn(Pn.resolve()) != Rn || On && Kn(new On()) != jn || Ln && Kn(new Ln()) != Fn) && (Kn = function (t) {
      var e = gt(t),
        n = "[object Object]" == e ? t.constructor : void 0,
        o = n ? Gt(n) : "";
      if (o) switch (o) {
        case Hn:
          return Vn;
        case Un:
          return zn;
        case qn:
          return Rn;
        case Gn:
          return jn;
        case Wn:
          return Fn;
      }
      return e;
    });
    const $n = Kn;
    var Yn = Object.prototype.hasOwnProperty;
    const Qn = function (t) {
      var e = t.length,
        n = new t.constructor(e);
      return e && "string" == typeof t[0] && Yn.call(t, "index") && (n.index = t.index, n.input = t.input), n;
    };
    const Zn = ot.Uint8Array;
    const Jn = function (t) {
      var e = new t.constructor(t.byteLength);
      return new Zn(e).set(new Zn(t)), e;
    };
    const Xn = function (t, e) {
      var n = e ? Jn(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    };
    var to = /\w*$/;
    const eo = function (t) {
      var e = new t.constructor(t.source, to.exec(t));
      return e.lastIndex = t.lastIndex, e;
    };
    var no = it ? it.prototype : void 0,
      oo = no ? no.valueOf : void 0;
    const io = function (t) {
      return oo ? Object(oo.call(t)) : {};
    };
    const ro = function (t, e) {
      var n = e ? Jn(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    };
    const so = function (t, e, n) {
      var o = t.constructor;
      switch (e) {
        case "[object ArrayBuffer]":
          return Jn(t);
        case "[object Boolean]":
        case "[object Date]":
          return new o(+t);
        case "[object DataView]":
          return Xn(t, n);
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return ro(t, n);
        case "[object Map]":
        case "[object Set]":
          return new o();
        case "[object Number]":
        case "[object String]":
          return new o(t);
        case "[object RegExp]":
          return eo(t);
        case "[object Symbol]":
          return io(t);
      }
    };
    var ao = Object.create;
    const co = function () {
      function t() {}
      return function (e) {
        if (!R(e)) return {};
        if (ao) return ao(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();
    const lo = function (t) {
      return "function" != typeof t.constructor || nn(t) ? {} : co(wt(t));
    };
    const uo = function (t) {
      return pt(t) && "[object Map]" == $n(t);
    };
    var ho = Qe && Qe.isMap;
    const go = ho ? We(ho) : uo;
    const mo = function (t) {
      return pt(t) && "[object Set]" == $n(t);
    };
    var po = Qe && Qe.isSet;
    const fo = po ? We(po) : mo;
    var ko = "[object Arguments]",
      bo = "[object Function]",
      wo = "[object Object]",
      Ao = {};
    Ao[ko] = Ao["[object Array]"] = Ao["[object ArrayBuffer]"] = Ao["[object DataView]"] = Ao["[object Boolean]"] = Ao["[object Date]"] = Ao["[object Float32Array]"] = Ao["[object Float64Array]"] = Ao["[object Int8Array]"] = Ao["[object Int16Array]"] = Ao["[object Int32Array]"] = Ao["[object Map]"] = Ao["[object Number]"] = Ao[wo] = Ao["[object RegExp]"] = Ao["[object Set]"] = Ao["[object String]"] = Ao["[object Symbol]"] = Ao["[object Uint8Array]"] = Ao["[object Uint8ClampedArray]"] = Ao["[object Uint16Array]"] = Ao["[object Uint32Array]"] = !0, Ao["[object Error]"] = Ao[bo] = Ao["[object WeakMap]"] = !1;
    const _o = function t(e, n, o, i, r, s) {
      var a,
        c = 1 & n,
        l = 2 & n,
        d = 4 & n;
      if (o && (a = r ? o(e, i, r, s) : o(e)), void 0 !== a) return a;
      if (!R(e)) return e;
      var u = mt(e);
      if (u) {
        if (a = Qn(e), !c) return An(e, a);
      } else {
        var h = $n(e),
          g = h == bo || "[object GeneratorFunction]" == h;
        if (Fe(e)) return wn(e, c);
        if (h == wo || h == ko || g && !r) {
          if (a = l || g ? {} : lo(e), !c) return l ? Tn(e, mn(a, e)) : En(e, ln(a, e));
        } else {
          if (!Ao[h]) return r ? e : {};
          a = so(e, h, c);
        }
      }
      s || (s = new ve());
      var m = s.get(e);
      if (m) return m;
      s.set(e, a), fo(e) ? e.forEach(function (i) {
        a.add(t(i, n, o, i, e, s));
      }) : go(e) && e.forEach(function (i, r) {
        a.set(r, t(i, n, o, r, e, s));
      });
      var p = u ? void 0 : (d ? l ? Bn : Sn : l ? gn : cn)(e);
      return ye(p || e, function (i, r) {
        p && (i = e[r = i]), Ie(a, r, t(i, n, o, r, e, s));
      }), a;
    };
    const Co = function (t, e) {
      return _o(t, 5, e = "function" == typeof e ? e : void 0);
    };
    const vo = function (t) {
      return pt(t) && 1 === t.nodeType && !xt(t);
    };
    class yo {
      constructor(t, e) {
        this._config = {}, e && this.define(xo(e)), t && this._setObjectToTarget(this._config, t);
      }
      set(t, e) {
        this._setToTarget(this._config, t, e);
      }
      define(t, e) {
        this._setToTarget(this._config, t, e, !0);
      }
      get(t) {
        return this._getFromSource(this._config, t);
      }
      *names() {
        for (const t of Object.keys(this._config)) yield t;
      }
      _setToTarget(t, e, n, o = !1) {
        if (xt(e)) return void this._setObjectToTarget(t, e, o);
        const i = e.split(".");
        e = i.pop();
        for (const e of i) xt(t[e]) || (t[e] = {}), t = t[e];
        if (xt(n)) return xt(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, o);
        o && void 0 !== t[e] || (t[e] = n);
      }
      _getFromSource(t, e) {
        const n = e.split(".");
        e = n.pop();
        for (const e of n) {
          if (!xt(t[e])) {
            t = null;
            break;
          }
          t = t[e];
        }
        return t ? xo(t[e]) : void 0;
      }
      _setObjectToTarget(t, e, n) {
        Object.keys(e).forEach(o => {
          this._setToTarget(t, o, e[o], n);
        });
      }
    }
    function xo(t) {
      return Co(t, Eo);
    }
    function Eo(t) {
      return vo(t) || "function" == typeof t ? t : void 0;
    }
    function Do(t) {
      if (t) {
        if (t.defaultView) return t instanceof t.defaultView.Document;
        if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
      }
      return !1;
    }
    function Io(t) {
      const e = Object.prototype.toString.apply(t);
      return "[object Window]" == e || "[object global]" == e;
    }
    const To = Mo(M());
    function Mo(t) {
      if (!t) return To;
      return class extends t {
        listenTo(t, e, n, o = {}) {
          if (Do(t) || Io(t)) {
            const i = {
                capture: !!o.useCapture,
                passive: !!o.usePassive
              },
              r = this._getProxyEmitter(t, i) || new So(t, i);
            this.listenTo(r, e, n, o);
          } else super.listenTo(t, e, n, o);
        }
        stopListening(t, e, n) {
          if (Do(t) || Io(t)) {
            const o = this._getAllProxyEmitters(t);
            for (const t of o) this.stopListening(t, e, n);
          } else super.stopListening(t, e, n);
        }
        _getProxyEmitter(t, e) {
          return function (t, e) {
            const n = t[E];
            return n && n[e] ? n[e].emitter : null;
          }(this, Bo(t, e));
        }
        _getAllProxyEmitters(t) {
          return [{
            capture: !1,
            passive: !1
          }, {
            capture: !1,
            passive: !0
          }, {
            capture: !0,
            passive: !1
          }, {
            capture: !0,
            passive: !0
          }].map(e => this._getProxyEmitter(t, e)).filter(t => !!t);
        }
      };
    }
    ["_getProxyEmitter", "_getAllProxyEmitters", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(t => {
      Mo[t] = To.prototype[t];
    });
    class So extends M() {
      constructor(t, e) {
        super(), S(this, Bo(t, e)), this._domNode = t, this._options = e;
      }
      attach(t) {
        if (this._domListeners && this._domListeners[t]) return;
        const e = this._createDomListener(t);
        this._domNode.addEventListener(t, e, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t] = e;
      }
      detach(t) {
        let e;
        !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
      }
      _addEventListener(t, e, n) {
        this.attach(t), M().prototype._addEventListener.call(this, t, e, n);
      }
      _removeEventListener(t, e) {
        M().prototype._removeEventListener.call(this, t, e), this.detach(t);
      }
      _createDomListener(t) {
        const e = e => {
          this.fire(t, e);
        };
        return e.removeListener = () => {
          this._domNode.removeEventListener(t, e, this._options), delete this._domListeners[t];
        }, e;
      }
    }
    function Bo(t, e) {
      let n = function (t) {
        return t["data-ck-expando"] || (t["data-ck-expando"] = p());
      }(t);
      for (const t of Object.keys(e).sort()) e[t] && (n += "-" + t);
      return n;
    }
    function No(t) {
      const e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }
    function Po(t) {
      return "[object Text]" == Object.prototype.toString.call(t);
    }
    function Oo(t) {
      return "[object Range]" == Object.prototype.toString.apply(t);
    }
    function Lo(t) {
      return t && t.parentNode ? t.offsetParent === e.document.body ? null : t.offsetParent : null;
    }
    const zo = ["top", "right", "bottom", "left", "width", "height"];
    class Ro {
      constructor(t) {
        const e = Oo(t);
        if (Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: !0,
          enumerable: !1
        }), Vo(t) || e) {
          if (e) {
            const e = Ro.getDomRangeRects(t);
            jo(this, Ro.getBoundingRect(e));
          } else jo(this, t.getBoundingClientRect());
        } else if (Io(t)) {
          const {
            innerWidth: e,
            innerHeight: n
          } = t;
          jo(this, {
            top: 0,
            right: e,
            bottom: n,
            left: 0,
            width: e,
            height: n
          });
        } else jo(this, t);
      }
      clone() {
        return new Ro(this);
      }
      moveTo(t, e) {
        return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
      }
      moveBy(t, e) {
        return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
      }
      getIntersection(t) {
        const e = {
          top: Math.max(this.top, t.top),
          right: Math.min(this.right, t.right),
          bottom: Math.min(this.bottom, t.bottom),
          left: Math.max(this.left, t.left),
          width: 0,
          height: 0
        };
        if (e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0) return null;
        {
          const t = new Ro(e);
          return t._source = this._source, t;
        }
      }
      getIntersectionArea(t) {
        const e = this.getIntersection(t);
        return e ? e.getArea() : 0;
      }
      getArea() {
        return this.width * this.height;
      }
      getVisible() {
        const t = this._source;
        let e = this.clone();
        if (Fo(t)) return e;
        let n,
          o = t,
          i = t.parentNode || t.commonAncestorContainer;
        for (; i && !Fo(i);) {
          const t = "visible" === ((r = i) instanceof HTMLElement ? r.ownerDocument.defaultView.getComputedStyle(r).overflow : "visible");
          o instanceof HTMLElement && "absolute" === Ho(o) && (n = o);
          const s = Ho(i);
          if (t || n && ("relative" === s && t || "relative" !== s)) {
            o = i, i = i.parentNode;
            continue;
          }
          const a = new Ro(i),
            c = e.getIntersection(a);
          if (!c) return null;
          c.getArea() < e.getArea() && (e = c), o = i, i = i.parentNode;
        }
        var r;
        return e;
      }
      isEqual(t) {
        for (const e of zo) if (this[e] !== t[e]) return !1;
        return !0;
      }
      contains(t) {
        const e = this.getIntersection(t);
        return !(!e || !e.isEqual(t));
      }
      toAbsoluteRect() {
        const {
            scrollX: t,
            scrollY: n
          } = e.window,
          o = this.clone().moveBy(t, n);
        if (Vo(o._source)) {
          const t = Lo(o._source);
          t && function (t, e) {
            const n = new Ro(e),
              o = No(e);
            let i = 0,
              r = 0;
            i -= n.left, r -= n.top, i += e.scrollLeft, r += e.scrollTop, i -= o.left, r -= o.top, t.moveBy(i, r);
          }(o, t);
        }
        return o;
      }
      excludeScrollbarsAndBorders() {
        const t = this._source;
        let e, n, o;
        if (Io(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight, o = t.getComputedStyle(t.document.documentElement).direction;else {
          const i = No(t);
          e = t.offsetWidth - t.clientWidth - i.left - i.right, n = t.offsetHeight - t.clientHeight - i.top - i.bottom, o = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += i.left, this.top += i.top, this.right -= i.right, this.bottom -= i.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
        }
        return this.width -= e, "ltr" === o ? this.right -= e : this.left += e, this.height -= n, this.bottom -= n, this;
      }
      static getDomRangeRects(t) {
        const e = [],
          n = Array.from(t.getClientRects());
        if (n.length) for (const t of n) e.push(new Ro(t));else {
          let n = t.startContainer;
          Po(n) && (n = n.parentNode);
          const o = new Ro(n.getBoundingClientRect());
          o.right = o.left, o.width = 0, e.push(o);
        }
        return e;
      }
      static getBoundingRect(t) {
        const e = {
          left: Number.POSITIVE_INFINITY,
          top: Number.POSITIVE_INFINITY,
          right: Number.NEGATIVE_INFINITY,
          bottom: Number.NEGATIVE_INFINITY,
          width: 0,
          height: 0
        };
        let n = 0;
        for (const o of t) n++, e.left = Math.min(e.left, o.left), e.top = Math.min(e.top, o.top), e.right = Math.max(e.right, o.right), e.bottom = Math.max(e.bottom, o.bottom);
        return 0 == n ? null : (e.width = e.right - e.left, e.height = e.bottom - e.top, new Ro(e));
      }
    }
    function jo(t, e) {
      for (const n of zo) t[n] = e[n];
    }
    function Fo(t) {
      return !!Vo(t) && t === t.ownerDocument.body;
    }
    function Vo(t) {
      return null !== t && "object" == typeof t && 1 === t.nodeType && "function" == typeof t.getBoundingClientRect;
    }
    function Ho(t) {
      return t instanceof HTMLElement ? t.ownerDocument.defaultView.getComputedStyle(t).position : "static";
    }
    const Uo = class {
      constructor(t, e) {
        Uo._observerInstance || Uo._createObserver(), this._element = t, this._callback = e, Uo._addElementCallback(t, e), Uo._observerInstance.observe(t);
      }
      get element() {
        return this._element;
      }
      destroy() {
        Uo._deleteElementCallback(this._element, this._callback);
      }
      static _addElementCallback(t, e) {
        Uo._elementCallbacks || (Uo._elementCallbacks = new Map());
        let n = Uo._elementCallbacks.get(t);
        n || (n = new Set(), Uo._elementCallbacks.set(t, n)), n.add(e);
      }
      static _deleteElementCallback(t, e) {
        const n = Uo._getElementCallbacks(t);
        n && (n.delete(e), n.size || (Uo._elementCallbacks.delete(t), Uo._observerInstance.unobserve(t))), Uo._elementCallbacks && !Uo._elementCallbacks.size && (Uo._observerInstance = null, Uo._elementCallbacks = null);
      }
      static _getElementCallbacks(t) {
        return Uo._elementCallbacks ? Uo._elementCallbacks.get(t) : null;
      }
      static _createObserver() {
        Uo._observerInstance = new e.window.ResizeObserver(t => {
          for (const e of t) {
            const t = Uo._getElementCallbacks(e.target);
            if (t) for (const n of t) n(e);
          }
        });
      }
    };
    let qo = Uo;
    function Go(t, e) {
      t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
    }
    function Wo(t) {
      return e => e + t;
    }
    function Ko(t) {
      let e = 0;
      for (; t.previousSibling;) t = t.previousSibling, e++;
      return e;
    }
    function $o(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }
    function Yo(t) {
      return t && t.nodeType === Node.COMMENT_NODE;
    }
    function Qo(t) {
      return !!(t && t.getClientRects && t.getClientRects().length);
    }
    qo._observerInstance = null, qo._elementCallbacks = null;
    var Zo = Math.pow;
    function Jo({
      element: t,
      target: n,
      positions: o,
      limiter: i,
      fitInViewport: r,
      viewportOffsetConfig: s
    }) {
      Ft(n) && (n = n()), Ft(i) && (i = i());
      const a = Lo(t),
        c = function (t) {
          t = Object.assign({
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }, t);
          const n = new Ro(e.window);
          return n.top += t.top, n.height -= t.top, n.bottom -= t.bottom, n.height -= t.bottom, n;
        }(s),
        l = new Ro(t),
        d = Xo(n, c);
      let u;
      if (!d || !c.getIntersection(d)) return null;
      const h = {
        targetRect: d,
        elementRect: l,
        positionedElementAncestor: a,
        viewportRect: c
      };
      if (i || r) {
        if (i) {
          const t = Xo(i, c);
          t && (h.limiterRect = t);
        }
        u = function (t, e) {
          const {
              elementRect: n
            } = e,
            o = n.getArea(),
            i = t.map(t => new ti(t, e)).filter(t => !!t.name);
          let r = 0,
            s = null;
          for (const t of i) {
            const {
              limiterIntersectionArea: e,
              viewportIntersectionArea: n
            } = t;
            if (e === o) return t;
            const i = Zo(n, 2) + Zo(e, 2);
            i > r && (r = i, s = t);
          }
          return s;
        }(o, h);
      } else u = new ti(o[0], h);
      return u;
    }
    function Xo(t, e) {
      const n = new Ro(t).getVisible();
      return n ? n.getIntersection(e) : null;
    }
    class ti {
      constructor(t, e) {
        const n = t(e.targetRect, e.elementRect, e.viewportRect, e.limiterRect);
        if (!n) return;
        const {
          left: o,
          top: i,
          name: r,
          config: s
        } = n;
        this.name = r, this.config = s, this._positioningFunctionCoordinates = {
          left: o,
          top: i
        }, this._options = e;
      }
      get left() {
        return this._absoluteRect.left;
      }
      get top() {
        return this._absoluteRect.top;
      }
      get limiterIntersectionArea() {
        const t = this._options.limiterRect;
        return t ? t.getIntersectionArea(this._rect) : 0;
      }
      get viewportIntersectionArea() {
        return this._options.viewportRect.getIntersectionArea(this._rect);
      }
      get _rect() {
        return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top)), this._cachedRect;
      }
      get _absoluteRect() {
        return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = this._rect.toAbsoluteRect()), this._cachedAbsoluteRect;
      }
    }
    function ei(t) {
      const e = t.parentNode;
      e && e.removeChild(t);
    }
    function ni({
      window: t,
      rect: e,
      alignToTop: n,
      forceScroll: o,
      viewportOffset: i
    }) {
      const r = e.clone().moveBy(0, i.bottom),
        s = e.clone().moveBy(0, -i.top),
        a = new Ro(t).excludeScrollbarsAndBorders(),
        c = n && o,
        l = [s, r].every(t => a.contains(t));
      let {
        scrollX: d,
        scrollY: u
      } = t;
      const h = d,
        g = u;
      c ? u -= a.top - e.top + i.top : l || (ri(s, a) ? u -= a.top - e.top + i.top : ii(r, a) && (u += n ? e.top - a.top - i.top : e.bottom - a.bottom + i.bottom)), l || (si(e, a) ? d -= a.left - e.left + i.left : ai(e, a) && (d += e.right - a.right + i.right)), d == h && u === g || t.scrollTo(d, u);
    }
    function oi({
      parent: t,
      getRect: e,
      alignToTop: n,
      forceScroll: o,
      ancestorOffset: i = 0,
      limiterElement: r
    }) {
      const s = ci(t),
        a = n && o;
      let c, l, d;
      const u = r || s.document.body;
      for (; t != u;) l = e(), c = new Ro(t).excludeScrollbarsAndBorders(), d = c.contains(l), a ? t.scrollTop -= c.top - l.top + i : d || (ri(l, c) ? t.scrollTop -= c.top - l.top + i : ii(l, c) && (t.scrollTop += n ? l.top - c.top - i : l.bottom - c.bottom + i)), d || (si(l, c) ? t.scrollLeft -= c.left - l.left + i : ai(l, c) && (t.scrollLeft += l.right - c.right + i)), t = t.parentNode;
    }
    function ii(t, e) {
      return t.bottom > e.bottom;
    }
    function ri(t, e) {
      return t.top < e.top;
    }
    function si(t, e) {
      return t.left < e.left;
    }
    function ai(t, e) {
      return t.right > e.right;
    }
    function ci(t) {
      return Oo(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
    }
    function li(t) {
      if (Oo(t)) {
        let e = t.commonAncestorContainer;
        return Po(e) && (e = e.parentNode), e;
      }
      return t.parentNode;
    }
    function di(t, e) {
      const n = ci(t),
        o = new Ro(t);
      if (n === e) return o;
      {
        let t = n;
        for (; t != e;) {
          const e = t.frameElement,
            n = new Ro(e).excludeScrollbarsAndBorders();
          o.moveBy(n.left, n.top), t = t.parent;
        }
      }
      return o;
    }
    const ui = {
        ctrl: "⌃",
        cmd: "⌘",
        alt: "⌥",
        shift: "⇧"
      },
      hi = {
        ctrl: "Ctrl+",
        alt: "Alt+",
        shift: "Shift+"
      },
      gi = {
        37: "←",
        38: "↑",
        39: "→",
        40: "↓",
        9: "⇥",
        33: "Page Up",
        34: "Page Down"
      },
      mi = function () {
        const t = {
          pageup: 33,
          pagedown: 34,
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          shift: 2228224,
          alt: 4456448,
          cmd: 8912896
        };
        for (let e = 65; e <= 90; e++) {
          t[String.fromCharCode(e).toLowerCase()] = e;
        }
        for (let e = 48; e <= 57; e++) t[e - 48] = e;
        for (let e = 112; e <= 123; e++) t["f" + (e - 111)] = e;
        return Object.assign(t, {
          "'": 222,
          ",": 108,
          "-": 109,
          ".": 110,
          "/": 111,
          ";": 186,
          "=": 187,
          "[": 219,
          "\\": 220,
          "]": 221,
          "`": 223
        }), t;
      }(),
      pi = Object.fromEntries(Object.entries(mi).map(([t, e]) => {
        let n;
        return n = e in gi ? gi[e] : t.charAt(0).toUpperCase() + t.slice(1), [e, n];
      }));
    function fi(t) {
      let e;
      if ("string" == typeof t) {
        if (e = mi[t.toLowerCase()], !e) throw new w("keyboard-unknown-key", null, {
          key: t
        });
      } else e = t.keyCode + (t.altKey ? mi.alt : 0) + (t.ctrlKey ? mi.ctrl : 0) + (t.shiftKey ? mi.shift : 0) + (t.metaKey ? mi.cmd : 0);
      return e;
    }
    function ki(t) {
      return "string" == typeof t && (t = function (t) {
        return t.split("+").map(t => t.trim());
      }(t)), t.map(t => "string" == typeof t ? function (t) {
        if (t.endsWith("!")) return fi(t.slice(0, -1));
        const e = fi(t);
        return (s.isMac || s.isiOS) && e == mi.ctrl ? mi.cmd : e;
      }(t) : t).reduce((t, e) => e + t, 0);
    }
    function bi(t) {
      let e = ki(t);
      return Object.entries(s.isMac || s.isiOS ? ui : hi).reduce((t, [n, o]) => (e & mi[n] && (e &= ~mi[n], t += o), t), "") + (e ? pi[e] : "");
    }
    function wi(t, e) {
      const n = "ltr" === e;
      switch (t) {
        case mi.arrowleft:
          return n ? "left" : "right";
        case mi.arrowright:
          return n ? "right" : "left";
        case mi.arrowup:
          return "up";
        case mi.arrowdown:
          return "down";
      }
    }
    function Ai(t) {
      return Array.isArray(t) ? t : [t];
    }
    const _i = function (t, e, n) {
      (void 0 !== n && !Dt(t[e], n) || void 0 === n && !(e in t)) && Ee(t, e, n);
    };
    const Ci = function (t) {
      return function (e, n, o) {
        for (var i = -1, r = Object(e), s = o(e), a = s.length; a--;) {
          var c = s[t ? a : ++i];
          if (!1 === n(r[c], c, r)) break;
        }
        return e;
      };
    }();
    const vi = function (t) {
      return pt(t) && an(t);
    };
    const yi = function (t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    };
    const xi = function (t) {
      return Te(t, gn(t));
    };
    const Ei = function (t, e, n, o, i, r, s) {
      var a = yi(t, n),
        c = yi(e, n),
        l = s.get(c);
      if (l) _i(t, n, l);else {
        var d = r ? r(a, c, n + "", t, e, s) : void 0,
          u = void 0 === d;
        if (u) {
          var h = mt(c),
            g = !h && Fe(c),
            m = !h && !g && Je(c);
          d = c, h || g || m ? mt(a) ? d = a : vi(a) ? d = An(a) : g ? (u = !1, d = wn(c, !0)) : m ? (u = !1, d = ro(c, !0)) : d = [] : xt(c) || Oe(c) ? (d = a, Oe(a) ? d = xi(a) : R(a) && !Ft(a) || (d = lo(c))) : u = !1;
        }
        u && (s.set(c, d), i(d, c, o, r, s), s.delete(c)), _i(t, n, d);
      }
    };
    const Di = function t(e, n, o, i, r) {
      e !== n && Ci(n, function (s, a) {
        if (r || (r = new ve()), R(s)) Ei(e, n, a, o, t, i, r);else {
          var c = i ? i(yi(e, a), s, a + "", e, n, r) : void 0;
          void 0 === c && (c = s), _i(e, a, c);
        }
      }, gn);
    };
    const Ii = function (t) {
      return t;
    };
    const Ti = function (t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);
        case 1:
          return t.call(e, n[0]);
        case 2:
          return t.call(e, n[0], n[1]);
        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }
      return t.apply(e, n);
    };
    var Mi = Math.max;
    const Si = function (t, e, n) {
      return e = Mi(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var o = arguments, i = -1, r = Mi(o.length - e, 0), s = Array(r); ++i < r;) s[i] = o[e + i];
        i = -1;
        for (var a = Array(e + 1); ++i < e;) a[i] = o[i];
        return a[e] = n(s), Ti(t, this, a);
      };
    };
    const Bi = function (t) {
      return function () {
        return t;
      };
    };
    const Ni = xe ? function (t, e) {
      return xe(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Bi(e),
        writable: !0
      });
    } : Ii;
    var Pi = Date.now;
    const Oi = function (t) {
      var e = 0,
        n = 0;
      return function () {
        var o = Pi(),
          i = 16 - (o - n);
        if (n = o, i > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;
        return t.apply(void 0, arguments);
      };
    };
    const Li = Oi(Ni);
    const zi = function (t, e) {
      return Li(Si(t, e, Ii), t + "");
    };
    const Ri = function (t, e, n) {
      if (!R(n)) return !1;
      var o = typeof e;
      return !!("number" == o ? an(n) && He(e, n.length) : "string" == o && e in n) && Dt(n[e], t);
    };
    const ji = function (t) {
      return zi(function (e, n) {
        var o = -1,
          i = n.length,
          r = i > 1 ? n[i - 1] : void 0,
          s = i > 2 ? n[2] : void 0;
        for (r = t.length > 3 && "function" == typeof r ? (i--, r) : void 0, s && Ri(n[0], n[1], s) && (r = i < 3 ? void 0 : r, i = 1), e = Object(e); ++o < i;) {
          var a = n[o];
          a && t(e, a, o, r);
        }
        return e;
      });
    };
    const Fi = ji(function (t, e, n) {
      Di(t, e, n);
    });
    function Vi(t, n, o = 1, i) {
      if ("number" != typeof o) throw new w("translation-service-quantity-not-a-number", null, {
        quantity: o
      });
      const r = i || e.window.CKEDITOR_TRANSLATIONS,
        s = function (t) {
          return Object.keys(t).length;
        }(r);
      1 === s && (t = Object.keys(r)[0]);
      const a = n.id || n.string;
      if (0 === s || !function (t, e, n) {
        return !!n[t] && !!n[t].dictionary[e];
      }(t, a, r)) return 1 !== o ? n.plural : n.string;
      const c = r[t].dictionary,
        l = r[t].getPluralForm || (t => 1 === t ? 0 : 1),
        d = c[a];
      if ("string" == typeof d) return d;
      return d[Number(l(o))];
    }
    e.window.CKEDITOR_TRANSLATIONS || (e.window.CKEDITOR_TRANSLATIONS = {});
    const Hi = ["ar", "ara", "dv", "div", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
    function Ui(t) {
      return Hi.includes(t) ? "rtl" : "ltr";
    }
    class qi {
      constructor({
        uiLanguage: t = "en",
        contentLanguage: e,
        translations: n
      } = {}) {
        this.uiLanguage = t, this.contentLanguage = e || this.uiLanguage, this.uiLanguageDirection = Ui(this.uiLanguage), this.contentLanguageDirection = Ui(this.contentLanguage), this.translations = function (t) {
          return Array.isArray(t) ? t.reduce((t, e) => Fi(t, e)) : t;
        }(n), this.t = (t, e) => this._t(t, e);
      }
      get language() {
        return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
      }
      _t(t, e = []) {
        e = Ai(e), "string" == typeof t && (t = {
          string: t
        });
        const n = !!t.plural ? e[0] : 1;
        return function (t, e) {
          return t.replace(/%(\d+)/g, (t, n) => n < e.length ? e[n] : t);
        }(Vi(this.uiLanguage, t, n, this.translations), e);
      }
    }
    class Gi extends M() {
      constructor(t = {}, e = {}) {
        super();
        const n = tt(t);
        if (n || (e = t), this._items = [], this._itemMap = new Map(), this._idProperty = e.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], n) for (const e of t) this._items.push(e), this._itemMap.set(this._getItemIdBeforeAdding(e), e);
      }
      get length() {
        return this._items.length;
      }
      get first() {
        return this._items[0] || null;
      }
      get last() {
        return this._items[this.length - 1] || null;
      }
      add(t, e) {
        return this.addMany([t], e);
      }
      addMany(t, e) {
        if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new w("collection-add-item-invalid-index", this);
        let n = 0;
        for (const o of t) {
          const t = this._getItemIdBeforeAdding(o),
            i = e + n;
          this._items.splice(i, 0, o), this._itemMap.set(t, o), this.fire("add", o, i), n++;
        }
        return this.fire("change", {
          added: t,
          removed: [],
          index: e
        }), this;
      }
      get(t) {
        let e;
        if ("string" == typeof t) e = this._itemMap.get(t);else {
          if ("number" != typeof t) throw new w("collection-get-invalid-arg", this);
          e = this._items[t];
        }
        return e || null;
      }
      has(t) {
        if ("string" == typeof t) return this._itemMap.has(t);
        {
          const e = t[this._idProperty];
          return e && this._itemMap.has(e);
        }
      }
      getIndex(t) {
        let e;
        return e = "string" == typeof t ? this._itemMap.get(t) : t, e ? this._items.indexOf(e) : -1;
      }
      remove(t) {
        const [e, n] = this._remove(t);
        return this.fire("change", {
          added: [],
          removed: [e],
          index: n
        }), e;
      }
      map(t, e) {
        return this._items.map(t, e);
      }
      forEach(t, e) {
        this._items.forEach(t, e);
      }
      find(t, e) {
        return this._items.find(t, e);
      }
      filter(t, e) {
        return this._items.filter(t, e);
      }
      clear() {
        this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
        const t = Array.from(this._items);
        for (; this.length;) this._remove(0);
        this.fire("change", {
          added: [],
          removed: t,
          index: 0
        });
      }
      bindTo(t) {
        if (this._bindToCollection) throw new w("collection-bind-to-rebind", this);
        return this._bindToCollection = t, {
          as: t => {
            this._setUpBindToBinding(e => new t(e));
          },
          using: t => {
            "function" == typeof t ? this._setUpBindToBinding(t) : this._setUpBindToBinding(e => e[t]);
          }
        };
      }
      _setUpBindToBinding(t) {
        const e = this._bindToCollection,
          n = (n, o, i) => {
            const r = e._bindToCollection == this,
              s = e._bindToInternalToExternalMap.get(o);
            if (r && s) this._bindToExternalToInternalMap.set(o, s), this._bindToInternalToExternalMap.set(s, o);else {
              const n = t(o);
              if (!n) return void this._skippedIndexesFromExternal.push(i);
              let r = i;
              for (const t of this._skippedIndexesFromExternal) i > t && r--;
              for (const t of e._skippedIndexesFromExternal) r >= t && r++;
              this._bindToExternalToInternalMap.set(o, n), this._bindToInternalToExternalMap.set(n, o), this.add(n, r);
              for (let t = 0; t < e._skippedIndexesFromExternal.length; t++) r <= e._skippedIndexesFromExternal[t] && e._skippedIndexesFromExternal[t]++;
            }
          };
        for (const t of e) n(0, t, e.getIndex(t));
        this.listenTo(e, "add", n), this.listenTo(e, "remove", (t, e, n) => {
          const o = this._bindToExternalToInternalMap.get(e);
          o && this.remove(o), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((t, e) => (n < e && t.push(e - 1), n > e && t.push(e), t), []);
        });
      }
      _getItemIdBeforeAdding(t) {
        const e = this._idProperty;
        let n;
        if (e in t) {
          if (n = t[e], "string" != typeof n) throw new w("collection-add-invalid-id", this);
          if (this.get(n)) throw new w("collection-add-item-already-exists", this);
        } else t[e] = n = p();
        return n;
      }
      _remove(t) {
        let e,
          n,
          o,
          i = !1;
        const r = this._idProperty;
        if ("string" == typeof t ? (n = t, o = this._itemMap.get(n), i = !o, o && (e = this._items.indexOf(o))) : "number" == typeof t ? (e = t, o = this._items[e], i = !o, o && (n = o[r])) : (o = t, n = o[r], e = this._items.indexOf(o), i = -1 == e || !this._itemMap.get(n)), i) throw new w("collection-remove-404", this);
        this._items.splice(e, 1), this._itemMap.delete(n);
        const s = this._bindToInternalToExternalMap.get(o);
        return this._bindToInternalToExternalMap.delete(o), this._bindToExternalToInternalMap.delete(s), this.fire("remove", o, e), [o, e];
      }
      [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
      }
    }
    function Wi(t) {
      const e = t.next();
      return e.done ? null : e.value;
    }
    class Ki extends Mo(G()) {
      constructor() {
        super(), this._elements = new Set(), this._nextEventLoopTimeout = null, this.set("isFocused", !1), this.set("focusedElement", null);
      }
      add(t) {
        if (this._elements.has(t)) throw new w("focustracker-add-element-already-exist", this);
        this.listenTo(t, "focus", () => this._focus(t), {
          useCapture: !0
        }), this.listenTo(t, "blur", () => this._blur(), {
          useCapture: !0
        }), this._elements.add(t);
      }
      remove(t) {
        t === this.focusedElement && this._blur(), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
      }
      destroy() {
        this.stopListening();
      }
      _focus(t) {
        clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
      }
      _blur() {
        clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(() => {
          this.focusedElement = null, this.isFocused = !1;
        }, 0);
      }
    }
    class $i {
      constructor() {
        this._listener = new (Mo())();
      }
      listenTo(t) {
        this._listener.listenTo(t, "keydown", (t, e) => {
          this._listener.fire("_keydown:" + fi(e), e);
        });
      }
      set(t, e, n = {}) {
        const o = ki(t),
          i = n.priority;
        this._listener.listenTo(this._listener, "_keydown:" + o, (t, n) => {
          e(n, () => {
            n.preventDefault(), n.stopPropagation(), t.stop();
          }), t.return = !0;
        }, {
          priority: i
        });
      }
      press(t) {
        return !!this._listener.fire("_keydown:" + fi(t), t);
      }
      stopListening(t) {
        this._listener.stopListening(t);
      }
      destroy() {
        this.stopListening();
      }
    }
    function Yi(t) {
      return tt(t) ? new Map(t) : function (t) {
        const e = new Map();
        for (const n in t) e.set(n, t[n]);
        return e;
      }(t);
    }
    Math.pow;
    function Qi(t, e) {
      let n;
      function o(...i) {
        o.cancel(), n = setTimeout(() => t(...i), e);
      }
      return o.cancel = () => {
        clearTimeout(n);
      }, o;
    }
    function Zi(t, e) {
      return !!(n = t.charAt(e - 1)) && 1 == n.length && /[\ud800-\udbff]/.test(n) && function (t) {
        return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
      }(t.charAt(e));
      var n;
    }
    function Ji(t, e) {
      return !!(n = t.charAt(e)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
      var n;
    }
    const Xi = function () {
      const t = [new RegExp("\\p{Emoji}[\\u{E0020}-\\u{E007E}]+\\u{E007F}", "u"), new RegExp("\\p{Emoji}\\u{FE0F}?\\u{20E3}", "u"), new RegExp("\\p{Emoji}\\u{FE0F}", "u"), new RegExp("(?=\\p{General_Category=Other_Symbol})\\p{Emoji}\\p{Emoji_Modifier}*", "u")],
        e = new RegExp("\\p{Regional_Indicator}{2}", "u").source,
        n = "(?:" + t.map(t => t.source).join("|") + ")";
      return new RegExp(`${e}|${n}(?:‍${n})*`, "ug");
    }();
    function tr(t, e) {
      const n = String(t).matchAll(Xi);
      return Array.from(n).some(t => t.index < e && e < t.index + t[0].length);
    }
    class er extends Gi {
      constructor(t = []) {
        super(t, {
          idProperty: "viewUid"
        }), this.on("add", (t, e, n) => {
          this._renderViewIntoCollectionParent(e, n);
        }), this.on("remove", (t, e) => {
          e.element && this._parentElement && e.element.remove();
        }), this._parentElement = null;
      }
      destroy() {
        this.map(t => t.destroy());
      }
      setParent(t) {
        this._parentElement = t;
        for (const t of this) this._renderViewIntoCollectionParent(t);
      }
      delegate(...t) {
        if (!t.length || !t.every(t => "string" == typeof t)) throw new w("ui-viewcollection-delegate-wrong-events", this);
        return {
          to: e => {
            for (const n of this) for (const o of t) n.delegate(o).to(e);
            this.on("add", (n, o) => {
              for (const n of t) o.delegate(n).to(e);
            }), this.on("remove", (n, o) => {
              for (const n of t) o.stopDelegating(n, e);
            });
          }
        };
      }
      _renderViewIntoCollectionParent(t, e) {
        t.isRendered || t.render(), t.element && this._parentElement && this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
      }
      remove(t) {
        return super.remove(t);
      }
    }
    class nr extends M() {
      constructor(t) {
        super(), Object.assign(this, hr(ur(t))), this._isRendered = !1, this._revertData = null;
      }
      render() {
        const t = this._renderNode({
          intoFragment: !0
        });
        return this._isRendered = !0, t;
      }
      apply(t) {
        return this._revertData = {
          children: [],
          bindings: [],
          attributes: {}
        }, this._renderNode({
          node: t,
          intoFragment: !1,
          isApplying: !0,
          revertData: this._revertData
        }), t;
      }
      revert(t) {
        if (!this._revertData) throw new w("ui-template-revert-not-applied", [this, t]);
        this._revertTemplateFromNode(t, this._revertData);
      }
      *getViews() {
        yield* function* t(e) {
          if (e.children) for (const n of e.children) br(n) ? yield n : wr(n) && (yield* t(n));
        }(this);
      }
      static bind(t, e) {
        return {
          to: (n, o) => new ir({
            eventNameOrFunction: n,
            attribute: n,
            observable: t,
            emitter: e,
            callback: o
          }),
          if: (n, o, i) => new rr({
            observable: t,
            emitter: e,
            attribute: n,
            valueIfTrue: o,
            callback: i
          })
        };
      }
      static extend(t, e) {
        if (t._isRendered) throw new w("template-extend-render", [this, t]);
        fr(t, hr(ur(e)));
      }
      _renderNode(t) {
        let e;
        if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text, e) throw new w("ui-template-wrong-syntax", this);
        return this.text ? this._renderText(t) : this._renderElement(t);
      }
      _renderElement(t) {
        let e = t.node;
        return e || (e = t.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
      }
      _renderText(t) {
        let e = t.node;
        return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), sr(this.text) ? this._bindToObservable({
          schema: this.text,
          updater: cr(e),
          data: t
        }) : e.textContent = this.text.join(""), e;
      }
      _renderAttributes(t) {
        if (!this.attributes) return;
        const e = t.node,
          n = t.revertData;
        for (const o in this.attributes) {
          const i = e.getAttribute(o),
            r = this.attributes[o];
          n && (n.attributes[o] = i);
          const s = _r(r) ? r[0].ns : null;
          if (sr(r)) {
            const a = _r(r) ? r[0].value : r;
            n && Cr(o) && a.unshift(i), this._bindToObservable({
              schema: a,
              updater: lr(e, o, s),
              data: t
            });
          } else if ("style" == o && "string" != typeof r[0]) this._renderStyleAttribute(r[0], t);else {
            n && i && Cr(o) && r.unshift(i);
            const t = r.map(t => t && t.value || t).reduce((t, e) => t.concat(e), []).reduce(mr, "");
            kr(t) || e.setAttributeNS(s, o, t);
          }
        }
      }
      _renderStyleAttribute(t, e) {
        const n = e.node;
        for (const o in t) {
          const i = t[o];
          sr(i) ? this._bindToObservable({
            schema: [i],
            updater: dr(n, o),
            data: e
          }) : n.style[o] = i;
        }
      }
      _renderElementChildren(t) {
        const e = t.node,
          n = t.intoFragment ? document.createDocumentFragment() : e,
          o = t.isApplying;
        let i = 0;
        for (const r of this.children) if (Ar(r)) {
          if (!o) {
            r.setParent(e);
            for (const t of r) n.appendChild(t.element);
          }
        } else if (br(r)) o || (r.isRendered || r.render(), n.appendChild(r.element));else if (Do(r)) n.appendChild(r);else if (o) {
          const e = {
            children: [],
            bindings: [],
            attributes: {}
          };
          t.revertData.children.push(e), r._renderNode({
            intoFragment: !1,
            node: n.childNodes[i++],
            isApplying: !0,
            revertData: e
          });
        } else n.appendChild(r.render());
        t.intoFragment && e.appendChild(n);
      }
      _setUpListeners(t) {
        if (this.eventListeners) for (const e in this.eventListeners) {
          const n = this.eventListeners[e].map(n => {
            const [o, i] = e.split("@");
            return n.activateDomEventListener(o, i, t);
          });
          t.revertData && t.revertData.bindings.push(n);
        }
      }
      _bindToObservable({
        schema: t,
        updater: e,
        data: n
      }) {
        const o = n.revertData;
        ar(t, e, n);
        const i = t.filter(t => !kr(t)).filter(t => t.observable).map(o => o.activateAttributeListener(t, e, n));
        o && o.bindings.push(i);
      }
      _revertTemplateFromNode(t, e) {
        for (const t of e.bindings) for (const e of t) e();
        if (e.text) return void (t.textContent = e.text);
        const n = t;
        for (const t in e.attributes) {
          const o = e.attributes[t];
          null === o ? n.removeAttribute(t) : n.setAttribute(t, o);
        }
        for (let t = 0; t < e.children.length; ++t) this._revertTemplateFromNode(n.childNodes[t], e.children[t]);
      }
    }
    class or {
      constructor(t) {
        this.attribute = t.attribute, this.observable = t.observable, this.emitter = t.emitter, this.callback = t.callback;
      }
      getValue(t) {
        const e = this.observable[this.attribute];
        return this.callback ? this.callback(e, t) : e;
      }
      activateAttributeListener(t, e, n) {
        const o = () => ar(t, e, n);
        return this.emitter.listenTo(this.observable, `change:${this.attribute}`, o), () => {
          this.emitter.stopListening(this.observable, `change:${this.attribute}`, o);
        };
      }
    }
    class ir extends or {
      constructor(t) {
        super(t), this.eventNameOrFunction = t.eventNameOrFunction;
      }
      activateDomEventListener(t, e, n) {
        const o = (t, n) => {
          e && !n.target.matches(e) || ("function" == typeof this.eventNameOrFunction ? this.eventNameOrFunction(n) : this.observable.fire(this.eventNameOrFunction, n));
        };
        return this.emitter.listenTo(n.node, t, o), () => {
          this.emitter.stopListening(n.node, t, o);
        };
      }
    }
    class rr extends or {
      constructor(t) {
        super(t), this.valueIfTrue = t.valueIfTrue;
      }
      getValue(t) {
        return !kr(super.getValue(t)) && (this.valueIfTrue || !0);
      }
    }
    function sr(t) {
      return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(sr) : t instanceof or);
    }
    function ar(t, e, {
      node: n
    }) {
      const o = function (t, e) {
        return t.map(t => t instanceof or ? t.getValue(e) : t);
      }(t, n);
      let i;
      i = 1 == t.length && t[0] instanceof rr ? o[0] : o.reduce(mr, ""), kr(i) ? e.remove() : e.set(i);
    }
    function cr(t) {
      return {
        set(e) {
          t.textContent = e;
        },
        remove() {
          t.textContent = "";
        }
      };
    }
    function lr(t, e, n) {
      return {
        set(o) {
          t.setAttributeNS(n, e, o);
        },
        remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }
    function dr(t, e) {
      return {
        set(n) {
          t.style[e] = n;
        },
        remove() {
          t.style[e] = null;
        }
      };
    }
    function ur(t) {
      return Co(t, t => {
        if (t && (t instanceof or || wr(t) || br(t) || Ar(t))) return t;
      });
    }
    function hr(t) {
      if ("string" == typeof t ? t = function (t) {
        return {
          text: [t]
        };
      }(t) : t.text && function (t) {
        t.text = Ai(t.text);
      }(t), t.on && (t.eventListeners = function (t) {
        for (const e in t) gr(t, e);
        return t;
      }(t.on), delete t.on), !t.text) {
        t.attributes && function (t) {
          for (const e in t) t[e].value && (t[e].value = Ai(t[e].value)), gr(t, e);
        }(t.attributes);
        const e = [];
        if (t.children) if (Ar(t.children)) e.push(t.children);else for (const n of t.children) wr(n) || br(n) || Do(n) ? e.push(n) : e.push(new nr(n));
        t.children = e;
      }
      return t;
    }
    function gr(t, e) {
      t[e] = Ai(t[e]);
    }
    function mr(t, e) {
      return kr(e) ? t : kr(t) ? e : `${t} ${e}`;
    }
    function pr(t, e) {
      for (const n in e) t[n] ? t[n].push(...e[n]) : t[n] = e[n];
    }
    function fr(t, e) {
      if (e.attributes && (t.attributes || (t.attributes = {}), pr(t.attributes, e.attributes)), e.eventListeners && (t.eventListeners || (t.eventListeners = {}), pr(t.eventListeners, e.eventListeners)), e.text && t.text.push(...e.text), e.children && e.children.length) {
        if (t.children.length != e.children.length) throw new w("ui-template-extend-children-mismatch", t);
        let n = 0;
        for (const o of e.children) fr(t.children[n++], o);
      }
    }
    function kr(t) {
      return !t && 0 !== t;
    }
    function br(t) {
      return t instanceof Dr;
    }
    function wr(t) {
      return t instanceof nr;
    }
    function Ar(t) {
      return t instanceof er;
    }
    function _r(t) {
      return R(t[0]) && t[0].ns;
    }
    function Cr(t) {
      return "class" == t || "style" == t;
    }
    var vr = n(2591),
      yr = n.n(vr),
      xr = n(7676),
      Er = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(xr.A, Er);
    xr.A.locals;
    class Dr extends Mo(G()) {
      constructor(t) {
        super(), this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new Gi(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (e, n) => {
          n.locale = t, n.t = t && t.t;
        }), this.decorate("render");
      }
      get bindTemplate() {
        return this._bindTemplate ? this._bindTemplate : this._bindTemplate = nr.bind(this, this);
      }
      createCollection(t) {
        const e = new er(t);
        return this._viewCollections.add(e), e;
      }
      registerChild(t) {
        tt(t) || (t = [t]);
        for (const e of t) this._unboundChildren.add(e);
      }
      deregisterChild(t) {
        tt(t) || (t = [t]);
        for (const e of t) this._unboundChildren.remove(e);
      }
      setTemplate(t) {
        this.template = new nr(t);
      }
      extendTemplate(t) {
        nr.extend(this.template, t);
      }
      render() {
        if (this.isRendered) throw new w("ui-view-render-already-rendered", this);
        this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
      }
      destroy() {
        this.stopListening(), this._viewCollections.map(t => t.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
      }
    }
    function Ir({
      emitter: t,
      activator: e,
      callback: n,
      contextElements: o
    }) {
      t.listenTo(document, "mousedown", (t, i) => {
        if (!e()) return;
        const r = "function" == typeof i.composedPath ? i.composedPath() : [],
          s = "function" == typeof o ? o() : o;
        for (const t of s) if (t.contains(i.target) || r.includes(t)) return;
        n();
      });
    }
    function Tr(t) {
      return class extends t {
        disableCssTransitions() {
          this._isCssTransitionsDisabled = !0;
        }
        enableCssTransitions() {
          this._isCssTransitionsDisabled = !1;
        }
        constructor(...t) {
          super(...t), this.set("_isCssTransitionsDisabled", !1), this.initializeCssTransitionDisablerMixin();
        }
        initializeCssTransitionDisablerMixin() {
          this.extendTemplate({
            attributes: {
              class: [this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
            }
          });
        }
      };
    }
    function Mr({
      view: t
    }) {
      t.listenTo(t.element, "submit", (e, n) => {
        n.preventDefault(), t.fire("submit");
      }, {
        useCapture: !0
      });
    }
    function Sr({
      keystrokeHandler: t,
      focusTracker: e,
      gridItems: n,
      numberOfColumns: o,
      uiLanguageDirection: i
    }) {
      const r = "number" == typeof o ? () => o : o;
      function s(t) {
        return o => {
          const i = n.find(t => t.element === e.focusedElement),
            r = n.getIndex(i),
            s = t(r, n);
          n.get(s).focus(), o.stopPropagation(), o.preventDefault();
        };
      }
      function a(t, e) {
        return t === e - 1 ? 0 : t + 1;
      }
      function c(t, e) {
        return 0 === t ? e - 1 : t - 1;
      }
      t.set("arrowright", s((t, e) => "rtl" === i ? c(t, e.length) : a(t, e.length))), t.set("arrowleft", s((t, e) => "rtl" === i ? a(t, e.length) : c(t, e.length))), t.set("arrowup", s((t, e) => {
        let n = t - r();
        return n < 0 && (n = t + r() * Math.floor(e.length / r()), n > e.length - 1 && (n -= r())), n;
      })), t.set("arrowdown", s((t, e) => {
        let n = t + r();
        return n > e.length - 1 && (n = t % r()), n;
      }));
    }
    class Br extends G() {
      constructor(t) {
        super(), this._disableStack = new Set(), this.editor = t, this.set("isEnabled", !0);
      }
      forceDisabled(t) {
        this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", Nr, {
          priority: "highest"
        }), this.isEnabled = !1);
      }
      clearForceDisabled(t) {
        this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", Nr), this.isEnabled = !0);
      }
      destroy() {
        this.stopListening();
      }
      static get isContextPlugin() {
        return !1;
      }
    }
    function Nr(t) {
      t.return = !1, t.stop();
    }
    class Pr extends G() {
      constructor(t) {
        super(), this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._affectsData = !0, this._isEnabledBasedOnSelection = !0, this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
          this.refresh();
        }), this.listenTo(t, "change:isReadOnly", () => {
          this.refresh();
        }), this.on("set:isEnabled", e => {
          if (!this.affectsData) return;
          const n = t.model.document.selection,
            o = !("$graveyard" == n.getFirstPosition().root.rootName) && t.model.canEditAt(n);
          (t.isReadOnly || this._isEnabledBasedOnSelection && !o) && (e.return = !1, e.stop());
        }, {
          priority: "highest"
        }), this.on("execute", t => {
          this.isEnabled || t.stop();
        }, {
          priority: "high"
        });
      }
      get affectsData() {
        return this._affectsData;
      }
      set affectsData(t) {
        this._affectsData = t;
      }
      refresh() {
        this.isEnabled = !0;
      }
      forceDisabled(t) {
        this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", Or, {
          priority: "highest"
        }), this.isEnabled = !1);
      }
      clearForceDisabled(t) {
        this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", Or), this.refresh());
      }
      execute(...t) {}
      destroy() {
        this.stopListening();
      }
    }
    function Or(t) {
      t.return = !1, t.stop();
    }
    class Lr extends Pr {
      constructor() {
        super(...arguments), this._childCommandsDefinitions = [];
      }
      refresh() {}
      execute(...t) {
        const e = this._getFirstEnabledCommand();
        return !!e && e.execute(t);
      }
      registerChildCommand(t, e = {}) {
        k(this._childCommandsDefinitions, {
          command: t,
          priority: e.priority || "normal"
        }), t.on("change:isEnabled", () => this._checkEnabled()), this._checkEnabled();
      }
      _checkEnabled() {
        this.isEnabled = !!this._getFirstEnabledCommand();
      }
      _getFirstEnabledCommand() {
        const t = this._childCommandsDefinitions.find(({
          command: t
        }) => t.isEnabled);
        return t && t.command;
      }
    }
    class zr extends M() {
      constructor(t, e = [], n = []) {
        super(), this._plugins = new Map(), this._context = t, this._availablePlugins = new Map();
        for (const t of e) t.pluginName && this._availablePlugins.set(t.pluginName, t);
        this._contextPlugins = new Map();
        for (const [t, e] of n) this._contextPlugins.set(t, e), this._contextPlugins.set(e, t), t.pluginName && this._availablePlugins.set(t.pluginName, t);
      }
      *[Symbol.iterator]() {
        for (const t of this._plugins) "function" == typeof t[0] && (yield t);
      }
      get(t) {
        const e = this._plugins.get(t);
        if (!e) {
          let e = t;
          throw "function" == typeof t && (e = t.pluginName || t.name), new w("plugincollection-plugin-not-loaded", this._context, {
            plugin: e
          });
        }
        return e;
      }
      has(t) {
        return this._plugins.has(t);
      }
      init(t, e = [], n = []) {
        const o = this,
          i = this._context;
        !function t(e, n = new Set()) {
          e.forEach(e => {
            a(e) && (n.has(e) || (n.add(e), e.pluginName && !o._availablePlugins.has(e.pluginName) && o._availablePlugins.set(e.pluginName, e), e.requires && t(e.requires, n)));
          });
        }(t), u(t);
        const r = [...function t(e, n = new Set()) {
          return e.map(t => a(t) ? t : o._availablePlugins.get(t)).reduce((e, o) => n.has(o) ? e : (n.add(o), o.requires && (u(o.requires, o), t(o.requires, n).forEach(t => e.add(t))), e.add(o)), new Set());
        }(t.filter(t => !l(t, e)))];
        !function (t, e) {
          for (const n of e) {
            if ("function" != typeof n) throw new w("plugincollection-replace-plugin-invalid-type", null, {
              pluginItem: n
            });
            const e = n.pluginName;
            if (!e) throw new w("plugincollection-replace-plugin-missing-name", null, {
              pluginItem: n
            });
            if (n.requires && n.requires.length) throw new w("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
              pluginName: e
            });
            const i = o._availablePlugins.get(e);
            if (!i) throw new w("plugincollection-plugin-for-replacing-not-exist", null, {
              pluginName: e
            });
            const r = t.indexOf(i);
            if (-1 === r) {
              if (o._contextPlugins.has(i)) return;
              throw new w("plugincollection-plugin-for-replacing-not-loaded", null, {
                pluginName: e
              });
            }
            if (i.requires && i.requires.length) throw new w("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
              pluginName: e
            });
            t.splice(r, 1, n), o._availablePlugins.set(e, n);
          }
        }(r, n);
        const s = r.map(t => {
          let e = o._contextPlugins.get(t);
          return e = e || new t(i), o._add(t, e), e;
        });
        return h(s, "init").then(() => h(s, "afterInit")).then(() => s);
        function a(t) {
          return "function" == typeof t;
        }
        function c(t) {
          return a(t) && !!t.isContextPlugin;
        }
        function l(t, e) {
          return e.some(e => e === t || d(t) === e || d(e) === t);
        }
        function d(t) {
          return a(t) ? t.pluginName || t.name : t;
        }
        function u(t, n = null) {
          t.map(t => a(t) ? t : o._availablePlugins.get(t) || t).forEach(t => {
            !function (t, e) {
              if (a(t)) return;
              if (e) throw new w("plugincollection-soft-required", i, {
                missingPlugin: t,
                requiredBy: d(e)
              });
              throw new w("plugincollection-plugin-not-found", i, {
                plugin: t
              });
            }(t, n), function (t, e) {
              if (!c(e)) return;
              if (c(t)) return;
              throw new w("plugincollection-context-required", i, {
                plugin: d(t),
                requiredBy: d(e)
              });
            }(t, n), function (t, n) {
              if (!n) return;
              if (!l(t, e)) return;
              throw new w("plugincollection-required", i, {
                plugin: d(t),
                requiredBy: d(n)
              });
            }(t, n);
          });
        }
        function h(t, e) {
          return t.reduce((t, n) => n[e] ? o._contextPlugins.has(n) ? t : t.then(n[e].bind(n)) : t, Promise.resolve());
        }
      }
      destroy() {
        const t = [];
        for (const [, e] of this) "function" != typeof e.destroy || this._contextPlugins.has(e) || t.push(e.destroy());
        return Promise.all(t);
      }
      _add(t, e) {
        this._plugins.set(t, e);
        const n = t.pluginName;
        if (n) {
          if (this._plugins.has(n)) throw new w("plugincollection-plugin-name-conflict", null, {
            pluginName: n,
            plugin1: this._plugins.get(n).constructor,
            plugin2: t
          });
          this._plugins.set(n, e);
        }
      }
    }
    var Rr = Object.getOwnPropertySymbols,
      jr = Object.prototype.hasOwnProperty,
      Fr = Object.prototype.propertyIsEnumerable;
    class Vr {
      constructor(t) {
        this._contextOwner = null;
        const e = t || {},
          {
            translations: n
          } = e,
          o = ((t, e) => {
            var n = {};
            for (var o in t) jr.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
            if (null != t && Rr) for (var o of Rr(t)) e.indexOf(o) < 0 && Fr.call(t, o) && (n[o] = t[o]);
            return n;
          })(e, ["translations"]);
        this.config = new yo(o, this.constructor.defaultConfig);
        const i = this.constructor.builtinPlugins;
        this.config.define("plugins", i), this.plugins = new zr(this, i);
        const r = this.config.get("language") || {};
        this.locale = new qi({
          uiLanguage: "string" == typeof r ? r : r.ui,
          contentLanguage: this.config.get("language.content"),
          translations: n
        }), this.t = this.locale.t, this.editors = new Gi();
      }
      initPlugins() {
        const t = this.config.get("plugins") || [],
          e = this.config.get("substitutePlugins") || [];
        for (const n of t.concat(e)) {
          if ("function" != typeof n) throw new w("context-initplugins-constructor-only", null, {
            Plugin: n
          });
          if (!0 !== n.isContextPlugin) throw new w("context-initplugins-invalid-plugin", null, {
            Plugin: n
          });
        }
        return this.plugins.init(t, [], e);
      }
      destroy() {
        return Promise.all(Array.from(this.editors, t => t.destroy())).then(() => this.plugins.destroy());
      }
      _addEditor(t, e) {
        if (this._contextOwner) throw new w("context-addeditor-private-context");
        this.editors.add(t), e && (this._contextOwner = t);
      }
      _removeEditor(t) {
        return this.editors.has(t) && this.editors.remove(t), this._contextOwner === t ? this.destroy() : Promise.resolve();
      }
      _getEditorConfig() {
        const t = {};
        for (const e of this.config.names()) ["plugins", "removePlugins", "extraPlugins"].includes(e) || (t[e] = this.config.get(e));
        return t;
      }
      static create(t) {
        return new Promise(e => {
          const n = new this(t);
          e(n.initPlugins().then(() => n));
        });
      }
    }
    class Hr extends G() {
      constructor(t) {
        super(), this.context = t;
      }
      destroy() {
        this.stopListening();
      }
      static get isContextPlugin() {
        return !0;
      }
    }
    class Ur extends $i {
      constructor(t) {
        super(), this.editor = t;
      }
      set(t, e, n = {}) {
        if ("string" == typeof e) {
          const t = e;
          e = (e, n) => {
            this.editor.execute(t), n();
          };
        }
        super.set(t, e, n);
      }
    }
    var qr = n(4098),
      Gr = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(qr.A, Gr);
    qr.A.locals;
    const Wr = new WeakMap();
    let Kr = !1;
    function $r({
      view: t,
      element: e,
      text: n,
      isDirectHost: o = !0,
      keepOnFocus: i = !1
    }) {
      const r = t.document;
      function s(n) {
        Wr.get(r).set(e, {
          text: n,
          isDirectHost: o,
          keepOnFocus: i,
          hostElement: o ? e : null
        }), t.change(t => Jr(r, t));
      }
      Wr.has(r) || (Wr.set(r, new Map()), r.registerPostFixer(t => Jr(r, t)), r.on("change:isComposing", () => {
        t.change(t => Jr(r, t));
      }, {
        priority: "high"
      })), e.is("editableElement") && e.on("change:placeholder", (t, e, n) => {
        s(n);
      }), e.placeholder ? s(e.placeholder) : n && s(n), n && function () {
        Kr || A("enableplaceholder-deprecated-text-option");
        Kr = !0;
      }();
    }
    function Yr(t, e) {
      return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
    }
    function Qr(t, e) {
      return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
    }
    function Zr(t, e) {
      if (!t.isAttached()) return !1;
      if (Array.from(t.getChildren()).some(t => !t.is("uiElement"))) return !1;
      const n = t.document,
        o = n.selection.anchor;
      return (!n.isComposing || !o || o.parent !== t) && (!!e || !n.isFocused || !!o && o.parent !== t);
    }
    function Jr(t, e) {
      const n = Wr.get(t),
        o = [];
      let i = !1;
      for (const [t, r] of n) r.isDirectHost && (o.push(t), Xr(e, t, r) && (i = !0));
      for (const [t, r] of n) {
        if (r.isDirectHost) continue;
        const n = ts(t);
        n && (o.includes(n) || (r.hostElement = n, Xr(e, t, r) && (i = !0)));
      }
      return i;
    }
    function Xr(t, e, n) {
      const {
        text: o,
        isDirectHost: i,
        hostElement: r
      } = n;
      let s = !1;
      r.getAttribute("data-placeholder") !== o && (t.setAttribute("data-placeholder", o, r), s = !0);
      return (i || 1 == e.childCount) && Zr(r, n.keepOnFocus) ? Yr(t, r) && (s = !0) : Qr(t, r) && (s = !0), s;
    }
    function ts(t) {
      if (t.childCount) {
        const e = t.getChild(0);
        if (e.is("element") && !e.is("uiElement") && !e.is("attributeElement")) return e;
      }
      return null;
    }
    class es {
      is() {
        throw new Error("is() method is abstract");
      }
    }
    const ns = function (t) {
      return _o(t, 4);
    };
    class os extends M(es) {
      constructor(t) {
        super(), this.document = t, this.parent = null;
      }
      get index() {
        let t;
        if (!this.parent) return null;
        if (-1 == (t = this.parent.getChildIndex(this))) throw new w("view-node-not-found-in-parent", this);
        return t;
      }
      get nextSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t + 1) || null;
      }
      get previousSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t - 1) || null;
      }
      get root() {
        let t = this;
        for (; t.parent;) t = t.parent;
        return t;
      }
      isAttached() {
        return this.root.is("rootElement");
      }
      getPath() {
        const t = [];
        let e = this;
        for (; e.parent;) t.unshift(e.index), e = e.parent;
        return t;
      }
      getAncestors(t = {}) {
        const e = [];
        let n = t.includeSelf ? this : this.parent;
        for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
      getCommonAncestor(t, e = {}) {
        const n = this.getAncestors(e),
          o = t.getAncestors(e);
        let i = 0;
        for (; n[i] == o[i] && n[i];) i++;
        return 0 === i ? null : n[i - 1];
      }
      isBefore(t) {
        if (this == t) return !1;
        if (this.root !== t.root) return !1;
        const e = this.getPath(),
          n = t.getPath(),
          o = X(e, n);
        switch (o) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return e[o] < n[o];
        }
      }
      isAfter(t) {
        return this != t && this.root === t.root && !this.isBefore(t);
      }
      _remove() {
        this.parent._removeChildren(this.index);
      }
      _fireChange(t, e) {
        this.fire(`change:${t}`, e), this.parent && this.parent._fireChange(t, e);
      }
      toJSON() {
        const t = ns(this);
        return delete t.parent, t;
      }
    }
    os.prototype.is = function (t) {
      return "node" === t || "view:node" === t;
    };
    class is extends os {
      constructor(t, e) {
        super(t), this._textData = e;
      }
      get data() {
        return this._textData;
      }
      get _data() {
        return this.data;
      }
      set _data(t) {
        this._fireChange("text", this), this._textData = t;
      }
      isSimilar(t) {
        return t instanceof is && (this === t || this.data === t.data);
      }
      _clone() {
        return new is(this.document, this.data);
      }
    }
    is.prototype.is = function (t) {
      return "$text" === t || "view:$text" === t || "text" === t || "view:text" === t || "node" === t || "view:node" === t;
    };
    class rs extends es {
      constructor(t, e, n) {
        if (super(), this.textNode = t, e < 0 || e > t.data.length) throw new w("view-textproxy-wrong-offsetintext", this);
        if (n < 0 || e + n > t.data.length) throw new w("view-textproxy-wrong-length", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }
      get offsetSize() {
        return this.data.length;
      }
      get isPartial() {
        return this.data.length !== this.textNode.data.length;
      }
      get parent() {
        return this.textNode.parent;
      }
      get root() {
        return this.textNode.root;
      }
      get document() {
        return this.textNode.document;
      }
      getAncestors(t = {}) {
        const e = [];
        let n = t.includeSelf ? this.textNode : this.parent;
        for (; null !== n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
    }
    rs.prototype.is = function (t) {
      return "$textProxy" === t || "view:$textProxy" === t || "textProxy" === t || "view:textProxy" === t;
    };
    class ss {
      constructor(...t) {
        this._patterns = [], this.add(...t);
      }
      add(...t) {
        for (let e of t) ("string" == typeof e || e instanceof RegExp) && (e = {
          name: e
        }), this._patterns.push(e);
      }
      match(...t) {
        for (const e of t) for (const t of this._patterns) {
          const n = as(e, t);
          if (n) return {
            element: e,
            pattern: t,
            match: n
          };
        }
        return null;
      }
      matchAll(...t) {
        const e = [];
        for (const n of t) for (const t of this._patterns) {
          const o = as(n, t);
          o && e.push({
            element: n,
            pattern: t,
            match: o
          });
        }
        return e.length > 0 ? e : null;
      }
      getElementName() {
        if (1 !== this._patterns.length) return null;
        const t = this._patterns[0],
          e = t.name;
        return "function" == typeof t || !e || e instanceof RegExp ? null : e;
      }
    }
    function as(t, e) {
      if ("function" == typeof e) return e(t);
      const n = {};
      return e.name && (n.name = function (t, e) {
        if (t instanceof RegExp) return !!e.match(t);
        return t === e;
      }(e.name, t.name), !n.name) || e.attributes && (n.attributes = function (t, e) {
        const n = new Set(e.getAttributeKeys());
        xt(t) ? (void 0 !== t.style && A("matcher-pattern-deprecated-attributes-style-key", t), void 0 !== t.class && A("matcher-pattern-deprecated-attributes-class-key", t)) : (n.delete("style"), n.delete("class"));
        return cs(t, n, t => e.getAttribute(t));
      }(e.attributes, t), !n.attributes) || e.classes && (n.classes = function (t, e) {
        return cs(t, e.getClassNames(), () => {});
      }(e.classes, t), !n.classes) || e.styles && (n.styles = function (t, e) {
        return cs(t, e.getStyleNames(!0), t => e.getStyle(t));
      }(e.styles, t), !n.styles) ? null : n;
    }
    function cs(t, e, n) {
      const o = function (t) {
          if (Array.isArray(t)) return t.map(t => xt(t) ? (void 0 !== t.key && void 0 !== t.value || A("matcher-pattern-missing-key-or-value", t), [t.key, t.value]) : [t, !0]);
          if (xt(t)) return Object.entries(t);
          return [[t, !0]];
        }(t),
        i = Array.from(e),
        r = [];
      if (o.forEach(([t, e]) => {
        i.forEach(o => {
          (function (t, e) {
            return !0 === t || t === e || t instanceof RegExp && e.match(t);
          })(t, o) && function (t, e, n) {
            if (!0 === t) return !0;
            const o = n(e);
            return t === o || t instanceof RegExp && !!String(o).match(t);
          }(e, o, n) && r.push(o);
        });
      }), o.length && !(r.length < o.length)) return r;
    }
    const ls = function (t) {
      return "symbol" == typeof t || pt(t) && "[object Symbol]" == gt(t);
    };
    var ds = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      us = /^\w*$/;
    const hs = function (t, e) {
      if (mt(t)) return !1;
      var n = typeof t;
      return !("number" != n && "symbol" != n && "boolean" != n && null != t && !ls(t)) || us.test(t) || !ds.test(t) || null != e && t in Object(e);
    };
    function gs(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
      var n = function () {
        var o = arguments,
          i = e ? e.apply(this, o) : o[0],
          r = n.cache;
        if (r.has(i)) return r.get(i);
        var s = t.apply(this, o);
        return n.cache = r.set(i, s) || r, s;
      };
      return n.cache = new (gs.Cache || Ae)(), n;
    }
    gs.Cache = Ae;
    const ms = gs;
    const ps = function (t) {
      var e = ms(t, function (t) {
          return 500 === n.size && n.clear(), t;
        }),
        n = e.cache;
      return e;
    };
    var fs = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      ks = /\\(\\)?/g,
      bs = ps(function (t) {
        var e = [];
        return 46 === t.charCodeAt(0) && e.push(""), t.replace(fs, function (t, n, o, i) {
          e.push(o ? i.replace(ks, "$1") : n || t);
        }), e;
      });
    const ws = bs;
    const As = function (t, e) {
      for (var n = -1, o = null == t ? 0 : t.length, i = Array(o); ++n < o;) i[n] = e(t[n], n, t);
      return i;
    };
    var _s = it ? it.prototype : void 0,
      Cs = _s ? _s.toString : void 0;
    const vs = function t(e) {
      if ("string" == typeof e) return e;
      if (mt(e)) return As(e, t) + "";
      if (ls(e)) return Cs ? Cs.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
    };
    const ys = function (t) {
      return null == t ? "" : vs(t);
    };
    const xs = function (t, e) {
      return mt(t) ? t : hs(t, e) ? [t] : ws(ys(t));
    };
    const Es = function (t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };
    const Ds = function (t) {
      if ("string" == typeof t || ls(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
    };
    const Is = function (t, e) {
      for (var n = 0, o = (e = xs(e, t)).length; null != t && n < o;) t = t[Ds(e[n++])];
      return n && n == o ? t : void 0;
    };
    const Ts = function (t, e, n) {
      var o = -1,
        i = t.length;
      e < 0 && (e = -e > i ? 0 : i + e), (n = n > i ? i : n) < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
      for (var r = Array(i); ++o < i;) r[o] = t[o + e];
      return r;
    };
    const Ms = function (t, e) {
      return e.length < 2 ? t : Is(t, Ts(e, 0, -1));
    };
    const Ss = function (t, e) {
      return e = xs(e, t), null == (t = Ms(t, e)) || delete t[Ds(Es(e))];
    };
    const Bs = function (t, e) {
      return null == t || Ss(t, e);
    };
    const Ns = function (t, e, n) {
      var o = null == t ? void 0 : Is(t, e);
      return void 0 === o ? n : o;
    };
    const Ps = function (t, e, n, o) {
      if (!R(t)) return t;
      for (var i = -1, r = (e = xs(e, t)).length, s = r - 1, a = t; null != a && ++i < r;) {
        var c = Ds(e[i]),
          l = n;
        if ("__proto__" === c || "constructor" === c || "prototype" === c) return t;
        if (i != s) {
          var d = a[c];
          void 0 === (l = o ? o(d, c, a) : void 0) && (l = R(d) ? d : He(e[i + 1]) ? [] : {});
        }
        Ie(a, c, l), a = a[c];
      }
      return t;
    };
    const Os = function (t, e, n) {
      return null == t ? t : Ps(t, e, n);
    };
    class Ls {
      constructor(t) {
        this._styles = {}, this._styleProcessor = t;
      }
      get isEmpty() {
        return !Object.entries(this._styles).length;
      }
      get size() {
        return this.isEmpty ? 0 : this.getStyleNames().length;
      }
      setTo(t) {
        this.clear();
        const e = function (t) {
          let e = null,
            n = 0,
            o = 0,
            i = null;
          const r = new Map();
          if ("" === t) return r;
          ";" != t.charAt(t.length - 1) && (t += ";");
          for (let s = 0; s < t.length; s++) {
            const a = t.charAt(s);
            if (null === e) switch (a) {
              case ":":
                i || (i = t.substr(n, s - n), o = s + 1);
                break;
              case '"':
              case "'":
                e = a;
                break;
              case ";":
                {
                  const e = t.substr(o, s - o);
                  i && r.set(i.trim(), e.trim()), i = null, n = s + 1;
                  break;
                }
            } else a === e && (e = null);
          }
          return r;
        }(t);
        for (const [t, n] of e) this._styleProcessor.toNormalizedForm(t, n, this._styles);
      }
      has(t) {
        if (this.isEmpty) return !1;
        const e = this._styleProcessor.getReducedForm(t, this._styles).find(([e]) => e === t);
        return Array.isArray(e);
      }
      set(t, e) {
        if (R(t)) for (const [e, n] of Object.entries(t)) this._styleProcessor.toNormalizedForm(e, n, this._styles);else this._styleProcessor.toNormalizedForm(t, e, this._styles);
      }
      remove(t) {
        const e = Rs(t);
        Bs(this._styles, e), delete this._styles[t], this._cleanEmptyObjectsOnPath(e);
      }
      getNormalized(t) {
        return this._styleProcessor.getNormalized(t, this._styles);
      }
      toString() {
        return this.isEmpty ? "" : this.getStylesEntries().map(t => t.join(":")).sort().join(";") + ";";
      }
      getAsString(t) {
        if (this.isEmpty) return;
        if (this._styles[t] && !R(this._styles[t])) return this._styles[t];
        const e = this._styleProcessor.getReducedForm(t, this._styles).find(([e]) => e === t);
        return Array.isArray(e) ? e[1] : void 0;
      }
      getStyleNames(t = !1) {
        if (this.isEmpty) return [];
        if (t) return this._styleProcessor.getStyleNames(this._styles);
        return this.getStylesEntries().map(([t]) => t);
      }
      clear() {
        this._styles = {};
      }
      getStylesEntries() {
        const t = [],
          e = Object.keys(this._styles);
        for (const n of e) t.push(...this._styleProcessor.getReducedForm(n, this._styles));
        return t;
      }
      _cleanEmptyObjectsOnPath(t) {
        const e = t.split(".");
        if (!(e.length > 1)) return;
        const n = e.splice(0, e.length - 1).join("."),
          o = Ns(this._styles, n);
        if (!o) return;
        !Object.keys(o).length && this.remove(n);
      }
    }
    class zs {
      constructor() {
        this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
      }
      toNormalizedForm(t, e, n) {
        if (R(e)) js(n, Rs(t), e);else if (this._normalizers.has(t)) {
          const o = this._normalizers.get(t),
            {
              path: i,
              value: r
            } = o(e);
          js(n, i, r);
        } else js(n, t, e);
      }
      getNormalized(t, e) {
        if (!t) return Fi({}, e);
        if (void 0 !== e[t]) return e[t];
        if (this._extractors.has(t)) {
          const n = this._extractors.get(t);
          if ("string" == typeof n) return Ns(e, n);
          const o = n(t, e);
          if (o) return o;
        }
        return Ns(e, Rs(t));
      }
      getReducedForm(t, e) {
        const n = this.getNormalized(t, e);
        if (void 0 === n) return [];
        if (this._reducers.has(t)) {
          return this._reducers.get(t)(n);
        }
        return [[t, n]];
      }
      getStyleNames(t) {
        const e = Array.from(this._consumables.keys()).filter(e => {
            const n = this.getNormalized(e, t);
            return n && "object" == typeof n ? Object.keys(n).length : n;
          }),
          n = new Set([...e, ...Object.keys(t)]);
        return Array.from(n);
      }
      getRelatedStyles(t) {
        return this._consumables.get(t) || [];
      }
      setNormalizer(t, e) {
        this._normalizers.set(t, e);
      }
      setExtractor(t, e) {
        this._extractors.set(t, e);
      }
      setReducer(t, e) {
        this._reducers.set(t, e);
      }
      setStyleRelation(t, e) {
        this._mapStyleNames(t, e);
        for (const n of e) this._mapStyleNames(n, [t]);
      }
      _mapStyleNames(t, e) {
        this._consumables.has(t) || this._consumables.set(t, []), this._consumables.get(t).push(...e);
      }
    }
    function Rs(t) {
      return t.replace("-", ".");
    }
    function js(t, e, n) {
      let o = n;
      R(n) && (o = Fi({}, Ns(t, e), n)), Os(t, e, o);
    }
    class Fs extends os {
      constructor(t, e, n, o) {
        if (super(t), this._unsafeAttributesToRender = [], this._customProperties = new Map(), this.name = e, this._attrs = function (t) {
          const e = Yi(t);
          for (const [t, n] of e) null === n ? e.delete(t) : "string" != typeof n && e.set(t, String(n));
          return e;
        }(n), this._children = [], o && this._insertChild(0, o), this._classes = new Set(), this._attrs.has("class")) {
          const t = this._attrs.get("class");
          Vs(this._classes, t), this._attrs.delete("class");
        }
        this._styles = new Ls(this.document.stylesProcessor), this._attrs.has("style") && (this._styles.setTo(this._attrs.get("style")), this._attrs.delete("style"));
      }
      get childCount() {
        return this._children.length;
      }
      get isEmpty() {
        return 0 === this._children.length;
      }
      getChild(t) {
        return this._children[t];
      }
      getChildIndex(t) {
        return this._children.indexOf(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      *getAttributeKeys() {
        this._classes.size > 0 && (yield "class"), this._styles.isEmpty || (yield "style"), yield* this._attrs.keys();
      }
      *getAttributes() {
        yield* this._attrs.entries(), this._classes.size > 0 && (yield ["class", this.getAttribute("class")]), this._styles.isEmpty || (yield ["style", this.getAttribute("style")]);
      }
      getAttribute(t) {
        if ("class" == t) return this._classes.size > 0 ? [...this._classes].join(" ") : void 0;
        if ("style" == t) {
          const t = this._styles.toString();
          return "" == t ? void 0 : t;
        }
        return this._attrs.get(t);
      }
      hasAttribute(t) {
        return "class" == t ? this._classes.size > 0 : "style" == t ? !this._styles.isEmpty : this._attrs.has(t);
      }
      isSimilar(t) {
        if (!(t instanceof Fs)) return !1;
        if (this === t) return !0;
        if (this.name != t.name) return !1;
        if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;
        for (const [e, n] of this._attrs) if (!t._attrs.has(e) || t._attrs.get(e) !== n) return !1;
        for (const e of this._classes) if (!t._classes.has(e)) return !1;
        for (const e of this._styles.getStyleNames()) if (!t._styles.has(e) || t._styles.getAsString(e) !== this._styles.getAsString(e)) return !1;
        return !0;
      }
      hasClass(...t) {
        for (const e of t) if (!this._classes.has(e)) return !1;
        return !0;
      }
      getClassNames() {
        return this._classes.keys();
      }
      getStyle(t) {
        return this._styles.getAsString(t);
      }
      getNormalizedStyle(t) {
        return this._styles.getNormalized(t);
      }
      getStyleNames(t) {
        return this._styles.getStyleNames(t);
      }
      hasStyle(...t) {
        for (const e of t) if (!this._styles.has(e)) return !1;
        return !0;
      }
      findAncestor(...t) {
        const e = new ss(...t);
        let n = this.parent;
        for (; n && !n.is("documentFragment");) {
          if (e.match(n)) return n;
          n = n.parent;
        }
        return null;
      }
      getCustomProperty(t) {
        return this._customProperties.get(t);
      }
      *getCustomProperties() {
        yield* this._customProperties.entries();
      }
      getIdentity() {
        const t = Array.from(this._classes).sort().join(","),
          e = this._styles.toString(),
          n = Array.from(this._attrs).map(t => `${t[0]}="${t[1]}"`).sort().join(" ");
        return this.name + ("" == t ? "" : ` class="${t}"`) + (e ? ` style="${e}"` : "") + ("" == n ? "" : ` ${n}`);
      }
      shouldRenderUnsafeAttribute(t) {
        return this._unsafeAttributesToRender.includes(t);
      }
      _clone(t = !1) {
        const e = [];
        if (t) for (const n of this.getChildren()) e.push(n._clone(t));
        const n = new this.constructor(this.document, this.name, this._attrs, e);
        return n._classes = new Set(this._classes), n._styles.set(this._styles.getNormalized()), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n._unsafeAttributesToRender = this._unsafeAttributesToRender, n;
      }
      _appendChild(t) {
        return this._insertChild(this.childCount, t);
      }
      _insertChild(t, e) {
        this._fireChange("children", this);
        let n = 0;
        const o = function (t, e) {
          if ("string" == typeof e) return [new is(t, e)];
          tt(e) || (e = [e]);
          return Array.from(e).map(e => "string" == typeof e ? new is(t, e) : e instanceof rs ? new is(t, e.data) : e);
        }(this.document, e);
        for (const e of o) null !== e.parent && e._remove(), e.parent = this, e.document = this.document, this._children.splice(t, 0, e), t++, n++;
        return n;
      }
      _removeChildren(t, e = 1) {
        this._fireChange("children", this);
        for (let n = t; n < t + e; n++) this._children[n].parent = null;
        return this._children.splice(t, e);
      }
      _setAttribute(t, e) {
        const n = String(e);
        this._fireChange("attributes", this), "class" == t ? Vs(this._classes, n) : "style" == t ? this._styles.setTo(n) : this._attrs.set(t, n);
      }
      _removeAttribute(t) {
        return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(t);
      }
      _addClass(t) {
        this._fireChange("attributes", this);
        for (const e of Ai(t)) this._classes.add(e);
      }
      _removeClass(t) {
        this._fireChange("attributes", this);
        for (const e of Ai(t)) this._classes.delete(e);
      }
      _setStyle(t, e) {
        this._fireChange("attributes", this), "string" != typeof t ? this._styles.set(t) : this._styles.set(t, e);
      }
      _removeStyle(t) {
        this._fireChange("attributes", this);
        for (const e of Ai(t)) this._styles.remove(e);
      }
      _setCustomProperty(t, e) {
        this._customProperties.set(t, e);
      }
      _removeCustomProperty(t) {
        return this._customProperties.delete(t);
      }
    }
    function Vs(t, e) {
      const n = e.split(/\s+/);
      t.clear(), n.forEach(e => t.add(e));
    }
    Fs.prototype.is = function (t, e) {
      return e ? e === this.name && ("element" === t || "view:element" === t) : "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class Hs extends Fs {
      constructor(t, e, n, o) {
        super(t, e, n, o), this.getFillerOffset = Us;
      }
    }
    function Us() {
      const t = [...this.getChildren()],
        e = t[this.childCount - 1];
      if (e && e.is("element", "br")) return this.childCount;
      for (const e of t) if (!e.is("uiElement")) return null;
      return this.childCount;
    }
    Hs.prototype.is = function (t, e) {
      return e ? e === this.name && ("containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class qs extends G(Hs) {
      constructor(t, e, n, o) {
        super(t, e, n, o), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("placeholder", void 0), this.bind("isReadOnly").to(t), this.bind("isFocused").to(t, "isFocused", e => e && t.selection.editableElement == this), this.listenTo(t.selection, "change", () => {
          this.isFocused = t.isFocused && t.selection.editableElement == this;
        });
      }
      destroy() {
        this.stopListening();
      }
    }
    qs.prototype.is = function (t, e) {
      return e ? e === this.name && ("editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    const Gs = Symbol("rootName");
    class Ws extends qs {
      constructor(t, e) {
        super(t, e), this.rootName = "main";
      }
      get rootName() {
        return this.getCustomProperty(Gs);
      }
      set rootName(t) {
        this._setCustomProperty(Gs, t);
      }
      set _name(t) {
        this.name = t;
      }
    }
    Ws.prototype.is = function (t, e) {
      return e ? e === this.name && ("rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class Ks {
      constructor(t = {}) {
        if (!t.boundaries && !t.startPosition) throw new w("view-tree-walker-no-start-position", null);
        if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new w("view-tree-walker-unknown-direction", t.startPosition, {
          direction: t.direction
        });
        this.boundaries = t.boundaries || null, t.startPosition ? this._position = $s._createAt(t.startPosition) : this._position = $s._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }
      [Symbol.iterator]() {
        return this;
      }
      get position() {
        return this._position;
      }
      skip(t) {
        let e, n;
        do {
          n = this.position, e = this.next();
        } while (!e.done && t(e.value));
        e.done || (this._position = n);
      }
      next() {
        return "forward" == this.direction ? this._next() : this._previous();
      }
      _next() {
        let t = this.position.clone();
        const e = this.position,
          n = t.parent;
        if (null === n.parent && t.offset === n.childCount) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        let o;
        if (n instanceof is) {
          if (t.isAtEnd) return this._position = $s._createAfter(n), this._next();
          o = n.data[t.offset];
        } else o = n.getChild(t.offset);
        if (o instanceof Fs) {
          if (this.shallow) {
            if (this.boundaries && this.boundaries.end.isBefore(t)) return {
              done: !0,
              value: void 0
            };
            t.offset++;
          } else t = new $s(o, 0);
          return this._position = t, this._formatReturnValue("elementStart", o, e, t, 1);
        }
        if (o instanceof is) {
          if (this.singleCharacters) return t = new $s(o, 0), this._position = t, this._next();
          let n,
            i = o.data.length;
          return o == this._boundaryEndParent ? (i = this.boundaries.end.offset, n = new rs(o, 0, i), t = $s._createAfter(n)) : (n = new rs(o, 0, o.data.length), t.offset++), this._position = t, this._formatReturnValue("text", n, e, t, i);
        }
        if ("string" == typeof o) {
          let o;
          if (this.singleCharacters) o = 1;else {
            o = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
          }
          const i = new rs(n, t.offset, o);
          return t.offset += o, this._position = t, this._formatReturnValue("text", i, e, t, o);
        }
        return t = $s._createAfter(n), this._position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
      }
      _previous() {
        let t = this.position.clone();
        const e = this.position,
          n = t.parent;
        if (null === n.parent && 0 === t.offset) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        let o;
        if (n instanceof is) {
          if (t.isAtStart) return this._position = $s._createBefore(n), this._previous();
          o = n.data[t.offset - 1];
        } else o = n.getChild(t.offset - 1);
        if (o instanceof Fs) return this.shallow ? (t.offset--, this._position = t, this._formatReturnValue("elementStart", o, e, t, 1)) : (t = new $s(o, o.childCount), this._position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", o, e, t));
        if (o instanceof is) {
          if (this.singleCharacters) return t = new $s(o, o.data.length), this._position = t, this._previous();
          let n,
            i = o.data.length;
          if (o == this._boundaryStartParent) {
            const e = this.boundaries.start.offset;
            n = new rs(o, e, o.data.length - e), i = n.data.length, t = $s._createBefore(n);
          } else n = new rs(o, 0, o.data.length), t.offset--;
          return this._position = t, this._formatReturnValue("text", n, e, t, i);
        }
        if ("string" == typeof o) {
          let o;
          if (this.singleCharacters) o = 1;else {
            const e = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
            o = t.offset - e;
          }
          t.offset -= o;
          const i = new rs(n, t.offset, o);
          return this._position = t, this._formatReturnValue("text", i, e, t, o);
        }
        return t = $s._createBefore(n), this._position = t, this._formatReturnValue("elementStart", n, e, t, 1);
      }
      _formatReturnValue(t, e, n, o, i) {
        return e instanceof rs && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = $s._createAfter(e.textNode) : (o = $s._createAfter(e.textNode), this._position = o)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = $s._createBefore(e.textNode) : (o = $s._createBefore(e.textNode), this._position = o))), {
          done: !1,
          value: {
            type: t,
            item: e,
            previousPosition: n,
            nextPosition: o,
            length: i
          }
        };
      }
    }
    class $s extends es {
      constructor(t, e) {
        super(), this.parent = t, this.offset = e;
      }
      get nodeAfter() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
      }
      get nodeBefore() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
      }
      get isAtStart() {
        return 0 === this.offset;
      }
      get isAtEnd() {
        const t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
        return this.offset === t;
      }
      get root() {
        return this.parent.root;
      }
      get editableElement() {
        let t = this.parent;
        for (; !(t instanceof qs);) {
          if (!t.parent) return null;
          t = t.parent;
        }
        return t;
      }
      getShiftedBy(t) {
        const e = $s._createAt(this),
          n = e.offset + t;
        return e.offset = n < 0 ? 0 : n, e;
      }
      getLastMatchingPosition(t, e = {}) {
        e.startPosition = this;
        const n = new Ks(e);
        return n.skip(t), n.position;
      }
      getAncestors() {
        return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
          includeSelf: !0
        });
      }
      getCommonAncestor(t) {
        const e = this.getAncestors(),
          n = t.getAncestors();
        let o = 0;
        for (; e[o] == n[o] && e[o];) o++;
        return 0 === o ? null : e[o - 1];
      }
      isEqual(t) {
        return this.parent == t.parent && this.offset == t.offset;
      }
      isBefore(t) {
        return "before" == this.compareWith(t);
      }
      isAfter(t) {
        return "after" == this.compareWith(t);
      }
      compareWith(t) {
        if (this.root !== t.root) return "different";
        if (this.isEqual(t)) return "same";
        const e = this.parent.is("node") ? this.parent.getPath() : [],
          n = t.parent.is("node") ? t.parent.getPath() : [];
        e.push(this.offset), n.push(t.offset);
        const o = X(e, n);
        switch (o) {
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return e[o] < n[o] ? "before" : "after";
        }
      }
      getWalker(t = {}) {
        return t.startPosition = this, new Ks(t);
      }
      clone() {
        return new $s(this.parent, this.offset);
      }
      static _createAt(t, e) {
        if (t instanceof $s) return new this(t.parent, t.offset);
        {
          const n = t;
          if ("end" == e) e = n.is("$text") ? n.data.length : n.childCount;else {
            if ("before" == e) return this._createBefore(n);
            if ("after" == e) return this._createAfter(n);
            if (0 !== e && !e) throw new w("view-createpositionat-offset-required", n);
          }
          return new $s(n, e);
        }
      }
      static _createAfter(t) {
        if (t.is("$textProxy")) return new $s(t.textNode, t.offsetInText + t.data.length);
        if (!t.parent) throw new w("view-position-after-root", t, {
          root: t
        });
        return new $s(t.parent, t.index + 1);
      }
      static _createBefore(t) {
        if (t.is("$textProxy")) return new $s(t.textNode, t.offsetInText);
        if (!t.parent) throw new w("view-position-before-root", t, {
          root: t
        });
        return new $s(t.parent, t.index);
      }
    }
    $s.prototype.is = function (t) {
      return "position" === t || "view:position" === t;
    };
    class Ys extends es {
      constructor(t, e = null) {
        super(), this.start = t.clone(), this.end = e ? e.clone() : t.clone();
      }
      *[Symbol.iterator]() {
        yield* new Ks({
          boundaries: this,
          ignoreElementEnd: !0
        });
      }
      get isCollapsed() {
        return this.start.isEqual(this.end);
      }
      get isFlat() {
        return this.start.parent === this.end.parent;
      }
      get root() {
        return this.start.root;
      }
      getEnlarged() {
        let t = this.start.getLastMatchingPosition(Qs, {
            direction: "backward"
          }),
          e = this.end.getLastMatchingPosition(Qs);
        return t.parent.is("$text") && t.isAtStart && (t = $s._createBefore(t.parent)), e.parent.is("$text") && e.isAtEnd && (e = $s._createAfter(e.parent)), new Ys(t, e);
      }
      getTrimmed() {
        let t = this.start.getLastMatchingPosition(Qs);
        if (t.isAfter(this.end) || t.isEqual(this.end)) return new Ys(t, t);
        let e = this.end.getLastMatchingPosition(Qs, {
          direction: "backward"
        });
        const n = t.nodeAfter,
          o = e.nodeBefore;
        return n && n.is("$text") && (t = new $s(n, 0)), o && o.is("$text") && (e = new $s(o, o.data.length)), new Ys(t, e);
      }
      isEqual(t) {
        return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
      }
      containsPosition(t) {
        return t.isAfter(this.start) && t.isBefore(this.end);
      }
      containsRange(t, e = !1) {
        t.isCollapsed && (e = !1);
        const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
          o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
        return n && o;
      }
      getDifference(t) {
        const e = [];
        return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Ys(this.start, t.start)), this.containsPosition(t.end) && e.push(new Ys(t.end, this.end))) : e.push(this.clone()), e;
      }
      getIntersection(t) {
        if (this.isIntersecting(t)) {
          let e = this.start,
            n = this.end;
          return this.containsPosition(t.start) && (e = t.start), this.containsPosition(t.end) && (n = t.end), new Ys(e, n);
        }
        return null;
      }
      getWalker(t = {}) {
        return t.boundaries = this, new Ks(t);
      }
      getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
      }
      getContainedElement() {
        if (this.isCollapsed) return null;
        let t = this.start.nodeAfter,
          e = this.end.nodeBefore;
        return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (e = this.end.parent.previousSibling), t && t.is("element") && t === e ? t : null;
      }
      clone() {
        return new Ys(this.start, this.end);
      }
      *getItems(t = {}) {
        t.boundaries = this, t.ignoreElementEnd = !0;
        const e = new Ks(t);
        for (const t of e) yield t.item;
      }
      *getPositions(t = {}) {
        t.boundaries = this;
        const e = new Ks(t);
        yield e.position;
        for (const t of e) yield t.nextPosition;
      }
      isIntersecting(t) {
        return this.start.isBefore(t.end) && this.end.isAfter(t.start);
      }
      static _createFromParentsAndOffsets(t, e, n, o) {
        return new this(new $s(t, e), new $s(n, o));
      }
      static _createFromPositionAndShift(t, e) {
        const n = t,
          o = t.getShiftedBy(e);
        return e > 0 ? new this(n, o) : new this(o, n);
      }
      static _createIn(t) {
        return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
      }
      static _createOn(t) {
        const e = t.is("$textProxy") ? t.offsetSize : 1;
        return this._createFromPositionAndShift($s._createBefore(t), e);
      }
    }
    function Qs(t) {
      return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
    }
    Ys.prototype.is = function (t) {
      return "range" === t || "view:range" === t;
    };
    class Zs extends M(es) {
      constructor(...t) {
        super(), this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", t.length && this.setTo(...t);
      }
      get isFake() {
        return this._isFake;
      }
      get fakeSelectionLabel() {
        return this._fakeSelectionLabel;
      }
      get anchor() {
        if (!this._ranges.length) return null;
        const t = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? t.end : t.start).clone();
      }
      get focus() {
        if (!this._ranges.length) return null;
        const t = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? t.start : t.end).clone();
      }
      get isCollapsed() {
        return 1 === this.rangeCount && this._ranges[0].isCollapsed;
      }
      get rangeCount() {
        return this._ranges.length;
      }
      get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
      }
      get editableElement() {
        return this.anchor ? this.anchor.editableElement : null;
      }
      *getRanges() {
        for (const t of this._ranges) yield t.clone();
      }
      getFirstRange() {
        let t = null;
        for (const e of this._ranges) t && !e.start.isBefore(t.start) || (t = e);
        return t ? t.clone() : null;
      }
      getLastRange() {
        let t = null;
        for (const e of this._ranges) t && !e.end.isAfter(t.end) || (t = e);
        return t ? t.clone() : null;
      }
      getFirstPosition() {
        const t = this.getFirstRange();
        return t ? t.start.clone() : null;
      }
      getLastPosition() {
        const t = this.getLastRange();
        return t ? t.end.clone() : null;
      }
      isEqual(t) {
        if (this.isFake != t.isFake) return !1;
        if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
        if (this.rangeCount != t.rangeCount) return !1;
        if (0 === this.rangeCount) return !0;
        if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
        for (const e of this._ranges) {
          let n = !1;
          for (const o of t._ranges) if (e.isEqual(o)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      isSimilar(t) {
        if (this.isBackward != t.isBackward) return !1;
        const e = J(this.getRanges());
        if (e != J(t.getRanges())) return !1;
        if (0 == e) return !0;
        for (let e of this.getRanges()) {
          e = e.getTrimmed();
          let n = !1;
          for (let o of t.getRanges()) if (o = o.getTrimmed(), e.start.isEqual(o.start) && e.end.isEqual(o.end)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      getSelectedElement() {
        return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
      }
      setTo(...t) {
        let [e, n, o] = t;
        if ("object" == typeof n && (o = n, n = void 0), null === e) this._setRanges([]), this._setFakeOptions(o);else if (e instanceof Zs || e instanceof Js) this._setRanges(e.getRanges(), e.isBackward), this._setFakeOptions({
          fake: e.isFake,
          label: e.fakeSelectionLabel
        });else if (e instanceof Ys) this._setRanges([e], o && o.backward), this._setFakeOptions(o);else if (e instanceof $s) this._setRanges([new Ys(e)]), this._setFakeOptions(o);else if (e instanceof os) {
          const t = !!o && !!o.backward;
          let i;
          if (void 0 === n) throw new w("view-selection-setto-required-second-parameter", this);
          i = "in" == n ? Ys._createIn(e) : "on" == n ? Ys._createOn(e) : new Ys($s._createAt(e, n)), this._setRanges([i], t), this._setFakeOptions(o);
        } else {
          if (!tt(e)) throw new w("view-selection-setto-not-selectable", this);
          this._setRanges(e, o && o.backward), this._setFakeOptions(o);
        }
        this.fire("change");
      }
      setFocus(t, e) {
        if (null === this.anchor) throw new w("view-selection-setfocus-no-ranges", this);
        const n = $s._createAt(t, e);
        if ("same" == n.compareWith(this.focus)) return;
        const o = this.anchor;
        this._ranges.pop(), "before" == n.compareWith(o) ? this._addRange(new Ys(n, o), !0) : this._addRange(new Ys(o, n)), this.fire("change");
      }
      _setRanges(t, e = !1) {
        t = Array.from(t), this._ranges = [];
        for (const e of t) this._addRange(e);
        this._lastRangeBackward = !!e;
      }
      _setFakeOptions(t = {}) {
        this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
      }
      _addRange(t, e = !1) {
        if (!(t instanceof Ys)) throw new w("view-selection-add-range-not-range", this);
        this._pushRange(t), this._lastRangeBackward = !!e;
      }
      _pushRange(t) {
        for (const e of this._ranges) if (t.isIntersecting(e)) throw new w("view-selection-range-intersects", this, {
          addedRange: t,
          intersectingRange: e
        });
        this._ranges.push(new Ys(t.start, t.end));
      }
    }
    Zs.prototype.is = function (t) {
      return "selection" === t || "view:selection" === t;
    };
    class Js extends M(es) {
      constructor(...t) {
        super(), this._selection = new Zs(), this._selection.delegate("change").to(this), t.length && this._selection.setTo(...t);
      }
      get isFake() {
        return this._selection.isFake;
      }
      get fakeSelectionLabel() {
        return this._selection.fakeSelectionLabel;
      }
      get anchor() {
        return this._selection.anchor;
      }
      get focus() {
        return this._selection.focus;
      }
      get isCollapsed() {
        return this._selection.isCollapsed;
      }
      get rangeCount() {
        return this._selection.rangeCount;
      }
      get isBackward() {
        return this._selection.isBackward;
      }
      get editableElement() {
        return this._selection.editableElement;
      }
      get _ranges() {
        return this._selection._ranges;
      }
      *getRanges() {
        yield* this._selection.getRanges();
      }
      getFirstRange() {
        return this._selection.getFirstRange();
      }
      getLastRange() {
        return this._selection.getLastRange();
      }
      getFirstPosition() {
        return this._selection.getFirstPosition();
      }
      getLastPosition() {
        return this._selection.getLastPosition();
      }
      getSelectedElement() {
        return this._selection.getSelectedElement();
      }
      isEqual(t) {
        return this._selection.isEqual(t);
      }
      isSimilar(t) {
        return this._selection.isSimilar(t);
      }
      _setTo(...t) {
        this._selection.setTo(...t);
      }
      _setFocus(t, e) {
        this._selection.setFocus(t, e);
      }
    }
    Js.prototype.is = function (t) {
      return "selection" === t || "documentSelection" == t || "view:selection" == t || "view:documentSelection" == t;
    };
    class Xs extends g {
      constructor(t, e, n) {
        super(t, e), this.startRange = n, this._eventPhase = "none", this._currentTarget = null;
      }
      get eventPhase() {
        return this._eventPhase;
      }
      get currentTarget() {
        return this._currentTarget;
      }
    }
    const ta = Symbol("bubbling contexts");
    function ea(t) {
      return class extends t {
        fire(t, ...e) {
          try {
            const n = t instanceof g ? t : new g(this, t),
              o = ra(this);
            if (!o.size) return;
            if (na(n, "capturing", this), oa(o, "$capture", n, ...e)) return n.return;
            const i = n.startRange || this.selection.getFirstRange(),
              r = i ? i.getContainedElement() : null,
              s = !!r && Boolean(ia(o, r));
            let a = r || function (t) {
              if (!t) return null;
              const e = t.start.parent,
                n = t.end.parent,
                o = e.getPath(),
                i = n.getPath();
              return o.length > i.length ? e : n;
            }(i);
            if (na(n, "atTarget", a), !s) {
              if (oa(o, "$text", n, ...e)) return n.return;
              na(n, "bubbling", a);
            }
            for (; a;) {
              if (a.is("rootElement")) {
                if (oa(o, "$root", n, ...e)) return n.return;
              } else if (a.is("element") && oa(o, a.name, n, ...e)) return n.return;
              if (oa(o, a, n, ...e)) return n.return;
              a = a.parent, na(n, "bubbling", a);
            }
            return na(n, "bubbling", this), oa(o, "$document", n, ...e), n.return;
          } catch (t) {
            w.rethrowUnexpectedError(t, this);
          }
        }
        _addEventListener(t, e, n) {
          const o = Ai(n.context || "$document"),
            i = ra(this);
          for (const r of o) {
            let o = i.get(r);
            o || (o = new (M())(), i.set(r, o)), this.listenTo(o, t, e, n);
          }
        }
        _removeEventListener(t, e) {
          const n = ra(this);
          for (const o of n.values()) this.stopListening(o, t, e);
        }
      };
    }
    {
      const t = ea(Object);
      ["fire", "_addEventListener", "_removeEventListener"].forEach(e => {
        ea[e] = t.prototype[e];
      });
    }
    function na(t, e, n) {
      t instanceof Xs && (t._eventPhase = e, t._currentTarget = n);
    }
    function oa(t, e, n, ...o) {
      const i = "string" == typeof e ? t.get(e) : ia(t, e);
      return !!i && (i.fire(n, ...o), n.stop.called);
    }
    function ia(t, e) {
      for (const [n, o] of t) if ("function" == typeof n && n(e)) return o;
      return null;
    }
    function ra(t) {
      return t[ta] || (t[ta] = new Map()), t[ta];
    }
    class sa extends ea(G()) {
      constructor(t) {
        super(), this._postFixers = new Set(), this.selection = new Js(), this.roots = new Gi({
          idProperty: "rootName"
        }), this.stylesProcessor = t, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1);
      }
      getRoot(t = "main") {
        return this.roots.get(t);
      }
      registerPostFixer(t) {
        this._postFixers.add(t);
      }
      destroy() {
        this.roots.forEach(t => t.destroy()), this.stopListening();
      }
      _callPostFixers(t) {
        let e = !1;
        do {
          for (const n of this._postFixers) if (e = n(t), e) break;
        } while (e);
      }
    }
    class aa extends Fs {
      constructor(t, e, n, o) {
        super(t, e, n, o), this._priority = 10, this._id = null, this._clonesGroup = null, this.getFillerOffset = ca;
      }
      get priority() {
        return this._priority;
      }
      get id() {
        return this._id;
      }
      getElementsWithSameId() {
        if (null === this.id) throw new w("attribute-element-get-elements-with-same-id-no-id", this);
        return new Set(this._clonesGroup);
      }
      isSimilar(t) {
        return null !== this.id || null !== t.id ? this.id === t.id : super.isSimilar(t) && this.priority == t.priority;
      }
      _clone(t = !1) {
        const e = super._clone(t);
        return e._priority = this._priority, e._id = this._id, e;
      }
    }
    function ca() {
      if (la(this)) return null;
      let t = this.parent;
      for (; t && t.is("attributeElement");) {
        if (la(t) > 1) return null;
        t = t.parent;
      }
      return !t || la(t) > 1 ? null : this.childCount;
    }
    function la(t) {
      return Array.from(t.getChildren()).filter(t => !t.is("uiElement")).length;
    }
    aa.DEFAULT_PRIORITY = 10, aa.prototype.is = function (t, e) {
      return e ? e === this.name && ("attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t) : "attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class da extends Fs {
      constructor(t, e, n, o) {
        super(t, e, n, o), this.getFillerOffset = ua;
      }
      _insertChild(t, e) {
        if (e && (e instanceof os || Array.from(e).length > 0)) throw new w("view-emptyelement-cannot-add", [this, e]);
        return 0;
      }
    }
    function ua() {
      return null;
    }
    da.prototype.is = function (t, e) {
      return e ? e === this.name && ("emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t) : "emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class ha extends Fs {
      constructor(t, e, n, o) {
        super(t, e, n, o), this.getFillerOffset = ma;
      }
      _insertChild(t, e) {
        if (e && (e instanceof os || Array.from(e).length > 0)) throw new w("view-uielement-cannot-add", [this, e]);
        return 0;
      }
      render(t, e) {
        return this.toDomElement(t);
      }
      toDomElement(t) {
        const e = t.createElement(this.name);
        for (const t of this.getAttributeKeys()) e.setAttribute(t, this.getAttribute(t));
        return e;
      }
    }
    function ga(t) {
      t.document.on("arrowKey", (e, n) => function (t, e, n) {
        if (e.keyCode == mi.arrowright) {
          const t = e.domTarget.ownerDocument.defaultView.getSelection(),
            o = 1 == t.rangeCount && t.getRangeAt(0).collapsed;
          if (o || e.shiftKey) {
            const e = t.focusNode,
              i = t.focusOffset,
              r = n.domPositionToView(e, i);
            if (null === r) return;
            let s = !1;
            const a = r.getLastMatchingPosition(t => (t.item.is("uiElement") && (s = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"))));
            if (s) {
              const e = n.viewPositionToDom(a);
              o ? t.collapse(e.parent, e.offset) : t.extend(e.parent, e.offset);
            }
          }
        }
      }(0, n, t.domConverter), {
        priority: "low"
      });
    }
    function ma() {
      return null;
    }
    ha.prototype.is = function (t, e) {
      return e ? e === this.name && ("uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t) : "uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class pa extends Fs {
      constructor(t, e, n, o) {
        super(t, e, n, o), this.getFillerOffset = fa;
      }
      _insertChild(t, e) {
        if (e && (e instanceof os || Array.from(e).length > 0)) throw new w("view-rawelement-cannot-add", [this, e]);
        return 0;
      }
      render(t, e) {}
    }
    function fa() {
      return null;
    }
    pa.prototype.is = function (t, e) {
      return e ? e === this.name && ("rawElement" === t || "view:rawElement" === t || "element" === t || "view:element" === t) : "rawElement" === t || "view:rawElement" === t || t === this.name || t === "view:" + this.name || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class ka extends M(es) {
      constructor(t, e) {
        super(), this._children = [], this._customProperties = new Map(), this.document = t, e && this._insertChild(0, e);
      }
      [Symbol.iterator]() {
        return this._children[Symbol.iterator]();
      }
      get childCount() {
        return this._children.length;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      get root() {
        return this;
      }
      get parent() {
        return null;
      }
      get name() {}
      get getFillerOffset() {}
      getCustomProperty(t) {
        return this._customProperties.get(t);
      }
      *getCustomProperties() {
        yield* this._customProperties.entries();
      }
      _appendChild(t) {
        return this._insertChild(this.childCount, t);
      }
      getChild(t) {
        return this._children[t];
      }
      getChildIndex(t) {
        return this._children.indexOf(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      _insertChild(t, e) {
        this._fireChange("children", this);
        let n = 0;
        const o = function (t, e) {
          if ("string" == typeof e) return [new is(t, e)];
          tt(e) || (e = [e]);
          return Array.from(e).map(e => "string" == typeof e ? new is(t, e) : e instanceof rs ? new is(t, e.data) : e);
        }(this.document, e);
        for (const e of o) null !== e.parent && e._remove(), e.parent = this, this._children.splice(t, 0, e), t++, n++;
        return n;
      }
      _removeChildren(t, e = 1) {
        this._fireChange("children", this);
        for (let n = t; n < t + e; n++) this._children[n].parent = null;
        return this._children.splice(t, e);
      }
      _fireChange(t, e) {
        this.fire("change:" + t, e);
      }
      _setCustomProperty(t, e) {
        this._customProperties.set(t, e);
      }
      _removeCustomProperty(t) {
        return this._customProperties.delete(t);
      }
    }
    ka.prototype.is = function (t) {
      return "documentFragment" === t || "view:documentFragment" === t;
    };
    class ba {
      constructor(t) {
        this._cloneGroups = new Map(), this._slotFactory = null, this.document = t;
      }
      setSelection(...t) {
        this.document.selection._setTo(...t);
      }
      setSelectionFocus(t, e) {
        this.document.selection._setFocus(t, e);
      }
      createDocumentFragment(t) {
        return new ka(this.document, t);
      }
      createText(t) {
        return new is(this.document, t);
      }
      createAttributeElement(t, e, n = {}) {
        const o = new aa(this.document, t, e);
        return "number" == typeof n.priority && (o._priority = n.priority), n.id && (o._id = n.id), n.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), o;
      }
      createContainerElement(t, e, n = {}, o = {}) {
        let i = null;
        xt(n) ? o = n : i = n;
        const r = new Hs(this.document, t, e, i);
        return o.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...o.renderUnsafeAttributes), r;
      }
      createEditableElement(t, e, n = {}) {
        const o = new qs(this.document, t, e);
        return n.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), o;
      }
      createEmptyElement(t, e, n = {}) {
        const o = new da(this.document, t, e);
        return n.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), o;
      }
      createUIElement(t, e, n) {
        const o = new ha(this.document, t, e);
        return n && (o.render = n), o;
      }
      createRawElement(t, e, n, o = {}) {
        const i = new pa(this.document, t, e);
        return n && (i.render = n), o.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...o.renderUnsafeAttributes), i;
      }
      setAttribute(t, e, n) {
        n._setAttribute(t, e);
      }
      removeAttribute(t, e) {
        e._removeAttribute(t);
      }
      addClass(t, e) {
        e._addClass(t);
      }
      removeClass(t, e) {
        e._removeClass(t);
      }
      setStyle(t, e, n) {
        xt(t) && void 0 === n ? e._setStyle(t) : n._setStyle(t, e);
      }
      removeStyle(t, e) {
        e._removeStyle(t);
      }
      setCustomProperty(t, e, n) {
        n._setCustomProperty(t, e);
      }
      removeCustomProperty(t, e) {
        return e._removeCustomProperty(t);
      }
      breakAttributes(t) {
        return t instanceof $s ? this._breakAttributes(t) : this._breakAttributesRange(t);
      }
      breakContainer(t) {
        const e = t.parent;
        if (!e.is("containerElement")) throw new w("view-writer-break-non-container-element", this.document);
        if (!e.parent) throw new w("view-writer-break-root", this.document);
        if (t.isAtStart) return $s._createBefore(e);
        if (!t.isAtEnd) {
          const n = e._clone(!1);
          this.insert($s._createAfter(e), n);
          const o = new Ys(t, $s._createAt(e, "end")),
            i = new $s(n, 0);
          this.move(o, i);
        }
        return $s._createAfter(e);
      }
      mergeAttributes(t) {
        const e = t.offset,
          n = t.parent;
        if (n.is("$text")) return t;
        if (n.is("attributeElement") && 0 === n.childCount) {
          const t = n.parent,
            e = n.index;
          return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new $s(t, e));
        }
        const o = n.getChild(e - 1),
          i = n.getChild(e);
        if (!o || !i) return t;
        if (o.is("$text") && i.is("$text")) return va(o, i);
        if (o.is("attributeElement") && i.is("attributeElement") && o.isSimilar(i)) {
          const t = o.childCount;
          return o._appendChild(i.getChildren()), i._remove(), this._removeFromClonedElementsGroup(i), this.mergeAttributes(new $s(o, t));
        }
        return t;
      }
      mergeContainers(t) {
        const e = t.nodeBefore,
          n = t.nodeAfter;
        if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new w("view-writer-merge-containers-invalid-position", this.document);
        const o = e.getChild(e.childCount - 1),
          i = o instanceof is ? $s._createAt(o, "end") : $s._createAt(e, "end");
        return this.move(Ys._createIn(n), $s._createAt(e, "end")), this.remove(Ys._createOn(n)), i;
      }
      insert(t, e) {
        xa(e = tt(e) ? [...e] : [e], this.document);
        const n = e.reduce((t, e) => {
          const n = t[t.length - 1],
            o = !e.is("uiElement");
          return n && n.breakAttributes == o ? n.nodes.push(e) : t.push({
            breakAttributes: o,
            nodes: [e]
          }), t;
        }, []);
        let o = null,
          i = t;
        for (const {
          nodes: t,
          breakAttributes: e
        } of n) {
          const n = this._insertNodes(i, t, e);
          o || (o = n.start), i = n.end;
        }
        return o ? new Ys(o, i) : new Ys(t);
      }
      remove(t) {
        const e = t instanceof Ys ? t : Ys._createOn(t);
        if (Da(e, this.document), e.isCollapsed) return new ka(this.document);
        const {
            start: n,
            end: o
          } = this._breakAttributesRange(e, !0),
          i = n.parent,
          r = o.offset - n.offset,
          s = i._removeChildren(n.offset, r);
        for (const t of s) this._removeFromClonedElementsGroup(t);
        const a = this.mergeAttributes(n);
        return e.start = a, e.end = a.clone(), new ka(this.document, s);
      }
      clear(t, e) {
        Da(t, this.document);
        const n = t.getWalker({
          direction: "backward",
          ignoreElementEnd: !0
        });
        for (const o of n) {
          const n = o.item;
          let i;
          if (n.is("element") && e.isSimilar(n)) i = Ys._createOn(n);else if (!o.nextPosition.isAfter(t.start) && n.is("$textProxy")) {
            const t = n.getAncestors().find(t => t.is("element") && e.isSimilar(t));
            t && (i = Ys._createIn(t));
          }
          i && (i.end.isAfter(t.end) && (i.end = t.end), i.start.isBefore(t.start) && (i.start = t.start), this.remove(i));
        }
      }
      move(t, e) {
        let n;
        if (e.isAfter(t.end)) {
          const o = (e = this._breakAttributes(e, !0)).parent,
            i = o.childCount;
          t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += o.childCount - i;
        } else n = this.remove(t);
        return this.insert(e, n);
      }
      wrap(t, e) {
        if (!(e instanceof aa)) throw new w("view-writer-wrap-invalid-attribute", this.document);
        if (Da(t, this.document), t.isCollapsed) {
          let o = t.start;
          o.parent.is("element") && (n = o.parent, !Array.from(n.getChildren()).some(t => !t.is("uiElement"))) && (o = o.getLastMatchingPosition(t => t.item.is("uiElement"))), o = this._wrapPosition(o, e);
          const i = this.document.selection;
          return i.isCollapsed && i.getFirstPosition().isEqual(t.start) && this.setSelection(o), new Ys(o);
        }
        return this._wrapRange(t, e);
        var n;
      }
      unwrap(t, e) {
        if (!(e instanceof aa)) throw new w("view-writer-unwrap-invalid-attribute", this.document);
        if (Da(t, this.document), t.isCollapsed) return t;
        const {
            start: n,
            end: o
          } = this._breakAttributesRange(t, !0),
          i = n.parent,
          r = this._unwrapChildren(i, n.offset, o.offset, e),
          s = this.mergeAttributes(r.start);
        s.isEqual(r.start) || r.end.offset--;
        const a = this.mergeAttributes(r.end);
        return new Ys(s, a);
      }
      rename(t, e) {
        const n = new Hs(this.document, t, e.getAttributes());
        return this.insert($s._createAfter(e), n), this.move(Ys._createIn(e), $s._createAt(n, 0)), this.remove(Ys._createOn(e)), n;
      }
      clearClonedElementsGroup(t) {
        this._cloneGroups.delete(t);
      }
      createPositionAt(t, e) {
        return $s._createAt(t, e);
      }
      createPositionAfter(t) {
        return $s._createAfter(t);
      }
      createPositionBefore(t) {
        return $s._createBefore(t);
      }
      createRange(t, e) {
        return new Ys(t, e);
      }
      createRangeOn(t) {
        return Ys._createOn(t);
      }
      createRangeIn(t) {
        return Ys._createIn(t);
      }
      createSelection(...t) {
        return new Zs(...t);
      }
      createSlot(t = "children") {
        if (!this._slotFactory) throw new w("view-writer-invalid-create-slot-context", this.document);
        return this._slotFactory(this, t);
      }
      _registerSlotFactory(t) {
        this._slotFactory = t;
      }
      _clearSlotFactory() {
        this._slotFactory = null;
      }
      _insertNodes(t, e, n) {
        let o, i;
        if (o = n ? wa(t) : t.parent.is("$text") ? t.parent.parent : t.parent, !o) throw new w("view-writer-invalid-position-container", this.document);
        i = n ? this._breakAttributes(t, !0) : t.parent.is("$text") ? Ca(t) : t;
        const r = o._insertChild(i.offset, e);
        for (const t of e) this._addToClonedElementsGroup(t);
        const s = i.getShiftedBy(r),
          a = this.mergeAttributes(i);
        a.isEqual(i) || s.offset--;
        const c = this.mergeAttributes(s);
        return new Ys(a, c);
      }
      _wrapChildren(t, e, n, o) {
        let i = e;
        const r = [];
        for (; i < n;) {
          const e = t.getChild(i),
            n = e.is("$text"),
            s = e.is("attributeElement");
          if (s && this._wrapAttributeElement(o, e)) r.push(new $s(t, i));else if (n || !s || Aa(o, e)) {
            const n = o._clone();
            e._remove(), n._appendChild(e), t._insertChild(i, n), this._addToClonedElementsGroup(n), r.push(new $s(t, i));
          } else this._wrapChildren(e, 0, e.childCount, o);
          i++;
        }
        let s = 0;
        for (const t of r) {
          if (t.offset -= s, t.offset == e) continue;
          this.mergeAttributes(t).isEqual(t) || (s++, n--);
        }
        return Ys._createFromParentsAndOffsets(t, e, t, n);
      }
      _unwrapChildren(t, e, n, o) {
        let i = e;
        const r = [];
        for (; i < n;) {
          const e = t.getChild(i);
          if (e.is("attributeElement")) {
            if (e.isSimilar(o)) {
              const o = e.getChildren(),
                s = e.childCount;
              e._remove(), t._insertChild(i, o), this._removeFromClonedElementsGroup(e), r.push(new $s(t, i), new $s(t, i + s)), i += s, n += s - 1;
            } else this._unwrapAttributeElement(o, e) ? (r.push(new $s(t, i), new $s(t, i + 1)), i++) : (this._unwrapChildren(e, 0, e.childCount, o), i++);
          } else i++;
        }
        let s = 0;
        for (const t of r) {
          if (t.offset -= s, t.offset == e || t.offset == n) continue;
          this.mergeAttributes(t).isEqual(t) || (s++, n--);
        }
        return Ys._createFromParentsAndOffsets(t, e, t, n);
      }
      _wrapRange(t, e) {
        const {
            start: n,
            end: o
          } = this._breakAttributesRange(t, !0),
          i = n.parent,
          r = this._wrapChildren(i, n.offset, o.offset, e),
          s = this.mergeAttributes(r.start);
        s.isEqual(r.start) || r.end.offset--;
        const a = this.mergeAttributes(r.end);
        return new Ys(s, a);
      }
      _wrapPosition(t, e) {
        if (e.isSimilar(t.parent)) return _a(t.clone());
        t.parent.is("$text") && (t = Ca(t));
        const n = this.createAttributeElement("_wrapPosition-fake-element");
        n._priority = Number.POSITIVE_INFINITY, n.isSimilar = () => !1, t.parent._insertChild(t.offset, n);
        const o = new Ys(t, t.getShiftedBy(1));
        this.wrap(o, e);
        const i = new $s(n.parent, n.index);
        n._remove();
        const r = i.nodeBefore,
          s = i.nodeAfter;
        return r instanceof is && s instanceof is ? va(r, s) : _a(i);
      }
      _wrapAttributeElement(t, e) {
        if (!Ia(t, e)) return !1;
        if (t.name !== e.name || t.priority !== e.priority) return !1;
        for (const n of t.getAttributeKeys()) if ("class" !== n && "style" !== n && e.hasAttribute(n) && e.getAttribute(n) !== t.getAttribute(n)) return !1;
        for (const n of t.getStyleNames()) if (e.hasStyle(n) && e.getStyle(n) !== t.getStyle(n)) return !1;
        for (const n of t.getAttributeKeys()) "class" !== n && "style" !== n && (e.hasAttribute(n) || this.setAttribute(n, t.getAttribute(n), e));
        for (const n of t.getStyleNames()) e.hasStyle(n) || this.setStyle(n, t.getStyle(n), e);
        for (const n of t.getClassNames()) e.hasClass(n) || this.addClass(n, e);
        return !0;
      }
      _unwrapAttributeElement(t, e) {
        if (!Ia(t, e)) return !1;
        if (t.name !== e.name || t.priority !== e.priority) return !1;
        for (const n of t.getAttributeKeys()) if ("class" !== n && "style" !== n && (!e.hasAttribute(n) || e.getAttribute(n) !== t.getAttribute(n))) return !1;
        if (!e.hasClass(...t.getClassNames())) return !1;
        for (const n of t.getStyleNames()) if (!e.hasStyle(n) || e.getStyle(n) !== t.getStyle(n)) return !1;
        for (const n of t.getAttributeKeys()) "class" !== n && "style" !== n && this.removeAttribute(n, e);
        return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
      }
      _breakAttributesRange(t, e = !1) {
        const n = t.start,
          o = t.end;
        if (Da(t, this.document), t.isCollapsed) {
          const n = this._breakAttributes(t.start, e);
          return new Ys(n, n);
        }
        const i = this._breakAttributes(o, e),
          r = i.parent.childCount,
          s = this._breakAttributes(n, e);
        return i.offset += i.parent.childCount - r, new Ys(s, i);
      }
      _breakAttributes(t, e = !1) {
        const n = t.offset,
          o = t.parent;
        if (t.parent.is("emptyElement")) throw new w("view-writer-cannot-break-empty-element", this.document);
        if (t.parent.is("uiElement")) throw new w("view-writer-cannot-break-ui-element", this.document);
        if (t.parent.is("rawElement")) throw new w("view-writer-cannot-break-raw-element", this.document);
        if (!e && o.is("$text") && Ea(o.parent)) return t.clone();
        if (Ea(o)) return t.clone();
        if (o.is("$text")) return this._breakAttributes(Ca(t), e);
        if (n == o.childCount) {
          const t = new $s(o.parent, o.index + 1);
          return this._breakAttributes(t, e);
        }
        if (0 === n) {
          const t = new $s(o.parent, o.index);
          return this._breakAttributes(t, e);
        }
        {
          const t = o.index + 1,
            i = o._clone();
          o.parent._insertChild(t, i), this._addToClonedElementsGroup(i);
          const r = o.childCount - n,
            s = o._removeChildren(n, r);
          i._appendChild(s);
          const a = new $s(o.parent, t);
          return this._breakAttributes(a, e);
        }
      }
      _addToClonedElementsGroup(t) {
        if (!t.root.is("rootElement")) return;
        if (t.is("element")) for (const e of t.getChildren()) this._addToClonedElementsGroup(e);
        const e = t.id;
        if (!e) return;
        let n = this._cloneGroups.get(e);
        n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
      }
      _removeFromClonedElementsGroup(t) {
        if (t.is("element")) for (const e of t.getChildren()) this._removeFromClonedElementsGroup(e);
        const e = t.id;
        if (!e) return;
        const n = this._cloneGroups.get(e);
        n && n.delete(t);
      }
    }
    function wa(t) {
      let e = t.parent;
      for (; !Ea(e);) {
        if (!e) return;
        e = e.parent;
      }
      return e;
    }
    function Aa(t, e) {
      return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
    }
    function _a(t) {
      const e = t.nodeBefore;
      if (e && e.is("$text")) return new $s(e, e.data.length);
      const n = t.nodeAfter;
      return n && n.is("$text") ? new $s(n, 0) : t;
    }
    function Ca(t) {
      if (t.offset == t.parent.data.length) return new $s(t.parent.parent, t.parent.index + 1);
      if (0 === t.offset) return new $s(t.parent.parent, t.parent.index);
      const e = t.parent.data.slice(t.offset);
      return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new is(t.root.document, e)), new $s(t.parent.parent, t.parent.index + 1);
    }
    function va(t, e) {
      const n = t.data.length;
      return t._data += e.data, e._remove(), new $s(t, n);
    }
    const ya = [is, aa, Hs, da, pa, ha];
    function xa(t, e) {
      for (const n of t) {
        if (!ya.some(t => n instanceof t)) throw new w("view-writer-insert-invalid-node-type", e);
        n.is("$text") || xa(n.getChildren(), e);
      }
    }
    function Ea(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }
    function Da(t, e) {
      const n = wa(t.start),
        o = wa(t.end);
      if (!n || !o || n !== o) throw new w("view-writer-invalid-range-container", e);
    }
    function Ia(t, e) {
      return null === t.id && null === e.id;
    }
    const Ta = t => t.createTextNode(" "),
      Ma = t => {
        const e = t.createElement("span");
        return e.dataset.ckeFiller = "true", e.innerText = " ", e;
      },
      Sa = t => {
        const e = t.createElement("br");
        return e.dataset.ckeFiller = "true", e;
      },
      Ba = 7,
      Na = "⁠".repeat(Ba);
    function Pa(t) {
      return "string" == typeof t ? t.substr(0, Ba) === Na : Po(t) && t.data.substr(0, Ba) === Na;
    }
    function Oa(t) {
      return t.data.length == Ba && Pa(t);
    }
    function La(t) {
      const e = "string" == typeof t ? t : t.data;
      return Pa(t) ? e.slice(Ba) : e;
    }
    function za(t, e) {
      if (e.keyCode == mi.arrowleft) {
        const t = e.domTarget.ownerDocument.defaultView.getSelection();
        if (1 == t.rangeCount && t.getRangeAt(0).collapsed) {
          const e = t.getRangeAt(0).startContainer,
            n = t.getRangeAt(0).startOffset;
          Pa(e) && n <= Ba && t.collapse(e, 0);
        }
      }
    }
    var Ra = n(8264),
      ja = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ra.A, ja);
    Ra.A.locals;
    class Fa extends G() {
      constructor(t, e) {
        super(), this.domDocuments = new Set(), this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this._inlineFiller = null, this._fakeSelectionContainer = null, this.domConverter = t, this.selection = e, this.set("isFocused", !1), this.set("isSelecting", !1), s.isBlink && !s.isAndroid && this.on("change:isSelecting", () => {
          this.isSelecting || this.render();
        }), this.set("isComposing", !1), this.on("change:isComposing", () => {
          this.isComposing || this.render();
        });
      }
      markToSync(t, e) {
        if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
          if (!this.domConverter.mapViewToDom(e)) return;
          if ("attributes" === t) this.markedAttributes.add(e);else {
            if ("children" !== t) {
              throw new w("view-renderer-unknown-type", this);
            }
            this.markedChildren.add(e);
          }
        }
      }
      render() {
        if (this.isComposing && !s.isAndroid) return;
        let t = null;
        const e = !(s.isBlink && !s.isAndroid) || !this.isSelecting;
        for (const t of this.markedChildren) this._updateChildrenMappings(t);
        e ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (t = this.domConverter.domPositionToView(this._inlineFiller), t && t.parent.is("$text") && (t = $s._createBefore(t.parent)));
        for (const t of this.markedAttributes) this._updateAttrs(t);
        for (const e of this.markedChildren) this._updateChildren(e, {
          inlineFillerPosition: t
        });
        for (const e of this.markedTexts) !this.markedChildren.has(e.parent) && this.domConverter.mapViewToDom(e.parent) && this._updateText(e, {
          inlineFillerPosition: t
        });
        if (e) if (t) {
          const e = this.domConverter.viewPositionToDom(t),
            n = e.parent.ownerDocument;
          Pa(e.parent) ? this._inlineFiller = e.parent : this._inlineFiller = Va(n, e.parent, e.offset);
        } else this._inlineFiller = null;
        this._updateFocus(), this._updateSelection(), this.domConverter._clearTemporaryCustomProperties(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
      }
      _updateChildrenMappings(t) {
        const e = this.domConverter.mapViewToDom(t);
        if (!e) return;
        const n = Array.from(e.childNodes),
          o = Array.from(this.domConverter.viewChildrenToDom(t, {
            withChildren: !1
          })),
          i = this._diffNodeLists(n, o),
          r = this._findUpdateActions(i, n, o, Ha);
        if (-1 !== r.indexOf("update")) {
          const e = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          for (const i of r) if ("update" === i) {
            const i = e.equal + e.insert,
              r = e.equal + e.delete,
              s = t.getChild(i);
            !s || s.is("uiElement") || s.is("rawElement") || this._updateElementMappings(s, n[r]), ei(o[i]), e.equal++;
          } else e[i]++;
        }
      }
      _updateElementMappings(t, e) {
        this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
      }
      _getInlineFillerPosition() {
        const t = this.selection.getFirstPosition();
        return t.parent.is("$text") ? $s._createBefore(t.parent) : t;
      }
      _isSelectionInInlineFiller() {
        if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
        const t = this.selection.getFirstPosition(),
          e = this.domConverter.viewPositionToDom(t);
        return !!(e && Po(e.parent) && Pa(e.parent));
      }
      _removeInlineFiller() {
        const t = this._inlineFiller;
        if (!Pa(t)) throw new w("view-renderer-filler-was-lost", this);
        Oa(t) ? t.remove() : t.data = t.data.substr(Ba), this._inlineFiller = null;
      }
      _needsInlineFillerAtSelection() {
        if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
        const t = this.selection.getFirstPosition(),
          e = t.parent,
          n = t.offset;
        if (!this.domConverter.mapViewToDom(e.root)) return !1;
        if (!e.is("element")) return !1;
        if (!function (t) {
          if ("false" == t.getAttribute("contenteditable")) return !1;
          const e = t.findAncestor(t => t.hasAttribute("contenteditable"));
          return !e || "true" == e.getAttribute("contenteditable");
        }(e)) return !1;
        const o = t.nodeBefore,
          i = t.nodeAfter;
        return !(o instanceof is || i instanceof is) && !!(n !== e.getFillerOffset() || o && o.is("element", "br")) && (!s.isAndroid || !o && !i);
      }
      _updateText(t, e) {
        const n = this.domConverter.findCorrespondingDomText(t);
        let o = this.domConverter.viewToDom(t).data;
        const i = e.inlineFillerPosition;
        i && i.parent == t.parent && i.offset == t.index && (o = Na + o), Ga(n, o);
      }
      _updateAttrs(t) {
        const e = this.domConverter.mapViewToDom(t);
        if (!e) return;
        const n = Array.from(e.attributes).map(t => t.name),
          o = t.getAttributeKeys();
        for (const n of o) this.domConverter.setDomElementAttribute(e, n, t.getAttribute(n), t);
        for (const o of n) t.hasAttribute(o) || this.domConverter.removeDomElementAttribute(e, o);
      }
      _updateChildren(t, e) {
        const n = this.domConverter.mapViewToDom(t);
        if (!n) return;
        if (s.isAndroid) {
          let t = null;
          for (const e of Array.from(n.childNodes)) {
            if (t && Po(t) && Po(e)) {
              n.normalize();
              break;
            }
            t = e;
          }
        }
        const o = e.inlineFillerPosition,
          i = n.childNodes,
          r = Array.from(this.domConverter.viewChildrenToDom(t, {
            bind: !0
          }));
        o && o.parent === t && Va(n.ownerDocument, r, o.offset);
        const a = this._diffNodeLists(i, r),
          c = this._findUpdateActions(a, i, r, Ua);
        let l = 0;
        const d = new Set();
        for (const t of c) "delete" === t ? (d.add(i[l]), ei(i[l])) : "equal" !== t && "update" !== t || l++;
        l = 0;
        for (const t of c) "insert" === t ? ($o(n, l, r[l]), l++) : "update" === t ? (Ga(i[l], r[l].data), l++) : "equal" === t && (this._markDescendantTextToSync(this.domConverter.domToView(r[l])), l++);
        for (const t of d) t.parentNode || this.domConverter.unbindDomElement(t);
      }
      _diffNodeLists(t, e) {
        return t = function (t, e) {
          const n = Array.from(t);
          if (0 == n.length || !e) return n;
          const o = n[n.length - 1];
          o == e && n.pop();
          return n;
        }(t, this._fakeSelectionContainer), u(t, e, qa.bind(null, this.domConverter));
      }
      _findUpdateActions(t, e, n, o) {
        if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
        let i = [],
          r = [],
          s = [];
        const a = {
          equal: 0,
          insert: 0,
          delete: 0
        };
        for (const c of t) "insert" === c ? s.push(n[a.equal + a.insert]) : "delete" === c ? r.push(e[a.equal + a.delete]) : (i = i.concat(u(r, s, o).map(t => "equal" === t ? "update" : t)), i.push("equal"), r = [], s = []), a[c]++;
        return i.concat(u(r, s, o).map(t => "equal" === t ? "update" : t));
      }
      _markDescendantTextToSync(t) {
        if (t) if (t.is("$text")) this.markedTexts.add(t);else if (t.is("element")) for (const e of t.getChildren()) this._markDescendantTextToSync(e);
      }
      _updateSelection() {
        if (s.isBlink && !s.isAndroid && this.isSelecting && !this.markedChildren.size) return;
        if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
        const t = this.domConverter.mapViewToDom(this.selection.editableElement);
        this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(t)) : this.isComposing && s.isAndroid || this._updateDomSelection(t));
      }
      _updateFakeSelection(t) {
        const e = t.ownerDocument;
        this._fakeSelectionContainer || (this._fakeSelectionContainer = function (t) {
          const e = t.createElement("div");
          return e.className = "ck-fake-selection-container", Object.assign(e.style, {
            position: "fixed",
            top: 0,
            left: "-9999px",
            width: "42px"
          }), e.textContent = " ", e;
        }(e));
        const n = this._fakeSelectionContainer;
        if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(t)) return;
        n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
        const o = e.getSelection(),
          i = e.createRange();
        o.removeAllRanges(), i.selectNodeContents(n), o.addRange(i);
      }
      _updateDomSelection(t) {
        const e = t.ownerDocument.defaultView.getSelection();
        if (!this._domSelectionNeedsUpdate(e)) return;
        const n = this.domConverter.viewPositionToDom(this.selection.anchor),
          o = this.domConverter.viewPositionToDom(this.selection.focus);
        e.setBaseAndExtent(n.parent, n.offset, o.parent, o.offset), s.isGecko && function (t, e) {
          let n = t.parent,
            o = t.offset;
          Po(n) && Oa(n) && (o = Ko(n) + 1, n = n.parentNode);
          if (n.nodeType != Node.ELEMENT_NODE || o != n.childNodes.length - 1) return;
          const i = n.childNodes[o];
          i && "BR" == i.tagName && e.addRange(e.getRangeAt(0));
        }(o, e);
      }
      _domSelectionNeedsUpdate(t) {
        if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
        const e = t && this.domConverter.domSelectionToView(t);
        return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
      }
      _fakeSelectionNeedsUpdate(t) {
        const e = this._fakeSelectionContainer,
          n = t.ownerDocument.getSelection();
        return !e || e.parentElement !== t || n.anchorNode !== e && !e.contains(n.anchorNode) || e.textContent !== this.selection.fakeSelectionLabel;
      }
      _removeDomSelection() {
        for (const t of this.domDocuments) {
          const e = t.getSelection();
          if (e.rangeCount) {
            const n = t.activeElement,
              o = this.domConverter.mapDomToView(n);
            n && o && e.removeAllRanges();
          }
        }
      }
      _removeFakeSelection() {
        const t = this._fakeSelectionContainer;
        t && t.remove();
      }
      _updateFocus() {
        if (this.isFocused) {
          const t = this.selection.editableElement;
          t && this.domConverter.focus(t);
        }
      }
    }
    function Va(t, e, n) {
      const o = e instanceof Array ? e : e.childNodes,
        i = o[n];
      if (Po(i)) return i.data = Na + i.data, i;
      {
        const i = t.createTextNode(Na);
        return Array.isArray(e) ? o.splice(n, 0, i) : $o(e, n, i), i;
      }
    }
    function Ha(t, e) {
      return Do(t) && Do(e) && !Po(t) && !Po(e) && !Yo(t) && !Yo(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }
    function Ua(t, e) {
      return Do(t) && Do(e) && Po(t) && Po(e);
    }
    function qa(t, e, n) {
      return e === n || (Po(e) && Po(n) ? e.data === n.data : !(!t.isBlockFiller(e) || !t.isBlockFiller(n)));
    }
    function Ga(t, e) {
      const n = t.data;
      if (n == e) return;
      const o = c(n, e);
      for (const e of o) "insert" === e.type ? t.insertData(e.index, e.values.join("")) : t.deleteData(e.index, e.howMany);
    }
    const Wa = Sa(e.document),
      Ka = Ta(e.document),
      $a = Ma(e.document),
      Ya = "data-ck-unsafe-attribute-",
      Qa = "data-ck-unsafe-element";
    class Za {
      constructor(t, {
        blockFillerMode: n,
        renderingMode: o = "editing"
      } = {}) {
        this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new ss(), this._inlineObjectElementMatcher = new ss(), this._elementsWithTemporaryCustomProperties = new Set(), this.document = t, this.renderingMode = o, this.blockFillerMode = n || ("editing" === o ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this.unsafeElements = ["script", "style"], this._domDocument = "editing" === this.renderingMode ? e.document : e.document.implementation.createHTMLDocument("");
      }
      bindFakeSelection(t, e) {
        this._fakeSelectionMapping.set(t, new Zs(e));
      }
      fakeSelectionToView(t) {
        return this._fakeSelectionMapping.get(t);
      }
      bindElements(t, e) {
        this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
      }
      unbindDomElement(t) {
        const e = this._domToViewMapping.get(t);
        if (e) {
          this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);
          for (const e of Array.from(t.children)) this.unbindDomElement(e);
        }
      }
      bindDocumentFragments(t, e) {
        this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
      }
      shouldRenderAttribute(t, e, n) {
        return "data" === this.renderingMode || !(t = t.toLowerCase()).startsWith("on") && ("srcdoc" !== t || !e.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && ("img" === n && ("src" === t || "srcset" === t) || "source" === n && "srcset" === t || !e.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
      }
      setContentOf(t, e) {
        if ("data" === this.renderingMode) return void (t.innerHTML = e);
        const n = new DOMParser().parseFromString(e, "text/html"),
          o = n.createDocumentFragment(),
          i = n.body.childNodes;
        for (; i.length > 0;) o.appendChild(i[0]);
        const r = n.createTreeWalker(o, NodeFilter.SHOW_ELEMENT),
          s = [];
        let a;
        for (; a = r.nextNode();) s.push(a);
        for (const t of s) {
          for (const e of t.getAttributeNames()) this.setDomElementAttribute(t, e, t.getAttribute(e));
          const e = t.tagName.toLowerCase();
          this._shouldRenameElement(e) && (ec(e), t.replaceWith(this._createReplacementDomElement(e, t)));
        }
        for (; t.firstChild;) t.firstChild.remove();
        t.append(o);
      }
      viewToDom(t, e = {}) {
        if (t.is("$text")) {
          const e = this._processDataFromViewText(t);
          return this._domDocument.createTextNode(e);
        }
        {
          const n = t;
          if (this.mapViewToDom(n)) {
            if (!n.getCustomProperty("editingPipeline:doNotReuseOnce")) return this.mapViewToDom(n);
            this._elementsWithTemporaryCustomProperties.add(n);
          }
          let o;
          if (n.is("documentFragment")) o = this._domDocument.createDocumentFragment(), e.bind && this.bindDocumentFragments(o, n);else {
            if (n.is("uiElement")) return o = "$comment" === n.name ? this._domDocument.createComment(n.getCustomProperty("$rawContent")) : n.render(this._domDocument, this), e.bind && this.bindElements(o, n), o;
            this._shouldRenameElement(n.name) ? (ec(n.name), o = this._createReplacementDomElement(n.name)) : o = n.hasAttribute("xmlns") ? this._domDocument.createElementNS(n.getAttribute("xmlns"), n.name) : this._domDocument.createElement(n.name), n.is("rawElement") && n.render(o, this), e.bind && this.bindElements(o, n);
            for (const t of n.getAttributeKeys()) this.setDomElementAttribute(o, t, n.getAttribute(t), n);
          }
          if (!1 !== e.withChildren) for (const t of this.viewChildrenToDom(n, e)) o instanceof HTMLTemplateElement ? o.content.appendChild(t) : o.appendChild(t);
          return o;
        }
      }
      setDomElementAttribute(t, n, o, i) {
        const r = this.shouldRenderAttribute(n, o, t.tagName.toLowerCase()) || i && i.shouldRenderUnsafeAttribute(n);
        r || A("domconverter-unsafe-attribute-detected", {
          domElement: t,
          key: n,
          value: o
        }), function (t) {
          try {
            e.document.createAttribute(t);
          } catch (t) {
            return !1;
          }
          return !0;
        }(n) ? (t.hasAttribute(n) && !r ? t.removeAttribute(n) : t.hasAttribute(Ya + n) && r && t.removeAttribute(Ya + n), t.setAttribute(r ? n : Ya + n, o)) : A("domconverter-invalid-attribute-detected", {
          domElement: t,
          key: n,
          value: o
        });
      }
      removeDomElementAttribute(t, e) {
        e != Qa && (t.removeAttribute(e), t.removeAttribute(Ya + e));
      }
      *viewChildrenToDom(t, e = {}) {
        const n = t.getFillerOffset && t.getFillerOffset();
        let o = 0;
        for (const i of t.getChildren()) {
          n === o && (yield this._getBlockFiller());
          const t = i.is("element") && !!i.getCustomProperty("dataPipeline:transparentRendering") && !Wi(i.getAttributes());
          t && "data" == this.renderingMode ? yield* this.viewChildrenToDom(i, e) : (t && A("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
            viewElement: i
          }), yield this.viewToDom(i, e)), o++;
        }
        n === o && (yield this._getBlockFiller());
      }
      viewRangeToDom(t) {
        const e = this.viewPositionToDom(t.start),
          n = this.viewPositionToDom(t.end),
          o = this._domDocument.createRange();
        return o.setStart(e.parent, e.offset), o.setEnd(n.parent, n.offset), o;
      }
      viewPositionToDom(t) {
        const e = t.parent;
        if (e.is("$text")) {
          const n = this.findCorrespondingDomText(e);
          if (!n) return null;
          let o = t.offset;
          return Pa(n) && (o += Ba), {
            parent: n,
            offset: o
          };
        }
        {
          let n, o, i;
          if (0 === t.offset) {
            if (n = this.mapViewToDom(e), !n) return null;
            i = n.childNodes[0];
          } else {
            const e = t.nodeBefore;
            if (o = e.is("$text") ? this.findCorrespondingDomText(e) : this.mapViewToDom(e), !o) return null;
            n = o.parentNode, i = o.nextSibling;
          }
          if (Po(i) && Pa(i)) return {
            parent: i,
            offset: Ba
          };
          return {
            parent: n,
            offset: o ? Ko(o) + 1 : 0
          };
        }
      }
      domToView(t, e = {}) {
        const n = [],
          o = this._domToView(t, e, n),
          i = o.next().value;
        return i ? (o.next(), this._processDomInlineNodes(null, n, e), i.is("$text") && 0 == i.data.length ? null : i) : null;
      }
      *domChildrenToView(t, e = {}, n = []) {
        let o = [];
        o = t instanceof HTMLTemplateElement ? [...t.content.childNodes] : [...t.childNodes];
        for (let i = 0; i < o.length; i++) {
          const r = o[i],
            s = this._domToView(r, e, n),
            a = s.next().value;
          null !== a && (this._isBlockViewElement(a) && this._processDomInlineNodes(t, n, e), yield a, s.next());
        }
        this._processDomInlineNodes(t, n, e);
      }
      domSelectionToView(t) {
        if (function (t) {
          if (!s.isGecko) return !1;
          if (!t.rangeCount) return !1;
          const e = t.getRangeAt(0).startContainer;
          try {
            Object.prototype.toString.call(e);
          } catch (t) {
            return !0;
          }
          return !1;
        }(t)) return new Zs([]);
        if (1 === t.rangeCount) {
          let e = t.getRangeAt(0).startContainer;
          Po(e) && (e = e.parentNode);
          const n = this.fakeSelectionToView(e);
          if (n) return n;
        }
        const e = this.isDomSelectionBackward(t),
          n = [];
        for (let e = 0; e < t.rangeCount; e++) {
          const o = t.getRangeAt(e),
            i = this.domRangeToView(o);
          i && n.push(i);
        }
        return new Zs(n, {
          backward: e
        });
      }
      domRangeToView(t) {
        const e = this.domPositionToView(t.startContainer, t.startOffset),
          n = this.domPositionToView(t.endContainer, t.endOffset);
        return e && n ? new Ys(e, n) : null;
      }
      domPositionToView(t, e = 0) {
        if (this.isBlockFiller(t)) return this.domPositionToView(t.parentNode, Ko(t));
        const n = this.mapDomToView(t);
        if (n && (n.is("uiElement") || n.is("rawElement"))) return $s._createBefore(n);
        if (Po(t)) {
          if (Oa(t)) return this.domPositionToView(t.parentNode, Ko(t));
          const n = this.findCorrespondingViewText(t);
          let o = e;
          return n ? (Pa(t) && (o -= Ba, o = o < 0 ? 0 : o), new $s(n, o)) : null;
        }
        if (0 === e) {
          const e = this.mapDomToView(t);
          if (e) return new $s(e, 0);
        } else {
          const n = t.childNodes[e - 1];
          if (Po(n) && Oa(n) || n && this.isBlockFiller(n)) return this.domPositionToView(n.parentNode, Ko(n));
          const o = Po(n) ? this.findCorrespondingViewText(n) : this.mapDomToView(n);
          if (o && o.parent) return new $s(o.parent, o.index + 1);
        }
        return null;
      }
      mapDomToView(t) {
        return this.getHostViewElement(t) || this._domToViewMapping.get(t);
      }
      findCorrespondingViewText(t) {
        if (Oa(t)) return null;
        const e = this.getHostViewElement(t);
        if (e) return e;
        const n = t.previousSibling;
        if (n) {
          if (!this.isElement(n)) return null;
          const t = this.mapDomToView(n);
          if (t) {
            const e = t.nextSibling;
            return e instanceof is ? e : null;
          }
        } else {
          const e = this.mapDomToView(t.parentNode);
          if (e) {
            const t = e.getChild(0);
            return t instanceof is ? t : null;
          }
        }
        return null;
      }
      mapViewToDom(t) {
        return this._viewToDomMapping.get(t);
      }
      findCorrespondingDomText(t) {
        const e = t.previousSibling;
        return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
      }
      focus(t) {
        const n = this.mapViewToDom(t);
        if (n && n.ownerDocument.activeElement !== n) {
          const {
              scrollX: t,
              scrollY: o
            } = e.window,
            i = [];
          Xa(n, t => {
            const {
              scrollLeft: e,
              scrollTop: n
            } = t;
            i.push([e, n]);
          }), n.focus(), Xa(n, t => {
            const [e, n] = i.shift();
            t.scrollLeft = e, t.scrollTop = n;
          }), e.window.scrollTo(t, o);
        }
      }
      _clearDomSelection() {
        const t = this.mapViewToDom(this.document.selection.editableElement);
        if (!t) return;
        const e = t.ownerDocument.defaultView.getSelection(),
          n = this.domSelectionToView(e);
        n && n.rangeCount > 0 && e.removeAllRanges();
      }
      isElement(t) {
        return t && t.nodeType == Node.ELEMENT_NODE;
      }
      isDocumentFragment(t) {
        return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
      }
      isBlockFiller(t) {
        return "br" == this.blockFillerMode ? t.isEqualNode(Wa) : !("BR" !== t.tagName || !tc(t, this.blockElements) || 1 !== t.parentNode.childNodes.length) || t.isEqualNode($a) || function (t, e) {
          const n = t.isEqualNode(Ka);
          return n && tc(t, e) && 1 === t.parentNode.childNodes.length;
        }(t, this.blockElements);
      }
      isDomSelectionBackward(t) {
        if (t.isCollapsed) return !1;
        const e = this._domDocument.createRange();
        try {
          e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
        } catch (t) {
          return !1;
        }
        const n = e.collapsed;
        return e.detach(), n;
      }
      getHostViewElement(t) {
        const e = function (t) {
          const e = [];
          let n = t;
          for (; n && n.nodeType != Node.DOCUMENT_NODE;) e.unshift(n), n = n.parentNode;
          return e;
        }(t);
        for (e.pop(); e.length;) {
          const t = e.pop(),
            n = this._domToViewMapping.get(t);
          if (n && (n.is("uiElement") || n.is("rawElement"))) return n;
        }
        return null;
      }
      isDomSelectionCorrect(t) {
        return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
      }
      registerRawContentMatcher(t) {
        this._rawContentElementMatcher.add(t);
      }
      registerInlineObjectMatcher(t) {
        this._inlineObjectElementMatcher.add(t);
      }
      _clearTemporaryCustomProperties() {
        for (const t of this._elementsWithTemporaryCustomProperties) t._removeCustomProperty("editingPipeline:doNotReuseOnce");
        this._elementsWithTemporaryCustomProperties.clear();
      }
      _getBlockFiller() {
        switch (this.blockFillerMode) {
          case "nbsp":
            return Ta(this._domDocument);
          case "markedNbsp":
            return Ma(this._domDocument);
          case "br":
            return Sa(this._domDocument);
        }
      }
      _isDomSelectionPositionCorrect(t, e) {
        if (Po(t) && Pa(t) && e < Ba) return !1;
        if (this.isElement(t) && Pa(t.childNodes[e])) return !1;
        const n = this.mapDomToView(t);
        return !n || !n.is("uiElement") && !n.is("rawElement");
      }
      *_domToView(t, e, n) {
        if (this.isBlockFiller(t)) return null;
        const o = this.getHostViewElement(t);
        if (o) return o;
        if (Yo(t) && e.skipComments) return null;
        if (Po(t)) {
          if (Oa(t)) return null;
          {
            const e = t.data;
            if ("" === e) return null;
            const o = new is(this.document, e);
            return n.push(o), o;
          }
        }
        {
          let o = this.mapDomToView(t);
          if (o) return this._isInlineObjectElement(o) && n.push(o), o;
          if (this.isDocumentFragment(t)) o = new ka(this.document), e.bind && this.bindDocumentFragments(t, o);else {
            o = this._createViewElement(t, e), e.bind && this.bindElements(t, o);
            const i = t.attributes;
            if (i) for (let t = i.length, e = 0; e < t; e++) o._setAttribute(i[e].name, i[e].value);
            if (this._isViewElementWithRawContent(o, e)) return o._setCustomProperty("$rawContent", t.innerHTML), this._isBlockViewElement(o) || n.push(o), o;
            if (Yo(t)) return o._setCustomProperty("$rawContent", t.data), o;
          }
          yield o;
          const i = [];
          if (!1 !== e.withChildren) for (const n of this.domChildrenToView(t, e, i)) o._appendChild(n);
          if (this._isInlineObjectElement(o)) n.push(o);else for (const t of i) n.push(t);
        }
      }
      _processDomInlineNodes(t, e, n) {
        if (!e.length) return;
        if (t && !this.isDocumentFragment(t) && !this._isBlockDomElement(t)) return;
        let o = !1;
        for (let t = 0; t < e.length; t++) {
          const i = e[t];
          if (!i.is("$text")) {
            o = !1;
            continue;
          }
          let r,
            s = !1;
          if (Ja(i, this.preElements)) r = La(i.data);else {
            r = i.data.replace(/[ \n\t\r]{1,}/g, " "), s = /[^\S\u00A0]/.test(r.charAt(r.length - 1));
            const a = t > 0 ? e[t - 1] : null,
              c = t + 1 < e.length ? e[t + 1] : null,
              l = !a || a.is("element") && "br" == a.name || o,
              d = !c && !Pa(i.data);
            !1 !== n.withChildren && (l && (r = r.replace(/^ /, "")), d && (r = r.replace(/ $/, ""))), r = La(r), r = r.replace(/ \u00A0/g, "  ");
            const u = c && c.is("element") && "br" != c.name,
              h = c && c.is("$text") && " " == c.data.charAt(0);
            (/[ \u00A0]\u00A0$/.test(r) || !c || u || h) && (r = r.replace(/\u00A0$/, " ")), (l || a && a.is("element") && "br" != a.name) && (r = r.replace(/^\u00A0/, " "));
          }
          0 == r.length && i.parent ? (i._remove(), e.splice(t, 1), t--) : (i._data = r, o = s);
        }
        e.length = 0;
      }
      _processDataFromViewText(t) {
        let e = t.data;
        if (t.getAncestors().some(t => this.preElements.includes(t.name))) return e;
        if (" " == e.charAt(0)) {
          const n = this._getTouchingInlineViewNode(t, !1);
          !(n && n.is("$textProxy") && this._nodeEndsWithSpace(n)) && n || (e = " " + e.substr(1));
        }
        if (" " == e.charAt(e.length - 1)) {
          const n = this._getTouchingInlineViewNode(t, !0),
            o = n && n.is("$textProxy") && " " == n.data.charAt(0);
          " " != e.charAt(e.length - 2) && n && !o || (e = e.substr(0, e.length - 1) + " ");
        }
        return e.replace(/ {2}/g, "  ");
      }
      _nodeEndsWithSpace(t) {
        if (t.getAncestors().some(t => this.preElements.includes(t.name))) return !1;
        const e = this._processDataFromViewText(t);
        return " " == e.charAt(e.length - 1);
      }
      _getTouchingInlineViewNode(t, e) {
        const n = new Ks({
          startPosition: e ? $s._createAfter(t) : $s._createBefore(t),
          direction: e ? "forward" : "backward"
        });
        for (const t of n) {
          if (t.item.is("element", "br")) return null;
          if (this._isInlineObjectElement(t.item)) return t.item;
          if (t.item.is("containerElement")) return null;
          if (t.item.is("$textProxy")) return t.item;
        }
        return null;
      }
      _isBlockDomElement(t) {
        return this.isElement(t) && this.blockElements.includes(t.tagName.toLowerCase());
      }
      _isBlockViewElement(t) {
        return t.is("element") && this.blockElements.includes(t.name);
      }
      _isInlineObjectElement(t) {
        return !!t.is("element") && ("br" == t.name || this.inlineObjectElements.includes(t.name) || !!this._inlineObjectElementMatcher.match(t));
      }
      _createViewElement(t, e) {
        if (Yo(t)) return new ha(this.document, "$comment");
        const n = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
        return new Fs(this.document, n);
      }
      _isViewElementWithRawContent(t, e) {
        return !1 !== e.withChildren && t.is("element") && !!this._rawContentElementMatcher.match(t);
      }
      _shouldRenameElement(t) {
        const e = t.toLowerCase();
        return "editing" === this.renderingMode && this.unsafeElements.includes(e);
      }
      _createReplacementDomElement(t, e) {
        const n = this._domDocument.createElement("span");
        if (n.setAttribute(Qa, t), e) {
          for (; e.firstChild;) n.appendChild(e.firstChild);
          for (const t of e.getAttributeNames()) n.setAttribute(t, e.getAttribute(t));
        }
        return n;
      }
    }
    function Ja(t, e) {
      return t.getAncestors().some(t => t.is("element") && e.includes(t.name));
    }
    function Xa(t, e) {
      let n = t;
      for (; n;) e(n), n = n.parentElement;
    }
    function tc(t, e) {
      const n = t.parentNode;
      return !!n && !!n.tagName && e.includes(n.tagName.toLowerCase());
    }
    function ec(t) {
      "script" === t && A("domconverter-unsafe-script-element-detected"), "style" === t && A("domconverter-unsafe-style-element-detected");
    }
    class nc extends Mo() {
      constructor(t) {
        super(), this._isEnabled = !1, this.view = t, this.document = t.document;
      }
      get isEnabled() {
        return this._isEnabled;
      }
      enable() {
        this._isEnabled = !0;
      }
      disable() {
        this._isEnabled = !1;
      }
      destroy() {
        this.disable(), this.stopListening();
      }
      checkShouldIgnoreEventFromTarget(t) {
        return t && 3 === t.nodeType && (t = t.parentNode), !(!t || 1 !== t.nodeType) && t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
      }
    }
    const oc = ji(function (t, e) {
      Te(e, gn(e), t);
    });
    class ic {
      constructor(t, e, n) {
        this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, oc(this, n);
      }
      get target() {
        return this.view.domConverter.mapDomToView(this.domTarget);
      }
      preventDefault() {
        this.domEvent.preventDefault();
      }
      stopPropagation() {
        this.domEvent.stopPropagation();
      }
    }
    class rc extends nc {
      constructor() {
        super(...arguments), this.useCapture = !1;
      }
      observe(t) {
        ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(e => {
          this.listenTo(t, e, (t, e) => {
            this.isEnabled && !this.checkShouldIgnoreEventFromTarget(e.target) && this.onDomEvent(e);
          }, {
            useCapture: this.useCapture
          });
        });
      }
      stopObserving(t) {
        this.stopListening(t);
      }
      fire(t, e, n) {
        this.isEnabled && this.document.fire(t, new ic(this.view, e, n));
      }
    }
    class sc extends rc {
      constructor() {
        super(...arguments), this.domEventType = ["keydown", "keyup"];
      }
      onDomEvent(t) {
        const e = {
          keyCode: t.keyCode,
          altKey: t.altKey,
          ctrlKey: t.ctrlKey,
          shiftKey: t.shiftKey,
          metaKey: t.metaKey,
          get keystroke() {
            return fi(this);
          }
        };
        this.fire(t.type, t, e);
      }
    }
    const ac = function () {
      return ot.Date.now();
    };
    var cc = /\s/;
    const lc = function (t) {
      for (var e = t.length; e-- && cc.test(t.charAt(e)););
      return e;
    };
    var dc = /^\s+/;
    const uc = function (t) {
      return t ? t.slice(0, lc(t) + 1).replace(dc, "") : t;
    };
    var hc = /^[-+]0x[0-9a-f]+$/i,
      gc = /^0b[01]+$/i,
      mc = /^0o[0-7]+$/i,
      pc = parseInt;
    const fc = function (t) {
      if ("number" == typeof t) return t;
      if (ls(t)) return NaN;
      if (R(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = R(e) ? e + "" : e;
      }
      if ("string" != typeof t) return 0 === t ? t : +t;
      t = uc(t);
      var n = gc.test(t);
      return n || mc.test(t) ? pc(t.slice(2), n ? 2 : 8) : hc.test(t) ? NaN : +t;
    };
    var kc = Math.max,
      bc = Math.min;
    const wc = function (t, e, n) {
      var o,
        i,
        r,
        s,
        a,
        c,
        l = 0,
        d = !1,
        u = !1,
        h = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      function g(e) {
        var n = o,
          r = i;
        return o = i = void 0, l = e, s = t.apply(r, n);
      }
      function m(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || u && t - l >= r;
      }
      function p() {
        var t = ac();
        if (m(t)) return f(t);
        a = setTimeout(p, function (t) {
          var n = e - (t - c);
          return u ? bc(n, r - (t - l)) : n;
        }(t));
      }
      function f(t) {
        return a = void 0, h && o ? g(t) : (o = i = void 0, s);
      }
      function k() {
        var t = ac(),
          n = m(t);
        if (o = arguments, i = this, c = t, n) {
          if (void 0 === a) return function (t) {
            return l = t, a = setTimeout(p, e), d ? g(t) : s;
          }(c);
          if (u) return clearTimeout(a), a = setTimeout(p, e), g(c);
        }
        return void 0 === a && (a = setTimeout(p, e)), s;
      }
      return e = fc(e) || 0, R(n) && (d = !!n.leading, r = (u = "maxWait" in n) ? kc(fc(n.maxWait) || 0, e) : r, h = "trailing" in n ? !!n.trailing : h), k.cancel = function () {
        void 0 !== a && clearTimeout(a), l = 0, o = c = i = a = void 0;
      }, k.flush = function () {
        return void 0 === a ? s : f(ac());
      }, k;
    };
    class Ac extends nc {
      constructor(t) {
        super(t), this._fireSelectionChangeDoneDebounced = wc(t => {
          this.document.fire("selectionChangeDone", t);
        }, 200);
      }
      observe() {
        const t = this.document;
        t.on("arrowKey", (e, n) => {
          t.selection.isFake && this.isEnabled && n.preventDefault();
        }, {
          context: "$capture"
        }), t.on("arrowKey", (e, n) => {
          t.selection.isFake && this.isEnabled && this._handleSelectionMove(n.keyCode);
        }, {
          priority: "lowest"
        });
      }
      stopObserving() {}
      destroy() {
        super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
      }
      _handleSelectionMove(t) {
        const e = this.document.selection,
          n = new Zs(e.getRanges(), {
            backward: e.isBackward,
            fake: !1
          });
        t != mi.arrowleft && t != mi.arrowup || n.setTo(n.getFirstPosition()), t != mi.arrowright && t != mi.arrowdown || n.setTo(n.getLastPosition());
        const o = {
          oldSelection: e,
          newSelection: n,
          domSelection: null
        };
        this.document.fire("selectionChange", o), this._fireSelectionChangeDoneDebounced(o);
      }
    }
    const _c = function (t) {
      return this.__data__.set(t, "__lodash_hash_undefined__"), this;
    };
    const Cc = function (t) {
      return this.__data__.has(t);
    };
    function vc(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.__data__ = new Ae(); ++e < n;) this.add(t[e]);
    }
    vc.prototype.add = vc.prototype.push = _c, vc.prototype.has = Cc;
    const yc = vc;
    const xc = function (t, e) {
      for (var n = -1, o = null == t ? 0 : t.length; ++n < o;) if (e(t[n], n, t)) return !0;
      return !1;
    };
    const Ec = function (t, e) {
      return t.has(e);
    };
    const Dc = function (t, e, n, o, i, r) {
      var s = 1 & n,
        a = t.length,
        c = e.length;
      if (a != c && !(s && c > a)) return !1;
      var l = r.get(t),
        d = r.get(e);
      if (l && d) return l == e && d == t;
      var u = -1,
        h = !0,
        g = 2 & n ? new yc() : void 0;
      for (r.set(t, e), r.set(e, t); ++u < a;) {
        var m = t[u],
          p = e[u];
        if (o) var f = s ? o(p, m, u, e, t, r) : o(m, p, u, t, e, r);
        if (void 0 !== f) {
          if (f) continue;
          h = !1;
          break;
        }
        if (g) {
          if (!xc(e, function (t, e) {
            if (!Ec(g, e) && (m === t || i(m, t, n, o, r))) return g.push(e);
          })) {
            h = !1;
            break;
          }
        } else if (m !== p && !i(m, p, n, o, r)) {
          h = !1;
          break;
        }
      }
      return r.delete(t), r.delete(e), h;
    };
    const Ic = function (t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t, o) {
        n[++e] = [o, t];
      }), n;
    };
    const Tc = function (t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    };
    var Mc = it ? it.prototype : void 0,
      Sc = Mc ? Mc.valueOf : void 0;
    const Bc = function (t, e, n, o, i, r, s) {
      switch (n) {
        case "[object DataView]":
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;
        case "[object ArrayBuffer]":
          return !(t.byteLength != e.byteLength || !r(new Zn(t), new Zn(e)));
        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return Dt(+t, +e);
        case "[object Error]":
          return t.name == e.name && t.message == e.message;
        case "[object RegExp]":
        case "[object String]":
          return t == e + "";
        case "[object Map]":
          var a = Ic;
        case "[object Set]":
          var c = 1 & o;
          if (a || (a = Tc), t.size != e.size && !c) return !1;
          var l = s.get(t);
          if (l) return l == e;
          o |= 2, s.set(t, e);
          var d = Dc(a(t), a(e), o, i, r, s);
          return s.delete(t), d;
        case "[object Symbol]":
          if (Sc) return Sc.call(t) == Sc.call(e);
      }
      return !1;
    };
    var Nc = Object.prototype.hasOwnProperty;
    const Pc = function (t, e, n, o, i, r) {
      var s = 1 & n,
        a = Sn(t),
        c = a.length;
      if (c != Sn(e).length && !s) return !1;
      for (var l = c; l--;) {
        var d = a[l];
        if (!(s ? d in e : Nc.call(e, d))) return !1;
      }
      var u = r.get(t),
        h = r.get(e);
      if (u && h) return u == e && h == t;
      var g = !0;
      r.set(t, e), r.set(e, t);
      for (var m = s; ++l < c;) {
        var p = t[d = a[l]],
          f = e[d];
        if (o) var k = s ? o(f, p, d, e, t, r) : o(p, f, d, t, e, r);
        if (!(void 0 === k ? p === f || i(p, f, n, o, r) : k)) {
          g = !1;
          break;
        }
        m || (m = "constructor" == d);
      }
      if (g && !m) {
        var b = t.constructor,
          w = e.constructor;
        b == w || !("constructor" in t) || !("constructor" in e) || "function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w || (g = !1);
      }
      return r.delete(t), r.delete(e), g;
    };
    var Oc = "[object Arguments]",
      Lc = "[object Array]",
      zc = "[object Object]",
      Rc = Object.prototype.hasOwnProperty;
    const jc = function (t, e, n, o, i, r) {
      var s = mt(t),
        a = mt(e),
        c = s ? Lc : $n(t),
        l = a ? Lc : $n(e),
        d = (c = c == Oc ? zc : c) == zc,
        u = (l = l == Oc ? zc : l) == zc,
        h = c == l;
      if (h && Fe(t)) {
        if (!Fe(e)) return !1;
        s = !0, d = !1;
      }
      if (h && !d) return r || (r = new ve()), s || Je(t) ? Dc(t, e, n, o, i, r) : Bc(t, e, c, n, o, i, r);
      if (!(1 & n)) {
        var g = d && Rc.call(t, "__wrapped__"),
          m = u && Rc.call(e, "__wrapped__");
        if (g || m) {
          var p = g ? t.value() : t,
            f = m ? e.value() : e;
          return r || (r = new ve()), i(p, f, n, o, r);
        }
      }
      return !!h && (r || (r = new ve()), Pc(t, e, n, o, i, r));
    };
    const Fc = function t(e, n, o, i, r) {
      return e === n || (null == e || null == n || !pt(e) && !pt(n) ? e != e && n != n : jc(e, n, o, i, t, r));
    };
    const Vc = function (t, e, n) {
      var o = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
      return void 0 === o ? Fc(t, e, void 0, n) : !!o;
    };
    class Hc extends nc {
      constructor(t) {
        super(t), this._config = {
          childList: !0,
          characterData: !0,
          subtree: !0
        }, this.domConverter = t.domConverter, this.renderer = t._renderer, this._domElements = new Set(), this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
      }
      flush() {
        this._onMutations(this._mutationObserver.takeRecords());
      }
      observe(t) {
        this._domElements.add(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
      }
      stopObserving(t) {
        if (this._domElements.delete(t), this.isEnabled) {
          this._mutationObserver.disconnect();
          for (const t of this._domElements) this._mutationObserver.observe(t, this._config);
        }
      }
      enable() {
        super.enable();
        for (const t of this._domElements) this._mutationObserver.observe(t, this._config);
      }
      disable() {
        super.disable(), this._mutationObserver.disconnect();
      }
      destroy() {
        super.destroy(), this._mutationObserver.disconnect();
      }
      _onMutations(t) {
        if (0 === t.length) return;
        const e = this.domConverter,
          n = new Set(),
          o = new Set();
        for (const n of t) {
          const t = e.mapDomToView(n.target);
          t && (t.is("uiElement") || t.is("rawElement") || "childList" !== n.type || this._isBogusBrMutation(n) || o.add(t));
        }
        for (const i of t) {
          const t = e.mapDomToView(i.target);
          if ((!t || !t.is("uiElement") && !t.is("rawElement")) && "characterData" === i.type) {
            const t = e.findCorrespondingViewText(i.target);
            t && !o.has(t.parent) ? n.add(t) : !t && Pa(i.target) && o.add(e.mapDomToView(i.target.parentNode));
          }
        }
        let i = !1;
        for (const t of n) i = !0, this.renderer.markToSync("text", t);
        for (const t of o) {
          const n = e.mapViewToDom(t),
            o = Array.from(t.getChildren()),
            r = Array.from(e.domChildrenToView(n, {
              withChildren: !1
            }));
          Vc(o, r, Uc) || (i = !0, this.renderer.markToSync("children", t));
        }
        i && this.view.forceRender();
      }
      _isBogusBrMutation(t) {
        let e = null;
        return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
          withChildren: !1
        })), e && e.is("element", "br");
      }
    }
    function Uc(t, e) {
      if (!Array.isArray(t)) return t === e || !(!t.is("$text") || !e.is("$text")) && t.data === e.data;
    }
    class qc extends rc {
      constructor(t) {
        super(t), this._isFocusChanging = !1, this.domEventType = ["focus", "blur"], this.useCapture = !0;
        const e = this.document;
        e.on("focus", () => {
          this._isFocusChanging = !0, this._renderTimeoutId = setTimeout(() => {
            this.flush(), t.change(() => {});
          }, 50);
        }), e.on("blur", (n, o) => {
          const i = e.selection.editableElement;
          null !== i && i !== o.target || (e.isFocused = !1, this._isFocusChanging = !1, t.change(() => {}));
        });
      }
      flush() {
        this._isFocusChanging && (this._isFocusChanging = !1, this.document.isFocused = !0);
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
      destroy() {
        this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
      }
    }
    class Gc extends nc {
      constructor(t) {
        super(t), this.mutationObserver = t.getObserver(Hc), this.focusObserver = t.getObserver(qc), this.selection = this.document.selection, this.domConverter = t.domConverter, this._documents = new WeakSet(), this._fireSelectionChangeDoneDebounced = wc(t => {
          this.document.fire("selectionChangeDone", t);
        }, 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._documentIsSelectingInactivityTimeoutDebounced = wc(() => this.document.isSelecting = !1, 5e3), this._loopbackCounter = 0;
      }
      observe(t) {
        const e = t.ownerDocument,
          n = () => {
            this.document.isSelecting && (this._handleSelectionChange(null, e), this.document.isSelecting = !1, this._documentIsSelectingInactivityTimeoutDebounced.cancel());
          };
        this.listenTo(t, "selectstart", () => {
          this.document.isSelecting = !0, this._documentIsSelectingInactivityTimeoutDebounced();
        }, {
          priority: "highest"
        }), this.listenTo(t, "keydown", n, {
          priority: "highest",
          useCapture: !0
        }), this.listenTo(t, "keyup", n, {
          priority: "highest",
          useCapture: !0
        }), this._documents.has(e) || (this.listenTo(e, "mouseup", n, {
          priority: "highest",
          useCapture: !0
        }), this.listenTo(e, "selectionchange", (t, n) => {
          this.document.isComposing && !s.isAndroid || (this._handleSelectionChange(n, e), this._documentIsSelectingInactivityTimeoutDebounced());
        }), this._documents.add(e));
      }
      stopObserving(t) {
        this.stopListening(t);
      }
      destroy() {
        super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
      }
      _reportInfiniteLoop() {}
      _handleSelectionChange(t, e) {
        if (!this.isEnabled) return;
        const n = e.defaultView.getSelection();
        if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
        this.mutationObserver.flush();
        const o = this.domConverter.domSelectionToView(n);
        if (0 != o.rangeCount) {
          if (this.view.hasDomSelection = !0, this.focusObserver.flush(), !this.selection.isEqual(o) || !this.domConverter.isDomSelectionCorrect(n)) if (++this._loopbackCounter > 60) this._reportInfiniteLoop();else if (this.selection.isSimilar(o)) this.view.forceRender();else {
            const t = {
              oldSelection: this.selection,
              newSelection: o,
              domSelection: n
            };
            this.document.fire("selectionChange", t), this._fireSelectionChangeDoneDebounced(t);
          }
        } else this.view.hasDomSelection = !1;
      }
      _clearInfiniteLoop() {
        this._loopbackCounter = 0;
      }
    }
    class Wc extends rc {
      constructor(t) {
        super(t), this.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        const e = this.document;
        e.on("compositionstart", () => {
          e.isComposing = !0;
        }, {
          priority: "low"
        }), e.on("compositionend", () => {
          e.isComposing = !1;
        }, {
          priority: "low"
        });
      }
      onDomEvent(t) {
        this.fire(t.type, t, {
          data: t.data
        });
      }
    }
    class Kc {
      constructor(t, e = {}) {
        this._files = e.cacheFiles ? $c(t) : null, this._native = t;
      }
      get files() {
        return this._files || (this._files = $c(this._native)), this._files;
      }
      get types() {
        return this._native.types;
      }
      getData(t) {
        return this._native.getData(t);
      }
      setData(t, e) {
        this._native.setData(t, e);
      }
      set effectAllowed(t) {
        this._native.effectAllowed = t;
      }
      get effectAllowed() {
        return this._native.effectAllowed;
      }
      set dropEffect(t) {
        this._native.dropEffect = t;
      }
      get dropEffect() {
        return this._native.dropEffect;
      }
      setDragImage(t, e, n) {
        this._native.setDragImage(t, e, n);
      }
      get isCanceled() {
        return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
      }
    }
    function $c(t) {
      const e = Array.from(t.files || []),
        n = Array.from(t.items || []);
      return e.length ? e : n.filter(t => "file" === t.kind).map(t => t.getAsFile());
    }
    class Yc extends rc {
      constructor() {
        super(...arguments), this.domEventType = "beforeinput";
      }
      onDomEvent(t) {
        const e = t.getTargetRanges(),
          n = this.view,
          o = n.document;
        let i = null,
          r = null,
          a = [];
        if (t.dataTransfer && (i = new Kc(t.dataTransfer)), null !== t.data ? r = t.data : i && (r = i.getData("text/plain")), o.selection.isFake) a = Array.from(o.selection.getRanges());else if (e.length) a = e.map(t => {
          const e = n.domConverter.domPositionToView(t.startContainer, t.startOffset),
            o = n.domConverter.domPositionToView(t.endContainer, t.endOffset);
          return e ? n.createRange(e, o) : o ? n.createRange(o) : void 0;
        }).filter(t => !!t);else if (s.isAndroid) {
          const e = t.target.ownerDocument.defaultView.getSelection();
          a = Array.from(n.domConverter.domSelectionToView(e).getRanges());
        }
        if (s.isAndroid && "insertCompositionText" == t.inputType && r && r.endsWith("\n")) this.fire(t.type, t, {
          inputType: "insertParagraph",
          targetRanges: [n.createRange(a[0].end)]
        });else if ("insertText" == t.inputType && r && r.includes("\n")) {
          const e = r.split(/\n{1,2}/g);
          let n = a;
          for (let r = 0; r < e.length; r++) {
            const s = e[r];
            "" != s && (this.fire(t.type, t, {
              data: s,
              dataTransfer: i,
              targetRanges: n,
              inputType: t.inputType,
              isComposing: t.isComposing
            }), n = [o.selection.getFirstRange()]), r + 1 < e.length && (this.fire(t.type, t, {
              inputType: "insertParagraph",
              targetRanges: n
            }), n = [o.selection.getFirstRange()]);
          }
        } else this.fire(t.type, t, {
          data: r,
          dataTransfer: i,
          targetRanges: a,
          inputType: t.inputType,
          isComposing: t.isComposing
        });
      }
    }
    class Qc extends nc {
      constructor(t) {
        super(t), this.document.on("keydown", (t, e) => {
          if (this.isEnabled && ((n = e.keyCode) == mi.arrowright || n == mi.arrowleft || n == mi.arrowup || n == mi.arrowdown)) {
            const n = new Xs(this.document, "arrowKey", this.document.selection.getFirstRange());
            this.document.fire(n, e), n.stop.called && t.stop();
          }
          var n;
        });
      }
      observe() {}
      stopObserving() {}
    }
    class Zc extends nc {
      constructor(t) {
        super(t);
        const e = this.document;
        e.on("keydown", (t, n) => {
          if (!this.isEnabled || n.keyCode != mi.tab || n.ctrlKey) return;
          const o = new Xs(e, "tab", e.selection.getFirstRange());
          e.fire(o, n), o.stop.called && t.stop();
        });
      }
      observe() {}
      stopObserving() {}
    }
    const Jc = function (t) {
      return _o(t, 5);
    };
    class Xc extends G() {
      constructor(t) {
        super(), this.domRoots = new Map(), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this.document = new sa(t), this.domConverter = new Za(this.document), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new Fa(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing"), this._writer = new ba(this.document), this.addObserver(Hc), this.addObserver(qc), this.addObserver(Gc), this.addObserver(sc), this.addObserver(Ac), this.addObserver(Wc), this.addObserver(Qc), this.addObserver(Yc), this.addObserver(Zc), this.document.on("arrowKey", za, {
          priority: "low"
        }), ga(this), this.on("render", () => {
          this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", () => {
          this._hasChangedSinceTheLastRendering = !0;
        }), this.listenTo(this.document, "change:isFocused", () => {
          this._hasChangedSinceTheLastRendering = !0;
        }), s.isiOS && this.listenTo(this.document, "blur", (t, e) => {
          this.domConverter.mapDomToView(e.domEvent.relatedTarget) || this.domConverter._clearDomSelection();
        });
      }
      attachDomRoot(t, e = "main") {
        const n = this.document.getRoot(e);
        n._name = t.tagName.toLowerCase();
        const o = {};
        for (const {
          name: e,
          value: i
        } of Array.from(t.attributes)) o[e] = i, "class" === e ? this._writer.addClass(i.split(" "), n) : this._writer.setAttribute(e, i, n);
        this._initialDomRootAttributes.set(t, o);
        const i = () => {
          this._writer.setAttribute("contenteditable", (!n.isReadOnly).toString(), n), n.isReadOnly ? this._writer.addClass("ck-read-only", n) : this._writer.removeClass("ck-read-only", n);
        };
        i(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", (t, e) => this._renderer.markToSync("children", e)), n.on("change:attributes", (t, e) => this._renderer.markToSync("attributes", e)), n.on("change:text", (t, e) => this._renderer.markToSync("text", e)), n.on("change:isReadOnly", () => this.change(i)), n.on("change", () => {
          this._hasChangedSinceTheLastRendering = !0;
        });
        for (const n of this._observers.values()) n.observe(t, e);
      }
      detachDomRoot(t) {
        const e = this.domRoots.get(t);
        Array.from(e.attributes).forEach(({
          name: t
        }) => e.removeAttribute(t));
        const n = this._initialDomRootAttributes.get(e);
        for (const t in n) e.setAttribute(t, n[t]);
        this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
        for (const t of this._observers.values()) t.stopObserving(e);
      }
      getDomRoot(t = "main") {
        return this.domRoots.get(t);
      }
      addObserver(t) {
        let e = this._observers.get(t);
        if (e) return e;
        e = new t(this), this._observers.set(t, e);
        for (const [t, n] of this.domRoots) e.observe(n, t);
        return e.enable(), e;
      }
      getObserver(t) {
        return this._observers.get(t);
      }
      disableObservers() {
        for (const t of this._observers.values()) t.disable();
      }
      enableObservers() {
        for (const t of this._observers.values()) t.enable();
      }
      scrollToTheSelection({
        alignToTop: t,
        forceScroll: e,
        viewportOffset: n = 20,
        ancestorOffset: o = 20
      } = {}) {
        const i = this.document.selection.getFirstRange();
        if (!i) return;
        const r = Jc({
          alignToTop: t,
          forceScroll: e,
          viewportOffset: n,
          ancestorOffset: o
        });
        "number" == typeof n && (n = {
          top: n,
          bottom: n,
          left: n,
          right: n
        });
        const s = {
          target: this.domConverter.viewRangeToDom(i),
          viewportOffset: n,
          ancestorOffset: o,
          alignToTop: t,
          forceScroll: e
        };
        this.fire("scrollToTheSelection", s, r), function ({
          target: t,
          viewportOffset: e = 0,
          ancestorOffset: n = 0,
          alignToTop: o,
          forceScroll: i
        }) {
          const r = ci(t);
          let s = r,
            a = null;
          for (e = function (t) {
            return "number" == typeof t ? {
              top: t,
              bottom: t,
              left: t,
              right: t
            } : t;
          }(e); s;) {
            let c;
            c = li(s == r ? t : a), oi({
              parent: c,
              getRect: () => di(t, s),
              alignToTop: o,
              ancestorOffset: n,
              forceScroll: i
            });
            const l = di(t, s);
            if (ni({
              window: s,
              rect: l,
              viewportOffset: e,
              alignToTop: o,
              forceScroll: i
            }), s.parent != s) {
              if (a = s.frameElement, s = s.parent, !a) return;
            } else s = null;
          }
        }(s);
      }
      focus() {
        if (!this.document.isFocused) {
          const t = this.document.selection.editableElement;
          t && (this.domConverter.focus(t), this.forceRender());
        }
      }
      change(t) {
        if (this.isRenderingInProgress || this._postFixersInProgress) throw new w("cannot-change-view-tree", this);
        try {
          if (this._ongoingChange) return t(this._writer);
          this._ongoingChange = !0;
          const e = t(this._writer);
          return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), e;
        } catch (t) {
          w.rethrowUnexpectedError(t, this);
        }
      }
      forceRender() {
        this._hasChangedSinceTheLastRendering = !0, this.getObserver(qc).flush(), this.change(() => {});
      }
      destroy() {
        for (const t of this._observers.values()) t.destroy();
        this.document.destroy(), this.stopListening();
      }
      createPositionAt(t, e) {
        return $s._createAt(t, e);
      }
      createPositionAfter(t) {
        return $s._createAfter(t);
      }
      createPositionBefore(t) {
        return $s._createBefore(t);
      }
      createRange(t, e) {
        return new Ys(t, e);
      }
      createRangeOn(t) {
        return Ys._createOn(t);
      }
      createRangeIn(t) {
        return Ys._createIn(t);
      }
      createSelection(...t) {
        return new Zs(...t);
      }
      _disableRendering(t) {
        this._renderingDisabled = t, 0 == t && this.change(() => {});
      }
      _render() {
        this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
      }
    }
    class tl {
      is() {
        throw new Error("is() method is abstract");
      }
    }
    class el extends tl {
      constructor(t) {
        super(), this.parent = null, this._attrs = Yi(t);
      }
      get document() {
        return null;
      }
      get index() {
        let t;
        if (!this.parent) return null;
        if (null === (t = this.parent.getChildIndex(this))) throw new w("model-node-not-found-in-parent", this);
        return t;
      }
      get startOffset() {
        let t;
        if (!this.parent) return null;
        if (null === (t = this.parent.getChildStartOffset(this))) throw new w("model-node-not-found-in-parent", this);
        return t;
      }
      get offsetSize() {
        return 1;
      }
      get endOffset() {
        return this.parent ? this.startOffset + this.offsetSize : null;
      }
      get nextSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t + 1) || null;
      }
      get previousSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t - 1) || null;
      }
      get root() {
        let t = this;
        for (; t.parent;) t = t.parent;
        return t;
      }
      isAttached() {
        return null !== this.parent && this.root.isAttached();
      }
      getPath() {
        const t = [];
        let e = this;
        for (; e.parent;) t.unshift(e.startOffset), e = e.parent;
        return t;
      }
      getAncestors(t = {}) {
        const e = [];
        let n = t.includeSelf ? this : this.parent;
        for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
      getCommonAncestor(t, e = {}) {
        const n = this.getAncestors(e),
          o = t.getAncestors(e);
        let i = 0;
        for (; n[i] == o[i] && n[i];) i++;
        return 0 === i ? null : n[i - 1];
      }
      isBefore(t) {
        if (this == t) return !1;
        if (this.root !== t.root) return !1;
        const e = this.getPath(),
          n = t.getPath(),
          o = X(e, n);
        switch (o) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return e[o] < n[o];
        }
      }
      isAfter(t) {
        return this != t && this.root === t.root && !this.isBefore(t);
      }
      hasAttribute(t) {
        return this._attrs.has(t);
      }
      getAttribute(t) {
        return this._attrs.get(t);
      }
      getAttributes() {
        return this._attrs.entries();
      }
      getAttributeKeys() {
        return this._attrs.keys();
      }
      toJSON() {
        const t = {};
        return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce((t, e) => (t[e[0]] = e[1], t), {})), t;
      }
      _clone(t) {
        return new this.constructor(this._attrs);
      }
      _remove() {
        this.parent._removeChildren(this.index);
      }
      _setAttribute(t, e) {
        this._attrs.set(t, e);
      }
      _setAttributesTo(t) {
        this._attrs = Yi(t);
      }
      _removeAttribute(t) {
        return this._attrs.delete(t);
      }
      _clearAttributes() {
        this._attrs.clear();
      }
    }
    el.prototype.is = function (t) {
      return "node" === t || "model:node" === t;
    };
    class nl {
      constructor(t) {
        this._nodes = [], t && this._insertNodes(0, t);
      }
      [Symbol.iterator]() {
        return this._nodes[Symbol.iterator]();
      }
      get length() {
        return this._nodes.length;
      }
      get maxOffset() {
        return this._nodes.reduce((t, e) => t + e.offsetSize, 0);
      }
      getNode(t) {
        return this._nodes[t] || null;
      }
      getNodeIndex(t) {
        const e = this._nodes.indexOf(t);
        return -1 == e ? null : e;
      }
      getNodeStartOffset(t) {
        const e = this.getNodeIndex(t);
        return null === e ? null : this._nodes.slice(0, e).reduce((t, e) => t + e.offsetSize, 0);
      }
      indexToOffset(t) {
        if (t == this._nodes.length) return this.maxOffset;
        const e = this._nodes[t];
        if (!e) throw new w("model-nodelist-index-out-of-bounds", this);
        return this.getNodeStartOffset(e);
      }
      offsetToIndex(t) {
        let e = 0;
        for (const n of this._nodes) {
          if (t >= e && t < e + n.offsetSize) return this.getNodeIndex(n);
          e += n.offsetSize;
        }
        if (e != t) throw new w("model-nodelist-offset-out-of-bounds", this, {
          offset: t,
          nodeList: this
        });
        return this.length;
      }
      _insertNodes(t, e) {
        for (const t of e) if (!(t instanceof el)) throw new w("model-nodelist-insertnodes-not-node", this);
        this._nodes = function (t, e, n, o) {
          if (Math.max(e.length, t.length) > 1e4) return t.slice(0, n).concat(e).concat(t.slice(n + o, t.length));
          {
            const i = Array.from(t);
            return i.splice(n, o, ...e), i;
          }
        }(this._nodes, Array.from(e), t, 0);
      }
      _removeNodes(t, e = 1) {
        return this._nodes.splice(t, e);
      }
      toJSON() {
        return this._nodes.map(t => t.toJSON());
      }
    }
    class ol extends el {
      constructor(t, e) {
        super(e), this._data = t || "";
      }
      get offsetSize() {
        return this.data.length;
      }
      get data() {
        return this._data;
      }
      toJSON() {
        const t = super.toJSON();
        return t.data = this.data, t;
      }
      _clone() {
        return new ol(this.data, this.getAttributes());
      }
      static fromJSON(t) {
        return new ol(t.data, t.attributes);
      }
    }
    ol.prototype.is = function (t) {
      return "$text" === t || "model:$text" === t || "text" === t || "model:text" === t || "node" === t || "model:node" === t;
    };
    class il extends tl {
      constructor(t, e, n) {
        if (super(), this.textNode = t, e < 0 || e > t.offsetSize) throw new w("model-textproxy-wrong-offsetintext", this);
        if (n < 0 || e + n > t.offsetSize) throw new w("model-textproxy-wrong-length", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }
      get startOffset() {
        return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
      }
      get offsetSize() {
        return this.data.length;
      }
      get endOffset() {
        return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
      }
      get isPartial() {
        return this.offsetSize !== this.textNode.offsetSize;
      }
      get parent() {
        return this.textNode.parent;
      }
      get root() {
        return this.textNode.root;
      }
      getPath() {
        const t = this.textNode.getPath();
        return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
      }
      getAncestors(t = {}) {
        const e = [];
        let n = t.includeSelf ? this : this.parent;
        for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
      hasAttribute(t) {
        return this.textNode.hasAttribute(t);
      }
      getAttribute(t) {
        return this.textNode.getAttribute(t);
      }
      getAttributes() {
        return this.textNode.getAttributes();
      }
      getAttributeKeys() {
        return this.textNode.getAttributeKeys();
      }
    }
    il.prototype.is = function (t) {
      return "$textProxy" === t || "model:$textProxy" === t || "textProxy" === t || "model:textProxy" === t;
    };
    class rl extends el {
      constructor(t, e, n) {
        super(e), this._children = new nl(), this.name = t, n && this._insertChild(0, n);
      }
      get childCount() {
        return this._children.length;
      }
      get maxOffset() {
        return this._children.maxOffset;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      getChild(t) {
        return this._children.getNode(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      getChildIndex(t) {
        return this._children.getNodeIndex(t);
      }
      getChildStartOffset(t) {
        return this._children.getNodeStartOffset(t);
      }
      offsetToIndex(t) {
        return this._children.offsetToIndex(t);
      }
      getNodeByPath(t) {
        let e = this;
        for (const n of t) e = e.getChild(e.offsetToIndex(n));
        return e;
      }
      findAncestor(t, e = {}) {
        let n = e.includeSelf ? this : this.parent;
        for (; n;) {
          if (n.name === t) return n;
          n = n.parent;
        }
        return null;
      }
      toJSON() {
        const t = super.toJSON();
        if (t.name = this.name, this._children.length > 0) {
          t.children = [];
          for (const e of this._children) t.children.push(e.toJSON());
        }
        return t;
      }
      _clone(t = !1) {
        const e = t ? Array.from(this._children).map(t => t._clone(!0)) : void 0;
        return new rl(this.name, this.getAttributes(), e);
      }
      _appendChild(t) {
        this._insertChild(this.childCount, t);
      }
      _insertChild(t, e) {
        const n = function (t) {
          if ("string" == typeof t) return [new ol(t)];
          tt(t) || (t = [t]);
          return Array.from(t).map(t => "string" == typeof t ? new ol(t) : t instanceof il ? new ol(t.data, t.getAttributes()) : t);
        }(e);
        for (const t of n) null !== t.parent && t._remove(), t.parent = this;
        this._children._insertNodes(t, n);
      }
      _removeChildren(t, e = 1) {
        const n = this._children._removeNodes(t, e);
        for (const t of n) t.parent = null;
        return n;
      }
      static fromJSON(t) {
        let e;
        if (t.children) {
          e = [];
          for (const n of t.children) n.name ? e.push(rl.fromJSON(n)) : e.push(ol.fromJSON(n));
        }
        return new rl(t.name, t.attributes, e);
      }
    }
    rl.prototype.is = function (t, e) {
      return e ? e === this.name && ("element" === t || "model:element" === t) : "element" === t || "model:element" === t || "node" === t || "model:node" === t;
    };
    class sl {
      constructor(t) {
        if (!t || !t.boundaries && !t.startPosition) throw new w("model-tree-walker-no-start-position", null);
        const e = t.direction || "forward";
        if ("forward" != e && "backward" != e) throw new w("model-tree-walker-unknown-direction", t, {
          direction: e
        });
        this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this._position = t.startPosition.clone() : this._position = cl._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }
      [Symbol.iterator]() {
        return this;
      }
      get position() {
        return this._position;
      }
      skip(t) {
        let e, n, o, i;
        do {
          o = this.position, i = this._visitedParent, {
            done: e,
            value: n
          } = this.next();
        } while (!e && t(n));
        e || (this._position = o, this._visitedParent = i);
      }
      next() {
        return "forward" == this.direction ? this._next() : this._previous();
      }
      _next() {
        const t = this.position,
          e = this.position.clone(),
          n = this._visitedParent;
        if (null === n.parent && e.offset === n.maxOffset) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        const o = ll(e, n),
          i = o || dl(e, n, o);
        if (i instanceof rl) {
          if (this.shallow) {
            if (this.boundaries && this.boundaries.end.isBefore(e)) return {
              done: !0,
              value: void 0
            };
            e.offset++;
          } else e.path.push(0), this._visitedParent = i;
          return this._position = e, al("elementStart", i, t, e, 1);
        }
        if (i instanceof ol) {
          let o;
          if (this.singleCharacters) o = 1;else {
            let t = i.endOffset;
            this._boundaryEndParent == n && this.boundaries.end.offset < t && (t = this.boundaries.end.offset), o = t - e.offset;
          }
          const r = e.offset - i.startOffset,
            s = new il(i, r, o);
          return e.offset += o, this._position = e, al("text", s, t, e, o);
        }
        return e.path.pop(), e.offset++, this._position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : al("elementEnd", n, t, e);
      }
      _previous() {
        const t = this.position,
          e = this.position.clone(),
          n = this._visitedParent;
        if (null === n.parent && 0 === e.offset) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        const o = e.parent,
          i = ll(e, o),
          r = i || ul(e, o, i);
        if (r instanceof rl) return e.offset--, this.shallow ? (this._position = e, al("elementStart", r, t, e, 1)) : (e.path.push(r.maxOffset), this._position = e, this._visitedParent = r, this.ignoreElementEnd ? this._previous() : al("elementEnd", r, t, e));
        if (r instanceof ol) {
          let o;
          if (this.singleCharacters) o = 1;else {
            let t = r.startOffset;
            this._boundaryStartParent == n && this.boundaries.start.offset > t && (t = this.boundaries.start.offset), o = e.offset - t;
          }
          const i = e.offset - r.startOffset,
            s = new il(r, i - o, o);
          return e.offset -= o, this._position = e, al("text", s, t, e, o);
        }
        return e.path.pop(), this._position = e, this._visitedParent = n.parent, al("elementStart", n, t, e, 1);
      }
    }
    function al(t, e, n, o, i) {
      return {
        done: !1,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: o,
          length: i
        }
      };
    }
    class cl extends tl {
      constructor(t, e, n = "toNone") {
        if (super(), !t.is("element") && !t.is("documentFragment")) throw new w("model-position-root-invalid", t);
        if (!(e instanceof Array) || 0 === e.length) throw new w("model-position-path-incorrect-format", t, {
          path: e
        });
        t.is("rootElement") ? e = e.slice() : (e = [...t.getPath(), ...e], t = t.root), this.root = t, this.path = e, this.stickiness = n;
      }
      get offset() {
        return this.path[this.path.length - 1];
      }
      set offset(t) {
        this.path[this.path.length - 1] = t;
      }
      get parent() {
        let t = this.root;
        for (let e = 0; e < this.path.length - 1; e++) if (t = t.getChild(t.offsetToIndex(this.path[e])), !t) throw new w("model-position-path-incorrect", this, {
          position: this
        });
        if (t.is("$text")) throw new w("model-position-path-incorrect", this, {
          position: this
        });
        return t;
      }
      get index() {
        return this.parent.offsetToIndex(this.offset);
      }
      get textNode() {
        return ll(this, this.parent);
      }
      get nodeAfter() {
        const t = this.parent;
        return dl(this, t, ll(this, t));
      }
      get nodeBefore() {
        const t = this.parent;
        return ul(this, t, ll(this, t));
      }
      get isAtStart() {
        return 0 === this.offset;
      }
      get isAtEnd() {
        return this.offset == this.parent.maxOffset;
      }
      compareWith(t) {
        if (this.root != t.root) return "different";
        const e = X(this.path, t.path);
        switch (e) {
          case "same":
            return "same";
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return this.path[e] < t.path[e] ? "before" : "after";
        }
      }
      getLastMatchingPosition(t, e = {}) {
        e.startPosition = this;
        const n = new sl(e);
        return n.skip(t), n.position;
      }
      getParentPath() {
        return this.path.slice(0, -1);
      }
      getAncestors() {
        const t = this.parent;
        return t.is("documentFragment") ? [t] : t.getAncestors({
          includeSelf: !0
        });
      }
      findAncestor(t) {
        const e = this.parent;
        return e.is("element") ? e.findAncestor(t, {
          includeSelf: !0
        }) : null;
      }
      getCommonPath(t) {
        if (this.root != t.root) return [];
        const e = X(this.path, t.path),
          n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
        return this.path.slice(0, n);
      }
      getCommonAncestor(t) {
        const e = this.getAncestors(),
          n = t.getAncestors();
        let o = 0;
        for (; e[o] == n[o] && e[o];) o++;
        return 0 === o ? null : e[o - 1];
      }
      getShiftedBy(t) {
        const e = this.clone(),
          n = e.offset + t;
        return e.offset = n < 0 ? 0 : n, e;
      }
      isAfter(t) {
        return "after" == this.compareWith(t);
      }
      isBefore(t) {
        return "before" == this.compareWith(t);
      }
      isEqual(t) {
        return "same" == this.compareWith(t);
      }
      isTouching(t) {
        if (this.root !== t.root) return !1;
        const e = Math.min(this.path.length, t.path.length);
        for (let n = 0; n < e; n++) {
          const e = this.path[n] - t.path[n];
          if (e < -1 || e > 1) return !1;
          if (1 === e) return hl(t, this, n);
          if (-1 === e) return hl(this, t, n);
        }
        return this.path.length === t.path.length || (this.path.length > t.path.length ? gl(this.path, e) : gl(t.path, e));
      }
      hasSameParentAs(t) {
        if (this.root !== t.root) return !1;
        return "same" == X(this.getParentPath(), t.getParentPath());
      }
      getTransformedByOperation(t) {
        let e;
        switch (t.type) {
          case "insert":
            e = this._getTransformedByInsertOperation(t);
            break;
          case "move":
          case "remove":
          case "reinsert":
            e = this._getTransformedByMoveOperation(t);
            break;
          case "split":
            e = this._getTransformedBySplitOperation(t);
            break;
          case "merge":
            e = this._getTransformedByMergeOperation(t);
            break;
          default:
            e = cl._createAt(this);
        }
        return e;
      }
      _getTransformedByInsertOperation(t) {
        return this._getTransformedByInsertion(t.position, t.howMany);
      }
      _getTransformedByMoveOperation(t) {
        return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
      }
      _getTransformedBySplitOperation(t) {
        const e = t.movedRange;
        return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
      }
      _getTransformedByMergeOperation(t) {
        const e = t.movedRange;
        let n;
        return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? cl._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
      }
      _getTransformedByDeletion(t, e) {
        const n = cl._createAt(this);
        if (this.root != t.root) return n;
        if ("same" == X(t.getParentPath(), this.getParentPath())) {
          if (t.offset < this.offset) {
            if (t.offset + e > this.offset) return null;
            n.offset -= e;
          }
        } else if ("prefix" == X(t.getParentPath(), this.getParentPath())) {
          const o = t.path.length - 1;
          if (t.offset <= this.path[o]) {
            if (t.offset + e > this.path[o]) return null;
            n.path[o] -= e;
          }
        }
        return n;
      }
      _getTransformedByInsertion(t, e) {
        const n = cl._createAt(this);
        if (this.root != t.root) return n;
        if ("same" == X(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == X(t.getParentPath(), this.getParentPath())) {
          const o = t.path.length - 1;
          t.offset <= this.path[o] && (n.path[o] += e);
        }
        return n;
      }
      _getTransformedByMove(t, e, n) {
        if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return cl._createAt(this);
        const o = this._getTransformedByDeletion(t, n);
        return null === o || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : o._getTransformedByInsertion(e, n);
      }
      _getCombined(t, e) {
        const n = t.path.length - 1,
          o = cl._createAt(e);
        return o.stickiness = this.stickiness, o.offset = o.offset + this.path[n] - t.offset, o.path = [...o.path, ...this.path.slice(n + 1)], o;
      }
      toJSON() {
        return {
          root: this.root.toJSON(),
          path: Array.from(this.path),
          stickiness: this.stickiness
        };
      }
      clone() {
        return new this.constructor(this.root, this.path, this.stickiness);
      }
      static _createAt(t, e, n = "toNone") {
        if (t instanceof cl) return new cl(t.root, t.path, t.stickiness);
        {
          const o = t;
          if ("end" == e) e = o.maxOffset;else {
            if ("before" == e) return this._createBefore(o, n);
            if ("after" == e) return this._createAfter(o, n);
            if (0 !== e && !e) throw new w("model-createpositionat-offset-required", [this, t]);
          }
          if (!o.is("element") && !o.is("documentFragment")) throw new w("model-position-parent-incorrect", [this, t]);
          const i = o.getPath();
          return i.push(e), new this(o.root, i, n);
        }
      }
      static _createAfter(t, e) {
        if (!t.parent) throw new w("model-position-after-root", [this, t], {
          root: t
        });
        return this._createAt(t.parent, t.endOffset, e);
      }
      static _createBefore(t, e) {
        if (!t.parent) throw new w("model-position-before-root", t, {
          root: t
        });
        return this._createAt(t.parent, t.startOffset, e);
      }
      static fromJSON(t, e) {
        if ("$graveyard" === t.root) {
          const n = new cl(e.graveyard, t.path);
          return n.stickiness = t.stickiness, n;
        }
        if (!e.getRoot(t.root)) throw new w("model-position-fromjson-no-root", e, {
          rootName: t.root
        });
        return new cl(e.getRoot(t.root), t.path, t.stickiness);
      }
    }
    function ll(t, e) {
      const n = e.getChild(e.offsetToIndex(t.offset));
      return n && n.is("$text") && n.startOffset < t.offset ? n : null;
    }
    function dl(t, e, n) {
      return null !== n ? null : e.getChild(e.offsetToIndex(t.offset));
    }
    function ul(t, e, n) {
      return null !== n ? null : e.getChild(e.offsetToIndex(t.offset) - 1);
    }
    function hl(t, e, n) {
      return n + 1 !== t.path.length && !!gl(e.path, n + 1) && !!function (t, e) {
        let n = t.parent,
          o = t.path.length - 1,
          i = 0;
        for (; o >= e;) {
          if (t.path[o] + i !== n.maxOffset) return !1;
          i = 1, o--, n = n.parent;
        }
        return !0;
      }(t, n + 1);
    }
    function gl(t, e) {
      for (; e < t.length;) {
        if (0 !== t[e]) return !1;
        e++;
      }
      return !0;
    }
    cl.prototype.is = function (t) {
      return "position" === t || "model:position" === t;
    };
    class ml extends tl {
      constructor(t, e) {
        super(), this.start = cl._createAt(t), this.end = e ? cl._createAt(e) : cl._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }
      *[Symbol.iterator]() {
        yield* new sl({
          boundaries: this,
          ignoreElementEnd: !0
        });
      }
      get isCollapsed() {
        return this.start.isEqual(this.end);
      }
      get isFlat() {
        return "same" == X(this.start.getParentPath(), this.end.getParentPath());
      }
      get root() {
        return this.start.root;
      }
      containsPosition(t) {
        return t.isAfter(this.start) && t.isBefore(this.end);
      }
      containsRange(t, e = !1) {
        t.isCollapsed && (e = !1);
        const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
          o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
        return n && o;
      }
      containsItem(t) {
        const e = cl._createBefore(t);
        return this.containsPosition(e) || this.start.isEqual(e);
      }
      isEqual(t) {
        return this.start.isEqual(t.start) && this.end.isEqual(t.end);
      }
      isIntersecting(t) {
        return this.start.isBefore(t.end) && this.end.isAfter(t.start);
      }
      getDifference(t) {
        const e = [];
        return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new ml(this.start, t.start)), this.containsPosition(t.end) && e.push(new ml(t.end, this.end))) : e.push(new ml(this.start, this.end)), e;
      }
      getIntersection(t) {
        if (this.isIntersecting(t)) {
          let e = this.start,
            n = this.end;
          return this.containsPosition(t.start) && (e = t.start), this.containsPosition(t.end) && (n = t.end), new ml(e, n);
        }
        return null;
      }
      getJoined(t, e = !1) {
        let n = this.isIntersecting(t);
        if (n || (n = this.start.isBefore(t.start) ? e ? this.end.isTouching(t.start) : this.end.isEqual(t.start) : e ? t.end.isTouching(this.start) : t.end.isEqual(this.start)), !n) return null;
        let o = this.start,
          i = this.end;
        return t.start.isBefore(o) && (o = t.start), t.end.isAfter(i) && (i = t.end), new ml(o, i);
      }
      getMinimalFlatRanges() {
        const t = [],
          e = this.start.getCommonPath(this.end).length,
          n = cl._createAt(this.start);
        let o = n.parent;
        for (; n.path.length > e + 1;) {
          const e = o.maxOffset - n.offset;
          0 !== e && t.push(new ml(n, n.getShiftedBy(e))), n.path = n.path.slice(0, -1), n.offset++, o = o.parent;
        }
        for (; n.path.length <= this.end.path.length;) {
          const e = this.end.path[n.path.length - 1],
            o = e - n.offset;
          0 !== o && t.push(new ml(n, n.getShiftedBy(o))), n.offset = e, n.path.push(0);
        }
        return t;
      }
      getWalker(t = {}) {
        return t.boundaries = this, new sl(t);
      }
      *getItems(t = {}) {
        t.boundaries = this, t.ignoreElementEnd = !0;
        const e = new sl(t);
        for (const t of e) yield t.item;
      }
      *getPositions(t = {}) {
        t.boundaries = this;
        const e = new sl(t);
        yield e.position;
        for (const t of e) yield t.nextPosition;
      }
      getTransformedByOperation(t) {
        switch (t.type) {
          case "insert":
            return this._getTransformedByInsertOperation(t);
          case "move":
          case "remove":
          case "reinsert":
            return this._getTransformedByMoveOperation(t);
          case "split":
            return [this._getTransformedBySplitOperation(t)];
          case "merge":
            return [this._getTransformedByMergeOperation(t)];
        }
        return [new ml(this.start, this.end)];
      }
      getTransformedByOperations(t) {
        const e = [new ml(this.start, this.end)];
        for (const n of t) for (let t = 0; t < e.length; t++) {
          const o = e[t].getTransformedByOperation(n);
          e.splice(t, 1, ...o), t += o.length - 1;
        }
        for (let t = 0; t < e.length; t++) {
          const n = e[t];
          for (let o = t + 1; o < e.length; o++) {
            const t = e[o];
            (n.containsRange(t) || t.containsRange(n) || n.isEqual(t)) && e.splice(o, 1);
          }
        }
        return e;
      }
      getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
      }
      getContainedElement() {
        if (this.isCollapsed) return null;
        const t = this.start.nodeAfter,
          e = this.end.nodeBefore;
        return t && t.is("element") && t === e ? t : null;
      }
      toJSON() {
        return {
          start: this.start.toJSON(),
          end: this.end.toJSON()
        };
      }
      clone() {
        return new this.constructor(this.start, this.end);
      }
      _getTransformedByInsertOperation(t, e = !1) {
        return this._getTransformedByInsertion(t.position, t.howMany, e);
      }
      _getTransformedByMoveOperation(t, e = !1) {
        const n = t.sourcePosition,
          o = t.howMany,
          i = t.targetPosition;
        return this._getTransformedByMove(n, i, o, e);
      }
      _getTransformedBySplitOperation(t) {
        const e = this.start._getTransformedBySplitOperation(t);
        let n = this.end._getTransformedBySplitOperation(t);
        return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new ml(e, n);
      }
      _getTransformedByMergeOperation(t) {
        if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new ml(this.start);
        let e = this.start._getTransformedByMergeOperation(t),
          n = this.end._getTransformedByMergeOperation(t);
        return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = cl._createAt(n), e.offset = 0) : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new ml(e, n)) : new ml(e, n);
      }
      _getTransformedByInsertion(t, e, n = !1) {
        if (n && this.containsPosition(t)) return [new ml(this.start, t), new ml(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
        {
          const n = new ml(this.start, this.end);
          return n.start = n.start._getTransformedByInsertion(t, e), n.end = n.end._getTransformedByInsertion(t, e), [n];
        }
      }
      _getTransformedByMove(t, e, n, o = !1) {
        if (this.isCollapsed) {
          const o = this.start._getTransformedByMove(t, e, n);
          return [new ml(o)];
        }
        const i = ml._createFromPositionAndShift(t, n),
          r = e._getTransformedByDeletion(t, n);
        if (this.containsPosition(e) && !o && (i.containsPosition(this.start) || i.containsPosition(this.end))) {
          const o = this.start._getTransformedByMove(t, e, n),
            i = this.end._getTransformedByMove(t, e, n);
          return [new ml(o, i)];
        }
        let s;
        const a = this.getDifference(i);
        let c = null;
        const l = this.getIntersection(i);
        if (1 == a.length ? c = new ml(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (c = new ml(this.start, this.end._getTransformedByDeletion(t, n))), s = c ? c._getTransformedByInsertion(r, n, null !== l || o) : [], l) {
          const t = new ml(l.start._getCombined(i.start, r), l.end._getCombined(i.start, r));
          2 == s.length ? s.splice(1, 0, t) : s.push(t);
        }
        return s;
      }
      _getTransformedByDeletion(t, e) {
        let n = this.start._getTransformedByDeletion(t, e),
          o = this.end._getTransformedByDeletion(t, e);
        return null == n && null == o ? null : (null == n && (n = t), null == o && (o = t), new ml(n, o));
      }
      static _createFromPositionAndShift(t, e) {
        const n = t,
          o = t.getShiftedBy(e);
        return e > 0 ? new this(n, o) : new this(o, n);
      }
      static _createIn(t) {
        return new this(cl._createAt(t, 0), cl._createAt(t, t.maxOffset));
      }
      static _createOn(t) {
        return this._createFromPositionAndShift(cl._createBefore(t), t.offsetSize);
      }
      static _createFromRanges(t) {
        if (0 === t.length) throw new w("range-create-from-ranges-empty-array", null);
        if (1 == t.length) return t[0].clone();
        const e = t[0];
        t.sort((t, e) => t.start.isAfter(e.start) ? 1 : -1);
        const n = t.indexOf(e),
          o = new this(e.start, e.end);
        if (n > 0) for (let e = n - 1; t[e].end.isEqual(o.start); e++) o.start = cl._createAt(t[e].start);
        for (let e = n + 1; e < t.length && t[e].start.isEqual(o.end); e++) o.end = cl._createAt(t[e].end);
        return o;
      }
      static fromJSON(t, e) {
        return new this(cl.fromJSON(t.start, e), cl.fromJSON(t.end, e));
      }
    }
    ml.prototype.is = function (t) {
      return "range" === t || "model:range" === t;
    };
    class pl extends M() {
      constructor() {
        super(), this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._deferredBindingRemovals = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", (t, e) => {
          if (e.viewPosition) return;
          const n = this._modelToViewMapping.get(e.modelPosition.parent);
          if (!n) throw new w("mapping-model-position-view-parent-not-found", this, {
            modelPosition: e.modelPosition
          });
          e.viewPosition = this.findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", (t, e) => {
          if (e.modelPosition) return;
          const n = this.findMappedViewAncestor(e.viewPosition),
            o = this._viewToModelMapping.get(n),
            i = this._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);
          e.modelPosition = cl._createAt(o, i);
        }, {
          priority: "low"
        });
      }
      bindElements(t, e) {
        this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
      }
      unbindViewElement(t, e = {}) {
        const n = this.toModelElement(t);
        if (this._elementToMarkerNames.has(t)) for (const e of this._elementToMarkerNames.get(t)) this._unboundMarkerNames.add(e);
        e.defer ? this._deferredBindingRemovals.set(t, t.root) : (this._viewToModelMapping.delete(t), this._modelToViewMapping.get(n) == t && this._modelToViewMapping.delete(n));
      }
      unbindModelElement(t) {
        const e = this.toViewElement(t);
        this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
      }
      bindElementToMarker(t, e) {
        const n = this._markerNameToElements.get(e) || new Set();
        n.add(t);
        const o = this._elementToMarkerNames.get(t) || new Set();
        o.add(e), this._markerNameToElements.set(e, n), this._elementToMarkerNames.set(t, o);
      }
      unbindElementFromMarkerName(t, e) {
        const n = this._markerNameToElements.get(e);
        n && (n.delete(t), 0 == n.size && this._markerNameToElements.delete(e));
        const o = this._elementToMarkerNames.get(t);
        o && (o.delete(e), 0 == o.size && this._elementToMarkerNames.delete(t));
      }
      flushUnboundMarkerNames() {
        const t = Array.from(this._unboundMarkerNames);
        return this._unboundMarkerNames.clear(), t;
      }
      flushDeferredBindings() {
        for (const [t, e] of this._deferredBindingRemovals) t.root == e && this.unbindViewElement(t);
        this._deferredBindingRemovals = new Map();
      }
      clearBindings() {
        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this._deferredBindingRemovals = new Map();
      }
      toModelElement(t) {
        return this._viewToModelMapping.get(t);
      }
      toViewElement(t) {
        return this._modelToViewMapping.get(t);
      }
      toModelRange(t) {
        return new ml(this.toModelPosition(t.start), this.toModelPosition(t.end));
      }
      toViewRange(t) {
        return new Ys(this.toViewPosition(t.start), this.toViewPosition(t.end));
      }
      toModelPosition(t) {
        const e = {
          viewPosition: t,
          mapper: this
        };
        return this.fire("viewToModelPosition", e), e.modelPosition;
      }
      toViewPosition(t, e = {}) {
        const n = {
          modelPosition: t,
          mapper: this,
          isPhantom: e.isPhantom
        };
        return this.fire("modelToViewPosition", n), n.viewPosition;
      }
      markerNameToElements(t) {
        const e = this._markerNameToElements.get(t);
        if (!e) return null;
        const n = new Set();
        for (const t of e) if (t.is("attributeElement")) for (const e of t.getElementsWithSameId()) n.add(e);else n.add(t);
        return n;
      }
      registerViewToModelLength(t, e) {
        this._viewToModelLengthCallbacks.set(t, e);
      }
      findMappedViewAncestor(t) {
        let e = t.parent;
        for (; !this._viewToModelMapping.has(e);) e = e.parent;
        return e;
      }
      _toModelOffset(t, e, n) {
        if (n != t) {
          return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
        }
        if (t.is("$text")) return e;
        let o = 0;
        for (let n = 0; n < e; n++) o += this.getModelLength(t.getChild(n));
        return o;
      }
      getModelLength(t) {
        if (this._viewToModelLengthCallbacks.get(t.name)) {
          return this._viewToModelLengthCallbacks.get(t.name)(t);
        }
        if (this._viewToModelMapping.has(t)) return 1;
        if (t.is("$text")) return t.data.length;
        if (t.is("uiElement")) return 0;
        {
          let e = 0;
          for (const n of t.getChildren()) e += this.getModelLength(n);
          return e;
        }
      }
      findPositionIn(t, e) {
        let n,
          o = 0,
          i = 0,
          r = 0;
        if (t.is("$text")) return new $s(t, e);
        for (; i < e;) n = t.getChild(r), o = this.getModelLength(n), i += o, r++;
        return i == e ? this._moveViewPositionToTextNode(new $s(t, r)) : this.findPositionIn(n, e - (i - o));
      }
      _moveViewPositionToTextNode(t) {
        const e = t.nodeBefore,
          n = t.nodeAfter;
        return e instanceof is ? new $s(e, e.data.length) : n instanceof is ? new $s(n, 0) : t;
      }
    }
    class fl {
      constructor() {
        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }
      add(t, e) {
        e = kl(e), t instanceof il && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
      }
      consume(t, e) {
        return e = kl(e), t instanceof il && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
      }
      test(t, e) {
        e = kl(e), t instanceof il && (t = this._getSymbolForTextProxy(t));
        const n = this._consumable.get(t);
        if (void 0 === n) return null;
        const o = n.get(e);
        return void 0 === o ? null : o;
      }
      revert(t, e) {
        e = kl(e), t instanceof il && (t = this._getSymbolForTextProxy(t));
        const n = this.test(t, e);
        return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
      }
      verifyAllConsumed(t) {
        const e = [];
        for (const [n, o] of this._consumable) for (const [i, r] of o) {
          const o = i.split(":")[0];
          r && t == o && e.push({
            event: i,
            item: n.name || n.description
          });
        }
        if (e.length) throw new w("conversion-model-consumable-not-consumed", null, {
          items: e
        });
      }
      _getSymbolForTextProxy(t) {
        let e = null;
        const n = this._textProxyRegistry.get(t.startOffset);
        if (n) {
          const o = n.get(t.endOffset);
          o && (e = o.get(t.parent));
        }
        return e || (e = this._addSymbolForTextProxy(t)), e;
      }
      _addSymbolForTextProxy(t) {
        const e = t.startOffset,
          n = t.endOffset,
          o = t.parent,
          i = Symbol("$textProxy:" + t.data);
        let r, s;
        return r = this._textProxyRegistry.get(e), r || (r = new Map(), this._textProxyRegistry.set(e, r)), s = r.get(n), s || (s = new Map(), r.set(n, s)), s.set(o, i), i;
      }
    }
    function kl(t) {
      const e = t.split(":");
      return "insert" == e[0] ? e[0] : "addMarker" == e[0] || "removeMarker" == e[0] ? t : e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }
    var bl = Object.defineProperty,
      wl = Object.defineProperties,
      Al = Object.getOwnPropertyDescriptors,
      _l = Object.getOwnPropertySymbols,
      Cl = Object.prototype.hasOwnProperty,
      vl = Object.prototype.propertyIsEnumerable,
      yl = (t, e, n) => e in t ? bl(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      xl = (t, e) => {
        for (var n in e || (e = {})) Cl.call(e, n) && yl(t, n, e[n]);
        if (_l) for (var n of _l(e)) vl.call(e, n) && yl(t, n, e[n]);
        return t;
      },
      El = (t, e) => wl(t, Al(e));
    class Dl extends M() {
      constructor(t) {
        super(), this._conversionApi = xl({
          dispatcher: this
        }, t), this._firedEventsMap = new WeakMap();
      }
      convertChanges(t, e, n) {
        const o = this._createConversionApi(n, t.getRefreshedItems());
        for (const e of t.getMarkersToRemove()) this._convertMarkerRemove(e.name, e.range, o);
        const i = this._reduceChanges(t.getChanges());
        for (const t of i) "insert" === t.type ? this._convertInsert(ml._createFromPositionAndShift(t.position, t.length), o) : "reinsert" === t.type ? this._convertReinsert(ml._createFromPositionAndShift(t.position, t.length), o) : "remove" === t.type ? this._convertRemove(t.position, t.length, t.name, o) : this._convertAttribute(t.range, t.attributeKey, t.attributeOldValue, t.attributeNewValue, o);
        o.mapper.flushDeferredBindings();
        for (const t of o.mapper.flushUnboundMarkerNames()) {
          const n = e.get(t).getRange();
          this._convertMarkerRemove(t, n, o), this._convertMarkerAdd(t, n, o);
        }
        for (const e of t.getMarkersToAdd()) this._convertMarkerAdd(e.name, e.range, o);
        o.consumable.verifyAllConsumed("insert");
      }
      convert(t, e, n, o = {}) {
        const i = this._createConversionApi(n, void 0, o);
        this._convertInsert(t, i);
        for (const [t, n] of e) this._convertMarkerAdd(t, n, i);
        i.consumable.verifyAllConsumed("insert");
      }
      convertSelection(t, e, n) {
        const o = this._createConversionApi(n);
        this.fire("cleanSelection", {
          selection: t
        }, o);
        const i = t.getFirstPosition().root;
        if (!o.mapper.toViewElement(i)) return;
        const r = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));
        if (this._addConsumablesForSelection(o.consumable, t, r), this.fire("selection", {
          selection: t
        }, o), t.isCollapsed) {
          for (const e of r) if (o.consumable.test(t, "addMarker:" + e.name)) {
            const n = e.getRange();
            if (!Il(t.getFirstPosition(), e, o.mapper)) continue;
            const i = {
              item: t,
              markerName: e.name,
              markerRange: n
            };
            this.fire(`addMarker:${e.name}`, i, o);
          }
          for (const e of t.getAttributeKeys()) if (o.consumable.test(t, "attribute:" + e)) {
            const n = {
              item: t,
              range: t.getFirstRange(),
              attributeKey: e,
              attributeOldValue: null,
              attributeNewValue: t.getAttribute(e)
            };
            this.fire(`attribute:${e}:$text`, n, o);
          }
        }
      }
      _convertInsert(t, e, n = {}) {
        n.doNotAddConsumables || this._addConsumablesForInsert(e.consumable, t);
        for (const n of Array.from(t.getWalker({
          shallow: !0
        })).map(Tl)) this._testAndFire("insert", n, e);
      }
      _convertRemove(t, e, n, o) {
        this.fire(`remove:${n}`, {
          position: t,
          length: e
        }, o);
      }
      _convertAttribute(t, e, n, o, i) {
        this._addConsumablesForRange(i.consumable, t, `attribute:${e}`);
        for (const r of t) {
          const t = {
            item: r.item,
            range: ml._createFromPositionAndShift(r.previousPosition, r.length),
            attributeKey: e,
            attributeOldValue: n,
            attributeNewValue: o
          };
          this._testAndFire(`attribute:${e}`, t, i);
        }
      }
      _convertReinsert(t, e) {
        const n = Array.from(t.getWalker({
          shallow: !0
        }));
        this._addConsumablesForInsert(e.consumable, n);
        for (const t of n.map(Tl)) this._testAndFire("insert", El(xl({}, t), {
          reconversion: !0
        }), e);
      }
      _convertMarkerAdd(t, e, n) {
        if ("$graveyard" == e.root.rootName) return;
        const o = `addMarker:${t}`;
        if (n.consumable.add(e, o), this.fire(o, {
          markerName: t,
          markerRange: e
        }, n), n.consumable.consume(e, o)) {
          this._addConsumablesForRange(n.consumable, e, o);
          for (const i of e.getItems()) {
            if (!n.consumable.test(i, o)) continue;
            const r = {
              item: i,
              range: ml._createOn(i),
              markerName: t,
              markerRange: e
            };
            this.fire(o, r, n);
          }
        }
      }
      _convertMarkerRemove(t, e, n) {
        "$graveyard" != e.root.rootName && this.fire(`removeMarker:${t}`, {
          markerName: t,
          markerRange: e
        }, n);
      }
      _reduceChanges(t) {
        const e = {
          changes: t
        };
        return this.fire("reduceChanges", e), e.changes;
      }
      _addConsumablesForInsert(t, e) {
        for (const n of e) {
          const e = n.item;
          if (null === t.test(e, "insert")) {
            t.add(e, "insert");
            for (const n of e.getAttributeKeys()) t.add(e, "attribute:" + n);
          }
        }
        return t;
      }
      _addConsumablesForRange(t, e, n) {
        for (const o of e.getItems()) t.add(o, n);
        return t;
      }
      _addConsumablesForSelection(t, e, n) {
        t.add(e, "selection");
        for (const o of n) t.add(e, "addMarker:" + o.name);
        for (const n of e.getAttributeKeys()) t.add(e, "attribute:" + n);
        return t;
      }
      _testAndFire(t, e, n) {
        const o = function (t, e) {
            const n = e.item.is("element") ? e.item.name : "$text";
            return `${t}:${n}`;
          }(t, e),
          i = e.item.is("$textProxy") ? n.consumable._getSymbolForTextProxy(e.item) : e.item,
          r = this._firedEventsMap.get(n),
          s = r.get(i);
        if (s) {
          if (s.has(o)) return;
          s.add(o);
        } else r.set(i, new Set([o]));
        this.fire(o, e, n);
      }
      _testAndFireAddAttributes(t, e) {
        const n = {
          item: t,
          range: ml._createOn(t)
        };
        for (const t of n.item.getAttributeKeys()) n.attributeKey = t, n.attributeOldValue = null, n.attributeNewValue = n.item.getAttribute(t), this._testAndFire(`attribute:${t}`, n, e);
      }
      _createConversionApi(t, e = new Set(), n = {}) {
        const o = El(xl({}, this._conversionApi), {
          consumable: new fl(),
          writer: t,
          options: n,
          convertItem: t => this._convertInsert(ml._createOn(t), o),
          convertChildren: t => this._convertInsert(ml._createIn(t), o, {
            doNotAddConsumables: !0
          }),
          convertAttributes: t => this._testAndFireAddAttributes(t, o),
          canReuseView: t => !e.has(o.mapper.toModelElement(t))
        });
        return this._firedEventsMap.set(o, new Map()), o;
      }
    }
    function Il(t, e, n) {
      const o = e.getRange(),
        i = Array.from(t.getAncestors());
      i.shift(), i.reverse();
      return !i.some(t => {
        if (o.containsItem(t)) {
          return !!n.toViewElement(t).getCustomProperty("addHighlight");
        }
      });
    }
    function Tl(t) {
      return {
        item: t.item,
        range: ml._createFromPositionAndShift(t.previousPosition, t.length)
      };
    }
    class Ml extends M(tl) {
      constructor(...t) {
        super(), this._lastRangeBackward = !1, this._attrs = new Map(), this._ranges = [], t.length && this.setTo(...t);
      }
      get anchor() {
        if (this._ranges.length > 0) {
          const t = this._ranges[this._ranges.length - 1];
          return this._lastRangeBackward ? t.end : t.start;
        }
        return null;
      }
      get focus() {
        if (this._ranges.length > 0) {
          const t = this._ranges[this._ranges.length - 1];
          return this._lastRangeBackward ? t.start : t.end;
        }
        return null;
      }
      get isCollapsed() {
        return 1 === this._ranges.length && this._ranges[0].isCollapsed;
      }
      get rangeCount() {
        return this._ranges.length;
      }
      get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
      }
      isEqual(t) {
        if (this.rangeCount != t.rangeCount) return !1;
        if (0 === this.rangeCount) return !0;
        if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
        for (const e of this._ranges) {
          let n = !1;
          for (const o of t._ranges) if (e.isEqual(o)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      *getRanges() {
        for (const t of this._ranges) yield new ml(t.start, t.end);
      }
      getFirstRange() {
        let t = null;
        for (const e of this._ranges) t && !e.start.isBefore(t.start) || (t = e);
        return t ? new ml(t.start, t.end) : null;
      }
      getLastRange() {
        let t = null;
        for (const e of this._ranges) t && !e.end.isAfter(t.end) || (t = e);
        return t ? new ml(t.start, t.end) : null;
      }
      getFirstPosition() {
        const t = this.getFirstRange();
        return t ? t.start.clone() : null;
      }
      getLastPosition() {
        const t = this.getLastRange();
        return t ? t.end.clone() : null;
      }
      setTo(...t) {
        let [e, n, o] = t;
        if ("object" == typeof n && (o = n, n = void 0), null === e) this._setRanges([]);else if (e instanceof Ml) this._setRanges(e.getRanges(), e.isBackward);else if (e && "function" == typeof e.getRanges) this._setRanges(e.getRanges(), e.isBackward);else if (e instanceof ml) this._setRanges([e], !!o && !!o.backward);else if (e instanceof cl) this._setRanges([new ml(e)]);else if (e instanceof el) {
          const t = !!o && !!o.backward;
          let i;
          if ("in" == n) i = ml._createIn(e);else if ("on" == n) i = ml._createOn(e);else {
            if (void 0 === n) throw new w("model-selection-setto-required-second-parameter", [this, e]);
            i = new ml(cl._createAt(e, n));
          }
          this._setRanges([i], t);
        } else {
          if (!tt(e)) throw new w("model-selection-setto-not-selectable", [this, e]);
          this._setRanges(e, o && !!o.backward);
        }
      }
      _setRanges(t, e = !1) {
        const n = Array.from(t),
          o = n.some(e => {
            if (!(e instanceof ml)) throw new w("model-selection-set-ranges-not-range", [this, t]);
            return this._ranges.every(t => !t.isEqual(e));
          });
        (n.length !== this._ranges.length || o) && (this._replaceAllRanges(n), this._lastRangeBackward = !!e, this.fire("change:range", {
          directChange: !0
        }));
      }
      setFocus(t, e) {
        if (null === this.anchor) throw new w("model-selection-setfocus-no-ranges", [this, t]);
        const n = cl._createAt(t, e);
        if ("same" == n.compareWith(this.focus)) return;
        const o = this.anchor;
        this._ranges.length && this._popRange(), "before" == n.compareWith(o) ? (this._pushRange(new ml(n, o)), this._lastRangeBackward = !0) : (this._pushRange(new ml(o, n)), this._lastRangeBackward = !1), this.fire("change:range", {
          directChange: !0
        });
      }
      getAttribute(t) {
        return this._attrs.get(t);
      }
      getAttributes() {
        return this._attrs.entries();
      }
      getAttributeKeys() {
        return this._attrs.keys();
      }
      hasAttribute(t) {
        return this._attrs.has(t);
      }
      removeAttribute(t) {
        this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
          attributeKeys: [t],
          directChange: !0
        }));
      }
      setAttribute(t, e) {
        this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
          attributeKeys: [t],
          directChange: !0
        }));
      }
      getSelectedElement() {
        return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
      }
      *getSelectedBlocks() {
        const t = new WeakSet();
        for (const e of this.getRanges()) {
          const n = Nl(e.start, t);
          Ol(n, e) && (yield n);
          for (const n of e.getWalker()) {
            const o = n.item;
            "elementEnd" == n.type && Bl(o, t, e) && (yield o);
          }
          const o = Nl(e.end, t);
          Ll(o, e) && (yield o);
        }
      }
      containsEntireContent(t = this.anchor.root) {
        const e = cl._createAt(t, 0),
          n = cl._createAt(t, "end");
        return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
      }
      _pushRange(t) {
        this._checkRange(t), this._ranges.push(new ml(t.start, t.end));
      }
      _checkRange(t) {
        for (let e = 0; e < this._ranges.length; e++) if (t.isIntersecting(this._ranges[e])) throw new w("model-selection-range-intersects", [this, t], {
          addedRange: t,
          intersectingRange: this._ranges[e]
        });
      }
      _replaceAllRanges(t) {
        this._removeAllRanges();
        for (const e of t) this._pushRange(e);
      }
      _removeAllRanges() {
        for (; this._ranges.length > 0;) this._popRange();
      }
      _popRange() {
        this._ranges.pop();
      }
    }
    function Sl(t, e) {
      return !e.has(t) && (e.add(t), t.root.document.model.schema.isBlock(t) && !!t.parent);
    }
    function Bl(t, e, n) {
      return Sl(t, e) && Pl(t, n);
    }
    function Nl(t, e) {
      const n = t.parent.root.document.model.schema,
        o = t.parent.getAncestors({
          parentFirst: !0,
          includeSelf: !0
        });
      let i = !1;
      const r = o.find(t => !i && (i = n.isLimit(t), !i && Sl(t, e)));
      return o.forEach(t => e.add(t)), r;
    }
    function Pl(t, e) {
      const n = function (t) {
        const e = t.root.document.model.schema;
        let n = t.parent;
        for (; n;) {
          if (e.isBlock(n)) return n;
          n = n.parent;
        }
      }(t);
      if (!n) return !0;
      return !e.containsRange(ml._createOn(n), !0);
    }
    function Ol(t, e) {
      return !!t && (!(!e.isCollapsed && !t.isEmpty) || !e.start.isTouching(cl._createAt(t, t.maxOffset)) && Pl(t, e));
    }
    function Ll(t, e) {
      return !!t && (!(!e.isCollapsed && !t.isEmpty) || !e.end.isTouching(cl._createAt(t, 0)) && Pl(t, e));
    }
    Ml.prototype.is = function (t) {
      return "selection" === t || "model:selection" === t;
    };
    class zl extends M(ml) {
      constructor(t, e) {
        super(t, e), Rl.call(this);
      }
      detach() {
        this.stopListening();
      }
      toRange() {
        return new ml(this.start, this.end);
      }
      static fromRange(t) {
        return new zl(t.start, t.end);
      }
    }
    function Rl() {
      this.listenTo(this.root.document.model, "applyOperation", (t, e) => {
        const n = e[0];
        n.isDocumentOperation && jl.call(this, n);
      }, {
        priority: "low"
      });
    }
    function jl(t) {
      const e = this.getTransformedByOperation(t),
        n = ml._createFromRanges(e),
        o = !n.isEqual(this),
        i = function (t, e) {
          switch (e.type) {
            case "insert":
              return t.containsPosition(e.position);
            case "move":
            case "remove":
            case "reinsert":
            case "merge":
              return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);
            case "split":
              return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
          }
          return !1;
        }(this, t);
      let r = null;
      if (o) {
        "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);
        const e = this.toRange();
        this.start = n.start, this.end = n.end, this.fire("change:range", e, {
          deletionPosition: r
        });
      } else i && this.fire("change:content", this.toRange(), {
        deletionPosition: r
      });
    }
    zl.prototype.is = function (t) {
      return "liveRange" === t || "model:liveRange" === t || "range" == t || "model:range" === t;
    };
    const Fl = "selection:";
    class Vl extends M(tl) {
      constructor(t) {
        super(), this._selection = new Hl(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
      }
      get isCollapsed() {
        return this._selection.isCollapsed;
      }
      get anchor() {
        return this._selection.anchor;
      }
      get focus() {
        return this._selection.focus;
      }
      get rangeCount() {
        return this._selection.rangeCount;
      }
      get hasOwnRange() {
        return this._selection.hasOwnRange;
      }
      get isBackward() {
        return this._selection.isBackward;
      }
      get isGravityOverridden() {
        return this._selection.isGravityOverridden;
      }
      get markers() {
        return this._selection.markers;
      }
      get _ranges() {
        return this._selection._ranges;
      }
      getRanges() {
        return this._selection.getRanges();
      }
      getFirstPosition() {
        return this._selection.getFirstPosition();
      }
      getLastPosition() {
        return this._selection.getLastPosition();
      }
      getFirstRange() {
        return this._selection.getFirstRange();
      }
      getLastRange() {
        return this._selection.getLastRange();
      }
      getSelectedBlocks() {
        return this._selection.getSelectedBlocks();
      }
      getSelectedElement() {
        return this._selection.getSelectedElement();
      }
      containsEntireContent(t) {
        return this._selection.containsEntireContent(t);
      }
      destroy() {
        this._selection.destroy();
      }
      getAttributeKeys() {
        return this._selection.getAttributeKeys();
      }
      getAttributes() {
        return this._selection.getAttributes();
      }
      getAttribute(t) {
        return this._selection.getAttribute(t);
      }
      hasAttribute(t) {
        return this._selection.hasAttribute(t);
      }
      refresh() {
        this._selection.updateMarkers(), this._selection._updateAttributes(!1);
      }
      observeMarkers(t) {
        this._selection.observeMarkers(t);
      }
      _setFocus(t, e) {
        this._selection.setFocus(t, e);
      }
      _setTo(...t) {
        this._selection.setTo(...t);
      }
      _setAttribute(t, e) {
        this._selection.setAttribute(t, e);
      }
      _removeAttribute(t) {
        this._selection.removeAttribute(t);
      }
      _getStoredAttributes() {
        return this._selection.getStoredAttributes();
      }
      _overrideGravity() {
        return this._selection.overrideGravity();
      }
      _restoreGravity(t) {
        this._selection.restoreGravity(t);
      }
      static _getStoreAttributeKey(t) {
        return Fl + t;
      }
      static _isStoreAttributeKey(t) {
        return t.startsWith(Fl);
      }
    }
    Vl.prototype.is = function (t) {
      return "selection" === t || "model:selection" == t || "documentSelection" == t || "model:documentSelection" == t;
    };
    class Hl extends Ml {
      constructor(t) {
        super(), this.markers = new Gi({
          idProperty: "name"
        }), this._attributePriority = new Map(), this._selectionRestorePosition = null, this._hasChangedRange = !1, this._overriddenGravityRegister = new Set(), this._observedMarkers = new Set(), this._model = t.model, this._document = t, this.listenTo(this._model, "applyOperation", (t, e) => {
          const n = e[0];
          n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type && (0 == this._ranges.length && this._selectionRestorePosition && this._fixGraveyardSelection(this._selectionRestorePosition), this._selectionRestorePosition = null, this._hasChangedRange && (this._hasChangedRange = !1, this.fire("change:range", {
            directChange: !1
          })));
        }, {
          priority: "lowest"
        }), this.on("change:range", () => {
          this._validateSelectionRanges(this.getRanges());
        }), this.listenTo(this._model.markers, "update", (t, e, n, o) => {
          this._updateMarker(e, o);
        }), this.listenTo(this._document, "change", (t, e) => {
          !function (t, e) {
            const n = t.document.differ;
            for (const o of n.getChanges()) {
              if ("insert" != o.type) continue;
              const n = o.position.parent;
              o.length === n.maxOffset && t.enqueueChange(e, t => {
                const e = Array.from(n.getAttributeKeys()).filter(t => t.startsWith(Fl));
                for (const o of e) t.removeAttribute(o, n);
              });
            }
          }(this._model, e);
        });
      }
      get isCollapsed() {
        return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
      }
      get anchor() {
        return super.anchor || this._document._getDefaultRange().start;
      }
      get focus() {
        return super.focus || this._document._getDefaultRange().end;
      }
      get rangeCount() {
        return this._ranges.length ? this._ranges.length : 1;
      }
      get hasOwnRange() {
        return this._ranges.length > 0;
      }
      get isGravityOverridden() {
        return !!this._overriddenGravityRegister.size;
      }
      destroy() {
        for (let t = 0; t < this._ranges.length; t++) this._ranges[t].detach();
        this.stopListening();
      }
      *getRanges() {
        this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
      }
      getFirstRange() {
        return super.getFirstRange() || this._document._getDefaultRange();
      }
      getLastRange() {
        return super.getLastRange() || this._document._getDefaultRange();
      }
      setTo(...t) {
        super.setTo(...t), this._updateAttributes(!0), this.updateMarkers();
      }
      setFocus(t, e) {
        super.setFocus(t, e), this._updateAttributes(!0), this.updateMarkers();
      }
      setAttribute(t, e) {
        if (this._setAttribute(t, e)) {
          const e = [t];
          this.fire("change:attribute", {
            attributeKeys: e,
            directChange: !0
          });
        }
      }
      removeAttribute(t) {
        if (this._removeAttribute(t)) {
          const e = [t];
          this.fire("change:attribute", {
            attributeKeys: e,
            directChange: !0
          });
        }
      }
      overrideGravity() {
        const t = p();
        return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
      }
      restoreGravity(t) {
        if (!this._overriddenGravityRegister.has(t)) throw new w("document-selection-gravity-wrong-restore", this, {
          uid: t
        });
        this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
      }
      observeMarkers(t) {
        this._observedMarkers.add(t), this.updateMarkers();
      }
      _replaceAllRanges(t) {
        this._validateSelectionRanges(t), super._replaceAllRanges(t);
      }
      _popRange() {
        this._ranges.pop().detach();
      }
      _pushRange(t) {
        const e = this._prepareRange(t);
        e && this._ranges.push(e);
      }
      _validateSelectionRanges(t) {
        for (const e of t) if (!this._document._validateSelectionRange(e)) throw new w("document-selection-wrong-position", this, {
          range: e
        });
      }
      _prepareRange(t) {
        if (this._checkRange(t), t.root == this._document.graveyard) return;
        const e = zl.fromRange(t);
        return e.on("change:range", (t, n, o) => {
          if (this._hasChangedRange = !0, e.root == this._document.graveyard) {
            this._selectionRestorePosition = o.deletionPosition;
            const t = this._ranges.indexOf(e);
            this._ranges.splice(t, 1), e.detach();
          }
        }), e;
      }
      updateMarkers() {
        if (!this._observedMarkers.size) return;
        const t = [];
        let e = !1;
        for (const e of this._model.markers) {
          const n = e.name.split(":", 1)[0];
          if (!this._observedMarkers.has(n)) continue;
          const o = e.getRange();
          for (const n of this.getRanges()) o.containsRange(n, !n.isCollapsed) && t.push(e);
        }
        const n = Array.from(this.markers);
        for (const n of t) this.markers.has(n) || (this.markers.add(n), e = !0);
        for (const n of Array.from(this.markers)) t.includes(n) || (this.markers.remove(n), e = !0);
        e && this.fire("change:marker", {
          oldMarkers: n,
          directChange: !1
        });
      }
      _updateMarker(t, e) {
        const n = t.name.split(":", 1)[0];
        if (!this._observedMarkers.has(n)) return;
        let o = !1;
        const i = Array.from(this.markers),
          r = this.markers.has(t);
        if (e) {
          let n = !1;
          for (const t of this.getRanges()) if (e.containsRange(t, !t.isCollapsed)) {
            n = !0;
            break;
          }
          n && !r ? (this.markers.add(t), o = !0) : !n && r && (this.markers.remove(t), o = !0);
        } else r && (this.markers.remove(t), o = !0);
        o && this.fire("change:marker", {
          oldMarkers: i,
          directChange: !1
        });
      }
      _updateAttributes(t) {
        const e = Yi(this._getSurroundingAttributes()),
          n = Yi(this.getAttributes());
        if (t) this._attributePriority = new Map(), this._attrs = new Map();else for (const [t, e] of this._attributePriority) "low" == e && (this._attrs.delete(t), this._attributePriority.delete(t));
        this._setAttributesTo(e);
        const o = [];
        for (const [t, e] of this.getAttributes()) n.has(t) && n.get(t) === e || o.push(t);
        for (const [t] of n) this.hasAttribute(t) || o.push(t);
        o.length > 0 && this.fire("change:attribute", {
          attributeKeys: o,
          directChange: !1
        });
      }
      _setAttribute(t, e, n = !0) {
        const o = n ? "normal" : "low";
        if ("low" == o && "normal" == this._attributePriority.get(t)) return !1;
        return super.getAttribute(t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, o), !0);
      }
      _removeAttribute(t, e = !0) {
        const n = e ? "normal" : "low";
        return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!super.hasAttribute(t) && (this._attrs.delete(t), !0));
      }
      _setAttributesTo(t) {
        const e = new Set();
        for (const [e, n] of this.getAttributes()) t.get(e) !== n && this._removeAttribute(e, !1);
        for (const [n, o] of t) {
          this._setAttribute(n, o, !1) && e.add(n);
        }
        return e;
      }
      *getStoredAttributes() {
        const t = this.getFirstPosition().parent;
        if (this.isCollapsed && t.isEmpty) for (const e of t.getAttributeKeys()) if (e.startsWith(Fl)) {
          const n = e.substr(10);
          yield [n, t.getAttribute(e)];
        }
      }
      _getSurroundingAttributes() {
        const t = this.getFirstPosition(),
          e = this._model.schema;
        if ("$graveyard" == t.root.rootName) return null;
        let n = null;
        if (this.isCollapsed) {
          const o = t.textNode ? t.textNode : t.nodeBefore,
            i = t.textNode ? t.textNode : t.nodeAfter;
          if (this.isGravityOverridden || (n = Ul(o, e)), n || (n = Ul(i, e)), !this.isGravityOverridden && !n) {
            let t = o;
            for (; t && !n;) t = t.previousSibling, n = Ul(t, e);
          }
          if (!n) {
            let t = i;
            for (; t && !n;) t = t.nextSibling, n = Ul(t, e);
          }
          n || (n = this.getStoredAttributes());
        } else {
          const t = this.getFirstRange();
          for (const o of t) {
            if (o.item.is("element") && e.isObject(o.item)) {
              n = Ul(o.item, e);
              break;
            }
            if ("text" == o.type) {
              n = o.item.getAttributes();
              break;
            }
          }
        }
        return n;
      }
      _fixGraveyardSelection(t) {
        const e = this._model.schema.getNearestSelectionRange(t);
        e && this._pushRange(e);
      }
    }
    function Ul(t, e) {
      if (!t) return null;
      if (t instanceof il || t instanceof ol) return t.getAttributes();
      if (!e.isInline(t)) return null;
      if (!e.isObject(t)) return [];
      const n = [];
      for (const [o, i] of t.getAttributes()) e.checkAttribute("$text", o) && !1 !== e.getAttributeProperties(o).copyFromObject && n.push([o, i]);
      return n;
    }
    class ql {
      constructor(t) {
        this._dispatchers = t;
      }
      add(t) {
        for (const e of this._dispatchers) t(e);
        return this;
      }
    }
    class Gl extends ql {
      elementToElement(t) {
        return this.add(function (t) {
          const e = Zl(t.model),
            n = Jl(t.view, "container");
          e.attributes.length && (e.children = !0);
          return o => {
            o.on(`insert:${e.name}`, $l(n, od(e)), {
              priority: t.converterPriority || "normal"
            }), (e.children || e.attributes.length) && o.on("reduceChanges", nd(e), {
              priority: "low"
            });
          };
        }(t));
      }
      elementToStructure(t) {
        return this.add(function (t) {
          const e = Zl(t.model),
            n = Jl(t.view, "container");
          return e.children = !0, o => {
            if (o._conversionApi.schema.checkChild(e.name, "$text")) throw new w("conversion-element-to-structure-disallowed-text", o, {
              elementName: e.name
            });
            var i, r;
            o.on(`insert:${e.name}`, (i = n, r = od(e), (t, e, n) => {
              if (!r(e.item, n.consumable, {
                preflight: !0
              })) return;
              const o = new Map();
              n.writer._registerSlotFactory(function (t, e, n) {
                return (o, i) => {
                  const r = o.createContainerElement("$slot");
                  let s = null;
                  if ("children" === i) s = Array.from(t.getChildren());else {
                    if ("function" != typeof i) throw new w("conversion-slot-mode-unknown", n.dispatcher, {
                      modeOrFilter: i
                    });
                    s = Array.from(t.getChildren()).filter(t => i(t));
                  }
                  return e.set(r, s), r;
                };
              }(e.item, o, n));
              const s = i(e.item, n, e);
              if (n.writer._clearSlotFactory(), !s) return;
              !function (t, e, n) {
                const o = Array.from(e.values()).flat(),
                  i = new Set(o);
                if (i.size != o.length) throw new w("conversion-slot-filter-overlap", n.dispatcher, {
                  element: t
                });
                if (i.size != t.childCount) throw new w("conversion-slot-filter-incomplete", n.dispatcher, {
                  element: t
                });
              }(e.item, o, n), r(e.item, n.consumable);
              const a = n.mapper.toViewPosition(e.range.start);
              n.mapper.bindElements(e.item, s), n.writer.insert(a, s), n.convertAttributes(e.item), function (t, e, n, o) {
                n.mapper.on("modelToViewPosition", s, {
                  priority: "highest"
                });
                let i = null,
                  r = null;
                for ([i, r] of e) id(t, r, n, o), n.writer.move(n.writer.createRangeIn(i), n.writer.createPositionBefore(i)), n.writer.remove(i);
                function s(t, e) {
                  const n = e.modelPosition.nodeAfter,
                    o = r.indexOf(n);
                  o < 0 || (e.viewPosition = e.mapper.findPositionIn(i, o));
                }
                n.mapper.off("modelToViewPosition", s);
              }(s, o, n, {
                reconversion: e.reconversion
              });
            }), {
              priority: t.converterPriority || "normal"
            }), o.on("reduceChanges", nd(e), {
              priority: "low"
            });
          };
        }(t));
      }
      attributeToElement(t) {
        return this.add(function (t) {
          t = Jc(t);
          let e = t.model;
          "string" == typeof e && (e = {
            key: e
          });
          let n = `attribute:${e.key}`;
          e.name && (n += ":" + e.name);
          if (e.values) for (const n of e.values) t.view[n] = Jl(t.view[n], "attribute");else t.view = Jl(t.view, "attribute");
          const o = Xl(t);
          return e => {
            e.on(n, Kl(o), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      attributeToAttribute(t) {
        return this.add(function (t) {
          t = Jc(t);
          let e = t.model;
          "string" == typeof e && (e = {
            key: e
          });
          let n = `attribute:${e.key}`;
          e.name && (n += ":" + e.name);
          if (e.values) for (const n of e.values) t.view[n] = td(t.view[n]);else t.view = td(t.view);
          const o = Xl(t);
          return e => {
            var i;
            e.on(n, (i = o, (t, e, n) => {
              if (!n.consumable.test(e.item, t.name)) return;
              const o = i(e.attributeOldValue, n, e),
                r = i(e.attributeNewValue, n, e);
              if (!o && !r) return;
              n.consumable.consume(e.item, t.name);
              const s = n.mapper.toViewElement(e.item),
                a = n.writer;
              if (!s) throw new w("conversion-attribute-to-attribute-on-text", n.dispatcher, e);
              if (null !== e.attributeOldValue && o) if ("class" == o.key) {
                const t = "string" == typeof o.value ? o.value.split(/\s+/) : o.value;
                for (const e of t) a.removeClass(e, s);
              } else if ("style" == o.key) {
                if ("string" == typeof o.value) {
                  const t = new Ls(a.document.stylesProcessor);
                  t.setTo(o.value);
                  for (const [e] of t.getStylesEntries()) a.removeStyle(e, s);
                } else {
                  const t = Object.keys(o.value);
                  for (const e of t) a.removeStyle(e, s);
                }
              } else a.removeAttribute(o.key, s);
              if (null !== e.attributeNewValue && r) if ("class" == r.key) {
                const t = "string" == typeof r.value ? r.value.split(/\s+/) : r.value;
                for (const e of t) a.addClass(e, s);
              } else if ("style" == r.key) {
                if ("string" == typeof r.value) {
                  const t = new Ls(a.document.stylesProcessor);
                  t.setTo(r.value);
                  for (const [e, n] of t.getStylesEntries()) a.setStyle(e, n, s);
                } else {
                  const t = Object.keys(r.value);
                  for (const e of t) a.setStyle(e, r.value[e], s);
                }
              } else a.setAttribute(r.key, r.value, s);
            }), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      markerToElement(t) {
        return this.add(function (t) {
          const e = Jl(t.view, "ui");
          return n => {
            n.on(`addMarker:${t.model}`, Yl(e), {
              priority: t.converterPriority || "normal"
            }), n.on(`removeMarker:${t.model}`, (t, e, n) => {
              const o = n.mapper.markerNameToElements(e.markerName);
              if (o) {
                for (const t of o) n.mapper.unbindElementFromMarkerName(t, e.markerName), n.writer.clear(n.writer.createRangeOn(t), t);
                n.writer.clearClonedElementsGroup(e.markerName), t.stop();
              }
            }, {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      markerToHighlight(t) {
        return this.add(function (t) {
          return e => {
            var n;
            e.on(`addMarker:${t.model}`, (n = t.view, (t, e, o) => {
              if (!e.item) return;
              if (!(e.item instanceof Ml || e.item instanceof Vl || e.item.is("$textProxy"))) return;
              const i = ed(n, e, o);
              if (!i) return;
              if (!o.consumable.consume(e.item, t.name)) return;
              const r = o.writer,
                s = Wl(r, i),
                a = r.document.selection;
              if (e.item instanceof Ml || e.item instanceof Vl) r.wrap(a.getFirstRange(), s);else {
                const t = o.mapper.toViewRange(e.range),
                  n = r.wrap(t, s);
                for (const t of n.getItems()) if (t.is("attributeElement") && t.isSimilar(s)) {
                  o.mapper.bindElementToMarker(t, e.markerName);
                  break;
                }
              }
            }), {
              priority: t.converterPriority || "normal"
            }), e.on(`addMarker:${t.model}`, function (t) {
              return (e, n, o) => {
                if (!n.item) return;
                if (!(n.item instanceof rl)) return;
                const i = ed(t, n, o);
                if (!i) return;
                if (!o.consumable.test(n.item, e.name)) return;
                const r = o.mapper.toViewElement(n.item);
                if (r && r.getCustomProperty("addHighlight")) {
                  o.consumable.consume(n.item, e.name);
                  for (const t of ml._createIn(n.item)) o.consumable.consume(t.item, e.name);
                  r.getCustomProperty("addHighlight")(r, i, o.writer), o.mapper.bindElementToMarker(r, n.markerName);
                }
              };
            }(t.view), {
              priority: t.converterPriority || "normal"
            }), e.on(`removeMarker:${t.model}`, function (t) {
              return (e, n, o) => {
                if (n.markerRange.isCollapsed) return;
                const i = ed(t, n, o);
                if (!i) return;
                const r = Wl(o.writer, i),
                  s = o.mapper.markerNameToElements(n.markerName);
                if (s) {
                  for (const t of s) if (o.mapper.unbindElementFromMarkerName(t, n.markerName), t.is("attributeElement")) o.writer.unwrap(o.writer.createRangeOn(t), r);else {
                    t.getCustomProperty("removeHighlight")(t, i.id, o.writer);
                  }
                  o.writer.clearClonedElementsGroup(n.markerName), e.stop();
                }
              };
            }(t.view), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      markerToData(t) {
        return this.add(function (t) {
          t = Jc(t);
          const e = t.model;
          let n = t.view;
          n || (n = n => ({
            group: e,
            name: n.substr(t.model.length + 1)
          }));
          return o => {
            var i;
            o.on(`addMarker:${e}`, (i = n, (t, e, n) => {
              const o = i(e.markerName, n);
              if (!o) return;
              const r = e.markerRange;
              n.consumable.consume(r, t.name) && (Ql(r, !1, n, e, o), Ql(r, !0, n, e, o), t.stop());
            }), {
              priority: t.converterPriority || "normal"
            }), o.on(`removeMarker:${e}`, function (t) {
              return (e, n, o) => {
                const i = t(n.markerName, o);
                if (!i) return;
                const r = o.mapper.markerNameToElements(n.markerName);
                if (r) {
                  for (const t of r) o.mapper.unbindElementFromMarkerName(t, n.markerName), t.is("containerElement") ? (s(`data-${i.group}-start-before`, t), s(`data-${i.group}-start-after`, t), s(`data-${i.group}-end-before`, t), s(`data-${i.group}-end-after`, t)) : o.writer.clear(o.writer.createRangeOn(t), t);
                  o.writer.clearClonedElementsGroup(n.markerName), e.stop();
                }
                function s(t, e) {
                  if (e.hasAttribute(t)) {
                    const n = new Set(e.getAttribute(t).split(","));
                    n.delete(i.name), 0 == n.size ? o.writer.removeAttribute(t, e) : o.writer.setAttribute(t, Array.from(n).join(","), e);
                  }
                }
              };
            }(n), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
    }
    function Wl(t, e) {
      const n = t.createAttributeElement("span", e.attributes);
      return e.classes && n._addClass(e.classes), "number" == typeof e.priority && (n._priority = e.priority), n._id = e.id, n;
    }
    function Kl(t) {
      return (e, n, o) => {
        if (!o.consumable.test(n.item, e.name)) return;
        const i = t(n.attributeOldValue, o, n),
          r = t(n.attributeNewValue, o, n);
        if (!i && !r) return;
        o.consumable.consume(n.item, e.name);
        const s = o.writer,
          a = s.document.selection;
        if (n.item instanceof Ml || n.item instanceof Vl) s.wrap(a.getFirstRange(), r);else {
          let t = o.mapper.toViewRange(n.range);
          null !== n.attributeOldValue && i && (t = s.unwrap(t, i)), null !== n.attributeNewValue && r && s.wrap(t, r);
        }
      };
    }
    function $l(t, e = sd) {
      return (n, o, i) => {
        if (!e(o.item, i.consumable, {
          preflight: !0
        })) return;
        const r = t(o.item, i, o);
        if (!r) return;
        e(o.item, i.consumable);
        const s = i.mapper.toViewPosition(o.range.start);
        i.mapper.bindElements(o.item, r), i.writer.insert(s, r), i.convertAttributes(o.item), id(r, o.item.getChildren(), i, {
          reconversion: o.reconversion
        });
      };
    }
    function Yl(t) {
      return (e, n, o) => {
        n.isOpening = !0;
        const i = t(n, o);
        n.isOpening = !1;
        const r = t(n, o);
        if (!i || !r) return;
        const s = n.markerRange;
        if (s.isCollapsed && !o.consumable.consume(s, e.name)) return;
        for (const t of s) if (!o.consumable.consume(t.item, e.name)) return;
        const a = o.mapper,
          c = o.writer;
        c.insert(a.toViewPosition(s.start), i), o.mapper.bindElementToMarker(i, n.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), o.mapper.bindElementToMarker(r, n.markerName)), e.stop();
      };
    }
    function Ql(t, e, n, o, i) {
      const r = e ? t.start : t.end,
        s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
        a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;
      if (s || a) {
        let t, r;
        e && s || !e && !a ? (t = s, r = !0) : (t = a, r = !1);
        const c = n.mapper.toViewElement(t);
        if (c) return void function (t, e, n, o, i, r) {
          const s = `data-${r.group}-${e ? "start" : "end"}-${n ? "before" : "after"}`,
            a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
          a.unshift(r.name), o.writer.setAttribute(s, a.join(","), t), o.mapper.bindElementToMarker(t, i.markerName);
        }(c, e, r, n, o, i);
      }
      !function (t, e, n, o, i) {
        const r = `${i.group}-${e ? "start" : "end"}`,
          s = i.name ? {
            name: i.name
          } : null,
          a = n.writer.createUIElement(r, s);
        n.writer.insert(t, a), n.mapper.bindElementToMarker(a, o.markerName);
      }(n.mapper.toViewPosition(r), e, n, o, i);
    }
    function Zl(t) {
      return "string" == typeof t && (t = {
        name: t
      }), {
        name: t.name,
        attributes: t.attributes ? Ai(t.attributes) : [],
        children: !!t.children
      };
    }
    function Jl(t, e) {
      return "function" == typeof t ? t : (n, o) => function (t, e, n) {
        "string" == typeof t && (t = {
          name: t
        });
        let o;
        const i = e.writer,
          r = Object.assign({}, t.attributes);
        if ("container" == n) o = i.createContainerElement(t.name, r);else if ("attribute" == n) {
          const e = {
            priority: t.priority || aa.DEFAULT_PRIORITY
          };
          o = i.createAttributeElement(t.name, r, e);
        } else o = i.createUIElement(t.name, r);
        if (t.styles) {
          const e = Object.keys(t.styles);
          for (const n of e) i.setStyle(n, t.styles[n], o);
        }
        if (t.classes) {
          const e = t.classes;
          if ("string" == typeof e) i.addClass(e, o);else for (const t of e) i.addClass(t, o);
        }
        return o;
      }(t, o, e);
    }
    function Xl(t) {
      return t.model.values ? (e, n, o) => {
        const i = t.view[e];
        return i ? i(e, n, o) : null;
      } : t.view;
    }
    function td(t) {
      return "string" == typeof t ? e => ({
        key: t,
        value: e
      }) : "object" == typeof t ? t.value ? () => t : e => ({
        key: t.key,
        value: e
      }) : t;
    }
    function ed(t, e, n) {
      const o = "function" == typeof t ? t(e, n) : t;
      return o ? (o.priority || (o.priority = 10), o.id || (o.id = e.markerName), o) : null;
    }
    function nd(t) {
      const e = function (t) {
        return (e, n) => {
          if (!e.is("element", t.name)) return !1;
          if ("attribute" == n.type) {
            if (t.attributes.includes(n.attributeKey)) return !0;
          } else if (t.children) return !0;
          return !1;
        };
      }(t);
      return (t, n) => {
        const o = [];
        n.reconvertedElements || (n.reconvertedElements = new Set());
        for (const t of n.changes) {
          const i = "attribute" == t.type ? t.range.start.nodeAfter : t.position.parent;
          if (i && e(i, t)) {
            if (!n.reconvertedElements.has(i)) {
              n.reconvertedElements.add(i);
              const t = cl._createBefore(i);
              let e = o.length;
              for (let n = o.length - 1; n >= 0; n--) {
                const i = o[n],
                  r = ("attribute" == i.type ? i.range.start : i.position).compareWith(t);
                if ("before" == r || "remove" == i.type && "same" == r) break;
                e = n;
              }
              o.splice(e, 0, {
                type: "remove",
                name: i.name,
                position: t,
                length: 1
              }, {
                type: "reinsert",
                name: i.name,
                position: t,
                length: 1
              });
            }
          } else o.push(t);
        }
        n.changes = o;
      };
    }
    function od(t) {
      return (e, n, o = {}) => {
        const i = ["insert"];
        for (const n of t.attributes) e.hasAttribute(n) && i.push(`attribute:${n}`);
        return !!i.every(t => n.test(e, t)) && (o.preflight || i.forEach(t => n.consume(e, t)), !0);
      };
    }
    function id(t, e, n, o) {
      for (const i of e) rd(t.root, i, n, o) || n.convertItem(i);
    }
    function rd(t, e, n, o) {
      const {
        writer: i,
        mapper: r
      } = n;
      if (!o.reconversion) return !1;
      const s = r.toViewElement(e);
      return !(!s || s.root == t) && !!n.canReuseView(s) && (i.move(i.createRangeOn(s), r.toViewPosition(cl._createBefore(e))), !0);
    }
    function sd(t, e, {
      preflight: n
    } = {}) {
      return n ? e.test(t, "insert") : e.consume(t, "insert");
    }
    function ad(t) {
      const {
        schema: e,
        document: n
      } = t.model;
      for (const o of n.getRoots()) if (o.isEmpty && !e.checkChild(o, "$text") && e.checkChild(o, "paragraph")) return t.insertElement("paragraph", o), !0;
      return !1;
    }
    function cd(t, e, n) {
      const o = n.createContext(t);
      return !!n.checkChild(o, "paragraph") && !!n.checkChild(o.push("paragraph"), e);
    }
    function ld(t, e) {
      const n = e.createElement("paragraph");
      return e.insert(n, t), e.createPositionAt(n, 0);
    }
    var dd = Object.defineProperty,
      ud = Object.defineProperties,
      hd = Object.getOwnPropertyDescriptors,
      gd = Object.getOwnPropertySymbols,
      md = Object.prototype.hasOwnProperty,
      pd = Object.prototype.propertyIsEnumerable,
      fd = (t, e, n) => e in t ? dd(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class kd extends ql {
      elementToElement(t) {
        return this.add(bd(t));
      }
      elementToAttribute(t) {
        return this.add(function (t) {
          t = Jc(t), _d(t);
          const e = Cd(t, !1),
            n = wd(t.view),
            o = n ? `element:${n}` : "element";
          return n => {
            n.on(o, e, {
              priority: t.converterPriority || "low"
            });
          };
        }(t));
      }
      attributeToAttribute(t) {
        return this.add(function (t) {
          t = Jc(t);
          let e = null;
          ("string" == typeof t.view || t.view.key) && (e = function (t) {
            "string" == typeof t.view && (t.view = {
              key: t.view
            });
            const e = t.view.key,
              n = void 0 === t.view.value ? /[\s\S]*/ : t.view.value;
            let o;
            if ("class" == e || "style" == e) {
              const t = "class" == e ? "classes" : "styles";
              o = {
                [t]: n
              };
            } else o = {
              attributes: {
                [e]: n
              }
            };
            t.view.name && (o.name = t.view.name);
            return t.view = o, e;
          }(t));
          _d(t, e);
          const n = Cd(t, !0);
          return e => {
            e.on("element", n, {
              priority: t.converterPriority || "low"
            });
          };
        }(t));
      }
      elementToMarker(t) {
        return this.add(function (t) {
          const e = function (t) {
            return (e, n) => {
              const o = "string" == typeof t ? t : t(e, n);
              return n.writer.createElement("$marker", {
                "data-name": o
              });
            };
          }(t.model);
          return bd((n = ((t, e) => {
            for (var n in e || (e = {})) md.call(e, n) && fd(t, n, e[n]);
            if (gd) for (var n of gd(e)) pd.call(e, n) && fd(t, n, e[n]);
            return t;
          })({}, t), o = {
            model: e
          }, ud(n, hd(o))));
          var n, o;
        }(t));
      }
      dataToMarker(t) {
        return this.add(function (t) {
          t = Jc(t), t.model || (t.model = e => e ? t.view + ":" + e : t.view);
          const e = {
              view: t.view,
              model: t.model
            },
            n = Ad(vd(e, "start")),
            o = Ad(vd(e, "end"));
          return i => {
            i.on(`element:${t.view}-start`, n, {
              priority: t.converterPriority || "normal"
            }), i.on(`element:${t.view}-end`, o, {
              priority: t.converterPriority || "normal"
            });
            const r = f.low,
              s = f.highest,
              a = f.get(t.converterPriority) / s;
            i.on("element", function (t) {
              return (e, n, o) => {
                const i = `data-${t.view}`;
                function r(e, i) {
                  for (const r of i) {
                    const i = t.model(r, o),
                      s = o.writer.createElement("$marker", {
                        "data-name": i
                      });
                    o.writer.insert(s, e), n.modelCursor.isEqual(e) ? n.modelCursor = n.modelCursor.getShiftedBy(1) : n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1), n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
                  }
                }
                (o.consumable.test(n.viewItem, {
                  attributes: i + "-end-after"
                }) || o.consumable.test(n.viewItem, {
                  attributes: i + "-start-after"
                }) || o.consumable.test(n.viewItem, {
                  attributes: i + "-end-before"
                }) || o.consumable.test(n.viewItem, {
                  attributes: i + "-start-before"
                })) && (n.modelRange || Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor)), o.consumable.consume(n.viewItem, {
                  attributes: i + "-end-after"
                }) && r(n.modelRange.end, n.viewItem.getAttribute(i + "-end-after").split(",")), o.consumable.consume(n.viewItem, {
                  attributes: i + "-start-after"
                }) && r(n.modelRange.end, n.viewItem.getAttribute(i + "-start-after").split(",")), o.consumable.consume(n.viewItem, {
                  attributes: i + "-end-before"
                }) && r(n.modelRange.start, n.viewItem.getAttribute(i + "-end-before").split(",")), o.consumable.consume(n.viewItem, {
                  attributes: i + "-start-before"
                }) && r(n.modelRange.start, n.viewItem.getAttribute(i + "-start-before").split(",")));
              };
            }(e), {
              priority: r + a
            });
          };
        }(t));
      }
    }
    function bd(t) {
      const e = Ad(t = Jc(t)),
        n = wd(t.view),
        o = n ? `element:${n}` : "element";
      return n => {
        n.on(o, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function wd(t) {
      return "string" == typeof t ? t : "object" == typeof t && "string" == typeof t.name ? t.name : null;
    }
    function Ad(t) {
      const e = new ss(t.view);
      return (n, o, i) => {
        const r = e.match(o.viewItem);
        if (!r) return;
        const s = r.match;
        if (s.name = !0, !i.consumable.test(o.viewItem, s)) return;
        const a = function (t, e, n) {
          return t instanceof Function ? t(e, n) : n.writer.createElement(t);
        }(t.model, o.viewItem, i);
        a && i.safeInsert(a, o.modelCursor) && (i.consumable.consume(o.viewItem, s), i.convertChildren(o.viewItem, a), i.updateConversionResult(a, o));
      };
    }
    function _d(t, e = null) {
      const n = null === e || (t => t.getAttribute(e)),
        o = "object" != typeof t.model ? t.model : t.model.key,
        i = "object" != typeof t.model || void 0 === t.model.value ? n : t.model.value;
      t.model = {
        key: o,
        value: i
      };
    }
    function Cd(t, e) {
      const n = new ss(t.view);
      return (o, i, r) => {
        if (!i.modelRange && e) return;
        const s = n.match(i.viewItem);
        if (!s) return;
        if (!function (t, e) {
          const n = "function" == typeof t ? t(e) : t;
          if ("object" == typeof n && !wd(n)) return !1;
          return !n.classes && !n.attributes && !n.styles;
        }(t.view, i.viewItem) ? delete s.match.name : s.match.name = !0, !r.consumable.test(i.viewItem, s.match)) return;
        const a = t.model.key,
          c = "function" == typeof t.model.value ? t.model.value(i.viewItem, r) : t.model.value;
        if (null === c) return;
        i.modelRange || Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
        const l = function (t, e, n, o) {
          let i = !1;
          for (const r of Array.from(t.getItems({
            shallow: n
          }))) o.schema.checkAttribute(r, e.key) && (i = !0, r.hasAttribute(e.key) || o.writer.setAttribute(e.key, e.value, r));
          return i;
        }(i.modelRange, {
          key: a,
          value: c
        }, e, r);
        l && (r.consumable.test(i.viewItem, {
          name: !0
        }) && (s.match.name = !0), r.consumable.consume(i.viewItem, s.match));
      };
    }
    function vd(t, e) {
      return {
        view: `${t.view}-${e}`,
        model: (e, n) => {
          const o = e.getAttribute("name"),
            i = t.model(o, n);
          return n.writer.createElement("$marker", {
            "data-name": i
          });
        }
      };
    }
    function yd(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.selection,
          o = e.schema,
          i = [];
        let r = !1;
        for (const t of n.getRanges()) {
          const e = xd(t, o);
          e && !e.isEqual(t) ? (i.push(e), r = !0) : i.push(t);
        }
        r && t.setSelection(function (t) {
          const e = [...t],
            n = new Set();
          let o = 1;
          for (; o < e.length;) {
            const t = e[o],
              i = e.slice(0, o);
            for (const [r, s] of i.entries()) if (!n.has(r)) if (t.isEqual(s)) n.add(r);else if (t.isIntersecting(s)) {
              n.add(r), n.add(o);
              const i = t.getJoined(s);
              e.push(i);
            }
            o++;
          }
          return e.filter((t, e) => !n.has(e));
        }(i), {
          backward: n.isBackward
        });
        return !1;
      }(e, t));
    }
    function xd(t, e) {
      return t.isCollapsed ? function (t, e) {
        const n = t.start,
          o = e.getNearestSelectionRange(n);
        if (!o) {
          const t = n.getAncestors().reverse().find(t => e.isObject(t));
          return t ? ml._createOn(t) : null;
        }
        if (!o.isCollapsed) return o;
        const i = o.start;
        if (n.isEqual(i)) return null;
        return new ml(i);
      }(t, e) : function (t, e) {
        const {
            start: n,
            end: o
          } = t,
          i = e.checkChild(n, "$text"),
          r = e.checkChild(o, "$text"),
          s = e.getLimitElement(n),
          a = e.getLimitElement(o);
        if (s === a) {
          if (i && r) return null;
          if (function (t, e, n) {
            const o = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
              i = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
            return o || i;
          }(n, o, e)) {
            const t = n.nodeAfter && e.isSelectable(n.nodeAfter) ? null : e.getNearestSelectionRange(n, "forward"),
              i = o.nodeBefore && e.isSelectable(o.nodeBefore) ? null : e.getNearestSelectionRange(o, "backward"),
              r = t ? t.start : n,
              s = i ? i.end : o;
            return new ml(r, s);
          }
        }
        const c = s && !s.is("rootElement"),
          l = a && !a.is("rootElement");
        if (c || l) {
          const t = n.nodeAfter && o.nodeBefore && n.nodeAfter.parent === o.nodeBefore.parent,
            i = c && (!t || !Dd(n.nodeAfter, e)),
            r = l && (!t || !Dd(o.nodeBefore, e));
          let d = n,
            u = o;
          return i && (d = cl._createBefore(Ed(s, e))), r && (u = cl._createAfter(Ed(a, e))), new ml(d, u);
        }
        return null;
      }(t, e);
    }
    function Ed(t, e) {
      let n = t,
        o = n;
      for (; e.isLimit(o) && o.parent;) n = o, o = o.parent;
      return n;
    }
    function Dd(t, e) {
      return t && e.isSelectable(t);
    }
    class Id extends G() {
      constructor(t, e) {
        super(), this.model = t, this.view = new Xc(e), this.mapper = new pl(), this.downcastDispatcher = new Dl({
          mapper: this.mapper,
          schema: t.schema
        });
        const n = this.model.document,
          o = n.selection,
          i = this.model.markers;
        var r, a, c;
        this.listenTo(this.model, "_beforeChanges", () => {
          this.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", () => {
          this.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(n, "change", () => {
          this.view.change(t => {
            this.downcastDispatcher.convertChanges(n.differ, i, t), this.downcastDispatcher.convertSelection(o, i, t);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
          return (n, o) => {
            const i = o.newSelection,
              r = [];
            for (const t of i.getRanges()) r.push(e.toModelRange(t));
            const s = t.createSelection(r, {
              backward: i.isBackward
            });
            s.isEqual(t.document.selection) || t.change(t => {
              t.setSelection(s);
            });
          };
        }(this.model, this.mapper)), this.listenTo(this.view.document, "beforeinput", (r = this.mapper, a = this.model.schema, c = this.view, (t, e) => {
          if (!c.document.isComposing || s.isAndroid) for (let t = 0; t < e.targetRanges.length; t++) {
            const n = e.targetRanges[t],
              o = r.toModelRange(n),
              i = xd(o, a);
            i && !i.isEqual(o) && (e.targetRanges[t] = r.toViewRange(i));
          }
        }), {
          priority: "high"
        }), this.downcastDispatcher.on("insert:$text", (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) return;
          const o = n.writer,
            i = n.mapper.toViewPosition(e.range.start),
            r = o.createText(e.item.data);
          o.insert(i, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("insert", (t, e, n) => {
          n.convertAttributes(e.item), e.reconversion || !e.item.is("element") || e.item.isEmpty || n.convertChildren(e.item);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", (t, e, n) => {
          const o = n.mapper.toViewPosition(e.position),
            i = e.position.getShiftedBy(e.length),
            r = n.mapper.toViewPosition(i, {
              isPhantom: !0
            }),
            s = n.writer.createRange(o, r),
            a = n.writer.remove(s.getTrimmed());
          for (const t of n.writer.createRangeIn(a).getItems()) n.mapper.unbindViewElement(t, {
            defer: !0
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("cleanSelection", (t, e, n) => {
          const o = n.writer,
            i = o.document.selection;
          for (const t of i.getRanges()) t.isCollapsed && t.end.parent.isAttached() && n.writer.mergeAttributes(t.start);
          o.setSelection(null);
        }), this.downcastDispatcher.on("selection", (t, e, n) => {
          const o = e.selection;
          if (o.isCollapsed) return;
          if (!n.consumable.consume(o, "selection")) return;
          const i = [];
          for (const t of o.getRanges()) i.push(n.mapper.toViewRange(t));
          n.writer.setSelection(i, {
            backward: o.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", (t, e, n) => {
          const o = e.selection;
          if (!o.isCollapsed) return;
          if (!n.consumable.consume(o, "selection")) return;
          const i = n.writer,
            r = o.getFirstPosition(),
            s = n.mapper.toViewPosition(r),
            a = i.breakAttributes(s);
          i.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(t => {
          if ("$graveyard" == t.rootName) return null;
          const e = new Ws(this.view.document, t.name);
          return e.rootName = t.rootName, this.mapper.bindElements(t, e), e;
        });
      }
      destroy() {
        this.view.destroy(), this.stopListening();
      }
      reconvertMarker(t) {
        const e = "string" == typeof t ? t : t.name,
          n = this.model.markers.get(e);
        if (!n) throw new w("editingcontroller-reconvertmarker-marker-not-exist", this, {
          markerName: e
        });
        this.model.change(() => {
          this.model.markers._refresh(n);
        });
      }
      reconvertItem(t) {
        this.model.change(() => {
          this.model.document.differ._refreshItem(t);
        });
      }
    }
    class Td {
      constructor() {
        this._consumables = new Map();
      }
      add(t, e) {
        let n;
        t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new Sd(t), this._consumables.set(t, n)), n.add(e));
      }
      test(t, e) {
        const n = this._consumables.get(t);
        return void 0 === n ? null : t.is("$text") || t.is("documentFragment") ? n : n.test(e);
      }
      consume(t, e) {
        return !!this.test(t, e) && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
      }
      revert(t, e) {
        const n = this._consumables.get(t);
        void 0 !== n && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
      }
      static consumablesFromElement(t) {
        const e = {
            element: t,
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
          n = t.getAttributeKeys();
        for (const t of n) "style" != t && "class" != t && e.attributes.push(t);
        const o = t.getClassNames();
        for (const t of o) e.classes.push(t);
        const i = t.getStyleNames();
        for (const t of i) e.styles.push(t);
        return e;
      }
      static createFrom(t, e) {
        if (e || (e = new Td()), t.is("$text")) return e.add(t), e;
        t.is("element") && e.add(t, Td.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);
        for (const n of t.getChildren()) e = Td.createFrom(n, e);
        return e;
      }
    }
    const Md = ["attributes", "classes", "styles"];
    class Sd {
      constructor(t) {
        this.element = t, this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }
      add(t) {
        t.name && (this._canConsumeName = !0);
        for (const e of Md) e in t && this._add(e, t[e]);
      }
      test(t) {
        if (t.name && !this._canConsumeName) return this._canConsumeName;
        for (const e of Md) if (e in t) {
          const n = this._test(e, t[e]);
          if (!0 !== n) return n;
        }
        return !0;
      }
      consume(t) {
        t.name && (this._canConsumeName = !1);
        for (const e of Md) e in t && this._consume(e, t[e]);
      }
      revert(t) {
        t.name && (this._canConsumeName = !0);
        for (const e of Md) e in t && this._revert(e, t[e]);
      }
      _add(t, e) {
        const n = Ai(e),
          o = this._consumables[t];
        for (const e of n) {
          if ("attributes" === t && ("class" === e || "style" === e)) throw new w("viewconsumable-invalid-attribute", this);
          if (o.set(e, !0), "styles" === t) for (const t of this.element.document.stylesProcessor.getRelatedStyles(e)) o.set(t, !0);
        }
      }
      _test(t, e) {
        const n = Ai(e),
          o = this._consumables[t];
        for (const e of n) if ("attributes" !== t || "class" !== e && "style" !== e) {
          const t = o.get(e);
          if (void 0 === t) return null;
          if (!t) return !1;
        } else {
          const t = "class" == e ? "classes" : "styles",
            n = this._test(t, [...this._consumables[t].keys()]);
          if (!0 !== n) return n;
        }
        return !0;
      }
      _consume(t, e) {
        const n = Ai(e),
          o = this._consumables[t];
        for (const e of n) if ("attributes" !== t || "class" !== e && "style" !== e) {
          if (o.set(e, !1), "styles" == t) for (const t of this.element.document.stylesProcessor.getRelatedStyles(e)) o.set(t, !1);
        } else {
          const t = "class" == e ? "classes" : "styles";
          this._consume(t, [...this._consumables[t].keys()]);
        }
      }
      _revert(t, e) {
        const n = Ai(e),
          o = this._consumables[t];
        for (const e of n) if ("attributes" !== t || "class" !== e && "style" !== e) {
          !1 === o.get(e) && o.set(e, !0);
        } else {
          const t = "class" == e ? "classes" : "styles";
          this._revert(t, [...this._consumables[t].keys()]);
        }
      }
    }
    class Bd extends G() {
      constructor() {
        super(), this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (t, e) => {
          e[0] = new Nd(e[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", (t, e) => {
          e[0] = new Nd(e[0]), e[1] = this.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }
      register(t, e) {
        if (this._sourceDefinitions[t]) throw new w("schema-cannot-register-item-twice", this, {
          itemName: t
        });
        this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
      }
      extend(t, e) {
        if (!this._sourceDefinitions[t]) throw new w("schema-cannot-extend-missing-item", this, {
          itemName: t
        });
        this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
      }
      getDefinitions() {
        return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
      }
      getDefinition(t) {
        let e;
        return e = "string" == typeof t ? t : "is" in t && (t.is("$text") || t.is("$textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
      }
      isRegistered(t) {
        return !!this.getDefinition(t);
      }
      isBlock(t) {
        const e = this.getDefinition(t);
        return !(!e || !e.isBlock);
      }
      isLimit(t) {
        const e = this.getDefinition(t);
        return !!e && !(!e.isLimit && !e.isObject);
      }
      isObject(t) {
        const e = this.getDefinition(t);
        return !!e && !!(e.isObject || e.isLimit && e.isSelectable && e.isContent);
      }
      isInline(t) {
        const e = this.getDefinition(t);
        return !(!e || !e.isInline);
      }
      isSelectable(t) {
        const e = this.getDefinition(t);
        return !!e && !(!e.isSelectable && !e.isObject);
      }
      isContent(t) {
        const e = this.getDefinition(t);
        return !!e && !(!e.isContent && !e.isObject);
      }
      checkChild(t, e) {
        return !!e && this._checkContextMatch(e, t);
      }
      checkAttribute(t, e) {
        const n = this.getDefinition(t.last);
        return !!n && n.allowAttributes.includes(e);
      }
      checkMerge(t, e) {
        if (t instanceof cl) {
          const e = t.nodeBefore,
            n = t.nodeAfter;
          if (!(e instanceof rl)) throw new w("schema-check-merge-no-element-before", this);
          if (!(n instanceof rl)) throw new w("schema-check-merge-no-element-after", this);
          return this.checkMerge(e, n);
        }
        for (const n of e.getChildren()) if (!this.checkChild(t, n)) return !1;
        return !0;
      }
      addChildCheck(t) {
        this.on("checkChild", (e, [n, o]) => {
          if (!o) return;
          const i = t(n, o);
          "boolean" == typeof i && (e.stop(), e.return = i);
        }, {
          priority: "high"
        });
      }
      addAttributeCheck(t) {
        this.on("checkAttribute", (e, [n, o]) => {
          const i = t(n, o);
          "boolean" == typeof i && (e.stop(), e.return = i);
        }, {
          priority: "high"
        });
      }
      setAttributeProperties(t, e) {
        this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
      }
      getAttributeProperties(t) {
        return this._attributeProperties[t] || {};
      }
      getLimitElement(t) {
        let e;
        if (t instanceof cl) e = t.parent;else {
          e = (t instanceof ml ? [t] : Array.from(t.getRanges())).reduce((t, e) => {
            const n = e.getCommonAncestor();
            return t ? t.getCommonAncestor(n, {
              includeSelf: !0
            }) : n;
          }, null);
        }
        for (; !this.isLimit(e) && e.parent;) e = e.parent;
        return e;
      }
      checkAttributeInSelection(t, e) {
        if (t.isCollapsed) {
          const n = [...t.getFirstPosition().getAncestors(), new ol("", t.getAttributes())];
          return this.checkAttribute(n, e);
        }
        {
          const n = t.getRanges();
          for (const t of n) for (const n of t) if (this.checkAttribute(n.item, e)) return !0;
        }
        return !1;
      }
      *getValidRanges(t, e) {
        t = function* (t) {
          for (const e of t) yield* e.getMinimalFlatRanges();
        }(t);
        for (const n of t) yield* this._getValidRangesForRange(n, e);
      }
      getNearestSelectionRange(t, e = "both") {
        if ("$graveyard" == t.root.rootName) return null;
        if (this.checkChild(t, "$text")) return new ml(t);
        let n, o;
        const i = t.getAncestors().reverse().find(t => this.isLimit(t)) || t.root;
        "both" != e && "backward" != e || (n = new sl({
          boundaries: ml._createIn(i),
          startPosition: t,
          direction: "backward"
        })), "both" != e && "forward" != e || (o = new sl({
          boundaries: ml._createIn(i),
          startPosition: t
        }));
        for (const t of function* (t, e) {
          let n = !1;
          for (; !n;) {
            if (n = !0, t) {
              const e = t.next();
              e.done || (n = !1, yield {
                walker: t,
                value: e.value
              });
            }
            if (e) {
              const t = e.next();
              t.done || (n = !1, yield {
                walker: e,
                value: t.value
              });
            }
          }
        }(n, o)) {
          const e = t.walker == n ? "elementEnd" : "elementStart",
            o = t.value;
          if (o.type == e && this.isObject(o.item)) return ml._createOn(o.item);
          if (this.checkChild(o.nextPosition, "$text")) return new ml(o.nextPosition);
        }
        return null;
      }
      findAllowedParent(t, e) {
        let n = t.parent;
        for (; n;) {
          if (this.checkChild(n, e)) return n;
          if (this.isLimit(n)) return null;
          n = n.parent;
        }
        return null;
      }
      setAllowedAttributes(t, e, n) {
        const o = n.model;
        for (const [i, r] of Object.entries(e)) o.schema.checkAttribute(t, i) && n.setAttribute(i, r, t);
      }
      removeDisallowedAttributes(t, e) {
        for (const n of t) if (n.is("$text")) Wd(this, n, e);else {
          const t = ml._createIn(n).getPositions();
          for (const n of t) {
            Wd(this, n.nodeBefore || n.parent, e);
          }
        }
      }
      getAttributesWithProperty(t, e, n) {
        const o = {};
        for (const [i, r] of t.getAttributes()) {
          const t = this.getAttributeProperties(i);
          void 0 !== t[e] && (void 0 !== n && n !== t[e] || (o[i] = r));
        }
        return o;
      }
      createContext(t) {
        return new Nd(t);
      }
      _clearCache() {
        this._compiledDefinitions = null;
      }
      _compile() {
        const t = {},
          e = this._sourceDefinitions,
          n = Object.keys(e);
        for (const o of n) t[o] = Pd(e[o], o);
        for (const e of n) Od(t, e);
        for (const e of n) Ld(t, e);
        for (const e of n) zd(t, e);
        for (const e of n) Rd(t, e), jd(t, e);
        for (const e of n) Fd(t, e), Vd(t, e), Hd(t, e);
        this._compiledDefinitions = t;
      }
      _checkContextMatch(t, e, n = e.length - 1) {
        const o = e.getItem(n);
        if (t.allowIn.includes(o.name)) {
          if (0 == n) return !0;
          {
            const t = this.getDefinition(o);
            return this._checkContextMatch(t, e, n - 1);
          }
        }
        return !1;
      }
      *_getValidRangesForRange(t, e) {
        let n = t.start,
          o = t.start;
        for (const i of t.getItems({
          shallow: !0
        })) i.is("element") && (yield* this._getValidRangesForRange(ml._createIn(i), e)), this.checkAttribute(i, e) || (n.isEqual(o) || (yield new ml(n, o)), n = cl._createAfter(i)), o = cl._createAfter(i);
        n.isEqual(o) || (yield new ml(n, o));
      }
      findOptimalInsertionRange(t, e) {
        const n = t.getSelectedElement();
        if (n && this.isObject(n) && !this.isInline(n)) return "before" == e || "after" == e ? new ml(cl._createAt(n, e)) : ml._createOn(n);
        const o = Wi(t.getSelectedBlocks());
        if (!o) return new ml(t.focus);
        if (o.isEmpty) return new ml(cl._createAt(o, 0));
        const i = cl._createAfter(o);
        return t.focus.isTouching(i) ? new ml(i) : new ml(cl._createBefore(o));
      }
    }
    class Nd {
      constructor(t) {
        if (t instanceof Nd) return t;
        let e;
        e = "string" == typeof t ? [t] : Array.isArray(t) ? t : t.getAncestors({
          includeSelf: !0
        }), this._items = e.map(Gd);
      }
      get length() {
        return this._items.length;
      }
      get last() {
        return this._items[this._items.length - 1];
      }
      [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
      }
      push(t) {
        const e = new Nd([t]);
        return e._items = [...this._items, ...e._items], e;
      }
      getItem(t) {
        return this._items[t];
      }
      *getNames() {
        yield* this._items.map(t => t.name);
      }
      endsWith(t) {
        return Array.from(this.getNames()).join(" ").endsWith(t);
      }
      startsWith(t) {
        return Array.from(this.getNames()).join(" ").startsWith(t);
      }
    }
    function Pd(t, e) {
      const n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        allowChildren: [],
        inheritTypesFrom: []
      };
      return function (t, e) {
        for (const n of t) {
          const t = Object.keys(n).filter(t => t.startsWith("is"));
          for (const o of t) e[o] = !!n[o];
        }
      }(t, n), Ud(t, n, "allowIn"), Ud(t, n, "allowContentOf"), Ud(t, n, "allowWhere"), Ud(t, n, "allowAttributes"), Ud(t, n, "allowAttributesOf"), Ud(t, n, "allowChildren"), Ud(t, n, "inheritTypesFrom"), function (t, e) {
        for (const n of t) {
          const t = n.inheritAllFrom;
          t && (e.allowContentOf.push(t), e.allowWhere.push(t), e.allowAttributesOf.push(t), e.inheritTypesFrom.push(t));
        }
      }(t, n), n;
    }
    function Od(t, e) {
      const n = t[e];
      for (const o of n.allowChildren) {
        const n = t[o];
        n && n.allowIn.push(e);
      }
      n.allowChildren.length = 0;
    }
    function Ld(t, e) {
      for (const n of t[e].allowContentOf) if (t[n]) {
        qd(t, n).forEach(t => {
          t.allowIn.push(e);
        });
      }
      delete t[e].allowContentOf;
    }
    function zd(t, e) {
      for (const n of t[e].allowWhere) {
        const o = t[n];
        if (o) {
          const n = o.allowIn;
          t[e].allowIn.push(...n);
        }
      }
      delete t[e].allowWhere;
    }
    function Rd(t, e) {
      for (const n of t[e].allowAttributesOf) {
        const o = t[n];
        if (o) {
          const n = o.allowAttributes;
          t[e].allowAttributes.push(...n);
        }
      }
      delete t[e].allowAttributesOf;
    }
    function jd(t, e) {
      const n = t[e];
      for (const e of n.inheritTypesFrom) {
        const o = t[e];
        if (o) {
          const t = Object.keys(o).filter(t => t.startsWith("is"));
          for (const e of t) e in n || (n[e] = o[e]);
        }
      }
      delete n.inheritTypesFrom;
    }
    function Fd(t, e) {
      const n = t[e],
        o = n.allowIn.filter(e => t[e]);
      n.allowIn = Array.from(new Set(o));
    }
    function Vd(t, e) {
      const n = t[e];
      for (const o of n.allowIn) {
        t[o].allowChildren.push(e);
      }
    }
    function Hd(t, e) {
      const n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }
    function Ud(t, e, n) {
      for (const o of t) {
        const t = o[n];
        "string" == typeof t ? e[n].push(t) : Array.isArray(t) && e[n].push(...t);
      }
    }
    function qd(t, e) {
      const n = t[e];
      return (o = t, Object.keys(o).map(t => o[t])).filter(t => t.allowIn.includes(n.name));
      var o;
    }
    function Gd(t) {
      return "string" == typeof t || t.is("documentFragment") ? {
        name: "string" == typeof t ? t : "$documentFragment",
        *getAttributeKeys() {},
        getAttribute() {}
      } : {
        name: t.is("element") ? t.name : "$text",
        *getAttributeKeys() {
          yield* t.getAttributeKeys();
        },
        getAttribute: e => t.getAttribute(e)
      };
    }
    function Wd(t, e, n) {
      for (const o of e.getAttributeKeys()) t.checkAttribute(e, o) || n.removeAttribute(o, e);
    }
    var Kd = Object.defineProperty,
      $d = Object.defineProperties,
      Yd = Object.getOwnPropertyDescriptors,
      Qd = Object.getOwnPropertySymbols,
      Zd = Object.prototype.hasOwnProperty,
      Jd = Object.prototype.propertyIsEnumerable,
      Xd = (t, e, n) => e in t ? Kd(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class tu extends M() {
      constructor(t) {
        var e;
        super(), this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this._emptyElementsToKeep = new Set(), this.conversionApi = (e = ((t, e) => {
          for (var n in e || (e = {})) Zd.call(e, n) && Xd(t, n, e[n]);
          if (Qd) for (var n of Qd(e)) Jd.call(e, n) && Xd(t, n, e[n]);
          return t;
        })({}, t), $d(e, Yd({
          consumable: null,
          writer: null,
          store: null,
          convertItem: (t, e) => this._convertItem(t, e),
          convertChildren: (t, e) => this._convertChildren(t, e),
          safeInsert: (t, e) => this._safeInsert(t, e),
          updateConversionResult: (t, e) => this._updateConversionResult(t, e),
          splitToAllowedParent: (t, e) => this._splitToAllowedParent(t, e),
          getSplitParts: t => this._getSplitParts(t),
          keepEmptyElement: t => this._keepEmptyElement(t)
        })));
      }
      convert(t, e, n = ["$root"]) {
        this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
          let n;
          for (const o of new Nd(t)) {
            const t = {};
            for (const e of o.getAttributeKeys()) t[e] = o.getAttribute(e);
            const i = e.createElement(o.name, t);
            n && e.insert(i, n), n = cl._createAt(i, 0);
          }
          return n;
        }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = Td.createFrom(t), this.conversionApi.store = {};
        const {
            modelRange: o
          } = this._convertItem(t, this._modelCursor),
          i = e.createDocumentFragment();
        if (o) {
          this._removeEmptyElements();
          for (const t of Array.from(this._modelCursor.parent.getChildren())) e.append(t, i);
          i.markers = function (t, e) {
            const n = new Set(),
              o = new Map(),
              i = ml._createIn(t).getItems();
            for (const t of i) t.is("element", "$marker") && n.add(t);
            for (const t of n) {
              const n = t.getAttribute("data-name"),
                i = e.createPositionBefore(t);
              o.has(n) ? o.get(n).end = i.clone() : o.set(n, new ml(i.clone())), e.remove(t);
            }
            return o;
          }(i, e);
        }
        return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, i;
      }
      _convertItem(t, e) {
        const n = {
          viewItem: t,
          modelCursor: e,
          modelRange: null
        };
        if (t.is("element") ? this.fire(`element:${t.name}`, n, this.conversionApi) : t.is("$text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof ml)) throw new w("view-conversion-dispatcher-incorrect-result", this);
        return {
          modelRange: n.modelRange,
          modelCursor: n.modelCursor
        };
      }
      _convertChildren(t, e) {
        let n = e.is("position") ? e : cl._createAt(e, 0);
        const o = new ml(n);
        for (const e of Array.from(t.getChildren())) {
          const t = this._convertItem(e, n);
          t.modelRange instanceof ml && (o.end = t.modelRange.end, n = t.modelCursor);
        }
        return {
          modelRange: o,
          modelCursor: n
        };
      }
      _safeInsert(t, e) {
        const n = this._splitToAllowedParent(t, e);
        return !!n && (this.conversionApi.writer.insert(t, n.position), !0);
      }
      _updateConversionResult(t, e) {
        const n = this._getSplitParts(t),
          o = this.conversionApi.writer;
        e.modelRange || (e.modelRange = o.createRange(o.createPositionBefore(t), o.createPositionAfter(n[n.length - 1])));
        const i = this._cursorParents.get(t);
        e.modelCursor = i ? o.createPositionAt(i, 0) : e.modelRange.end;
      }
      _splitToAllowedParent(t, e) {
        const {
          schema: n,
          writer: o
        } = this.conversionApi;
        let i = n.findAllowedParent(e, t);
        if (i) {
          if (i === e.parent) return {
            position: e
          };
          this._modelCursor.parent.getAncestors().includes(i) && (i = null);
        }
        if (!i) return cd(e, t, n) ? {
          position: ld(e, o)
        } : null;
        const r = this.conversionApi.writer.split(e, i),
          s = [];
        for (const t of r.range.getWalker()) if ("elementEnd" == t.type) s.push(t.item);else {
          const e = s.pop(),
            n = t.item;
          this._registerSplitPair(e, n);
        }
        const a = r.range.end.parent;
        return this._cursorParents.set(t, a), {
          position: r.position,
          cursorParent: a
        };
      }
      _registerSplitPair(t, e) {
        this._splitParts.has(t) || this._splitParts.set(t, [t]);
        const n = this._splitParts.get(t);
        this._splitParts.set(e, n), n.push(e);
      }
      _getSplitParts(t) {
        let e;
        return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t], e;
      }
      _keepEmptyElement(t) {
        this._emptyElementsToKeep.add(t);
      }
      _removeEmptyElements() {
        let t = !1;
        for (const e of this._splitParts.keys()) e.isEmpty && !this._emptyElementsToKeep.has(e) && (this.conversionApi.writer.remove(e), this._splitParts.delete(e), t = !0);
        t && this._removeEmptyElements();
      }
    }
    class eu {
      getHtml(t) {
        const n = e.document.implementation.createHTMLDocument("").createElement("div");
        return n.appendChild(t), n.innerHTML;
      }
    }
    class nu {
      constructor(t) {
        this.skipComments = !0, this.domParser = new DOMParser(), this.domConverter = new Za(t, {
          renderingMode: "data"
        }), this.htmlWriter = new eu();
      }
      toData(t) {
        const e = this.domConverter.viewToDom(t);
        return this.htmlWriter.getHtml(e);
      }
      toView(t) {
        const e = this._toDom(t);
        return this.domConverter.domToView(e, {
          skipComments: this.skipComments
        });
      }
      registerRawContentMatcher(t) {
        this.domConverter.registerRawContentMatcher(t);
      }
      useFillerType(t) {
        this.domConverter.blockFillerMode = "marked" == t ? "markedNbsp" : "nbsp";
      }
      _toDom(t) {
        t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (t = `<body>${t}</body>`);
        const e = this.domParser.parseFromString(t, "text/html"),
          n = e.createDocumentFragment(),
          o = e.body.childNodes;
        for (; o.length > 0;) n.appendChild(o[0]);
        return n;
      }
    }
    class ou extends M() {
      constructor(t, e) {
        super(), this.model = t, this.mapper = new pl(), this.downcastDispatcher = new Dl({
          mapper: this.mapper,
          schema: t.schema
        }), this.downcastDispatcher.on("insert:$text", (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) return;
          const o = n.writer,
            i = n.mapper.toViewPosition(e.range.start),
            r = o.createText(e.item.data);
          o.insert(i, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("insert", (t, e, n) => {
          n.convertAttributes(e.item), e.reconversion || !e.item.is("element") || e.item.isEmpty || n.convertChildren(e.item);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new tu({
          schema: t.schema
        }), this.viewDocument = new sa(e), this.stylesProcessor = e, this.htmlProcessor = new nu(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new ba(this.viewDocument), this.upcastDispatcher.on("text", (t, e, {
          schema: n,
          consumable: o,
          writer: i
        }) => {
          let r = e.modelCursor;
          if (!o.test(e.viewItem)) return;
          if (!n.checkChild(r, "$text")) {
            if (!cd(r, "$text", n)) return;
            if (0 == e.viewItem.data.trim().length) return;
            const t = r.nodeBefore;
            r = ld(r, i), t && t.is("element", "$marker") && (i.move(i.createRangeOn(t), r), r = i.createPositionAfter(t));
          }
          o.consume(e.viewItem);
          const s = i.createText(e.viewItem.data);
          i.insert(s, r), e.modelRange = i.createRange(r, r.getShiftedBy(s.offsetSize)), e.modelCursor = e.modelRange.end;
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", (t, e, n) => {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            const {
              modelRange: t,
              modelCursor: o
            } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = t, e.modelCursor = o;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", (t, e, n) => {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            const {
              modelRange: t,
              modelCursor: o
            } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = t, e.modelCursor = o;
          }
        }, {
          priority: "lowest"
        }), G().prototype.decorate.call(this, "init"), G().prototype.decorate.call(this, "set"), G().prototype.decorate.call(this, "get"), G().prototype.decorate.call(this, "toView"), G().prototype.decorate.call(this, "toModel"), this.on("init", () => {
          this.fire("ready");
        }, {
          priority: "lowest"
        }), this.on("ready", () => {
          this.model.enqueueChange({
            isUndoable: !1
          }, ad);
        }, {
          priority: "lowest"
        });
      }
      get(t = {}) {
        const {
          rootName: e = "main",
          trim: n = "empty"
        } = t;
        if (!this._checkIfRootsExists([e])) throw new w("datacontroller-get-non-existent-root", this);
        const o = this.model.document.getRoot(e);
        return o.isAttached() || A("datacontroller-get-detached-root", this), "empty" !== n || this.model.hasContent(o, {
          ignoreWhitespaces: !0
        }) ? this.stringify(o, t) : "";
      }
      stringify(t, e = {}) {
        const n = this.toView(t, e);
        return this.processor.toData(n);
      }
      toView(t, e = {}) {
        const n = this.viewDocument,
          o = this._viewWriter;
        this.mapper.clearBindings();
        const i = ml._createIn(t),
          r = new ka(n);
        this.mapper.bindElements(t, r);
        const s = t.is("documentFragment") ? t.markers : function (t) {
          const e = [],
            n = t.root.document;
          if (!n) return new Map();
          const o = ml._createIn(t);
          for (const t of n.model.markers) {
            const n = t.getRange(),
              i = n.isCollapsed,
              r = n.start.isEqual(o.start) || n.end.isEqual(o.end);
            if (i && r) e.push([t.name, n]);else {
              const i = o.getIntersection(n);
              i && e.push([t.name, i]);
            }
          }
          return e.sort(([t, e], [n, o]) => {
            if ("after" !== e.end.compareWith(o.start)) return 1;
            if ("before" !== e.start.compareWith(o.end)) return -1;
            switch (e.start.compareWith(o.start)) {
              case "before":
                return 1;
              case "after":
                return -1;
              default:
                switch (e.end.compareWith(o.end)) {
                  case "before":
                    return 1;
                  case "after":
                    return -1;
                  default:
                    return n.localeCompare(t);
                }
            }
          }), new Map(e);
        }(t);
        return this.downcastDispatcher.convert(i, s, o, e), r;
      }
      init(t) {
        if (this.model.document.version) throw new w("datacontroller-init-document-not-empty", this);
        let e = {};
        if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new w("datacontroller-init-non-existent-root", this);
        return this.model.enqueueChange({
          isUndoable: !1
        }, t => {
          for (const n of Object.keys(e)) {
            const o = this.model.document.getRoot(n);
            t.insert(this.parse(e[n], o), o, 0);
          }
        }), Promise.resolve();
      }
      set(t, e = {}) {
        let n = {};
        if ("string" == typeof t ? n.main = t : n = t, !this._checkIfRootsExists(Object.keys(n))) throw new w("datacontroller-set-non-existent-root", this);
        this.model.enqueueChange(e.batchType || {}, t => {
          t.setSelection(null), t.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
          for (const e of Object.keys(n)) {
            const o = this.model.document.getRoot(e);
            t.remove(t.createRangeIn(o)), t.insert(this.parse(n[e], o), o, 0);
          }
        });
      }
      parse(t, e = "$root") {
        const n = this.processor.toView(t);
        return this.toModel(n, e);
      }
      toModel(t, e = "$root") {
        return this.model.change(n => this.upcastDispatcher.convert(t, n, e));
      }
      addStyleProcessorRules(t) {
        t(this.stylesProcessor);
      }
      registerRawContentMatcher(t) {
        this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t), this.htmlProcessor.registerRawContentMatcher(t);
      }
      destroy() {
        this.stopListening();
      }
      _checkIfRootsExists(t) {
        for (const e of t) if (!this.model.document.getRoot(e)) return !1;
        return !0;
      }
    }
    class iu {
      constructor(t, e) {
        this._helpers = new Map(), this._downcast = Ai(t), this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = Ai(e), this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }
      addAlias(t, e) {
        const n = this._downcast.includes(e);
        if (!this._upcast.includes(e) && !n) throw new w("conversion-add-alias-dispatcher-not-registered", this);
        this._createConversionHelpers({
          name: t,
          dispatchers: [e],
          isDowncast: n
        });
      }
      for(t) {
        if (!this._helpers.has(t)) throw new w("conversion-for-unknown-group", this);
        return this._helpers.get(t);
      }
      elementToElement(t) {
        this.for("downcast").elementToElement(t);
        for (const {
          model: e,
          view: n
        } of ru(t)) this.for("upcast").elementToElement({
          model: e,
          view: n,
          converterPriority: t.converterPriority
        });
      }
      attributeToElement(t) {
        this.for("downcast").attributeToElement(t);
        for (const {
          model: e,
          view: n
        } of ru(t)) this.for("upcast").elementToAttribute({
          view: n,
          model: e,
          converterPriority: t.converterPriority
        });
      }
      attributeToAttribute(t) {
        this.for("downcast").attributeToAttribute(t);
        for (const {
          model: e,
          view: n
        } of ru(t)) this.for("upcast").attributeToAttribute({
          view: n,
          model: e
        });
      }
      _createConversionHelpers({
        name: t,
        dispatchers: e,
        isDowncast: n
      }) {
        if (this._helpers.has(t)) throw new w("conversion-group-exists", this);
        const o = n ? new Gl(e) : new kd(e);
        this._helpers.set(t, o);
      }
    }
    function* ru(t) {
      if (t.model.values) for (const e of t.model.values) {
        const n = {
            key: t.model.key,
            value: e
          },
          o = t.view[e],
          i = t.upcastAlso ? t.upcastAlso[e] : void 0;
        yield* su(n, o, i);
      } else yield* su(t.model, t.view, t.upcastAlso);
    }
    function* su(t, e, n) {
      if (yield {
        model: t,
        view: e
      }, n) for (const e of Ai(n)) yield {
        model: t,
        view: e
      };
    }
    class au {
      constructor(t) {
        this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }
      _validate() {}
      toJSON() {
        const t = Object.assign({}, this);
        return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
      }
      static get className() {
        return "Operation";
      }
      static fromJSON(t, e) {
        return new this(t.baseVersion);
      }
    }
    function cu(t, e) {
      const n = uu(e),
        o = n.reduce((t, e) => t + e.offsetSize, 0),
        i = t.parent;
      gu(t);
      const r = t.index;
      return i._insertChild(r, n), hu(i, r + n.length), hu(i, r), new ml(t, t.getShiftedBy(o));
    }
    function lu(t) {
      if (!t.isFlat) throw new w("operation-utils-remove-range-not-flat", this);
      const e = t.start.parent;
      gu(t.start), gu(t.end);
      const n = e._removeChildren(t.start.index, t.end.index - t.start.index);
      return hu(e, t.start.index), n;
    }
    function du(t, e) {
      if (!t.isFlat) throw new w("operation-utils-move-range-not-flat", this);
      const n = lu(t);
      return cu(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
    }
    function uu(t) {
      const e = [];
      !function t(n) {
        if ("string" == typeof n) e.push(new ol(n));else if (n instanceof il) e.push(new ol(n.data, n.getAttributes()));else if (n instanceof el) e.push(n);else if (tt(n)) for (const e of n) t(e);else {}
      }(t);
      for (let t = 1; t < e.length; t++) {
        const n = e[t],
          o = e[t - 1];
        n instanceof ol && o instanceof ol && mu(n, o) && (e.splice(t - 1, 2, new ol(o.data + n.data, o.getAttributes())), t--);
      }
      return e;
    }
    function hu(t, e) {
      const n = t.getChild(e - 1),
        o = t.getChild(e);
      if (n && o && n.is("$text") && o.is("$text") && mu(n, o)) {
        const i = new ol(n.data + o.data, n.getAttributes());
        t._removeChildren(e - 1, 2), t._insertChild(e - 1, i);
      }
    }
    function gu(t) {
      const e = t.textNode,
        n = t.parent;
      if (e) {
        const o = t.offset - e.startOffset,
          i = e.index;
        n._removeChildren(i, 1);
        const r = new ol(e.data.substr(0, o), e.getAttributes()),
          s = new ol(e.data.substr(o), e.getAttributes());
        n._insertChild(i, [r, s]);
      }
    }
    function mu(t, e) {
      const n = t.getAttributes(),
        o = e.getAttributes();
      for (const t of n) {
        if (t[1] !== e.getAttribute(t[0])) return !1;
        o.next();
      }
      return o.next().done;
    }
    class pu extends au {
      constructor(t, e, n, o) {
        super(o), this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = e, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNone";
      }
      get type() {
        return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
      }
      get affectedSelectable() {
        return [ml._createFromPositionAndShift(this.sourcePosition, this.howMany), ml._createFromPositionAndShift(this.targetPosition, 0)];
      }
      clone() {
        return new pu(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
      }
      getMovedRangeStart() {
        return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
      }
      getReversed() {
        const t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
        return new pu(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
      }
      _validate() {
        const t = this.sourcePosition.parent,
          e = this.targetPosition.parent,
          n = this.sourcePosition.offset,
          o = this.targetPosition.offset;
        if (n + this.howMany > t.maxOffset) throw new w("move-operation-nodes-do-not-exist", this);
        if (t === e && n < o && o < n + this.howMany) throw new w("move-operation-range-into-itself", this);
        if (this.sourcePosition.root == this.targetPosition.root && "prefix" == X(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
          const t = this.sourcePosition.path.length - 1;
          if (this.targetPosition.path[t] >= n && this.targetPosition.path[t] < n + this.howMany) throw new w("move-operation-node-into-itself", this);
        }
      }
      _execute() {
        du(ml._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
      }
      toJSON() {
        const t = super.toJSON();
        return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
      }
      static get className() {
        return "MoveOperation";
      }
      static fromJSON(t, e) {
        const n = cl.fromJSON(t.sourcePosition, e),
          o = cl.fromJSON(t.targetPosition, e);
        return new this(n, t.howMany, o, t.baseVersion);
      }
    }
    class fu extends au {
      constructor(t, e, n) {
        super(n), this.position = t.clone(), this.position.stickiness = "toNone", this.nodes = new nl(uu(e)), this.shouldReceiveAttributes = !1;
      }
      get type() {
        return "insert";
      }
      get howMany() {
        return this.nodes.maxOffset;
      }
      get affectedSelectable() {
        return this.position.clone();
      }
      clone() {
        const t = new nl([...this.nodes].map(t => t._clone(!0))),
          e = new fu(this.position, t, this.baseVersion);
        return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
      }
      getReversed() {
        const t = this.position.root.document.graveyard,
          e = new cl(t, [0]);
        return new pu(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
      }
      _validate() {
        const t = this.position.parent;
        if (!t || t.maxOffset < this.position.offset) throw new w("insert-operation-position-invalid", this);
      }
      _execute() {
        const t = this.nodes;
        this.nodes = new nl([...t].map(t => t._clone(!0))), cu(this.position, t);
      }
      toJSON() {
        const t = super.toJSON();
        return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
      }
      static get className() {
        return "InsertOperation";
      }
      static fromJSON(t, e) {
        const n = [];
        for (const e of t.nodes) e.name ? n.push(rl.fromJSON(e)) : n.push(ol.fromJSON(e));
        const o = new fu(cl.fromJSON(t.position, e), n, t.baseVersion);
        return o.shouldReceiveAttributes = t.shouldReceiveAttributes, o;
      }
    }
    class ku extends au {
      constructor(t, e, n, o, i) {
        super(i), this.splitPosition = t.clone(), this.splitPosition.stickiness = "toNext", this.howMany = e, this.insertionPosition = n, this.graveyardPosition = o ? o.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
      }
      get type() {
        return "split";
      }
      get moveTargetPosition() {
        const t = this.insertionPosition.path.slice();
        return t.push(0), new cl(this.insertionPosition.root, t);
      }
      get movedRange() {
        const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new ml(this.splitPosition, t);
      }
      get affectedSelectable() {
        const t = [ml._createFromPositionAndShift(this.splitPosition, 0), ml._createFromPositionAndShift(this.insertionPosition, 0)];
        return this.graveyardPosition && t.push(ml._createFromPositionAndShift(this.graveyardPosition, 0)), t;
      }
      clone() {
        return new ku(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
      }
      getReversed() {
        const t = this.splitPosition.root.document.graveyard,
          e = new cl(t, [0]);
        return new bu(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
      }
      _validate() {
        const t = this.splitPosition.parent,
          e = this.splitPosition.offset;
        if (!t || t.maxOffset < e) throw new w("split-operation-position-invalid", this);
        if (!t.parent) throw new w("split-operation-split-in-root", this);
        if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new w("split-operation-how-many-invalid", this);
        if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new w("split-operation-graveyard-position-invalid", this);
      }
      _execute() {
        const t = this.splitPosition.parent;
        if (this.graveyardPosition) du(ml._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
          const e = t._clone();
          cu(this.insertionPosition, e);
        }
        du(new ml(cl._createAt(t, this.splitPosition.offset), cl._createAt(t, t.maxOffset)), this.moveTargetPosition);
      }
      toJSON() {
        const t = super.toJSON();
        return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
      }
      static get className() {
        return "SplitOperation";
      }
      static getInsertionPosition(t) {
        const e = t.path.slice(0, -1);
        return e[e.length - 1]++, new cl(t.root, e, "toPrevious");
      }
      static fromJSON(t, e) {
        const n = cl.fromJSON(t.splitPosition, e),
          o = cl.fromJSON(t.insertionPosition, e),
          i = t.graveyardPosition ? cl.fromJSON(t.graveyardPosition, e) : null;
        return new this(n, t.howMany, o, i, t.baseVersion);
      }
    }
    class bu extends au {
      constructor(t, e, n, o, i) {
        super(i), this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = e, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = o.clone();
      }
      get type() {
        return "merge";
      }
      get deletionPosition() {
        return new cl(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
      }
      get movedRange() {
        const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new ml(this.sourcePosition, t);
      }
      get affectedSelectable() {
        const t = this.sourcePosition.parent;
        return [ml._createOn(t), ml._createFromPositionAndShift(this.targetPosition, 0), ml._createFromPositionAndShift(this.graveyardPosition, 0)];
      }
      clone() {
        return new bu(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
      }
      getReversed() {
        const t = this.targetPosition._getTransformedByMergeOperation(this),
          e = this.sourcePosition.path.slice(0, -1),
          n = new cl(this.sourcePosition.root, e)._getTransformedByMergeOperation(this);
        return new ku(t, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
      }
      _validate() {
        const t = this.sourcePosition.parent,
          e = this.targetPosition.parent;
        if (!t.parent) throw new w("merge-operation-source-position-invalid", this);
        if (!e.parent) throw new w("merge-operation-target-position-invalid", this);
        if (this.howMany != t.maxOffset) throw new w("merge-operation-how-many-invalid", this);
      }
      _execute() {
        const t = this.sourcePosition.parent;
        du(ml._createIn(t), this.targetPosition), du(ml._createOn(t), this.graveyardPosition);
      }
      toJSON() {
        const t = super.toJSON();
        return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
      }
      static get className() {
        return "MergeOperation";
      }
      static fromJSON(t, e) {
        const n = cl.fromJSON(t.sourcePosition, e),
          o = cl.fromJSON(t.targetPosition, e),
          i = cl.fromJSON(t.graveyardPosition, e);
        return new this(n, t.howMany, o, i, t.baseVersion);
      }
    }
    class wu extends au {
      constructor(t, e, n, o, i, r) {
        super(r), this.name = t, this.oldRange = e ? e.clone() : null, this.newRange = n ? n.clone() : null, this.affectsData = i, this._markers = o;
      }
      get type() {
        return "marker";
      }
      get affectedSelectable() {
        const t = [];
        return this.oldRange && t.push(this.oldRange.clone()), this.newRange && (this.oldRange ? t.push(...this.newRange.getDifference(this.oldRange)) : t.push(this.newRange.clone())), t;
      }
      clone() {
        return new wu(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
      }
      getReversed() {
        return new wu(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
      }
      _execute() {
        this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
      }
      toJSON() {
        const t = super.toJSON();
        return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
      }
      static get className() {
        return "MarkerOperation";
      }
      static fromJSON(t, e) {
        return new wu(t.name, t.oldRange ? ml.fromJSON(t.oldRange, e) : null, t.newRange ? ml.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
      }
    }
    const Au = function (t, e) {
      return Fc(t, e);
    };
    class _u extends au {
      constructor(t, e, n, o, i) {
        super(i), this.range = t.clone(), this.key = e, this.oldValue = void 0 === n ? null : n, this.newValue = void 0 === o ? null : o;
      }
      get type() {
        return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
      }
      get affectedSelectable() {
        return this.range.clone();
      }
      clone() {
        return new _u(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
      }
      getReversed() {
        return new _u(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
      }
      toJSON() {
        const t = super.toJSON();
        return t.range = this.range.toJSON(), t;
      }
      _validate() {
        if (!this.range.isFlat) throw new w("attribute-operation-range-not-flat", this);
        for (const t of this.range.getItems({
          shallow: !0
        })) {
          if (null !== this.oldValue && !Au(t.getAttribute(this.key), this.oldValue)) throw new w("attribute-operation-wrong-old-value", this, {
            item: t,
            key: this.key,
            value: this.oldValue
          });
          if (null === this.oldValue && null !== this.newValue && t.hasAttribute(this.key)) throw new w("attribute-operation-attribute-exists", this, {
            node: t,
            key: this.key
          });
        }
      }
      _execute() {
        Au(this.oldValue, this.newValue) || function (t, e, n) {
          gu(t.start), gu(t.end);
          for (const o of t.getItems({
            shallow: !0
          })) {
            const t = o.is("$textProxy") ? o.textNode : o;
            null !== n ? t._setAttribute(e, n) : t._removeAttribute(e), hu(t.parent, t.index);
          }
          hu(t.end.parent, t.end.index);
        }(this.range, this.key, this.newValue);
      }
      static get className() {
        return "AttributeOperation";
      }
      static fromJSON(t, e) {
        return new _u(ml.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
      }
    }
    class Cu extends au {
      get type() {
        return "noop";
      }
      get affectedSelectable() {
        return null;
      }
      clone() {
        return new Cu(this.baseVersion);
      }
      getReversed() {
        return new Cu(this.baseVersion + 1);
      }
      _execute() {}
      static get className() {
        return "NoOperation";
      }
    }
    class vu extends au {
      constructor(t, e, n, o) {
        super(o), this.position = t, this.position.stickiness = "toNext", this.oldName = e, this.newName = n;
      }
      get type() {
        return "rename";
      }
      get affectedSelectable() {
        return this.position.nodeAfter;
      }
      clone() {
        return new vu(this.position.clone(), this.oldName, this.newName, this.baseVersion);
      }
      getReversed() {
        return new vu(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
      }
      _validate() {
        const t = this.position.nodeAfter;
        if (!(t instanceof rl)) throw new w("rename-operation-wrong-position", this);
        if (t.name !== this.oldName) throw new w("rename-operation-wrong-name", this);
      }
      _execute() {
        this.position.nodeAfter.name = this.newName;
      }
      toJSON() {
        const t = super.toJSON();
        return t.position = this.position.toJSON(), t;
      }
      static get className() {
        return "RenameOperation";
      }
      static fromJSON(t, e) {
        return new vu(cl.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
      }
    }
    class yu extends au {
      constructor(t, e, n, o, i) {
        super(i), this.root = t, this.key = e, this.oldValue = void 0 === n ? null : n, this.newValue = void 0 === o ? null : o;
      }
      get type() {
        return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
      }
      get affectedSelectable() {
        return this.root;
      }
      clone() {
        return new yu(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
      }
      getReversed() {
        return new yu(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
      }
      _validate() {
        if (this.root != this.root.root || this.root.is("documentFragment")) throw new w("rootattribute-operation-not-a-root", this, {
          root: this.root,
          key: this.key
        });
        if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new w("rootattribute-operation-wrong-old-value", this, {
          root: this.root,
          key: this.key
        });
        if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new w("rootattribute-operation-attribute-exists", this, {
          root: this.root,
          key: this.key
        });
      }
      _execute() {
        null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
      }
      toJSON() {
        const t = super.toJSON();
        return t.root = this.root.toJSON(), t;
      }
      static get className() {
        return "RootAttributeOperation";
      }
      static fromJSON(t, e) {
        if (!e.getRoot(t.root)) throw new w("rootattribute-operation-fromjson-no-root", this, {
          rootName: t.root
        });
        return new yu(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
      }
    }
    class xu extends au {
      constructor(t, e, n, o, i) {
        if (super(i), this.rootName = t, this.elementName = e, this.isAdd = n, this._document = o, !this._document.getRoot(this.rootName)) {
          this._document.createRoot(this.elementName, this.rootName)._isAttached = !1;
        }
      }
      get type() {
        return this.isAdd ? "addRoot" : "detachRoot";
      }
      get affectedSelectable() {
        return this._document.getRoot(this.rootName);
      }
      clone() {
        return new xu(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
      }
      getReversed() {
        return new xu(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
      }
      _execute() {
        this._document.getRoot(this.rootName)._isAttached = this.isAdd;
      }
      toJSON() {
        const t = super.toJSON();
        return delete t._document, t;
      }
      static get className() {
        return "RootOperation";
      }
      static fromJSON(t, e) {
        return new xu(t.rootName, t.elementName, t.isAdd, e, t.baseVersion);
      }
    }
    const Eu = {};
    Eu[_u.className] = _u, Eu[fu.className] = fu, Eu[wu.className] = wu, Eu[pu.className] = pu, Eu[Cu.className] = Cu, Eu[au.className] = au, Eu[vu.className] = vu, Eu[yu.className] = yu, Eu[xu.className] = xu, Eu[ku.className] = ku, Eu[bu.className] = bu;
    class Du {
      static fromJSON(t, e) {
        return Eu[t.__className].fromJSON(t, e);
      }
    }
    const Iu = new Map();
    function Tu(t, e, n) {
      let o = Iu.get(t);
      o || (o = new Map(), Iu.set(t, o)), o.set(e, n);
    }
    function Mu(t) {
      return [t];
    }
    function Su(t, e, n = {}) {
      const o = function (t, e) {
        const n = Iu.get(t);
        return n && n.has(e) ? n.get(e) : Mu;
      }(t.constructor, e.constructor);
      try {
        return o(t = t.clone(), e, n);
      } catch (t) {
        throw t;
      }
    }
    function Bu(t, e, n) {
      t = t.slice(), e = e.slice();
      const o = new Nu(n.document, n.useRelations, n.forceWeakRemove);
      o.setOriginalOperations(t), o.setOriginalOperations(e);
      const i = o.originalOperations;
      if (0 == t.length || 0 == e.length) return {
        operationsA: t,
        operationsB: e,
        originalOperations: i
      };
      const r = new WeakMap();
      for (const e of t) r.set(e, 0);
      const s = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      };
      let a = 0;
      for (; a < t.length;) {
        const n = t[a],
          i = r.get(n);
        if (i == e.length) {
          a++;
          continue;
        }
        const s = e[i],
          c = Su(n, s, o.getContext(n, s, !0)),
          l = Su(s, n, o.getContext(s, n, !1));
        o.updateRelation(n, s), o.setOriginalOperations(c, n), o.setOriginalOperations(l, s);
        for (const t of c) r.set(t, i + l.length);
        t.splice(a, 1, ...c), e.splice(i, 1, ...l);
      }
      if (n.padWithNoOps) {
        const n = t.length - s.originalOperationsACount,
          o = e.length - s.originalOperationsBCount;
        Ou(t, o - n), Ou(e, n - o);
      }
      return Pu(t, s.nextBaseVersionB), Pu(e, s.nextBaseVersionA), {
        operationsA: t,
        operationsB: e,
        originalOperations: i
      };
    }
    class Nu {
      constructor(t, e, n = !1) {
        this.originalOperations = new Map(), this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._relations = new Map();
      }
      setOriginalOperations(t, e = null) {
        const n = e ? this.originalOperations.get(e) : null;
        for (const e of t) this.originalOperations.set(e, n || e);
      }
      updateRelation(t, e) {
        if (t instanceof pu) e instanceof bu ? t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter") : e instanceof pu && (t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter"));else if (t instanceof ku) {
          if (e instanceof bu) t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");else if (e instanceof pu) if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "splitBefore");else {
            const n = ml._createFromPositionAndShift(e.sourcePosition, e.howMany);
            if (t.splitPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(t.splitPosition)) {
              const o = n.end.offset - t.splitPosition.offset,
                i = t.splitPosition.offset - n.start.offset;
              this._setRelation(t, e, {
                howMany: o,
                offset: i
              });
            }
          }
        } else if (t instanceof bu) e instanceof bu ? (t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement")) : e instanceof ku ? t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource") : e instanceof pu && e.howMany > 0 && (t.sourcePosition.isEqual(e.sourcePosition.getShiftedBy(e.howMany)) && this._setRelation(t, e, "mergeSourceAffected"), t.targetPosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeTargetWasBefore"));else if (t instanceof wu) {
          const n = t.newRange;
          if (!n) return;
          if (e instanceof pu) {
            const o = ml._createFromPositionAndShift(e.sourcePosition, e.howMany),
              i = o.containsPosition(n.start) || o.start.isEqual(n.start),
              r = o.containsPosition(n.end) || o.end.isEqual(n.end);
            !i && !r || o.containsRange(n) || this._setRelation(t, e, {
              side: i ? "left" : "right",
              path: i ? n.start.path.slice() : n.end.path.slice()
            });
          } else if (e instanceof bu) {
            const o = n.start.isEqual(e.targetPosition),
              i = n.start.isEqual(e.deletionPosition),
              r = n.end.isEqual(e.deletionPosition),
              s = n.end.isEqual(e.sourcePosition);
            (o || i || r || s) && this._setRelation(t, e, {
              wasInLeftElement: o,
              wasStartBeforeMergedElement: i,
              wasEndBeforeMergedElement: r,
              wasInRightElement: s
            });
          }
        }
      }
      getContext(t, e, n) {
        return {
          aIsStrong: n,
          aWasUndone: this._wasUndone(t),
          bWasUndone: this._wasUndone(e),
          abRelation: this._useRelations ? this._getRelation(t, e) : null,
          baRelation: this._useRelations ? this._getRelation(e, t) : null,
          forceWeakRemove: this._forceWeakRemove
        };
      }
      _wasUndone(t) {
        const e = this.originalOperations.get(t);
        return e.wasUndone || this._history.isUndoneOperation(e);
      }
      _getRelation(t, e) {
        const n = this.originalOperations.get(e),
          o = this._history.getUndoneOperation(n);
        if (!o) return null;
        const i = this.originalOperations.get(t),
          r = this._relations.get(i);
        return r && r.get(o) || null;
      }
      _setRelation(t, e, n) {
        const o = this.originalOperations.get(t),
          i = this.originalOperations.get(e);
        let r = this._relations.get(o);
        r || (r = new Map(), this._relations.set(o, r)), r.set(i, n);
      }
    }
    function Pu(t, e) {
      for (const n of t) n.baseVersion = e++;
    }
    function Ou(t, e) {
      for (let n = 0; n < e; n++) t.push(new Cu(0));
    }
    function Lu(t, e, n) {
      const o = t.nodes.getNode(0).getAttribute(e);
      if (o == n) return null;
      const i = new ml(t.position, t.position.getShiftedBy(t.howMany));
      return new _u(i, e, o, n, 0);
    }
    function zu(t, e) {
      return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
    }
    function Ru(t, e) {
      const n = [];
      for (let o = 0; o < t.length; o++) {
        const i = t[o],
          r = new pu(i.start, i.end.offset - i.start.offset, e, 0);
        n.push(r);
        for (let e = o + 1; e < t.length; e++) t[e] = t[e]._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany)[0];
        e = e._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany);
      }
      return n;
    }
    Tu(_u, _u, (t, e, n) => {
      if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
        const o = t.range.getDifference(e.range).map(e => new _u(e, t.key, t.oldValue, t.newValue, 0)),
          i = t.range.getIntersection(e.range);
        return i && n.aIsStrong && o.push(new _u(i, e.key, e.newValue, t.newValue, 0)), 0 == o.length ? [new Cu(0)] : o;
      }
      return [t];
    }), Tu(_u, fu, (t, e) => {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        const n = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(e => new _u(e, t.key, t.oldValue, t.newValue, t.baseVersion));
        if (e.shouldReceiveAttributes) {
          const o = Lu(e, t.key, t.oldValue);
          o && n.unshift(o);
        }
        return n;
      }
      return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
    }), Tu(_u, bu, (t, e) => {
      const n = [];
      t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(ml._createFromPositionAndShift(e.graveyardPosition, 1));
      const o = t.range._getTransformedByMergeOperation(e);
      return o.isCollapsed || n.push(o), n.map(e => new _u(e, t.key, t.oldValue, t.newValue, t.baseVersion));
    }), Tu(_u, pu, (t, e) => {
      const n = function (t, e) {
        const n = ml._createFromPositionAndShift(e.sourcePosition, e.howMany);
        let o = null,
          i = [];
        n.containsRange(t, !0) ? o = t : t.start.hasSameParentAs(n.start) ? (i = t.getDifference(n), o = t.getIntersection(n)) : i = [t];
        const r = [];
        for (let t of i) {
          t = t._getTransformedByDeletion(e.sourcePosition, e.howMany);
          const n = e.getMovedRangeStart(),
            o = t.start.hasSameParentAs(n),
            i = t._getTransformedByInsertion(n, e.howMany, o);
          r.push(...i);
        }
        o && r.push(o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
        return r;
      }(t.range, e);
      return n.map(e => new _u(e, t.key, t.oldValue, t.newValue, t.baseVersion));
    }), Tu(_u, ku, (t, e) => {
      if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];
      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        const n = t.clone();
        return n.range = new ml(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, n];
      }
      return t.range = t.range._getTransformedBySplitOperation(e), [t];
    }), Tu(fu, _u, (t, e) => {
      const n = [t];
      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        const o = Lu(t, e.key, e.newValue);
        o && n.push(o);
      }
      return n;
    }), Tu(fu, fu, (t, e, n) => (t.position.isEqual(e.position) && n.aIsStrong || (t.position = t.position._getTransformedByInsertOperation(e)), [t])), Tu(fu, pu, (t, e) => (t.position = t.position._getTransformedByMoveOperation(e), [t])), Tu(fu, ku, (t, e) => (t.position = t.position._getTransformedBySplitOperation(e), [t])), Tu(fu, bu, (t, e) => (t.position = t.position._getTransformedByMergeOperation(e), [t])), Tu(wu, fu, (t, e) => (t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t])), Tu(wu, wu, (t, e, n) => {
      if (t.name == e.name) {
        if (!n.aIsStrong) return [new Cu(0)];
        t.oldRange = e.newRange ? e.newRange.clone() : null;
      }
      return [t];
    }), Tu(wu, bu, (t, e) => (t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t])), Tu(wu, pu, (t, e, n) => {
      if (t.oldRange && (t.oldRange = ml._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
        if (n.abRelation) {
          const o = ml._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
          if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.end = o.end, t.newRange.start.path = n.abRelation.path, [t];
          if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = o.start, t.newRange.end.path = n.abRelation.path, [t];
        }
        t.newRange = ml._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }
      return [t];
    }), Tu(wu, ku, (t, e, n) => {
      if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
        if (n.abRelation) {
          const o = t.newRange._getTransformedBySplitOperation(e);
          return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = cl._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = cl._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = cl._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = cl._createAt(e.insertionPosition) : t.newRange.end = o.end, [t];
        }
        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }
      return [t];
    }), Tu(bu, fu, (t, e) => (t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t])), Tu(bu, bu, (t, e, n) => {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (n.bWasUndone) {
          const n = e.graveyardPosition.path.slice();
          return n.push(0), t.sourcePosition = new cl(e.graveyardPosition.root, n), t.howMany = 0, [t];
        }
        return [new Cu(0)];
      }
      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        const o = "$graveyard" == t.targetPosition.root.rootName,
          i = "$graveyard" == e.targetPosition.root.rootName;
        if (i && !o || !(o && !i) && n.aIsStrong) {
          const n = e.targetPosition._getTransformedByMergeOperation(e),
            o = t.targetPosition._getTransformedByMergeOperation(e);
          return [new pu(n, t.howMany, o, 0)];
        }
        return [new Cu(0)];
      }
      return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), Tu(bu, pu, (t, e, n) => {
      const o = ml._createFromPositionAndShift(e.sourcePosition, e.howMany);
      return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition) ? [new Cu(0)] : (e.sourcePosition.getShiftedBy(e.howMany).isEqual(t.sourcePosition) ? t.sourcePosition.stickiness = "toNone" : e.targetPosition.isEqual(t.sourcePosition) && "mergeSourceAffected" == n.abRelation ? t.sourcePosition.stickiness = "toNext" : e.sourcePosition.isEqual(t.targetPosition) ? (t.targetPosition.stickiness = "toNone", t.howMany -= e.howMany) : e.targetPosition.isEqual(t.targetPosition) && "mergeTargetWasBefore" == n.abRelation ? (t.targetPosition.stickiness = "toPrevious", t.howMany += e.howMany) : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany)), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.sourcePosition.stickiness = "toPrevious", t.targetPosition.stickiness = "toNext", t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
    }), Tu(bu, ku, (t, e, n) => {
      if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
        const o = 0 != e.howMany,
          i = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);
        if (o || i || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
      }
      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }
      return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
    }), Tu(pu, fu, (t, e) => {
      const n = ml._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];
      return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
    }), Tu(pu, pu, (t, e, n) => {
      const o = ml._createFromPositionAndShift(t.sourcePosition, t.howMany),
        i = ml._createFromPositionAndShift(e.sourcePosition, e.howMany);
      let r,
        s = n.aIsStrong,
        a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), zu(t, e) && zu(e, t)) return [e.getReversed()];
      if (o.containsPosition(e.targetPosition) && o.containsRange(i, !0)) return o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Ru([o], r);
      if (i.containsPosition(t.targetPosition) && i.containsRange(o, !0)) return o.start = o.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), o.end = o.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), Ru([o], r);
      const c = X(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if ("prefix" == c || "extension" == c) return o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Ru([o], r);
      "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      const l = [],
        d = o.getDifference(i);
      for (const t of d) {
        t.start = t.start._getTransformedByDeletion(e.sourcePosition, e.howMany), t.end = t.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
        const n = "same" == X(t.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
          o = t._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, n);
        l.push(...o);
      }
      const u = o.getIntersection(i);
      return null !== u && s && (u.start = u.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), u.end = u.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === l.length ? l.push(u) : 1 == l.length ? i.start.isBefore(o.start) || i.start.isEqual(o.start) ? l.unshift(u) : l.push(u) : l.splice(1, 0, u)), 0 === l.length ? [new Cu(t.baseVersion)] : Ru(l, r);
    }), Tu(pu, ku, (t, e, n) => {
      let o = t.targetPosition.clone();
      t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (o = t.targetPosition._getTransformedBySplitOperation(e));
      const i = ml._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (i.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = o, [t];
      if (i.start.hasSameParentAs(e.splitPosition) && i.containsPosition(e.splitPosition)) {
        let t = new ml(e.splitPosition, i.end);
        t = t._getTransformedBySplitOperation(e);
        return Ru([new ml(i.start, e.splitPosition), t], o);
      }
      t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (o = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (o = t.targetPosition);
      const r = [i._getTransformedBySplitOperation(e)];
      if (e.graveyardPosition) {
        const o = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
        t.howMany > 1 && o && !n.aWasUndone && r.push(ml._createFromPositionAndShift(e.insertionPosition, 1));
      }
      return Ru(r, o);
    }), Tu(pu, bu, (t, e, n) => {
      const o = ml._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
        if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new Cu(0)];
      } else if (!n.aWasUndone) {
        const n = [];
        let o = e.graveyardPosition.clone(),
          i = e.targetPosition._getTransformedByMergeOperation(e);
        t.howMany > 1 && (n.push(new pu(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), o = o._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), i = i._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));
        const r = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
          s = new pu(o, 1, r, 0),
          a = s.getMovedRangeStart().path.slice();
        a.push(0);
        const c = new cl(s.targetPosition.root, a);
        i = i._getTransformedByMove(o, r, 1);
        const l = new pu(i, e.howMany, c, 0);
        return n.push(s), n.push(l), n;
      }
      const i = ml._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);
      return t.sourcePosition = i.start, t.howMany = i.end.offset - i.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
    }), Tu(vu, fu, (t, e) => (t.position = t.position._getTransformedByInsertOperation(e), [t])), Tu(vu, bu, (t, e) => t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t])), Tu(vu, pu, (t, e) => (t.position = t.position._getTransformedByMoveOperation(e), [t])), Tu(vu, vu, (t, e, n) => {
      if (t.position.isEqual(e.position)) {
        if (!n.aIsStrong) return [new Cu(0)];
        t.oldName = e.newName;
      }
      return [t];
    }), Tu(vu, ku, (t, e) => {
      if ("same" == X(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
        const e = new vu(t.position.getShiftedBy(1), t.oldName, t.newName, 0);
        return [t, e];
      }
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), Tu(yu, yu, (t, e, n) => {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) return [new Cu(0)];
        t.oldValue = e.newValue;
      }
      return [t];
    }), Tu(xu, xu, (t, e) => t.rootName === e.rootName && t.isAdd === e.isAdd ? [new Cu(0)] : [t]), Tu(ku, fu, (t, e) => (t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = t.insertionPosition._getTransformedByInsertOperation(e), [t])), Tu(ku, bu, (t, e, n) => {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        const n = e.graveyardPosition.path.slice();
        n.push(0);
        const o = new cl(e.graveyardPosition.root, n),
          i = ku.getInsertionPosition(new cl(e.graveyardPosition.root, n)),
          r = new ku(o, 0, i, null, 0);
        return t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = ku.getInsertionPosition(t.splitPosition), t.graveyardPosition = r.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [r, t];
      }
      return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = ku.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), Tu(ku, pu, (t, e, n) => {
      const o = ml._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (t.graveyardPosition) {
        const i = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);
        if (!n.bWasUndone && i) {
          const n = t.splitPosition._getTransformedByMoveOperation(e),
            o = t.graveyardPosition._getTransformedByMoveOperation(e),
            i = o.path.slice();
          i.push(0);
          const r = new cl(o.root, i);
          return [new pu(n, t.howMany, r, 0)];
        }
        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }
      const i = t.splitPosition.isEqual(e.targetPosition);
      if (i && ("insertAtSource" == n.baRelation || "splitBefore" == n.abRelation)) return t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = ku.getInsertionPosition(t.splitPosition), [t];
      if (i && n.abRelation && n.abRelation.howMany) {
        const {
          howMany: e,
          offset: o
        } = n.abRelation;
        return t.howMany += e, t.splitPosition = t.splitPosition.getShiftedBy(o), [t];
      }
      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.splitPosition)) {
        const n = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
        return t.howMany -= n, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = ku.getInsertionPosition(t.splitPosition), [t];
      }
      return e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = ku.getInsertionPosition(t.splitPosition), [t];
    }), Tu(ku, ku, (t, e, n) => {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) return [new Cu(0)];
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new Cu(0)];
        if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
      }
      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        const o = "$graveyard" == t.splitPosition.root.rootName,
          i = "$graveyard" == e.splitPosition.root.rootName;
        if (i && !o || !(o && !i) && n.aIsStrong) {
          const n = [];
          return e.howMany && n.push(new pu(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && n.push(new pu(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), n;
        }
        return [new Cu(0)];
      }
      if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];
      if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
        const n = e.insertionPosition.path.slice();
        n.push(0);
        const o = new cl(e.insertionPosition.root, n);
        return [t, new pu(t.insertionPosition, 1, o, 0)];
      }
      return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = ku.getInsertionPosition(t.splitPosition), [t];
    });
    class ju extends M(cl) {
      constructor(t, e, n = "toNone") {
        if (super(t, e, n), !this.root.is("rootElement")) throw new w("model-liveposition-root-not-rootelement", t);
        Fu.call(this);
      }
      detach() {
        this.stopListening();
      }
      toPosition() {
        return new cl(this.root, this.path.slice(), this.stickiness);
      }
      static fromPosition(t, e) {
        return new this(t.root, t.path.slice(), e || t.stickiness);
      }
    }
    function Fu() {
      this.listenTo(this.root.document.model, "applyOperation", (t, e) => {
        const n = e[0];
        n.isDocumentOperation && Vu.call(this, n);
      }, {
        priority: "low"
      });
    }
    function Vu(t) {
      const e = this.getTransformedByOperation(t);
      if (!this.isEqual(e)) {
        const t = this.toPosition();
        this.path = e.path, this.root = e.root, this.fire("change", t);
      }
    }
    ju.prototype.is = function (t) {
      return "livePosition" === t || "model:livePosition" === t || "position" == t || "model:position" === t;
    };
    class Hu {
      constructor(t = {}) {
        "string" == typeof t && (t = "transparent" === t ? {
          isUndoable: !1
        } : {}, A("batch-constructor-deprecated-string-type"));
        const {
          isUndoable: e = !0,
          isLocal: n = !0,
          isUndo: o = !1,
          isTyping: i = !1
        } = t;
        this.operations = [], this.isUndoable = e, this.isLocal = n, this.isUndo = o, this.isTyping = i;
      }
      get type() {
        return A("batch-type-deprecated"), "default";
      }
      get baseVersion() {
        for (const t of this.operations) if (null !== t.baseVersion) return t.baseVersion;
        return null;
      }
      addOperation(t) {
        return t.batch = this, this.operations.push(t), t;
      }
    }
    var Uu = Object.defineProperty,
      qu = Object.defineProperties,
      Gu = Object.getOwnPropertyDescriptors,
      Wu = Object.getOwnPropertySymbols,
      Ku = Object.prototype.hasOwnProperty,
      $u = Object.prototype.propertyIsEnumerable,
      Yu = (t, e, n) => e in t ? Uu(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      Qu = (t, e) => {
        for (var n in e || (e = {})) Ku.call(e, n) && Yu(t, n, e[n]);
        if (Wu) for (var n of Wu(e)) $u.call(e, n) && Yu(t, n, e[n]);
        return t;
      };
    class Zu {
      constructor(t) {
        this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changedRoots = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null, this._refreshedItems = new Set(), this._markerCollection = t;
      }
      get isEmpty() {
        return 0 == this._changesInElement.size && 0 == this._changedMarkers.size && 0 == this._changedRoots.size;
      }
      bufferOperation(t) {
        const e = t;
        switch (e.type) {
          case "insert":
            if (this._isInInsertedElement(e.position.parent)) return;
            this._markInsert(e.position.parent, e.position.offset, e.nodes.maxOffset);
            break;
          case "addAttribute":
          case "removeAttribute":
          case "changeAttribute":
            for (const t of e.range.getItems({
              shallow: !0
            })) this._isInInsertedElement(t.parent) || this._markAttribute(t);
            break;
          case "remove":
          case "move":
          case "reinsert":
            {
              if (e.sourcePosition.isEqual(e.targetPosition) || e.sourcePosition.getShiftedBy(e.howMany).isEqual(e.targetPosition)) return;
              const t = this._isInInsertedElement(e.sourcePosition.parent),
                n = this._isInInsertedElement(e.targetPosition.parent);
              t || this._markRemove(e.sourcePosition.parent, e.sourcePosition.offset, e.howMany), n || this._markInsert(e.targetPosition.parent, e.getMovedRangeStart().offset, e.howMany);
              break;
            }
          case "rename":
            {
              if (this._isInInsertedElement(e.position.parent)) return;
              this._markRemove(e.position.parent, e.position.offset, 1), this._markInsert(e.position.parent, e.position.offset, 1);
              const t = ml._createFromPositionAndShift(e.position, 1);
              for (const e of this._markerCollection.getMarkersIntersectingRange(t)) {
                const t = e.getData();
                this.bufferMarkerChange(e.name, t, t);
              }
              break;
            }
          case "split":
            {
              const t = e.splitPosition.parent;
              this._isInInsertedElement(t) || this._markRemove(t, e.splitPosition.offset, e.howMany), this._isInInsertedElement(e.insertionPosition.parent) || this._markInsert(e.insertionPosition.parent, e.insertionPosition.offset, 1), e.graveyardPosition && this._markRemove(e.graveyardPosition.parent, e.graveyardPosition.offset, 1);
              break;
            }
          case "merge":
            {
              const t = e.sourcePosition.parent;
              this._isInInsertedElement(t.parent) || this._markRemove(t.parent, t.startOffset, 1);
              const n = e.graveyardPosition.parent;
              this._markInsert(n, e.graveyardPosition.offset, 1);
              const o = e.targetPosition.parent;
              this._isInInsertedElement(o) || this._markInsert(o, e.targetPosition.offset, t.maxOffset);
              break;
            }
          case "detachRoot":
          case "addRoot":
            {
              const t = e.affectedSelectable;
              if (!t._isLoaded) return;
              if (t.isAttached() == e.isAdd) return;
              this._bufferRootStateChange(e.rootName, e.isAdd);
              break;
            }
          case "addRootAttribute":
          case "removeRootAttribute":
          case "changeRootAttribute":
            {
              if (!e.root._isLoaded) return;
              const t = e.root.rootName;
              this._bufferRootAttributeChange(t, e.key, e.oldValue, e.newValue);
              break;
            }
        }
        this._cachedChanges = null;
      }
      bufferMarkerChange(t, e, n) {
        e.range && e.range.root.is("rootElement") && !e.range.root._isLoaded && (e.range = null), n.range && n.range.root.is("rootElement") && !n.range.root._isLoaded && (n.range = null);
        let o = this._changedMarkers.get(t);
        o ? o.newMarkerData = n : (o = {
          newMarkerData: n,
          oldMarkerData: e
        }, this._changedMarkers.set(t, o)), null == o.oldMarkerData.range && null == n.range && this._changedMarkers.delete(t);
      }
      getMarkersToRemove() {
        const t = [];
        for (const [e, n] of this._changedMarkers) null != n.oldMarkerData.range && t.push({
          name: e,
          range: n.oldMarkerData.range
        });
        return t;
      }
      getMarkersToAdd() {
        const t = [];
        for (const [e, n] of this._changedMarkers) null != n.newMarkerData.range && t.push({
          name: e,
          range: n.newMarkerData.range
        });
        return t;
      }
      getChangedMarkers() {
        return Array.from(this._changedMarkers).map(([t, e]) => ({
          name: t,
          data: {
            oldRange: e.oldMarkerData.range,
            newRange: e.newMarkerData.range
          }
        }));
      }
      hasDataChanges() {
        if (this.getChanges().length) return !0;
        if (this._changedRoots.size > 0) return !0;
        for (const {
          newMarkerData: t,
          oldMarkerData: e
        } of this._changedMarkers.values()) {
          if (t.affectsData !== e.affectsData) return !0;
          if (t.affectsData) {
            const n = t.range && !e.range,
              o = !t.range && e.range,
              i = t.range && e.range && !t.range.isEqual(e.range);
            if (n || o || i) return !0;
          }
        }
        return !1;
      }
      getChanges(t = {}) {
        if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
        let e = [];
        for (const t of this._changesInElement.keys()) {
          const n = this._changesInElement.get(t).sort((t, e) => t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1),
            o = this._elementSnapshots.get(t),
            i = Ju(t.getChildren()),
            r = Xu(o.length, n);
          let s = 0,
            a = 0;
          for (const n of r) if ("i" === n) e.push(this._getInsertDiff(t, s, i[s])), s++;else if ("r" === n) e.push(this._getRemoveDiff(t, s, o[a])), a++;else if ("a" === n) {
            const n = i[s].attributes,
              r = o[a].attributes;
            let c;
            if ("$text" == i[s].name) c = new ml(cl._createAt(t, s), cl._createAt(t, s + 1));else {
              const e = t.offsetToIndex(s);
              c = new ml(cl._createAt(t, s), cl._createAt(t.getChild(e), 0));
            }
            e.push(...this._getAttributesDiff(c, r, n)), s++, a++;
          } else s++, a++;
        }
        e.sort((t, e) => t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1);
        for (let t = 1, n = 0; t < e.length; t++) {
          const o = e[n],
            i = e[t],
            r = "remove" == o.type && "remove" == i.type && "$text" == o.name && "$text" == i.name && o.position.isEqual(i.position),
            s = "insert" == o.type && "insert" == i.type && "$text" == o.name && "$text" == i.name && o.position.parent == i.position.parent && o.position.offset + o.length == i.position.offset,
            a = "attribute" == o.type && "attribute" == i.type && o.position.parent == i.position.parent && o.range.isFlat && i.range.isFlat && o.position.offset + o.length == i.position.offset && o.attributeKey == i.attributeKey && o.attributeOldValue == i.attributeOldValue && o.attributeNewValue == i.attributeNewValue;
          r || s || a ? (o.length++, a && (o.range.end = o.range.end.getShiftedBy(1)), e[t] = null) : n = t;
        }
        e = e.filter(t => t);
        for (const t of e) delete t.changeCount, "attribute" == t.type && (delete t.position, delete t.length);
        return this._changeCount = 0, this._cachedChangesWithGraveyard = e, this._cachedChanges = e.filter(th), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
      }
      getChangedRoots() {
        return Array.from(this._changedRoots.values()).map(t => {
          const e = Qu({}, t);
          return void 0 !== e.state && delete e.attributes, e;
        });
      }
      getRefreshedItems() {
        return new Set(this._refreshedItems);
      }
      reset() {
        this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._changedRoots.clear(), this._refreshedItems = new Set(), this._cachedChanges = null;
      }
      _bufferRootStateChange(t, e) {
        if (!this._changedRoots.has(t)) return void this._changedRoots.set(t, {
          name: t,
          state: e ? "attached" : "detached"
        });
        const n = this._changedRoots.get(t);
        void 0 !== n.state ? (delete n.state, void 0 === n.attributes && this._changedRoots.delete(t)) : n.state = e ? "attached" : "detached";
      }
      _bufferRootAttributeChange(t, e, n, o) {
        const i = this._changedRoots.get(t) || {
            name: t
          },
          r = i.attributes || {};
        if (r[e]) {
          const t = r[e];
          o === t.oldValue ? delete r[e] : t.newValue = o;
        } else r[e] = {
          oldValue: n,
          newValue: o
        };
        0 === Object.entries(r).length ? (delete i.attributes, void 0 === i.state && this._changedRoots.delete(t)) : (i.attributes = r, this._changedRoots.set(t, i));
      }
      _refreshItem(t) {
        if (this._isInInsertedElement(t.parent)) return;
        this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize), this._refreshedItems.add(t);
        const e = ml._createOn(t);
        for (const t of this._markerCollection.getMarkersIntersectingRange(e)) {
          const e = t.getData();
          this.bufferMarkerChange(t.name, e, e);
        }
        this._cachedChanges = null;
      }
      _bufferRootLoad(t) {
        if (t.isAttached()) {
          this._bufferRootStateChange(t.rootName, !0), this._markInsert(t, 0, t.maxOffset);
          for (const e of t.getAttributeKeys()) this._bufferRootAttributeChange(t.rootName, e, null, t.getAttribute(e));
          for (const n of this._markerCollection) if (n.getRange().root == t) {
            const t = n.getData();
            this.bufferMarkerChange(n.name, (e = Qu({}, t), qu(e, Gu({
              range: null
            }))), t);
          }
          var e;
        }
      }
      _markInsert(t, e, n) {
        if (t.root.is("rootElement") && !t.root._isLoaded) return;
        const o = {
          type: "insert",
          offset: e,
          howMany: n,
          count: this._changeCount++
        };
        this._markChange(t, o);
      }
      _markRemove(t, e, n) {
        if (t.root.is("rootElement") && !t.root._isLoaded) return;
        const o = {
          type: "remove",
          offset: e,
          howMany: n,
          count: this._changeCount++
        };
        this._markChange(t, o), this._removeAllNestedChanges(t, e, n);
      }
      _markAttribute(t) {
        if (t.root.is("rootElement") && !t.root._isLoaded) return;
        const e = {
          type: "attribute",
          offset: t.startOffset,
          howMany: t.offsetSize,
          count: this._changeCount++
        };
        this._markChange(t.parent, e);
      }
      _markChange(t, e) {
        this._makeSnapshot(t);
        const n = this._getChangesForElement(t);
        this._handleChange(e, n), n.push(e);
        for (let t = 0; t < n.length; t++) n[t].howMany < 1 && (n.splice(t, 1), t--);
      }
      _getChangesForElement(t) {
        let e;
        return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
      }
      _makeSnapshot(t) {
        this._elementSnapshots.has(t) || this._elementSnapshots.set(t, Ju(t.getChildren()));
      }
      _handleChange(t, e) {
        t.nodesToHandle = t.howMany;
        for (const n of e) {
          const o = t.offset + t.howMany,
            i = n.offset + n.howMany;
          if ("insert" == t.type && ("insert" == n.type && (t.offset <= n.offset ? n.offset += t.howMany : t.offset < i && (n.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == n.type && t.offset < n.offset && (n.offset += t.howMany), "attribute" == n.type)) if (t.offset <= n.offset) n.offset += t.howMany;else if (t.offset < i) {
            const i = n.howMany;
            n.howMany = t.offset - n.offset, e.unshift({
              type: "attribute",
              offset: o,
              howMany: i - n.howMany,
              count: this._changeCount++
            });
          }
          if ("remove" == t.type) {
            if ("insert" == n.type) if (o <= n.offset) n.offset -= t.howMany;else if (o <= i) {
              if (t.offset < n.offset) {
                const e = o - n.offset;
                n.offset = t.offset, n.howMany -= e, t.nodesToHandle -= e;
              } else n.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
            } else if (t.offset <= n.offset) t.nodesToHandle -= n.howMany, n.howMany = 0;else if (t.offset < i) {
              const e = i - t.offset;
              n.howMany -= e, t.nodesToHandle -= e;
            }
            if ("remove" == n.type && (o <= n.offset ? n.offset -= t.howMany : t.offset < n.offset && (t.nodesToHandle += n.howMany, n.howMany = 0)), "attribute" == n.type) if (o <= n.offset) n.offset -= t.howMany;else if (t.offset < n.offset) {
              const e = o - n.offset;
              n.offset = t.offset, n.howMany -= e;
            } else if (t.offset < i) if (o <= i) {
              const o = n.howMany;
              n.howMany = t.offset - n.offset;
              const i = o - n.howMany - t.nodesToHandle;
              e.unshift({
                type: "attribute",
                offset: t.offset,
                howMany: i,
                count: this._changeCount++
              });
            } else n.howMany -= i - t.offset;
          }
          if ("attribute" == t.type) {
            if ("insert" == n.type) if (t.offset < n.offset && o > n.offset) {
              if (o > i) {
                const t = {
                  type: "attribute",
                  offset: i,
                  howMany: o - i,
                  count: this._changeCount++
                };
                this._handleChange(t, e), e.push(t);
              }
              t.nodesToHandle = n.offset - t.offset, t.howMany = t.nodesToHandle;
            } else t.offset >= n.offset && t.offset < i && (o > i ? (t.nodesToHandle = o - i, t.offset = i) : t.nodesToHandle = 0);
            if ("remove" == n.type && t.offset < n.offset && o > n.offset) {
              const i = {
                type: "attribute",
                offset: n.offset,
                howMany: o - n.offset,
                count: this._changeCount++
              };
              this._handleChange(i, e), e.push(i), t.nodesToHandle = n.offset - t.offset, t.howMany = t.nodesToHandle;
            }
            "attribute" == n.type && (t.offset >= n.offset && o <= i ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= n.offset && o >= i && (n.howMany = 0));
          }
        }
        t.howMany = t.nodesToHandle, delete t.nodesToHandle;
      }
      _getInsertDiff(t, e, n) {
        return {
          type: "insert",
          position: cl._createAt(t, e),
          name: n.name,
          attributes: new Map(n.attributes),
          length: 1,
          changeCount: this._changeCount++,
          _element: n.element
        };
      }
      _getRemoveDiff(t, e, n) {
        return {
          type: "remove",
          position: cl._createAt(t, e),
          name: n.name,
          attributes: new Map(n.attributes),
          length: 1,
          changeCount: this._changeCount++,
          _element: n.element
        };
      }
      _getAttributesDiff(t, e, n) {
        const o = [];
        n = new Map(n);
        for (const [i, r] of e) {
          const e = n.has(i) ? n.get(i) : null;
          e !== r && o.push({
            type: "attribute",
            position: t.start,
            range: t.clone(),
            length: 1,
            attributeKey: i,
            attributeOldValue: r,
            attributeNewValue: e,
            changeCount: this._changeCount++
          }), n.delete(i);
        }
        for (const [e, i] of n) o.push({
          type: "attribute",
          position: t.start,
          range: t.clone(),
          length: 1,
          attributeKey: e,
          attributeOldValue: null,
          attributeNewValue: i,
          changeCount: this._changeCount++
        });
        return o;
      }
      _isInInsertedElement(t) {
        const e = t.parent;
        if (!e) return !1;
        const n = this._changesInElement.get(e),
          o = t.startOffset;
        if (n) for (const t of n) if ("insert" == t.type && o >= t.offset && o < t.offset + t.howMany) return !0;
        return this._isInInsertedElement(e);
      }
      _removeAllNestedChanges(t, e, n) {
        const o = new ml(cl._createAt(t, e), cl._createAt(t, e + n));
        for (const t of o.getItems({
          shallow: !0
        })) t.is("element") && (this._elementSnapshots.delete(t), this._changesInElement.delete(t), this._removeAllNestedChanges(t, 0, t.maxOffset));
      }
    }
    function Ju(t) {
      const e = [];
      for (const n of t) if (n.is("$text")) for (let t = 0; t < n.data.length; t++) e.push({
        name: "$text",
        attributes: new Map(n.getAttributes())
      });else e.push({
        name: n.name,
        attributes: new Map(n.getAttributes()),
        element: n
      });
      return e;
    }
    function Xu(t, e) {
      const n = [];
      let o = 0,
        i = 0;
      for (const t of e) {
        if (t.offset > o) {
          for (let e = 0; e < t.offset - o; e++) n.push("e");
          i += t.offset - o;
        }
        if ("insert" == t.type) {
          for (let e = 0; e < t.howMany; e++) n.push("i");
          o = t.offset + t.howMany;
        } else if ("remove" == t.type) {
          for (let e = 0; e < t.howMany; e++) n.push("r");
          o = t.offset, i += t.howMany;
        } else n.push(..."a".repeat(t.howMany).split("")), o = t.offset + t.howMany, i += t.howMany;
      }
      if (i < t) for (let e = 0; e < t - i - o; e++) n.push("e");
      return n;
    }
    function th(t) {
      const e = "position" in t && "$graveyard" == t.position.root.rootName,
        n = "range" in t && "$graveyard" == t.range.root.rootName;
      return !e && !n;
    }
    class eh {
      constructor() {
        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set(), this._baseVersionToOperationIndex = new Map(), this._version = 0, this._gaps = new Map();
      }
      get version() {
        return this._version;
      }
      set version(t) {
        this._operations.length && t > this._version + 1 && this._gaps.set(this._version, t), this._version = t;
      }
      get lastOperation() {
        return this._operations[this._operations.length - 1];
      }
      addOperation(t) {
        if (t.baseVersion !== this.version) throw new w("model-document-history-addoperation-incorrect-version", this, {
          operation: t,
          historyVersion: this.version
        });
        this._operations.push(t), this._version++, this._baseVersionToOperationIndex.set(t.baseVersion, this._operations.length - 1);
      }
      getOperations(t, e = this.version) {
        if (!this._operations.length) return [];
        const n = this._operations[0];
        void 0 === t && (t = n.baseVersion);
        let o = e - 1;
        for (const [e, n] of this._gaps) t > e && t < n && (t = n), o > e && o < n && (o = e - 1);
        if (o < n.baseVersion || t > this.lastOperation.baseVersion) return [];
        let i = this._baseVersionToOperationIndex.get(t);
        void 0 === i && (i = 0);
        let r = this._baseVersionToOperationIndex.get(o);
        return void 0 === r && (r = this._operations.length - 1), this._operations.slice(i, r + 1);
      }
      getOperation(t) {
        const e = this._baseVersionToOperationIndex.get(t);
        if (void 0 !== e) return this._operations[e];
      }
      setOperationAsUndone(t, e) {
        this._undoPairs.set(e, t), this._undoneOperations.add(t);
      }
      isUndoingOperation(t) {
        return this._undoPairs.has(t);
      }
      isUndoneOperation(t) {
        return this._undoneOperations.has(t);
      }
      getUndoneOperation(t) {
        return this._undoPairs.get(t);
      }
      reset() {
        this._version = 0, this._undoPairs = new Map(), this._operations = [], this._undoneOperations = new Set(), this._gaps = new Map(), this._baseVersionToOperationIndex = new Map();
      }
    }
    class nh extends rl {
      constructor(t, e, n = "main") {
        super(e), this._isAttached = !0, this._isLoaded = !0, this._document = t, this.rootName = n;
      }
      get document() {
        return this._document;
      }
      isAttached() {
        return this._isAttached;
      }
      toJSON() {
        return this.rootName;
      }
    }
    nh.prototype.is = function (t, e) {
      return e ? e === this.name && ("rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t) : "rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t || "node" === t || "model:node" === t;
    };
    var oh = Object.defineProperty,
      ih = Object.defineProperties,
      rh = Object.getOwnPropertyDescriptors,
      sh = Object.getOwnPropertySymbols,
      ah = Object.prototype.hasOwnProperty,
      ch = Object.prototype.propertyIsEnumerable,
      lh = (t, e, n) => e in t ? oh(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      dh = (t, e) => {
        for (var n in e || (e = {})) ah.call(e, n) && lh(t, n, e[n]);
        if (sh) for (var n of sh(e)) ch.call(e, n) && lh(t, n, e[n]);
        return t;
      },
      uh = (t, e) => ih(t, rh(e));
    const hh = "$graveyard";
    class gh extends M() {
      constructor(t) {
        super(), this.model = t, this.history = new eh(), this.selection = new Vl(this), this.roots = new Gi({
          idProperty: "rootName"
        }), this.differ = new Zu(t.markers), this.isReadOnly = !1, this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", hh), this.listenTo(t, "applyOperation", (t, e) => {
          const n = e[0];
          n.isDocumentOperation && this.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(t, "applyOperation", (t, e) => {
          const n = e[0];
          n.isDocumentOperation && this.history.addOperation(n);
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", () => {
          this._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(t.markers, "update", (t, e, n, o, i) => {
          const r = uh(dh({}, e.getData()), {
            range: o
          });
          this.differ.bufferMarkerChange(e.name, i, r), null === n && e.on("change", (t, n) => {
            const o = e.getData();
            this.differ.bufferMarkerChange(e.name, uh(dh({}, o), {
              range: n
            }), o);
          });
        }), this.registerPostFixer(t => {
          let e = !1;
          for (const n of this.roots) n.isAttached() || n.isEmpty || (t.remove(t.createRangeIn(n)), e = !0);
          for (const n of this.model.markers) n.getRange().root.isAttached() || (t.removeMarker(n), e = !0);
          return e;
        });
      }
      get version() {
        return this.history.version;
      }
      set version(t) {
        this.history.version = t;
      }
      get graveyard() {
        return this.getRoot(hh);
      }
      createRoot(t = "$root", e = "main") {
        if (this.roots.get(e)) throw new w("model-document-createroot-name-exists", this, {
          name: e
        });
        const n = new nh(this, t, e);
        return this.roots.add(n), n;
      }
      destroy() {
        this.selection.destroy(), this.stopListening();
      }
      getRoot(t = "main") {
        return this.roots.get(t);
      }
      getRootNames(t = !1) {
        return this.getRoots(t).map(t => t.rootName);
      }
      getRoots(t = !1) {
        return this.roots.filter(e => e != this.graveyard && (t || e.isAttached()) && e._isLoaded);
      }
      registerPostFixer(t) {
        this._postFixers.add(t);
      }
      toJSON() {
        const t = ns(this);
        return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
      }
      _handleChangeBlock(t) {
        this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
      }
      _hasDocumentChangedFromTheLastChangeBlock() {
        return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
      }
      _getDefaultRoot() {
        const t = this.getRoots();
        return t.length ? t[0] : this.graveyard;
      }
      _getDefaultRange() {
        const t = this._getDefaultRoot(),
          e = this.model,
          n = e.schema,
          o = e.createPositionFromPath(t, [0]);
        return n.getNearestSelectionRange(o) || e.createRange(o);
      }
      _validateSelectionRange(t) {
        return mh(t.start) && mh(t.end);
      }
      _callPostFixers(t) {
        let e = !1;
        do {
          for (const n of this._postFixers) if (this.selection.refresh(), e = n(t), e) break;
        } while (e);
      }
    }
    function mh(t) {
      const e = t.textNode;
      if (e) {
        const n = e.data,
          o = t.offset - e.startOffset;
        return !Zi(n, o) && !Ji(n, o);
      }
      return !0;
    }
    var ph = Object.defineProperty,
      fh = Object.defineProperties,
      kh = Object.getOwnPropertyDescriptors,
      bh = Object.getOwnPropertySymbols,
      wh = Object.prototype.hasOwnProperty,
      Ah = Object.prototype.propertyIsEnumerable,
      _h = (t, e, n) => e in t ? ph(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class Ch extends M() {
      constructor() {
        super(...arguments), this._markers = new Map();
      }
      [Symbol.iterator]() {
        return this._markers.values();
      }
      has(t) {
        const e = t instanceof vh ? t.name : t;
        return this._markers.has(e);
      }
      get(t) {
        return this._markers.get(t) || null;
      }
      _set(t, e, n = !1, o = !1) {
        const i = t instanceof vh ? t.name : t;
        if (i.includes(",")) throw new w("markercollection-incorrect-marker-name", this);
        const r = this._markers.get(i);
        if (r) {
          const t = r.getData(),
            s = r.getRange();
          let a = !1;
          return s.isEqual(e) || (r._attachLiveRange(zl.fromRange(e)), a = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, a = !0), "boolean" == typeof o && o != r.affectsData && (r._affectsData = o, a = !0), a && this.fire(`update:${i}`, r, s, e, t), r;
        }
        const s = zl.fromRange(e),
          a = new vh(i, s, n, o);
        var c;
        return this._markers.set(i, a), this.fire(`update:${i}`, a, null, e, (c = ((t, e) => {
          for (var n in e || (e = {})) wh.call(e, n) && _h(t, n, e[n]);
          if (bh) for (var n of bh(e)) Ah.call(e, n) && _h(t, n, e[n]);
          return t;
        })({}, a.getData()), fh(c, kh({
          range: null
        })))), a;
      }
      _remove(t) {
        const e = t instanceof vh ? t.name : t,
          n = this._markers.get(e);
        return !!n && (this._markers.delete(e), this.fire(`update:${e}`, n, n.getRange(), null, n.getData()), this._destroyMarker(n), !0);
      }
      _refresh(t) {
        const e = t instanceof vh ? t.name : t,
          n = this._markers.get(e);
        if (!n) throw new w("markercollection-refresh-marker-not-exists", this);
        const o = n.getRange();
        this.fire(`update:${e}`, n, o, o, n.getData());
      }
      *getMarkersAtPosition(t) {
        for (const e of this) e.getRange().containsPosition(t) && (yield e);
      }
      *getMarkersIntersectingRange(t) {
        for (const e of this) null !== e.getRange().getIntersection(t) && (yield e);
      }
      destroy() {
        for (const t of this._markers.values()) this._destroyMarker(t);
        this._markers = null, this.stopListening();
      }
      *getMarkersGroup(t) {
        for (const e of this._markers.values()) e.name.startsWith(t + ":") && (yield e);
      }
      _destroyMarker(t) {
        t.stopListening(), t._detachLiveRange();
      }
    }
    class vh extends M(tl) {
      constructor(t, e, n, o) {
        super(), this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = o;
      }
      get managedUsingOperations() {
        if (!this._liveRange) throw new w("marker-destroyed", this);
        return this._managedUsingOperations;
      }
      get affectsData() {
        if (!this._liveRange) throw new w("marker-destroyed", this);
        return this._affectsData;
      }
      getData() {
        return {
          range: this.getRange(),
          affectsData: this.affectsData,
          managedUsingOperations: this.managedUsingOperations
        };
      }
      getStart() {
        if (!this._liveRange) throw new w("marker-destroyed", this);
        return this._liveRange.start.clone();
      }
      getEnd() {
        if (!this._liveRange) throw new w("marker-destroyed", this);
        return this._liveRange.end.clone();
      }
      getRange() {
        if (!this._liveRange) throw new w("marker-destroyed", this);
        return this._liveRange.toRange();
      }
      _attachLiveRange(t) {
        return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
      }
      _detachLiveRange() {
        this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
      }
    }
    vh.prototype.is = function (t) {
      return "marker" === t || "model:marker" === t;
    };
    class yh extends au {
      constructor(t, e) {
        super(null), this.sourcePosition = t.clone(), this.howMany = e;
      }
      get type() {
        return "detach";
      }
      get affectedSelectable() {
        return null;
      }
      toJSON() {
        const t = super.toJSON();
        return t.sourcePosition = this.sourcePosition.toJSON(), t;
      }
      _validate() {
        if (this.sourcePosition.root.document) throw new w("detach-operation-on-document-node", this);
      }
      _execute() {
        lu(ml._createFromPositionAndShift(this.sourcePosition, this.howMany));
      }
      static get className() {
        return "DetachOperation";
      }
    }
    class xh extends tl {
      constructor(t) {
        super(), this.markers = new Map(), this._children = new nl(), t && this._insertChild(0, t);
      }
      [Symbol.iterator]() {
        return this.getChildren();
      }
      get childCount() {
        return this._children.length;
      }
      get maxOffset() {
        return this._children.maxOffset;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      get nextSibling() {
        return null;
      }
      get previousSibling() {
        return null;
      }
      get root() {
        return this;
      }
      get parent() {
        return null;
      }
      get document() {
        return null;
      }
      isAttached() {
        return !1;
      }
      getAncestors() {
        return [];
      }
      getChild(t) {
        return this._children.getNode(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      getChildIndex(t) {
        return this._children.getNodeIndex(t);
      }
      getChildStartOffset(t) {
        return this._children.getNodeStartOffset(t);
      }
      getPath() {
        return [];
      }
      getNodeByPath(t) {
        let e = this;
        for (const n of t) e = e.getChild(e.offsetToIndex(n));
        return e;
      }
      offsetToIndex(t) {
        return this._children.offsetToIndex(t);
      }
      toJSON() {
        const t = [];
        for (const e of this._children) t.push(e.toJSON());
        return t;
      }
      static fromJSON(t) {
        const e = [];
        for (const n of t) n.name ? e.push(rl.fromJSON(n)) : e.push(ol.fromJSON(n));
        return new xh(e);
      }
      _appendChild(t) {
        this._insertChild(this.childCount, t);
      }
      _insertChild(t, e) {
        const n = function (t) {
          if ("string" == typeof t) return [new ol(t)];
          tt(t) || (t = [t]);
          return Array.from(t).map(t => "string" == typeof t ? new ol(t) : t instanceof il ? new ol(t.data, t.getAttributes()) : t);
        }(e);
        for (const t of n) null !== t.parent && t._remove(), t.parent = this;
        this._children._insertNodes(t, n);
      }
      _removeChildren(t, e = 1) {
        const n = this._children._removeNodes(t, e);
        for (const t of n) t.parent = null;
        return n;
      }
    }
    xh.prototype.is = function (t) {
      return "documentFragment" === t || "model:documentFragment" === t;
    };
    class Eh {
      constructor(t, e) {
        this.model = t, this.batch = e;
      }
      createText(t, e) {
        return new ol(t, e);
      }
      createElement(t, e) {
        return new rl(t, e);
      }
      createDocumentFragment() {
        return new xh();
      }
      cloneElement(t, e = !0) {
        return t._clone(e);
      }
      insert(t, e, n = 0) {
        if (this._assertWriterUsedCorrectly(), t instanceof ol && "" == t.data) return;
        const o = cl._createAt(e, n);
        if (t.parent) {
          if (Sh(t.root, o.root)) return void this.move(ml._createOn(t), o);
          if (t.root.document) throw new w("model-writer-insert-forbidden-move", this);
          this.remove(t);
        }
        const i = o.root.document ? o.root.document.version : null,
          r = new fu(o, t, i);
        if (t instanceof ol && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof xh) for (const [e, n] of t.markers) {
          const t = cl._createAt(n.root, 0),
            i = {
              range: new ml(n.start._getCombined(t, o), n.end._getCombined(t, o)),
              usingOperation: !0,
              affectsData: !0
            };
          this.model.markers.has(e) ? this.updateMarker(e, i) : this.addMarker(e, i);
        }
      }
      insertText(t, e, n, o) {
        e instanceof xh || e instanceof rl || e instanceof cl ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, o);
      }
      insertElement(t, e, n, o) {
        e instanceof xh || e instanceof rl || e instanceof cl ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, o);
      }
      append(t, e) {
        this.insert(t, e, "end");
      }
      appendText(t, e, n) {
        e instanceof xh || e instanceof rl ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
      }
      appendElement(t, e, n) {
        e instanceof xh || e instanceof rl ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
      }
      setAttribute(t, e, n) {
        if (this._assertWriterUsedCorrectly(), n instanceof ml) {
          const o = n.getMinimalFlatRanges();
          for (const n of o) Dh(this, t, e, n);
        } else Ih(this, t, e, n);
      }
      setAttributes(t, e) {
        for (const [n, o] of Yi(t)) this.setAttribute(n, o, e);
      }
      removeAttribute(t, e) {
        if (this._assertWriterUsedCorrectly(), e instanceof ml) {
          const n = e.getMinimalFlatRanges();
          for (const e of n) Dh(this, t, null, e);
        } else Ih(this, t, null, e);
      }
      clearAttributes(t) {
        this._assertWriterUsedCorrectly();
        const e = t => {
          for (const e of t.getAttributeKeys()) this.removeAttribute(e, t);
        };
        if (t instanceof ml) for (const n of t.getItems()) e(n);else e(t);
      }
      move(t, e, n) {
        if (this._assertWriterUsedCorrectly(), !(t instanceof ml)) throw new w("writer-move-invalid-range", this);
        if (!t.isFlat) throw new w("writer-move-range-not-flat", this);
        const o = cl._createAt(e, n);
        if (o.isEqual(t.start)) return;
        if (this._addOperationForAffectedMarkers("move", t), !Sh(t.root, o.root)) throw new w("writer-move-different-document", this);
        const i = t.root.document ? t.root.document.version : null,
          r = new pu(t.start, t.end.offset - t.start.offset, o, i);
        this.batch.addOperation(r), this.model.applyOperation(r);
      }
      remove(t) {
        this._assertWriterUsedCorrectly();
        const e = (t instanceof ml ? t : ml._createOn(t)).getMinimalFlatRanges().reverse();
        for (const t of e) this._addOperationForAffectedMarkers("move", t), Mh(t.start, t.end.offset - t.start.offset, this.batch, this.model);
      }
      merge(t) {
        this._assertWriterUsedCorrectly();
        const e = t.nodeBefore,
          n = t.nodeAfter;
        if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof rl)) throw new w("writer-merge-no-element-before", this);
        if (!(n instanceof rl)) throw new w("writer-merge-no-element-after", this);
        t.root.document ? this._merge(t) : this._mergeDetached(t);
      }
      createPositionFromPath(t, e, n) {
        return this.model.createPositionFromPath(t, e, n);
      }
      createPositionAt(t, e) {
        return this.model.createPositionAt(t, e);
      }
      createPositionAfter(t) {
        return this.model.createPositionAfter(t);
      }
      createPositionBefore(t) {
        return this.model.createPositionBefore(t);
      }
      createRange(t, e) {
        return this.model.createRange(t, e);
      }
      createRangeIn(t) {
        return this.model.createRangeIn(t);
      }
      createRangeOn(t) {
        return this.model.createRangeOn(t);
      }
      createSelection(...t) {
        return this.model.createSelection(...t);
      }
      _mergeDetached(t) {
        const e = t.nodeBefore,
          n = t.nodeAfter;
        this.move(ml._createIn(n), cl._createAt(e, "end")), this.remove(n);
      }
      _merge(t) {
        const e = cl._createAt(t.nodeBefore, "end"),
          n = cl._createAt(t.nodeAfter, 0),
          o = t.root.document.graveyard,
          i = new cl(o, [0]),
          r = t.root.document.version,
          s = new bu(n, t.nodeAfter.maxOffset, e, i, r);
        this.batch.addOperation(s), this.model.applyOperation(s);
      }
      rename(t, e) {
        if (this._assertWriterUsedCorrectly(), !(t instanceof rl)) throw new w("writer-rename-not-element-instance", this);
        const n = t.root.document ? t.root.document.version : null,
          o = new vu(cl._createBefore(t), t.name, e, n);
        this.batch.addOperation(o), this.model.applyOperation(o);
      }
      split(t, e) {
        this._assertWriterUsedCorrectly();
        let n,
          o,
          i = t.parent;
        if (!i.parent) throw new w("writer-split-element-no-parent", this);
        if (e || (e = i.parent), !t.parent.getAncestors({
          includeSelf: !0
        }).includes(e)) throw new w("writer-split-invalid-limit-element", this);
        do {
          const e = i.root.document ? i.root.document.version : null,
            r = i.maxOffset - t.offset,
            s = ku.getInsertionPosition(t),
            a = new ku(t, r, s, null, e);
          this.batch.addOperation(a), this.model.applyOperation(a), n || o || (n = i, o = t.parent.nextSibling), i = (t = this.createPositionAfter(t.parent)).parent;
        } while (i !== e);
        return {
          position: t,
          range: new ml(cl._createAt(n, "end"), cl._createAt(o, 0))
        };
      }
      wrap(t, e) {
        if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new w("writer-wrap-range-not-flat", this);
        const n = e instanceof rl ? e : new rl(e);
        if (n.childCount > 0) throw new w("writer-wrap-element-not-empty", this);
        if (null !== n.parent) throw new w("writer-wrap-element-attached", this);
        this.insert(n, t.start);
        const o = new ml(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
        this.move(o, cl._createAt(n, 0));
      }
      unwrap(t) {
        if (this._assertWriterUsedCorrectly(), null === t.parent) throw new w("writer-unwrap-element-no-parent", this);
        this.move(ml._createIn(t), this.createPositionAfter(t)), this.remove(t);
      }
      addMarker(t, e) {
        if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new w("writer-addmarker-no-usingoperation", this);
        const n = e.usingOperation,
          o = e.range,
          i = void 0 !== e.affectsData && e.affectsData;
        if (this.model.markers.has(t)) throw new w("writer-addmarker-marker-exists", this);
        if (!o) throw new w("writer-addmarker-no-range", this);
        return n ? (Th(this, t, null, o, i), this.model.markers.get(t)) : this.model.markers._set(t, o, n, i);
      }
      updateMarker(t, e) {
        this._assertWriterUsedCorrectly();
        const n = "string" == typeof t ? t : t.name,
          o = this.model.markers.get(n);
        if (!o) throw new w("writer-updatemarker-marker-not-exists", this);
        if (!e) return A("writer-updatemarker-reconvert-using-editingcontroller", {
          markerName: n
        }), void this.model.markers._refresh(o);
        const i = "boolean" == typeof e.usingOperation,
          r = "boolean" == typeof e.affectsData,
          s = r ? e.affectsData : o.affectsData;
        if (!i && !e.range && !r) throw new w("writer-updatemarker-wrong-options", this);
        const a = o.getRange(),
          c = e.range ? e.range : a;
        i && e.usingOperation !== o.managedUsingOperations ? e.usingOperation ? Th(this, n, null, c, s) : (Th(this, n, a, null, s), this.model.markers._set(n, c, void 0, s)) : o.managedUsingOperations ? Th(this, n, a, c, s) : this.model.markers._set(n, c, void 0, s);
      }
      removeMarker(t) {
        this._assertWriterUsedCorrectly();
        const e = "string" == typeof t ? t : t.name;
        if (!this.model.markers.has(e)) throw new w("writer-removemarker-no-marker", this);
        const n = this.model.markers.get(e);
        if (!n.managedUsingOperations) return void this.model.markers._remove(e);
        Th(this, e, n.getRange(), null, n.affectsData);
      }
      addRoot(t, e = "$root") {
        this._assertWriterUsedCorrectly();
        const n = this.model.document.getRoot(t);
        if (n && n.isAttached()) throw new w("writer-addroot-root-exists", this);
        const o = this.model.document,
          i = new xu(t, e, !0, o, o.version);
        return this.batch.addOperation(i), this.model.applyOperation(i), this.model.document.getRoot(t);
      }
      detachRoot(t) {
        this._assertWriterUsedCorrectly();
        const e = "string" == typeof t ? this.model.document.getRoot(t) : t;
        if (!e || !e.isAttached()) throw new w("writer-detachroot-no-root", this);
        for (const t of this.model.markers) t.getRange().root === e && this.removeMarker(t);
        for (const t of e.getAttributeKeys()) this.removeAttribute(t, e);
        this.remove(this.createRangeIn(e));
        const n = this.model.document,
          o = new xu(e.rootName, e.name, !1, n, n.version);
        this.batch.addOperation(o), this.model.applyOperation(o);
      }
      setSelection(...t) {
        this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...t);
      }
      setSelectionFocus(t, e) {
        this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
      }
      setSelectionAttribute(t, e) {
        if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else for (const [e, n] of Yi(t)) this._setSelectionAttribute(e, n);
      }
      removeSelectionAttribute(t) {
        if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else for (const e of t) this._removeSelectionAttribute(e);
      }
      overrideSelectionGravity() {
        return this.model.document.selection._overrideGravity();
      }
      restoreSelectionGravity(t) {
        this.model.document.selection._restoreGravity(t);
      }
      _setSelectionAttribute(t, e) {
        const n = this.model.document.selection;
        if (n.isCollapsed && n.anchor.parent.isEmpty) {
          const o = Vl._getStoreAttributeKey(t);
          this.setAttribute(o, e, n.anchor.parent);
        }
        n._setAttribute(t, e);
      }
      _removeSelectionAttribute(t) {
        const e = this.model.document.selection;
        if (e.isCollapsed && e.anchor.parent.isEmpty) {
          const n = Vl._getStoreAttributeKey(t);
          this.removeAttribute(n, e.anchor.parent);
        }
        e._removeAttribute(t);
      }
      _assertWriterUsedCorrectly() {
        if (this.model._currentWriter !== this) throw new w("writer-incorrect-use", this);
      }
      _addOperationForAffectedMarkers(t, e) {
        for (const n of this.model.markers) {
          if (!n.managedUsingOperations) continue;
          const o = n.getRange();
          let i = !1;
          if ("move" === t) {
            const t = e;
            i = t.containsPosition(o.start) || t.start.isEqual(o.start) || t.containsPosition(o.end) || t.end.isEqual(o.end);
          } else {
            const t = e,
              n = t.nodeBefore,
              r = t.nodeAfter,
              s = o.start.parent == n && o.start.isAtEnd,
              a = o.end.parent == r && 0 == o.end.offset,
              c = o.end.nodeAfter == r,
              l = o.start.nodeAfter == r;
            i = s || a || c || l;
          }
          i && this.updateMarker(n.name, {
            range: o
          });
        }
      }
    }
    function Dh(t, e, n, o) {
      const i = t.model,
        r = i.document;
      let s,
        a,
        c,
        l = o.start;
      for (const t of o.getWalker({
        shallow: !0
      })) c = t.item.getAttribute(e), s && a != c && (a != n && d(), l = s), s = t.nextPosition, a = c;
      function d() {
        const o = new ml(l, s),
          c = o.root.document ? r.version : null,
          d = new _u(o, e, a, n, c);
        t.batch.addOperation(d), i.applyOperation(d);
      }
      s instanceof cl && s != l && a != n && d();
    }
    function Ih(t, e, n, o) {
      const i = t.model,
        r = i.document,
        s = o.getAttribute(e);
      let a, c;
      if (s != n) {
        if (o.root === o) {
          const t = o.document ? r.version : null;
          c = new yu(o, e, s, n, t);
        } else {
          a = new ml(cl._createBefore(o), t.createPositionAfter(o));
          const i = a.root.document ? r.version : null;
          c = new _u(a, e, s, n, i);
        }
        t.batch.addOperation(c), i.applyOperation(c);
      }
    }
    function Th(t, e, n, o, i) {
      const r = t.model,
        s = r.document,
        a = new wu(e, n, o, r.markers, !!i, s.version);
      t.batch.addOperation(a), r.applyOperation(a);
    }
    function Mh(t, e, n, o) {
      let i;
      if (t.root.document) {
        const n = o.document,
          r = new cl(n.graveyard, [0]);
        i = new pu(t, e, r, n.version);
      } else i = new yh(t, e);
      n.addOperation(i), o.applyOperation(i);
    }
    function Sh(t, e) {
      return t === e || t instanceof nh && e instanceof nh;
    }
    function Bh(t, e, n = {}) {
      if (e.isCollapsed) return;
      const o = e.getFirstRange();
      if ("$graveyard" == o.root.rootName) return;
      const i = t.schema;
      t.change(t => {
        if (!n.doNotResetEntireContent && function (t, e) {
          const n = t.getLimitElement(e);
          if (!e.containsEntireContent(n)) return !1;
          const o = e.getFirstRange();
          if (o.start.parent == o.end.parent) return !1;
          return t.checkChild(n, "paragraph");
        }(i, e)) return void function (t, e) {
          const n = t.model.schema.getLimitElement(e);
          t.remove(t.createRangeIn(n)), Lh(t, t.createPositionAt(n, 0), e);
        }(t, e);
        const r = {};
        if (!n.doNotAutoparagraph) {
          const t = e.getSelectedElement();
          t && Object.assign(r, i.getAttributesWithProperty(t, "copyOnReplace", !0));
        }
        const [s, a] = function (t) {
          const e = t.root.document.model,
            n = t.start;
          let o = t.end;
          if (e.hasContent(t, {
            ignoreMarkers: !0
          })) {
            const n = function (t) {
              const e = t.parent,
                n = e.root.document.model.schema,
                o = e.getAncestors({
                  parentFirst: !0,
                  includeSelf: !0
                });
              for (const t of o) {
                if (n.isLimit(t)) return null;
                if (n.isBlock(t)) return t;
              }
            }(o);
            if (n && o.isTouching(e.createPositionAt(n, 0))) {
              const n = e.createSelection(t);
              e.modifySelection(n, {
                direction: "backward"
              });
              const i = n.getLastPosition(),
                r = e.createRange(i, o);
              e.hasContent(r, {
                ignoreMarkers: !0
              }) || (o = i);
            }
          }
          return [ju.fromPosition(n, "toPrevious"), ju.fromPosition(o, "toNext")];
        }(o);
        s.isTouching(a) || t.remove(t.createRange(s, a)), n.leaveUnmerged || (!function (t, e, n) {
          const o = t.model;
          if (!Oh(t.model.schema, e, n)) return;
          const [i, r] = function (t, e) {
            const n = t.getAncestors(),
              o = e.getAncestors();
            let i = 0;
            for (; n[i] && n[i] == o[i];) i++;
            return [n[i], o[i]];
          }(e, n);
          if (!i || !r) return;
          !o.hasContent(i, {
            ignoreMarkers: !0
          }) && o.hasContent(r, {
            ignoreMarkers: !0
          }) ? Ph(t, e, n, i.parent) : Nh(t, e, n, i.parent);
        }(t, s, a), i.removeDisallowedAttributes(s.parent.getChildren(), t)), zh(t, e, s), !n.doNotAutoparagraph && function (t, e) {
          const n = t.checkChild(e, "$text"),
            o = t.checkChild(e, "paragraph");
          return !n && o;
        }(i, s) && Lh(t, s, e, r), s.detach(), a.detach();
      });
    }
    function Nh(t, e, n, o) {
      const i = e.parent,
        r = n.parent;
      if (i != o && r != o) {
        for (e = t.createPositionAfter(i), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(r, e), t.merge(e); n.parent.isEmpty;) {
          const e = n.parent;
          n = t.createPositionBefore(e), t.remove(e);
        }
        Oh(t.model.schema, e, n) && Nh(t, e, n, o);
      }
    }
    function Ph(t, e, n, o) {
      const i = e.parent,
        r = n.parent;
      if (i != o && r != o) {
        for (e = t.createPositionAfter(i), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(i, n); e.parent.isEmpty;) {
          const n = e.parent;
          e = t.createPositionBefore(n), t.remove(n);
        }
        n = t.createPositionBefore(r), function (t, e) {
          const n = e.nodeBefore,
            o = e.nodeAfter;
          n.name != o.name && t.rename(n, o.name);
          t.clearAttributes(n), t.setAttributes(Object.fromEntries(o.getAttributes()), n), t.merge(e);
        }(t, n), Oh(t.model.schema, e, n) && Ph(t, e, n, o);
      }
    }
    function Oh(t, e, n) {
      const o = e.parent,
        i = n.parent;
      return o != i && !t.isLimit(o) && !t.isLimit(i) && function (t, e, n) {
        const o = new ml(t, e);
        for (const t of o.getWalker()) if (n.isLimit(t.item)) return !1;
        return !0;
      }(e, n, t);
    }
    function Lh(t, e, n, o = {}) {
      const i = t.createElement("paragraph");
      t.model.schema.setAllowedAttributes(i, o, t), t.insert(i, e), zh(t, n, t.createPositionAt(i, 0));
    }
    function zh(t, e, n) {
      e instanceof Vl ? t.setSelection(n) : e.setTo(n);
    }
    function Rh(t, e) {
      const n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(t => e.createRangeOn(t)).filter(e => (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end))).forEach(t => {
        n.push(t.start.parent), e.remove(t);
      }), n.forEach(t => {
        let n = t;
        for (; n.parent && n.isEmpty;) {
          const t = e.createRangeOn(n);
          n = n.parent, e.remove(t);
        }
      });
    }
    class jh {
      constructor(t, e, n) {
        this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null, this._nodeToSelect = null, this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._documentFragment = e.createDocumentFragment(), this._documentFragmentPosition = e.createPositionAt(this._documentFragment, 0);
      }
      handleNodes(t) {
        for (const e of Array.from(t)) this._handleNode(e);
        this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
      }
      _updateLastNodeFromAutoParagraph(t) {
        const e = this.writer.createPositionAfter(this._lastNode),
          n = this.writer.createPositionAfter(t);
        if (n.isAfter(e)) {
          if (this._lastNode = t, this.position.parent != t || !this.position.isAtEnd) throw new w("insertcontent-invalid-insertion-position", this);
          this.position = n, this._setAffectedBoundaries(this.position);
        }
      }
      getSelectionRange() {
        return this._nodeToSelect ? ml._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
      }
      getAffectedRange() {
        return this._affectedStart ? new ml(this._affectedStart, this._affectedEnd) : null;
      }
      destroy() {
        this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
      }
      _handleNode(t) {
        if (this.schema.isObject(t)) return void this._handleObject(t);
        let e = this._checkAndAutoParagraphToAllowedPosition(t);
        e || (e = this._checkAndSplitToAllowedPosition(t), e) ? (this._appendToFragment(t), this._firstNode || (this._firstNode = t), this._lastNode = t) : this._handleDisallowedNode(t);
      }
      _insertPartialFragment() {
        if (this._documentFragment.isEmpty) return;
        const t = ju.fromPosition(this.position, "toNext");
        this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = t.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = t.toPosition(), t.detach();
      }
      _handleObject(t) {
        this._checkAndSplitToAllowedPosition(t) ? this._appendToFragment(t) : this._tryAutoparagraphing(t);
      }
      _handleDisallowedNode(t) {
        t.is("element") ? this.handleNodes(t.getChildren()) : this._tryAutoparagraphing(t);
      }
      _appendToFragment(t) {
        if (!this.schema.checkChild(this.position, t)) throw new w("insertcontent-wrong-position", this, {
          node: t,
          position: this.position
        });
        this.writer.insert(t, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = t : this._nodeToSelect = null, this._filterAttributesOf.push(t);
      }
      _setAffectedBoundaries(t) {
        this._affectedStart || (this._affectedStart = ju.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = ju.fromPosition(t, "toNext"));
      }
      _mergeOnLeft() {
        const t = this._firstNode;
        if (!(t instanceof rl)) return;
        if (!this._canMergeLeft(t)) return;
        const e = ju._createBefore(t);
        e.stickiness = "toNext";
        const n = ju.fromPosition(this.position, "toNext");
        this._affectedStart.isEqual(e) && (this._affectedStart.detach(), this._affectedStart = ju._createAt(e.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = ju._createAt(e.nodeBefore, "end", "toNext")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
      }
      _mergeOnRight() {
        const t = this._lastNode;
        if (!(t instanceof rl)) return;
        if (!this._canMergeRight(t)) return;
        const e = ju._createAfter(t);
        if (e.stickiness = "toNext", !this.position.isEqual(e)) throw new w("insertcontent-invalid-insertion-position", this);
        this.position = cl._createAt(e.nodeBefore, "end");
        const n = ju.fromPosition(this.position, "toPrevious");
        this._affectedEnd.isEqual(e) && (this._affectedEnd.detach(), this._affectedEnd = ju._createAt(e.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = ju._createAt(e.nodeBefore, 0, "toPrevious")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
      }
      _canMergeLeft(t) {
        const e = t.previousSibling;
        return e instanceof rl && this.canMergeWith.has(e) && this.model.schema.checkMerge(e, t);
      }
      _canMergeRight(t) {
        const e = t.nextSibling;
        return e instanceof rl && this.canMergeWith.has(e) && this.model.schema.checkMerge(t, e);
      }
      _tryAutoparagraphing(t) {
        const e = this.writer.createElement("paragraph");
        this._getAllowedIn(this.position.parent, e) && this.schema.checkChild(e, t) && (e._appendChild(t), this._handleNode(e));
      }
      _checkAndAutoParagraphToAllowedPosition(t) {
        if (this.schema.checkChild(this.position.parent, t)) return !0;
        if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t)) return !1;
        this._insertPartialFragment();
        const e = this.writer.createElement("paragraph");
        return this.writer.insert(e, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = e, this.position = this.writer.createPositionAt(e, 0), !0;
      }
      _checkAndSplitToAllowedPosition(t) {
        const e = this._getAllowedIn(this.position.parent, t);
        if (!e) return !1;
        for (e != this.position.parent && this._insertPartialFragment(); e != this.position.parent;) if (this.position.isAtStart) {
          const t = this.position.parent;
          this.position = this.writer.createPositionBefore(t), t.isEmpty && t.parent === e && this.writer.remove(t);
        } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
          const t = this.writer.createPositionAfter(this.position.parent);
          this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = t, this.canMergeWith.add(this.position.nodeAfter);
        }
        return !0;
      }
      _getAllowedIn(t, e) {
        return this.schema.checkChild(t, e) ? t : this.schema.isLimit(t) ? null : this._getAllowedIn(t.parent, e);
      }
    }
    function Fh(t, e, n, o = {}) {
      if (!t.schema.isObject(e)) throw new w("insertobject-element-not-an-object", t, {
        object: e
      });
      const i = n || t.document.selection;
      let r = i;
      o.findOptimalPosition && t.schema.isBlock(e) && (r = t.createSelection(t.schema.findOptimalInsertionRange(i, o.findOptimalPosition)));
      const s = Wi(i.getSelectedBlocks()),
        a = {};
      return s && Object.assign(a, t.schema.getAttributesWithProperty(s, "copyOnReplace", !0)), t.change(n => {
        r.isCollapsed || t.deleteContent(r, {
          doNotAutoparagraph: !0
        });
        let i = e;
        const s = r.anchor.parent;
        !t.schema.checkChild(s, e) && t.schema.checkChild(s, "paragraph") && t.schema.checkChild("paragraph", e) && (i = n.createElement("paragraph"), n.insert(e, i)), t.schema.setAllowedAttributes(i, a, n);
        const c = t.insertContent(i, r);
        return c.isCollapsed || o.setSelection && function (t, e, n, o) {
          const i = t.model;
          if ("on" == n) return void t.setSelection(e, "on");
          if ("after" != n) throw new w("insertobject-invalid-place-parameter-value", i);
          let r = e.nextSibling;
          if (i.schema.isInline(e)) return void t.setSelection(e, "after");
          const s = r && i.schema.checkChild(r, "$text");
          !s && i.schema.checkChild(e.parent, "paragraph") && (r = t.createElement("paragraph"), i.schema.setAllowedAttributes(r, o, t), i.insertContent(r, t.createPositionAfter(e)));
          r && t.setSelection(r, 0);
        }(n, e, o.setSelection, a), c;
      });
    }
    const Vh = ' ,.?!:;"-()';
    function Hh(t, e) {
      const {
          isForward: n,
          walker: o,
          unit: i,
          schema: r,
          treatEmojiAsSingleUnit: s
        } = t,
        {
          type: a,
          item: c,
          nextPosition: l
        } = e;
      if ("text" == a) return "word" === t.unit ? function (t, e) {
        let n = t.position.textNode;
        n || (n = e ? t.position.nodeAfter : t.position.nodeBefore);
        for (; n && n.is("$text");) {
          const o = t.position.offset - n.startOffset;
          if (Gh(n, o, e)) n = e ? t.position.nodeAfter : t.position.nodeBefore;else {
            if (qh(n.data, o, e)) break;
            t.next();
          }
        }
        return t.position;
      }(o, n) : function (t, e, n) {
        const o = t.position.textNode;
        if (o) {
          const i = o.data;
          let r = t.position.offset - o.startOffset;
          for (; Zi(i, r) || "character" == e && Ji(i, r) || n && tr(i, r);) t.next(), r = t.position.offset - o.startOffset;
        }
        return t.position;
      }(o, i, s);
      if (a == (n ? "elementStart" : "elementEnd")) {
        if (r.isSelectable(c)) return cl._createAt(c, n ? "after" : "before");
        if (r.checkChild(l, "$text")) return l;
      } else {
        if (r.isLimit(c)) return void o.skip(() => !0);
        if (r.checkChild(l, "$text")) return l;
      }
    }
    function Uh(t, e) {
      const n = t.root,
        o = cl._createAt(n, e ? "end" : 0);
      return e ? new ml(t, o) : new ml(o, t);
    }
    function qh(t, e, n) {
      const o = e + (n ? 0 : -1);
      return Vh.includes(t.charAt(o));
    }
    function Gh(t, e, n) {
      return e === (n ? t.offsetSize : 0);
    }
    class Wh extends G() {
      constructor() {
        super(), this.markers = new Ch(), this.document = new gh(this), this.schema = new Bd(), this._pendingChanges = [], this._currentWriter = null, ["deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(t => this.decorate(t)), this.on("applyOperation", (t, e) => {
          e[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$container", {
          allowIn: ["$root", "$container"]
        }), this.schema.register("$block", {
          allowIn: ["$root", "$container"],
          isBlock: !0
        }), this.schema.register("$blockObject", {
          allowWhere: "$block",
          isBlock: !0,
          isObject: !0
        }), this.schema.register("$inlineObject", {
          allowWhere: "$text",
          allowAttributesOf: "$text",
          isInline: !0,
          isObject: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0,
          isContent: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$documentFragment", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$marker"), this.schema.addChildCheck((t, e) => {
          if ("$marker" === e.name) return !0;
        }), yd(this), this.document.registerPostFixer(ad), this.on("insertContent", (t, [e, n]) => {
          t.return = function (t, e, n) {
            return t.change(o => {
              const i = n || t.document.selection;
              i.isCollapsed || t.deleteContent(i, {
                doNotAutoparagraph: !0
              });
              const r = new jh(t, o, i.anchor),
                s = [];
              let a;
              if (e.is("documentFragment")) {
                if (e.markers.size) {
                  const t = [];
                  for (const [n, o] of e.markers) {
                    const {
                        start: e,
                        end: i
                      } = o,
                      r = e.isEqual(i);
                    t.push({
                      position: e,
                      name: n,
                      isCollapsed: r
                    }, {
                      position: i,
                      name: n,
                      isCollapsed: r
                    });
                  }
                  t.sort(({
                    position: t
                  }, {
                    position: e
                  }) => t.isBefore(e) ? 1 : -1);
                  for (const {
                    position: n,
                    name: i,
                    isCollapsed: r
                  } of t) {
                    let t = null,
                      a = null;
                    const c = n.parent === e && n.isAtStart,
                      l = n.parent === e && n.isAtEnd;
                    c || l ? r && (a = c ? "start" : "end") : (t = o.createElement("$marker"), o.insert(t, n)), s.push({
                      name: i,
                      element: t,
                      collapsed: a
                    });
                  }
                }
                a = e.getChildren();
              } else a = [e];
              r.handleNodes(a);
              let c = r.getSelectionRange();
              if (e.is("documentFragment") && s.length) {
                const t = c ? zl.fromRange(c) : null,
                  e = {};
                for (let t = s.length - 1; t >= 0; t--) {
                  const {
                      name: n,
                      element: i,
                      collapsed: a
                    } = s[t],
                    c = !e[n];
                  if (c && (e[n] = []), i) {
                    const t = o.createPositionAt(i, "before");
                    e[n].push(t), o.remove(i);
                  } else {
                    const t = r.getAffectedRange();
                    if (!t) {
                      a && e[n].push(r.position);
                      continue;
                    }
                    a ? e[n].push(t[a]) : e[n].push(c ? t.start : t.end);
                  }
                }
                for (const [t, [n, i]] of Object.entries(e)) n && i && n.root === i.root && n.root.document && !o.model.markers.has(t) && o.addMarker(t, {
                  usingOperation: !0,
                  affectsData: !0,
                  range: new ml(n, i)
                });
                t && (c = t.toRange(), t.detach());
              }
              c && (i instanceof Vl ? o.setSelection(c) : i.setTo(c));
              const l = r.getAffectedRange() || t.createRange(i.anchor);
              return r.destroy(), l;
            });
          }(this, e, n);
        }), this.on("insertObject", (t, [e, n, o]) => {
          t.return = Fh(this, e, n, o);
        }), this.on("canEditAt", t => {
          const e = !this.document.isReadOnly;
          t.return = e, e || t.stop();
        });
      }
      change(t) {
        try {
          return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
            batch: new Hu(),
            callback: t
          }), this._runPendingChanges()[0]) : t(this._currentWriter);
        } catch (t) {
          w.rethrowUnexpectedError(t, this);
        }
      }
      enqueueChange(t, e) {
        try {
          t ? "function" == typeof t ? (e = t, t = new Hu()) : t instanceof Hu || (t = new Hu(t)) : t = new Hu(), this._pendingChanges.push({
            batch: t,
            callback: e
          }), 1 == this._pendingChanges.length && this._runPendingChanges();
        } catch (t) {
          w.rethrowUnexpectedError(t, this);
        }
      }
      applyOperation(t) {
        t._execute();
      }
      insertContent(t, e, n, ...o) {
        const i = Kh(e, n);
        return this.fire("insertContent", [t, i, n, ...o]);
      }
      insertObject(t, e, n, o, ...i) {
        const r = Kh(e, n);
        return this.fire("insertObject", [t, r, o, o, ...i]);
      }
      deleteContent(t, e) {
        Bh(this, t, e);
      }
      modifySelection(t, e) {
        !function (t, e, n = {}) {
          const o = t.schema,
            i = "backward" != n.direction,
            r = n.unit ? n.unit : "character",
            s = !!n.treatEmojiAsSingleUnit,
            a = e.focus,
            c = new sl({
              boundaries: Uh(a, i),
              singleCharacters: !0,
              direction: i ? "forward" : "backward"
            }),
            l = {
              walker: c,
              schema: o,
              isForward: i,
              unit: r,
              treatEmojiAsSingleUnit: s
            };
          let d;
          for (; d = c.next();) {
            if (d.done) return;
            const n = Hh(l, d.value);
            if (n) return void (e instanceof Vl ? t.change(t => {
              t.setSelectionFocus(n);
            }) : e.setFocus(n));
          }
        }(this, t, e);
      }
      getSelectedContent(t) {
        return function (t, e) {
          return t.change(t => {
            const n = t.createDocumentFragment(),
              o = e.getFirstRange();
            if (!o || o.isCollapsed) return n;
            const i = o.start.root,
              r = o.start.getCommonPath(o.end),
              s = i.getNodeByPath(r);
            let a;
            a = o.start.parent == o.end.parent ? o : t.createRange(t.createPositionAt(s, o.start.path[r.length]), t.createPositionAt(s, o.end.path[r.length] + 1));
            const c = a.end.offset - a.start.offset;
            for (const e of a.getItems({
              shallow: !0
            })) e.is("$textProxy") ? t.appendText(e.data, e.getAttributes(), n) : t.append(t.cloneElement(e, !0), n);
            if (a != o) {
              const e = o._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0],
                i = t.createRange(t.createPositionAt(n, 0), e.start);
              Rh(t.createRange(e.end, t.createPositionAt(n, "end")), t), Rh(i, t);
            }
            return n;
          });
        }(this, t);
      }
      hasContent(t, e = {}) {
        const n = t instanceof ml ? t : ml._createIn(t);
        if (n.isCollapsed) return !1;
        const {
          ignoreWhitespaces: o = !1,
          ignoreMarkers: i = !1
        } = e;
        if (!i) for (const t of this.markers.getMarkersIntersectingRange(n)) if (t.affectsData) return !0;
        for (const t of n.getItems()) if (this.schema.isContent(t)) {
          if (!t.is("$textProxy")) return !0;
          if (!o) return !0;
          if (-1 !== t.data.search(/\S/)) return !0;
        }
        return !1;
      }
      canEditAt(t) {
        const e = Kh(t);
        return this.fire("canEditAt", [e]);
      }
      createPositionFromPath(t, e, n) {
        return new cl(t, e, n);
      }
      createPositionAt(t, e) {
        return cl._createAt(t, e);
      }
      createPositionAfter(t) {
        return cl._createAfter(t);
      }
      createPositionBefore(t) {
        return cl._createBefore(t);
      }
      createRange(t, e) {
        return new ml(t, e);
      }
      createRangeIn(t) {
        return ml._createIn(t);
      }
      createRangeOn(t) {
        return ml._createOn(t);
      }
      createSelection(...t) {
        return new Ml(...t);
      }
      createBatch(t) {
        return new Hu(t);
      }
      createOperationFromJSON(t) {
        return Du.fromJSON(t, this.document);
      }
      destroy() {
        this.document.destroy(), this.stopListening();
      }
      _runPendingChanges() {
        const t = [];
        this.fire("_beforeChanges");
        try {
          for (; this._pendingChanges.length;) {
            const e = this._pendingChanges[0].batch;
            this._currentWriter = new Eh(this, e);
            const n = this._pendingChanges[0].callback(this._currentWriter);
            t.push(n), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }
        } finally {
          this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
        }
        return t;
      }
    }
    function Kh(t, e) {
      if (t) return t instanceof Ml || t instanceof Vl ? t : t instanceof el ? e || 0 === e ? new Ml(t, e) : t.is("rootElement") ? new Ml(t, "in") : new Ml(t, "on") : new Ml(t);
    }
    class $h extends rc {
      constructor() {
        super(...arguments), this.domEventType = "click";
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
    }
    class Yh extends rc {
      constructor() {
        super(...arguments), this.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
    }
    class Qh {
      constructor(t) {
        this.document = t;
      }
      createDocumentFragment(t) {
        return new ka(this.document, t);
      }
      createElement(t, e, n) {
        return new Fs(this.document, t, e, n);
      }
      createText(t) {
        return new is(this.document, t);
      }
      clone(t, e = !1) {
        return t._clone(e);
      }
      appendChild(t, e) {
        return e._appendChild(t);
      }
      insertChild(t, e, n) {
        return n._insertChild(t, e);
      }
      removeChildren(t, e, n) {
        return n._removeChildren(t, e);
      }
      remove(t) {
        const e = t.parent;
        return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
      }
      replace(t, e) {
        const n = t.parent;
        if (n) {
          const o = n.getChildIndex(t);
          return this.removeChildren(o, 1, n), this.insertChild(o, e, n), !0;
        }
        return !1;
      }
      unwrapElement(t) {
        const e = t.parent;
        if (e) {
          const n = e.getChildIndex(t);
          this.remove(t), this.insertChild(n, t.getChildren(), e);
        }
      }
      rename(t, e) {
        const n = new Fs(this.document, t, e.getAttributes(), e.getChildren());
        return this.replace(e, n) ? n : null;
      }
      setAttribute(t, e, n) {
        n._setAttribute(t, e);
      }
      removeAttribute(t, e) {
        e._removeAttribute(t);
      }
      addClass(t, e) {
        e._addClass(t);
      }
      removeClass(t, e) {
        e._removeClass(t);
      }
      setStyle(t, e, n) {
        xt(t) && void 0 === n ? e._setStyle(t) : n._setStyle(t, e);
      }
      removeStyle(t, e) {
        e._removeStyle(t);
      }
      setCustomProperty(t, e, n) {
        n._setCustomProperty(t, e);
      }
      removeCustomProperty(t, e) {
        return e._removeCustomProperty(t);
      }
      createPositionAt(t, e) {
        return $s._createAt(t, e);
      }
      createPositionAfter(t) {
        return $s._createAfter(t);
      }
      createPositionBefore(t) {
        return $s._createBefore(t);
      }
      createRange(t, e) {
        return new Ys(t, e);
      }
      createRangeOn(t) {
        return Ys._createOn(t);
      }
      createRangeIn(t) {
        return Ys._createIn(t);
      }
      createSelection(...t) {
        return new Zs(...t);
      }
    }
    class Zh {
      constructor() {
        this._commands = new Map();
      }
      add(t, e) {
        this._commands.set(t, e);
      }
      get(t) {
        return this._commands.get(t);
      }
      execute(t, ...e) {
        const n = this.get(t);
        if (!n) throw new w("commandcollection-command-not-found", this, {
          commandName: t
        });
        return n.execute(...e);
      }
      *names() {
        yield* this._commands.keys();
      }
      *commands() {
        yield* this._commands.values();
      }
      [Symbol.iterator]() {
        return this._commands[Symbol.iterator]();
      }
      destroy() {
        for (const t of this.commands()) t.destroy();
      }
    }
    var Jh = Object.defineProperty,
      Xh = Object.getOwnPropertySymbols,
      tg = Object.prototype.hasOwnProperty,
      eg = Object.prototype.propertyIsEnumerable,
      ng = (t, e, n) => e in t ? Jh(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    const og = "contentEditing",
      ig = "common";
    class rg {
      constructor(t) {
        this.keystrokeInfos = new Map(), this._editor = t;
        const e = t.config.get("menuBar.isVisible"),
          n = t.locale.t;
        this.addKeystrokeInfoCategory({
          id: og,
          label: n("Content editing keystrokes"),
          description: n("These keyboard shortcuts allow for quick access to content editing features.")
        });
        const o = [{
          label: n("Close contextual balloons, dropdowns, and dialogs"),
          keystroke: "Esc"
        }, {
          label: n("Open the accessibility help dialog"),
          keystroke: "Alt+0"
        }, {
          label: n("Move focus between form fields (inputs, buttons, etc.)"),
          keystroke: [["Tab"], ["Shift+Tab"]]
        }, {
          label: n("Move focus to the toolbar, navigate between toolbars"),
          keystroke: "Alt+F10",
          mayRequireFn: !0
        }, {
          label: n("Navigate through the toolbar or menu bar"),
          keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
        }, {
          label: n("Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content."),
          keystroke: [["Enter"], ["Space"]]
        }];
        e && o.push({
          label: n("Move focus to the menu bar, navigate between menu bars"),
          keystroke: "Alt+F9",
          mayRequireFn: !0
        }), this.addKeystrokeInfoCategory({
          id: "navigation",
          label: n("User interface and content navigation keystrokes"),
          description: n("Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface."),
          groups: [{
            id: "common",
            keystrokes: o
          }]
        });
      }
      addKeystrokeInfoCategory({
        id: t,
        label: e,
        description: n,
        groups: o
      }) {
        this.keystrokeInfos.set(t, {
          id: t,
          label: e,
          description: n,
          groups: new Map()
        }), this.addKeystrokeInfoGroup({
          categoryId: t,
          id: ig
        }), o && o.forEach(e => {
          this.addKeystrokeInfoGroup(((t, e) => {
            for (var n in e || (e = {})) tg.call(e, n) && ng(t, n, e[n]);
            if (Xh) for (var n of Xh(e)) eg.call(e, n) && ng(t, n, e[n]);
            return t;
          })({
            categoryId: t
          }, e));
        });
      }
      addKeystrokeInfoGroup({
        categoryId: t = og,
        id: e,
        label: n,
        keystrokes: o
      }) {
        const i = this.keystrokeInfos.get(t);
        if (!i) throw new w("accessibility-unknown-keystroke-info-category", this._editor, {
          groupId: e,
          categoryId: t
        });
        i.groups.set(e, {
          id: e,
          label: n,
          keystrokes: o || []
        });
      }
      addKeystrokeInfos({
        categoryId: t = og,
        groupId: e = ig,
        keystrokes: n
      }) {
        if (!this.keystrokeInfos.has(t)) throw new w("accessibility-unknown-keystroke-info-category", this._editor, {
          categoryId: t,
          keystrokes: n
        });
        const o = this.keystrokeInfos.get(t);
        if (!o.groups.has(e)) throw new w("accessibility-unknown-keystroke-info-group", this._editor, {
          groupId: e,
          categoryId: t,
          keystrokes: n
        });
        o.groups.get(e).keystrokes.push(...n);
      }
    }
    var sg = Object.getOwnPropertySymbols,
      ag = Object.prototype.hasOwnProperty,
      cg = Object.prototype.propertyIsEnumerable,
      lg = (t, e) => {
        var n = {};
        for (var o in t) ag.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
        if (null != t && sg) for (var o of sg(t)) e.indexOf(o) < 0 && cg.call(t, o) && (n[o] = t[o]);
        return n;
      };
    class dg extends G() {
      constructor(t = {}) {
        super();
        const e = this.constructor,
          n = e.defaultConfig || {},
          {
            translations: o
          } = n,
          i = lg(n, ["translations"]),
          r = t,
          {
            translations: s = o
          } = r,
          a = lg(r, ["translations"]),
          c = t.language || i.language;
        this._context = t.context || new Vr({
          language: c,
          translations: s
        }), this._context._addEditor(this, !t.context);
        const l = Array.from(e.builtinPlugins || []);
        this.config = new yo(a, i), this.config.define("plugins", l), this.config.define(this._context._getEditorConfig()), this.plugins = new zr(this, l, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this._readOnlyLocks = new Set(), this.commands = new Zh(), this.set("state", "initializing"), this.once("ready", () => this.state = "ready", {
          priority: "high"
        }), this.once("destroy", () => this.state = "destroyed", {
          priority: "high"
        }), this.model = new Wh(), this.on("change:isReadOnly", () => {
          this.model.document.isReadOnly = this.isReadOnly;
        });
        const d = new zs();
        this.data = new ou(this.model, d), this.editing = new Id(this.model, d), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new iu([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new Ur(this), this.keystrokes.listenTo(this.editing.view.document), this.accessibility = new rg(this);
      }
      get isReadOnly() {
        return this._readOnlyLocks.size > 0;
      }
      set isReadOnly(t) {
        throw new w("editor-isreadonly-has-no-setter");
      }
      enableReadOnlyMode(t) {
        if ("string" != typeof t && "symbol" != typeof t) throw new w("editor-read-only-lock-id-invalid", null, {
          lockId: t
        });
        this._readOnlyLocks.has(t) || (this._readOnlyLocks.add(t), 1 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", !0, !1));
      }
      disableReadOnlyMode(t) {
        if ("string" != typeof t && "symbol" != typeof t) throw new w("editor-read-only-lock-id-invalid", null, {
          lockId: t
        });
        this._readOnlyLocks.has(t) && (this._readOnlyLocks.delete(t), 0 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", !1, !0));
      }
      setData(t) {
        this.data.set(t);
      }
      getData(t) {
        return this.data.get(t);
      }
      initPlugins() {
        const t = this.config,
          e = t.get("plugins"),
          n = t.get("removePlugins") || [],
          o = t.get("extraPlugins") || [],
          i = t.get("substitutePlugins") || [];
        return this.plugins.init(e.concat(o), n, i);
      }
      destroy() {
        let t = Promise.resolve();
        return "initializing" == this.state && (t = new Promise(t => this.once("ready", t))), t.then(() => {
          this.fire("destroy"), this.stopListening(), this.commands.destroy();
        }).then(() => this.plugins.destroy()).then(() => {
          this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
        }).then(() => this._context._removeEditor(this));
      }
      execute(t, ...e) {
        try {
          return this.commands.execute(t, ...e);
        } catch (t) {
          w.rethrowUnexpectedError(t, this);
        }
      }
      focus() {
        this.editing.view.focus();
      }
      static create(...t) {
        throw new Error("This is an abstract method.");
      }
    }
    function ug(t) {
      return class extends t {
        updateSourceElement(t) {
          if (!this.sourceElement) throw new w("editor-missing-sourceelement", this);
          const e = this.config.get("updateSourceElementOnDestroy"),
            n = this.sourceElement instanceof HTMLTextAreaElement;
          if (!e && !n) return void Go(this.sourceElement, "");
          const o = "string" == typeof t ? t : this.data.get();
          Go(this.sourceElement, o);
        }
      };
    }
    ug.updateSourceElement = ug(Object).prototype.updateSourceElement;
    class hg extends Hr {
      static get pluginName() {
        return "PendingActions";
      }
      init() {
        this.set("hasAny", !1), this._actions = new Gi({
          idProperty: "_id"
        }), this._actions.delegate("add", "remove").to(this);
      }
      add(t) {
        if ("string" != typeof t) throw new w("pendingactions-add-invalid-message", this);
        const e = new (G())();
        return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
      }
      remove(t) {
        this._actions.remove(t), this.hasAny = !!this._actions.length;
      }
      get first() {
        return this._actions.get(0);
      }
      [Symbol.iterator]() {
        return this._actions[Symbol.iterator]();
      }
    }
    const gg = {
      bold: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
      cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
      caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
      check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
      cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
      colorPalette: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.209 18.717A8.5 8.5 0 1 1 18.686 9.6h-.008l.002.12a3 3 0 0 1-2.866 2.997h-.268l-.046-.002v.002h-4.791a2 2 0 1 0 0 4 1 1 0 1 1-.128 1.992 8.665 8.665 0 0 1-.372.008Zm-3.918-7.01a1.25 1.25 0 1 0-2.415-.648 1.25 1.25 0 0 0 2.415.647ZM5.723 8.18a1.25 1.25 0 1 0 .647-2.414 1.25 1.25 0 0 0-.647 2.414ZM9.76 6.155a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Zm4.028 1.759a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Z"/></svg>',
      eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
      history: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1z"/><path d="M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052z"/><path d="M11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z"/></svg>',
      image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.66 9.118a.693.693 0 0 1 .956.032l3.65 3.411 2.422-2.238a.695.695 0 0 1 .945 0L17.5 13.6V2.5h-15v11.1l4.16-4.482ZM17.8 1c.652 0 1.2.47 1.2 1.1v14.362c0 .64-.532 1.038-1.184 1.038H2.184C1.532 17.5 1 17.103 1 16.462V2.1C1 1.47 1.537 1 2.2 1h15.6Zm-5.655 6a2.128 2.128 0 0 1 .157-2.364A2.133 2.133 0 1 1 12.145 7Z"/></svg>',
      imageUpload: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h9.494a2.97 2.97 0 0 1-.414-.287 2.998 2.998 0 0 1-1.055-2.03 3.003 3.003 0 0 1 .693-2.185l.383-.455-.02.018-3.65-3.41a.695.695 0 0 0-.957-.034L1.5 13.6V2.5h15v5.535a2.97 2.97 0 0 1 1.412.932l.088.105V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.713 2.803a2.146 2.146 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.644-3.11 2.134 2.134 0 0 0-1.875-.978Z"/><path d="M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.784.784 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79Z"/><path d="M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.784.784 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79Z"/></svg>',
      imageAssetManager: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1c-.662 0-1.2.47-1.2 1.1v14.248c0 .64.533 1.152 1.185 1.152h6.623v-7.236L6.617 9.15a.694.694 0 0 0-.957-.033L1.602 13.55V2.553l14.798.003V9.7H18V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.723 2.805a2.094 2.094 0 0 0-1.621.832 2.127 2.127 0 0 0 1.136 3.357 2.13 2.13 0 0 0 2.611-1.506 2.133 2.133 0 0 0-.76-2.244 2.13 2.13 0 0 0-1.366-.44Z"/><path clip-rule="evenodd" d="M19.898 12.369v6.187a.844.844 0 0 1-.844.844h-8.719a.844.844 0 0 1-.843-.844v-7.312a.844.844 0 0 1 .843-.844h2.531a.843.843 0 0 1 .597.248l.838.852h4.75c.223 0 .441.114.6.272a.844.844 0 0 1 .247.597Zm-1.52.654-4.377.02-1.1-1.143H11v6h7.4l-.023-4.877Z"/></svg>',
      imageUrl: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h7.029a5.401 5.401 0 0 1 .615-4.338l.762-1.232-2.975-2.78a.696.696 0 0 0-.957-.033L1.5 13.6V2.5h15v6.023c.449.131.887.32 1.307.573l.058.033c.046.028.09.057.135.086V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.713 2.803a2.15 2.15 0 0 0-1.611.834 2.118 2.118 0 0 0-.438 1.158 2.14 2.14 0 0 0 1.277 2.096 2.132 2.132 0 0 0 2.645-3.11 2.13 2.13 0 0 0-1.873-.978Z"/><path d="M16.63 10.294a3.003 3.003 0 0 0-4.142.887l-.117.177a.647.647 0 0 0-.096.492.664.664 0 0 0 .278.418.7.7 0 0 0 .944-.234 1.741 1.741 0 0 1 2.478-.463 1.869 1.869 0 0 1 .476 2.55.637.637 0 0 0-.071.5.646.646 0 0 0 .309.396.627.627 0 0 0 .869-.19l.027-.041a3.226 3.226 0 0 0-.956-4.492Zm-6.061 3.78-.044.066a3.228 3.228 0 0 0 .82 4.403 3.005 3.005 0 0 0 4.275-.798l.13-.197a.626.626 0 0 0 .092-.475.638.638 0 0 0-.268-.402.713.713 0 0 0-.99.26l-.018.029a1.741 1.741 0 0 1-2.477.461 1.87 1.87 0 0 1-.475-2.55l.029-.047a.647.647 0 0 0 .086-.485.66.66 0 0 0-.275-.408l-.04-.027a.609.609 0 0 0-.845.17Z"/><path d="M15.312 13.925c.24-.36.154-.838-.19-1.067-.346-.23-.82-.124-1.059.236l-1.268 1.907c-.239.36-.153.838.192 1.067.345.23.818.123 1.057-.236l1.268-1.907Z"/></svg>',
      lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
      textAlternative: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.035 1C2.446 1 2 1.54 2 2.098V10.5h1.5v-8h13v8H18V2.098C18 1.539 17.48 1 16.9 1H3.035Zm10.453 2.61a1.885 1.885 0 0 0-1.442.736 1.89 1.89 0 0 0 1.011 2.976 1.903 1.903 0 0 0 2.253-1.114 1.887 1.887 0 0 0-1.822-2.598ZM7.463 8.163a.611.611 0 0 0-.432.154L5.071 10.5h5.119L7.88 8.348a.628.628 0 0 0-.417-.185Zm6.236 1.059a.62.62 0 0 0-.42.164L12.07 10.5h2.969l-.92-1.113a.618.618 0 0 0-.42-.165ZM.91 11.5a.91.91 0 0 0-.91.912v6.877c0 .505.405.91.91.91h18.178a.91.91 0 0 0 .912-.91v-6.877a.908.908 0 0 0-.912-.912H.91ZM3.668 13h1.947l2.135 5.7H5.898l-.28-.946H3.601l-.278.945H1.516L3.668 13Zm4.947 0h1.801v4.3h2.7v1.4h-4.5V13h-.001Zm4.5 0h5.4v1.4h-1.798v4.3h-1.701v-4.3h-1.9V13h-.001Zm-8.517 1.457-.614 2.059h1.262l-.648-2.059Z"/></svg>',
      loupe: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.68 13.74h-.001l4.209 4.208a1 1 0 1 0 1.414-1.414l-4.267-4.268a6 6 0 1 0-1.355 1.474ZM13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"/></svg>',
      previousArrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>',
      nextArrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>',
      importExport: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></svg>',
      paragraph: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>',
      plus: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>',
      text: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></svg>',
      alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
      alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
      alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
      alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
      alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
      alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
      objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
      objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectSizeCustom: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:v="https://vecta.io/nano" viewBox="0 0 20 20"><path d="M.95 1.43a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h.75v6.3H.95a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-.65h1.932l1.539-1.5H5v-.95a.95.95 0 0 0-.95-.95H3.2v-6.3h.85A.95.95 0 0 0 5 5.48v-.55h10v.55a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-3.1a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95v1.05H5V2.38a.95.95 0 0 0-.95-.95H.95zm.55 3.5v-2h2v2h-2zm0 9.3v2h2v-2h-2zm15-11.3v2h2v-2h-2z"/><path d="M8.139 20.004v-2.388l7.045-7.048 2.391 2.391-7.046 7.046h-2.39zm11.421-9.101a.64.64 0 0 1-.138.206l-1.165 1.168-2.391-2.391 1.167-1.163a.63.63 0 0 1 .206-.138.635.635 0 0 1 .243-.049.63.63 0 0 1 .449.187l1.491 1.488c.059.059.108.129.138.206s.049.16.049.243a.6.6 0 0 1-.049.243z"/></svg>',
      objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
      objectSizeLarge: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M13 5.5H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM13 7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 2 7h11Z"/></svg>',
      objectSizeSmall: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M7 9.5H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2ZM7 11a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4A.5.5 0 0 1 2 11h5Z"/></svg>',
      objectSizeMedium: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M10 7.5H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2ZM10 9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 2 9h8Z"/></svg>',
      pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
      pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
      quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
      threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>',
      dragIndicator: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/></svg>',
      redo: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>',
      undo: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
      bulletedList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>',
      numberedList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
      todoList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m2.315 14.705 2.224-2.24a.689.689 0 0 1 .963 0 .664.664 0 0 1 0 .949L2.865 16.07a.682.682 0 0 1-.112.089.647.647 0 0 1-.852-.051L.688 14.886a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.717.722zm5.185.045a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75zM2.329 5.745l2.21-2.226a.689.689 0 0 1 .963 0 .664.664 0 0 1 0 .95L2.865 7.125a.685.685 0 0 1-.496.196.644.644 0 0 1-.468-.187L.688 5.912a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.73.736zM7.5 5.75A.75.75 0 0 1 8.25 5h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
      codeBlock: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174zm2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207zM16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14zM5.009 15l.003 1H3v-1h2.009zm2.188-2-1.471 1H5v-1h2.197zM10 11v.095L8.668 12H7v-1h3zm4-2v1H7V9h7zm0-2v1H7V7h7zm-4-2v1H5V5h5zM6 3v1H3V3h3z"/></svg>',
      browseFiles: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>',
      heading1: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 9v10h-2v-8h-2V9h4zM4 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11H4v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v4.5z"/></svg>',
      heading2: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm16.076 8.343V18.5h-6.252c.067-.626.27-1.22.61-1.78.338-.561 1.006-1.305 2.005-2.232.804-.749 1.297-1.257 1.479-1.523.245-.368.368-.732.368-1.092 0-.398-.107-.703-.32-.917-.214-.214-.51-.32-.886-.32-.372 0-.669.111-.889.336-.22.224-.347.596-.38 1.117l-1.778-.178c.106-.982.438-1.686.997-2.114.558-.427 1.257-.64 2.095-.64.918 0 1.64.247 2.164.742.525.495.787 1.11.787 1.847 0 .419-.075.818-.225 1.197-.15.378-.388.775-.714 1.19-.216.275-.605.67-1.168 1.187-.563.516-.92.859-1.07 1.028a3.11 3.11 0 0 0-.365.495h3.542z"/></svg>',
      heading3: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm9.989 7.53 1.726-.209c.055.44.203.777.445 1.01.24.232.533.349.876.349.368 0 .678-.14.93-.42.251-.279.377-.655.377-1.13 0-.448-.12-.803-.362-1.066a1.153 1.153 0 0 0-.882-.393c-.228 0-.501.044-.819.133l.197-1.453c.482.012.85-.092 1.105-.315.253-.222.38-.517.38-.885 0-.313-.093-.563-.279-.75-.186-.185-.434-.278-.743-.278a1.07 1.07 0 0 0-.78.317c-.216.212-.347.52-.394.927l-1.644-.28c.114-.562.287-1.012.517-1.348.231-.337.553-.601.965-.794a3.24 3.24 0 0 1 1.387-.289c.876 0 1.579.28 2.108.838.436.457.653.973.653 1.549 0 .817-.446 1.468-1.339 1.955.533.114.96.37 1.28.768.319.398.478.878.478 1.441 0 .817-.298 1.513-.895 2.088-.596.576-1.339.864-2.228.864-.842 0-1.54-.243-2.094-.727-.555-.485-.876-1.118-.965-1.901z"/></svg>',
      heading4: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm13.55 10v-1.873h-3.81v-1.561l4.037-5.91h1.498v5.904h1.156v1.567h-1.156V18.5H17.05zm0-3.44v-3.18l-2.14 3.18h2.14z"/></svg>',
      heading5: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm9.578 7.607 1.777-.184c.05.402.201.72.45.955a1.223 1.223 0 0 0 1.81-.101c.258-.303.387-.759.387-1.368 0-.572-.128-1-.384-1.286-.256-.285-.59-.428-1-.428-.512 0-.971.226-1.377.679l-1.448-.21.915-4.843h4.716v1.67H15.56l-.28 1.58a2.697 2.697 0 0 1 1.219-.298 2.68 2.68 0 0 1 2.012.863c.55.576.825 1.323.825 2.241a3.36 3.36 0 0 1-.666 2.05c-.605.821-1.445 1.232-2.52 1.232-.86 0-1.56-.23-2.101-.692-.542-.461-.866-1.081-.971-1.86z"/></svg>',
      heading6: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm15.595 2.973-1.726.19c-.043-.355-.153-.617-.33-.787-.178-.169-.409-.253-.692-.253-.377 0-.695.169-.956.507-.26.339-.424 1.043-.492 2.114.445-.525.997-.787 1.657-.787.745 0 1.383.284 1.914.85.531.568.797 1.3.797 2.197 0 .952-.28 1.716-.838 2.291-.559.576-1.276.864-2.152.864-.94 0-1.712-.365-2.317-1.095-.605-.73-.908-1.927-.908-3.59 0-1.705.316-2.935.946-3.688.63-.753 1.45-1.13 2.457-1.13.706 0 1.291.198 1.755.594.463.395.758.97.885 1.723zm-4.043 3.891c0 .58.133 1.028.4 1.343.266.315.57.473.914.473.33 0 .605-.13.825-.388.22-.258.33-.68.33-1.27 0-.604-.118-1.047-.355-1.329a1.115 1.115 0 0 0-.89-.422c-.342 0-.632.134-.869.403s-.355.666-.355 1.19z"/></svg>',
      horizontalLine: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 9h16v2H2z"/></svg>',
      html: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17 0a2 2 0 0 1 2 2v7a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993l-.118.006L19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-1.001-.116-.006A1 1 0 0 1 0 15v-5a1 1 0 0 1 .999-1L1 2a2 2 0 0 1 2-2h14zm.499 15.999h-15L2.5 17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5l-.001-1.001zm-3.478-6.013-.014.014H14v.007l-1.525 1.525-1.46-1.46-.015.013V10h-1v5h1v-3.53l1.428 1.43.048.043.131-.129L14 11.421V15h1v-5h-.965l-.014-.014zM2 10H1v5h1v-2h2v2h1v-5H4v2H2v-2zm7 0H6v1h1v4h1v-4h1v-1zm8 0h-1v5h3v-1h-2v-4zm0-8.5H3a.5.5 0 0 0-.5.5l-.001 6.999h15L17.5 2a.5.5 0 0 0-.5-.5zM10 7v1H4V7h6zm3-2v1H4V5h9zm-3-2v1H4V3h6z"/></svg>',
      indent: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
      outdent: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>',
      table: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 5.5v3h4v-3H3Zm0 4v3h4v-3H3Zm0 4v3h4v-3H3Zm5 3h4v-3H8v3Zm5 0h4v-3h-4v3Zm4-4v-3h-4v3h4Zm0-4v-3h-4v3h4Zm1.5 8A1.5 1.5 0 0 1 17 18H3a1.5 1.5 0 0 1-1.5-1.5V3c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13.5Zm-6.5-4v-3H8v3h4Zm0-4v-3H8v3h4Z"/></svg>'
    };
    var mg = n(7801),
      pg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(mg.A, pg);
    mg.A.locals;
    class fg extends Dr {
      constructor(t) {
        super(t), this.set("text", void 0), this.set("for", void 0), this.id = `ck-editor__label_${p()}`;
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            id: this.id,
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });
      }
    }
    class kg extends Dr {
      constructor(t, e) {
        super(t);
        const n = t.t,
          o = new fg();
        o.text = n("Help Contents. To close this dialog press ESC."), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-accessibility-help-dialog__content"],
            "aria-labelledby": o.id,
            role: "document",
            tabindex: -1
          },
          children: [kt(document, "p", {}, n("Below, you can find a list of keyboard shortcuts that can be used in the editor.")), ...this._createCategories(Array.from(e.values())), o]
        });
      }
      focus() {
        this.element.focus();
      }
      _createCategories(t) {
        return t.map(t => {
          const e = [kt(document, "h3", {}, t.label), ...Array.from(t.groups.values()).map(t => this._createGroup(t)).flat()];
          return t.description && e.splice(1, 0, kt(document, "p", {}, t.description)), kt(document, "section", {}, e);
        });
      }
      _createGroup(t) {
        const e = t.keystrokes.sort((t, e) => t.label.localeCompare(e.label)).map(t => this._createGroupRow(t)).flat(),
          n = [kt(document, "dl", {}, e)];
        return t.label && n.unshift(kt(document, "h4", {}, t.label)), n;
      }
      _createGroupRow(t) {
        const e = this.locale.t,
          n = kt(document, "dt"),
          o = kt(document, "dd"),
          i = function (t) {
            if ("string" == typeof t) return [[t]];
            if ("string" == typeof t[0]) return [t];
            return t;
          }(t.keystroke),
          r = [];
        for (const t of i) r.push(t.map(bg).join(""));
        return n.innerHTML = t.label, o.innerHTML = r.join(", ") + (t.mayRequireFn && s.isMac ? ` ${e("(may require <kbd>Fn</kbd>)")}` : ""), [n, o];
      }
    }
    function bg(t) {
      return bi(t).split("+").map(t => `<kbd>${t}</kbd>`).join("+");
    }
    const wg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 6.628a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/><path d="M8.5 9.125a.3.3 0 0 0-.253-.296L5.11 8.327a.75.75 0 1 1 .388-1.449l4.04.716c.267.072.624.08.893.009l4.066-.724a.75.75 0 1 1 .388 1.45l-3.132.5a.3.3 0 0 0-.253.296v1.357a.3.3 0 0 0 .018.102l1.615 4.438a.75.75 0 0 1-1.41.513l-1.35-3.71a.3.3 0 0 0-.281-.197h-.209a.3.3 0 0 0-.282.198l-1.35 3.711a.75.75 0 0 1-1.41-.513l1.64-4.509a.3.3 0 0 0 .019-.103V9.125Z"/><path clip-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17Zm0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z"/></svg>';
    var Ag = n(8527),
      _g = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ag.A, _g);
    Ag.A.locals;
    class Cg extends Br {
      constructor() {
        super(...arguments), this.contentView = null;
      }
      static get requires() {
        return [Cp];
      }
      static get pluginName() {
        return "AccessibilityHelp";
      }
      init() {
        const t = this.editor,
          e = t.locale.t;
        t.ui.componentFactory.add("accessibilityHelp", () => {
          const t = this._createButton(Sg);
          return t.set({
            tooltip: !0,
            withText: !1,
            label: e("Accessibility help")
          }), t;
        }), t.ui.componentFactory.add("menuBar:accessibilityHelp", () => {
          const t = this._createButton(Yk);
          return t.label = e("Accessibility"), t;
        }), t.keystrokes.set("Alt+0", (t, e) => {
          this._showDialog(), e();
        }), this._setupRootLabels();
      }
      _createButton(t) {
        const e = new t(this.editor.locale);
        return e.set({
          keystroke: "Alt+0",
          icon: wg
        }), e.on("execute", () => this._showDialog()), e;
      }
      _setupRootLabels() {
        const t = this.editor,
          e = t.editing.view,
          n = t.t;
        function o(t, e) {
          const o = `${e.getAttribute("aria-label")}. ${n("Press %0 for help.", [bi("Alt+0")])}`;
          t.setAttribute("aria-label", o, e);
        }
        t.ui.on("ready", () => {
          e.change(t => {
            for (const n of e.document.roots) o(t, n);
          }), t.on("addRoot", (n, i) => {
            const r = t.editing.view.document.getRoot(i.rootName);
            e.change(t => o(t, r));
          }, {
            priority: "low"
          });
        });
      }
      _showDialog() {
        const t = this.editor,
          e = t.plugins.get("Dialog"),
          n = t.locale.t;
        this.contentView || (this.contentView = new kg(t.locale, t.accessibility.keystrokeInfos)), e.show({
          id: "accessibilityHelp",
          className: "ck-accessibility-help-dialog",
          title: n("Accessibility help"),
          icon: wg,
          hasCloseButton: !0,
          content: this.contentView
        });
      }
    }
    class vg extends er {
      constructor(t, e = []) {
        super(e), this.locale = t;
      }
      get bodyCollectionContainer() {
        return this._bodyCollectionContainer;
      }
      attachToDom() {
        this._bodyCollectionContainer = new nr({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
            dir: this.locale.uiLanguageDirection
          },
          children: this
        }).render();
        let t = document.querySelector(".ck-body-wrapper");
        t || (t = kt(document, "div", {
          class: "ck-body-wrapper"
        }), document.body.appendChild(t)), t.appendChild(this._bodyCollectionContainer);
      }
      detachFromDom() {
        super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
        const t = document.querySelector(".ck-body-wrapper");
        t && 0 == t.childElementCount && t.remove();
      }
    }
    var yg = n(7621),
      xg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(yg.A, xg);
    yg.A.locals;
    const Eg = class extends Dr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.set("isColorInherited", !0), this.set("isVisible", !0), this.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon", t.if("isVisible", "ck-hidden", t => !t), "ck-reset_all-excluded", t.if("isColorInherited", "ck-icon_inherit-color")],
            viewBox: t.to("viewBox")
          }
        });
      }
      render() {
        super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
          this._updateXMLContent(), this._colorFillPaths();
        }), this.on("change:fillColor", () => {
          this._colorFillPaths();
        });
      }
      _updateXMLContent() {
        if (this.content) {
          const t = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
            e = t.getAttribute("viewBox");
          e && (this.viewBox = e);
          for (const {
            name: e,
            value: n
          } of Array.from(t.attributes)) Eg.presentationalAttributeNames.includes(e) && this.element.setAttribute(e, n);
          for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
          for (; t.childNodes.length > 0;) this.element.appendChild(t.childNodes[0]);
        }
      }
      _colorFillPaths() {
        this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(t => {
          t.style.fill = this.fillColor;
        });
      }
    };
    let Dg = Eg;
    Dg.presentationalAttributeNames = ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"];
    class Ig extends Dr {
      constructor() {
        super(), this.set({
          style: void 0,
          text: void 0,
          id: void 0
        });
        const t = this.bindTemplate;
        this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__label"],
            style: t.to("style"),
            id: t.to("id")
          },
          children: [{
            text: t.to("text")
          }]
        });
      }
    }
    var Tg = n(9715),
      Mg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Tg.A, Mg);
    Tg.A.locals;
    class Sg extends Dr {
      constructor(t, e = new Ig()) {
        super(t), this._focusDelayed = null;
        const n = this.bindTemplate,
          o = p();
        this.set("ariaLabel", void 0), this.set("ariaLabelledBy", `ck-editor__aria-label_${o}`), this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isVisible", !0), this.set("isToggleable", !1), this.set("keystroke", void 0), this.set("label", void 0), this.set("role", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.set("withKeystroke", !1), this.children = this.createCollection(), this.labelView = this._setupLabelView(e), this.iconView = new Dg(), this.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), this.keystrokeView = this._createKeystrokeView(), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
        const i = {
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", n.to("class"), n.if("isEnabled", "ck-disabled", t => !t), n.if("isVisible", "ck-hidden", t => !t), n.to("isOn", t => t ? "ck-on" : "ck-off"), n.if("withText", "ck-button_with-text"), n.if("withKeystroke", "ck-button_with-keystroke")],
            role: n.to("role"),
            type: n.to("type", t => t || "button"),
            tabindex: n.to("tabindex"),
            "aria-checked": n.to("ariaChecked"),
            "aria-label": n.to("ariaLabel"),
            "aria-labelledby": n.to("ariaLabelledBy"),
            "aria-disabled": n.if("isEnabled", !0, t => !t),
            "aria-pressed": n.to("isOn", t => !!this.isToggleable && String(!!t)),
            "data-cke-tooltip-text": n.to("_tooltipString"),
            "data-cke-tooltip-position": n.to("tooltipPosition")
          },
          children: this.children,
          on: {
            click: n.to(t => {
              this.isEnabled ? this.fire("execute") : t.preventDefault();
            })
          }
        };
        s.isSafari && (this._focusDelayed || (this._focusDelayed = Qi(() => this.focus(), 0)), i.on.mousedown = n.to(() => {
          this._focusDelayed();
        }), i.on.mouseup = n.to(() => {
          this._focusDelayed.cancel();
        })), this.setTemplate(i);
      }
      render() {
        super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
      }
      focus() {
        this.element.focus();
      }
      destroy() {
        this._focusDelayed && this._focusDelayed.cancel(), super.destroy();
      }
      _setupLabelView(t) {
        return t.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), t;
      }
      _createKeystrokeView() {
        const t = new Dr();
        return t.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__keystroke"]
          },
          children: [{
            text: this.bindTemplate.to("keystroke", t => bi(t))
          }]
        }), t;
      }
      _getTooltipString(t, e, n) {
        return t ? "string" == typeof t ? t : (n && (n = bi(n)), t instanceof Function ? t(e, n) : `${e}${n ? ` (${n})` : ""}`) : "";
      }
    }
    var Bg = n(4391),
      Ng = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Bg.A, Ng);
    Bg.A.locals;
    class Pg extends Sg {
      constructor(t) {
        super(t), this.isToggleable = !0, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
      }
      render() {
        super.render(), this.children.add(this.toggleSwitchView);
      }
      _createToggleView() {
        const t = new Dr();
        return t.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__toggle"]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle__inner"]
            }
          }]
        }), t;
      }
    }
    class Og extends Sg {
      constructor(t) {
        super(t), this.buttonView = this, this._fileInputView = new Lg(t), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.on("execute", () => {
          this._fileInputView.open();
        }), this.extendTemplate({
          attributes: {
            class: "ck-file-dialog-button"
          }
        });
      }
      render() {
        super.render(), this.children.add(this._fileInputView);
      }
    }
    class Lg extends Dr {
      constructor(t) {
        super(t), this.set("acceptedType", void 0), this.set("allowMultipleFiles", !1);
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(() => {
              this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
            })
          }
        });
      }
      open() {
        this.element.click();
      }
    }
    const zg = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
    var Rg = n(25),
      jg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Rg.A, jg);
    Rg.A.locals;
    class Fg extends Dr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.set("isCollapsed", !1), this.set("label", ""), this.buttonView = this._createButtonView(), this.children = this.createCollection(), this.set("_collapsibleAriaLabelUid", void 0), e && this.children.addMany(e), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-collapsible", n.if("isCollapsed", "ck-collapsible_collapsed")]
          },
          children: [this.buttonView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-collapsible__children"],
              role: "region",
              hidden: n.if("isCollapsed", "hidden"),
              "aria-labelledby": n.to("_collapsibleAriaLabelUid")
            },
            children: this.children
          }]
        });
      }
      render() {
        super.render(), this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
      }
      focus() {
        this.buttonView.focus();
      }
      _createButtonView() {
        const t = new Sg(this.locale),
          e = t.bindTemplate;
        return t.set({
          withText: !0,
          icon: zg
        }), t.extendTemplate({
          attributes: {
            "aria-expanded": e.to("isOn", t => String(t))
          }
        }), t.bind("label").to(this), t.bind("isOn").to(this, "isCollapsed", t => !t), t.on("execute", () => {
          this.isCollapsed = !this.isCollapsed;
        }), t;
      }
    }
    var Vg = n(7317),
      Hg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Vg.A, Hg);
    Vg.A.locals;
    n(6931);
    n(9047);
    var Ug = n(4962),
      qg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ug.A, qg);
    Ug.A.locals;
    class Gg extends Dr {
      constructor(t, e) {
        super(t);
        const n = `ck-labeled-field-view-${p()}`,
          o = `ck-labeled-field-view-status-${p()}`;
        this.fieldView = e(this, n, o), this.set("label", void 0), this.set("isEnabled", !0), this.set("isEmpty", !0), this.set("isFocused", !1), this.set("errorText", null), this.set("infoText", null), this.set("class", void 0), this.set("placeholder", void 0), this.labelView = this._createLabelView(n), this.statusView = this._createStatusView(o), this.fieldWrapperChildren = this.createCollection([this.fieldView, this.labelView]), this.bind("_statusText").to(this, "errorText", this, "infoText", (t, e) => t || e);
        const i = this.bindTemplate;
        this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view", i.to("class"), i.if("isEnabled", "ck-disabled", t => !t), i.if("isEmpty", "ck-labeled-field-view_empty"), i.if("isFocused", "ck-labeled-field-view_focused"), i.if("placeholder", "ck-labeled-field-view_placeholder"), i.if("errorText", "ck-error")]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__input-wrapper"]
            },
            children: this.fieldWrapperChildren
          }, this.statusView]
        });
      }
      _createLabelView(t) {
        const e = new fg(this.locale);
        return e.for = t, e.bind("text").to(this, "label"), e;
      }
      _createStatusView(t) {
        const e = new Dr(this.locale),
          n = this.bindTemplate;
        return e.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", t => !t)],
            id: t,
            role: n.if("errorText", "alert")
          },
          children: [{
            text: n.to("_statusText")
          }]
        }), e;
      }
      focus(t) {
        this.fieldView.focus(t);
      }
    }
    class Wg extends Dr {
      constructor(t) {
        super(t), this.set("value", void 0), this.set("id", void 0), this.set("placeholder", void 0), this.set("tabIndex", void 0), this.set("isReadOnly", !1), this.set("hasError", !1), this.set("ariaDescribedById", void 0), this.set("ariaLabel", void 0), this.focusTracker = new Ki(), this.bind("isFocused").to(this.focusTracker), this.set("isEmpty", !0);
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck", "ck-input", e.if("isFocused", "ck-input_focused"), e.if("isEmpty", "ck-input-text_empty"), e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            tabindex: e.to("tabIndex"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", !0),
            "aria-describedby": e.to("ariaDescribedById"),
            "aria-label": e.to("ariaLabel")
          },
          on: {
            input: e.to((...t) => {
              this.fire("input", ...t), this._updateIsEmpty();
            }),
            change: e.to(this._updateIsEmpty.bind(this))
          }
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", (t, e, n) => {
          this._setDomElementValue(n), this._updateIsEmpty();
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy();
      }
      select() {
        this.element.select();
      }
      focus() {
        this.element.focus();
      }
      reset() {
        this.value = this.element.value = "", this._updateIsEmpty();
      }
      _updateIsEmpty() {
        this.isEmpty = !this.element.value;
      }
      _setDomElementValue(t) {
        this.element.value = t || 0 === t ? t : "";
      }
    }
    var Kg = n(253),
      $g = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Kg.A, $g);
    Kg.A.locals;
    class Yg extends Wg {
      constructor(t) {
        super(t), this.set("inputMode", "text");
        const e = this.bindTemplate;
        this.extendTemplate({
          attributes: {
            inputmode: e.to("inputMode")
          }
        });
      }
    }
    class Qg extends Yg {
      constructor(t) {
        super(t), this.extendTemplate({
          attributes: {
            type: "text",
            class: ["ck-input-text"]
          }
        });
      }
    }
    var Zg = n(1671),
      Jg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Zg.A, Jg);
    Zg.A.locals;
    class Xg extends Dr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", t => `ck-dropdown__panel_${t}`), e.if("isVisible", "ck-dropdown__panel-visible")],
            tabindex: "-1"
          },
          children: this.children,
          on: {
            selectstart: e.to(t => {
              "input" !== t.target.tagName.toLocaleLowerCase() && t.preventDefault();
            })
          }
        });
      }
      focus() {
        if (this.children.length) {
          const t = this.children.first;
          "function" == typeof t.focus ? t.focus() : A("ui-dropdown-panel-focus-child-missing-focus", {
            childView: this.children.first,
            dropdownPanel: this
          });
        }
      }
      focusLast() {
        if (this.children.length) {
          const t = this.children.last;
          "function" == typeof t.focusLast ? t.focusLast() : t.focus();
        }
      }
    }
    var tm = n(8149),
      em = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(tm.A, em);
    tm.A.locals;
    const nm = class extends Dr {
      constructor(t, e, n) {
        super(t);
        const o = this.bindTemplate;
        this.buttonView = e, this.panelView = n, this.set("isOpen", !1), this.set("isEnabled", !0), this.set("class", void 0), this.set("id", void 0), this.set("panelPosition", "auto"), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new $i(), this.focusTracker = new Ki(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", o.to("class"), o.if("isEnabled", "ck-disabled", t => !t)],
            id: o.to("id"),
            "aria-describedby": o.to("ariaDescribedById")
          },
          children: [e, n]
        }), e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"],
            "data-cke-tooltip-disabled": o.to("isOpen")
          }
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", () => {
          this.isOpen = !this.isOpen;
        }), this.on("change:isOpen", (t, e, n) => {
          if (n) if ("auto" === this.panelPosition) {
            const t = nm._getOptimalPosition({
              element: this.panelView.element,
              target: this.buttonView.element,
              fitInViewport: !0,
              positions: this._panelPositions
            });
            this.panelView.position = t ? t.name : this._panelPositions[0].name;
          } else this.panelView.position = this.panelPosition;
        }), this.keystrokes.listenTo(this.element);
        const t = (t, e) => {
          this.isOpen && (this.isOpen = !1, e());
        };
        this.keystrokes.set("arrowdown", (t, e) => {
          this.buttonView.isEnabled && !this.isOpen && (this.isOpen = !0, e());
        }), this.keystrokes.set("arrowright", (t, e) => {
          this.isOpen && e();
        }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
      }
      focus() {
        this.buttonView.focus();
      }
      get _panelPositions() {
        const {
          south: t,
          north: e,
          southEast: n,
          southWest: o,
          northEast: i,
          northWest: r,
          southMiddleEast: s,
          southMiddleWest: a,
          northMiddleEast: c,
          northMiddleWest: l
        } = nm.defaultPanelPositions;
        return "rtl" !== this.locale.uiLanguageDirection ? [n, o, s, a, t, i, r, c, l, e] : [o, n, a, s, t, r, i, l, c, e];
      }
    };
    let om = nm;
    om.defaultPanelPositions = {
      south: (t, e) => ({
        top: t.bottom,
        left: t.left - (e.width - t.width) / 2,
        name: "s"
      }),
      southEast: t => ({
        top: t.bottom,
        left: t.left,
        name: "se"
      }),
      southWest: (t, e) => ({
        top: t.bottom,
        left: t.left - e.width + t.width,
        name: "sw"
      }),
      southMiddleEast: (t, e) => ({
        top: t.bottom,
        left: t.left - (e.width - t.width) / 4,
        name: "sme"
      }),
      southMiddleWest: (t, e) => ({
        top: t.bottom,
        left: t.left - 3 * (e.width - t.width) / 4,
        name: "smw"
      }),
      north: (t, e) => ({
        top: t.top - e.height,
        left: t.left - (e.width - t.width) / 2,
        name: "n"
      }),
      northEast: (t, e) => ({
        top: t.top - e.height,
        left: t.left,
        name: "ne"
      }),
      northWest: (t, e) => ({
        top: t.top - e.height,
        left: t.left - e.width + t.width,
        name: "nw"
      }),
      northMiddleEast: (t, e) => ({
        top: t.top - e.height,
        left: t.left - (e.width - t.width) / 4,
        name: "nme"
      }),
      northMiddleWest: (t, e) => ({
        top: t.top - e.height,
        left: t.left - 3 * (e.width - t.width) / 4,
        name: "nmw"
      })
    }, om._getOptimalPosition = Jo;
    class im extends Sg {
      constructor(t) {
        super(t), this.arrowView = this._createArrowView(), this.extendTemplate({
          attributes: {
            "aria-haspopup": !0,
            "aria-expanded": this.bindTemplate.to("isOn", t => String(t))
          }
        }), this.delegate("execute").to(this, "open");
      }
      render() {
        super.render(), this.children.add(this.arrowView);
      }
      _createArrowView() {
        const t = new Dg();
        return t.content = zg, t.extendTemplate({
          attributes: {
            class: "ck-dropdown__arrow"
          }
        }), t;
      }
    }
    class rm extends M() {
      constructor(t) {
        if (super(), this.focusables = t.focusables, this.focusTracker = t.focusTracker, this.keystrokeHandler = t.keystrokeHandler, this.actions = t.actions, t.actions && t.keystrokeHandler) for (const e in t.actions) {
          let n = t.actions[e];
          "string" == typeof n && (n = [n]);
          for (const o of n) t.keystrokeHandler.set(o, (t, n) => {
            this[e](), n();
          });
        }
        this.on("forwardCycle", () => this.focusFirst(), {
          priority: "low"
        }), this.on("backwardCycle", () => this.focusLast(), {
          priority: "low"
        });
      }
      get first() {
        return this.focusables.find(sm) || null;
      }
      get last() {
        return this.focusables.filter(sm).slice(-1)[0] || null;
      }
      get next() {
        return this._getDomFocusableItem(1);
      }
      get previous() {
        return this._getDomFocusableItem(-1);
      }
      get current() {
        let t = null;
        return null === this.focusTracker.focusedElement ? null : (this.focusables.find((e, n) => {
          const o = e.element === this.focusTracker.focusedElement;
          return o && (t = n), o;
        }), t);
      }
      focusFirst() {
        this._focus(this.first, 1);
      }
      focusLast() {
        this._focus(this.last, -1);
      }
      focusNext() {
        const t = this.next;
        t && this.focusables.getIndex(t) === this.current || t === this.first ? this.fire("forwardCycle") : this._focus(t, 1);
      }
      focusPrevious() {
        const t = this.previous;
        t && this.focusables.getIndex(t) === this.current || t === this.last ? this.fire("backwardCycle") : this._focus(t, -1);
      }
      _focus(t, e) {
        t && this.focusTracker.focusedElement !== t.element && t.focus(e);
      }
      _getDomFocusableItem(t) {
        const e = this.focusables.length;
        if (!e) return null;
        const n = this.current;
        if (null === n) return this[1 === t ? "first" : "last"];
        let o = this.focusables.get(n),
          i = (n + e + t) % e;
        do {
          const n = this.focusables.get(i);
          if (sm(n)) {
            o = n;
            break;
          }
          i = (i + e + t) % e;
        } while (i !== n);
        return o;
      }
    }
    function sm(t) {
      return am(t) && Qo(t.element);
    }
    function am(t) {
      return !(!("focus" in t) || "function" != typeof t.focus);
    }
    class cm extends Dr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
      }
    }
    class lm extends Dr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__line-break"]
          }
        });
      }
    }
    var dm = Object.defineProperty,
      um = Object.getOwnPropertySymbols,
      hm = Object.prototype.hasOwnProperty,
      gm = Object.prototype.propertyIsEnumerable,
      mm = (t, e, n) => e in t ? dm(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      pm = (t, e) => {
        for (var n in e || (e = {})) hm.call(e, n) && mm(t, n, e[n]);
        if (um) for (var n of um(e)) gm.call(e, n) && mm(t, n, e[n]);
        return t;
      };
    function fm(t) {
      if (Array.isArray(t)) return {
        items: t,
        removeItems: []
      };
      const e = {
        items: [],
        removeItems: []
      };
      return t ? pm(pm({}, e), t) : e;
    }
    var km = n(9677),
      bm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(km.A, bm);
    km.A.locals;
    const wm = {
      alignLeft: gg.alignLeft,
      bold: gg.bold,
      importExport: gg.importExport,
      paragraph: gg.paragraph,
      plus: gg.plus,
      text: gg.text,
      threeVerticalDots: gg.threeVerticalDots,
      pilcrow: gg.pilcrow,
      dragIndicator: gg.dragIndicator
    };
    class Am extends Dr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate,
          o = this.t;
        this.options = e || {}, this.set("ariaLabel", o("Editor toolbar")), this.set("maxWidth", "auto"), this.items = this.createCollection(), this.focusTracker = new Ki(), this.keystrokes = new $i(), this.set("class", void 0), this.set("isCompact", !1), this.itemsView = new _m(t), this.children = this.createCollection(), this.children.add(this.itemsView), this.focusables = this.createCollection();
        const i = "rtl" === t.uiLanguageDirection;
        this._focusCycler = new rm({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: [i ? "arrowright" : "arrowleft", "arrowup"],
            focusNext: [i ? "arrowleft" : "arrowright", "arrowdown"]
          }
        });
        const r = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")];
        var s;
        this.options.shouldGroupWhenFull && this.options.isFloating && r.push("ck-toolbar_floating"), this.setTemplate({
          tag: "div",
          attributes: {
            class: r,
            role: "toolbar",
            "aria-label": n.to("ariaLabel"),
            style: {
              maxWidth: n.to("maxWidth")
            },
            tabindex: -1
          },
          children: this.children,
          on: {
            mousedown: (s = this, s.bindTemplate.to(t => {
              t.target === s.element && t.preventDefault();
            }))
          }
        }), this._behavior = this.options.shouldGroupWhenFull ? new vm(this) : new Cm(this);
      }
      render() {
        super.render(), this.focusTracker.add(this.element);
        for (const t of this.items) this.focusTracker.add(t.element);
        this.items.on("add", (t, e) => {
          this.focusTracker.add(e.element);
        }), this.items.on("remove", (t, e) => {
          this.focusTracker.remove(e.element);
        }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
      }
      destroy() {
        return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      fillFromConfig(t, e, n) {
        this.items.addMany(this._buildItemsFromConfig(t, e, n));
      }
      _buildItemsFromConfig(t, e, n) {
        const o = fm(t),
          i = n || o.removeItems;
        return this._cleanItemsConfiguration(o.items, e, i).map(t => R(t) ? this._createNestedToolbarDropdown(t, e, i) : "|" === t ? new cm() : "-" === t ? new lm() : e.create(t)).filter(t => !!t);
      }
      _cleanItemsConfiguration(t, e, n) {
        const o = t.filter((t, o, i) => "|" === t || -1 === n.indexOf(t) && ("-" === t ? !this.options.shouldGroupWhenFull || (A("toolbarview-line-break-ignored-when-grouping-items", i), !1) : !(!R(t) && !e.has(t)) || (A("toolbarview-item-unavailable", {
          item: t
        }), !1)));
        return this._cleanSeparatorsAndLineBreaks(o);
      }
      _cleanSeparatorsAndLineBreaks(t) {
        const e = t => "-" !== t && "|" !== t,
          n = t.length,
          o = t.findIndex(e);
        if (-1 === o) return [];
        const i = n - t.slice().reverse().findIndex(e);
        return t.slice(o, i).filter((t, n, o) => {
          if (e(t)) return !0;
          return !(n > 0 && o[n - 1] === t);
        });
      }
      _createNestedToolbarDropdown(t, e, n) {
        let {
          label: o,
          icon: i,
          items: r,
          tooltip: s = !0,
          withText: a = !1
        } = t;
        if (r = this._cleanItemsConfiguration(r, e, n), !r.length) return null;
        const c = zm(this.locale);
        return o || A("toolbarview-nested-toolbar-dropdown-missing-label", t), c.class = "ck-toolbar__nested-toolbar-dropdown", c.buttonView.set({
          label: o,
          tooltip: s,
          withText: !!a
        }), !1 !== i ? c.buttonView.icon = wm[i] || i || gg.threeVerticalDots : c.buttonView.withText = !0, Rm(c, () => c.toolbarView._buildItemsFromConfig(r, e, n)), c;
      }
    }
    class _m extends Dr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: this.children
        });
      }
    }
    class Cm {
      constructor(t) {
        const e = t.bindTemplate;
        t.set("isVertical", !1), t.itemsView.children.bindTo(t.items).using(t => t), t.focusables.bindTo(t.items).using(t => am(t) ? t : null), t.extendTemplate({
          attributes: {
            class: [e.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }
      render() {}
      destroy() {}
    }
    class vm {
      constructor(t) {
        this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, this.view = t, this.viewChildren = t.children, this.viewFocusables = t.focusables, this.viewItemsView = t.itemsView, this.viewFocusTracker = t.focusTracker, this.viewLocale = t.locale, this.ungroupedItems = t.createCollection(), this.groupedItems = t.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), t.itemsView.children.bindTo(this.ungroupedItems).using(t => t), this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this)), t.children.on("change", this._updateFocusCyclableItems.bind(this)), t.items.on("change", (t, e) => {
          const n = e.index,
            o = Array.from(e.added);
          for (const t of e.removed) n >= this.ungroupedItems.length ? this.groupedItems.remove(t) : this.ungroupedItems.remove(t);
          for (let t = n; t < n + o.length; t++) {
            const e = o[t - n];
            t > this.ungroupedItems.length ? this.groupedItems.add(e, t - this.ungroupedItems.length) : this.ungroupedItems.add(e, t);
          }
          this._updateGrouping();
        }), t.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }
      render(t) {
        this.viewElement = t.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(t);
      }
      destroy() {
        this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
      }
      _updateGrouping() {
        if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
        if (!Qo(this.viewElement)) return void (this.shouldUpdateGroupingOnNextResize = !0);
        const t = this.groupedItems.length;
        let e;
        for (; this._areItemsOverflowing;) this._groupLastItem(), e = !0;
        if (!e && this.groupedItems.length) {
          for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
          this._areItemsOverflowing && this._groupLastItem();
        }
        this.groupedItems.length !== t && this.view.fire("groupedItemsUpdate");
      }
      get _areItemsOverflowing() {
        if (!this.ungroupedItems.length) return !1;
        const t = this.viewElement,
          n = this.viewLocale.uiLanguageDirection,
          o = new Ro(t.lastChild),
          i = new Ro(t);
        if (!this.cachedPadding) {
          const o = e.window.getComputedStyle(t),
            i = "ltr" === n ? "paddingRight" : "paddingLeft";
          this.cachedPadding = Number.parseInt(o[i]);
        }
        return "ltr" === n ? o.right > i.right - this.cachedPadding : o.left < i.left + this.cachedPadding;
      }
      _enableGroupingOnResize() {
        let t;
        this.resizeObserver = new qo(this.viewElement, e => {
          t && t === e.contentRect.width && !this.shouldUpdateGroupingOnNextResize || (this.shouldUpdateGroupingOnNextResize = !1, this._updateGrouping(), t = e.contentRect.width);
        }), this._updateGrouping();
      }
      _enableGroupingOnMaxWidthChange(t) {
        t.on("change:maxWidth", () => {
          this._updateGrouping();
        });
      }
      _groupLastItem() {
        this.groupedItems.length || (this.viewChildren.add(new cm()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
      }
      _ungroupFirstItem() {
        this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
      }
      _createGroupedItemsDropdown() {
        const t = this.viewLocale,
          e = t.t,
          n = zm(t);
        return n.class = "ck-toolbar__grouped-dropdown", n.panelPosition = "ltr" === t.uiLanguageDirection ? "sw" : "se", Rm(n, this.groupedItems), n.buttonView.set({
          label: e("Show more items"),
          tooltip: !0,
          tooltipPosition: "rtl" === t.uiLanguageDirection ? "se" : "sw",
          icon: gg.threeVerticalDots
        }), n;
      }
      _updateFocusCyclableItems() {
        this.viewFocusables.clear(), this.ungroupedItems.map(t => {
          am(t) && this.viewFocusables.add(t);
        }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
      }
    }
    class ym extends Dr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isVisible", !0), this.children = this.createCollection(), this.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item", e.if("isVisible", "ck-hidden", t => !t)],
            role: "presentation"
          },
          children: this.children
        });
      }
      focus() {
        this.children.first && this.children.first.focus();
      }
    }
    class xm extends Dr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
      }
    }
    class Em extends Dr {
      constructor(t, e = new fg()) {
        super(t);
        const n = this.bindTemplate,
          o = new Tm(t);
        this.set({
          label: "",
          isVisible: !0
        }), this.labelView = e, this.labelView.bind("text").to(this, "label"), this.children = this.createCollection(), this.children.addMany([this.labelView, o]), o.set({
          role: "group",
          ariaLabelledBy: e.id
        }), o.focusTracker.destroy(), o.keystrokes.destroy(), this.items = o.items, this.setTemplate({
          tag: "li",
          attributes: {
            role: "presentation",
            class: ["ck", "ck-list__group", n.if("isVisible", "ck-hidden", t => !t)]
          },
          children: this.children
        });
      }
      focus() {
        if (this.items) {
          const t = this.items.find(t => !(t instanceof xm));
          t && t.focus();
        }
      }
    }
    var Dm = n(5199),
      Im = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Dm.A, Im);
    Dm.A.locals;
    class Tm extends Dr {
      constructor(t) {
        super(t), this._listItemGroupToChangeListeners = new WeakMap();
        const e = this.bindTemplate;
        this.focusables = new er(), this.items = this.createCollection(), this.focusTracker = new Ki(), this.keystrokes = new $i(), this._focusCycler = new rm({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), this.set("ariaLabel", void 0), this.set("ariaLabelledBy", void 0), this.set("role", void 0), this.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"],
            role: e.to("role"),
            "aria-label": e.to("ariaLabel"),
            "aria-labelledby": e.to("ariaLabelledBy")
          },
          children: this.items
        });
      }
      render() {
        super.render();
        for (const t of this.items) t instanceof Em ? this._registerFocusableItemsGroup(t) : t instanceof ym && this._registerFocusableListItem(t);
        this.items.on("change", (t, e) => {
          for (const t of e.removed) t instanceof Em ? this._deregisterFocusableItemsGroup(t) : t instanceof ym && this._deregisterFocusableListItem(t);
          for (const t of Array.from(e.added).reverse()) t instanceof Em ? this._registerFocusableItemsGroup(t, e.index) : this._registerFocusableListItem(t, e.index);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusFirst() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      _registerFocusableListItem(t, e) {
        this.focusTracker.add(t.element), this.focusables.add(t, e);
      }
      _deregisterFocusableListItem(t) {
        this.focusTracker.remove(t.element), this.focusables.remove(t);
      }
      _getOnGroupItemsChangeCallback(t) {
        return (e, n) => {
          for (const t of n.removed) this._deregisterFocusableListItem(t);
          for (const e of Array.from(n.added).reverse()) this._registerFocusableListItem(e, this.items.getIndex(t) + n.index);
        };
      }
      _registerFocusableItemsGroup(t, e) {
        Array.from(t.items).forEach((t, n) => {
          const o = void 0 !== e ? e + n : void 0;
          this._registerFocusableListItem(t, o);
        });
        const n = this._getOnGroupItemsChangeCallback(t);
        this._listItemGroupToChangeListeners.set(t, n), t.items.on("change", n);
      }
      _deregisterFocusableItemsGroup(t) {
        for (const e of t.items) this._deregisterFocusableListItem(e);
        t.items.off("change", this._listItemGroupToChangeListeners.get(t)), this._listItemGroupToChangeListeners.delete(t);
      }
    }
    var Mm = n(1792),
      Sm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Mm.A, Sm);
    Mm.A.locals;
    class Bm extends Dr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isToggleable", !1), this.set("isVisible", !0), this.set("keystroke", void 0), this.set("withKeystroke", !1), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.children = this.createCollection(), this.actionView = this._createActionView(e), this.arrowView = this._createArrowView(), this.keystrokes = new $i(), this.focusTracker = new Ki(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-splitbutton", n.to("class"), n.if("isVisible", "ck-hidden", t => !t), this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", (t, e) => {
          this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), e());
        }), this.keystrokes.set("arrowleft", (t, e) => {
          this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), e());
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this.actionView.focus();
      }
      _createActionView(t) {
        const e = t || new Sg();
        return t || e.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), e.extendTemplate({
          attributes: {
            class: "ck-splitbutton__action"
          }
        }), e.delegate("execute").to(this), e;
      }
      _createArrowView() {
        const t = new Sg(),
          e = t.bindTemplate;
        return t.icon = zg, t.extendTemplate({
          attributes: {
            class: ["ck-splitbutton__arrow"],
            "data-cke-tooltip-disabled": e.to("isOn"),
            "aria-haspopup": !0,
            "aria-expanded": e.to("isOn", t => String(t))
          }
        }), t.bind("isEnabled").to(this), t.bind("label").to(this), t.bind("tooltip").to(this), t.delegate("execute").to(this, "open"), t;
      }
    }
    var Nm = n(1666),
      Pm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Nm.A, Pm);
    Nm.A.locals;
    var Om = n(3629),
      Lm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Om.A, Lm);
    Om.A.locals;
    function zm(t, n = im) {
      const o = "function" == typeof n ? new n(t) : n,
        i = new Xg(t),
        r = new om(t, o, i);
      return o.bind("isEnabled").to(r), o instanceof Bm ? o.arrowView.bind("isOn").to(r, "isOpen") : o.bind("isOn").to(r, "isOpen"), function (t) {
        (function (t) {
          t.on("render", () => {
            Ir({
              emitter: t,
              activator: () => t.isOpen,
              callback: () => {
                t.isOpen = !1;
              },
              contextElements: () => [t.element, ...t.focusTracker._elements]
            });
          });
        })(t), function (t) {
          t.on("execute", e => {
            e.source instanceof Pg || (t.isOpen = !1);
          });
        }(t), function (t) {
          t.focusTracker.on("change:isFocused", (e, n, o) => {
            t.isOpen && !o && (t.isOpen = !1);
          });
        }(t), function (t) {
          t.keystrokes.set("arrowdown", (e, n) => {
            t.isOpen && (t.panelView.focus(), n());
          }), t.keystrokes.set("arrowup", (e, n) => {
            t.isOpen && (t.panelView.focusLast(), n());
          });
        }(t), function (t) {
          t.on("change:isOpen", (n, o, i) => {
            if (i) return;
            const r = t.panelView.element;
            r && r.contains(e.document.activeElement) && t.buttonView.focus();
          });
        }(t), function (t) {
          t.on("change:isOpen", (e, n, o) => {
            o && t.panelView.focus();
          }, {
            priority: "low"
          });
        }(t);
      }(r), r;
    }
    function Rm(t, e, n = {}) {
      t.extendTemplate({
        attributes: {
          class: ["ck-toolbar-dropdown"]
        }
      }), t.isOpen ? jm(t, e, n) : t.once("change:isOpen", () => jm(t, e, n), {
        priority: "highest"
      }), n.enableActiveItemFocusOnDropdownOpen && Hm(t, () => t.toolbarView.items.find(t => t.isOn));
    }
    function jm(t, e, n) {
      const o = t.locale,
        i = o.t,
        r = t.toolbarView = new Am(o),
        s = "function" == typeof e ? e() : e;
      r.ariaLabel = n.ariaLabel || i("Dropdown toolbar"), n.maxWidth && (r.maxWidth = n.maxWidth), n.class && (r.class = n.class), n.isCompact && (r.isCompact = n.isCompact), n.isVertical && (r.isVertical = !0), s instanceof er ? r.items.bindTo(s).using(t => t) : r.items.addMany(s), t.panelView.children.add(r), r.items.delegate("execute").to(t);
    }
    function Fm(t, e, n = {}) {
      t.isOpen ? Vm(t, e, n) : t.once("change:isOpen", () => Vm(t, e, n), {
        priority: "highest"
      }), Hm(t, () => t.listView.items.find(t => t instanceof ym && t.children.first.isOn));
    }
    function Vm(t, e, n) {
      const o = t.locale,
        i = t.listView = new Tm(o),
        r = "function" == typeof e ? e() : e;
      i.ariaLabel = n.ariaLabel, i.role = n.role, Um(t, i.items, r, o), t.panelView.children.add(i), i.items.delegate("execute").to(t);
    }
    function Hm(t, e) {
      t.on("change:isOpen", () => {
        if (!t.isOpen) return;
        const n = e();
        n && ("function" == typeof n.focus ? n.focus() : A("ui-dropdown-focus-child-on-open-child-missing-focus", {
          view: n
        }));
      }, {
        priority: f.low - 10
      });
    }
    function Um(t, e, n, o) {
      e.bindTo(n).using(e => {
        if ("separator" === e.type) return new xm(o);
        if ("group" === e.type) {
          const n = new Em(o);
          return n.set({
            label: e.label
          }), Um(t, n.items, e.items, o), n.items.delegate("execute").to(t), n;
        }
        if ("button" === e.type || "switchbutton" === e.type) {
          const t = new ym(o);
          let n;
          return "button" === e.type ? (n = new Sg(o), n.bind("ariaChecked").to(n, "isOn")) : n = new Pg(o), n.bind(...Object.keys(e.model)).to(e.model), n.delegate("execute").to(t), t.children.add(n), t;
        }
        return null;
      });
    }
    const qm = (t, e, n) => {
      const o = new Qg(t.locale);
      return o.set({
        id: e,
        ariaDescribedById: n
      }), o.bind("isReadOnly").to(t, "isEnabled", t => !t), o.bind("hasError").to(t, "errorText", t => !!t), o.on("input", () => {
        t.errorText = null;
      }), t.bind("isEmpty", "isFocused", "placeholder").to(o), o;
    };
    Math.PI;
    const Gm = Symbol("same"),
      Wm = (Symbol("color"), Symbol("hsva"), Symbol("update")),
      Km = (Symbol("parts"), Symbol("css")),
      $m = Symbol("sliders");
    HTMLElement;
    var Ym = n(1905),
      Qm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ym.A, Qm);
    Ym.A.locals;
    G(Gi);
    const {
      eraser: Zm,
      colorPalette: Jm
    } = gg;
    Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    var Xm = n(6309),
      tp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Xm.A, tp);
    Xm.A.locals;
    class ep {
      constructor(t) {
        this._components = new Map(), this.editor = t;
      }
      *names() {
        for (const t of this._components.values()) yield t.originalName;
      }
      add(t, e) {
        this._components.set(np(t), {
          callback: e,
          originalName: t
        });
      }
      create(t) {
        if (!this.has(t)) throw new w("componentfactory-item-missing", this, {
          name: t
        });
        return this._components.get(np(t)).callback(this.editor.locale);
      }
      has(t) {
        return this._components.has(np(t));
      }
    }
    function np(t) {
      return String(t).toLowerCase();
    }
    var op = n(7913),
      ip = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(op.A, ip);
    op.A.locals;
    class rp extends Dr {
      constructor(t, e = {}) {
        super(t);
        const n = this.bindTemplate;
        this.set("label", e.label || ""), this.set("class", e.class || null), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-form__header", n.to("class")]
          },
          children: this.children
        }), e.icon && (this.iconView = new Dg(), this.iconView.content = e.icon, this.children.add(this.iconView));
        const o = new Dr(t);
        o.setTemplate({
          tag: "h2",
          attributes: {
            class: ["ck", "ck-form__header__label"],
            role: "presentation"
          },
          children: [{
            text: n.to("label")
          }]
        }), this.children.add(o);
      }
    }
    var sp = n(9822),
      ap = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(sp.A, ap);
    sp.A.locals;
    class cp extends Dr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.keystrokes = new $i(), this._focusTracker = new Ki(), this._focusables = new er(), this.focusCycler = new rm({
          focusables: this._focusables,
          focusTracker: this._focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog__actions"]
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element);
      }
      setButtons(t) {
        for (const e of t) {
          const t = new Sg(this.locale);
          let n;
          for (n in t.on("execute", () => e.onExecute()), e.onCreate && e.onCreate(t), e) "onExecute" != n && "onCreate" != n && t.set(n, e[n]);
          this.children.add(t);
        }
        this._updateFocusCyclableItems();
      }
      focus(t) {
        -1 === t ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
      _updateFocusCyclableItems() {
        Array.from(this.children).forEach(t => {
          this._focusables.add(t), this._focusTracker.add(t.element);
        });
      }
    }
    class lp extends Dr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog__content"]
          },
          children: this.children
        });
      }
      reset() {
        for (; this.children.length;) this.children.remove(0);
      }
    }
    var dp = n(9819),
      up = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(dp.A, up);
    dp.A.locals;
    const hp = "screen-center",
      gp = "editor-center",
      mp = "editor-top-side",
      pp = "editor-top-center",
      fp = "editor-bottom-center",
      kp = "editor-above-center",
      bp = "editor-below-center",
      wp = Wo("px"),
      Ap = class extends function (t) {
        return class extends t {
          constructor(...t) {
            super(...t), this._onDragBound = this._onDrag.bind(this), this._onDragEndBound = this._onDragEnd.bind(this), this._lastDraggingCoordinates = {
              x: 0,
              y: 0
            }, this.on("render", () => {
              this._attachListeners();
            }), this.set("isDragging", !1);
          }
          _attachListeners() {
            this.listenTo(this.element, "mousedown", this._onDragStart.bind(this)), this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
          }
          _attachDragListeners() {
            this.listenTo(e.document, "mouseup", this._onDragEndBound), this.listenTo(e.document, "touchend", this._onDragEndBound), this.listenTo(e.document, "mousemove", this._onDragBound), this.listenTo(e.document, "touchmove", this._onDragBound);
          }
          _detachDragListeners() {
            this.stopListening(e.document, "mouseup", this._onDragEndBound), this.stopListening(e.document, "touchend", this._onDragEndBound), this.stopListening(e.document, "mousemove", this._onDragBound), this.stopListening(e.document, "touchmove", this._onDragBound);
          }
          _onDragStart(t, e) {
            if (!this._isHandleElementPressed(e)) return;
            this._attachDragListeners();
            let n = 0,
              o = 0;
            e instanceof MouseEvent ? (n = e.clientX, o = e.clientY) : (n = e.touches[0].clientX, o = e.touches[0].clientY), this._lastDraggingCoordinates = {
              x: n,
              y: o
            }, this.isDragging = !0;
          }
          _onDrag(t, e) {
            if (!this.isDragging) return void this._detachDragListeners();
            let n = 0,
              o = 0;
            e instanceof MouseEvent ? (n = e.clientX, o = e.clientY) : (n = e.touches[0].clientX, o = e.touches[0].clientY), e.preventDefault(), this.fire("drag", {
              deltaX: Math.round(n - this._lastDraggingCoordinates.x),
              deltaY: Math.round(o - this._lastDraggingCoordinates.y)
            }), this._lastDraggingCoordinates = {
              x: n,
              y: o
            };
          }
          _onDragEnd() {
            this._detachDragListeners(), this.isDragging = !1;
          }
          _isHandleElementPressed(t) {
            return !!this.dragHandleElement && (this.dragHandleElement === t.target || t.target instanceof HTMLElement && this.dragHandleElement.contains(t.target));
          }
        };
      }(Dr) {
        constructor(t, {
          getCurrentDomRoot: e,
          getViewportOffset: n
        }) {
          super(t), this.wasMoved = !1;
          const o = this.bindTemplate,
            i = t.t;
          this.set("className", ""), this.set("ariaLabel", i("Editor dialog")), this.set("isModal", !1), this.set("position", hp), this.set("_isVisible", !1), this.set("_isTransparent", !1), this.set("_top", 0), this.set("_left", 0), this._getCurrentDomRoot = e, this._getViewportOffset = n, this.decorate("moveTo"), this.parts = this.createCollection(), this.keystrokes = new $i(), this.focusTracker = new Ki(), this._focusables = new er(), this._focusCycler = new rm({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
              focusPrevious: "shift + tab",
              focusNext: "tab"
            }
          }), this.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-dialog-overlay", o.if("isModal", "ck-dialog-overlay__transparent", t => !t), o.if("_isVisible", "ck-hidden", t => !t)],
              tabindex: "-1"
            },
            children: [{
              tag: "div",
              attributes: {
                tabindex: "-1",
                class: ["ck", "ck-dialog", o.to("className")],
                role: "dialog",
                "aria-label": o.to("ariaLabel"),
                style: {
                  top: o.to("_top", t => wp(t)),
                  left: o.to("_left", t => wp(t)),
                  visibility: o.if("_isTransparent", "hidden")
                }
              },
              children: this.parts
            }]
          });
        }
        render() {
          super.render(), this.keystrokes.set("Esc", (t, e) => {
            this.fire("close", {
              source: "escKeyPress"
            }), e();
          }), this.on("drag", (t, {
            deltaX: e,
            deltaY: n
          }) => {
            this.wasMoved = !0, this.moveBy(e, n);
          }), this.listenTo(e.window, "resize", () => {
            this._isVisible && !this.wasMoved && this.updatePosition();
          }), this.listenTo(e.document, "scroll", () => {
            this._isVisible && !this.wasMoved && this.updatePosition();
          }), this.on("change:_isVisible", (t, e, n) => {
            n && (this._isTransparent = !0, setTimeout(() => {
              this.updatePosition(), this._isTransparent = !1, this.focus();
            }, 10));
          }), this.keystrokes.listenTo(this.element);
        }
        get dragHandleElement() {
          return this.headerView ? this.headerView.element : null;
        }
        setupParts({
          icon: t,
          title: e,
          hasCloseButton: n = !0,
          content: o,
          actionButtons: i
        }) {
          e && (this.headerView = new rp(this.locale, {
            icon: t
          }), n && (this.closeButtonView = this._createCloseButton(), this.headerView.children.add(this.closeButtonView)), this.headerView.label = e, this.ariaLabel = e, this.parts.add(this.headerView, 0)), o && (o instanceof Dr && (o = [o]), this.contentView = new lp(this.locale), this.contentView.children.addMany(o), this.parts.add(this.contentView)), i && (this.actionsView = new cp(this.locale), this.actionsView.setButtons(i), this.parts.add(this.actionsView)), this._updateFocusCyclableItems();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        moveTo(t, e) {
          const n = this._getViewportRect(),
            o = this._getDialogRect();
          t + o.width > n.right && (t = n.right - o.width), t < n.left && (t = n.left), e < n.top && (e = n.top), this._moveTo(t, e);
        }
        _moveTo(t, e) {
          this._left = t, this._top = e;
        }
        moveBy(t, e) {
          this.moveTo(this._left + t, this._top + e);
        }
        _moveOffScreen() {
          this._moveTo(-9999, -9999);
        }
        updatePosition() {
          if (!this.element || !this.element.parentNode) return;
          const t = this._getViewportRect();
          let e,
            n = this.position;
          this._getCurrentDomRoot() ? e = this._getVisibleDomRootRect(t) : n = hp;
          const o = Ap.defaultOffset,
            i = this._getDialogRect();
          switch (n) {
            case mp:
              if (e) {
                const t = "ltr" === this.locale.contentLanguageDirection ? e.right - i.width - o : e.left + o;
                this.moveTo(t, e.top + o);
              } else this._moveOffScreen();
              break;
            case gp:
              e ? this.moveTo(Math.round(e.left + e.width / 2 - i.width / 2), Math.round(e.top + e.height / 2 - i.height / 2)) : this._moveOffScreen();
              break;
            case hp:
              this.moveTo(Math.round((t.width - i.width) / 2), Math.round((t.height - i.height) / 2));
              break;
            case pp:
              e ? this.moveTo(Math.round(e.left + e.width / 2 - i.width / 2), e.top + o) : this._moveOffScreen();
              break;
            case fp:
              e ? this.moveTo(Math.round(e.left + e.width / 2 - i.width / 2), e.bottom - i.height - o) : this._moveOffScreen();
              break;
            case kp:
              e ? this.moveTo(Math.round(e.left + e.width / 2 - i.width / 2), e.top - i.height - o) : this._moveOffScreen();
              break;
            case bp:
              e ? this.moveTo(Math.round(e.left + e.width / 2 - i.width / 2), e.bottom + o) : this._moveOffScreen();
          }
        }
        _getVisibleDomRootRect(t) {
          let e = new Ro(this._getCurrentDomRoot()).getVisible();
          return e ? (e = t.getIntersection(e), e || null) : null;
        }
        _getDialogRect() {
          return new Ro(this.element.firstElementChild);
        }
        _getViewportRect() {
          return function (t) {
            t = Object.assign({
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            }, t);
            const n = new Ro(e.window);
            return n.top += t.top, n.height -= t.top, n.bottom -= t.bottom, n.height -= t.bottom, n.left += t.left, n.right -= t.right, n.width -= t.left + t.right, n;
          }(this._getViewportOffset());
        }
        _updateFocusCyclableItems() {
          const t = [];
          if (this.contentView) for (const e of this.contentView.children) am(e) && t.push(e);
          this.actionsView && t.push(this.actionsView), this.closeButtonView && t.push(this.closeButtonView), t.forEach(t => {
            var e;
            this._focusables.add(t), this.focusTracker.add(t.element), am(e = t) && "focusCycler" in e && e.focusCycler instanceof rm && (this.listenTo(t.focusCycler, "forwardCycle", t => {
              this._focusCycler.focusNext(), this._focusCycler.next !== this._focusCycler.focusables.get(this._focusCycler.current) && t.stop();
            }), this.listenTo(t.focusCycler, "backwardCycle", t => {
              this._focusCycler.focusPrevious(), this._focusCycler.previous !== this._focusCycler.focusables.get(this._focusCycler.current) && t.stop();
            }));
          });
        }
        _createCloseButton() {
          const t = new Sg(this.locale),
            e = this.locale.t;
          return t.set({
            label: e("Close"),
            tooltip: !0,
            icon: gg.cancel
          }), t.on("execute", () => this.fire("close", {
            source: "closeButton"
          })), t;
        }
      };
    let _p = Ap;
    _p.defaultOffset = 15;
    class Cp extends Br {
      constructor(t) {
        super(t);
        const e = t.t;
        this._initShowHideListeners(), this._initFocusToggler(), this._initMultiRootIntegration(), this.set("id", null), t.accessibility.addKeystrokeInfos({
          categoryId: "navigation",
          keystrokes: [{
            label: e("Move focus in and out of an active dialog window"),
            keystroke: "Ctrl+F6",
            mayRequireFn: !0
          }]
        });
      }
      static get pluginName() {
        return "Dialog";
      }
      _initShowHideListeners() {
        this.on("show", (t, e) => {
          this._show(e);
        }), this.on("show", (t, e) => {
          e.onShow && e.onShow(this);
        }, {
          priority: "low"
        }), this.on("hide", () => {
          Cp._visibleDialogPlugin && Cp._visibleDialogPlugin._hide();
        }), this.on("hide", () => {
          this._onHide && (this._onHide(this), this._onHide = void 0);
        }, {
          priority: "low"
        });
      }
      _initFocusToggler() {
        const t = this.editor;
        t.keystrokes.set("Ctrl+F6", (e, n) => {
          this.isOpen && !this.view.isModal && (this.view.focusTracker.isFocused ? t.editing.view.focus() : this.view.focus(), n());
        });
      }
      _initMultiRootIntegration() {
        const t = this.editor.model;
        t.document.on("change:data", () => {
          if (!this.view) return;
          const e = t.document.differ.getChangedRoots();
          for (const t of e) t.state && this.view.updatePosition();
        });
      }
      show(t) {
        this.hide(), this.fire(`show:${t.id}`, t);
      }
      _show({
        id: t,
        icon: e,
        title: n,
        hasCloseButton: o = !0,
        content: i,
        actionButtons: r,
        className: s,
        isModal: a,
        position: c,
        onHide: l
      }) {
        const d = this.editor;
        this.view = new _p(d.locale, {
          getCurrentDomRoot: () => d.editing.view.getDomRoot(d.model.document.selection.anchor.root.rootName),
          getViewportOffset: () => d.ui.viewportOffset
        });
        const u = this.view;
        u.on("close", () => {
          this.hide();
        }), d.ui.view.body.add(u), d.ui.focusTracker.add(u.element), d.keystrokes.listenTo(u.element), c || (c = a ? hp : gp), u.set({
          position: c,
          _isVisible: !0,
          className: s,
          isModal: a
        }), u.setupParts({
          icon: e,
          title: n,
          hasCloseButton: o,
          content: i,
          actionButtons: r
        }), this.id = t, l && (this._onHide = l), this.isOpen = !0, Cp._visibleDialogPlugin = this;
      }
      hide() {
        Cp._visibleDialogPlugin && Cp._visibleDialogPlugin.fire(`hide:${Cp._visibleDialogPlugin.id}`);
      }
      _hide() {
        if (!this.view) return;
        const t = this.editor,
          e = this.view;
        e.contentView && e.contentView.reset(), t.ui.view.body.remove(e), t.ui.focusTracker.remove(e.element), t.keystrokes.stopListening(e.element), e.destroy(), t.editing.view.focus(), this.id = null, this.isOpen = !1, Cp._visibleDialogPlugin = null;
      }
    }
    var vp = n(3710),
      yp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(vp.A, yp);
    vp.A.locals;
    var xp = Object.defineProperty,
      Ep = Object.getOwnPropertySymbols,
      Dp = Object.prototype.hasOwnProperty,
      Ip = Object.prototype.propertyIsEnumerable,
      Tp = (t, e, n) => e in t ? xp(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      Mp = (t, e) => {
        for (var n in e || (e = {})) Dp.call(e, n) && Tp(t, n, e[n]);
        if (Ep) for (var n of Ep(e)) Ip.call(e, n) && Tp(t, n, e[n]);
        return t;
      };
    const Sp = Wo("px"),
      Bp = e.document.body,
      Np = {
        top: -99999,
        left: -99999,
        name: "arrowless",
        config: {
          withArrow: !1
        }
      },
      Pp = class extends Dr {
        constructor(t) {
          super(t);
          const e = this.bindTemplate;
          this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", !1), this.set("withArrow", !0), this.set("class", void 0), this._pinWhenIsVisibleCallback = null, this.content = this.createCollection(), this.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-balloon-panel", e.to("position", t => `ck-balloon-panel_${t}`), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
              style: {
                top: e.to("top", Sp),
                left: e.to("left", Sp)
              }
            },
            children: this.content
          });
        }
        show() {
          this.isVisible = !0;
        }
        hide() {
          this.isVisible = !1;
        }
        attachTo(t) {
          this.show();
          const e = Pp.defaultPositions,
            n = Object.assign({}, {
              element: this.element,
              positions: [e.southArrowNorth, e.southArrowNorthMiddleWest, e.southArrowNorthMiddleEast, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthMiddleWest, e.northArrowSouthMiddleEast, e.northArrowSouthWest, e.northArrowSouthEast, e.viewportStickyNorth],
              limiter: Bp,
              fitInViewport: !0
            }, t),
            o = Pp._getOptimalPosition(n) || Np,
            i = parseInt(o.left),
            r = parseInt(o.top),
            s = o.name,
            a = o.config || {},
            {
              withArrow: c = !0
            } = a;
          this.top = r, this.left = i, this.position = s, this.withArrow = c;
        }
        pin(t) {
          this.unpin(), this._pinWhenIsVisibleCallback = () => {
            this.isVisible ? this._startPinning(t) : this._stopPinning();
          }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
        unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
        _startPinning(t) {
          this.attachTo(t);
          const n = Lp(t.target),
            o = t.limiter ? Lp(t.limiter) : Bp;
          this.listenTo(e.document, "scroll", (e, i) => {
            const r = i.target,
              s = n && r.contains(n),
              a = o && r.contains(o);
            !s && !a && n && o || this.attachTo(t);
          }, {
            useCapture: !0
          }), this.listenTo(e.window, "resize", () => {
            this.attachTo(t);
          });
        }
        _stopPinning() {
          this.stopListening(e.document, "scroll"), this.stopListening(e.window, "resize");
        }
      };
    let Op = Pp;
    function Lp(t) {
      return vo(t) ? t : Oo(t) ? t.commonAncestorContainer : "function" == typeof t ? Lp(t()) : null;
    }
    function zp(t = {}) {
      const {
        sideOffset: e = Op.arrowSideOffset,
        heightOffset: n = Op.arrowHeightOffset,
        stickyVerticalOffset: o = Op.stickyVerticalOffset,
        config: i
      } = t;
      return {
        northWestArrowSouthWest: (t, n) => Mp({
          top: r(t, n),
          left: t.left - e,
          name: "arrow_sw"
        }, i && {
          config: i
        }),
        northWestArrowSouthMiddleWest: (t, n) => Mp({
          top: r(t, n),
          left: t.left - .25 * n.width - e,
          name: "arrow_smw"
        }, i && {
          config: i
        }),
        northWestArrowSouth: (t, e) => Mp({
          top: r(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s"
        }, i && {
          config: i
        }),
        northWestArrowSouthMiddleEast: (t, n) => Mp({
          top: r(t, n),
          left: t.left - .75 * n.width + e,
          name: "arrow_sme"
        }, i && {
          config: i
        }),
        northWestArrowSouthEast: (t, n) => Mp({
          top: r(t, n),
          left: t.left - n.width + e,
          name: "arrow_se"
        }, i && {
          config: i
        }),
        northArrowSouthWest: (t, n) => Mp({
          top: r(t, n),
          left: t.left + t.width / 2 - e,
          name: "arrow_sw"
        }, i && {
          config: i
        }),
        northArrowSouthMiddleWest: (t, n) => Mp({
          top: r(t, n),
          left: t.left + t.width / 2 - .25 * n.width - e,
          name: "arrow_smw"
        }, i && {
          config: i
        }),
        northArrowSouth: (t, e) => Mp({
          top: r(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s"
        }, i && {
          config: i
        }),
        northArrowSouthMiddleEast: (t, n) => Mp({
          top: r(t, n),
          left: t.left + t.width / 2 - .75 * n.width + e,
          name: "arrow_sme"
        }, i && {
          config: i
        }),
        northArrowSouthEast: (t, n) => Mp({
          top: r(t, n),
          left: t.left + t.width / 2 - n.width + e,
          name: "arrow_se"
        }, i && {
          config: i
        }),
        northEastArrowSouthWest: (t, n) => Mp({
          top: r(t, n),
          left: t.right - e,
          name: "arrow_sw"
        }, i && {
          config: i
        }),
        northEastArrowSouthMiddleWest: (t, n) => Mp({
          top: r(t, n),
          left: t.right - .25 * n.width - e,
          name: "arrow_smw"
        }, i && {
          config: i
        }),
        northEastArrowSouth: (t, e) => Mp({
          top: r(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s"
        }, i && {
          config: i
        }),
        northEastArrowSouthMiddleEast: (t, n) => Mp({
          top: r(t, n),
          left: t.right - .75 * n.width + e,
          name: "arrow_sme"
        }, i && {
          config: i
        }),
        northEastArrowSouthEast: (t, n) => Mp({
          top: r(t, n),
          left: t.right - n.width + e,
          name: "arrow_se"
        }, i && {
          config: i
        }),
        southWestArrowNorthWest: t => Mp({
          top: s(t),
          left: t.left - e,
          name: "arrow_nw"
        }, i && {
          config: i
        }),
        southWestArrowNorthMiddleWest: (t, n) => Mp({
          top: s(t),
          left: t.left - .25 * n.width - e,
          name: "arrow_nmw"
        }, i && {
          config: i
        }),
        southWestArrowNorth: (t, e) => Mp({
          top: s(t),
          left: t.left - e.width / 2,
          name: "arrow_n"
        }, i && {
          config: i
        }),
        southWestArrowNorthMiddleEast: (t, n) => Mp({
          top: s(t),
          left: t.left - .75 * n.width + e,
          name: "arrow_nme"
        }, i && {
          config: i
        }),
        southWestArrowNorthEast: (t, n) => Mp({
          top: s(t),
          left: t.left - n.width + e,
          name: "arrow_ne"
        }, i && {
          config: i
        }),
        southArrowNorthWest: t => Mp({
          top: s(t),
          left: t.left + t.width / 2 - e,
          name: "arrow_nw"
        }, i && {
          config: i
        }),
        southArrowNorthMiddleWest: (t, n) => Mp({
          top: s(t),
          left: t.left + t.width / 2 - .25 * n.width - e,
          name: "arrow_nmw"
        }, i && {
          config: i
        }),
        southArrowNorth: (t, e) => Mp({
          top: s(t),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n"
        }, i && {
          config: i
        }),
        southArrowNorthMiddleEast: (t, n) => Mp({
          top: s(t),
          left: t.left + t.width / 2 - .75 * n.width + e,
          name: "arrow_nme"
        }, i && {
          config: i
        }),
        southArrowNorthEast: (t, n) => Mp({
          top: s(t),
          left: t.left + t.width / 2 - n.width + e,
          name: "arrow_ne"
        }, i && {
          config: i
        }),
        southEastArrowNorthWest: t => Mp({
          top: s(t),
          left: t.right - e,
          name: "arrow_nw"
        }, i && {
          config: i
        }),
        southEastArrowNorthMiddleWest: (t, n) => Mp({
          top: s(t),
          left: t.right - .25 * n.width - e,
          name: "arrow_nmw"
        }, i && {
          config: i
        }),
        southEastArrowNorth: (t, e) => Mp({
          top: s(t),
          left: t.right - e.width / 2,
          name: "arrow_n"
        }, i && {
          config: i
        }),
        southEastArrowNorthMiddleEast: (t, n) => Mp({
          top: s(t),
          left: t.right - .75 * n.width + e,
          name: "arrow_nme"
        }, i && {
          config: i
        }),
        southEastArrowNorthEast: (t, n) => Mp({
          top: s(t),
          left: t.right - n.width + e,
          name: "arrow_ne"
        }, i && {
          config: i
        }),
        westArrowEast: (t, e) => Mp({
          top: t.top + t.height / 2 - e.height / 2,
          left: t.left - e.width - n,
          name: "arrow_e"
        }, i && {
          config: i
        }),
        eastArrowWest: (t, e) => Mp({
          top: t.top + t.height / 2 - e.height / 2,
          left: t.right + n,
          name: "arrow_w"
        }, i && {
          config: i
        }),
        viewportStickyNorth: (t, e, n, r) => {
          const s = r || n;
          return t.getIntersection(s) ? s.height - t.height > o ? null : {
            top: s.top + o,
            left: t.left + t.width / 2 - e.width / 2,
            name: "arrowless",
            config: Mp({
              withArrow: !1
            }, i)
          } : null;
        }
      };
      function r(t, e) {
        return t.top - e.height - n;
      }
      function s(t) {
        return t.bottom + n;
      }
    }
    Op.arrowSideOffset = 25, Op.arrowHeightOffset = 10, Op.stickyVerticalOffset = 20, Op._getOptimalPosition = Jo, Op.defaultPositions = zp();
    var Rp = n(9205),
      jp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Rp.A, jp);
    Rp.A.locals;
    const Fp = "ck-tooltip",
      Vp = class extends Mo() {
        constructor(t) {
          if (super(), this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._resizeObserver = null, this._mutationObserver = null, Vp._editors.add(t), Vp._instance) return Vp._instance;
          Vp._instance = this, this.tooltipTextView = new Dr(t.locale), this.tooltipTextView.set("text", ""), this.tooltipTextView.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: this.tooltipTextView.bindTemplate.to("text")
            }]
          }), this.balloonPanelView = new Op(t.locale), this.balloonPanelView.class = Fp, this.balloonPanelView.content.add(this.tooltipTextView), this._mutationObserver = function (t) {
            const e = new MutationObserver(() => {
              t();
            });
            return {
              attach(t) {
                e.observe(t, {
                  attributes: !0,
                  attributeFilter: ["data-cke-tooltip-text", "data-cke-tooltip-position"]
                });
              },
              detach() {
                e.disconnect();
              }
            };
          }(() => {
            this._updateTooltipPosition();
          }), this._pinTooltipDebounced = wc(this._pinTooltip, 600), this._unpinTooltipDebounced = wc(this._unpinTooltip, 400), this.listenTo(e.document, "keydown", this._onKeyDown.bind(this), {
            useCapture: !0
          }), this.listenTo(e.document, "mouseenter", this._onEnterOrFocus.bind(this), {
            useCapture: !0
          }), this.listenTo(e.document, "mouseleave", this._onLeaveOrBlur.bind(this), {
            useCapture: !0
          }), this.listenTo(e.document, "focus", this._onEnterOrFocus.bind(this), {
            useCapture: !0
          }), this.listenTo(e.document, "blur", this._onLeaveOrBlur.bind(this), {
            useCapture: !0
          }), this.listenTo(e.document, "scroll", this._onScroll.bind(this), {
            useCapture: !0
          }), this._watchdogExcluded = !0;
        }
        destroy(t) {
          const e = t.ui.view && t.ui.view.body;
          Vp._editors.delete(t), this.stopListening(t.ui), e && e.has(this.balloonPanelView) && e.remove(this.balloonPanelView), Vp._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), Vp._instance = null);
        }
        static getPositioningFunctions(t) {
          const e = Vp.defaultBalloonPositions;
          return {
            s: [e.southArrowNorth, e.southArrowNorthEast, e.southArrowNorthWest],
            n: [e.northArrowSouth],
            e: [e.eastArrowWest],
            w: [e.westArrowEast],
            sw: [e.southArrowNorthEast],
            se: [e.southArrowNorthWest]
          }[t];
        }
        _onKeyDown(t, e) {
          "Escape" === e.key && this._currentElementWithTooltip && (this._unpinTooltip(), e.stopPropagation());
        }
        _onEnterOrFocus(t, {
          target: e
        }) {
          const n = Up(e);
          n ? n !== this._currentElementWithTooltip && (this._unpinTooltip(), this._pinTooltipDebounced(n, qp(n))) : "focus" === t.name && this._unpinTooltip();
        }
        _onLeaveOrBlur(t, {
          target: e,
          relatedTarget: n
        }) {
          if ("mouseleave" === t.name) {
            if (!vo(e)) return;
            const t = this.balloonPanelView.element,
              o = t && (t === n || t.contains(n)),
              i = !o && e === t;
            if (o) return void this._unpinTooltipDebounced.cancel();
            if (!i && this._currentElementWithTooltip && e !== this._currentElementWithTooltip) return;
            const r = Up(e),
              s = Up(n);
            (i || r && r !== s) && this._unpinTooltipDebounced();
          } else {
            if (this._currentElementWithTooltip && e !== this._currentElementWithTooltip) return;
            this._unpinTooltipDebounced();
          }
        }
        _onScroll(t, {
          target: e
        }) {
          this._currentElementWithTooltip && (e.contains(this.balloonPanelView.element) && e.contains(this._currentElementWithTooltip) || this._unpinTooltip());
        }
        _pinTooltip(t, {
          text: e,
          position: n,
          cssClass: o
        }) {
          this._unpinTooltip();
          const i = Wi(Vp._editors.values()).ui.view.body;
          i.has(this.balloonPanelView) || i.add(this.balloonPanelView), this.tooltipTextView.text = e, this.balloonPanelView.pin({
            target: t,
            positions: Vp.getPositioningFunctions(n)
          }), this._resizeObserver = new qo(t, () => {
            Qo(t) || this._unpinTooltip();
          }), this._mutationObserver.attach(t), this.balloonPanelView.class = [Fp, o].filter(t => t).join(" ");
          for (const t of Vp._editors) this.listenTo(t.ui, "update", this._updateTooltipPosition.bind(this), {
            priority: "low"
          });
          this._currentElementWithTooltip = t, this._currentTooltipPosition = n;
        }
        _unpinTooltip() {
          this._unpinTooltipDebounced.cancel(), this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
          for (const t of Vp._editors) this.stopListening(t.ui, "update");
          this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this.tooltipTextView.text = "", this._resizeObserver && this._resizeObserver.destroy(), this._mutationObserver.detach();
        }
        _updateTooltipPosition() {
          if (!this._currentElementWithTooltip) return;
          const t = qp(this._currentElementWithTooltip);
          Qo(this._currentElementWithTooltip) && t.text ? this.balloonPanelView.pin({
            target: this._currentElementWithTooltip,
            positions: Vp.getPositioningFunctions(t.position)
          }) : this._unpinTooltip();
        }
      };
    let Hp = Vp;
    function Up(t) {
      return vo(t) ? t.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
    }
    function qp(t) {
      return {
        text: t.dataset.ckeTooltipText,
        position: t.dataset.ckeTooltipPosition || "s",
        cssClass: t.dataset.ckeTooltipClass || ""
      };
    }
    Hp.defaultBalloonPositions = zp({
      heightOffset: 5,
      sideOffset: 13
    }), Hp._editors = new Set(), Hp._instance = null;
    const Gp = function (t, e, n) {
      var o = !0,
        i = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return R(n) && (o = "leading" in n ? !!n.leading : o, i = "trailing" in n ? !!n.trailing : i), wc(t, e, {
        leading: o,
        maxWait: e,
        trailing: i
      });
    };
    var Wp = Object.defineProperty,
      Kp = Object.getOwnPropertySymbols,
      $p = Object.prototype.hasOwnProperty,
      Yp = Object.prototype.propertyIsEnumerable,
      Qp = (t, e, n) => e in t ? Wp(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      Zp = (t, e) => {
        for (var n in e || (e = {})) $p.call(e, n) && Qp(t, n, e[n]);
        if (Kp) for (var n of Kp(e)) Yp.call(e, n) && Qp(t, n, e[n]);
        return t;
      };
    const Jp = 50,
      Xp = 350,
      tf = "Powered by";
    class ef extends Mo() {
      constructor(t) {
        super(), this.editor = t, this._balloonView = null, this._lastFocusedEditableElement = null, this._showBalloonThrottled = Gp(this._showBalloon.bind(this), 50, {
          leading: !0
        }), t.on("ready", this._handleEditorReady.bind(this));
      }
      destroy() {
        const t = this._balloonView;
        t && (t.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
      }
      _handleEditorReady() {
        const t = this.editor;
        (!!t.config.get("ui.poweredBy.forceVisible") || "VALID" !== function (t) {
          function e(t) {
            return t.length >= 40 && t.length <= 255 ? "VALID" : "INVALID";
          }
          if (!t) return "INVALID";
          let n = "";
          try {
            n = atob(t);
          } catch (t) {
            return "INVALID";
          }
          const o = n.split("-"),
            i = o[0],
            r = o[1];
          if (!r) return e(t);
          try {
            atob(r);
          } catch (n) {
            try {
              if (atob(i), !atob(i).length) return e(t);
            } catch (n) {
              return e(t);
            }
          }
          if (i.length < 40 || i.length > 255) return "INVALID";
          let s = "";
          try {
            atob(i), s = atob(r);
          } catch (t) {
            return "INVALID";
          }
          if (8 !== s.length) return "INVALID";
          const a = Number(s.substring(0, 4)),
            c = Number(s.substring(4, 6)) - 1,
            l = Number(s.substring(6, 8)),
            d = new Date(a, c, l);
          return d < x || isNaN(Number(d)) ? "INVALID" : "VALID";
        }(t.config.get("licenseKey"))) && t.ui.view && (t.ui.focusTracker.on("change:isFocused", (t, e, n) => {
          this._updateLastFocusedEditableElement(), n ? this._showBalloon() : this._hideBalloon();
        }), t.ui.focusTracker.on("change:focusedElement", (t, e, n) => {
          this._updateLastFocusedEditableElement(), n && this._showBalloon();
        }), t.ui.on("update", () => {
          this._showBalloonThrottled();
        }));
      }
      _createBalloonView() {
        const t = this.editor,
          e = this._balloonView = new Op(),
          n = rf(t),
          o = new nf(t.locale, n.label);
        e.content.add(o), e.set({
          class: "ck-powered-by-balloon"
        }), t.ui.view.body.add(e), t.ui.focusTracker.add(e.element), this._balloonView = e;
      }
      _showBalloon() {
        if (!this._lastFocusedEditableElement) return;
        const t = function (t, e) {
          const n = rf(t),
            o = "right" === n.side ? function (t, e) {
              return of(t, e, (t, n) => t.left + t.width - n.width - e.horizontalOffset);
            }(e, n) : function (t, e) {
              return of(t, e, t => t.left + e.horizontalOffset);
            }(e, n);
          return {
            target: e,
            positions: [o]
          };
        }(this.editor, this._lastFocusedEditableElement);
        t && (this._balloonView || this._createBalloonView(), this._balloonView.pin(t));
      }
      _hideBalloon() {
        this._balloonView && this._balloonView.unpin();
      }
      _updateLastFocusedEditableElement() {
        const t = this.editor,
          e = t.ui.focusTracker.isFocused,
          n = t.ui.focusTracker.focusedElement;
        if (!e || !n) return void (this._lastFocusedEditableElement = null);
        const o = Array.from(t.ui.getEditableElementsNames()).map(e => t.ui.getEditableElement(e));
        o.includes(n) ? this._lastFocusedEditableElement = n : this._lastFocusedEditableElement = o[0];
      }
    }
    class nf extends Dr {
      constructor(t, e) {
        super(t);
        const n = new Dg(),
          o = this.bindTemplate;
        n.set({
          content: '<svg xmlns="http://www.w3.org/2000/svg" width="53" height="10" viewBox="0 0 53 10"><path fill="#1C2331" d="M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z"/><path fill="#AFE229" d="M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z"/><path fill="#771BFF" d="m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z"/></svg>\n',
          isColorInherited: !1
        }), n.extendTemplate({
          attributes: {
            style: {
              width: "53px",
              height: "10px"
            }
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-powered-by"],
            "aria-hidden": !0
          },
          children: [{
            tag: "a",
            attributes: {
              href: "https://ckeditor.com/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
              target: "_blank",
              tabindex: "-1"
            },
            children: [...(e ? [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-powered-by__label"]
              },
              children: [e]
            }] : []), n],
            on: {
              dragstart: o.to(t => t.preventDefault())
            }
          }]
        });
      }
    }
    function of(t, e, n) {
      return (o, i) => {
        const r = new Ro(t);
        if (r.width < Xp || r.height < Jp) return null;
        let s;
        s = "inside" === e.position ? r.bottom - i.height : r.bottom - i.height / 2, s -= e.verticalOffset;
        const a = n(r, i),
          c = o.clone().moveTo(a, s).getIntersection(i.clone().moveTo(a, s)).getVisible();
        return !c || c.getArea() < i.getArea() ? null : {
          top: s,
          left: a,
          name: `position_${e.position}-side_${e.side}`,
          config: {
            withArrow: !1
          }
        };
      };
    }
    function rf(t) {
      const e = t.config.get("ui.poweredBy"),
        n = e && e.position || "border";
      return Zp({
        position: n,
        label: tf,
        verticalOffset: "inside" === n ? 5 : 0,
        horizontalOffset: 5,
        side: "ltr" === t.locale.contentLanguageDirection ? "right" : "left"
      }, e);
    }
    var sf = n(1801),
      af = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(sf.A, af);
    sf.A.locals;
    const cf = {
      POLITE: "polite",
      ASSERTIVE: "assertive"
    };
    class lf {
      constructor(t) {
        this.editor = t, t.once("ready", () => {
          for (const t of Object.values(cf)) this.announce("", t);
        });
      }
      announce(t, e = cf.POLITE) {
        const n = this.editor;
        if (!n.ui.view) return;
        this.view || (this.view = new df(n.locale), n.ui.view.body.add(this.view));
        const {
          politeness: o,
          isUnsafeHTML: i
        } = "string" == typeof e ? {
          politeness: e
        } : e;
        let r = this.view.regionViews.find(t => t.politeness === o);
        r || (r = new uf(n, o), this.view.regionViews.add(r)), r.announce({
          announcement: t,
          isUnsafeHTML: i
        });
      }
    }
    class df extends Dr {
      constructor(t) {
        super(t), this.regionViews = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-aria-live-announcer"]
          },
          children: this.regionViews
        });
      }
    }
    class uf extends Dr {
      constructor(t, e) {
        super(t.locale), this.setTemplate({
          tag: "div",
          attributes: {
            role: "region",
            "aria-live": e,
            "aria-relevant": "additions"
          },
          children: [{
            tag: "ul",
            attributes: {
              class: ["ck", "ck-aria-live-region-list"]
            }
          }]
        }), t.on("destroy", () => {
          null !== this._pruneAnnouncementsInterval && (clearInterval(this._pruneAnnouncementsInterval), this._pruneAnnouncementsInterval = null);
        }), this.politeness = e, this._domConverter = t.data.htmlProcessor.domConverter, this._pruneAnnouncementsInterval = setInterval(() => {
          this.element && this._listElement.firstChild && this._listElement.firstChild.remove();
        }, 5e3);
      }
      announce({
        announcement: t,
        isUnsafeHTML: e
      }) {
        if (!t.trim().length) return;
        const n = document.createElement("li");
        e ? this._domConverter.setContentOf(n, t) : n.innerText = t, this._listElement.appendChild(n);
      }
      get _listElement() {
        return this.element.querySelector("ul");
      }
    }
    var hf = Object.defineProperty,
      gf = Object.getOwnPropertySymbols,
      mf = Object.prototype.hasOwnProperty,
      pf = Object.prototype.propertyIsEnumerable,
      ff = (t, e, n) => e in t ? hf(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class kf extends G() {
      constructor(t) {
        super(), this.isReady = !1, this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [];
        const e = t.editing.view;
        this.editor = t, this.componentFactory = new ep(t), this.focusTracker = new Ki(), this.tooltipManager = new Hp(t), this.poweredBy = new ef(t), this.ariaLiveAnnouncer = new lf(t), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this.once("ready", () => {
          this.isReady = !0;
        }), this.listenTo(e.document, "layoutChanged", this.update.bind(this)), this.listenTo(e, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this)), this._initFocusTracking();
      }
      get element() {
        return null;
      }
      update() {
        this.fire("update");
      }
      destroy() {
        this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy();
        for (const t of this._editableElementsMap.values()) t.ckeditorInstance = null, this.editor.keystrokes.stopListening(t);
        this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [];
      }
      setEditableElement(t, e) {
        this._editableElementsMap.set(t, e), e.ckeditorInstance || (e.ckeditorInstance = this.editor), this.focusTracker.add(e);
        const n = () => {
          this.editor.editing.view.getDomRoot(t) || this.editor.keystrokes.listenTo(e);
        };
        this.isReady ? n() : this.once("ready", n);
      }
      removeEditableElement(t) {
        const e = this._editableElementsMap.get(t);
        e && (this._editableElementsMap.delete(t), this.editor.keystrokes.stopListening(e), this.focusTracker.remove(e), e.ckeditorInstance = null);
      }
      getEditableElement(t = "main") {
        return this._editableElementsMap.get(t);
      }
      getEditableElementsNames() {
        return this._editableElementsMap.keys();
      }
      addToolbar(t, e = {}) {
        t.isRendered ? (this.focusTracker.add(t.element), this.editor.keystrokes.listenTo(t.element)) : t.once("render", () => {
          this.focusTracker.add(t.element), this.editor.keystrokes.listenTo(t.element);
        }), this._focusableToolbarDefinitions.push({
          toolbarView: t,
          options: e
        });
      }
      get _editableElements() {
        return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
          editorUI: this
        }), this._editableElementsMap;
      }
      _readViewportOffsetFromConfig() {
        const t = this.editor,
          e = t.config.get("ui.viewportOffset");
        if (e) return e;
        const n = t.config.get("toolbar.viewportTopOffset");
        return n ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
          top: n
        }) : {
          top: 0
        };
      }
      _initFocusTracking() {
        const t = this.editor,
          e = t.editing.view;
        let n, o;
        t.keystrokes.set("Alt+F10", (t, i) => {
          const r = this.focusTracker.focusedElement;
          Array.from(this._editableElementsMap.values()).includes(r) && !Array.from(e.domRoots.values()).includes(r) && (n = r);
          const s = this._getCurrentFocusedToolbarDefinition();
          s && o || (o = this._getFocusableCandidateToolbarDefinitions());
          for (let t = 0; t < o.length; t++) {
            const t = o.shift();
            if (o.push(t), t !== s && this._focusFocusableCandidateToolbar(t)) {
              s && s.options.afterBlur && s.options.afterBlur();
              break;
            }
          }
          i();
        }), t.keystrokes.set("Esc", (e, o) => {
          const i = this._getCurrentFocusedToolbarDefinition();
          i && (n ? (n.focus(), n = null) : t.editing.view.focus(), i.options.afterBlur && i.options.afterBlur(), o());
        });
      }
      _getFocusableCandidateToolbarDefinitions() {
        const t = [];
        for (const e of this._focusableToolbarDefinitions) {
          const {
            toolbarView: n,
            options: o
          } = e;
          (Qo(n.element) || o.beforeFocus) && t.push(e);
        }
        return t.sort((t, e) => bf(t) - bf(e)), t;
      }
      _getCurrentFocusedToolbarDefinition() {
        for (const t of this._focusableToolbarDefinitions) if (t.toolbarView.element && t.toolbarView.element.contains(this.focusTracker.focusedElement)) return t;
        return null;
      }
      _focusFocusableCandidateToolbar(t) {
        const {
          toolbarView: e,
          options: {
            beforeFocus: n
          }
        } = t;
        return n && n(), !!Qo(e.element) && (e.focus(), !0);
      }
      _handleScrollToTheSelection(t, e) {
        const n = ((t, e) => {
          for (var n in e || (e = {})) mf.call(e, n) && ff(t, n, e[n]);
          if (gf) for (var n of gf(e)) pf.call(e, n) && ff(t, n, e[n]);
          return t;
        })({
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }, this.viewportOffset);
        e.viewportOffset.top += n.top, e.viewportOffset.bottom += n.bottom, e.viewportOffset.left += n.left, e.viewportOffset.right += n.right;
      }
    }
    function bf(t) {
      const {
        toolbarView: e,
        options: n
      } = t;
      let o = 10;
      return Qo(e.element) && o--, n.isContextual && o--, o;
    }
    var wf = n(1185),
      Af = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(wf.A, Af);
    wf.A.locals;
    class _f extends Dr {
      constructor(t) {
        super(t), this.body = new vg(t);
      }
      render() {
        super.render(), this.body.attachToDom();
      }
      destroy() {
        return this.body.detachFromDom(), super.destroy();
      }
    }
    class Cf extends _f {
      constructor(t) {
        super(t), this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: t.uiLanguageDirection,
            lang: t.uiLanguage,
            "aria-labelledby": this._voiceLabelView.id
          },
          children: [this._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: this.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: this.main
          }]
        });
      }
      _createVoiceLabel() {
        const t = this.t,
          e = new fg();
        return e.text = t("Rich Text Editor"), e.extendTemplate({
          attributes: {
            class: "ck-voice-label"
          }
        }), e;
      }
    }
    class vf extends Dr {
      constructor(t, e, n) {
        super(t), this.name = null, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: t.contentLanguage,
            dir: t.contentLanguageDirection
          }
        }), this.set("isFocused", !1), this._editableElement = n, this._hasExternalElement = !!this._editableElement, this._editingView = e;
      }
      render() {
        super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
      }
      destroy() {
        this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
      }
      get hasExternalElement() {
        return this._hasExternalElement;
      }
      _updateIsFocusedClasses() {
        const t = this._editingView;
        function e(e) {
          t.change(n => {
            const o = t.document.getRoot(e.name);
            n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", o), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", o);
          });
        }
        t.isRenderingInProgress ? function n(o) {
          t.once("change:isRenderingInProgress", (t, i, r) => {
            r ? n(o) : e(o);
          });
        }(this) : e(this);
      }
    }
    class yf extends vf {
      constructor(t, e, n, o = {}) {
        super(t, e, n);
        const i = t.t;
        this.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        }), this._generateLabel = o.label || (() => i("Editor editing area: %0", this.name));
      }
      render() {
        super.render();
        const t = this._editingView;
        t.change(e => {
          const n = t.document.getRoot(this.name);
          e.setAttribute("aria-label", this._generateLabel(this), n);
        });
      }
    }
    class xf extends Hr {
      static get pluginName() {
        return "Notification";
      }
      init() {
        this.on("show:warning", (t, e) => {
          window.alert(e.message);
        }, {
          priority: "lowest"
        });
      }
      showSuccess(t, e = {}) {
        this._showNotification({
          message: t,
          type: "success",
          namespace: e.namespace,
          title: e.title
        });
      }
      showInfo(t, e = {}) {
        this._showNotification({
          message: t,
          type: "info",
          namespace: e.namespace,
          title: e.title
        });
      }
      showWarning(t, e = {}) {
        this._showNotification({
          message: t,
          type: "warning",
          namespace: e.namespace,
          title: e.title
        });
      }
      _showNotification(t) {
        const e = t.namespace ? `show:${t.type}:${t.namespace}` : `show:${t.type}`;
        this.fire(e, {
          message: t.message,
          type: t.type,
          title: t.title || ""
        });
      }
    }
    class Ef extends G() {
      constructor(t, e) {
        super(), e && oc(this, e), t && this.set(t);
      }
    }
    var Df = n(991),
      If = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Df.A, If);
    Df.A.locals;
    var Tf = n(5380),
      Mf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Tf.A, Mf);
    Tf.A.locals;
    const Sf = Wo("px");
    class Bf extends Br {
      constructor(t) {
        super(t), this._viewToStack = new Map(), this._idToStack = new Map(), this._view = null, this._rotatorView = null, this._fakePanelsView = null, this.positionLimiter = () => {
          const t = this.editor.editing.view,
            e = t.document.selection.editableElement;
          return e ? t.domConverter.mapViewToDom(e.root) : null;
        }, this.set("visibleView", null), this.set("_numberOfStacks", 0), this.set("_singleViewMode", !1);
      }
      static get pluginName() {
        return "ContextualBalloon";
      }
      destroy() {
        super.destroy(), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
      }
      get view() {
        return this._view || this._createPanelView(), this._view;
      }
      hasView(t) {
        return Array.from(this._viewToStack.keys()).includes(t);
      }
      add(t) {
        if (this._view || this._createPanelView(), this.hasView(t.view)) throw new w("contextualballoon-add-view-exist", [this, t]);
        const e = t.stackId || "main";
        if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));
        const n = this._idToStack.get(e);
        t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
      }
      remove(t) {
        if (!this.hasView(t)) throw new w("contextualballoon-remove-view-not-exist", [this, t]);
        const e = this._viewToStack.get(t);
        this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
      }
      updatePosition(t) {
        t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
      }
      showStack(t) {
        this.visibleStack = t;
        const e = this._idToStack.get(t);
        if (!e) throw new w("contextualballoon-showstack-stack-not-exist", this);
        this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
      }
      _createPanelView() {
        this._view = new Op(this.editor.locale), this.editor.ui.view.body.add(this._view), this.editor.ui.focusTracker.add(this._view.element), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
      }
      get _visibleStack() {
        return this._viewToStack.get(this.visibleView);
      }
      _getStackId(t) {
        return Array.from(this._idToStack.entries()).find(e => e[1] === t)[0];
      }
      _showNextStack() {
        const t = Array.from(this._idToStack.values());
        let e = t.indexOf(this._visibleStack) + 1;
        t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
      }
      _showPrevStack() {
        const t = Array.from(this._idToStack.values());
        let e = t.indexOf(this._visibleStack) - 1;
        t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
      }
      _createRotatorView() {
        const t = new Nf(this.editor.locale),
          e = this.editor.locale.t;
        return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (t, e) => !e && t > 1), t.on("change:isNavigationVisible", () => this.updatePosition(), {
          priority: "low"
        }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (t, n) => {
          if (n < 2) return "";
          const o = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
          return e("%0 of %1", [o, n]);
        }), t.buttonNextView.on("execute", () => {
          t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
        }), t.buttonPrevView.on("execute", () => {
          t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
        }), t;
      }
      _createFakePanelsView() {
        const t = new Pf(this.editor.locale, this.view);
        return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (t, e) => !e && t >= 2 ? Math.min(t - 1, 2) : 0), t.listenTo(this.view, "change:top", () => t.updatePosition()), t.listenTo(this.view, "change:left", () => t.updatePosition()), this.editor.ui.view.body.add(t), t;
      }
      _showView({
        view: t,
        balloonClassName: e = "",
        withArrow: n = !0,
        singleViewMode: o = !1
      }) {
        this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), o && (this._singleViewMode = !0);
      }
      _getBalloonPosition() {
        let t = Array.from(this._visibleStack.values()).pop().position;
        return t && (t.limiter || (t = Object.assign({}, t, {
          limiter: this.positionLimiter
        })), t = Object.assign({}, t, {
          viewportOffsetConfig: this.editor.ui.viewportOffset
        })), t;
      }
    }
    class Nf extends Dr {
      constructor(t) {
        super(t);
        const e = t.t,
          n = this.bindTemplate;
        this.set("isNavigationVisible", !0), this.focusTracker = new Ki(), this.buttonPrevView = this._createButtonView(e("Previous"), gg.previousArrow), this.buttonNextView = this._createButtonView(e("Next"), gg.nextArrow), this.content = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", t => t ? "" : "ck-hidden")]
            },
            children: [this.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, this.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: this.content
          }]
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy();
      }
      showView(t) {
        this.hideView(), this.content.add(t);
      }
      hideView() {
        this.content.clear();
      }
      _createButtonView(t, e) {
        const n = new Sg(this.locale);
        return n.set({
          label: t,
          icon: e,
          tooltip: !0
        }), n;
      }
    }
    class Pf extends Dr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = e, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", t => t ? "" : "ck-hidden")],
            style: {
              top: n.to("top", Sf),
              left: n.to("left", Sf),
              width: n.to("width", Sf),
              height: n.to("height", Sf)
            }
          },
          children: this.content
        }), this.on("change:numberOfPanels", (t, e, n, o) => {
          n > o ? this._addPanels(n - o) : this._removePanels(o - n), this.updatePosition();
        });
      }
      _addPanels(t) {
        for (; t--;) {
          const t = new Dr();
          t.setTemplate({
            tag: "div"
          }), this.content.add(t), this.registerChild(t);
        }
      }
      _removePanels(t) {
        for (; t--;) {
          const t = this.content.last;
          this.content.remove(t), this.deregisterChild(t), t.destroy();
        }
      }
      updatePosition() {
        if (this.numberOfPanels) {
          const {
              top: t,
              left: e
            } = this._balloonPanelView,
            {
              width: n,
              height: o
            } = new Ro(this._balloonPanelView.element);
          Object.assign(this, {
            top: t,
            left: e,
            width: n,
            height: o
          });
        }
      }
    }
    var Of = n(8298),
      Lf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Of.A, Lf);
    Of.A.locals;
    const zf = Wo("px");
    class Rf extends Dr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isActive", !1), this.set("isSticky", !1), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheBottomOfLimiter", !1), this.set("_stickyTopOffset", null), this.set("_stickyBottomOffset", null), this.content = this.createCollection(), this._contentPanelPlaceholder = new nr({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", t => t ? "block" : "none"),
              height: e.to("isSticky", t => t ? zf(this._contentPanelRect.height) : null)
            }
          }
        }).render(), this.contentPanelElement = new nr({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", t => t ? zf(this._contentPanelPlaceholder.getBoundingClientRect().width) : null),
              top: e.to("_stickyTopOffset", t => t ? zf(t) : t),
              bottom: e.to("_stickyBottomOffset", t => t ? zf(t) : t),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: this.content
        }).render(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [this._contentPanelPlaceholder, this.contentPanelElement]
        });
      }
      render() {
        super.render(), this.checkIfShouldBeSticky(), this.listenTo(e.document, "scroll", () => {
          this.checkIfShouldBeSticky();
        }, {
          useCapture: !0
        }), this.listenTo(this, "change:isActive", () => {
          this.checkIfShouldBeSticky();
        });
      }
      checkIfShouldBeSticky() {
        if (!this.limiterElement || !this.isActive) return void this._unstick();
        const t = new Ro(this.limiterElement);
        let n = t.getVisible();
        if (n) {
          const t = new Ro(e.window);
          t.top += this.viewportTopOffset, t.height -= this.viewportTopOffset, n = n.getIntersection(t);
        }
        if (n && t.top < n.top) {
          const e = n.top;
          if (e + this._contentPanelRect.height + this.limiterBottomOffset > n.bottom) {
            const e = Math.max(t.bottom - n.bottom, 0) + this.limiterBottomOffset;
            t.bottom - e > t.top + this._contentPanelRect.height ? this._stickToBottomOfLimiter(e) : this._unstick();
          } else this._contentPanelRect.height + this.limiterBottomOffset < t.height ? this._stickToTopOfAncestors(e) : this._unstick();
        } else this._unstick();
      }
      _stickToTopOfAncestors(t) {
        this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = t, this._stickyBottomOffset = null, this._marginLeft = zf(-e.window.scrollX);
      }
      _stickToBottomOfLimiter(t) {
        this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !0, this._stickyTopOffset = null, this._stickyBottomOffset = t, this._marginLeft = zf(-e.window.scrollX);
      }
      _unstick() {
        this.isSticky = !1, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
      }
      get _contentPanelRect() {
        return new Ro(this.contentPanelElement);
      }
    }
    class jf extends Gg {
      constructor(t, e) {
        const n = t.t,
          o = Object.assign({}, {
            showResetButton: !0,
            showIcon: !0,
            creator: qm
          }, e);
        super(t, o.creator), this.label = e.label, this._viewConfig = o, this._viewConfig.showIcon && (this.iconView = new Dg(), this.iconView.content = gg.loupe, this.fieldWrapperChildren.add(this.iconView, 0), this.extendTemplate({
          attributes: {
            class: "ck-search__query_with-icon"
          }
        })), this._viewConfig.showResetButton && (this.resetButtonView = new Sg(t), this.resetButtonView.set({
          label: n("Clear"),
          icon: gg.cancel,
          class: "ck-search__reset",
          isVisible: !1,
          tooltip: !0
        }), this.resetButtonView.on("execute", () => {
          this.reset(), this.focus(), this.fire("reset");
        }), this.resetButtonView.bind("isVisible").to(this.fieldView, "isEmpty", t => !t), this.fieldWrapperChildren.add(this.resetButtonView), this.extendTemplate({
          attributes: {
            class: "ck-search__query_with-reset"
          }
        }));
      }
      reset() {
        this.fieldView.reset(), this._viewConfig.showResetButton && (this.resetButtonView.isVisible = !1);
      }
    }
    class Ff extends Dr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.set({
          isVisible: !1,
          primaryText: "",
          secondaryText: ""
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search__info", t.if("isVisible", "ck-hidden", t => !t)],
            tabindex: -1
          },
          children: [{
            tag: "span",
            children: [{
              text: [t.to("primaryText")]
            }]
          }, {
            tag: "span",
            children: [{
              text: [t.to("secondaryText")]
            }]
          }]
        });
      }
      focus() {
        this.element.focus();
      }
    }
    class Vf extends Dr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.focusTracker = new Ki(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search__results"],
            tabindex: -1
          },
          children: this.children
        }), this._focusCycler = new rm({
          focusables: this.children,
          focusTracker: this.focusTracker
        });
      }
      render() {
        super.render();
        for (const t of this.children) this.focusTracker.add(t.element);
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusFirst() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
    }
    var Hf = /[\\^$.*+?()[\]{}|]/g,
      Uf = RegExp(Hf.source);
    const qf = function (t) {
      return (t = ys(t)) && Uf.test(t) ? t.replace(Hf, "\\$&") : t;
    };
    var Gf = n(8107),
      Wf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Gf.A, Wf);
    Gf.A.locals;
    var Kf = Object.defineProperty,
      $f = Object.getOwnPropertySymbols,
      Yf = Object.prototype.hasOwnProperty,
      Qf = Object.prototype.propertyIsEnumerable,
      Zf = (t, e, n) => e in t ? Kf(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class Jf extends Dr {
      constructor(t, e) {
        super(t), this._config = e, this.filteredView = e.filteredView, this.queryView = this._createSearchTextQueryView(), this.focusTracker = new Ki(), this.keystrokes = new $i(), this.resultsView = new Vf(t), this.children = this.createCollection(), this.focusableChildren = this.createCollection([this.queryView, this.resultsView]), this.set("isEnabled", !0), this.set("resultsCount", 0), this.set("totalItemsCount", 0), e.infoView && e.infoView.instance ? this.infoView = e.infoView.instance : (this.infoView = new Ff(), this._enableDefaultInfoViewBehavior(), this.on("render", () => {
          this.search("");
        })), this.resultsView.children.addMany([this.infoView, this.filteredView]), this.focusCycler = new rm({
          focusables: this.focusableChildren,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.on("search", (t, {
          resultsCount: e,
          totalItemsCount: n
        }) => {
          this.resultsCount = e, this.totalItemsCount = n;
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search", e.class || null],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.children.addMany([this.queryView, this.resultsView]);
        const t = t => t.stopPropagation();
        for (const t of this.focusableChildren) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      focus() {
        this.queryView.focus();
      }
      reset() {
        this.queryView.reset(), this.search("");
      }
      search(t) {
        const e = t ? new RegExp(qf(t), "ig") : null,
          n = this.filteredView.filter(e);
        this.fire("search", ((t, e) => {
          for (var n in e || (e = {})) Yf.call(e, n) && Zf(t, n, e[n]);
          if ($f) for (var n of $f(e)) Qf.call(e, n) && Zf(t, n, e[n]);
          return t;
        })({
          query: t
        }, n));
      }
      _createSearchTextQueryView() {
        const t = new jf(this.locale, this._config.queryView);
        return this.listenTo(t.fieldView, "input", () => {
          this.search(t.fieldView.element.value);
        }), t.on("reset", () => this.reset()), t.bind("isEnabled").to(this), t;
      }
      _enableDefaultInfoViewBehavior() {
        const t = this.locale.t,
          e = this.infoView;
        function n(t, {
          query: e,
          resultsCount: n,
          totalItemsCount: o
        }) {
          return "function" == typeof t ? t(e, n, o) : t;
        }
        this.on("search", (o, i) => {
          if (i.resultsCount) e.set({
            isVisible: !1
          });else {
            const o = this._config.infoView && this._config.infoView.text;
            let r, s;
            i.totalItemsCount ? o && o.notFound ? (r = o.notFound.primary, s = o.notFound.secondary) : (r = t("No results found"), s = "") : o && o.noSearchableItems ? (r = o.noSearchableItems.primary, s = o.noSearchableItems.secondary) : (r = t("No searchable items"), s = ""), e.set({
              primaryText: n(r, i),
              secondaryText: n(s, i),
              isVisible: !0
            });
          }
        });
      }
    }
    var Xf = n(5727),
      tk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Xf.A, tk);
    Xf.A.locals;
    const ek = class extends Jf {
      constructor(t, n) {
        super(t, n), this._config = n;
        const o = Wo("px");
        this.extendTemplate({
          attributes: {
            class: ["ck-autocomplete"]
          }
        });
        const i = this.resultsView.bindTemplate;
        this.resultsView.set("isVisible", !1), this.resultsView.set("_position", "s"), this.resultsView.set("_width", 0), this.resultsView.extendTemplate({
          attributes: {
            class: [i.if("isVisible", "ck-hidden", t => !t), i.to("_position", t => `ck-search__results_${t}`)],
            style: {
              width: i.to("_width", o)
            }
          }
        }), this.focusTracker.on("change:isFocused", (t, e, o) => {
          this._updateResultsVisibility(), o ? this.resultsView.element.scrollTop = 0 : n.resetOnBlur && this.queryView.reset();
        }), this.on("search", () => {
          this._updateResultsVisibility(), this._updateResultsViewWidthAndPosition();
        }), this.keystrokes.set("esc", (t, e) => {
          this.resultsView.isVisible && (this.queryView.focus(), this.resultsView.isVisible = !1, e());
        }), this.listenTo(e.document, "scroll", () => {
          this._updateResultsViewWidthAndPosition();
        }), this.on("change:isEnabled", () => {
          this._updateResultsVisibility();
        }), this.filteredView.on("execute", (t, {
          value: e
        }) => {
          this.focus(), this.reset(), this.queryView.fieldView.value = this.queryView.fieldView.element.value = e, this.resultsView.isVisible = !1;
        }), this.resultsView.on("change:isVisible", () => {
          this._updateResultsViewWidthAndPosition();
        });
      }
      _updateResultsViewWidthAndPosition() {
        if (!this.resultsView.isVisible) return;
        this.resultsView._width = new Ro(this.queryView.fieldView.element).width;
        const t = ek._getOptimalPosition({
          element: this.resultsView.element,
          target: this.queryView.element,
          fitInViewport: !0,
          positions: ek.defaultResultsPositions
        });
        this.resultsView._position = t ? t.name : "s";
      }
      _updateResultsVisibility() {
        const t = void 0 === this._config.queryMinChars ? 0 : this._config.queryMinChars,
          e = this.queryView.fieldView.element.value.length;
        this.resultsView.isVisible = this.focusTracker.isFocused && this.isEnabled && e >= t;
      }
    };
    let nk = ek;
    nk.defaultResultsPositions = [t => ({
      top: t.bottom,
      left: t.left,
      name: "s"
    }), (t, e) => ({
      top: t.top - e.height,
      left: t.left,
      name: "n"
    })], nk._getOptimalPosition = Jo;
    ok = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var ok;
    var ik = /[&<>"']/g;
    RegExp(ik.source);
    var rk = n(9529),
      sk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(rk.A, sk);
    rk.A.locals;
    var ak = n(109),
      ck = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(ak.A, ck);
    ak.A.locals;
    Wo("px");
    var lk = n(2710),
      dk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(lk.A, dk);
    lk.A.locals, Wo("px");
    Wo("px");
    var uk = n(3344),
      hk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(uk.A, hk);
    uk.A.locals;
    class gk extends Sg {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set({
          withText: !0,
          role: "menuitem"
        }), this.arrowView = this._createArrowView(), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__button"],
            "aria-haspopup": !0,
            "aria-expanded": this.bindTemplate.to("isOn", t => String(t)),
            "data-cke-tooltip-disabled": e.to("isOn")
          },
          on: {
            mouseenter: e.to("mouseenter")
          }
        });
      }
      render() {
        super.render(), this.children.add(this.arrowView);
      }
      _createArrowView() {
        const t = new Dg();
        return t.content = zg, t.extendTemplate({
          attributes: {
            class: "ck-menu-bar__menu__button__arrow"
          }
        }), t;
      }
    }
    var mk = n(9481),
      pk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(mk.A, pk);
    mk.A.locals;
    class fk extends ym {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item"]
          },
          on: {
            mouseenter: n.to("mouseenter")
          }
        }), this.delegate("mouseenter").to(e);
      }
    }
    var kk = Object.defineProperty,
      bk = Object.getOwnPropertySymbols,
      wk = Object.prototype.hasOwnProperty,
      Ak = Object.prototype.propertyIsEnumerable,
      _k = (t, e, n) => e in t ? kk(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      Ck = (t, e) => {
        for (var n in e || (e = {})) wk.call(e, n) && _k(t, n, e[n]);
        if (bk) for (var n of bk(e)) Ak.call(e, n) && _k(t, n, e[n]);
        return t;
      };
    const vk = {
        toggleMenusAndFocusItemsOnHover(t) {
          t.on("menu:mouseenter", e => {
            if (t.isOpen) {
              for (const n of t.menus) {
                const t = e.path[0],
                  o = t instanceof fk && t.children.first === n;
                n.isOpen = (e.path.includes(n) || o) && n.isEnabled;
              }
              e.source.focus();
            }
          });
        },
        focusCycleMenusOnArrows(t) {
          const e = "rtl" === t.locale.uiLanguageDirection;
          function n(e, n) {
            const o = t.children.getIndex(e),
              i = e.isOpen,
              r = t.children.length,
              s = t.children.get((o + r + n) % r);
            e.isOpen = !1, i && (s.isOpen = !0), s.buttonView.focus();
          }
          t.on("menu:arrowright", t => {
            n(t.source, e ? -1 : 1);
          }), t.on("menu:arrowleft", t => {
            n(t.source, e ? 1 : -1);
          });
        },
        closeMenusWhenTheBarCloses(t) {
          t.on("change:isOpen", () => {
            t.isOpen || t.menus.forEach(t => {
              t.isOpen = !1;
            });
          });
        },
        closeMenuWhenAnotherOnTheSameLevelOpens(t) {
          t.on("menu:change:isOpen", (e, n, o) => {
            o && t.menus.filter(t => e.source.parentMenuView === t.parentMenuView && e.source !== t && t.isOpen).forEach(t => {
              t.isOpen = !1;
            });
          });
        },
        closeOnClickOutside(t) {
          Ir({
            emitter: t,
            activator: () => t.isOpen,
            callback: () => t.close(),
            contextElements: () => t.children.map(t => t.element)
          });
        }
      },
      yk = {
        openAndFocusPanelOnArrowDownKey(t) {
          t.keystrokes.set("arrowdown", (e, n) => {
            t.focusTracker.focusedElement === t.buttonView.element && (t.isOpen || (t.isOpen = !0), t.panelView.focus(), n());
          });
        },
        openOnArrowRightKey(t) {
          const e = "rtl" === t.locale.uiLanguageDirection ? "arrowleft" : "arrowright";
          t.keystrokes.set(e, (e, n) => {
            t.focusTracker.focusedElement === t.buttonView.element && t.isEnabled && (t.isOpen || (t.isOpen = !0), t.panelView.focus(), n());
          });
        },
        openOnButtonClick(t) {
          t.buttonView.on("execute", () => {
            t.isOpen = !0, t.panelView.focus();
          });
        },
        toggleOnButtonClick(t) {
          t.buttonView.on("execute", () => {
            t.isOpen = !t.isOpen, t.isOpen && t.panelView.focus();
          });
        },
        closeOnArrowLeftKey(t) {
          const e = "rtl" === t.locale.uiLanguageDirection ? "arrowright" : "arrowleft";
          t.keystrokes.set(e, (e, n) => {
            t.isOpen && (t.isOpen = !1, t.focus(), n());
          });
        },
        closeOnEscKey(t) {
          t.keystrokes.set("esc", (e, n) => {
            t.isOpen && (t.isOpen = !1, t.focus(), n());
          });
        },
        closeOnParentClose(t) {
          t.parentMenuView.on("change:isOpen", (e, n, o) => {
            o || e.source !== t.parentMenuView || (t.isOpen = !1);
          });
        }
      },
      xk = {
        southEast: t => ({
          top: t.bottom,
          left: t.left,
          name: "se"
        }),
        southWest: (t, e) => ({
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        }),
        northEast: (t, e) => ({
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        }),
        northWest: (t, e) => ({
          top: t.top - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        }),
        eastSouth: t => ({
          top: t.top,
          left: t.right - 5,
          name: "es"
        }),
        eastNorth: (t, e) => ({
          top: t.top - e.height,
          left: t.right - 5,
          name: "en"
        }),
        westSouth: (t, e) => ({
          top: t.top,
          left: t.left - e.width + 5,
          name: "ws"
        }),
        westNorth: (t, e) => ({
          top: t.top - e.height,
          left: t.left - e.width + 5,
          name: "wn"
        })
      },
      Ek = [{
        menuId: "file",
        label: "File",
        groups: [{
          groupId: "export",
          items: ["menuBar:exportPdf", "menuBar:exportWord"]
        }, {
          groupId: "import",
          items: ["menuBar:importWord"]
        }, {
          groupId: "revisionHistory",
          items: ["menuBar:revisionHistory"]
        }]
      }, {
        menuId: "edit",
        label: "Edit",
        groups: [{
          groupId: "undo",
          items: ["menuBar:undo", "menuBar:redo"]
        }, {
          groupId: "selectAll",
          items: ["menuBar:selectAll"]
        }, {
          groupId: "findAndReplace",
          items: ["menuBar:findAndReplace"]
        }]
      }, {
        menuId: "view",
        label: "View",
        groups: [{
          groupId: "sourceEditing",
          items: ["menuBar:sourceEditing"]
        }, {
          groupId: "showBlocks",
          items: ["menuBar:showBlocks"]
        }, {
          groupId: "restrictedEditingException",
          items: ["menuBar:restrictedEditingException"]
        }]
      }, {
        menuId: "insert",
        label: "Insert",
        groups: [{
          groupId: "insertMainWidgets",
          items: ["menuBar:uploadImage", "menuBar:ckbox", "menuBar:ckfinder", "menuBar:insertTable"]
        }, {
          groupId: "insertInline",
          items: ["menuBar:link", "menuBar:comment"]
        }, {
          groupId: "insertMinorWidgets",
          items: ["menuBar:insertTemplate", "menuBar:blockQuote", "menuBar:codeBlock", "menuBar:htmlEmbed"]
        }, {
          groupId: "insertStructureWidgets",
          items: ["menuBar:horizontalLine", "menuBar:pageBreak", "menuBar:tableOfContents"]
        }, {
          groupId: "restrictedEditing",
          items: ["menuBar:restrictedEditing"]
        }]
      }, {
        menuId: "format",
        label: "Format",
        groups: [{
          groupId: "textAndFont",
          items: [{
            menuId: "text",
            label: "Text",
            groups: [{
              groupId: "basicStyles",
              items: ["menuBar:bold", "menuBar:italic", "menuBar:underline", "menuBar:strikethrough", "menuBar:superscript", "menuBar:subscript", "menuBar:code"]
            }, {
              groupId: "textPartLanguage",
              items: ["menuBar:textPartLanguage"]
            }]
          }, {
            menuId: "font",
            label: "Font",
            groups: [{
              groupId: "fontProperties",
              items: ["menuBar:fontSize", "menuBar:fontFamily"]
            }, {
              groupId: "fontColors",
              items: ["menuBar:fontColor", "menuBar:fontBackgroundColor"]
            }, {
              groupId: "highlight",
              items: ["menuBar:highlight"]
            }]
          }, "menuBar:heading"]
        }, {
          groupId: "list",
          items: ["menuBar:bulletedList", "menuBar:numberedList", "menuBar:todoList"]
        }, {
          groupId: "indent",
          items: ["menuBar:alignment", "menuBar:indent", "menuBar:outdent"]
        }, {
          groupId: "caseChange",
          items: ["menuBar:caseChange"]
        }, {
          groupId: "removeFormat",
          items: ["menuBar:removeFormat"]
        }]
      }, {
        menuId: "tools",
        label: "Tools",
        groups: [{
          groupId: "aiTools",
          items: ["menuBar:aiAssistant", "menuBar:aiCommands"]
        }, {
          groupId: "tools",
          items: ["menuBar:trackChanges", "menuBar:commentsArchive"]
        }]
      }, {
        menuId: "help",
        label: "Help",
        groups: [{
          groupId: "help",
          items: ["menuBar:accessibilityHelp"]
        }]
      }];
    function Dk({
      normalizedConfig: t,
      locale: e,
      componentFactory: n
    }) {
      const o = Jc(t);
      return function (t, e) {
        const n = e.removeItems,
          o = [];
        e.items = e.items.filter(({
          menuId: t
        }) => !n.includes(t) || (o.push(t), !1)), Sk(e.items, t => {
          t.groups = t.groups.filter(({
            groupId: t
          }) => !n.includes(t) || (o.push(t), !1));
          for (const e of t.groups) e.items = e.items.filter(t => {
            const e = Lk(t);
            return !n.includes(e) || (o.push(e), !1);
          });
        });
        for (const e of n) o.includes(e) || A("menu-bar-item-could-not-be-removed", {
          menuBarConfig: t,
          itemName: e
        });
      }(t, o), function (t, e) {
        const n = e.addItems,
          o = [];
        for (const t of n) {
          const n = Pk(t.position),
            i = Ok(t.position);
          if (Bk(t)) {
            if (i) {
              const r = e.items.findIndex(t => t.menuId === i);
              if (-1 != r) "before" === n ? (e.items.splice(r, 0, t.menu), o.push(t)) : "after" === n && (e.items.splice(r + 1, 0, t.menu), o.push(t));else {
                Ik(e, t.menu, i, n) && o.push(t);
              }
            } else "start" === n ? (e.items.unshift(t.menu), o.push(t)) : "end" === n && (e.items.push(t.menu), o.push(t));
          } else if (Nk(t)) Sk(e.items, e => {
            if (e.menuId === i) "start" === n ? (e.groups.unshift(t.group), o.push(t)) : "end" === n && (e.groups.push(t.group), o.push(t));else {
              const r = e.groups.findIndex(t => t.groupId === i);
              -1 !== r && ("before" === n ? (e.groups.splice(r, 0, t.group), o.push(t)) : "after" === n && (e.groups.splice(r + 1, 0, t.group), o.push(t)));
            }
          });else {
            Ik(e, t.item, i, n) && o.push(t);
          }
        }
        for (const e of n) o.includes(e) || A("menu-bar-item-could-not-be-added", {
          menuBarConfig: t,
          addedItemConfig: e
        });
      }(t, o), function (t, e, n) {
        Sk(e.items, o => {
          for (const i of o.groups) i.items = i.items.filter(i => {
            const r = "string" == typeof i && !n.has(i);
            return r && !e.isUsingDefaultConfig && A("menu-bar-item-unavailable", {
              menuBarConfig: t,
              parentMenuConfig: Jc(o),
              componentName: i
            }), !r;
          });
        });
      }(t, o, n), Tk(t, o), function (t, e) {
        const n = e.t,
          o = {
            File: n({
              string: "File",
              id: "MENU_BAR_MENU_FILE"
            }),
            Edit: n({
              string: "Edit",
              id: "MENU_BAR_MENU_EDIT"
            }),
            View: n({
              string: "View",
              id: "MENU_BAR_MENU_VIEW"
            }),
            Insert: n({
              string: "Insert",
              id: "MENU_BAR_MENU_INSERT"
            }),
            Format: n({
              string: "Format",
              id: "MENU_BAR_MENU_FORMAT"
            }),
            Tools: n({
              string: "Tools",
              id: "MENU_BAR_MENU_TOOLS"
            }),
            Help: n({
              string: "Help",
              id: "MENU_BAR_MENU_HELP"
            }),
            Text: n({
              string: "Text",
              id: "MENU_BAR_MENU_TEXT"
            }),
            Font: n({
              string: "Font",
              id: "MENU_BAR_MENU_FONT"
            })
          };
        Sk(t.items, t => {
          t.label in o && (t.label = o[t.label]);
        });
      }(o, e), o;
    }
    function Ik(t, e, n, o) {
      let i = !1;
      return Sk(t.items, t => {
        for (const {
          groupId: r,
          items: s
        } of t.groups) {
          if (i) return;
          if (r === n) "start" === o ? (s.unshift(e), i = !0) : "end" === o && (s.push(e), i = !0);else {
            const t = s.findIndex(t => Lk(t) === n);
            -1 !== t && ("before" === o ? (s.splice(t, 0, e), i = !0) : "after" === o && (s.splice(t + 1, 0, e), i = !0));
          }
        }
      }), i;
    }
    function Tk(t, e) {
      const n = e.isUsingDefaultConfig;
      let o = !1;
      e.items = e.items.filter(e => !!e.groups.length || (Mk(t, e, n), !1)), e.items.length ? (Sk(e.items, e => {
        e.groups = e.groups.filter(t => !!t.items.length || (o = !0, !1));
        for (const i of e.groups) i.items = i.items.filter(e => !(zk(e) && !e.groups.length) || (Mk(t, e, n), o = !0, !1));
      }), o && Tk(t, e)) : Mk(t, t, n);
    }
    function Mk(t, e, n) {
      n || A("menu-bar-menu-empty", {
        menuBarConfig: t,
        emptyMenuConfig: e
      });
    }
    function Sk(t, e) {
      if (Array.isArray(t)) for (const e of t) n(e);
      function n(t) {
        e(t);
        for (const e of t.groups) for (const t of e.items) zk(t) && n(t);
      }
    }
    function Bk(t) {
      return "object" == typeof t && "menu" in t;
    }
    function Nk(t) {
      return "object" == typeof t && "group" in t;
    }
    function Pk(t) {
      return t.startsWith("start") ? "start" : t.startsWith("end") ? "end" : t.startsWith("after") ? "after" : "before";
    }
    function Ok(t) {
      const e = t.match(/^[^:]+:(.+)/);
      return e ? e[1] : null;
    }
    function Lk(t) {
      return "string" == typeof t ? t : t.menuId;
    }
    function zk(t) {
      return "object" == typeof t && "menuId" in t;
    }
    function Rk(t, e) {
      const n = e.element;
      t.ui.focusTracker.add(n), t.keystrokes.listenTo(n);
      const o = function (t) {
        let e;
        return e = "items" in t && t.items ? Ck({
          items: t.items,
          removeItems: [],
          addItems: [],
          isVisible: !0,
          isUsingDefaultConfig: !1
        }, t) : Ck({
          items: Jc(Ek),
          addItems: [],
          removeItems: [],
          isVisible: !0,
          isUsingDefaultConfig: !0
        }, t), e;
      }(t.config.get("menuBar") || {});
      e.fillFromConfig(o, t.ui.componentFactory), t.keystrokes.set("Esc", (e, o) => {
        n.contains(t.ui.focusTracker.focusedElement) && (t.editing.view.focus(), o());
      }), t.keystrokes.set("Alt+F9", (o, i) => {
        n.contains(t.ui.focusTracker.focusedElement) || (e.focus(), i());
      });
    }
    var jk = n(9108),
      Fk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(jk.A, Fk);
    jk.A.locals;
    class Vk extends Dr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-menu-bar__menu__panel", e.to("position", t => `ck-menu-bar__menu__panel_position_${t}`), e.if("isVisible", "ck-hidden", t => !t)],
            tabindex: "-1"
          },
          children: this.children,
          on: {
            selectstart: e.to(t => {
              "input" !== t.target.tagName.toLocaleLowerCase() && t.preventDefault();
            })
          }
        });
      }
      focus(t = 1) {
        this.children.length && (1 === t ? this.children.first.focus() : this.children.last.focus());
      }
    }
    var Hk = n(4),
      Uk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Hk.A, Uk);
    Hk.A.locals;
    const qk = class extends Dr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.buttonView = new gk(t), this.buttonView.delegate("mouseenter").to(this), this.buttonView.bind("isOn", "isEnabled").to(this, "isOpen", "isEnabled"), this.panelView = new Vk(t), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new $i(), this.focusTracker = new Ki(), this.set("isOpen", !1), this.set("isEnabled", !0), this.set("panelPosition", "w"), this.set("class", void 0), this.set("parentMenuView", null), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-menu-bar__menu", e.to("class"), e.if("isEnabled", "ck-disabled", t => !t), e.if("parentMenuView", "ck-menu-bar__menu_top-level", t => !t)]
          },
          children: [this.buttonView, this.panelView]
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.keystrokes.listenTo(this.element), yk.closeOnEscKey(this), this._repositionPanelOnOpen();
      }
      _attachBehaviors() {
        this.parentMenuView ? (yk.openOnButtonClick(this), yk.openOnArrowRightKey(this), yk.closeOnArrowLeftKey(this), yk.closeOnParentClose(this)) : (this._propagateArrowKeystrokeEvents(), yk.openAndFocusPanelOnArrowDownKey(this), yk.toggleOnButtonClick(this));
      }
      _propagateArrowKeystrokeEvents() {
        this.keystrokes.set("arrowright", (t, e) => {
          this.fire("arrowright"), e();
        }), this.keystrokes.set("arrowleft", (t, e) => {
          this.fire("arrowleft"), e();
        });
      }
      _repositionPanelOnOpen() {
        this.on("change:isOpen", (t, e, n) => {
          if (!n) return;
          const o = qk._getOptimalPosition({
            element: this.panelView.element,
            target: this.buttonView.element,
            fitInViewport: !0,
            positions: this._panelPositions
          });
          this.panelView.position = o ? o.name : this._panelPositions[0].name;
        });
      }
      focus() {
        this.buttonView.focus();
      }
      get _panelPositions() {
        const {
          southEast: t,
          southWest: e,
          northEast: n,
          northWest: o,
          westSouth: i,
          eastSouth: r,
          westNorth: s,
          eastNorth: a
        } = xk;
        return "ltr" === this.locale.uiLanguageDirection ? this.parentMenuView ? [r, a, i, s] : [t, e, n, o] : this.parentMenuView ? [i, s, r, a] : [e, t, o, n];
      }
    };
    let Gk = qk;
    Gk._getOptimalPosition = Jo;
    class Wk extends Tm {
      constructor(t) {
        super(t), this.role = "menu";
      }
    }
    var Kk = n(977),
      $k = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Kk.A, $k);
    Kk.A.locals;
    class Yk extends Sg {
      constructor(t) {
        super(t), this.set({
          withText: !0,
          withKeystroke: !0,
          tooltip: !1,
          role: "menuitem"
        }), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item__button"]
          }
        });
      }
    }
    class Qk extends Og {
      constructor(t) {
        super(t), this.set({
          withText: !0,
          withKeystroke: !0,
          tooltip: !1,
          role: "menuitem"
        }), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item__button"]
          }
        });
      }
    }
    var Zk = n(497),
      Jk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Zk.A, Jk);
    Zk.A.locals;
    const Xk = ["mouseenter", "arrowleft", "arrowright", "change:isOpen"];
    class tb extends Dr {
      constructor(t) {
        super(t), this.menus = [];
        const e = t.t;
        this.set("isOpen", !1), this._setupIsOpenUpdater(), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-menu-bar"],
            "aria-label": e("Editor menu bar"),
            role: "menubar"
          },
          children: this.children
        });
      }
      fillFromConfig(t, e) {
        const n = Dk({
          normalizedConfig: t,
          locale: this.locale,
          componentFactory: e
        }).items.map(t => this._createMenu({
          componentFactory: e,
          menuDefinition: t
        }));
        this.children.addMany(n);
      }
      render() {
        super.render(), vk.toggleMenusAndFocusItemsOnHover(this), vk.closeMenusWhenTheBarCloses(this), vk.closeMenuWhenAnotherOnTheSameLevelOpens(this), vk.focusCycleMenusOnArrows(this), vk.closeOnClickOutside(this);
      }
      focus() {
        this.children.first && this.children.first.focus();
      }
      close() {
        for (const t of this.children) t.isOpen = !1;
      }
      registerMenu(t, e = null) {
        e ? (t.delegate(...Xk).to(e), t.parentMenuView = e) : t.delegate(...Xk).to(this, t => "menu:" + t), t._attachBehaviors(), this.menus.push(t);
      }
      _createMenu({
        componentFactory: t,
        menuDefinition: e,
        parentMenuView: n
      }) {
        const o = this.locale,
          i = new Gk(o);
        return this.registerMenu(i, n), i.buttonView.set({
          label: e.label
        }), i.once("change:isOpen", () => {
          const n = new Wk(o);
          n.ariaLabel = e.label, i.panelView.children.add(n), n.items.addMany(this._createMenuItems({
            menuDefinition: e,
            parentMenuView: i,
            componentFactory: t
          }));
        }), i;
      }
      _createMenuItems({
        menuDefinition: t,
        parentMenuView: e,
        componentFactory: n
      }) {
        const o = this.locale,
          i = [];
        for (const r of t.groups) {
          for (const t of r.items) {
            const r = new fk(o, e);
            if (R(t)) r.children.add(this._createMenu({
              componentFactory: n,
              menuDefinition: t,
              parentMenuView: e
            }));else {
              const o = this._createMenuItemContentFromFactory({
                componentName: t,
                componentFactory: n,
                parentMenuView: e
              });
              if (!o) continue;
              r.children.add(o);
            }
            i.push(r);
          }
          r !== t.groups[t.groups.length - 1] && i.push(new xm(o));
        }
        return i;
      }
      _createMenuItemContentFromFactory({
        componentName: t,
        parentMenuView: e,
        componentFactory: n
      }) {
        const o = n.create(t);
        return o instanceof Gk || o instanceof Yk || o instanceof Qk ? (this._registerMenuTree(o, e), o.on("execute", () => {
          this.close();
        }), o) : (A("menu-bar-component-unsupported", {
          componentName: t,
          componentView: o
        }), null);
      }
      _registerMenuTree(t, e) {
        if (!(t instanceof Gk)) return void t.delegate("mouseenter").to(e);
        this.registerMenu(t, e);
        const n = t.panelView.children.filter(t => t instanceof Wk)[0];
        if (!n) return void t.delegate("mouseenter").to(e);
        const o = n.items.filter(t => t instanceof ym);
        for (const e of o) this._registerMenuTree(e.children.get(0), t);
      }
      _setupIsOpenUpdater() {
        let t;
        this.on("menu:change:isOpen", (e, n, o) => {
          clearTimeout(t), o ? this.isOpen = !0 : t = setTimeout(() => {
            this.isOpen = Array.from(this.children).some(t => t.isOpen);
          }, 0);
        });
      }
    }
    class eb extends kf {
      constructor(t, e) {
        super(t), this.view = e, this._toolbarConfig = fm(t.config.get("toolbar")), this._elementReplacer = new Z(), this.listenTo(t.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
      }
      get element() {
        return this.view.element;
      }
      init(t) {
        const e = this.editor,
          n = this.view,
          o = e.editing.view,
          i = n.editable,
          r = o.document.getRoot();
        i.name = r.rootName, n.render();
        const s = i.element;
        this.setEditableElement(i.name, s), n.editable.bind("isFocused").to(this.focusTracker), o.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), n.menuBarView && Rk(e, n.menuBarView), this._initDialogPluginIntegration(), this.fire("ready");
      }
      destroy() {
        super.destroy();
        const t = this.view,
          e = this.editor.editing.view;
        this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy();
      }
      _initToolbar() {
        const t = this.view;
        t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", ({
          top: t
        }) => t || 0), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(t.toolbar);
      }
      _initPlaceholder() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document.getRoot(),
          o = t.sourceElement;
        let i;
        const r = t.config.get("placeholder");
        r && (i = "string" == typeof r ? r : r[this.view.editable.name]), !i && o && "textarea" === o.tagName.toLowerCase() && (i = o.getAttribute("placeholder")), i && (n.placeholder = i), $r({
          view: e,
          element: n,
          isDirectHost: !1,
          keepOnFocus: !0
        });
      }
      _handleScrollToTheSelectionWithStickyPanel(t, e, n) {
        const o = this.view.stickyPanel;
        if (o.isSticky) {
          const t = new Ro(o.element).height;
          e.viewportOffset.top += t;
        } else {
          const t = () => {
            this.editor.editing.view.scrollToTheSelection(n);
          };
          this.listenTo(o, "change:isSticky", t), setTimeout(() => {
            this.stopListening(o, "change:isSticky", t);
          }, 20);
        }
      }
      _initDialogPluginIntegration() {
        if (!this.editor.plugins.has("Dialog")) return;
        const t = this.view.stickyPanel,
          e = this.editor.plugins.get("Dialog");
        e.on("show", () => {
          const n = e.view;
          n.on("moveTo", (e, o) => {
            if (!t.isSticky || n.wasMoved) return;
            const i = new Ro(t.contentPanelElement);
            o[1] < i.bottom + _p.defaultOffset && (o[1] = i.bottom + _p.defaultOffset);
          }, {
            priority: "high"
          });
        }, {
          priority: "low"
        });
      }
    }
    var nb = n(7388),
      ob = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(nb.A, ob);
    nb.A.locals;
    class ib extends Cf {
      constructor(t, e, n = {}) {
        super(t), this.stickyPanel = new Rf(t), this.toolbar = new Am(t, {
          shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
        }), n.useMenuBar && (this.menuBarView = new tb(t)), this.editable = new yf(t, e);
      }
      render() {
        super.render(), this.menuBarView ? this.stickyPanel.content.addMany([this.menuBarView, this.toolbar]) : this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
      }
    }
    class rb {
      constructor(t) {
        if (this.crashes = [], this.state = "initializing", this._now = Date.now, this.crashes = [], this._crashNumberLimit = "number" == typeof t.crashNumberLimit ? t.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = "number" == typeof t.minimumNonErrorTimePeriod ? t.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = t => {
          const e = "error" in t ? t.error : t.reason;
          e instanceof Error && this._handleError(e, t);
        }, this._listeners = {}, !this._restart) throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
      }
      destroy() {
        this._stopErrorHandling(), this._listeners = {};
      }
      on(t, e) {
        this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(e);
      }
      off(t, e) {
        this._listeners[t] = this._listeners[t].filter(t => t !== e);
      }
      _fire(t, ...e) {
        const n = this._listeners[t] || [];
        for (const t of n) t.apply(this, [null, ...e]);
      }
      _startErrorHandling() {
        window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
      }
      _stopErrorHandling() {
        window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
      }
      _handleError(t, e) {
        if (this._shouldReactToError(t)) {
          this.crashes.push({
            message: t.message,
            stack: t.stack,
            filename: e instanceof ErrorEvent ? e.filename : void 0,
            lineno: e instanceof ErrorEvent ? e.lineno : void 0,
            colno: e instanceof ErrorEvent ? e.colno : void 0,
            date: this._now()
          });
          const n = this._shouldRestart();
          this.state = "crashed", this._fire("stateChange"), this._fire("error", {
            error: t,
            causesRestart: n
          }), n ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
        }
      }
      _shouldReactToError(t) {
        return t.is && t.is("CKEditorError") && void 0 !== t.context && null !== t.context && "ready" === this.state && this._isErrorComingFromThisItem(t);
      }
      _shouldRestart() {
        if (this.crashes.length <= this._crashNumberLimit) return !0;
        return (this.crashes[this.crashes.length - 1].date - this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
      }
    }
    function sb(t, e = new Set()) {
      const n = [t],
        o = new Set();
      let i = 0;
      for (; n.length > i;) {
        const t = n[i++];
        if (!o.has(t) && ab(t) && !e.has(t)) if (o.add(t), Symbol.iterator in t) try {
          for (const e of t) n.push(e);
        } catch (t) {} else for (const e in t) "defaultValue" !== e && n.push(t[e]);
      }
      return o;
    }
    function ab(t) {
      const e = Object.prototype.toString.call(t),
        n = typeof t;
      return !("number" === n || "boolean" === n || "string" === n || "symbol" === n || "function" === n || "[object Date]" === e || "[object RegExp]" === e || "[object Module]" === e || null == t || t._watchdogExcluded || t instanceof EventTarget || t instanceof Event);
    }
    function cb(t, e, n = new Set()) {
      if (t === e && "object" == typeof (o = t) && null !== o) return !0;
      var o;
      const i = sb(t, n),
        r = sb(e, n);
      for (const t of i) if (r.has(t)) return !0;
      return !1;
    }
    var lb = Object.defineProperty,
      db = Object.defineProperties,
      ub = Object.getOwnPropertyDescriptors,
      hb = Object.getOwnPropertySymbols,
      gb = Object.prototype.hasOwnProperty,
      mb = Object.prototype.propertyIsEnumerable,
      pb = (t, e, n) => e in t ? lb(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      fb = (t, e) => {
        for (var n in e || (e = {})) gb.call(e, n) && pb(t, n, e[n]);
        if (hb) for (var n of hb(e)) mb.call(e, n) && pb(t, n, e[n]);
        return t;
      };
    class kb extends rb {
      constructor(t, e = {}) {
        super(e), this._editor = null, this._lifecyclePromise = null, this._initUsingData = !0, this._editables = {}, this._throttledSave = Gp(this._save.bind(this), "number" == typeof e.saveInterval ? e.saveInterval : 5e3), t && (this._creator = (e, n) => t.create(e, n)), this._destructor = t => t.destroy();
      }
      get editor() {
        return this._editor;
      }
      get _item() {
        return this._editor;
      }
      setCreator(t) {
        this._creator = t;
      }
      setDestructor(t) {
        this._destructor = t;
      }
      _restart() {
        return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch(t => {
          console.error("An error happened during the editor destroying.", t);
        }).then(() => {
          const t = {},
            e = [],
            n = this._config.rootsAttributes || {},
            o = {};
          for (const [i, r] of Object.entries(this._data.roots)) r.isLoaded ? (t[i] = "", o[i] = n[i] || {}) : e.push(i);
          const i = (r = fb({}, this._config), s = {
            extraPlugins: this._config.extraPlugins || [],
            lazyRoots: e,
            rootsAttributes: o,
            _watchdogInitialData: this._data
          }, db(r, ub(s)));
          var r, s;
          return delete i.initialData, i.extraPlugins.push(bb), this._initUsingData ? this.create(t, i, i.context) : vo(this._elementOrData) ? this.create(this._elementOrData, i, i.context) : this.create(this._editables, i, i.context);
        }).then(() => {
          this._fire("restart");
        });
      }
      create(t = this._elementOrData, e = this._config, n) {
        return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (super._startErrorHandling(), this._elementOrData = t, this._initUsingData = "string" == typeof t || Object.keys(t).length > 0 && "string" == typeof Object.values(t)[0], this._config = this._cloneEditorConfiguration(e) || {}, this._config.context = n, this._creator(t, this._config))).then(t => {
          this._editor = t, t.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = t.model.document.version, this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this.state = "ready", this._fire("stateChange");
        }).finally(() => {
          this._lifecyclePromise = null;
        }), this._lifecyclePromise;
      }
      destroy() {
        return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy())).finally(() => {
          this._lifecyclePromise = null;
        }), this._lifecyclePromise;
      }
      _destroy() {
        return Promise.resolve().then(() => {
          this._stopErrorHandling(), this._throttledSave.cancel();
          const t = this._editor;
          return this._editor = null, t.model.document.off("change:data", this._throttledSave), this._destructor(t);
        });
      }
      _save() {
        const t = this._editor.model.document.version;
        try {
          this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = t;
        } catch (t) {
          console.error(t, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
        }
      }
      _setExcludedProperties(t) {
        this._excludedProps = t;
      }
      _getData() {
        const t = this._editor,
          e = t.model.document.roots.filter(t => t.isAttached() && "$graveyard" != t.rootName),
          {
            plugins: n
          } = t,
          o = n.has("CommentsRepository") && n.get("CommentsRepository"),
          i = n.has("TrackChanges") && n.get("TrackChanges"),
          r = {
            roots: {},
            markers: {},
            commentThreads: JSON.stringify([]),
            suggestions: JSON.stringify([])
          };
        e.forEach(t => {
          r.roots[t.rootName] = {
            content: JSON.stringify(Array.from(t.getChildren())),
            attributes: JSON.stringify(Array.from(t.getAttributes())),
            isLoaded: t._isLoaded
          };
        });
        for (const e of t.model.markers) e._affectsData && (r.markers[e.name] = {
          rangeJSON: e.getRange().toJSON(),
          usingOperation: e._managedUsingOperations,
          affectsData: e._affectsData
        });
        return o && (r.commentThreads = JSON.stringify(o.getCommentThreads({
          toJSON: !0,
          skipNotAttached: !0
        }))), i && (r.suggestions = JSON.stringify(i.getSuggestions({
          toJSON: !0,
          skipNotAttached: !0
        }))), r;
      }
      _getEditables() {
        const t = {};
        for (const e of this.editor.model.document.getRootNames()) {
          const n = this.editor.ui.getEditableElement(e);
          n && (t[e] = n);
        }
        return t;
      }
      _isErrorComingFromThisItem(t) {
        return cb(this._editor, t.context, this._excludedProps);
      }
      _cloneEditorConfiguration(t) {
        return Co(t, (t, e) => vo(t) || "context" === e ? t : void 0);
      }
    }
    class bb {
      constructor(t) {
        this.editor = t, this._data = t.config.get("_watchdogInitialData");
      }
      init() {
        this.editor.data.on("init", t => {
          t.stop(), this.editor.model.enqueueChange({
            isUndoable: !1
          }, t => {
            this._restoreCollaborationData(), this._restoreEditorData(t);
          }), this.editor.data.fire("ready");
        }, {
          priority: 999
        });
      }
      _createNode(t, e) {
        if ("name" in e) {
          const n = t.createElement(e.name, e.attributes);
          if (e.children) for (const o of e.children) n._appendChild(this._createNode(t, o));
          return n;
        }
        return t.createText(e.data, e.attributes);
      }
      _restoreEditorData(t) {
        const e = this.editor;
        Object.entries(this._data.roots).forEach(([n, {
          content: o,
          attributes: i
        }]) => {
          const r = JSON.parse(o),
            s = JSON.parse(i),
            a = e.model.document.getRoot(n);
          for (const [e, n] of s) t.setAttribute(e, n, a);
          for (const e of r) {
            const n = this._createNode(t, e);
            t.insert(n, a, "end");
          }
        }), Object.entries(this._data.markers).forEach(([n, o]) => {
          const {
              document: i
            } = e.model,
            r = o,
            {
              rangeJSON: {
                start: s,
                end: a
              }
            } = r,
            c = ((t, e) => {
              var n = {};
              for (var o in t) gb.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
              if (null != t && hb) for (var o of hb(t)) e.indexOf(o) < 0 && mb.call(t, o) && (n[o] = t[o]);
              return n;
            })(r, ["rangeJSON"]),
            l = i.getRoot(s.root),
            d = t.createPositionFromPath(l, s.path, s.stickiness),
            u = t.createPositionFromPath(l, a.path, a.stickiness),
            h = t.createRange(d, u);
          t.addMarker(n, fb({
            range: h
          }, c));
        });
      }
      _restoreCollaborationData() {
        const t = JSON.parse(this._data.commentThreads),
          e = JSON.parse(this._data.suggestions);
        t.forEach(t => {
          const e = this.editor.config.get("collaboration.channelId"),
            n = this.editor.plugins.get("CommentsRepository");
          if (n.hasCommentThread(t.threadId)) {
            n.getCommentThread(t.threadId).remove();
          }
          n.addCommentThread(fb({
            channelId: e
          }, t));
        }), e.forEach(t => {
          const e = this.editor.plugins.get("TrackChangesEditing");
          if (e.hasSuggestion(t.id)) {
            e.getSuggestion(t.id).attributes = t.attributes;
          } else e.addSuggestionData(t);
        });
      }
    }
    const wb = Symbol("MainQueueId");
    class Ab {
      constructor() {
        this._onEmptyCallbacks = [], this._queues = new Map(), this._activeActions = 0;
      }
      onEmpty(t) {
        this._onEmptyCallbacks.push(t);
      }
      enqueue(t, e) {
        const n = t === wb;
        this._activeActions++, this._queues.get(t) || this._queues.set(t, Promise.resolve());
        const o = (n ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(wb), this._queues.get(t)])).then(e),
          i = o.catch(() => {});
        return this._queues.set(t, i), o.finally(() => {
          this._activeActions--, this._queues.get(t) === i && 0 === this._activeActions && this._onEmptyCallbacks.forEach(t => t());
        });
      }
    }
    function _b(t) {
      return Array.isArray(t) ? t : [t];
    }
    class Cb extends ug(dg) {
      constructor(t, e = {}) {
        if (!vb(t) && void 0 !== e.initialData) throw new w("editor-create-initial-data", null);
        super(e), this.config.define("menuBar.isVisible", !1), void 0 === this.config.get("initialData") && this.config.set("initialData", function (t) {
          return vb(t) ? (e = t, e instanceof HTMLTextAreaElement ? e.value : e.innerHTML) : t;
          var e;
        }(t)), vb(t) && (this.sourceElement = t), this.model.document.createRoot();
        const n = !this.config.get("toolbar.shouldNotGroupWhenFull"),
          o = this.config.get("menuBar"),
          i = new ib(this.locale, this.editing.view, {
            shouldToolbarGroupWhenFull: n,
            useMenuBar: o.isVisible
          });
        this.ui = new eb(this, i), function (t) {
          if (!Ft(t.updateSourceElement)) throw new w("attachtoform-missing-elementapi-interface", t);
          const e = t.sourceElement;
          if (function (t) {
            return !!t && "textarea" === t.tagName.toLowerCase();
          }(e) && e.form) {
            let n;
            const o = e.form,
              i = () => t.updateSourceElement();
            Ft(o.submit) && (n = o.submit, o.submit = () => {
              i(), n.apply(o);
            }), o.addEventListener("submit", i), t.on("destroy", () => {
              o.removeEventListener("submit", i), n && (o.submit = n);
            });
          }
        }(this);
      }
      destroy() {
        return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
      }
      static create(t, e = {}) {
        return new Promise(n => {
          const o = new this(t, e);
          n(o.initPlugins().then(() => o.ui.init(vb(t) ? t : null)).then(() => o.data.init(o.config.get("initialData"))).then(() => o.fire("ready")).then(() => o));
        });
      }
    }
    function vb(t) {
      return vo(t);
    }
    Cb.Context = Vr, Cb.EditorWatchdog = kb, Cb.ContextWatchdog = class extends rb {
      constructor(t, e = {}) {
        super(e), this._watchdogs = new Map(), this._context = null, this._contextProps = new Set(), this._actionQueues = new Ab(), this._watchdogConfig = e, this._creator = e => t.create(e), this._destructor = t => t.destroy(), this._actionQueues.onEmpty(() => {
          "initializing" === this.state && (this.state = "ready", this._fire("stateChange"));
        });
      }
      setCreator(t) {
        this._creator = t;
      }
      setDestructor(t) {
        this._destructor = t;
      }
      get context() {
        return this._context;
      }
      create(t = {}) {
        return this._actionQueues.enqueue(wb, () => (this._contextConfig = t, this._create()));
      }
      getItem(t) {
        return this._getWatchdog(t)._item;
      }
      getItemState(t) {
        return this._getWatchdog(t).state;
      }
      add(t) {
        const e = _b(t);
        return Promise.all(e.map(t => this._actionQueues.enqueue(t.id, () => {
          if ("destroyed" === this.state) throw new Error("Cannot add items to destroyed watchdog.");
          if (!this._context) throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
          let e;
          if (this._watchdogs.has(t.id)) throw new Error(`Item with the given id is already added: '${t.id}'.`);
          if ("editor" === t.type) return e = new kb(null, this._watchdogConfig), e.setCreator(t.creator), e._setExcludedProperties(this._contextProps), t.destructor && e.setDestructor(t.destructor), this._watchdogs.set(t.id, e), e.on("error", (n, {
            error: o,
            causesRestart: i
          }) => {
            this._fire("itemError", {
              itemId: t.id,
              error: o
            }), i && this._actionQueues.enqueue(t.id, () => new Promise(n => {
              const o = () => {
                e.off("restart", o), this._fire("itemRestart", {
                  itemId: t.id
                }), n();
              };
              e.on("restart", o);
            }));
          }), e.create(t.sourceElementOrData, t.config, this._context);
          throw new Error(`Not supported item type: '${t.type}'.`);
        })));
      }
      remove(t) {
        const e = _b(t);
        return Promise.all(e.map(t => this._actionQueues.enqueue(t, () => {
          const e = this._getWatchdog(t);
          return this._watchdogs.delete(t), e.destroy();
        })));
      }
      destroy() {
        return this._actionQueues.enqueue(wb, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
      }
      _restart() {
        return this._actionQueues.enqueue(wb, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch(t => {
          console.error("An error happened during destroying the context or items.", t);
        }).then(() => this._create()).then(() => this._fire("restart"))));
      }
      _create() {
        return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then(t => (this._context = t, this._contextProps = sb(this._context), Promise.all(Array.from(this._watchdogs.values()).map(t => (t._setExcludedProperties(this._contextProps), t.create(void 0, void 0, this._context))))));
      }
      _destroy() {
        return Promise.resolve().then(() => {
          this._stopErrorHandling();
          const t = this._context;
          return this._context = null, this._contextProps = new Set(), Promise.all(Array.from(this._watchdogs.values()).map(t => t.destroy())).then(() => this._destructor(t));
        });
      }
      _getWatchdog(t) {
        const e = this._watchdogs.get(t);
        if (!e) throw new Error(`Item with the given id was not registered: ${t}.`);
        return e;
      }
      _isErrorComingFromThisItem(t) {
        for (const e of this._watchdogs.values()) if (e._isErrorComingFromThisItem(t)) return !1;
        return cb(this._context, t.context);
      }
    };
    class yb extends rc {
      constructor(t) {
        super(t), this.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"];
        const e = this.document;
        function n(t) {
          return (n, o) => {
            o.preventDefault();
            const i = o.dropRange ? [o.dropRange] : null,
              r = new g(e, t);
            e.fire(r, {
              dataTransfer: o.dataTransfer,
              method: n.name,
              targetRanges: i,
              target: o.target,
              domEvent: o.domEvent
            }), r.stop.called && o.stopPropagation();
          };
        }
        this.listenTo(e, "paste", n("clipboardInput"), {
          priority: "low"
        }), this.listenTo(e, "drop", n("clipboardInput"), {
          priority: "low"
        }), this.listenTo(e, "dragover", n("dragging"), {
          priority: "low"
        });
      }
      onDomEvent(t) {
        const e = "clipboardData" in t ? t.clipboardData : t.dataTransfer,
          n = "drop" == t.type || "paste" == t.type,
          o = {
            dataTransfer: new Kc(e, {
              cacheFiles: n
            })
          };
        "drop" != t.type && "dragover" != t.type || (o.dropRange = function (t, e) {
          const n = e.target.ownerDocument,
            o = e.clientX,
            i = e.clientY;
          let r;
          n.caretRangeFromPoint && n.caretRangeFromPoint(o, i) ? r = n.caretRangeFromPoint(o, i) : e.rangeParent && (r = n.createRange(), r.setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
          if (r) return t.domConverter.domRangeToView(r);
          return null;
        }(this.view, t)), this.fire(t.type, t, o);
      }
    }
    const xb = ["figcaption", "li"],
      Eb = ["ol", "ul"];
    function Db(t) {
      if (t.is("$text") || t.is("$textProxy")) return t.data;
      if (t.is("element", "img") && t.hasAttribute("alt")) return t.getAttribute("alt");
      if (t.is("element", "br")) return "\n";
      let e = "",
        n = null;
      for (const o of t.getChildren()) e += Ib(o, n) + Db(o), n = o;
      return e;
    }
    function Ib(t, e) {
      return e ? t.is("element", "li") && !t.isEmpty && t.getChild(0).is("containerElement") || Eb.includes(t.name) && Eb.includes(e.name) ? "\n\n" : t.is("containerElement") || e.is("containerElement") ? xb.includes(t.name) || xb.includes(e.name) ? "\n" : "\n\n" : "" : "";
    }
    const Tb = function (t, e) {
      return t && Ci(t, e, cn);
    };
    const Mb = function (t, e, n, o) {
      var i = n.length,
        r = i,
        s = !o;
      if (null == t) return !r;
      for (t = Object(t); i--;) {
        var a = n[i];
        if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t)) return !1;
      }
      for (; ++i < r;) {
        var c = (a = n[i])[0],
          l = t[c],
          d = a[1];
        if (s && a[2]) {
          if (void 0 === l && !(c in t)) return !1;
        } else {
          var u = new ve();
          if (o) var h = o(l, d, c, t, e, u);
          if (!(void 0 === h ? Fc(d, l, 3, o, u) : h)) return !1;
        }
      }
      return !0;
    };
    const Sb = function (t) {
      return t == t && !R(t);
    };
    const Bb = function (t) {
      for (var e = cn(t), n = e.length; n--;) {
        var o = e[n],
          i = t[o];
        e[n] = [o, i, Sb(i)];
      }
      return e;
    };
    const Nb = function (t, e) {
      return function (n) {
        return null != n && n[t] === e && (void 0 !== e || t in Object(n));
      };
    };
    const Pb = function (t) {
      var e = Bb(t);
      return 1 == e.length && e[0][2] ? Nb(e[0][0], e[0][1]) : function (n) {
        return n === t || Mb(n, t, e);
      };
    };
    const Ob = function (t, e) {
      return null != t && e in Object(t);
    };
    const Lb = function (t, e, n) {
      for (var o = -1, i = (e = xs(e, t)).length, r = !1; ++o < i;) {
        var s = Ds(e[o]);
        if (!(r = null != t && n(t, s))) break;
        t = t[s];
      }
      return r || ++o != i ? r : !!(i = null == t ? 0 : t.length) && Ue(i) && He(s, i) && (mt(t) || Oe(t));
    };
    const zb = function (t, e) {
      return null != t && Lb(t, e, Ob);
    };
    const Rb = function (t, e) {
      return hs(t) && Sb(e) ? Nb(Ds(t), e) : function (n) {
        var o = Ns(n, t);
        return void 0 === o && o === e ? zb(n, t) : Fc(e, o, 3);
      };
    };
    const jb = function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    };
    const Fb = function (t) {
      return function (e) {
        return Is(e, t);
      };
    };
    const Vb = function (t) {
      return hs(t) ? jb(Ds(t)) : Fb(t);
    };
    const Hb = function (t) {
      return "function" == typeof t ? t : null == t ? Ii : "object" == typeof t ? mt(t) ? Rb(t[0], t[1]) : Pb(t) : Vb(t);
    };
    const Ub = function (t, e) {
      var n = {};
      return e = Hb(e, 3), Tb(t, function (t, o, i) {
        Ee(n, o, e(t, o, i));
      }), n;
    };
    var qb = Object.defineProperty,
      Gb = Object.defineProperties,
      Wb = Object.getOwnPropertyDescriptors,
      Kb = Object.getOwnPropertySymbols,
      $b = Object.prototype.hasOwnProperty,
      Yb = Object.prototype.propertyIsEnumerable,
      Qb = (t, e, n) => e in t ? qb(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class Zb extends Br {
      constructor() {
        super(...arguments), this._markersToCopy = new Map();
      }
      static get pluginName() {
        return "ClipboardMarkersUtils";
      }
      _registerMarkerToCopy(t, e) {
        this._markersToCopy.set(t, e);
      }
      _copySelectedFragmentWithMarkers(t, e, n = t => t.model.getSelectedContent(t.model.document.selection)) {
        return this.editor.model.change(o => {
          const i = o.model.document.selection;
          o.setSelection(e);
          const r = this._insertFakeMarkersIntoSelection(o, o.model.document.selection, t),
            s = n(o),
            a = this._removeFakeMarkersInsideElement(o, s);
          for (const [t, e] of Object.entries(r)) {
            a[t] || (a[t] = o.createRangeIn(s));
            for (const t of e) o.remove(t);
          }
          s.markers.clear();
          for (const [t, e] of Object.entries(a)) s.markers.set(t, e);
          return o.setSelection(i), s;
        });
      }
      _pasteMarkersIntoTransformedElement(t, e) {
        const n = this._getPasteMarkersFromRangeMap(t);
        return this.editor.model.change(t => {
          const o = this._insertFakeMarkersElements(t, n),
            i = e(t),
            r = this._removeFakeMarkersInsideElement(t, i);
          for (const e of Object.values(o).flat()) t.remove(e);
          for (const [e, n] of Object.entries(r)) t.model.markers.has(e) || t.addMarker(e, {
            usingOperation: !0,
            affectsData: !0,
            range: n
          });
          return i;
        });
      }
      _pasteFragmentWithMarkers(t) {
        const e = this._getPasteMarkersFromRangeMap(t.markers);
        t.markers.clear();
        for (const n of e) t.markers.set(n.name, n.range);
        return this.editor.model.insertContent(t);
      }
      _forceMarkersCopy(t, e, n = {
        allowedActions: "all",
        copyPartiallySelected: !0,
        duplicateOnPaste: !0
      }) {
        const o = this._markersToCopy.get(t);
        this._markersToCopy.set(t, n), e(), o ? this._markersToCopy.set(t, o) : this._markersToCopy.delete(t);
      }
      _isMarkerCopyable(t, e) {
        const n = this._getMarkerClipboardConfig(t);
        if (!n) return !1;
        if (!e) return !0;
        const {
          allowedActions: o
        } = n;
        return "all" === o || o.includes(e);
      }
      _hasMarkerConfiguration(t) {
        return !!this._getMarkerClipboardConfig(t);
      }
      _getMarkerClipboardConfig(t) {
        const [e] = t.split(":");
        return this._markersToCopy.get(e) || null;
      }
      _insertFakeMarkersIntoSelection(t, e, n) {
        const o = this._getCopyableMarkersFromSelection(t, e, n);
        return this._insertFakeMarkersElements(t, o);
      }
      _getCopyableMarkersFromSelection(t, e, n) {
        const o = Array.from(e.getRanges()),
          i = new Set(o.flatMap(e => Array.from(t.model.markers.getMarkersIntersectingRange(e))));
        return Array.from(i).filter(t => {
          if (!this._isMarkerCopyable(t.name, n)) return !1;
          const {
            copyPartiallySelected: e
          } = this._getMarkerClipboardConfig(t.name);
          if (!e) {
            const e = t.getRange();
            return o.some(t => t.containsRange(e, !0));
          }
          return !0;
        }).map(t => ({
          name: "dragstart" === n ? this._getUniqueMarkerName(t.name) : t.name,
          range: t.getRange()
        }));
      }
      _getPasteMarkersFromRangeMap(t, e = null) {
        const {
          model: n
        } = this.editor;
        return (t instanceof Map ? Array.from(t.entries()) : Object.entries(t)).flatMap(([t, o]) => {
          if (!this._hasMarkerConfiguration(t)) return [{
            name: t,
            range: o
          }];
          if (this._isMarkerCopyable(t, e)) {
            const e = this._getMarkerClipboardConfig(t),
              i = n.markers.has(t) && "$graveyard" === n.markers.get(t).getRange().root.rootName;
            return (e.duplicateOnPaste || i) && (t = this._getUniqueMarkerName(t)), [{
              name: t,
              range: o
            }];
          }
          return [];
        });
      }
      _insertFakeMarkersElements(t, e) {
        const n = {},
          o = e.flatMap(t => {
            const {
              start: e,
              end: n
            } = t.range;
            return [{
              position: e,
              marker: t,
              type: "start"
            }, {
              position: n,
              marker: t,
              type: "end"
            }];
          }).sort(({
            position: t
          }, {
            position: e
          }) => t.isBefore(e) ? 1 : -1);
        for (const {
          position: e,
          marker: i,
          type: r
        } of o) {
          const o = t.createElement("$marker", {
            "data-name": i.name,
            "data-type": r
          });
          n[i.name] || (n[i.name] = []), n[i.name].push(o), t.insert(o, e);
        }
        return n;
      }
      _removeFakeMarkersInsideElement(t, e) {
        const n = this._getAllFakeMarkersFromElement(t, e).reduce((e, n) => {
          const o = n.markerElement && t.createPositionBefore(n.markerElement);
          let i = e[n.name],
            r = !1;
          if (i && i.start && i.end) {
            this._getMarkerClipboardConfig(n.name).duplicateOnPaste ? e[this._getUniqueMarkerName(n.name)] = e[n.name] : r = !0, i = null;
          }
          var s, a;
          return r || (e[n.name] = (s = ((t, e) => {
            for (var n in e || (e = {})) $b.call(e, n) && Qb(t, n, e[n]);
            if (Kb) for (var n of Kb(e)) Yb.call(e, n) && Qb(t, n, e[n]);
            return t;
          })({}, i), a = {
            [n.type]: o
          }, Gb(s, Wb(a)))), n.markerElement && t.remove(n.markerElement), e;
        }, {});
        return Ub(n, n => new ml(n.start || t.createPositionFromPath(e, [0]), n.end || t.createPositionAt(e, "end")));
      }
      _getAllFakeMarkersFromElement(t, e) {
        const n = Array.from(t.createRangeIn(e)).flatMap(({
            item: t
          }) => {
            if (!t.is("element", "$marker")) return [];
            const e = t.getAttribute("data-name"),
              n = t.getAttribute("data-type");
            return [{
              markerElement: t,
              name: e,
              type: n
            }];
          }),
          o = [],
          i = [];
        for (const t of n) {
          if ("end" === t.type) {
            n.some(e => e.name === t.name && "start" === e.type) || o.push({
              markerElement: null,
              name: t.name,
              type: "start"
            });
          }
          if ("start" === t.type) {
            n.some(e => e.name === t.name && "end" === e.type) || i.unshift({
              markerElement: null,
              name: t.name,
              type: "end"
            });
          }
        }
        return [...o, ...n, ...i];
      }
      _getUniqueMarkerName(t) {
        const e = t.split(":"),
          n = p().substring(1, 6);
        return 3 === e.length ? `${e.slice(0, 2).join(":")}:${n}` : `${e.join(":")}:${n}`;
      }
    }
    class Jb extends Br {
      static get pluginName() {
        return "ClipboardPipeline";
      }
      static get requires() {
        return [Zb];
      }
      init() {
        this.editor.editing.view.addObserver(yb), this._setupPasteDrop(), this._setupCopyCut();
      }
      _fireOutputTransformationEvent(t, e, n) {
        const o = this.editor.plugins.get("ClipboardMarkersUtils");
        this.editor.model.enqueueChange({
          isUndoable: "cut" === n
        }, () => {
          const i = o._copySelectedFragmentWithMarkers(n, e);
          this.fire("outputTransformation", {
            dataTransfer: t,
            content: i,
            method: n
          });
        });
      }
      _setupPasteDrop() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          o = n.document,
          i = this.editor.plugins.get("ClipboardMarkersUtils");
        this.listenTo(o, "clipboardInput", (e, n) => {
          "paste" != n.method || t.model.canEditAt(t.model.document.selection) || e.stop();
        }, {
          priority: "highest"
        }), this.listenTo(o, "clipboardInput", (t, e) => {
          const o = e.dataTransfer;
          let i;
          if (e.content) i = e.content;else {
            let t = "";
            o.getData("text/html") ? t = function (t) {
              return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t, e) => 1 == e.length ? " " : e).replace(/<!--[\s\S]*?-->/g, "");
            }(o.getData("text/html")) : o.getData("text/plain") && (((r = (r = o.getData("text/plain")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || r.includes("<br>")) && (r = `<p>${r}</p>`), t = r), i = this.editor.data.htmlProcessor.toView(t);
          }
          var r;
          const s = new g(this, "inputTransformation");
          this.fire(s, {
            content: i,
            dataTransfer: o,
            targetRanges: e.targetRanges,
            method: e.method
          }), s.stop.called && t.stop(), n.scrollToTheSelection();
        }, {
          priority: "low"
        }), this.listenTo(this, "inputTransformation", (t, n) => {
          if (n.content.isEmpty) return;
          const o = this.editor.data.toModel(n.content, "$clipboardHolder");
          0 != o.childCount && (t.stop(), e.change(() => {
            this.fire("contentInsertion", {
              content: o,
              method: n.method,
              dataTransfer: n.dataTransfer,
              targetRanges: n.targetRanges
            });
          }));
        }, {
          priority: "low"
        }), this.listenTo(this, "contentInsertion", (t, e) => {
          e.resultRange = i._pasteFragmentWithMarkers(e.content);
        }, {
          priority: "low"
        });
      }
      _setupCopyCut() {
        const t = this.editor,
          e = t.model.document,
          n = t.editing.view.document,
          o = (t, n) => {
            const o = n.dataTransfer;
            n.preventDefault(), this._fireOutputTransformationEvent(o, e.selection, t.name);
          };
        this.listenTo(n, "copy", o, {
          priority: "low"
        }), this.listenTo(n, "cut", (e, n) => {
          t.model.canEditAt(t.model.document.selection) ? o(e, n) : n.preventDefault();
        }, {
          priority: "low"
        }), this.listenTo(this, "outputTransformation", (e, o) => {
          const i = t.data.toView(o.content);
          n.fire("clipboardOutput", {
            dataTransfer: o.dataTransfer,
            content: i,
            method: o.method
          });
        }, {
          priority: "low"
        }), this.listenTo(n, "clipboardOutput", (n, o) => {
          o.content.isEmpty || (o.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(o.content)), o.dataTransfer.setData("text/plain", Db(o.content))), "cut" == o.method && t.model.deleteContent(e.selection);
        }, {
          priority: "low"
        });
      }
    }
    class Xb {
      constructor(t, e = 20) {
        this._batch = null, this.model = t, this._size = 0, this.limit = e, this._isLocked = !1, this._changeCallback = (t, e) => {
          e.isLocal && e.isUndoable && e !== this._batch && this._reset(!0);
        }, this._selectionChangeCallback = () => {
          this._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }
      get batch() {
        return this._batch || (this._batch = this.model.createBatch({
          isTyping: !0
        })), this._batch;
      }
      get size() {
        return this._size;
      }
      input(t) {
        this._size += t, this._size >= this.limit && this._reset(!0);
      }
      get isLocked() {
        return this._isLocked;
      }
      lock() {
        this._isLocked = !0;
      }
      unlock() {
        this._isLocked = !1;
      }
      destroy() {
        this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
      }
      _reset(t = !1) {
        this.isLocked && !t || (this._batch = null, this._size = 0);
      }
    }
    class tw extends Pr {
      constructor(t, e) {
        super(t), this._buffer = new Xb(t.model, e), this._isEnabledBasedOnSelection = !1;
      }
      get buffer() {
        return this._buffer;
      }
      destroy() {
        super.destroy(), this._buffer.destroy();
      }
      execute(t = {}) {
        const e = this.editor.model,
          n = e.document,
          o = t.text || "",
          i = o.length;
        let r = n.selection;
        if (t.selection ? r = t.selection : t.range && (r = e.createSelection(t.range)), !e.canEditAt(r)) return;
        const s = t.resultRange;
        e.enqueueChange(this._buffer.batch, t => {
          this._buffer.lock();
          const a = Array.from(n.selection.getAttributes());
          e.deleteContent(r), o && e.insertContent(t.createText(o, a), r), s ? t.setSelection(s) : r.is("documentSelection") || t.setSelection(r), this._buffer.unlock(), this._buffer.input(i);
        });
      }
    }
    const ew = ["insertText", "insertReplacementText"];
    class nw extends nc {
      constructor(t) {
        super(t), this.focusObserver = t.getObserver(qc), s.isAndroid && ew.push("insertCompositionText");
        const e = t.document;
        e.on("beforeinput", (n, o) => {
          if (!this.isEnabled) return;
          const {
            data: i,
            targetRanges: r,
            inputType: s,
            domEvent: a
          } = o;
          if (!ew.includes(s)) return;
          this.focusObserver.flush();
          const c = new g(e, "insertText");
          e.fire(c, new ic(t, a, {
            text: i,
            selection: t.createSelection(r)
          })), c.stop.called && n.stop();
        }), e.on("compositionend", (n, {
          data: o,
          domEvent: i
        }) => {
          this.isEnabled && !s.isAndroid && o && e.fire("insertText", new ic(t, i, {
            text: o,
            selection: e.selection
          }));
        }, {
          priority: "lowest"
        });
      }
      observe() {}
      stopObserving() {}
    }
    class ow extends Br {
      static get pluginName() {
        return "Input";
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          o = e.document.selection;
        n.addObserver(nw);
        const i = new tw(t, t.config.get("typing.undoStep") || 20);
        t.commands.add("insertText", i), t.commands.add("input", i), this.listenTo(n.document, "insertText", (o, i) => {
          n.document.isComposing || i.preventDefault();
          const {
              text: r,
              selection: a,
              resultRange: c
            } = i,
            l = Array.from(a.getRanges()).map(e => t.editing.mapper.toModelRange(e));
          let d = r;
          if (s.isAndroid) {
            const t = Array.from(l[0].getItems()).reduce((t, e) => t + (e.is("$textProxy") ? e.data : ""), "");
            t && (t.length <= d.length ? d.startsWith(t) && (d = d.substring(t.length), l[0].start = l[0].start.getShiftedBy(t.length)) : t.startsWith(d) && (l[0].start = l[0].start.getShiftedBy(d.length), d = ""));
          }
          const u = {
            text: d,
            selection: e.createSelection(l)
          };
          c && (u.resultRange = t.editing.mapper.toModelRange(c)), t.execute("insertText", u), n.scrollToTheSelection();
        }), s.isAndroid ? this.listenTo(n.document, "keydown", (t, r) => {
          !o.isCollapsed && 229 == r.keyCode && n.document.isComposing && iw(e, i);
        }) : this.listenTo(n.document, "compositionstart", () => {
          o.isCollapsed || iw(e, i);
        });
      }
    }
    function iw(t, e) {
      if (!e.isEnabled) return;
      const n = e.buffer;
      n.lock(), t.enqueueChange(n.batch, () => {
        t.deleteContent(t.document.selection);
      }), n.unlock();
    }
    class rw extends Pr {
      constructor(t, e) {
        super(t), this.direction = e, this._buffer = new Xb(t.model, t.config.get("typing.undoStep")), this._isEnabledBasedOnSelection = !1;
      }
      get buffer() {
        return this._buffer;
      }
      execute(t = {}) {
        const e = this.editor.model,
          n = e.document;
        e.enqueueChange(this._buffer.batch, o => {
          this._buffer.lock();
          const i = o.createSelection(t.selection || n.selection);
          if (!e.canEditAt(i)) return;
          const r = t.sequence || 1,
            s = i.isCollapsed;
          if (i.isCollapsed && e.modifySelection(i, {
            direction: this.direction,
            unit: t.unit,
            treatEmojiAsSingleUnit: !0
          }), this._shouldEntireContentBeReplacedWithParagraph(r)) return void this._replaceEntireContentWithParagraph(o);
          if (this._shouldReplaceFirstBlockWithParagraph(i, r)) return void this.editor.execute("paragraph", {
            selection: i
          });
          if (i.isCollapsed) return;
          let a = 0;
          i.getFirstRange().getMinimalFlatRanges().forEach(t => {
            a += J(t.getWalker({
              singleCharacters: !0,
              ignoreElementEnd: !0,
              shallow: !0
            }));
          }), e.deleteContent(i, {
            doNotResetEntireContent: s,
            direction: this.direction
          }), this._buffer.input(a), o.setSelection(i), this._buffer.unlock();
        });
      }
      _shouldEntireContentBeReplacedWithParagraph(t) {
        if (t > 1) return !1;
        const e = this.editor.model,
          n = e.document.selection,
          o = e.schema.getLimitElement(n);
        if (!(n.isCollapsed && n.containsEntireContent(o))) return !1;
        if (!e.schema.checkChild(o, "paragraph")) return !1;
        const i = o.getChild(0);
        return !i || !i.is("element", "paragraph");
      }
      _replaceEntireContentWithParagraph(t) {
        const e = this.editor.model,
          n = e.document.selection,
          o = e.schema.getLimitElement(n),
          i = t.createElement("paragraph");
        t.remove(t.createRangeIn(o)), t.insert(i, o), t.setSelection(i, 0);
      }
      _shouldReplaceFirstBlockWithParagraph(t, e) {
        const n = this.editor.model;
        if (e > 1 || "backward" != this.direction) return !1;
        if (!t.isCollapsed) return !1;
        const o = t.getFirstPosition(),
          i = n.schema.getLimitElement(o),
          r = i.getChild(0);
        return o.parent == r && !!t.containsEntireContent(r) && !!n.schema.checkChild(i, "paragraph") && "paragraph" != r.name;
      }
    }
    const sw = "word",
      aw = "selection",
      cw = "backward",
      lw = "forward",
      dw = {
        deleteContent: {
          unit: aw,
          direction: cw
        },
        deleteContentBackward: {
          unit: "codePoint",
          direction: cw
        },
        deleteWordBackward: {
          unit: sw,
          direction: cw
        },
        deleteHardLineBackward: {
          unit: aw,
          direction: cw
        },
        deleteSoftLineBackward: {
          unit: aw,
          direction: cw
        },
        deleteContentForward: {
          unit: "character",
          direction: lw
        },
        deleteWordForward: {
          unit: sw,
          direction: lw
        },
        deleteHardLineForward: {
          unit: aw,
          direction: lw
        },
        deleteSoftLineForward: {
          unit: aw,
          direction: lw
        }
      };
    class uw extends nc {
      constructor(t) {
        super(t);
        const e = t.document;
        let n = 0;
        e.on("keydown", () => {
          n++;
        }), e.on("keyup", () => {
          n = 0;
        }), e.on("beforeinput", (o, i) => {
          if (!this.isEnabled) return;
          const {
              targetRanges: r,
              domEvent: a,
              inputType: c
            } = i,
            l = dw[c];
          if (!l) return;
          const d = {
            direction: l.direction,
            unit: l.unit,
            sequence: n
          };
          d.unit == aw && (d.selectionToRemove = t.createSelection(r[0])), "deleteContentBackward" === c && (s.isAndroid && (d.sequence = 1), function (t) {
            if (1 != t.length || t[0].isCollapsed) return !1;
            const e = t[0].getWalker({
              direction: "backward",
              singleCharacters: !0,
              ignoreElementEnd: !0
            });
            let n = 0;
            for (const {
              nextPosition: t,
              item: o
            } of e) {
              if (t.parent.is("$text")) {
                const e = t.parent.data,
                  o = t.offset;
                if (Zi(e, o) || Ji(e, o) || tr(e, o)) continue;
                n++;
              } else (o.is("containerElement") || o.is("emptyElement")) && n++;
              if (n > 1) return !0;
            }
            return !1;
          }(r) && (d.unit = aw, d.selectionToRemove = t.createSelection(r)));
          const u = new Xs(e, "delete", r[0]);
          e.fire(u, new ic(t, a, d)), u.stop.called && o.stop();
        }), s.isBlink && function (t) {
          const e = t.view,
            n = e.document;
          let o = null,
            i = !1;
          function r(t) {
            return t == mi.backspace || t == mi.delete;
          }
          function s(t) {
            return t == mi.backspace ? cw : lw;
          }
          n.on("keydown", (t, {
            keyCode: e
          }) => {
            o = e, i = !1;
          }), n.on("keyup", (a, {
            keyCode: c,
            domEvent: l
          }) => {
            const d = n.selection,
              u = t.isEnabled && c == o && r(c) && !d.isCollapsed && !i;
            if (o = null, u) {
              const t = d.getFirstRange(),
                o = new Xs(n, "delete", t),
                i = {
                  unit: aw,
                  direction: s(c),
                  selectionToRemove: d
                };
              n.fire(o, new ic(e, l, i));
            }
          }), n.on("beforeinput", (t, {
            inputType: e
          }) => {
            const n = dw[e];
            r(o) && n && n.direction == s(o) && (i = !0);
          }, {
            priority: "high"
          }), n.on("beforeinput", (t, {
            inputType: e,
            data: n
          }) => {
            o == mi.delete && "insertText" == e && "" == n && t.stop();
          }, {
            priority: "high"
          });
        }(this);
      }
      observe() {}
      stopObserving() {}
    }
    class hw extends Br {
      static get pluginName() {
        return "Delete";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document,
          o = t.model.document;
        e.addObserver(uw), this._undoOnBackspace = !1;
        const i = new rw(t, "forward");
        t.commands.add("deleteForward", i), t.commands.add("forwardDelete", i), t.commands.add("delete", new rw(t, "backward")), this.listenTo(n, "delete", (o, i) => {
          n.isComposing || i.preventDefault();
          const {
              direction: r,
              sequence: s,
              selectionToRemove: a,
              unit: c
            } = i,
            l = "forward" === r ? "deleteForward" : "delete",
            d = {
              sequence: s
            };
          if ("selection" == c) {
            const e = Array.from(a.getRanges()).map(e => t.editing.mapper.toModelRange(e));
            d.selection = t.model.createSelection(e);
          } else d.unit = c;
          t.execute(l, d), e.scrollToTheSelection();
        }, {
          priority: "low"
        }), this.editor.plugins.has("UndoEditing") && (this.listenTo(n, "delete", (e, n) => {
          this._undoOnBackspace && "backward" == n.direction && 1 == n.sequence && "codePoint" == n.unit && (this._undoOnBackspace = !1, t.execute("undo"), n.preventDefault(), e.stop());
        }, {
          context: "$capture"
        }), this.listenTo(o, "change", () => {
          this._undoOnBackspace = !1;
        }));
      }
      requestUndoOnBackspace() {
        this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
      }
    }
    class gw extends Br {
      static get requires() {
        return [ow, hw];
      }
      static get pluginName() {
        return "Typing";
      }
    }
    function mw(t, e) {
      let n = t.start;
      return {
        text: Array.from(t.getWalker({
          ignoreElementEnd: !1
        })).reduce((t, {
          item: o
        }) => o.is("$text") || o.is("$textProxy") ? t + o.data : (n = e.createPositionAfter(o), ""), ""),
        range: e.createRange(n, t.end)
      };
    }
    class pw extends G() {
      constructor(t, e) {
        super(), this.model = t, this.testCallback = e, this._hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", () => {
          this.isEnabled ? this._startListening() : (this.stopListening(t.document.selection), this.stopListening(t.document));
        }), this._startListening();
      }
      get hasMatch() {
        return this._hasMatch;
      }
      _startListening() {
        const t = this.model.document;
        this.listenTo(t.selection, "change:range", (e, {
          directChange: n
        }) => {
          n && (t.selection.isCollapsed ? this._evaluateTextBeforeSelection("selection") : this.hasMatch && (this.fire("unmatched"), this._hasMatch = !1));
        }), this.listenTo(t, "change:data", (t, e) => {
          !e.isUndo && e.isLocal && this._evaluateTextBeforeSelection("data", {
            batch: e
          });
        });
      }
      _evaluateTextBeforeSelection(t, e = {}) {
        const n = this.model,
          o = n.document.selection,
          i = n.createRange(n.createPositionAt(o.focus.parent, 0), o.focus),
          {
            text: r,
            range: s
          } = mw(i, n),
          a = this.testCallback(r);
        if (!a && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!a, a) {
          const n = Object.assign(e, {
            text: r,
            range: s
          });
          "object" == typeof a && Object.assign(n, a), this.fire(`matched:${t}`, n);
        }
      }
    }
    class fw extends Br {
      constructor(t) {
        super(t), this._isNextGravityRestorationSkipped = !1, this.attributes = new Set(), this._overrideUid = null;
      }
      static get pluginName() {
        return "TwoStepCaretMovement";
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          o = t.locale,
          i = e.document.selection;
        this.listenTo(n.document, "arrowKey", (t, e) => {
          if (!i.isCollapsed) return;
          if (e.shiftKey || e.altKey || e.ctrlKey) return;
          const n = e.keyCode == mi.arrowright,
            r = e.keyCode == mi.arrowleft;
          if (!n && !r) return;
          const s = o.contentLanguageDirection;
          let a = !1;
          a = "ltr" === s && n || "rtl" === s && r ? this._handleForwardMovement(e) : this._handleBackwardMovement(e), !0 === a && t.stop();
        }, {
          context: "$text",
          priority: "highest"
        }), this.listenTo(i, "change:range", (t, e) => {
          this._isNextGravityRestorationSkipped ? this._isNextGravityRestorationSkipped = !1 : this._isGravityOverridden && (!e.directChange && Cw(i.getFirstPosition(), this.attributes) || this._restoreGravity());
        }), this._enableClickingAfterNode(), this._enableInsertContentSelectionAttributesFixer(), this._handleDeleteContentAfterNode();
      }
      registerAttribute(t) {
        this.attributes.add(t);
      }
      _handleForwardMovement(t) {
        const e = this.attributes,
          n = this.editor.model,
          o = n.document.selection,
          i = o.getFirstPosition();
        return !this._isGravityOverridden && (!i.isAtStart || !kw(o, e)) && !!Cw(i, e) && (Aw(t), kw(o, e) && Cw(i, e, !0) ? ww(n, e) : this._overrideGravity(), !0);
      }
      _handleBackwardMovement(t) {
        const e = this.attributes,
          n = this.editor.model,
          o = n.document.selection,
          i = o.getFirstPosition();
        return this._isGravityOverridden ? (Aw(t), this._restoreGravity(), Cw(i, e, !0) ? ww(n, e) : bw(n, e, i), !0) : i.isAtStart ? !!kw(o, e) && (Aw(t), bw(n, e, i), !0) : !kw(o, e) && Cw(i, e, !0) ? (Aw(t), bw(n, e, i), !0) : !!_w(i, e) && (i.isAtEnd && !kw(o, e) && Cw(i, e) ? (Aw(t), bw(n, e, i), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1));
      }
      _enableClickingAfterNode() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          o = t.editing.view.document;
        t.editing.view.addObserver(Yh);
        let i = !1;
        this.listenTo(o, "mousedown", () => {
          i = !0;
        }), this.listenTo(o, "selectionChange", () => {
          const t = this.attributes;
          if (!i) return;
          if (i = !1, !n.isCollapsed) return;
          if (!kw(n, t)) return;
          const o = n.getFirstPosition();
          Cw(o, t) && (o.isAtStart || Cw(o, t, !0) ? ww(e, t) : this._isGravityOverridden || this._overrideGravity());
        });
      }
      _enableInsertContentSelectionAttributesFixer() {
        const t = this.editor.model,
          e = t.document.selection,
          n = this.attributes;
        this.listenTo(t, "insertContent", () => {
          const o = e.getFirstPosition();
          kw(e, n) && Cw(o, n) && ww(t, n);
        }, {
          priority: "low"
        });
      }
      _handleDeleteContentAfterNode() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          o = t.editing.view;
        let i = !1,
          r = !1;
        this.listenTo(o.document, "delete", (t, e) => {
          i = "backward" === e.direction;
        }, {
          priority: "high"
        }), this.listenTo(e, "deleteContent", () => {
          if (!i) return;
          const t = n.getFirstPosition();
          r = kw(n, this.attributes) && !_w(t, this.attributes);
        }, {
          priority: "high"
        }), this.listenTo(e, "deleteContent", () => {
          i && (i = !1, r || t.model.enqueueChange(() => {
            const t = n.getFirstPosition();
            kw(n, this.attributes) && Cw(t, this.attributes) && (t.isAtStart || Cw(t, this.attributes, !0) ? ww(e, this.attributes) : this._isGravityOverridden || this._overrideGravity());
          }));
        }, {
          priority: "low"
        });
      }
      get _isGravityOverridden() {
        return !!this._overrideUid;
      }
      _overrideGravity() {
        this._overrideUid = this.editor.model.change(t => t.overrideSelectionGravity());
      }
      _restoreGravity() {
        this.editor.model.change(t => {
          t.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
        });
      }
    }
    function kw(t, e) {
      for (const n of e) if (t.hasAttribute(n)) return !0;
      return !1;
    }
    function bw(t, e, n) {
      const o = n.nodeBefore;
      t.change(n => {
        if (o) {
          const e = [],
            i = t.schema.isObject(o) && t.schema.isInline(o);
          for (const [n, r] of o.getAttributes()) !t.schema.checkAttribute("$text", n) || i && !1 === t.schema.getAttributeProperties(n).copyFromObject || e.push([n, r]);
          n.setSelectionAttribute(e);
        } else n.removeSelectionAttribute(e);
      });
    }
    function ww(t, e) {
      t.change(t => {
        t.removeSelectionAttribute(e);
      });
    }
    function Aw(t) {
      t.preventDefault();
    }
    function _w(t, e) {
      return Cw(t.getShiftedBy(-1), e);
    }
    function Cw(t, e, n = !1) {
      const {
        nodeBefore: o,
        nodeAfter: i
      } = t;
      for (const t of e) {
        const e = o ? o.getAttribute(t) : void 0,
          r = i ? i.getAttribute(t) : void 0;
        if ((!n || void 0 !== e && void 0 !== r) && r !== e) return !0;
      }
      return !1;
    }
    const vw = {
        copyright: {
          from: "(c)",
          to: "©"
        },
        registeredTrademark: {
          from: "(r)",
          to: "®"
        },
        trademark: {
          from: "(tm)",
          to: "™"
        },
        oneHalf: {
          from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
          to: [null, "½", null]
        },
        oneThird: {
          from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
          to: [null, "⅓", null]
        },
        twoThirds: {
          from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
          to: [null, "⅔", null]
        },
        oneForth: {
          from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
          to: [null, "¼", null]
        },
        threeQuarters: {
          from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
          to: [null, "¾", null]
        },
        lessThanOrEqual: {
          from: "<=",
          to: "≤"
        },
        greaterThanOrEqual: {
          from: ">=",
          to: "≥"
        },
        notEqual: {
          from: "!=",
          to: "≠"
        },
        arrowLeft: {
          from: "<-",
          to: "←"
        },
        arrowRight: {
          from: "->",
          to: "→"
        },
        horizontalEllipsis: {
          from: "...",
          to: "…"
        },
        enDash: {
          from: /(^| )(--)( )$/,
          to: [null, "–", null]
        },
        emDash: {
          from: /(^| )(---)( )$/,
          to: [null, "—", null]
        },
        quotesPrimary: {
          from: Tw('"'),
          to: [null, "“", null, "”"]
        },
        quotesSecondary: {
          from: Tw("'"),
          to: [null, "‘", null, "’"]
        },
        quotesPrimaryEnGb: {
          from: Tw("'"),
          to: [null, "‘", null, "’"]
        },
        quotesSecondaryEnGb: {
          from: Tw('"'),
          to: [null, "“", null, "”"]
        },
        quotesPrimaryPl: {
          from: Tw('"'),
          to: [null, "„", null, "”"]
        },
        quotesSecondaryPl: {
          from: Tw("'"),
          to: [null, "‚", null, "’"]
        }
      },
      yw = {
        symbols: ["copyright", "registeredTrademark", "trademark"],
        mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
        typography: ["horizontalEllipsis", "enDash", "emDash"],
        quotes: ["quotesPrimary", "quotesSecondary"]
      },
      xw = ["symbols", "mathematical", "typography", "quotes"];
    function Ew(t) {
      return "string" == typeof t ? new RegExp(`(${qf(t)})$`) : t;
    }
    function Dw(t) {
      return "string" == typeof t ? () => [t] : t instanceof Array ? () => t : t;
    }
    function Iw(t) {
      return (t.textNode ? t.textNode : t.nodeAfter).getAttributes();
    }
    function Tw(t) {
      return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`);
    }
    function Mw(t, e, n, o) {
      return o.createRange(Sw(t, e, n, !0, o), Sw(t, e, n, !1, o));
    }
    function Sw(t, e, n, o, i) {
      let r = t.textNode || (o ? t.nodeBefore : t.nodeAfter),
        s = null;
      for (; r && r.getAttribute(e) == n;) s = r, r = o ? r.previousSibling : r.nextSibling;
      return s ? i.createPositionAt(s, o ? "before" : "after") : t;
    }
    function* Bw(t, e) {
      for (const n of e) n && t.getAttributeProperties(n[0]).copyOnEnter && (yield n);
    }
    class Nw extends Pr {
      execute() {
        this.editor.model.change(t => {
          this.enterBlock(t), this.fire("afterExecute", {
            writer: t
          });
        });
      }
      enterBlock(t) {
        const e = this.editor.model,
          n = e.document.selection,
          o = e.schema,
          i = n.isCollapsed,
          r = n.getFirstRange(),
          s = r.start.parent,
          a = r.end.parent;
        if (o.isLimit(s) || o.isLimit(a)) return i || s != a || e.deleteContent(n), !1;
        if (i) {
          const e = Bw(t.model.schema, n.getAttributes());
          return Pw(t, r.start), t.setSelectionAttribute(e), !0;
        }
        {
          const o = !(r.start.isAtStart && r.end.isAtEnd),
            i = s == a;
          if (e.deleteContent(n, {
            leaveUnmerged: o
          }), o) {
            if (i) return Pw(t, n.focus), !0;
            t.setSelection(a, 0);
          }
        }
        return !1;
      }
    }
    function Pw(t, e) {
      t.split(e), t.setSelection(e.parent.nextSibling, 0);
    }
    const Ow = {
      insertParagraph: {
        isSoft: !1
      },
      insertLineBreak: {
        isSoft: !0
      }
    };
    class Lw extends nc {
      constructor(t) {
        super(t);
        const e = this.document;
        let n = !1;
        e.on("keydown", (t, e) => {
          n = e.shiftKey;
        }), e.on("beforeinput", (o, i) => {
          if (!this.isEnabled) return;
          let r = i.inputType;
          s.isSafari && n && "insertParagraph" == r && (r = "insertLineBreak");
          const a = i.domEvent,
            c = Ow[r];
          if (!c) return;
          const l = new Xs(e, "enter", i.targetRanges[0]);
          e.fire(l, new ic(t, a, {
            isSoft: c.isSoft
          })), l.stop.called && o.stop();
        });
      }
      observe() {}
      stopObserving() {}
    }
    class zw extends Br {
      static get pluginName() {
        return "Enter";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document,
          o = this.editor.t;
        e.addObserver(Lw), t.commands.add("enter", new Nw(t)), this.listenTo(n, "enter", (o, i) => {
          n.isComposing || i.preventDefault(), i.isSoft || (t.execute("enter"), e.scrollToTheSelection());
        }, {
          priority: "low"
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: o("Insert a hard break (a new paragraph)"),
            keystroke: "Enter"
          }]
        });
      }
    }
    class Rw extends Pr {
      execute() {
        const t = this.editor.model,
          e = t.document;
        t.change(n => {
          !function (t, e, n) {
            const o = n.isCollapsed,
              i = n.getFirstRange(),
              r = i.start.parent,
              s = i.end.parent,
              a = r == s;
            if (o) {
              const o = Bw(t.schema, n.getAttributes());
              jw(t, e, i.end), e.removeSelectionAttribute(n.getAttributeKeys()), e.setSelectionAttribute(o);
            } else {
              const o = !(i.start.isAtStart && i.end.isAtEnd);
              t.deleteContent(n, {
                leaveUnmerged: o
              }), a ? jw(t, e, n.focus) : o && e.setSelection(s, 0);
            }
          }(t, n, e.selection), this.fire("afterExecute", {
            writer: n
          });
        });
      }
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.isEnabled = function (t, e) {
          if (e.rangeCount > 1) return !1;
          const n = e.anchor;
          if (!n || !t.checkChild(n, "softBreak")) return !1;
          const o = e.getFirstRange(),
            i = o.start.parent,
            r = o.end.parent;
          if ((Fw(i, t) || Fw(r, t)) && i !== r) return !1;
          return !0;
        }(t.schema, e.selection);
      }
    }
    function jw(t, e, n) {
      const o = e.createElement("softBreak");
      t.insertContent(o, n), e.setSelection(o, "after");
    }
    function Fw(t, e) {
      return !t.is("rootElement") && (e.isLimit(t) || Fw(t.parent, e));
    }
    class Vw extends Br {
      static get pluginName() {
        return "ShiftEnter";
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.conversion,
          o = t.editing.view,
          i = o.document,
          r = this.editor.t;
        e.register("softBreak", {
          allowWhere: "$text",
          isInline: !0
        }), n.for("upcast").elementToElement({
          model: "softBreak",
          view: "br"
        }), n.for("downcast").elementToElement({
          model: "softBreak",
          view: (t, {
            writer: e
          }) => e.createEmptyElement("br")
        }), o.addObserver(Lw), t.commands.add("shiftEnter", new Rw(t)), this.listenTo(i, "enter", (e, n) => {
          i.isComposing || n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), o.scrollToTheSelection());
        }, {
          priority: "low"
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: r("Insert a soft break (a <code>&lt;br&gt;</code> element)"),
            keystroke: "Shift+Enter"
          }]
        });
      }
    }
    class Hw extends M() {
      constructor() {
        super(...arguments), this._stack = [];
      }
      add(t, e) {
        const n = this._stack,
          o = n[0];
        this._insertDescriptor(t);
        const i = n[0];
        o === i || Uw(o, i) || this.fire("change:top", {
          oldDescriptor: o,
          newDescriptor: i,
          writer: e
        });
      }
      remove(t, e) {
        const n = this._stack,
          o = n[0];
        this._removeDescriptor(t);
        const i = n[0];
        o === i || Uw(o, i) || this.fire("change:top", {
          oldDescriptor: o,
          newDescriptor: i,
          writer: e
        });
      }
      _insertDescriptor(t) {
        const e = this._stack,
          n = e.findIndex(e => e.id === t.id);
        if (Uw(t, e[n])) return;
        n > -1 && e.splice(n, 1);
        let o = 0;
        for (; e[o] && qw(e[o], t);) o++;
        e.splice(o, 0, t);
      }
      _removeDescriptor(t) {
        const e = this._stack,
          n = e.findIndex(e => e.id === t);
        n > -1 && e.splice(n, 1);
      }
    }
    function Uw(t, e) {
      return t && e && t.priority == e.priority && Gw(t.classes) == Gw(e.classes);
    }
    function qw(t, e) {
      return t.priority > e.priority || !(t.priority < e.priority) && Gw(t.classes) > Gw(e.classes);
    }
    function Gw(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }
    const Ww = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>',
      Kw = "ck-widget",
      $w = "ck-widget_selected";
    function Yw(t) {
      return !!t.is("element") && !!t.getCustomProperty("widget");
    }
    function Qw(t, e, n = {}) {
      if (!t.is("containerElement")) throw new w("widget-to-widget-wrong-element-type", null, {
        element: t
      });
      return e.setAttribute("contenteditable", "false", t), e.addClass(Kw, t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = nA, e.setCustomProperty("widgetLabel", [], t), n.label && function (t, e) {
        const n = t.getCustomProperty("widgetLabel");
        n.push(e);
      }(t, n.label), n.hasSelectionHandle && function (t, e) {
        const n = e.createUIElement("div", {
          class: "ck ck-widget__selection-handle"
        }, function (t) {
          const e = this.toDomElement(t),
            n = new Dg();
          return n.set("content", Ww), n.render(), e.appendChild(n.element), e;
        });
        e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handle"], t);
      }(t, e), Xw(t, e), t;
    }
    function Zw(t, e, n) {
      if (e.classes && n.addClass(Ai(e.classes), t), e.attributes) for (const o in e.attributes) n.setAttribute(o, e.attributes[o], t);
    }
    function Jw(t, e, n) {
      if (e.classes && n.removeClass(Ai(e.classes), t), e.attributes) for (const o in e.attributes) n.removeAttribute(o, t);
    }
    function Xw(t, e, n = Zw, o = Jw) {
      const i = new Hw();
      i.on("change:top", (e, i) => {
        i.oldDescriptor && o(t, i.oldDescriptor, i.writer), i.newDescriptor && n(t, i.newDescriptor, i.writer);
      });
      e.setCustomProperty("addHighlight", (t, e, n) => i.add(e, n), t), e.setCustomProperty("removeHighlight", (t, e, n) => i.remove(e, n), t);
    }
    function tA(t, e, n = {}) {
      return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), e.setAttribute("role", "textbox", t), e.setAttribute("tabindex", "-1", t), n.label && e.setAttribute("aria-label", n.label, t), e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", (n, o, i) => {
        e.setAttribute("contenteditable", i ? "false" : "true", t);
      }), t.on("change:isFocused", (n, o, i) => {
        i ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
      }), Xw(t, e), t;
    }
    function eA(t, e) {
      const n = t.getSelectedElement();
      if (n) {
        const o = rA(t);
        if (o) return e.createRange(e.createPositionAt(n, o));
      }
      return e.schema.findOptimalInsertionRange(t);
    }
    function nA() {
      return null;
    }
    const oA = "widget-type-around";
    function iA(t, e, n) {
      return !!t && Yw(t) && !n.isInline(e);
    }
    function rA(t) {
      return t.getAttribute(oA);
    }
    var sA = n(8508),
      aA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(sA.A, aA);
    sA.A.locals;
    const cA = ["before", "after"],
      lA = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild,
      dA = "ck-widget__type-around_disabled";
    class uA extends Br {
      constructor() {
        super(...arguments), this._currentFakeCaretModelElement = null;
      }
      static get pluginName() {
        return "WidgetTypeAround";
      }
      static get requires() {
        return [zw, hw];
      }
      init() {
        const t = this.editor,
          e = t.editing.view;
        this.on("change:isEnabled", (n, o, i) => {
          e.change(t => {
            for (const n of e.document.roots) i ? t.removeClass(dA, n) : t.addClass(dA, n);
          }), i || t.model.change(t => {
            t.removeSelectionAttribute(oA);
          });
        }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
      }
      destroy() {
        super.destroy(), this._currentFakeCaretModelElement = null;
      }
      _insertParagraph(t, e) {
        const n = this.editor,
          o = n.editing.view,
          i = n.model.schema.getAttributesWithProperty(t, "copyOnReplace", !0);
        n.execute("insertParagraph", {
          position: n.model.createPositionAt(t, e),
          attributes: i
        }), o.focus(), o.scrollToTheSelection();
      }
      _listenToIfEnabled(t, e, n, o) {
        this.listenTo(t, e, (...t) => {
          this.isEnabled && n(...t);
        }, o);
      }
      _insertParagraphAccordingToFakeCaretPosition() {
        const t = this.editor.model.document.selection,
          e = rA(t);
        if (!e) return !1;
        const n = t.getSelectedElement();
        return this._insertParagraph(n, e), !0;
      }
      _enableTypeAroundUIInjection() {
        const t = this.editor,
          e = t.model.schema,
          n = t.locale.t,
          o = {
            before: n("Insert paragraph before block"),
            after: n("Insert paragraph after block")
          };
        t.editing.downcastDispatcher.on("insert", (t, i, r) => {
          const s = r.mapper.toViewElement(i.item);
          if (s && iA(s, i.item, e)) {
            !function (t, e, n) {
              const o = t.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__type-around"
              }, function (t) {
                const n = this.toDomElement(t);
                return function (t, e) {
                  for (const n of cA) {
                    const o = new nr({
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-widget__type-around__button", `ck-widget__type-around__button_${n}`],
                        title: e[n],
                        "aria-hidden": "true"
                      },
                      children: [t.ownerDocument.importNode(lA, !0)]
                    });
                    t.appendChild(o.render());
                  }
                }(n, e), function (t) {
                  const e = new nr({
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-widget__type-around__fake-caret"]
                    }
                  });
                  t.appendChild(e.render());
                }(n), n;
              });
              t.insert(t.createPositionAt(n, "end"), o);
            }(r.writer, o, s);
            s.getCustomProperty("widgetLabel").push(() => this.isEnabled ? n("Press Enter to type after or press Shift + Enter to type before the widget") : "");
          }
        }, {
          priority: "low"
        });
      }
      _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          o = e.schema,
          i = t.editing.view;
        function r(t) {
          return `ck-widget_type-around_show-fake-caret_${t}`;
        }
        this._listenToIfEnabled(i.document, "arrowKey", (t, e) => {
          this._handleArrowKeyPress(t, e);
        }, {
          context: [Yw, "$text"],
          priority: "high"
        }), this._listenToIfEnabled(n, "change:range", (e, n) => {
          n.directChange && t.model.change(t => {
            t.removeSelectionAttribute(oA);
          });
        }), this._listenToIfEnabled(e.document, "change:data", () => {
          const e = n.getSelectedElement();
          if (e) {
            if (iA(t.editing.mapper.toViewElement(e), e, o)) return;
          }
          t.model.change(t => {
            t.removeSelectionAttribute(oA);
          });
        }), this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", (t, e, n) => {
          const i = n.writer;
          if (this._currentFakeCaretModelElement) {
            const t = n.mapper.toViewElement(this._currentFakeCaretModelElement);
            t && (i.removeClass(cA.map(r), t), this._currentFakeCaretModelElement = null);
          }
          const s = e.selection.getSelectedElement();
          if (!s) return;
          const a = n.mapper.toViewElement(s);
          if (!iA(a, s, o)) return;
          const c = rA(e.selection);
          c && (i.addClass(r(c), a), this._currentFakeCaretModelElement = s);
        }), this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", (e, n, o) => {
          o || t.model.change(t => {
            t.removeSelectionAttribute(oA);
          });
        });
      }
      _handleArrowKeyPress(t, e) {
        const n = this.editor,
          o = n.model,
          i = o.document.selection,
          r = o.schema,
          s = n.editing.view,
          a = function (t, e) {
            const n = wi(t, e);
            return "down" === n || "right" === n;
          }(e.keyCode, n.locale.contentLanguageDirection),
          c = s.document.selection.getSelectedElement();
        let l;
        iA(c, n.editing.mapper.toModelElement(c), r) ? l = this._handleArrowKeyPressOnSelectedWidget(a) : i.isCollapsed ? l = this._handleArrowKeyPressWhenSelectionNextToAWidget(a) : e.shiftKey || (l = this._handleArrowKeyPressWhenNonCollapsedSelection(a)), l && (e.preventDefault(), t.stop());
      }
      _handleArrowKeyPressOnSelectedWidget(t) {
        const e = this.editor.model,
          n = rA(e.document.selection);
        return e.change(e => {
          if (!n) return e.setSelectionAttribute(oA, t ? "after" : "before"), !0;
          if (!(n === (t ? "after" : "before"))) return e.removeSelectionAttribute(oA), !0;
          return !1;
        });
      }
      _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
        const e = this.editor,
          n = e.model,
          o = n.schema,
          i = e.plugins.get("Widget"),
          r = i._getObjectElementNextToSelection(t);
        return !!iA(e.editing.mapper.toViewElement(r), r, o) && (n.change(e => {
          i._setSelectionOverElement(r), e.setSelectionAttribute(oA, t ? "before" : "after");
        }), !0);
      }
      _handleArrowKeyPressWhenNonCollapsedSelection(t) {
        const e = this.editor,
          n = e.model,
          o = n.schema,
          i = e.editing.mapper,
          r = n.document.selection,
          s = t ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter;
        return !!iA(i.toViewElement(s), s, o) && (n.change(e => {
          e.setSelection(s, "on"), e.setSelectionAttribute(oA, t ? "after" : "before");
        }), !0);
      }
      _enableInsertingParagraphsOnButtonClick() {
        const t = this.editor,
          e = t.editing.view;
        this._listenToIfEnabled(e.document, "mousedown", (n, o) => {
          const i = o.domTarget.closest(".ck-widget__type-around__button");
          if (!i) return;
          const r = function (t) {
              return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
            }(i),
            s = function (t, e) {
              const n = t.closest(".ck-widget");
              return e.mapDomToView(n);
            }(i, e.domConverter),
            a = t.editing.mapper.toModelElement(s);
          this._insertParagraph(a, r), o.preventDefault(), n.stop();
        });
      }
      _enableInsertingParagraphsOnEnterKeypress() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.editing.view;
        this._listenToIfEnabled(n.document, "enter", (n, o) => {
          if ("atTarget" != n.eventPhase) return;
          const i = e.getSelectedElement(),
            r = t.editing.mapper.toViewElement(i),
            s = t.model.schema;
          let a;
          this._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : iA(r, i, s) && (this._insertParagraph(i, o.isSoft ? "before" : "after"), a = !0), a && (o.preventDefault(), n.stop());
        }, {
          context: Yw
        });
      }
      _enableInsertingParagraphsOnTypingKeystroke() {
        const t = this.editor.editing.view.document;
        this._listenToIfEnabled(t, "insertText", (e, n) => {
          this._insertParagraphAccordingToFakeCaretPosition() && (n.selection = t.selection);
        }, {
          priority: "high"
        }), s.isAndroid ? this._listenToIfEnabled(t, "keydown", (t, e) => {
          229 == e.keyCode && this._insertParagraphAccordingToFakeCaretPosition();
        }) : this._listenToIfEnabled(t, "compositionstart", () => {
          this._insertParagraphAccordingToFakeCaretPosition();
        }, {
          priority: "high"
        });
      }
      _enableDeleteIntegration() {
        const t = this.editor,
          e = t.editing.view,
          n = t.model,
          o = n.schema;
        this._listenToIfEnabled(e.document, "delete", (e, i) => {
          if ("atTarget" != e.eventPhase) return;
          const r = rA(n.document.selection);
          if (!r) return;
          const s = i.direction,
            a = n.document.selection.getSelectedElement(),
            c = "forward" == s;
          if ("before" === r === c) t.execute("delete", {
            selection: n.createSelection(a, "on")
          });else {
            const e = o.getNearestSelectionRange(n.createPositionAt(a, r), s);
            if (e) if (e.isCollapsed) {
              const i = n.createSelection(e.start);
              if (n.modifySelection(i, {
                direction: s
              }), i.focus.isEqual(e.start)) {
                const t = function (t, e) {
                  let n = e;
                  for (const o of e.getAncestors({
                    parentFirst: !0
                  })) {
                    if (o.childCount > 1 || t.isLimit(o)) break;
                    n = o;
                  }
                  return n;
                }(o, e.start.parent);
                n.deleteContent(n.createSelection(t, "on"), {
                  doNotAutoparagraph: !0
                });
              } else n.change(n => {
                n.setSelection(e), t.execute(c ? "deleteForward" : "delete");
              });
            } else n.change(n => {
              n.setSelection(e), t.execute(c ? "deleteForward" : "delete");
            });
          }
          i.preventDefault(), e.stop();
        }, {
          context: Yw
        });
      }
      _enableInsertContentIntegration() {
        const t = this.editor,
          e = this.editor.model,
          n = e.document.selection;
        this._listenToIfEnabled(t.model, "insertContent", (t, [o, i]) => {
          if (i && !i.is("documentSelection")) return;
          const r = rA(n);
          return r ? (t.stop(), e.change(t => {
            const i = n.getSelectedElement(),
              s = e.createPositionAt(i, r),
              a = t.createSelection(s),
              c = e.insertContent(o, a);
            return t.setSelection(a), c;
          })) : void 0;
        }, {
          priority: "high"
        });
      }
      _enableInsertObjectIntegration() {
        const t = this.editor,
          e = this.editor.model.document.selection;
        this._listenToIfEnabled(t.model, "insertObject", (t, n) => {
          const [, o, i = {}] = n;
          if (o && !o.is("documentSelection")) return;
          const r = rA(e);
          r && (i.findOptimalPosition = r, n[3] = i);
        }, {
          priority: "high"
        });
      }
      _enableDeleteContentIntegration() {
        const t = this.editor,
          e = this.editor.model.document.selection;
        this._listenToIfEnabled(t.model, "deleteContent", (t, [n]) => {
          if (n && !n.is("documentSelection")) return;
          rA(e) && t.stop();
        }, {
          priority: "high"
        });
      }
    }
    function hA(t) {
      const e = t.model;
      return (n, o) => {
        const i = o.keyCode == mi.arrowup,
          r = o.keyCode == mi.arrowdown,
          s = o.shiftKey,
          a = e.document.selection;
        if (!i && !r) return;
        const c = r;
        if (s && function (t, e) {
          return !t.isCollapsed && t.isBackward == e;
        }(a, c)) return;
        const l = function (t, e, n) {
          const o = t.model;
          if (n) {
            const t = e.isCollapsed ? e.focus : e.getLastPosition(),
              n = gA(o, t, "forward");
            if (!n) return null;
            const i = o.createRange(t, n),
              r = mA(o.schema, i, "backward");
            return r ? o.createRange(t, r) : null;
          }
          {
            const t = e.isCollapsed ? e.focus : e.getFirstPosition(),
              n = gA(o, t, "backward");
            if (!n) return null;
            const i = o.createRange(n, t),
              r = mA(o.schema, i, "forward");
            return r ? o.createRange(r, t) : null;
          }
        }(t, a, c);
        if (l) {
          if (l.isCollapsed) {
            if (a.isCollapsed) return;
            if (s) return;
          }
          (l.isCollapsed || function (t, e, n) {
            const o = t.model,
              i = t.view.domConverter;
            if (n) {
              const t = o.createSelection(e.start);
              o.modifySelection(t), t.focus.isAtEnd || e.start.isEqual(t.focus) || (e = o.createRange(t.focus, e.end));
            }
            const r = t.mapper.toViewRange(e),
              s = i.viewRangeToDom(r),
              a = Ro.getDomRangeRects(s);
            let c;
            for (const t of a) if (void 0 !== c) {
              if (Math.round(t.top) >= c) return !1;
              c = Math.max(c, Math.round(t.bottom));
            } else c = Math.round(t.bottom);
            return !0;
          }(t, l, c)) && (e.change(t => {
            const n = c ? l.end : l.start;
            if (s) {
              const o = e.createSelection(a.anchor);
              o.setFocus(n), t.setSelection(o);
            } else t.setSelection(n);
          }), n.stop(), o.preventDefault(), o.stopPropagation());
        }
      };
    }
    function gA(t, e, n) {
      const o = t.schema,
        i = t.createRangeIn(e.root),
        r = "forward" == n ? "elementStart" : "elementEnd";
      for (const {
        previousPosition: t,
        item: s,
        type: a
      } of i.getWalker({
        startPosition: e,
        direction: n
      })) {
        if (o.isLimit(s) && !o.isInline(s)) return t;
        if (a == r && o.isBlock(s)) return null;
      }
      return null;
    }
    function mA(t, e, n) {
      const o = "backward" == n ? e.end : e.start;
      if (t.checkChild(o, "$text")) return o;
      for (const {
        nextPosition: o
      } of e.getWalker({
        direction: n
      })) if (t.checkChild(o, "$text")) return o;
      return null;
    }
    var pA = n(695),
      fA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(pA.A, fA);
    pA.A.locals;
    class kA extends Br {
      constructor() {
        super(...arguments), this._previouslySelected = new Set();
      }
      static get pluginName() {
        return "Widget";
      }
      static get requires() {
        return [uA, hw];
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document,
          o = t.t;
        this.editor.editing.downcastDispatcher.on("selection", (e, n, o) => {
          const i = o.writer,
            r = n.selection;
          if (r.isCollapsed) return;
          const s = r.getSelectedElement();
          if (!s) return;
          const a = t.editing.mapper.toViewElement(s);
          var c;
          Yw(a) && o.consumable.consume(r, "selection") && i.setSelection(i.createRangeOn(a), {
            fake: !0,
            label: (c = a, c.getCustomProperty("widgetLabel").reduce((t, e) => "function" == typeof e ? t ? t + ". " + e() : e() : t ? t + ". " + e : e, ""))
          });
        }), this.editor.editing.downcastDispatcher.on("selection", (t, e, n) => {
          this._clearPreviouslySelectedWidgets(n.writer);
          const o = n.writer,
            i = o.document.selection;
          let r = null;
          for (const t of i.getRanges()) for (const e of t) {
            const t = e.item;
            Yw(t) && !bA(t, r) && (o.addClass($w, t), this._previouslySelected.add(t), r = t);
          }
        }, {
          priority: "low"
        }), e.addObserver(Yh), this.listenTo(n, "mousedown", (...t) => this._onMousedown(...t)), this.listenTo(n, "arrowKey", (...t) => {
          this._handleSelectionChangeOnArrowKeyPress(...t);
        }, {
          context: [Yw, "$text"]
        }), this.listenTo(n, "arrowKey", (...t) => {
          this._preventDefaultOnArrowKeyPress(...t);
        }, {
          context: "$root"
        }), this.listenTo(n, "arrowKey", hA(this.editor.editing), {
          context: "$text"
        }), this.listenTo(n, "delete", (t, e) => {
          this._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
        }, {
          context: "$root"
        }), this.listenTo(n, "tab", (t, e) => {
          "atTarget" == t.eventPhase && (e.shiftKey || this._selectFirstNestedEditable() && (e.preventDefault(), t.stop()));
        }, {
          context: Yw,
          priority: "low"
        }), this.listenTo(n, "tab", (t, e) => {
          e.shiftKey && this._selectAncestorWidget() && (e.preventDefault(), t.stop());
        }, {
          priority: "low"
        }), this.listenTo(n, "keydown", (t, e) => {
          e.keystroke == mi.esc && this._selectAncestorWidget() && (e.preventDefault(), t.stop());
        }, {
          priority: "low"
        }), t.accessibility.addKeystrokeInfoGroup({
          id: "widget",
          label: o("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
          keystrokes: [{
            label: o("Insert a new paragraph directly after a widget"),
            keystroke: "Enter"
          }, {
            label: o("Insert a new paragraph directly before a widget"),
            keystroke: "Shift+Enter"
          }, {
            label: o("Move the caret to allow typing directly before a widget"),
            keystroke: [["arrowup"], ["arrowleft"]]
          }, {
            label: o("Move the caret to allow typing directly after a widget"),
            keystroke: [["arrowdown"], ["arrowright"]]
          }]
        });
      }
      _onMousedown(t, e) {
        const n = this.editor,
          o = n.editing.view,
          i = o.document;
        let r = e.target;
        if (e.domEvent.detail >= 3) return void (this._selectBlockContent(r) && e.preventDefault());
        if (function (t) {
          let e = t;
          for (; e;) {
            if (e.is("editableElement") && !e.is("rootElement")) return !0;
            if (Yw(e)) return !1;
            e = e.parent;
          }
          return !1;
        }(r)) return;
        if (!Yw(r) && (r = r.findAncestor(Yw), !r)) return;
        s.isAndroid && e.preventDefault(), i.isFocused || o.focus();
        const a = n.editing.mapper.toModelElement(r);
        this._setSelectionOverElement(a);
      }
      _selectBlockContent(t) {
        const e = this.editor,
          n = e.model,
          o = e.editing.mapper,
          i = n.schema,
          r = o.findMappedViewAncestor(this.editor.editing.view.createPositionAt(t, 0)),
          s = function (t, e) {
            for (const n of t.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            })) {
              if (e.checkChild(n, "$text")) return n;
              if (e.isLimit(n) && !e.isObject(n)) break;
            }
            return null;
          }(o.toModelElement(r), n.schema);
        return !!s && (n.change(t => {
          const e = i.isLimit(s) ? null : function (t, e) {
              const n = new sl({
                startPosition: t
              });
              for (const {
                item: t
              } of n) {
                if (e.isLimit(t) || !t.is("element")) return null;
                if (e.checkChild(t, "$text")) return t;
              }
              return null;
            }(t.createPositionAfter(s), i),
            n = t.createPositionAt(s, 0),
            o = e ? t.createPositionAt(e, 0) : t.createPositionAt(s, "end");
          t.setSelection(t.createRange(n, o));
        }), !0);
      }
      _handleSelectionChangeOnArrowKeyPress(t, e) {
        const n = e.keyCode,
          o = this.editor.model,
          i = o.schema,
          r = o.document.selection,
          s = r.getSelectedElement(),
          a = wi(n, this.editor.locale.contentLanguageDirection),
          c = "down" == a || "right" == a,
          l = "up" == a || "down" == a;
        if (s && i.isObject(s)) {
          const n = c ? r.getLastPosition() : r.getFirstPosition(),
            s = i.getNearestSelectionRange(n, c ? "forward" : "backward");
          return void (s && (o.change(t => {
            t.setSelection(s);
          }), e.preventDefault(), t.stop()));
        }
        if (!r.isCollapsed && !e.shiftKey) {
          const n = r.getFirstPosition(),
            s = r.getLastPosition(),
            a = n.nodeAfter,
            l = s.nodeBefore;
          return void ((a && i.isObject(a) || l && i.isObject(l)) && (o.change(t => {
            t.setSelection(c ? s : n);
          }), e.preventDefault(), t.stop()));
        }
        if (!r.isCollapsed) return;
        const d = this._getObjectElementNextToSelection(c);
        if (d && i.isObject(d)) {
          if (i.isInline(d) && l) return;
          this._setSelectionOverElement(d), e.preventDefault(), t.stop();
        }
      }
      _preventDefaultOnArrowKeyPress(t, e) {
        const n = this.editor.model,
          o = n.schema,
          i = n.document.selection.getSelectedElement();
        i && o.isObject(i) && (e.preventDefault(), t.stop());
      }
      _handleDelete(t) {
        const e = this.editor.model.document.selection;
        if (!this.editor.model.canEditAt(e)) return;
        if (!e.isCollapsed) return;
        const n = this._getObjectElementNextToSelection(t);
        return n ? (this.editor.model.change(t => {
          let o = e.anchor.parent;
          for (; o.isEmpty;) {
            const e = o;
            o = e.parent, t.remove(e);
          }
          this._setSelectionOverElement(n);
        }), !0) : void 0;
      }
      _setSelectionOverElement(t) {
        this.editor.model.change(e => {
          e.setSelection(e.createRangeOn(t));
        });
      }
      _getObjectElementNextToSelection(t) {
        const e = this.editor.model,
          n = e.schema,
          o = e.document.selection,
          i = e.createSelection(o);
        if (e.modifySelection(i, {
          direction: t ? "forward" : "backward"
        }), i.isEqual(o)) return null;
        const r = t ? i.focus.nodeBefore : i.focus.nodeAfter;
        return r && n.isObject(r) ? r : null;
      }
      _clearPreviouslySelectedWidgets(t) {
        for (const e of this._previouslySelected) t.removeClass($w, e);
        this._previouslySelected.clear();
      }
      _selectFirstNestedEditable() {
        const t = this.editor,
          e = this.editor.editing.view.document;
        for (const n of e.selection.getFirstRange().getItems()) if (n.is("editableElement")) {
          const e = t.editing.mapper.toModelElement(n);
          if (!e) continue;
          const o = t.model.createPositionAt(e, 0),
            i = t.model.schema.getNearestSelectionRange(o, "forward");
          return t.model.change(t => {
            t.setSelection(i);
          }), !0;
        }
        return !1;
      }
      _selectAncestorWidget() {
        const t = this.editor,
          e = t.editing.mapper,
          n = t.editing.view.document.selection.getFirstPosition().parent,
          o = (n.is("$text") ? n.parent : n).findAncestor(Yw);
        if (!o) return !1;
        const i = e.toModelElement(o);
        return !!i && (t.model.change(t => {
          t.setSelection(i, "on");
        }), !0);
      }
    }
    function bA(t, e) {
      return !!e && Array.from(t.getAncestors()).includes(e);
    }
    class wA extends Br {
      constructor() {
        super(...arguments), this._toolbarDefinitions = new Map();
      }
      static get requires() {
        return [Bf];
      }
      static get pluginName() {
        return "WidgetToolbarRepository";
      }
      init() {
        const t = this.editor;
        if (t.plugins.has("BalloonToolbar")) {
          const e = t.plugins.get("BalloonToolbar");
          this.listenTo(e, "show", e => {
            (function (t) {
              const e = t.getSelectedElement();
              return !(!e || !Yw(e));
            })(t.editing.view.document.selection) && e.stop();
          }, {
            priority: "high"
          });
        }
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", () => {
          this._updateToolbarsVisibility();
        }), this.listenTo(t.ui, "update", () => {
          this._updateToolbarsVisibility();
        }), this.listenTo(t.ui.focusTracker, "change:isFocused", () => {
          this._updateToolbarsVisibility();
        }, {
          priority: "low"
        });
      }
      destroy() {
        super.destroy();
        for (const t of this._toolbarDefinitions.values()) t.view.destroy();
      }
      register(t, {
        ariaLabel: e,
        items: n,
        getRelatedElement: o,
        balloonClassName: i = "ck-toolbar-container"
      }) {
        if (!n.length) return void A("widget-toolbar-no-items", {
          toolbarId: t
        });
        const r = this.editor,
          s = r.t,
          a = new Am(r.locale);
        if (a.ariaLabel = e || s("Widget toolbar"), this._toolbarDefinitions.has(t)) throw new w("widget-toolbar-duplicated", this, {
          toolbarId: t
        });
        const c = {
          view: a,
          getRelatedElement: o,
          balloonClassName: i,
          itemsConfig: n,
          initialized: !1
        };
        r.ui.addToolbar(a, {
          isContextual: !0,
          beforeFocus: () => {
            const t = o(r.editing.view.document.selection);
            t && this._showToolbar(c, t);
          },
          afterBlur: () => {
            this._hideToolbar(c);
          }
        }), this._toolbarDefinitions.set(t, c);
      }
      _updateToolbarsVisibility() {
        let t = 0,
          e = null,
          n = null;
        for (const o of this._toolbarDefinitions.values()) {
          const i = o.getRelatedElement(this.editor.editing.view.document.selection);
          if (this.isEnabled && i) {
            if (this.editor.ui.focusTracker.isFocused) {
              const r = i.getAncestors().length;
              r > t && (t = r, e = i, n = o);
            } else this._isToolbarVisible(o) && this._hideToolbar(o);
          } else this._isToolbarInBalloon(o) && this._hideToolbar(o);
        }
        n && this._showToolbar(n, e);
      }
      _hideToolbar(t) {
        this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
      }
      _showToolbar(t, e) {
        this._isToolbarVisible(t) ? AA(this.editor, e) : this._isToolbarInBalloon(t) || (t.initialized || (t.initialized = !0, t.view.fillFromConfig(t.itemsConfig, this.editor.ui.componentFactory)), this._balloon.add({
          view: t.view,
          position: _A(this.editor, e),
          balloonClassName: t.balloonClassName
        }), this.listenTo(this._balloon, "change:visibleView", () => {
          for (const t of this._toolbarDefinitions.values()) if (this._isToolbarVisible(t)) {
            const e = t.getRelatedElement(this.editor.editing.view.document.selection);
            AA(this.editor, e);
          }
        }));
      }
      _isToolbarVisible(t) {
        return this._balloon.visibleView === t.view;
      }
      _isToolbarInBalloon(t) {
        return this._balloon.hasView(t.view);
      }
    }
    function AA(t, e) {
      const n = t.plugins.get("ContextualBalloon"),
        o = _A(t, e);
      n.updatePosition(o);
    }
    function _A(t, e) {
      const n = t.editing.view,
        o = Op.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [o.northArrowSouth, o.northArrowSouthWest, o.northArrowSouthEast, o.southArrowNorth, o.southArrowNorthWest, o.southArrowNorthEast, o.viewportStickyNorth]
      };
    }
    G();
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    G();
    var CA = n(4095),
      vA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(CA.A, vA);
    CA.A.locals;
    const yA = Wo("px");
    class xA extends Dr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.set({
          isVisible: !1,
          left: null,
          top: null,
          width: null
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-clipboard-drop-target-line", t.if("isVisible", "ck-hidden", t => !t)],
            style: {
              left: t.to("left", t => yA(t)),
              top: t.to("top", t => yA(t)),
              width: t.to("width", t => yA(t))
            }
          }
        });
      }
    }
    class EA extends Br {
      constructor() {
        super(...arguments), this.removeDropMarkerDelayed = Qi(() => this.removeDropMarker(), 40), this._updateDropMarkerThrottled = Gp(t => this._updateDropMarker(t), 40), this._reconvertMarkerThrottled = Gp(() => {
          this.editor.model.markers.has("drop-target") && this.editor.editing.reconvertMarker("drop-target");
        }, 0), this._dropTargetLineView = new xA(), this._domEmitter = new (Mo())(), this._scrollables = new Map();
      }
      static get pluginName() {
        return "DragDropTarget";
      }
      init() {
        this._setupDropMarker();
      }
      destroy() {
        this._domEmitter.stopListening();
        for (const {
          resizeObserver: t
        } of this._scrollables.values()) t.destroy();
        return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), super.destroy();
      }
      updateDropMarker(t, e, n, o, i, r) {
        this.removeDropMarkerDelayed.cancel();
        const s = DA(this.editor, t, e, n, o, i, r);
        if (s) return r && r.containsRange(s) ? this.removeDropMarker() : void this._updateDropMarkerThrottled(s);
      }
      getFinalDropRange(t, e, n, o, i, r) {
        const s = DA(this.editor, t, e, n, o, i, r);
        return this.removeDropMarker(), s;
      }
      removeDropMarker() {
        const t = this.editor.model;
        this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = !1, t.markers.has("drop-target") && t.change(t => {
          t.removeMarker("drop-target");
        });
      }
      _setupDropMarker() {
        const t = this.editor;
        t.ui.view.body.add(this._dropTargetLineView), t.conversion.for("editingDowncast").markerToHighlight({
          model: "drop-target",
          view: {
            classes: ["ck-clipboard-drop-target-range"]
          }
        }), t.conversion.for("editingDowncast").markerToElement({
          model: "drop-target",
          view: (e, {
            writer: n
          }) => {
            if (t.model.schema.checkChild(e.markerRange.start, "$text")) return this._dropTargetLineView.isVisible = !1, this._createDropTargetPosition(n);
            e.markerRange.isCollapsed ? this._updateDropTargetLine(e.markerRange) : this._dropTargetLineView.isVisible = !1;
          }
        });
      }
      _updateDropMarker(t) {
        const e = this.editor,
          n = e.model.markers;
        e.model.change(e => {
          n.has("drop-target") ? n.get("drop-target").getRange().isEqual(t) || e.updateMarker("drop-target", {
            range: t
          }) : e.addMarker("drop-target", {
            range: t,
            usingOperation: !1,
            affectsData: !1
          });
        });
      }
      _createDropTargetPosition(t) {
        return t.createUIElement("span", {
          class: "ck ck-clipboard-drop-target-position"
        }, function (t) {
          const e = this.toDomElement(t);
          return e.append("⁠", t.createElement("span"), "⁠"), e;
        });
      }
      _updateDropTargetLine(t) {
        const n = this.editor.editing,
          o = t.start.nodeBefore,
          i = t.start.nodeAfter,
          r = t.start.parent,
          s = o ? n.mapper.toViewElement(o) : null,
          a = s ? n.view.domConverter.mapViewToDom(s) : null,
          c = i ? n.mapper.toViewElement(i) : null,
          l = c ? n.view.domConverter.mapViewToDom(c) : null,
          d = n.mapper.toViewElement(r);
        if (!d) return;
        const u = n.view.domConverter.mapViewToDom(d),
          h = this._getScrollableRect(d),
          {
            scrollX: g,
            scrollY: m
          } = e.window,
          p = a ? new Ro(a) : null,
          f = l ? new Ro(l) : null,
          k = new Ro(u).excludeScrollbarsAndBorders(),
          b = p ? p.bottom : k.top,
          w = f ? f.top : k.bottom,
          A = e.window.getComputedStyle(u),
          _ = b <= w ? (b + w) / 2 : w;
        if (h.top < _ && _ < h.bottom) {
          const t = k.left + parseFloat(A.paddingLeft),
            e = k.right - parseFloat(A.paddingRight),
            n = Math.max(t + g, h.left),
            o = Math.min(e + g, h.right);
          this._dropTargetLineView.set({
            isVisible: !0,
            left: n,
            top: _ + m,
            width: o - n
          });
        } else this._dropTargetLineView.isVisible = !1;
      }
      _getScrollableRect(t) {
        const n = t.root.rootName;
        let o;
        if (this._scrollables.has(n)) o = this._scrollables.get(n).domElement;else {
          o = function (t) {
            let n = t;
            do {
              n = n.parentElement;
              const t = e.window.getComputedStyle(n).overflowY;
              if ("auto" == t || "scroll" == t) break;
            } while ("BODY" != n.tagName);
            return n;
          }(this.editor.editing.view.domConverter.mapViewToDom(t)), this._domEmitter.listenTo(o, "scroll", this._reconvertMarkerThrottled, {
            usePassive: !0
          });
          const i = new qo(o, this._reconvertMarkerThrottled);
          this._scrollables.set(n, {
            domElement: o,
            resizeObserver: i
          });
        }
        return new Ro(o).excludeScrollbarsAndBorders();
      }
    }
    function DA(t, e, n, o, i, r, s) {
      const a = t.model,
        c = t.editing.mapper;
      let l = SA(t, e);
      for (; l;) {
        if (!r) if (a.schema.checkChild(l, "$text")) {
          if (n) {
            const e = n[0].start,
              r = c.toModelPosition(e);
            if (!s || Array.from(s.getItems()).every(t => a.schema.checkChild(r, t))) {
              if (a.schema.checkChild(r, "$text")) return a.createRange(r);
              if (e) return TA(t, SA(t, e.parent), o, i);
            }
          }
        } else if (a.schema.isInline(l)) return TA(t, l, o, i);
        if (a.schema.isBlock(l)) return TA(t, l, o, i);
        if (a.schema.checkChild(l, "$block")) {
          const e = Array.from(l.getChildren()).filter(e => e.is("element") && !IA(t, e));
          let n = 0,
            r = e.length;
          if (0 == r) return a.createRange(a.createPositionAt(l, "end"));
          for (; n < r - 1;) {
            const s = Math.floor((n + r) / 2);
            "before" == MA(t, e[s], o, i) ? r = s : n = s;
          }
          return TA(t, e[n], o, i);
        }
        l = l.parent;
      }
      return null;
    }
    function IA(t, n) {
      const o = t.editing.mapper,
        i = t.editing.view.domConverter,
        r = o.toViewElement(n);
      if (!r) return !0;
      const s = i.mapViewToDom(r);
      return "none" != e.window.getComputedStyle(s).float;
    }
    function TA(t, e, n, o) {
      const i = t.model;
      return i.createRange(i.createPositionAt(e, MA(t, e, n, o)));
    }
    function MA(t, e, n, o) {
      const i = t.editing.mapper,
        r = t.editing.view.domConverter,
        s = i.toViewElement(e),
        a = r.mapViewToDom(s),
        c = new Ro(a);
      return t.model.schema.isInline(e) ? n < (c.left + c.right) / 2 ? "before" : "after" : o < (c.top + c.bottom) / 2 ? "before" : "after";
    }
    function SA(t, e) {
      const n = t.editing.mapper,
        o = t.editing.view,
        i = n.toModelElement(e);
      if (i) return i;
      const r = o.createPositionBefore(e),
        s = n.findMappedViewAncestor(r);
      return n.toModelElement(s);
    }
    var BA = Object.defineProperty,
      NA = Object.defineProperties,
      PA = Object.getOwnPropertyDescriptors,
      OA = Object.getOwnPropertySymbols,
      LA = Object.prototype.hasOwnProperty,
      zA = Object.prototype.propertyIsEnumerable,
      RA = (t, e, n) => e in t ? BA(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class jA extends Br {
      constructor() {
        super(...arguments), this._isBlockDragging = !1, this._domEmitter = new (Mo())();
      }
      static get pluginName() {
        return "DragDropBlockToolbar";
      }
      init() {
        const t = this.editor;
        if (this.listenTo(t, "change:isReadOnly", (t, e, n) => {
          n ? (this.forceDisabled("readOnlyMode"), this._isBlockDragging = !1) : this.clearForceDisabled("readOnlyMode");
        }), s.isAndroid && this.forceDisabled("noAndroidSupport"), t.plugins.has("BlockToolbar")) {
          const n = t.plugins.get("BlockToolbar").buttonView.element;
          this._domEmitter.listenTo(n, "dragstart", (t, e) => this._handleBlockDragStart(e)), this._domEmitter.listenTo(e.document, "dragover", (t, e) => this._handleBlockDragging(e)), this._domEmitter.listenTo(e.document, "drop", (t, e) => this._handleBlockDragging(e)), this._domEmitter.listenTo(e.document, "dragend", () => this._handleBlockDragEnd(), {
            useCapture: !0
          }), this.isEnabled && n.setAttribute("draggable", "true"), this.on("change:isEnabled", (t, e, o) => {
            n.setAttribute("draggable", o ? "true" : "false");
          });
        }
      }
      destroy() {
        return this._domEmitter.stopListening(), super.destroy();
      }
      _handleBlockDragStart(t) {
        if (!this.isEnabled) return;
        const e = this.editor.model,
          n = e.document.selection,
          o = this.editor.editing.view,
          i = Array.from(n.getSelectedBlocks()),
          r = e.createRange(e.createPositionBefore(i[0]), e.createPositionAfter(i[i.length - 1]));
        e.change(t => t.setSelection(r)), this._isBlockDragging = !0, o.focus(), o.getObserver(yb).onDomEvent(t);
      }
      _handleBlockDragging(t) {
        if (!this.isEnabled || !this._isBlockDragging) return;
        const e = t.clientX + ("ltr" == this.editor.locale.contentLanguageDirection ? 100 : -100),
          n = t.clientY,
          o = document.elementFromPoint(e, n),
          i = this.editor.editing.view;
        var r, s;
        o && o.closest(".ck-editor__editable") && i.getObserver(yb).onDomEvent((r = ((t, e) => {
          for (var n in e || (e = {})) LA.call(e, n) && RA(t, n, e[n]);
          if (OA) for (var n of OA(e)) zA.call(e, n) && RA(t, n, e[n]);
          return t;
        })({}, t), s = {
          type: t.type,
          dataTransfer: t.dataTransfer,
          target: o,
          clientX: e,
          clientY: n,
          preventDefault: () => t.preventDefault(),
          stopPropagation: () => t.stopPropagation()
        }, NA(r, PA(s))));
      }
      _handleBlockDragEnd() {
        this._isBlockDragging = !1;
      }
    }
    var FA = n(7793),
      VA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(FA.A, VA);
    FA.A.locals;
    class HA extends Br {
      constructor() {
        super(...arguments), this._clearDraggableAttributesDelayed = Qi(() => this._clearDraggableAttributes(), 40), this._blockMode = !1, this._domEmitter = new (Mo())();
      }
      static get pluginName() {
        return "DragDrop";
      }
      static get requires() {
        return [Jb, kA, EA, jA];
      }
      init() {
        const t = this.editor,
          e = t.editing.view;
        this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, e.addObserver(yb), e.addObserver(Yh), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(t, "change:isReadOnly", (t, e, n) => {
          n ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
        }), this.on("change:isEnabled", (t, e, n) => {
          n || this._finalizeDragging(!1);
        }), s.isAndroid && this.forceDisabled("noAndroidSupport");
      }
      destroy() {
        return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), super.destroy();
      }
      _setupDragging() {
        const t = this.editor,
          n = t.model,
          o = t.editing.view,
          i = o.document,
          r = t.plugins.get(EA);
        this.listenTo(i, "dragstart", (t, e) => {
          if (e.target && e.target.is("editableElement")) return void e.preventDefault();
          if (this._prepareDraggedRange(e.target), !this._draggedRange) return void e.preventDefault();
          this._draggingUid = p(), e.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy", e.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
          const o = n.createSelection(this._draggedRange.toRange());
          this.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(e.dataTransfer, o, "dragstart");
          const {
              dataTransfer: i,
              domTarget: r,
              domEvent: s
            } = e,
            {
              clientX: a
            } = s;
          this._updatePreview({
            dataTransfer: i,
            domTarget: r,
            clientX: a
          }), e.stopPropagation(), this.isEnabled || (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
        }, {
          priority: "low"
        }), this.listenTo(i, "dragend", (t, e) => {
          this._finalizeDragging(!e.dataTransfer.isCanceled && "move" == e.dataTransfer.dropEffect);
        }, {
          priority: "low"
        }), this._domEmitter.listenTo(e.document, "dragend", () => {
          this._blockMode = !1;
        }, {
          useCapture: !0
        }), this.listenTo(i, "dragenter", () => {
          this.isEnabled && o.focus();
        }), this.listenTo(i, "dragleave", () => {
          r.removeDropMarkerDelayed();
        }), this.listenTo(i, "dragging", (t, e) => {
          if (!this.isEnabled) return void (e.dataTransfer.dropEffect = "none");
          const {
            clientX: n,
            clientY: o
          } = e.domEvent;
          r.updateDropMarker(e.target, e.targetRanges, n, o, this._blockMode, this._draggedRange), this._draggedRange || (e.dataTransfer.dropEffect = "copy"), s.isGecko || ("copy" == e.dataTransfer.effectAllowed ? e.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(e.dataTransfer.effectAllowed) && (e.dataTransfer.dropEffect = "move")), t.stop();
        }, {
          priority: "low"
        });
      }
      _setupClipboardInputIntegration() {
        const t = this.editor,
          e = t.editing.view.document,
          n = t.plugins.get(EA);
        this.listenTo(e, "clipboardInput", (e, o) => {
          if ("drop" != o.method) return;
          const {
              clientX: i,
              clientY: r
            } = o.domEvent,
            s = n.getFinalDropRange(o.target, o.targetRanges, i, r, this._blockMode, this._draggedRange);
          if (!s) return this._finalizeDragging(!1), void e.stop();
          this._draggedRange && this._draggingUid != o.dataTransfer.getData("application/ckeditor5-dragging-uid") && (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
          if ("move" == UA(o.dataTransfer) && this._draggedRange && this._draggedRange.containsRange(s, !0)) return this._finalizeDragging(!1), void e.stop();
          o.targetRanges = [t.editing.mapper.toViewRange(s)];
        }, {
          priority: "high"
        });
      }
      _setupContentInsertionIntegration() {
        const t = this.editor.plugins.get(Jb);
        t.on("contentInsertion", (t, e) => {
          if (!this.isEnabled || "drop" !== e.method) return;
          const n = e.targetRanges.map(t => this.editor.editing.mapper.toModelRange(t));
          this.editor.model.change(t => t.setSelection(n));
        }, {
          priority: "high"
        }), t.on("contentInsertion", (t, e) => {
          if (!this.isEnabled || "drop" !== e.method) return;
          const n = "move" == UA(e.dataTransfer),
            o = !e.resultRange || !e.resultRange.isCollapsed;
          this._finalizeDragging(o && n);
        }, {
          priority: "lowest"
        });
      }
      _setupDraggableAttributeHandling() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document;
        this.listenTo(n, "mousedown", (o, i) => {
          if (s.isAndroid || !i) return;
          this._clearDraggableAttributesDelayed.cancel();
          let r = qA(i.target);
          if (s.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
            const t = n.selection.getSelectedElement();
            t && Yw(t) || (r = n.selection.editableElement);
          }
          r && (e.change(t => {
            t.setAttribute("draggable", "true", r);
          }), this._draggableElement = t.editing.mapper.toModelElement(r));
        }), this.listenTo(n, "mouseup", () => {
          s.isAndroid || this._clearDraggableAttributesDelayed();
        });
      }
      _clearDraggableAttributes() {
        const t = this.editor.editing;
        t.view.change(e => {
          this._draggableElement && "$graveyard" != this._draggableElement.root.rootName && e.removeAttribute("draggable", t.mapper.toViewElement(this._draggableElement)), this._draggableElement = null;
        });
      }
      _finalizeDragging(t) {
        const e = this.editor,
          n = e.model;
        if (e.plugins.get(EA).removeDropMarker(), this._clearDraggableAttributes(), e.plugins.has("WidgetToolbarRepository")) {
          e.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop");
        }
        this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (t && this.isEnabled && n.change(t => {
          const e = n.createSelection(this._draggedRange);
          n.deleteContent(e, {
            doNotAutoparagraph: !0
          });
          const o = e.getFirstPosition().parent;
          o.isEmpty && !n.schema.checkChild(o, "$text") && n.schema.checkChild(o, "paragraph") && t.insertElement("paragraph", o, 0);
        }), this._draggedRange.detach(), this._draggedRange = null);
      }
      _prepareDraggedRange(t) {
        const e = this.editor,
          n = e.model,
          o = n.document.selection,
          i = t ? qA(t) : null;
        if (i) {
          const t = e.editing.mapper.toModelElement(i);
          if (this._draggedRange = zl.fromRange(n.createRangeOn(t)), this._blockMode = n.schema.isBlock(t), e.plugins.has("WidgetToolbarRepository")) {
            e.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
          }
          return;
        }
        if (o.isCollapsed && !o.getFirstPosition().parent.isEmpty) return;
        const r = Array.from(o.getSelectedBlocks()),
          s = o.getFirstRange();
        if (0 == r.length) return void (this._draggedRange = zl.fromRange(s));
        const a = GA(n, r);
        if (r.length > 1) this._draggedRange = zl.fromRange(a), this._blockMode = !0;else if (1 == r.length) {
          const t = s.start.isTouching(a.start) && s.end.isTouching(a.end);
          this._draggedRange = zl.fromRange(t ? a : s), this._blockMode = t;
        }
        n.change(t => t.setSelection(this._draggedRange.toRange()));
      }
      _updatePreview({
        dataTransfer: t,
        domTarget: n,
        clientX: o
      }) {
        const i = this.editor.editing.view,
          r = i.document.selection.editableElement,
          a = i.domConverter.mapViewToDom(r),
          c = e.window.getComputedStyle(a);
        this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = kt(e.document, "div", {
          style: "position: fixed; left: -999999px;"
        }), e.document.body.appendChild(this._previewContainer));
        const l = new Ro(a);
        if (a.contains(n)) return;
        const d = parseFloat(c.paddingLeft),
          u = kt(e.document, "div");
        u.className = "ck ck-content", u.style.width = c.width, u.style.paddingLeft = `${l.left - o + d}px`, s.isiOS && (u.style.backgroundColor = "white"), u.innerHTML = t.getData("text/html"), t.setDragImage(u, 0, 0), this._previewContainer.appendChild(u);
      }
    }
    function UA(t) {
      return s.isGecko ? t.dropEffect : ["all", "copyMove"].includes(t.effectAllowed) ? "move" : "copy";
    }
    function qA(t) {
      if (t.is("editableElement")) return null;
      if (t.hasClass("ck-widget__selection-handle")) return t.findAncestor(Yw);
      if (Yw(t)) return t;
      const e = t.findAncestor(t => Yw(t) || t.is("editableElement"));
      return Yw(e) ? e : null;
    }
    function GA(t, e) {
      const n = e[0],
        o = e[e.length - 1],
        i = n.getCommonAncestor(o),
        r = t.createPositionBefore(n),
        s = t.createPositionAfter(o);
      if (i && i.is("element") && !t.schema.isLimit(i)) {
        const e = t.createRangeOn(i),
          n = r.isTouching(e.start),
          o = s.isTouching(e.end);
        if (n && o) return GA(t, [i]);
      }
      return t.createRange(r, s);
    }
    class WA extends Br {
      static get pluginName() {
        return "PastePlainText";
      }
      static get requires() {
        return [Jb];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          o = n.document,
          i = e.document.selection;
        let r = !1;
        n.addObserver(yb), this.listenTo(o, "keydown", (t, e) => {
          r = e.shiftKey;
        }), t.plugins.get(Jb).on("contentInsertion", (t, n) => {
          (r || function (t, e) {
            if (t.childCount > 1) return !1;
            const n = t.getChild(0);
            if (e.isObject(n)) return !1;
            return 0 == Array.from(n.getAttributeKeys()).length;
          }(n.content, e.schema)) && e.change(t => {
            const o = Array.from(i.getAttributes()).filter(([t]) => e.schema.getAttributeProperties(t).isFormatting);
            i.isCollapsed || e.deleteContent(i, {
              doNotAutoparagraph: !0
            }), o.push(...i.getAttributes());
            const r = t.createRangeIn(n.content);
            for (const e of r.getItems()) e.is("$textProxy") && t.setAttributes(o, e);
          });
        });
      }
    }
    class KA extends Br {
      static get pluginName() {
        return "Clipboard";
      }
      static get requires() {
        return [Zb, Jb, HA, WA];
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Copy selected content"),
            keystroke: "CTRL+C"
          }, {
            label: e("Paste content"),
            keystroke: "CTRL+V"
          }, {
            label: e("Paste content as plain text"),
            keystroke: "CTRL+SHIFT+V"
          }]
        });
      }
    }
    class $A extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1;
      }
      execute() {
        const t = this.editor.model,
          e = t.document.selection;
        let n = t.schema.getLimitElement(e);
        if (e.containsEntireContent(n) || !YA(t.schema, n)) do {
          if (n = n.parent, !n) return;
        } while (!YA(t.schema, n));
        t.change(t => {
          t.setSelection(n, "in");
        });
      }
    }
    function YA(t, e) {
      return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"));
    }
    const QA = ki("Ctrl+A");
    class ZA extends Br {
      static get pluginName() {
        return "SelectAllEditing";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = t.editing.view.document;
        t.commands.add("selectAll", new $A(t)), this.listenTo(n, "keydown", (e, n) => {
          fi(n) === QA && (t.execute("selectAll"), n.preventDefault());
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Select all"),
            keystroke: "CTRL+A"
          }]
        });
      }
    }
    class JA extends Br {
      static get pluginName() {
        return "SelectAllUI";
      }
      init() {
        const t = this.editor;
        t.ui.componentFactory.add("selectAll", () => {
          const t = this._createButton(Sg);
          return t.set({
            tooltip: !0
          }), t;
        }), t.ui.componentFactory.add("menuBar:selectAll", () => this._createButton(Yk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          o = e.commands.get("selectAll"),
          i = new t(e.locale),
          r = n.t;
        return i.set({
          label: r("Select all"),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
          keystroke: "Ctrl+A"
        }), i.bind("isEnabled").to(o, "isEnabled"), this.listenTo(i, "execute", () => {
          e.execute("selectAll"), e.editing.view.focus();
        }), i;
      }
    }
    class XA extends Br {
      static get requires() {
        return [ZA, JA];
      }
      static get pluginName() {
        return "SelectAll";
      }
    }
    var t_ = Object.defineProperty,
      e_ = Object.getOwnPropertySymbols,
      n_ = Object.prototype.hasOwnProperty,
      o_ = Object.prototype.propertyIsEnumerable,
      i_ = (t, e, n) => e in t ? t_(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class r_ extends Pr {
      constructor(t) {
        super(t), this._stack = [], this._createdBatches = new WeakSet(), this.refresh(), this._isEnabledBasedOnSelection = !1, this.listenTo(t.data, "set", (t, e) => {
          e[1] = ((t, e) => {
            for (var n in e || (e = {})) n_.call(e, n) && i_(t, n, e[n]);
            if (e_) for (var n of e_(e)) o_.call(e, n) && i_(t, n, e[n]);
            return t;
          })({}, e[1]);
          const n = e[1];
          n.batchType || (n.batchType = {
            isUndoable: !1
          });
        }, {
          priority: "high"
        }), this.listenTo(t.data, "set", (t, e) => {
          e[1].batchType.isUndoable || this.clearStack();
        });
      }
      refresh() {
        this.isEnabled = this._stack.length > 0;
      }
      get createdBatches() {
        return this._createdBatches;
      }
      addBatch(t) {
        const e = this.editor.model.document.selection,
          n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          };
        this._stack.push({
          batch: t,
          selection: n
        }), this.refresh();
      }
      clearStack() {
        this._stack = [], this.refresh();
      }
      _restoreSelection(t, e, n) {
        const o = this.editor.model,
          i = o.document,
          r = [],
          s = t.map(t => t.getTransformedByOperations(n)),
          a = s.flat();
        for (const t of s) {
          const e = t.filter(t => t.root != i.graveyard).filter(t => !a_(t, a));
          e.length && (s_(e), r.push(e[0]));
        }
        r.length && o.change(t => {
          t.setSelection(r, {
            backward: e
          });
        });
      }
      _undo(t, e) {
        const n = this.editor.model,
          o = n.document;
        this._createdBatches.add(e);
        const i = t.operations.slice().filter(t => t.isDocumentOperation);
        i.reverse();
        for (const t of i) {
          const i = t.baseVersion + 1,
            r = Array.from(o.history.getOperations(i)),
            s = Bu([t.getReversed()], r, {
              useRelations: !0,
              document: this.editor.model.document,
              padWithNoOps: !1,
              forceWeakRemove: !0
            }).operationsA;
          for (let i of s) {
            const r = i.affectedSelectable;
            r && !n.canEditAt(r) && (i = new Cu(i.baseVersion)), e.addOperation(i), n.applyOperation(i), o.history.setOperationAsUndone(t, i);
          }
        }
      }
    }
    function s_(t) {
      t.sort((t, e) => t.start.isBefore(e.start) ? -1 : 1);
      for (let e = 1; e < t.length; e++) {
        const n = t[e - 1].getJoined(t[e], !0);
        n && (e--, t.splice(e, 2, n));
      }
    }
    function a_(t, e) {
      return e.some(e => e !== t && e.containsRange(t, !0));
    }
    class c_ extends r_ {
      execute(t = null) {
        const e = t ? this._stack.findIndex(e => e.batch == t) : this._stack.length - 1,
          n = this._stack.splice(e, 1)[0],
          o = this.editor.model.createBatch({
            isUndo: !0
          });
        this.editor.model.enqueueChange(o, () => {
          this._undo(n.batch, o);
          const t = this.editor.model.document.history.getOperations(n.batch.baseVersion);
          this._restoreSelection(n.selection.ranges, n.selection.isBackward, t);
        }), this.fire("revert", n.batch, o), this.refresh();
      }
    }
    class l_ extends r_ {
      execute() {
        const t = this._stack.pop(),
          e = this.editor.model.createBatch({
            isUndo: !0
          });
        this.editor.model.enqueueChange(e, () => {
          const n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
            o = this.editor.model.document.history.getOperations(n);
          this._restoreSelection(t.selection.ranges, t.selection.isBackward, o), this._undo(t.batch, e);
        }), this.refresh();
      }
    }
    class d_ extends Br {
      constructor() {
        super(...arguments), this._batchRegistry = new WeakSet();
      }
      static get pluginName() {
        return "UndoEditing";
      }
      init() {
        const t = this.editor,
          e = t.t;
        this._undoCommand = new c_(t), this._redoCommand = new l_(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", (t, e) => {
          const n = e[0];
          if (!n.isDocumentOperation) return;
          const o = n.batch,
            i = this._redoCommand.createdBatches.has(o),
            r = this._undoCommand.createdBatches.has(o);
          this._batchRegistry.has(o) || (this._batchRegistry.add(o), o.isUndoable && (i ? this._undoCommand.addBatch(o) : r || (this._undoCommand.addBatch(o), this._redoCommand.clearStack())));
        }, {
          priority: "highest"
        }), this.listenTo(this._undoCommand, "revert", (t, e, n) => {
          this._redoCommand.addBatch(n);
        }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo"), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Undo"),
            keystroke: "CTRL+Z"
          }, {
            label: e("Redo"),
            keystroke: [["CTRL+Y"], ["CTRL+SHIFT+Z"]]
          }]
        });
      }
    }
    class u_ extends Br {
      static get pluginName() {
        return "UndoUI";
      }
      init() {
        const t = this.editor,
          e = t.locale,
          n = t.t,
          o = "ltr" == e.uiLanguageDirection ? gg.undo : gg.redo,
          i = "ltr" == e.uiLanguageDirection ? gg.redo : gg.undo;
        this._addButtonsToFactory("undo", n("Undo"), "CTRL+Z", o), this._addButtonsToFactory("redo", n("Redo"), "CTRL+Y", i);
      }
      _addButtonsToFactory(t, e, n, o) {
        const i = this.editor;
        i.ui.componentFactory.add(t, () => {
          const i = this._createButton(Sg, t, e, n, o);
          return i.set({
            tooltip: !0
          }), i;
        }), i.ui.componentFactory.add("menuBar:" + t, () => this._createButton(Yk, t, e, n, o));
      }
      _createButton(t, e, n, o, i) {
        const r = this.editor,
          s = r.locale,
          a = r.commands.get(e),
          c = new t(s);
        return c.set({
          label: n,
          icon: i,
          keystroke: o
        }), c.bind("isEnabled").to(a, "isEnabled"), this.listenTo(c, "execute", () => {
          r.execute(e), r.editing.view.focus();
        }), c;
      }
    }
    class h_ extends Br {
      static get requires() {
        return [d_, u_];
      }
      static get pluginName() {
        return "Undo";
      }
    }
    class g_ extends G() {
      constructor() {
        super();
        const t = new window.FileReader();
        this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = t => {
          this.loaded = t.loaded;
        };
      }
      get error() {
        return this._reader.error;
      }
      get data() {
        return this._data;
      }
      read(t) {
        const e = this._reader;
        return this.total = t.size, new Promise((n, o) => {
          e.onload = () => {
            const t = e.result;
            this._data = t, n(t);
          }, e.onerror = () => {
            o("error");
          }, e.onabort = () => {
            o("aborted");
          }, this._reader.readAsDataURL(t);
        });
      }
      abort() {
        this._reader.abort();
      }
    }
    class m_ extends Br {
      constructor() {
        super(...arguments), this.loaders = new Gi(), this._loadersMap = new Map(), this._pendingAction = null;
      }
      static get pluginName() {
        return "FileRepository";
      }
      static get requires() {
        return [hg];
      }
      init() {
        this.loaders.on("change", () => this._updatePendingAction()), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t, e) => e ? t / e * 100 : 0);
      }
      getLoader(t) {
        return this._loadersMap.get(t) || null;
      }
      createLoader(t) {
        if (!this.createUploadAdapter) return A("filerepository-no-upload-adapter"), null;
        const e = new p_(Promise.resolve(t), this.createUploadAdapter);
        return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(t => {
          this._loadersMap.set(t, e);
        }).catch(() => {}), e.on("change:uploaded", () => {
          let t = 0;
          for (const e of this.loaders) t += e.uploaded;
          this.uploaded = t;
        }), e.on("change:uploadTotal", () => {
          let t = 0;
          for (const e of this.loaders) e.uploadTotal && (t += e.uploadTotal);
          this.uploadTotal = t;
        }), e;
      }
      destroyLoader(t) {
        const e = t instanceof p_ ? t : this.getLoader(t);
        e._destroy(), this.loaders.remove(e), this._loadersMap.forEach((t, n) => {
          t === e && this._loadersMap.delete(n);
        });
      }
      _updatePendingAction() {
        const t = this.editor.plugins.get(hg);
        if (this.loaders.length) {
          if (!this._pendingAction) {
            const e = this.editor.t,
              n = t => `${e("Upload in progress")} ${parseInt(t)}%.`;
            this._pendingAction = t.add(n(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", n);
          }
        } else t.remove(this._pendingAction), this._pendingAction = null;
      }
    }
    class p_ extends G() {
      constructor(t, e) {
        super(), this.id = p(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new g_(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t, e) => e ? t / e * 100 : 0), this.set("uploadResponse", null);
      }
      get file() {
        return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(t => this._filePromiseWrapper ? t : null) : Promise.resolve(null);
      }
      get data() {
        return this._reader.data;
      }
      read() {
        if ("idle" != this.status) throw new w("filerepository-read-wrong-status", this);
        return this.status = "reading", this.file.then(t => this._reader.read(t)).then(t => {
          if ("reading" !== this.status) throw this.status;
          return this.status = "idle", t;
        }).catch(t => {
          if ("aborted" === t) throw this.status = "aborted", "aborted";
          throw this.status = "error", this._reader.error ? this._reader.error : t;
        });
      }
      upload() {
        if ("idle" != this.status) throw new w("filerepository-upload-wrong-status", this);
        return this.status = "uploading", this.file.then(() => this._adapter.upload()).then(t => (this.uploadResponse = t, this.status = "idle", t)).catch(t => {
          if ("aborted" === this.status) throw "aborted";
          throw this.status = "error", t;
        });
      }
      abort() {
        const t = this.status;
        this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(() => {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
      }
      _destroy() {
        this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
      }
      _createFilePromiseWrapper(t) {
        const e = {};
        return e.promise = new Promise((n, o) => {
          e.rejecter = o, e.isFulfilled = !1, t.then(t => {
            e.isFulfilled = !0, n(t);
          }).catch(t => {
            e.isFulfilled = !0, o(t);
          });
        }), e;
      }
    }
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    const f_ = "ckCsrfToken",
      k_ = "abcdefghijklmnopqrstuvwxyz0123456789";
    function b_() {
      let t = function (t) {
        t = t.toLowerCase();
        const e = document.cookie.split(";");
        for (const n of e) {
          const e = n.split("=");
          if (decodeURIComponent(e[0].trim().toLowerCase()) === t) return decodeURIComponent(e[1]);
        }
        return null;
      }(f_);
      var e, n;
      return t && 40 == t.length || (t = function (t) {
        let e = "";
        const n = new Uint8Array(t);
        window.crypto.getRandomValues(n);
        for (let t = 0; t < n.length; t++) {
          const o = k_.charAt(n[t] % k_.length);
          e += Math.random() > .5 ? o.toUpperCase() : o;
        }
        return e;
      }(40), e = f_, n = t, document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(n) + ";path=/"), t;
    }
    class w_ {
      constructor(t, e, n) {
        this.loader = t, this.url = e, this.t = n;
      }
      upload() {
        return this.loader.file.then(t => new Promise((e, n) => {
          this._initRequest(), this._initListeners(e, n, t), this._sendRequest(t);
        }));
      }
      abort() {
        this.xhr && this.xhr.abort();
      }
      _initRequest() {
        const t = this.xhr = new XMLHttpRequest();
        t.open("POST", this.url, !0), t.responseType = "json";
      }
      _initListeners(t, e, n) {
        const o = this.xhr,
          i = this.loader,
          r = (0, this.t)("Cannot upload file:") + ` ${n.name}.`;
        o.addEventListener("error", () => e(r)), o.addEventListener("abort", () => e()), o.addEventListener("load", () => {
          const n = o.response;
          if (!n || !n.uploaded) return e(n && n.error && n.error.message ? n.error.message : r);
          t({
            default: n.url
          });
        }), o.upload && o.upload.addEventListener("progress", t => {
          t.lengthComputable && (i.uploadTotal = t.total, i.uploaded = t.loaded);
        });
      }
      _sendRequest(t) {
        const e = new FormData();
        e.append("upload", t), e.append("ckCsrfToken", b_()), this.xhr.send(e);
      }
    }
    function A_(t, e, n, o) {
      let i,
        r = null;
      "function" == typeof o ? i = o : (r = t.commands.get(o), i = () => {
        t.execute(o);
      }), t.model.document.on("change:data", (s, a) => {
        if (r && !r.isEnabled || !e.isEnabled) return;
        const c = Wi(t.model.document.selection.getRanges());
        if (!c.isCollapsed) return;
        if (a.isUndo || !a.isLocal) return;
        const l = Array.from(t.model.document.differ.getChanges()),
          d = l[0];
        if (1 != l.length || "insert" !== d.type || "$text" != d.name || 1 != d.length) return;
        const u = d.position.parent;
        if (u.is("element", "codeBlock")) return;
        if (u.is("element", "listItem") && "function" != typeof o && !["numberedList", "bulletedList", "todoList"].includes(o)) return;
        if (r && !0 === r.value) return;
        const h = u.getChild(0),
          g = t.model.createRangeOn(h);
        if (!g.containsRange(c) && !c.end.isEqual(g.end)) return;
        const m = n.exec(h.data.substr(0, c.end.offset));
        m && t.model.enqueueChange(e => {
          const n = e.createPositionAt(u, 0),
            o = e.createPositionAt(u, m[0].length),
            r = new zl(n, o);
          if (!1 !== i({
            match: m
          })) {
            e.remove(r);
            const n = t.model.document.selection.getFirstRange(),
              o = e.createRangeIn(u);
            !u.isEmpty || o.isEqual(n) || o.containsRange(n, !0) || e.remove(u);
          }
          r.detach(), t.model.enqueueChange(() => {
            t.plugins.get("Delete").requestUndoOnBackspace();
          });
        });
      });
    }
    function __(t, e, n, o) {
      let i, r;
      n instanceof RegExp ? i = n : r = n, r = r || (t => {
        let e;
        const n = [],
          o = [];
        for (; null !== (e = i.exec(t)) && !(e && e.length < 4);) {
          let {
            index: t,
            1: i,
            2: r,
            3: s
          } = e;
          const a = i + r + s;
          t += e[0].length - a.length;
          const c = [t, t + i.length],
            l = [t + i.length + r.length, t + i.length + r.length + s.length];
          n.push(c), n.push(l), o.push([t + i.length, t + i.length + r.length]);
        }
        return {
          remove: n,
          format: o
        };
      }), t.model.document.on("change:data", (n, i) => {
        if (i.isUndo || !i.isLocal || !e.isEnabled) return;
        const s = t.model,
          a = s.document.selection;
        if (!a.isCollapsed) return;
        const c = Array.from(s.document.differ.getChanges()),
          l = c[0];
        if (1 != c.length || "insert" !== l.type || "$text" != l.name || 1 != l.length) return;
        const d = a.focus,
          u = d.parent,
          {
            text: h,
            range: g
          } = function (t, e) {
            let n = t.start;
            const o = Array.from(t.getItems()).reduce((t, o) => !o.is("$text") && !o.is("$textProxy") || o.getAttribute("code") ? (n = e.createPositionAfter(o), "") : t + o.data, "");
            return {
              text: o,
              range: e.createRange(n, t.end)
            };
          }(s.createRange(s.createPositionAt(u, 0), d), s),
          m = r(h),
          p = C_(g.start, m.format, s),
          f = C_(g.start, m.remove, s);
        p.length && f.length && s.enqueueChange(e => {
          if (!1 !== o(e, p)) {
            for (const t of f.reverse()) e.remove(t);
            s.enqueueChange(() => {
              t.plugins.get("Delete").requestUndoOnBackspace();
            });
          }
        });
      });
    }
    function C_(t, e, n) {
      return e.filter(t => void 0 !== t[0] && void 0 !== t[1]).map(e => n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1])));
    }
    function v_(t, e) {
      return (n, o) => {
        if (!t.commands.get(e).isEnabled) return !1;
        const i = t.model.schema.getValidRanges(o, e);
        for (const t of i) n.setAttribute(e, !0, t);
        n.removeSelectionAttribute(e);
      };
    }
    class y_ extends Pr {
      constructor(t, e) {
        super(t), this.attributeKey = e;
      }
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
      }
      execute(t = {}) {
        const e = this.editor.model,
          n = e.document.selection,
          o = void 0 === t.forceValue ? !this.value : t.forceValue;
        e.change(t => {
          if (n.isCollapsed) o ? t.setSelectionAttribute(this.attributeKey, !0) : t.removeSelectionAttribute(this.attributeKey);else {
            const i = e.schema.getValidRanges(n.getRanges(), this.attributeKey);
            for (const e of i) o ? t.setAttribute(this.attributeKey, o, e) : t.removeAttribute(this.attributeKey, e);
          }
        });
      }
      _getValueFromFirstAllowedNode() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection;
        if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
        for (const t of n.getRanges()) for (const n of t.getItems()) if (e.checkAttribute(n, this.attributeKey)) return n.hasAttribute(this.attributeKey);
        return !1;
      }
    }
    const x_ = "bold";
    class E_ extends Br {
      static get pluginName() {
        return "BoldEditing";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: x_
        }), t.model.schema.setAttributeProperties(x_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: x_,
          view: "strong",
          upcastAlso: ["b", t => {
            const e = t.getStyle("font-weight");
            return e && ("bold" == e || Number(e) >= 600) ? {
              name: !0,
              styles: ["font-weight"]
            } : null;
          }]
        }), t.commands.add(x_, new y_(t, x_)), t.keystrokes.set("CTRL+B", x_), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Bold text"),
            keystroke: "CTRL+B"
          }]
        });
      }
    }
    function D_({
      editor: t,
      commandName: e,
      plugin: n,
      icon: o,
      label: i,
      keystroke: r
    }) {
      return s => {
        const a = t.commands.get(e),
          c = new s(t.locale);
        return c.set({
          label: i,
          icon: o,
          keystroke: r,
          isToggleable: !0
        }), c.bind("isEnabled").to(a, "isEnabled"), n.listenTo(c, "execute", () => {
          t.execute(e), t.editing.view.focus();
        }), c;
      };
    }
    const I_ = "bold";
    class T_ extends Br {
      static get pluginName() {
        return "BoldUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = t.commands.get(I_),
          o = D_({
            editor: t,
            commandName: I_,
            plugin: this,
            icon: gg.bold,
            label: e("Bold"),
            keystroke: "CTRL+B"
          });
        t.ui.componentFactory.add(I_, () => {
          const t = o(Sg);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(n, "value"), t;
        }), t.ui.componentFactory.add("menuBar:" + I_, () => o(Yk));
      }
    }
    var M_ = n(4199),
      S_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(M_.A, S_);
    M_.A.locals;
    const B_ = "italic";
    class N_ extends Br {
      static get pluginName() {
        return "ItalicEditing";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: B_
        }), t.model.schema.setAttributeProperties(B_, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: B_,
          view: "i",
          upcastAlso: ["em", {
            styles: {
              "font-style": "italic"
            }
          }]
        }), t.commands.add(B_, new y_(t, B_)), t.keystrokes.set("CTRL+I", B_), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Italic text"),
            keystroke: "CTRL+I"
          }]
        });
      }
    }
    const P_ = "italic";
    class O_ extends Br {
      static get pluginName() {
        return "ItalicUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get(P_),
          n = t.locale.t,
          o = D_({
            editor: t,
            commandName: P_,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
            keystroke: "CTRL+I",
            label: n("Italic")
          });
        t.ui.componentFactory.add(P_, () => {
          const t = o(Sg);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(e, "value"), t;
        }), t.ui.componentFactory.add("menuBar:" + P_, () => o(Yk));
      }
    }
    class L_ extends Pr {
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute(t = {}) {
        const e = this.editor.model,
          n = e.schema,
          o = e.document.selection,
          i = Array.from(o.getSelectedBlocks()),
          r = void 0 === t.forceValue ? !this.value : t.forceValue;
        e.change(t => {
          if (r) {
            const e = i.filter(t => z_(t) || j_(n, t));
            this._applyQuote(t, e);
          } else this._removeQuote(t, i.filter(z_));
        });
      }
      _getValue() {
        const t = Wi(this.editor.model.document.selection.getSelectedBlocks());
        return !(!t || !z_(t));
      }
      _checkEnabled() {
        if (this.value) return !0;
        const t = this.editor.model.document.selection,
          e = this.editor.model.schema,
          n = Wi(t.getSelectedBlocks());
        return !!n && j_(e, n);
      }
      _removeQuote(t, e) {
        R_(t, e).reverse().forEach(e => {
          if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);
          if (e.start.isAtStart) {
            const n = t.createPositionBefore(e.start.parent);
            return void t.move(e, n);
          }
          e.end.isAtEnd || t.split(e.end);
          const n = t.createPositionAfter(e.end.parent);
          t.move(e, n);
        });
      }
      _applyQuote(t, e) {
        const n = [];
        R_(t, e).reverse().forEach(e => {
          let o = z_(e.start);
          o || (o = t.createElement("blockQuote"), t.wrap(e, o)), n.push(o);
        }), n.reverse().reduce((e, n) => e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n);
      }
    }
    function z_(t) {
      return "blockQuote" == t.parent.name ? t.parent : null;
    }
    function R_(t, e) {
      let n,
        o = 0;
      const i = [];
      for (; o < e.length;) {
        const r = e[o],
          s = e[o + 1];
        n || (n = t.createPositionBefore(r)), s && r.nextSibling == s || (i.push(t.createRange(n, t.createPositionAfter(r))), n = null), o++;
      }
      return i;
    }
    function j_(t, e) {
      const n = t.checkChild(e.parent, "blockQuote"),
        o = t.checkChild(["$root", "blockQuote"], e);
      return n && o;
    }
    class F_ extends Br {
      static get pluginName() {
        return "BlockQuoteEditing";
      }
      static get requires() {
        return [zw, hw];
      }
      init() {
        const t = this.editor,
          e = t.model.schema;
        t.commands.add("blockQuote", new L_(t)), e.register("blockQuote", {
          inheritAllFrom: "$container"
        }), t.conversion.elementToElement({
          model: "blockQuote",
          view: "blockquote"
        }), t.model.document.registerPostFixer(n => {
          const o = t.model.document.differ.getChanges();
          for (const t of o) if ("insert" == t.type) {
            const o = t.position.nodeAfter;
            if (!o) continue;
            if (o.is("element", "blockQuote") && o.isEmpty) return n.remove(o), !0;
            if (o.is("element", "blockQuote") && !e.checkChild(t.position, o)) return n.unwrap(o), !0;
            if (o.is("element")) {
              const t = n.createRangeIn(o);
              for (const o of t.getItems()) if (o.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(o), o)) return n.unwrap(o), !0;
            }
          } else if ("remove" == t.type) {
            const e = t.position.parent;
            if (e.is("element", "blockQuote") && e.isEmpty) return n.remove(e), !0;
          }
          return !1;
        });
        const n = this.editor.editing.view.document,
          o = t.model.document.selection,
          i = t.commands.get("blockQuote");
        this.listenTo(n, "enter", (e, n) => {
          if (!o.isCollapsed || !i.value) return;
          o.getLastPosition().parent.isEmpty && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
        }, {
          context: "blockquote"
        }), this.listenTo(n, "delete", (e, n) => {
          if ("backward" != n.direction || !o.isCollapsed || !i.value) return;
          const r = o.getLastPosition().parent;
          r.isEmpty && !r.previousSibling && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
        }, {
          context: "blockquote"
        });
      }
    }
    var V_ = n(8708),
      H_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(V_.A, H_);
    V_.A.locals;
    class U_ extends Br {
      static get pluginName() {
        return "BlockQuoteUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get("blockQuote");
        t.ui.componentFactory.add("blockQuote", () => {
          const t = this._createButton(Sg);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(e, "value"), t;
        }), t.ui.componentFactory.add("menuBar:blockQuote", () => this._createButton(Yk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          o = e.commands.get("blockQuote"),
          i = new t(e.locale),
          r = n.t;
        return i.set({
          label: r("Block quote"),
          icon: gg.quote,
          isToggleable: !0
        }), i.bind("isEnabled").to(o, "isEnabled"), this.listenTo(i, "execute", () => {
          e.execute("blockQuote"), e.editing.view.focus();
        }), i;
      }
    }
    class q_ extends Br {
      static get pluginName() {
        return "CKBoxUI";
      }
      afterInit() {
        const t = this.editor;
        if (!t.commands.get("ckbox")) return;
        const e = t.t,
          n = t.ui.componentFactory;
        if (n.add("ckbox", () => {
          const t = this._createButton(Sg);
          return t.tooltip = !0, t;
        }), n.add("menuBar:ckbox", () => this._createButton(Yk)), t.plugins.has("ImageInsertUI")) {
          const n = t.plugins.get("ImageInsertUI");
          n.registerIntegration({
            name: "assetManager",
            observable: () => t.commands.get("ckbox"),
            buttonViewCreator: () => {
              const t = this.editor.ui.componentFactory.create("ckbox");
              return t.icon = gg.imageAssetManager, t.bind("label").to(n, "isImageSelected", t => e(t ? "Replace image with file manager" : "Insert image with file manager")), t;
            },
            formViewCreator: () => {
              const t = this.editor.ui.componentFactory.create("ckbox");
              return t.icon = gg.imageAssetManager, t.withText = !0, t.bind("label").to(n, "isImageSelected", t => e(t ? "Replace with file manager" : "Insert with file manager")), t.on("execute", () => {
                n.dropdownView.isOpen = !1;
              }), t;
            }
          });
        }
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          o = new t(n),
          i = e.commands.get("ckbox"),
          r = n.t;
        return o.set({
          label: r("Open file manager"),
          icon: gg.browseFiles
        }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), o.on("execute", () => {
          e.execute("ckbox");
        }), o;
      }
    }
    var G_ = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"],
      W_ = t => {
        let e = 0;
        for (let n = 0; n < t.length; n++) {
          let o = t[n];
          e = 83 * e + G_.indexOf(o);
        }
        return e;
      },
      K_ = t => {
        let e = t / 255;
        return e <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
      },
      $_ = t => {
        let e = Math.max(0, Math.min(1, t));
        return e <= .0031308 ? Math.trunc(12.92 * e * 255 + .5) : Math.trunc(255 * (1.055 * Math.pow(e, .4166666666666667) - .055) + .5);
      },
      Y_ = (t, e) => (t => t < 0 ? -1 : 1)(t) * Math.pow(Math.abs(t), e),
      Q_ = class extends Error {
        constructor(t) {
          super(t), this.name = "ValidationError", this.message = t;
        }
      },
      Z_ = t => {
        if (!t || t.length < 6) throw new Q_("The blurhash string must be at least 6 characters");
        let e = W_(t[0]),
          n = Math.floor(e / 9) + 1,
          o = e % 9 + 1;
        if (t.length !== 4 + 2 * o * n) throw new Q_(`blurhash length mismatch: length is ${t.length} but it should be ${4 + 2 * o * n}`);
      },
      J_ = t => {
        let e = t >> 8 & 255,
          n = 255 & t;
        return [K_(t >> 16), K_(e), K_(n)];
      },
      X_ = (t, e) => {
        let n = Math.floor(t / 361),
          o = Math.floor(t / 19) % 19,
          i = t % 19;
        return [Y_((n - 9) / 9, 2) * e, Y_((o - 9) / 9, 2) * e, Y_((i - 9) / 9, 2) * e];
      },
      tC = (t, e, n, o) => {
        Z_(t), o |= 1;
        let i = W_(t[0]),
          r = Math.floor(i / 9) + 1,
          s = i % 9 + 1,
          a = (W_(t[1]) + 1) / 166,
          c = new Array(s * r);
        for (let e = 0; e < c.length; e++) if (0 === e) {
          let n = W_(t.substring(2, 6));
          c[e] = J_(n);
        } else {
          let n = W_(t.substring(4 + 2 * e, 6 + 2 * e));
          c[e] = X_(n, a * o);
        }
        let l = 4 * e,
          d = new Uint8ClampedArray(l * n);
        for (let t = 0; t < n; t++) for (let o = 0; o < e; o++) {
          let i = 0,
            a = 0,
            u = 0;
          for (let l = 0; l < r; l++) for (let r = 0; r < s; r++) {
            let d = Math.cos(Math.PI * o * r / e) * Math.cos(Math.PI * t * l / n),
              h = c[r + l * s];
            i += h[0] * d, a += h[1] * d, u += h[2] * d;
          }
          let h = $_(i),
            g = $_(a),
            m = $_(u);
          d[4 * o + 0 + t * l] = h, d[4 * o + 1 + t * l] = g, d[4 * o + 2 + t * l] = m, d[4 * o + 3 + t * l] = 255;
        }
        return d;
      },
      eC = Object.defineProperty,
      nC = Object.getOwnPropertySymbols,
      oC = Object.prototype.hasOwnProperty,
      iC = Object.prototype.propertyIsEnumerable,
      rC = (t, e, n) => e in t ? eC(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    function sC(t) {
      const e = [];
      let n = 0;
      for (const o in t) {
        const i = parseInt(o, 10);
        isNaN(i) || (i > n && (n = i), e.push(`${t[o]} ${o}w`));
      }
      const o = [{
        srcset: e.join(","),
        sizes: `(max-width: ${n}px) 100vw, ${n}px`,
        type: "image/webp"
      }];
      return {
        imageFallbackUrl: t.default,
        imageSources: o
      };
    }
    const aC = 32;
    function cC({
      url: t,
      method: e = "GET",
      data: n,
      onUploadProgress: o,
      signal: i,
      authorization: r
    }) {
      const s = new XMLHttpRequest();
      s.open(e, t.toString()), s.setRequestHeader("Authorization", r), s.setRequestHeader("CKBox-Version", "CKEditor 5"), s.responseType = "json";
      const a = () => {
        s.abort();
      };
      return new Promise((t, e) => {
        i.throwIfAborted(), i.addEventListener("abort", a), s.addEventListener("loadstart", () => {
          i.addEventListener("abort", a);
        }), s.addEventListener("loadend", () => {
          i.removeEventListener("abort", a);
        }), s.addEventListener("error", () => {
          e();
        }), s.addEventListener("abort", () => {
          e();
        }), s.addEventListener("load", () => {
          const n = s.response;
          if (!n || n.statusCode >= 400) return e(n && n.message);
          t(n);
        }), o && s.upload.addEventListener("progress", t => {
          o(t);
        }), s.send(n);
      });
    }
    const lC = {
      "image/gif": "gif",
      "image/jpeg": "jpg",
      "image/png": "png",
      "image/webp": "webp",
      "image/bmp": "bmp",
      "image/tiff": "tiff"
    };
    function dC(t, e) {
      return n = this, o = null, i = function* () {
        try {
          const n = yield fetch(t, ((t, e) => {
            for (var n in e || (e = {})) oC.call(e, n) && rC(t, n, e[n]);
            if (nC) for (var n of nC(e)) iC.call(e, n) && rC(t, n, e[n]);
            return t;
          })({
            method: "HEAD",
            cache: "force-cache"
          }, e));
          return n.ok && n.headers.get("content-type") || "";
        } catch (t) {
          return "";
        }
      }, new Promise((t, e) => {
        var r = t => {
            try {
              a(i.next(t));
            } catch (t) {
              e(t);
            }
          },
          s = t => {
            try {
              a(i.throw(t));
            } catch (t) {
              e(t);
            }
          },
          a = e => e.done ? t(e.value) : Promise.resolve(e.value).then(r, s);
        a((i = i.apply(n, o)).next());
      });
      var n, o, i;
    }
    var uC = Object.defineProperty,
      hC = Object.getOwnPropertySymbols,
      gC = Object.prototype.hasOwnProperty,
      mC = Object.prototype.propertyIsEnumerable,
      pC = (t, e, n) => e in t ? uC(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      fC = (t, e) => {
        for (var n in e || (e = {})) gC.call(e, n) && pC(t, n, e[n]);
        if (hC) for (var n of hC(e)) mC.call(e, n) && pC(t, n, e[n]);
        return t;
      };
    class kC extends Pr {
      constructor(t) {
        super(t), this._chosenAssets = new Set(), this._wrapper = null, this._initListeners();
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        this.fire("ckbox:open");
      }
      _getValue() {
        return null !== this._wrapper;
      }
      _checkEnabled() {
        const t = this.editor.commands.get("insertImage"),
          e = this.editor.commands.get("link");
        return !(!t.isEnabled && !e.isEnabled);
      }
      _prepareOptions() {
        const t = this.editor.config.get("ckbox");
        return {
          theme: t.theme,
          language: t.language,
          tokenUrl: t.tokenUrl,
          serviceOrigin: t.serviceOrigin,
          forceDemoLabel: t.forceDemoLabel,
          dialog: {
            onClose: () => this.fire("ckbox:close")
          },
          assets: {
            onChoose: t => this.fire("ckbox:choose", t)
          }
        };
      }
      _initListeners() {
        const t = this.editor,
          e = t.model,
          n = !t.config.get("ckbox.ignoreDataId");
        this.on("ckbox", () => {
          this.refresh();
        }, {
          priority: "low"
        }), this.on("ckbox:open", () => {
          this.isEnabled && !this.value && (this._wrapper = kt(document, "div", {
            class: "ck ckbox-wrapper"
          }), document.body.appendChild(this._wrapper), window.CKBox.mount(this._wrapper, this._prepareOptions()));
        }), this.on("ckbox:close", () => {
          this.value && (this._wrapper.remove(), this._wrapper = null, t.editing.view.focus());
        }), this.on("ckbox:choose", (o, i) => {
          if (!this.isEnabled) return;
          const r = t.commands.get("insertImage"),
            s = t.commands.get("link"),
            a = function ({
              assets: t,
              isImageAllowed: e,
              isLinkAllowed: n
            }) {
              return t.map(t => function (t) {
                const e = t.data.metadata;
                if (!e) return !1;
                return e.width && e.height;
              }(t) ? {
                id: t.data.id,
                type: "image",
                attributes: bC(t)
              } : {
                id: t.data.id,
                type: "link",
                attributes: wC(t)
              }).filter(t => "image" === t.type ? e : n);
            }({
              assets: i,
              isImageAllowed: r.isEnabled,
              isLinkAllowed: s.isEnabled
            }),
            c = a.length;
          0 !== c && (e.change(t => {
            for (const e of a) {
              const o = e === a[c - 1],
                i = 1 === c;
              this._insertAsset(e, o, t, i), n && (setTimeout(() => this._chosenAssets.delete(e), 1e3), this._chosenAssets.add(e));
            }
          }), t.editing.view.focus());
        }), this.listenTo(t, "destroy", () => {
          this.fire("ckbox:close"), this._chosenAssets.clear();
        });
      }
      _insertAsset(t, e, n, o) {
        const i = this.editor.model.document.selection;
        n.removeSelectionAttribute("linkHref"), "image" === t.type ? this._insertImage(t) : this._insertLink(t, n, o), e || n.setSelection(i.getLastPosition());
      }
      _insertImage(t) {
        const e = this.editor,
          {
            imageFallbackUrl: n,
            imageSources: o,
            imageTextAlternative: i,
            imageWidth: r,
            imageHeight: s,
            imagePlaceholder: a
          } = t.attributes;
        e.execute("insertImage", {
          source: fC({
            src: n,
            sources: o,
            alt: i,
            width: r,
            height: s
          }, a ? {
            placeholder: a
          } : null)
        });
      }
      _insertLink(t, e, n) {
        const o = this.editor,
          i = o.model,
          r = i.document.selection,
          {
            linkName: s,
            linkHref: a
          } = t.attributes;
        if (r.isCollapsed) {
          const t = Yi(r.getAttributes()),
            c = e.createText(s, t);
          if (!n) {
            const t = r.getLastPosition(),
              n = t.parent;
            "paragraph" === n.name && n.isEmpty || o.execute("insertParagraph", {
              position: t
            });
            const s = i.insertContent(c);
            return e.setSelection(s), void o.execute("link", a);
          }
          const l = i.insertContent(c);
          e.setSelection(l);
        }
        o.execute("link", a);
      }
    }
    function bC(t) {
      const {
          imageFallbackUrl: e,
          imageSources: n
        } = sC(t.data.imageUrls),
        {
          description: o,
          width: i,
          height: r,
          blurHash: s
        } = t.data.metadata,
        a = function (t) {
          if (t) try {
            const e = `${aC}px`,
              n = document.createElement("canvas");
            n.setAttribute("width", e), n.setAttribute("height", e);
            const o = n.getContext("2d");
            if (!o) return;
            const i = o.createImageData(aC, aC),
              r = tC(t, aC, aC);
            return i.data.set(r), o.putImageData(i, 0, 0), n.toDataURL();
          } catch (t) {
            return;
          }
        }(s);
      return fC({
        imageFallbackUrl: e,
        imageSources: n,
        imageTextAlternative: o || "",
        imageWidth: i,
        imageHeight: r
      }, a ? {
        imagePlaceholder: a
      } : null);
    }
    function wC(t) {
      return {
        linkName: t.data.name,
        linkHref: AC(t)
      };
    }
    function AC(t) {
      const e = new URL(t.data.url);
      return e.searchParams.set("download", "true"), e.toString();
    }
    var _C = (t, e, n) => new Promise((o, i) => {
      var r = t => {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        },
        s = t => {
          try {
            a(n.throw(t));
          } catch (t) {
            i(t);
          }
        },
        a = t => t.done ? o(t.value) : Promise.resolve(t.value).then(r, s);
      a((n = n.apply(t, e)).next());
    });
    class CC extends Br {
      static get pluginName() {
        return "CKBoxUtils";
      }
      static get requires() {
        return ["CloudServices"];
      }
      init() {
        return _C(this, null, function* () {
          const t = this.editor,
            e = !!t.config.get("ckbox"),
            n = !!window.CKBox;
          if (!e && !n) return;
          t.config.define("ckbox", {
            serviceOrigin: "https://api.ckbox.io",
            defaultUploadCategories: null,
            ignoreDataId: !1,
            language: t.locale.uiLanguage,
            theme: "lark",
            tokenUrl: t.config.get("cloudServices.tokenUrl")
          });
          const o = t.plugins.get("CloudServices"),
            i = t.config.get("cloudServices.tokenUrl"),
            r = t.config.get("ckbox.tokenUrl");
          if (!r) throw new w("ckbox-plugin-missing-token-url", this);
          this._token = r == i ? o.token : yield o.registerTokenUrl(r);
        });
      }
      getToken() {
        return this._token;
      }
      getWorkspaceId() {
        const t = (0, this.editor.t)("Cannot access default workspace."),
          e = this.editor.config.get("ckbox.defaultUploadWorkspaceId"),
          n = function (t, e) {
            const [, n] = t.value.split("."),
              o = JSON.parse(atob(n)),
              i = o.auth && o.auth.ckbox && o.auth.ckbox.workspaces || [o.aud];
            return e ? "superadmin" == (o.auth && o.auth.ckbox && o.auth.ckbox.role) || i.includes(e) ? e : null : i[0];
          }(this._token, e);
        if (null == n) throw _("ckbox-access-default-workspace-error"), t;
        return n;
      }
      getCategoryIdForFile(t, e) {
        return _C(this, null, function* () {
          const n = (0, this.editor.t)("Cannot determine a category for the uploaded file."),
            o = this.editor.config.get("ckbox.defaultUploadCategories"),
            i = this._getAvailableCategories(e),
            r = "string" == typeof t ? (s = yield dC(t, e), lC[s]) : function (t) {
              const e = t.name,
                n = new RegExp("\\.(?<ext>[^.]+)$");
              return e.match(n).groups.ext.toLowerCase();
            }(t);
          var s;
          const a = yield i;
          if (!a) throw n;
          if (o) {
            const t = Object.keys(o).find(t => o[t].find(t => t.toLowerCase() == r));
            if (t) {
              const e = a.find(e => e.id === t || e.name === t);
              if (!e) throw n;
              return e.id;
            }
          }
          const c = a.find(t => t.extensions.find(t => t.toLowerCase() == r));
          if (!c) throw n;
          return c.id;
        });
      }
      _getAvailableCategories(t) {
        return _C(this, null, function* () {
          const e = this.editor,
            n = this._token,
            {
              signal: o
            } = t,
            i = e.config.get("ckbox.serviceOrigin"),
            r = this.getWorkspaceId();
          try {
            const t = [];
            let e,
              n = 0;
            do {
              const o = yield s(n);
              t.push(...o.items), e = o.totalCount - (n + 50), n += 50;
            } while (e > 0);
            return t;
          } catch (t) {
            return o.throwIfAborted(), void _("ckbox-fetch-category-http-error");
          }
          function s(t) {
            const e = new URL("categories", i);
            return e.searchParams.set("limit", 50..toString()), e.searchParams.set("offset", t.toString()), e.searchParams.set("workspaceId", r), cC({
              url: e,
              signal: o,
              authorization: n.value
            });
          }
        });
      }
    }
    var vC = (t, e, n) => new Promise((o, i) => {
      var r = t => {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        },
        s = t => {
          try {
            a(n.throw(t));
          } catch (t) {
            i(t);
          }
        },
        a = t => t.done ? o(t.value) : Promise.resolve(t.value).then(r, s);
      a((n = n.apply(t, e)).next());
    });
    class yC extends Br {
      static get requires() {
        return ["ImageUploadEditing", "ImageUploadProgress", m_, EC];
      }
      static get pluginName() {
        return "CKBoxUploadAdapter";
      }
      afterInit() {
        return vC(this, null, function* () {
          const t = this.editor,
            e = !!t.config.get("ckbox"),
            n = !!window.CKBox;
          if (!e && !n) return;
          const o = t.plugins.get(m_),
            i = t.plugins.get(CC);
          o.createUploadAdapter = e => new xC(e, t, i);
          const r = !t.config.get("ckbox.ignoreDataId"),
            s = t.plugins.get("ImageUploadEditing");
          r && s.on("uploadComplete", (e, {
            imageElement: n,
            data: o
          }) => {
            t.model.change(t => {
              t.setAttribute("ckboxImageId", o.ckboxImageId, n);
            });
          });
        });
      }
    }
    class xC {
      constructor(t, e, n) {
        this.loader = t, this.token = n.getToken(), this.ckboxUtils = n, this.editor = e, this.controller = new AbortController(), this.serviceOrigin = e.config.get("ckbox.serviceOrigin");
      }
      upload() {
        return vC(this, null, function* () {
          const t = this.ckboxUtils,
            e = this.editor.t,
            n = yield this.loader.file,
            o = yield t.getCategoryIdForFile(n, {
              signal: this.controller.signal
            }),
            i = new URL("assets", this.serviceOrigin),
            r = new FormData();
          i.searchParams.set("workspaceId", t.getWorkspaceId()), r.append("categoryId", o), r.append("file", n);
          return cC({
            method: "POST",
            url: i,
            data: r,
            onUploadProgress: t => {
              t.lengthComputable && (this.loader.uploadTotal = t.total, this.loader.uploaded = t.loaded);
            },
            signal: this.controller.signal,
            authorization: this.token.value
          }).then(t => vC(this, null, function* () {
            const e = sC(t.imageUrls);
            return {
              ckboxImageId: t.id,
              default: e.imageFallbackUrl,
              sources: e.imageSources
            };
          })).catch(() => {
            const t = e("Cannot upload file:") + ` ${n.name}.`;
            return Promise.reject(t);
          });
        });
      }
      abort() {
        this.controller.abort();
      }
    }
    class EC extends Br {
      static get pluginName() {
        return "CKBoxEditing";
      }
      static get requires() {
        return ["LinkEditing", "PictureEditing", yC, CC];
      }
      init() {
        const t = this.editor;
        this._shouldBeInitialised() && (this._checkImagePlugins(), MC() && t.commands.add("ckbox", new kC(t)));
      }
      afterInit() {
        const t = this.editor;
        this._shouldBeInitialised() && (t.config.get("ckbox.ignoreDataId") || (this._initSchema(), this._initConversion(), this._initFixers()));
      }
      _shouldBeInitialised() {
        return !!this.editor.config.get("ckbox") || MC();
      }
      _checkImagePlugins() {
        const t = this.editor;
        t.plugins.has("ImageBlockEditing") || t.plugins.has("ImageInlineEditing") || _("ckbox-plugin-image-feature-missing", t);
      }
      _initSchema() {
        const t = this.editor.model.schema;
        t.extend("$text", {
          allowAttributes: "ckboxLinkId"
        }), t.isRegistered("imageBlock") && t.extend("imageBlock", {
          allowAttributes: ["ckboxImageId", "ckboxLinkId"]
        }), t.isRegistered("imageInline") && t.extend("imageInline", {
          allowAttributes: ["ckboxImageId", "ckboxLinkId"]
        }), t.addAttributeCheck((t, e) => {
          if (!!!t.last.getAttribute("linkHref") && "ckboxLinkId" === e) return !1;
        });
      }
      _initConversion() {
        const t = this.editor;
        t.conversion.for("downcast").add(t => {
          t.on("attribute:ckboxLinkId:imageBlock", (t, e, n) => {
            const {
              writer: o,
              mapper: i,
              consumable: r
            } = n;
            if (!r.consume(e.item, t.name)) return;
            const s = [...i.toViewElement(e.item).getChildren()].find(t => "a" === t.name);
            s && (e.item.hasAttribute("ckboxLinkId") ? o.setAttribute("data-ckbox-resource-id", e.item.getAttribute("ckboxLinkId"), s) : o.removeAttribute("data-ckbox-resource-id", s));
          }, {
            priority: "low"
          }), t.on("attribute:ckboxLinkId", (t, e, n) => {
            const {
              writer: o,
              mapper: i,
              consumable: r
            } = n;
            if (r.consume(e.item, t.name)) {
              if (e.attributeOldValue) {
                const t = IC(o, e.attributeOldValue);
                o.unwrap(i.toViewRange(e.range), t);
              }
              if (e.attributeNewValue) {
                const t = IC(o, e.attributeNewValue);
                if (e.item.is("selection")) {
                  const e = o.document.selection;
                  o.wrap(e.getFirstRange(), t);
                } else o.wrap(i.toViewRange(e.range), t);
              }
            }
          }, {
            priority: "low"
          });
        }), t.conversion.for("upcast").add(t => {
          t.on("element:a", (t, e, n) => {
            const {
              writer: o,
              consumable: i
            } = n;
            if (!e.viewItem.getAttribute("href")) return;
            if (!i.consume(e.viewItem, {
              attributes: ["data-ckbox-resource-id"]
            })) return;
            const r = e.viewItem.getAttribute("data-ckbox-resource-id");
            if (r) if (e.modelRange) for (let t of e.modelRange.getItems()) t.is("$textProxy") && (t = t.textNode), TC(t) && o.setAttribute("ckboxLinkId", r, t);else {
              const t = e.modelCursor.nodeBefore || e.modelCursor.parent;
              o.setAttribute("ckboxLinkId", r, t);
            }
          }, {
            priority: "low"
          });
        }), t.conversion.for("downcast").attributeToAttribute({
          model: "ckboxImageId",
          view: "data-ckbox-resource-id"
        }), t.conversion.for("upcast").elementToAttribute({
          model: {
            key: "ckboxImageId",
            value: t => t.getAttribute("data-ckbox-resource-id")
          },
          view: {
            attributes: {
              "data-ckbox-resource-id": /[\s\S]+/
            }
          }
        });
        const e = t.commands.get("replaceImageSource");
        e && this.listenTo(e, "cleanupImage", (t, [e, n]) => {
          e.removeAttribute("ckboxImageId", n);
        });
      }
      _initFixers() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection;
        e.document.registerPostFixer(function (t) {
          return e => {
            let n = !1;
            const o = t.model,
              i = t.commands.get("ckbox");
            if (!i) return n;
            for (const t of o.document.differ.getChanges()) {
              if ("insert" !== t.type && "attribute" !== t.type) continue;
              const o = "insert" === t.type ? new ml(t.position, t.position.getShiftedBy(t.length)) : t.range,
                r = "attribute" === t.type && "linkHref" === t.attributeKey && null === t.attributeNewValue;
              for (const t of o.getItems()) {
                if (r && t.hasAttribute("ckboxLinkId")) {
                  e.removeAttribute("ckboxLinkId", t), n = !0;
                  continue;
                }
                const o = DC(t, i._chosenAssets);
                for (const i of o) {
                  const o = "image" === i.type ? "ckboxImageId" : "ckboxLinkId";
                  i.id !== t.getAttribute(o) && (e.setAttribute(o, i.id, t), n = !0);
                }
              }
            }
            return n;
          };
        }(t)), e.document.registerPostFixer(function (t) {
          return e => !(t.hasAttribute("linkHref") || !t.hasAttribute("ckboxLinkId")) && (e.removeSelectionAttribute("ckboxLinkId"), !0);
        }(n));
      }
    }
    function DC(t, e) {
      const n = t.is("element", "imageInline") || t.is("element", "imageBlock"),
        o = t.hasAttribute("linkHref");
      return [...e].filter(e => "image" === e.type && n ? e.attributes.imageFallbackUrl === t.getAttribute("src") : "link" === e.type && o ? e.attributes.linkHref === t.getAttribute("linkHref") : void 0);
    }
    function IC(t, e) {
      const n = t.createAttributeElement("a", {
        "data-ckbox-resource-id": e
      }, {
        priority: 5
      });
      return t.setCustomProperty("link", !0, n), n;
    }
    function TC(t) {
      return !!t.is("$text") || !(!t.is("element", "imageInline") && !t.is("element", "imageBlock"));
    }
    function MC() {
      return !!window.CKBox;
    }
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    var SC = n(1866),
      BC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(SC.A, BC);
    SC.A.locals;
    class NC extends Br {
      static get pluginName() {
        return "CKFinderUI";
      }
      init() {
        const t = this.editor,
          e = t.ui.componentFactory,
          n = t.t;
        if (e.add("ckfinder", t => {
          const e = this._createButton(Sg),
            n = t.t;
          return e.set({
            label: n("Insert image or file"),
            tooltip: !0
          }), e;
        }), e.add("menuBar:ckfinder", t => {
          const e = this._createButton(Yk),
            n = t.t;
          return e.label = n("Image or file"), e;
        }), t.plugins.has("ImageInsertUI")) {
          const e = t.plugins.get("ImageInsertUI");
          e.registerIntegration({
            name: "assetManager",
            observable: () => t.commands.get("ckfinder"),
            buttonViewCreator: () => {
              const t = this.editor.ui.componentFactory.create("ckfinder");
              return t.icon = gg.imageAssetManager, t.bind("label").to(e, "isImageSelected", t => n(t ? "Replace image with file manager" : "Insert image with file manager")), t;
            },
            formViewCreator: () => {
              const t = this.editor.ui.componentFactory.create("ckfinder");
              return t.icon = gg.imageAssetManager, t.withText = !0, t.bind("label").to(e, "isImageSelected", t => n(t ? "Replace with file manager" : "Insert with file manager")), t.on("execute", () => {
                e.dropdownView.isOpen = !1;
              }), t;
            }
          });
        }
      }
      _createButton(t) {
        const e = this.editor,
          n = new t(e.locale),
          o = e.commands.get("ckfinder");
        return n.icon = gg.browseFiles, n.bind("isEnabled").to(o), n.on("execute", () => {
          e.execute("ckfinder"), e.editing.view.focus();
        }), n;
      }
    }
    class PC extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1, this.stopListening(this.editor.model.document, "change"), this.listenTo(this.editor.model.document, "change", () => this.refresh(), {
          priority: "low"
        });
      }
      refresh() {
        const t = this.editor.commands.get("insertImage"),
          e = this.editor.commands.get("link");
        this.isEnabled = t.isEnabled || e.isEnabled;
      }
      execute() {
        const t = this.editor,
          e = this.editor.config.get("ckfinder.openerMethod") || "modal";
        if ("popup" != e && "modal" != e) throw new w("ckfinder-unknown-openermethod", t);
        const n = this.editor.config.get("ckfinder.options") || {};
        n.chooseFiles = !0;
        const o = n.onInit;
        n.language || (n.language = t.locale.uiLanguage), n.onInit = e => {
          o && o(e), e.on("files:choose", n => {
            const o = n.data.files.toArray(),
              i = o.filter(t => !t.isImage()),
              r = o.filter(t => t.isImage());
            for (const e of i) t.execute("link", e.getUrl());
            const s = [];
            for (const t of r) {
              const n = t.getUrl();
              s.push(n || e.request("file:getProxyUrl", {
                file: t
              }));
            }
            s.length && OC(t, s);
          }), e.on("file:choose:resizedImage", e => {
            const n = e.data.resizedUrl;
            if (n) OC(t, [n]);else {
              const e = t.plugins.get("Notification"),
                n = t.locale.t;
              e.showWarning(n("Could not obtain resized image URL."), {
                title: n("Selecting resized image failed"),
                namespace: "ckfinder"
              });
            }
          });
        }, window.CKFinder[e](n);
      }
    }
    function OC(t, e) {
      if (t.commands.get("insertImage").isEnabled) t.execute("insertImage", {
        source: e
      });else {
        const e = t.plugins.get("Notification"),
          n = t.locale.t;
        e.showWarning(n("Could not insert image at the current position."), {
          title: n("Inserting image failed"),
          namespace: "ckfinder"
        });
      }
    }
    class LC extends Br {
      static get pluginName() {
        return "CKFinderEditing";
      }
      static get requires() {
        return [xf, "LinkEditing"];
      }
      init() {
        const t = this.editor;
        if (!t.plugins.has("ImageBlockEditing") && !t.plugins.has("ImageInlineEditing")) throw new w("ckfinder-missing-image-plugin", t);
        t.commands.add("ckfinder", new PC(t));
      }
    }
    class zC extends Br {
      static get pluginName() {
        return "CloudServicesUploadAdapter";
      }
      static get requires() {
        return ["CloudServices", m_];
      }
      init() {
        const t = this.editor,
          e = t.plugins.get("CloudServices"),
          n = e.token,
          o = e.uploadUrl;
        if (!n) return;
        const i = t.plugins.get("CloudServicesCore");
        this._uploadGateway = i.createUploadGateway(n, o), t.plugins.get(m_).createUploadAdapter = t => new RC(this._uploadGateway, t);
      }
    }
    class RC {
      constructor(t, e) {
        this.uploadGateway = t, this.loader = e;
      }
      upload() {
        return this.loader.file.then(t => (this.fileUploader = this.uploadGateway.upload(t), this.fileUploader.on("progress", (t, e) => {
          this.loader.uploadTotal = e.total, this.loader.uploaded = e.uploaded;
        }), this.fileUploader.send()));
      }
      abort() {
        this.fileUploader.abort();
      }
    }
    class jC extends Pr {
      constructor(t) {
        super(t), this._isEnabledBasedOnSelection = !1;
      }
      refresh() {
        const t = this.editor.model,
          e = Wi(t.document.selection.getSelectedBlocks());
        this.value = !!e && e.is("element", "paragraph"), this.isEnabled = !!e && FC(e, t.schema);
      }
      execute(t = {}) {
        const e = this.editor.model,
          n = e.document,
          o = t.selection || n.selection;
        e.canEditAt(o) && e.change(t => {
          const n = o.getSelectedBlocks();
          for (const o of n) !o.is("element", "paragraph") && FC(o, e.schema) && t.rename(o, "paragraph");
        });
      }
    }
    function FC(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }
    class VC extends Pr {
      constructor(t) {
        super(t), this._isEnabledBasedOnSelection = !1;
      }
      execute(t) {
        const e = this.editor.model,
          n = t.attributes;
        let o = t.position;
        e.canEditAt(o) && e.change(t => {
          if (o = this._findPositionToInsertParagraph(o, t), !o) return;
          const i = t.createElement("paragraph");
          n && e.schema.setAllowedAttributes(i, n, t), e.insertContent(i, o), t.setSelection(i, "in");
        });
      }
      _findPositionToInsertParagraph(t, e) {
        const n = this.editor.model;
        if (n.schema.checkChild(t, "paragraph")) return t;
        const o = n.schema.findAllowedParent(t, "paragraph");
        if (!o) return null;
        const i = t.parent,
          r = n.schema.checkChild(i, "$text");
        return i.isEmpty || r && t.isAtEnd ? n.createPositionAfter(i) : !i.isEmpty && r && t.isAtStart ? n.createPositionBefore(i) : e.split(t, o).position;
      }
    }
    const HC = class extends Br {
      static get pluginName() {
        return "Paragraph";
      }
      init() {
        const t = this.editor,
          e = t.model;
        t.commands.add("paragraph", new jC(t)), t.commands.add("insertParagraph", new VC(t)), e.schema.register("paragraph", {
          inheritAllFrom: "$block"
        }), t.conversion.elementToElement({
          model: "paragraph",
          view: "p"
        }), t.conversion.for("upcast").elementToElement({
          model: (t, {
            writer: e
          }) => HC.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null,
          view: /.+/,
          converterPriority: "low"
        });
      }
    };
    let UC = HC;
    UC.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
    class qC extends Pr {
      constructor(t, e) {
        super(t), this.modelElements = e;
      }
      refresh() {
        const t = Wi(this.editor.model.document.selection.getSelectedBlocks());
        this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(e => GC(t, e, this.editor.model.schema));
      }
      execute(t) {
        const e = this.editor.model,
          n = e.document,
          o = t.value;
        e.change(t => {
          const i = Array.from(n.selection.getSelectedBlocks()).filter(t => GC(t, o, e.schema));
          for (const e of i) e.is("element", o) || t.rename(e, o);
        });
      }
    }
    function GC(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }
    const WC = "paragraph";
    class KC extends Br {
      static get pluginName() {
        return "HeadingEditing";
      }
      constructor(t) {
        super(t), t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
      }
      static get requires() {
        return [UC];
      }
      init() {
        const t = this.editor,
          e = t.config.get("heading.options"),
          n = [];
        for (const o of e) "paragraph" !== o.model && (t.model.schema.register(o.model, {
          inheritAllFrom: "$block"
        }), t.conversion.elementToElement(o), n.push(o.model));
        this._addDefaultH1Conversion(t), t.commands.add("heading", new qC(t, n));
      }
      afterInit() {
        const t = this.editor,
          e = t.commands.get("enter"),
          n = t.config.get("heading.options");
        e && this.listenTo(e, "afterExecute", (e, o) => {
          const i = t.model.document.selection.getFirstPosition().parent;
          n.some(t => i.is("element", t.model)) && !i.is("element", WC) && 0 === i.childCount && o.writer.rename(i, WC);
        });
      }
      _addDefaultH1Conversion(t) {
        t.conversion.for("upcast").elementToElement({
          model: "heading1",
          view: "h1",
          converterPriority: f.low + 1
        });
      }
    }
    var $C = n(6269),
      YC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()($C.A, YC);
    $C.A.locals;
    class QC extends Br {
      static get pluginName() {
        return "HeadingUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = function (t) {
            const e = t.t,
              n = {
                Paragraph: e("Paragraph"),
                "Heading 1": e("Heading 1"),
                "Heading 2": e("Heading 2"),
                "Heading 3": e("Heading 3"),
                "Heading 4": e("Heading 4"),
                "Heading 5": e("Heading 5"),
                "Heading 6": e("Heading 6")
              };
            return t.config.get("heading.options").map(t => {
              const e = n[t.title];
              return e && e != t.title && (t.title = e), t;
            });
          }(t),
          o = e("Choose heading"),
          i = e("Heading");
        t.ui.componentFactory.add("heading", e => {
          const r = {},
            s = new Gi(),
            a = t.commands.get("heading"),
            c = t.commands.get("paragraph"),
            l = [a];
          for (const t of n) {
            const e = {
              type: "button",
              model: new Ef({
                label: t.title,
                class: t.class,
                role: "menuitemradio",
                withText: !0
              })
            };
            "paragraph" === t.model ? (e.model.bind("isOn").to(c, "value"), e.model.set("commandName", "paragraph"), l.push(c)) : (e.model.bind("isOn").to(a, "value", e => e === t.model), e.model.set({
              commandName: "heading",
              commandValue: t.model
            })), s.add(e), r[t.model] = t.title;
          }
          const d = zm(e);
          return Fm(d, s, {
            ariaLabel: i,
            role: "menu"
          }), d.buttonView.set({
            ariaLabel: i,
            ariaLabelledBy: void 0,
            isOn: !1,
            withText: !0,
            tooltip: i
          }), d.extendTemplate({
            attributes: {
              class: ["ck-heading-dropdown"]
            }
          }), d.bind("isEnabled").toMany(l, "isEnabled", (...t) => t.some(t => t)), d.buttonView.bind("label").to(a, "value", c, "value", (t, e) => {
            const n = e ? "paragraph" : t;
            return "boolean" == typeof n ? o : r[n] ? r[n] : o;
          }), d.buttonView.bind("ariaLabel").to(a, "value", c, "value", (t, e) => {
            const n = e ? "paragraph" : t;
            return "boolean" == typeof n ? i : r[n] ? `${r[n]}, ${i}` : i;
          }), this.listenTo(d, "execute", e => {
            const {
              commandName: n,
              commandValue: o
            } = e.source;
            t.execute(n, o ? {
              value: o
            } : void 0), t.editing.view.focus();
          }), d;
        }), t.ui.componentFactory.add("menuBar:heading", o => {
          const i = new Gk(o),
            r = t.commands.get("heading"),
            s = t.commands.get("paragraph"),
            a = [r],
            c = new Wk(o);
          i.set({
            class: "ck-heading-dropdown"
          }), c.set({
            ariaLabel: e("Heading"),
            role: "menu"
          }), i.buttonView.set({
            label: e("Heading")
          }), i.panelView.children.add(c);
          for (const e of n) {
            const n = new fk(o, i),
              l = new Yk(o);
            n.children.add(l), c.items.add(n), l.set({
              label: e.title,
              role: "menuitemradio",
              class: e.class
            }), l.bind("ariaChecked").to(l, "isOn"), l.delegate("execute").to(i), l.on("execute", () => {
              const n = "paragraph" === e.model ? "paragraph" : "heading";
              t.execute(n, {
                value: e.model
              }), t.editing.view.focus();
            }), "paragraph" === e.model ? (l.bind("isOn").to(s, "value"), a.push(s)) : l.bind("isOn").to(r, "value", t => t === e.model);
          }
          return i.bind("isEnabled").toMany(a, "isEnabled", (...t) => t.some(t => t)), i;
        });
      }
    }
    function ZC(t) {
      return t.createContainerElement("figure", {
        class: "image"
      }, [t.createEmptyElement("img"), t.createSlot("children")]);
    }
    function JC(t, e) {
      const n = t.plugins.get("ImageUtils"),
        o = t.plugins.has("ImageInlineEditing") && t.plugins.has("ImageBlockEditing");
      return t => {
        if (!n.isInlineImageView(t)) return null;
        if (!o) return i(t);
        return ("block" == t.getStyle("display") || t.findAncestor(n.isBlockImageView) ? "imageBlock" : "imageInline") !== e ? null : i(t);
      };
      function i(t) {
        const e = {
          name: !0
        };
        return t.hasAttribute("src") && (e.attributes = ["src"]), e;
      }
    }
    function XC(t, e) {
      const n = Wi(e.getSelectedBlocks());
      return !n || t.isObject(n) || n.isEmpty && "listItem" != n.name ? "imageBlock" : "imageInline";
    }
    function tv(t) {
      return t && t.endsWith("px") ? parseInt(t) : null;
    }
    function ev(t) {
      const e = tv(t.getStyle("width")),
        n = tv(t.getStyle("height"));
      return !(!e || !n);
    }
    var nv = Object.defineProperty,
      ov = Object.getOwnPropertySymbols,
      iv = Object.prototype.hasOwnProperty,
      rv = Object.prototype.propertyIsEnumerable,
      sv = (t, e, n) => e in t ? nv(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      av = (t, e) => {
        for (var n in e || (e = {})) iv.call(e, n) && sv(t, n, e[n]);
        if (ov) for (var n of ov(e)) rv.call(e, n) && sv(t, n, e[n]);
        return t;
      };
    const cv = /^(image|image-inline)$/;
    class lv extends Br {
      constructor() {
        super(...arguments), this._domEmitter = new (Mo())();
      }
      static get pluginName() {
        return "ImageUtils";
      }
      isImage(t) {
        return this.isInlineImage(t) || this.isBlockImage(t);
      }
      isInlineImageView(t) {
        return !!t && t.is("element", "img");
      }
      isBlockImageView(t) {
        return !!t && t.is("element", "figure") && t.hasClass("image");
      }
      insertImage(t = {}, e = null, n = null, o = {}) {
        const i = this.editor,
          r = i.model,
          s = r.document.selection,
          a = dv(i, e || s, n);
        t = av(av({}, Object.fromEntries(s.getAttributes())), t);
        for (const e in t) r.schema.checkAttribute(a, e) || delete t[e];
        return r.change(n => {
          const {
              setImageSizes: i = !0
            } = o,
            s = n.createElement(a, t);
          return r.insertObject(s, e, null, {
            setSelection: "on",
            findOptimalPosition: e || "imageInline" == a ? void 0 : "auto"
          }), s.parent ? (i && this.setImageNaturalSizeAttributes(s), s) : null;
        });
      }
      setImageNaturalSizeAttributes(t) {
        const n = t.getAttribute("src");
        n && (t.getAttribute("width") || t.getAttribute("height") || this.editor.model.change(o => {
          const i = new e.window.Image();
          this._domEmitter.listenTo(i, "load", () => {
            t.getAttribute("width") || t.getAttribute("height") || this.editor.model.enqueueChange(o.batch, e => {
              e.setAttribute("width", i.naturalWidth, t), e.setAttribute("height", i.naturalHeight, t);
            }), this._domEmitter.stopListening(i, "load");
          }), i.src = n;
        }));
      }
      getClosestSelectedImageWidget(t) {
        const e = t.getFirstPosition();
        if (!e) return null;
        const n = t.getSelectedElement();
        if (n && this.isImageWidget(n)) return n;
        let o = e.parent;
        for (; o;) {
          if (o.is("element") && this.isImageWidget(o)) return o;
          o = o.parent;
        }
        return null;
      }
      getClosestSelectedImageElement(t) {
        const e = t.getSelectedElement();
        return this.isImage(e) ? e : t.getFirstPosition().findAncestor("imageBlock");
      }
      getImageWidgetFromImageView(t) {
        return t.findAncestor({
          classes: cv
        });
      }
      isImageAllowed() {
        const t = this.editor.model.document.selection;
        return function (t, e) {
          const n = dv(t, e, null);
          if ("imageBlock" == n) {
            const n = function (t, e) {
              const n = eA(t, e),
                o = n.start.parent;
              if (o.isEmpty && !o.is("element", "$root")) return o.parent;
              return o;
            }(e, t.model);
            if (t.model.schema.checkChild(n, "imageBlock")) return !0;
          } else if (t.model.schema.checkChild(e.focus, "imageInline")) return !0;
          return !1;
        }(this.editor, t) && function (t) {
          return [...t.focus.getAncestors()].every(t => !t.is("element", "imageBlock"));
        }(t);
      }
      toImageWidget(t, e, n) {
        e.setCustomProperty("image", !0, t);
        return Qw(t, e, {
          label: () => {
            const e = this.findViewImgElement(t).getAttribute("alt");
            return e ? `${e} ${n}` : n;
          }
        });
      }
      isImageWidget(t) {
        return !!t.getCustomProperty("image") && Yw(t);
      }
      isBlockImage(t) {
        return !!t && t.is("element", "imageBlock");
      }
      isInlineImage(t) {
        return !!t && t.is("element", "imageInline");
      }
      findViewImgElement(t) {
        if (this.isInlineImageView(t)) return t;
        const e = this.editor.editing.view;
        for (const {
          item: n
        } of e.createRangeIn(t)) if (this.isInlineImageView(n)) return n;
      }
      destroy() {
        return this._domEmitter.stopListening(), super.destroy();
      }
    }
    function dv(t, e, n) {
      const o = t.model.schema,
        i = t.config.get("image.insert.type");
      return t.plugins.has("ImageBlockEditing") ? t.plugins.has("ImageInlineEditing") ? n || ("inline" === i ? "imageInline" : "auto" !== i ? "imageBlock" : e.is("selection") ? XC(o, e) : o.checkChild(e, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
    }
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    new RegExp(String(/^(http(s)?:\/\/)?[\w-]+\.[\w.~:/[\]@!$&'()*+,;=%-]+/.source + /\.(jpg|jpeg|png|gif|ico|webp|JPG|JPEG|PNG|GIF|ICO|WEBP)/.source + /(\?[\w.~:/[\]@!$&'()*+,;=%-]*)?/.source + /(#[\w.~:/[\]@!$&'()*+,;=%-]*)?$/.source));
    class uv extends Pr {
      refresh() {
        const t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!t, this.isEnabled && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
      }
      execute(t) {
        const e = this.editor,
          n = e.plugins.get("ImageUtils"),
          o = e.model,
          i = n.getClosestSelectedImageElement(o.document.selection);
        o.change(e => {
          e.setAttribute("alt", t.newValue, i);
        });
      }
    }
    class hv extends Br {
      static get requires() {
        return [lv];
      }
      static get pluginName() {
        return "ImageTextAlternativeEditing";
      }
      init() {
        this.editor.commands.add("imageTextAlternative", new uv(this.editor));
      }
    }
    var gv = n(4062),
      mv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(gv.A, mv);
    gv.A.locals;
    var pv = n(2722),
      fv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(pv.A, fv);
    pv.A.locals;
    class kv extends Dr {
      constructor(t) {
        super(t);
        const e = this.locale.t;
        this.focusTracker = new Ki(), this.keystrokes = new $i(), this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(e("Save"), gg.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(e("Cancel"), gg.cancel, "ck-button-cancel", "cancel"), this._focusables = new er(), this._focusCycler = new rm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.labeledInput, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element), Mr({
          view: this
        }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createButton(t, e, n, o) {
        const i = new Sg(this.locale);
        return i.set({
          label: t,
          icon: e,
          tooltip: !0
        }), i.extendTemplate({
          attributes: {
            class: n
          }
        }), o && i.delegate("execute").to(this, o), i;
      }
      _createLabeledInputView() {
        const t = this.locale.t,
          e = new Gg(this.locale, qm);
        return e.label = t("Text alternative"), e;
      }
    }
    function bv(t) {
      const e = t.editing.view,
        n = Op.defaultPositions,
        o = t.plugins.get("ImageUtils");
      return {
        target: e.domConverter.mapViewToDom(o.getClosestSelectedImageWidget(e.document.selection)),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast, n.viewportStickyNorth]
      };
    }
    class wv extends Br {
      static get requires() {
        return [Bf];
      }
      static get pluginName() {
        return "ImageTextAlternativeUI";
      }
      init() {
        this._createButton();
      }
      destroy() {
        super.destroy(), this._form && this._form.destroy();
      }
      _createButton() {
        const t = this.editor,
          e = t.t;
        t.ui.componentFactory.add("imageTextAlternative", n => {
          const o = t.commands.get("imageTextAlternative"),
            i = new Sg(n);
          return i.set({
            label: e("Change image text alternative"),
            icon: gg.textAlternative,
            tooltip: !0
          }), i.bind("isEnabled").to(o, "isEnabled"), i.bind("isOn").to(o, "value", t => !!t), this.listenTo(i, "execute", () => {
            this._showForm();
          }), i;
        });
      }
      _createForm() {
        const t = this.editor,
          e = t.editing.view.document,
          n = t.plugins.get("ImageUtils");
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new (Tr(kv))(t.locale), this._form.render(), this.listenTo(this._form, "submit", () => {
          t.execute("imageTextAlternative", {
            newValue: this._form.labeledInput.fieldView.element.value
          }), this._hideForm(!0);
        }), this.listenTo(this._form, "cancel", () => {
          this._hideForm(!0);
        }), this._form.keystrokes.set("Esc", (t, e) => {
          this._hideForm(!0), e();
        }), this.listenTo(t.ui, "update", () => {
          n.getClosestSelectedImageWidget(e.selection) ? this._isVisible && function (t) {
            const e = t.plugins.get("ContextualBalloon");
            if (t.plugins.get("ImageUtils").getClosestSelectedImageWidget(t.editing.view.document.selection)) {
              const n = bv(t);
              e.updatePosition(n);
            }
          }(t) : this._hideForm(!0);
        }), Ir({
          emitter: this._form,
          activator: () => this._isVisible,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideForm()
        });
      }
      _showForm() {
        if (this._isVisible) return;
        this._form || this._createForm();
        const t = this.editor,
          e = t.commands.get("imageTextAlternative"),
          n = this._form.labeledInput;
        this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({
          view: this._form,
          position: bv(t)
        }), n.fieldView.value = n.fieldView.element.value = e.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
      }
      _hideForm(t = !1) {
        this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
      }
      get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
      }
      get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
      }
    }
    class Av extends Br {
      static get requires() {
        return [hv, wv];
      }
      static get pluginName() {
        return "ImageTextAlternative";
      }
    }
    function _v(t, e) {
      const n = (e, n, o) => {
        if (!o.consumable.consume(n.item, e.name)) return;
        const i = o.writer,
          r = o.mapper.toViewElement(n.item),
          s = t.findViewImgElement(r);
        null === n.attributeNewValue ? (i.removeAttribute("srcset", s), i.removeAttribute("sizes", s)) : n.attributeNewValue && (i.setAttribute("srcset", n.attributeNewValue, s), i.setAttribute("sizes", "100vw", s));
      };
      return t => {
        t.on(`attribute:srcset:${e}`, n);
      };
    }
    function Cv(t, e, n) {
      const o = (e, n, o) => {
        if (!o.consumable.consume(n.item, e.name)) return;
        const i = o.writer,
          r = o.mapper.toViewElement(n.item),
          s = t.findViewImgElement(r);
        i.setAttribute(n.attributeKey, n.attributeNewValue || "", s);
      };
      return t => {
        t.on(`attribute:${n}:${e}`, o);
      };
    }
    class vv extends nc {
      observe(t) {
        this.listenTo(t, "load", (t, e) => {
          const n = e.target;
          this.checkShouldIgnoreEventFromTarget(n) || "IMG" == n.tagName && this._fireEvents(e);
        }, {
          useCapture: !0
        });
      }
      stopObserving(t) {
        this.stopListening(t);
      }
      _fireEvents(t) {
        this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
      }
    }
    var yv = Object.defineProperty,
      xv = Object.getOwnPropertySymbols,
      Ev = Object.prototype.hasOwnProperty,
      Dv = Object.prototype.propertyIsEnumerable,
      Iv = (t, e, n) => e in t ? yv(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      Tv = (t, e) => {
        for (var n in e || (e = {})) Ev.call(e, n) && Iv(t, n, e[n]);
        if (xv) for (var n of xv(e)) Dv.call(e, n) && Iv(t, n, e[n]);
        return t;
      };
    class Mv extends Pr {
      constructor(t) {
        super(t);
        const e = t.config.get("image.insert.type");
        t.plugins.has("ImageBlockEditing") || "block" === e && A("image-block-plugin-required"), t.plugins.has("ImageInlineEditing") || "inline" === e && A("image-inline-plugin-required");
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils");
        this.isEnabled = t.isImageAllowed();
      }
      execute(t) {
        const e = Ai(t.source),
          n = this.editor.model.document.selection,
          o = this.editor.plugins.get("ImageUtils"),
          i = Object.fromEntries(n.getAttributes());
        e.forEach((t, e) => {
          const r = n.getSelectedElement();
          if ("string" == typeof t && (t = {
            src: t
          }), e && r && o.isImage(r)) {
            const e = this.editor.model.createPositionAfter(r);
            o.insertImage(Tv(Tv({}, t), i), e);
          } else o.insertImage(Tv(Tv({}, t), i));
        });
      }
    }
    class Sv extends Pr {
      constructor(t) {
        super(t), this.decorate("cleanupImage");
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils"),
          e = this.editor.model.document.selection.getSelectedElement();
        this.isEnabled = t.isImage(e), this.value = this.isEnabled ? e.getAttribute("src") : null;
      }
      execute(t) {
        const e = this.editor.model.document.selection.getSelectedElement(),
          n = this.editor.plugins.get("ImageUtils");
        this.editor.model.change(o => {
          o.setAttribute("src", t.source, e), this.cleanupImage(o, e), n.setImageNaturalSizeAttributes(e);
        });
      }
      cleanupImage(t, e) {
        t.removeAttribute("srcset", e), t.removeAttribute("sizes", e), t.removeAttribute("sources", e), t.removeAttribute("width", e), t.removeAttribute("height", e), t.removeAttribute("alt", e);
      }
    }
    class Bv extends Br {
      static get requires() {
        return [lv];
      }
      static get pluginName() {
        return "ImageEditing";
      }
      init() {
        const t = this.editor,
          e = t.conversion;
        t.editing.view.addObserver(vv), e.for("upcast").attributeToAttribute({
          view: {
            name: "img",
            key: "alt"
          },
          model: "alt"
        }).attributeToAttribute({
          view: {
            name: "img",
            key: "srcset"
          },
          model: "srcset"
        });
        const n = new Mv(t),
          o = new Sv(t);
        t.commands.add("insertImage", n), t.commands.add("replaceImageSource", o), t.commands.add("imageInsert", n);
      }
    }
    class Nv extends Br {
      static get requires() {
        return [lv];
      }
      static get pluginName() {
        return "ImageSizeAttributes";
      }
      afterInit() {
        this._registerSchema(), this._registerConverters("imageBlock"), this._registerConverters("imageInline");
      }
      _registerSchema() {
        this.editor.plugins.has("ImageBlockEditing") && this.editor.model.schema.extend("imageBlock", {
          allowAttributes: ["width", "height"]
        }), this.editor.plugins.has("ImageInlineEditing") && this.editor.model.schema.extend("imageInline", {
          allowAttributes: ["width", "height"]
        });
      }
      _registerConverters(t) {
        const e = this.editor,
          n = e.plugins.get("ImageUtils"),
          o = "imageBlock" === t ? "figure" : "img";
        function i(e, o, i, r) {
          e.on(`attribute:${o}:${t}`, (e, o, s) => {
            if (!s.consumable.consume(o.item, e.name)) return;
            const a = s.writer,
              c = s.mapper.toViewElement(o.item),
              l = n.findViewImgElement(c);
            if (null !== o.attributeNewValue ? a.setAttribute(i, o.attributeNewValue, l) : a.removeAttribute(i, l), o.item.hasAttribute("sources")) return;
            const d = o.item.hasAttribute("resizedWidth");
            if ("imageInline" === t && !d && !r) return;
            const u = o.item.getAttribute("width"),
              h = o.item.getAttribute("height");
            u && h && a.setStyle("aspect-ratio", `${u}/${h}`, l);
          });
        }
        e.conversion.for("upcast").attributeToAttribute({
          view: {
            name: o,
            styles: {
              width: /.+/
            }
          },
          model: {
            key: "width",
            value: t => ev(t) ? tv(t.getStyle("width")) : null
          }
        }).attributeToAttribute({
          view: {
            name: o,
            key: "width"
          },
          model: "width"
        }).attributeToAttribute({
          view: {
            name: o,
            styles: {
              height: /.+/
            }
          },
          model: {
            key: "height",
            value: t => ev(t) ? tv(t.getStyle("height")) : null
          }
        }).attributeToAttribute({
          view: {
            name: o,
            key: "height"
          },
          model: "height"
        }), e.conversion.for("editingDowncast").add(t => {
          i(t, "width", "width", !0), i(t, "height", "height", !0);
        }), e.conversion.for("dataDowncast").add(t => {
          i(t, "width", "width", !1), i(t, "height", "height", !1);
        });
      }
    }
    class Pv extends Pr {
      constructor(t, e) {
        super(t), this._modelElementName = e;
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils"),
          e = t.getClosestSelectedImageElement(this.editor.model.document.selection);
        "imageBlock" === this._modelElementName ? this.isEnabled = t.isInlineImage(e) : this.isEnabled = t.isBlockImage(e);
      }
      execute(t = {}) {
        const e = this.editor,
          n = this.editor.model,
          o = e.plugins.get("ImageUtils"),
          i = o.getClosestSelectedImageElement(n.document.selection),
          r = Object.fromEntries(i.getAttributes());
        return r.src || r.uploadId ? n.change(e => {
          const {
              setImageSizes: s = !0
            } = t,
            a = Array.from(n.markers).filter(t => t.getRange().containsItem(i)),
            c = o.insertImage(r, n.createSelection(i, "on"), this._modelElementName, {
              setImageSizes: s
            });
          if (!c) return null;
          const l = e.createRangeOn(c);
          for (const t of a) {
            const n = t.getRange(),
              o = "$graveyard" != n.root.rootName ? n.getJoined(l, !0) : l;
            e.updateMarker(t, {
              range: o
            });
          }
          return {
            oldElement: i,
            newElement: c
          };
        }) : null;
      }
    }
    var Ov = n(7378),
      Lv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ov.A, Lv);
    Ov.A.locals;
    class zv extends Br {
      static get requires() {
        return [lv];
      }
      static get pluginName() {
        return "ImagePlaceholder";
      }
      afterInit() {
        this._setupSchema(), this._setupConversion(), this._setupLoadListener();
      }
      _setupSchema() {
        const t = this.editor.model.schema;
        t.isRegistered("imageBlock") && t.extend("imageBlock", {
          allowAttributes: ["placeholder"]
        }), t.isRegistered("imageInline") && t.extend("imageInline", {
          allowAttributes: ["placeholder"]
        });
      }
      _setupConversion() {
        const t = this.editor,
          e = t.conversion,
          n = t.plugins.get("ImageUtils");
        e.for("editingDowncast").add(t => {
          t.on("attribute:placeholder", (t, e, o) => {
            if (!o.consumable.test(e.item, t.name)) return;
            if (!e.item.is("element", "imageBlock") && !e.item.is("element", "imageInline")) return;
            o.consumable.consume(e.item, t.name);
            const i = o.writer,
              r = o.mapper.toViewElement(e.item),
              s = n.findViewImgElement(r);
            e.attributeNewValue ? (i.addClass("image_placeholder", s), i.setStyle("background-image", `url(${e.attributeNewValue})`, s), i.setCustomProperty("editingPipeline:doNotReuseOnce", !0, s)) : (i.removeClass("image_placeholder", s), i.removeStyle("background-image", s));
          });
        });
      }
      _setupLoadListener() {
        const t = this.editor,
          e = t.model,
          n = t.editing,
          o = n.view,
          i = t.plugins.get("ImageUtils");
        o.addObserver(vv), this.listenTo(o.document, "imageLoaded", (t, r) => {
          const s = o.domConverter.mapDomToView(r.target);
          if (!s) return;
          const a = i.getImageWidgetFromImageView(s);
          if (!a) return;
          const c = n.mapper.toModelElement(a);
          c && c.hasAttribute("placeholder") && e.enqueueChange({
            isUndoable: !1
          }, t => {
            t.removeAttribute("placeholder", c);
          });
        });
      }
    }
    class Rv extends Br {
      static get requires() {
        return [Bv, Nv, lv, zv, Jb];
      }
      static get pluginName() {
        return "ImageBlockEditing";
      }
      init() {
        const t = this.editor;
        t.model.schema.register("imageBlock", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["alt", "src", "srcset"]
        }), this._setupConversion(), t.plugins.has("ImageInlineEditing") && (t.commands.add("imageTypeBlock", new Pv(this.editor, "imageBlock")), this._setupClipboardIntegration());
      }
      _setupConversion() {
        const t = this.editor,
          e = t.t,
          n = t.conversion,
          o = t.plugins.get("ImageUtils");
        n.for("dataDowncast").elementToStructure({
          model: "imageBlock",
          view: (t, {
            writer: e
          }) => ZC(e)
        }), n.for("editingDowncast").elementToStructure({
          model: "imageBlock",
          view: (t, {
            writer: n
          }) => o.toImageWidget(ZC(n), n, e("image widget"))
        }), n.for("downcast").add(Cv(o, "imageBlock", "src")).add(Cv(o, "imageBlock", "alt")).add(_v(o, "imageBlock")), n.for("upcast").elementToElement({
          view: JC(t, "imageBlock"),
          model: (t, {
            writer: e
          }) => e.createElement("imageBlock", t.hasAttribute("src") ? {
            src: t.getAttribute("src")
          } : void 0)
        }).add(function (t) {
          const e = (e, n, o) => {
            if (!o.consumable.test(n.viewItem, {
              name: !0,
              classes: "image"
            })) return;
            const i = t.findViewImgElement(n.viewItem);
            if (!i || !o.consumable.test(i, {
              name: !0
            })) return;
            o.consumable.consume(n.viewItem, {
              name: !0,
              classes: "image"
            });
            const r = Wi(o.convertItem(i, n.modelCursor).modelRange.getItems());
            r ? (o.convertChildren(n.viewItem, r), o.updateConversionResult(r, n)) : o.consumable.revert(n.viewItem, {
              name: !0,
              classes: "image"
            });
          };
          return t => {
            t.on("element:figure", e);
          };
        }(o));
      }
      _setupClipboardIntegration() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          o = t.plugins.get("ImageUtils"),
          i = t.plugins.get("ClipboardPipeline");
        this.listenTo(i, "inputTransformation", (i, r) => {
          const s = Array.from(r.content.getChildren());
          let a;
          if (!s.every(o.isInlineImageView)) return;
          a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
          const c = e.createSelection(a);
          if ("imageBlock" === XC(e.schema, c)) {
            const t = new Qh(n.document),
              e = s.map(e => t.createElement("figure", {
                class: "image"
              }, e));
            r.content = t.createDocumentFragment(e);
          }
        }), this.listenTo(i, "contentInsertion", (t, n) => {
          "paste" === n.method && e.change(t => {
            const e = t.createRangeIn(n.content);
            for (const t of e.getItems()) t.is("element", "imageBlock") && o.setImageNaturalSizeAttributes(t);
          });
        });
      }
    }
    var jv = n(3350),
      Fv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(jv.A, Fv);
    jv.A.locals;
    class Vv extends Dr {
      constructor(t, e = []) {
        super(t), this.focusTracker = new Ki(), this.keystrokes = new $i(), this._focusables = new er(), this.children = this.createCollection(), this._focusCycler = new rm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        for (const t of e) this.children.add(t), this._focusables.add(t), t instanceof Fg && this._focusables.addMany(t.children);
        if (this._focusables.length > 1) for (const t of this._focusables) Hv(t) && (t.focusCycler.on("forwardCycle", t => {
          this._focusCycler.focusNext(), t.stop();
        }), t.focusCycler.on("backwardCycle", t => {
          this._focusCycler.focusPrevious(), t.stop();
        }));
        this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-image-insert-form"],
            tabindex: -1
          },
          children: this.children
        });
      }
      render() {
        super.render(), Mr({
          view: this
        });
        for (const t of this._focusables) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element);
        const t = t => t.stopPropagation();
        this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
    }
    function Hv(t) {
      return "focusCycler" in t;
    }
    class Uv extends Br {
      constructor(t) {
        super(t), this._integrations = new Map(), t.config.define("image.insert.integrations", ["upload", "assetManager", "url"]);
      }
      static get pluginName() {
        return "ImageInsertUI";
      }
      static get requires() {
        return [lv];
      }
      init() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.plugins.get("ImageUtils");
        this.set("isImageSelected", !1), this.listenTo(t.model.document, "change", () => {
          this.isImageSelected = n.isImage(e.getSelectedElement());
        });
        const o = t => this._createToolbarComponent(t);
        t.ui.componentFactory.add("insertImage", o), t.ui.componentFactory.add("imageInsert", o);
      }
      registerIntegration({
        name: t,
        observable: e,
        buttonViewCreator: n,
        formViewCreator: o,
        requiresForm: i
      }) {
        this._integrations.has(t) && A("image-insert-integration-exists", {
          name: t
        }), this._integrations.set(t, {
          observable: e,
          buttonViewCreator: n,
          formViewCreator: o,
          requiresForm: !!i
        });
      }
      _createToolbarComponent(t) {
        const e = this.editor,
          n = t.t,
          o = this._prepareIntegrations();
        if (!o.length) return null;
        let i;
        const r = o[0];
        if (1 == o.length) {
          if (!r.requiresForm) return r.buttonViewCreator(!0);
          i = r.buttonViewCreator(!0);
        } else {
          const e = r.buttonViewCreator(!1);
          i = new Bm(t, e), i.tooltip = !0, i.bind("label").to(this, "isImageSelected", t => n(t ? "Replace image" : "Insert image"));
        }
        const s = this.dropdownView = zm(t, i),
          a = o.map(({
            observable: t
          }) => "function" == typeof t ? t() : t);
        return s.bind("isEnabled").toMany(a, "isEnabled", (...t) => t.some(t => t)), s.once("change:isOpen", () => {
          const t = o.map(({
              formViewCreator: t
            }) => t(1 == o.length)),
            n = new Vv(e.locale, t);
          s.panelView.children.add(n);
        }), s;
      }
      _prepareIntegrations() {
        const t = this.editor.config.get("image.insert.integrations"),
          e = [];
        if (!t.length) return A("image-insert-integrations-not-specified"), e;
        for (const n of t) this._integrations.has(n) ? e.push(this._integrations.get(n)) : ["upload", "assetManager", "url"].includes(n) || A("image-insert-unknown-integration", {
          item: n
        });
        return e.length || A("image-insert-integrations-not-registered"), e;
      }
    }
    var qv = n(265),
      Gv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(qv.A, Gv);
    qv.A.locals;
    class Wv extends Br {
      static get requires() {
        return [Rv, kA, Av, Uv];
      }
      static get pluginName() {
        return "ImageBlock";
      }
    }
    class Kv extends Br {
      static get requires() {
        return [Bv, Nv, lv, zv, Jb];
      }
      static get pluginName() {
        return "ImageInlineEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.schema;
        e.register("imageInline", {
          inheritAllFrom: "$inlineObject",
          allowAttributes: ["alt", "src", "srcset"]
        }), e.addChildCheck((t, e) => {
          if (t.endsWith("caption") && "imageInline" === e.name) return !1;
        }), this._setupConversion(), t.plugins.has("ImageBlockEditing") && (t.commands.add("imageTypeInline", new Pv(this.editor, "imageInline")), this._setupClipboardIntegration());
      }
      _setupConversion() {
        const t = this.editor,
          e = t.t,
          n = t.conversion,
          o = t.plugins.get("ImageUtils");
        n.for("dataDowncast").elementToElement({
          model: "imageInline",
          view: (t, {
            writer: e
          }) => e.createEmptyElement("img")
        }), n.for("editingDowncast").elementToStructure({
          model: "imageInline",
          view: (t, {
            writer: n
          }) => o.toImageWidget(function (t) {
            return t.createContainerElement("span", {
              class: "image-inline"
            }, t.createEmptyElement("img"));
          }(n), n, e("image widget"))
        }), n.for("downcast").add(Cv(o, "imageInline", "src")).add(Cv(o, "imageInline", "alt")).add(_v(o, "imageInline")), n.for("upcast").elementToElement({
          view: JC(t, "imageInline"),
          model: (t, {
            writer: e
          }) => e.createElement("imageInline", t.hasAttribute("src") ? {
            src: t.getAttribute("src")
          } : void 0)
        });
      }
      _setupClipboardIntegration() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          o = t.plugins.get("ImageUtils"),
          i = t.plugins.get("ClipboardPipeline");
        this.listenTo(i, "inputTransformation", (i, r) => {
          const s = Array.from(r.content.getChildren());
          let a;
          if (!s.every(o.isBlockImageView)) return;
          a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
          const c = e.createSelection(a);
          if ("imageInline" === XC(e.schema, c)) {
            const t = new Qh(n.document),
              e = s.map(e => 1 === e.childCount ? (Array.from(e.getAttributes()).forEach(n => t.setAttribute(...n, o.findViewImgElement(e))), e.getChild(0)) : e);
            r.content = t.createDocumentFragment(e);
          }
        }), this.listenTo(i, "contentInsertion", (t, n) => {
          "paste" === n.method && e.change(t => {
            const e = t.createRangeIn(n.content);
            for (const t of e.getItems()) t.is("element", "imageInline") && o.setImageNaturalSizeAttributes(t);
          });
        });
      }
    }
    class $v extends Br {
      static get requires() {
        return [Kv, kA, Av, Uv];
      }
      static get pluginName() {
        return "ImageInline";
      }
    }
    class Yv extends Br {
      static get pluginName() {
        return "ImageCaptionUtils";
      }
      static get requires() {
        return [lv];
      }
      getCaptionFromImageModelElement(t) {
        for (const e of t.getChildren()) if (e && e.is("element", "caption")) return e;
        return null;
      }
      getCaptionFromModelSelection(t) {
        const e = this.editor.plugins.get("ImageUtils"),
          n = t.getFirstPosition().findAncestor("caption");
        return n && e.isBlockImage(n.parent) ? n : null;
      }
      matchImageCaptionViewElement(t) {
        const e = this.editor.plugins.get("ImageUtils");
        return "figcaption" == t.name && e.isBlockImageView(t.parent) ? {
          name: !0
        } : null;
      }
    }
    class Qv extends Pr {
      refresh() {
        const t = this.editor,
          e = t.plugins.get("ImageCaptionUtils"),
          n = t.plugins.get("ImageUtils");
        if (!t.plugins.has(Rv)) return this.isEnabled = !1, void (this.value = !1);
        const o = t.model.document.selection,
          i = o.getSelectedElement();
        if (!i) {
          const t = e.getCaptionFromModelSelection(o);
          return this.isEnabled = !!t, void (this.value = !!t);
        }
        this.isEnabled = n.isImage(i), this.isEnabled ? this.value = !!e.getCaptionFromImageModelElement(i) : this.value = !1;
      }
      execute(t = {}) {
        const {
          focusCaptionOnShow: e
        } = t;
        this.editor.model.change(t => {
          this.value ? this._hideImageCaption(t) : this._showImageCaption(t, e);
        });
      }
      _showImageCaption(t, e) {
        const n = this.editor.model.document.selection,
          o = this.editor.plugins.get("ImageCaptionEditing"),
          i = this.editor.plugins.get("ImageUtils");
        let r = n.getSelectedElement();
        const s = o._getSavedCaption(r);
        i.isInlineImage(r) && (this.editor.execute("imageTypeBlock"), r = n.getSelectedElement());
        const a = s || t.createElement("caption");
        t.append(a, r), e && t.setSelection(a, "in");
      }
      _hideImageCaption(t) {
        const e = this.editor,
          n = e.model.document.selection,
          o = e.plugins.get("ImageCaptionEditing"),
          i = e.plugins.get("ImageCaptionUtils");
        let r,
          s = n.getSelectedElement();
        s ? r = i.getCaptionFromImageModelElement(s) : (r = i.getCaptionFromModelSelection(n), s = r.parent), o._saveCaption(s, r), t.setSelection(s, "on"), t.remove(r);
      }
    }
    class Zv extends Br {
      constructor(t) {
        super(t), this._savedCaptionsMap = new WeakMap();
      }
      static get requires() {
        return [lv, Yv];
      }
      static get pluginName() {
        return "ImageCaptionEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.schema;
        e.isRegistered("caption") ? e.extend("caption", {
          allowIn: "imageBlock"
        }) : e.register("caption", {
          allowIn: "imageBlock",
          allowContentOf: "$block",
          isLimit: !0
        }), t.commands.add("toggleImageCaption", new Qv(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration(), this._registerCaptionReconversion();
      }
      _setupConversion() {
        const t = this.editor,
          e = t.editing.view,
          n = t.plugins.get("ImageUtils"),
          o = t.plugins.get("ImageCaptionUtils"),
          i = t.t;
        t.conversion.for("upcast").elementToElement({
          view: t => o.matchImageCaptionViewElement(t),
          model: "caption"
        }), t.conversion.for("dataDowncast").elementToElement({
          model: "caption",
          view: (t, {
            writer: e
          }) => n.isBlockImage(t.parent) ? e.createContainerElement("figcaption") : null
        }), t.conversion.for("editingDowncast").elementToElement({
          model: "caption",
          view: (t, {
            writer: o
          }) => {
            if (!n.isBlockImage(t.parent)) return null;
            const r = o.createEditableElement("figcaption");
            o.setCustomProperty("imageCaption", !0, r), r.placeholder = i("Enter image caption"), $r({
              view: e,
              element: r,
              keepOnFocus: !0
            });
            const s = t.parent.getAttribute("alt");
            return tA(r, o, {
              label: s ? i("Caption for image: %0", [s]) : i("Caption for the image")
            });
          }
        });
      }
      _setupImageTypeCommandsIntegration() {
        const t = this.editor,
          e = t.plugins.get("ImageUtils"),
          n = t.plugins.get("ImageCaptionUtils"),
          o = t.commands.get("imageTypeInline"),
          i = t.commands.get("imageTypeBlock"),
          r = t => {
            if (!t.return) return;
            const {
              oldElement: o,
              newElement: i
            } = t.return;
            if (!o) return;
            if (e.isBlockImage(o)) {
              const t = n.getCaptionFromImageModelElement(o);
              if (t) return void this._saveCaption(i, t);
            }
            const r = this._getSavedCaption(o);
            r && this._saveCaption(i, r);
          };
        o && this.listenTo(o, "execute", r, {
          priority: "low"
        }), i && this.listenTo(i, "execute", r, {
          priority: "low"
        });
      }
      _getSavedCaption(t) {
        const e = this._savedCaptionsMap.get(t);
        return e ? rl.fromJSON(e) : null;
      }
      _saveCaption(t, e) {
        this._savedCaptionsMap.set(t, e.toJSON());
      }
      _registerCaptionReconversion() {
        const t = this.editor,
          e = t.model,
          n = t.plugins.get("ImageUtils"),
          o = t.plugins.get("ImageCaptionUtils");
        e.document.on("change:data", () => {
          const i = e.document.differ.getChanges();
          for (const e of i) {
            if ("alt" !== e.attributeKey) continue;
            const i = e.range.start.nodeAfter;
            if (n.isBlockImage(i)) {
              const e = o.getCaptionFromImageModelElement(i);
              if (!e) return;
              t.editing.reconvertItem(e);
            }
          }
        });
      }
    }
    class Jv extends Br {
      static get requires() {
        return [Yv];
      }
      static get pluginName() {
        return "ImageCaptionUI";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = t.plugins.get("ImageCaptionUtils"),
          o = t.t;
        t.ui.componentFactory.add("toggleImageCaption", i => {
          const r = t.commands.get("toggleImageCaption"),
            s = new Sg(i);
          return s.set({
            icon: gg.caption,
            tooltip: !0,
            isToggleable: !0
          }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.bind("label").to(r, "value", t => o(t ? "Toggle caption off" : "Toggle caption on")), this.listenTo(s, "execute", () => {
            t.execute("toggleImageCaption", {
              focusCaptionOnShow: !0
            });
            const o = n.getCaptionFromModelSelection(t.model.document.selection);
            if (o) {
              const n = t.editing.mapper.toViewElement(o);
              e.scrollToTheSelection(), e.change(t => {
                t.addClass("image__caption_highlighted", n);
              });
            }
            t.editing.view.focus();
          }), s;
        });
      }
    }
    var Xv = n(5247),
      ty = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Xv.A, ty);
    Xv.A.locals;
    function ey(t) {
      const e = t.map(t => t.replace("+", "\\+"));
      return new RegExp(`^image\\/(${e.join("|")})$`);
    }
    function ny(t) {
      return new Promise((n, o) => {
        const i = t.getAttribute("src");
        fetch(i).then(t => t.blob()).then(t => {
          const e = oy(t, i),
            o = e.replace("image/", ""),
            r = new File([t], `image.${o}`, {
              type: e
            });
          n(r);
        }).catch(t => t && "TypeError" === t.name ? function (t) {
          return function (t) {
            return new Promise((n, o) => {
              const i = e.document.createElement("img");
              i.addEventListener("load", () => {
                const t = e.document.createElement("canvas");
                t.width = i.width, t.height = i.height;
                t.getContext("2d").drawImage(i, 0, 0), t.toBlob(t => t ? n(t) : o());
              }), i.addEventListener("error", () => o()), i.src = t;
            });
          }(t).then(e => {
            const n = oy(e, t),
              o = n.replace("image/", "");
            return new File([e], `image.${o}`, {
              type: n
            });
          });
        }(i).then(n).catch(o) : o(t));
      });
    }
    function oy(t, e) {
      return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
    }
    class iy extends Br {
      static get pluginName() {
        return "ImageUploadUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = () => {
            const t = this._createButton(Og);
            return t.set({
              label: e("Upload image from computer"),
              tooltip: !0
            }), t;
          };
        if (t.ui.componentFactory.add("uploadImage", n), t.ui.componentFactory.add("imageUpload", n), t.ui.componentFactory.add("menuBar:uploadImage", () => {
          const t = this._createButton(Qk);
          return t.label = e("Image from computer"), t;
        }), t.plugins.has("ImageInsertUI")) {
          const n = t.plugins.get("ImageInsertUI");
          n.registerIntegration({
            name: "upload",
            observable: () => t.commands.get("uploadImage"),
            buttonViewCreator: () => {
              const o = t.ui.componentFactory.create("uploadImage");
              return o.bind("label").to(n, "isImageSelected", t => e(t ? "Replace image from computer" : "Upload image from computer")), o;
            },
            formViewCreator: () => {
              const o = t.ui.componentFactory.create("uploadImage");
              return o.withText = !0, o.bind("label").to(n, "isImageSelected", t => e(t ? "Replace from computer" : "Upload from computer")), o.on("execute", () => {
                n.dropdownView.isOpen = !1;
              }), o;
            }
          });
        }
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          o = e.commands.get("uploadImage"),
          i = e.config.get("image.upload.types"),
          r = ey(i),
          s = new t(e.locale),
          a = n.t;
        return s.set({
          acceptedType: i.map(t => `image/${t}`).join(","),
          allowMultipleFiles: !0,
          label: a("Upload image from computer"),
          icon: gg.imageUpload
        }), s.bind("isEnabled").to(o), s.on("done", (t, n) => {
          const o = Array.from(n).filter(t => r.test(t.type));
          o.length && (e.execute("uploadImage", {
            file: o
          }), e.editing.view.focus());
        }), s;
      }
    }
    var ry = n(2267),
      sy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(ry.A, sy);
    ry.A.locals;
    var ay = n(7693),
      cy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(ay.A, cy);
    ay.A.locals;
    var ly = n(1559),
      dy = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(ly.A, dy);
    ly.A.locals;
    class uy extends Br {
      constructor(t) {
        super(t), this.uploadStatusChange = (t, e, n) => {
          const o = this.editor,
            i = e.item,
            r = i.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) return;
          const s = o.plugins.get("ImageUtils"),
            a = o.plugins.get(m_),
            c = r ? e.attributeNewValue : null,
            l = this.placeholder,
            d = o.editing.mapper.toViewElement(i),
            u = n.writer;
          if ("reading" == c) return hy(d, u), void gy(s, l, d, u);
          if ("uploading" == c) {
            const t = a.loaders.get(r);
            return hy(d, u), void (t ? (my(d, u), function (t, e, n, o) {
              const i = function (t) {
                const e = t.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return t.setCustomProperty("progressBar", !0, e), e;
              }(e);
              e.insert(e.createPositionAt(t, "end"), i), n.on("change:uploadedPercent", (t, e, n) => {
                o.change(t => {
                  t.setStyle("width", n + "%", i);
                });
              });
            }(d, u, t, o.editing.view), function (t, e, n, o) {
              if (o.data) {
                const i = t.findViewImgElement(e);
                n.setAttribute("src", o.data, i);
              }
            }(s, d, u, t)) : gy(s, l, d, u));
          }
          "complete" == c && a.loaders.get(r) && function (t, e, n) {
            const o = e.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            e.insert(e.createPositionAt(t, "end"), o), setTimeout(() => {
              n.change(t => t.remove(t.createRangeOn(o)));
            }, 3e3);
          }(d, u, o.editing.view), function (t, e) {
            fy(t, e, "progressBar");
          }(d, u), my(d, u), function (t, e) {
            e.removeClass("ck-appear", t);
          }(d, u);
        }, this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      }
      static get pluginName() {
        return "ImageUploadProgress";
      }
      init() {
        const t = this.editor;
        t.plugins.has("ImageBlockEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", this.uploadStatusChange), t.plugins.has("ImageInlineEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", this.uploadStatusChange);
      }
    }
    function hy(t, e) {
      t.hasClass("ck-appear") || e.addClass("ck-appear", t);
    }
    function gy(t, e, n, o) {
      n.hasClass("ck-image-upload-placeholder") || o.addClass("ck-image-upload-placeholder", n);
      const i = t.findViewImgElement(n);
      i.getAttribute("src") !== e && o.setAttribute("src", e, i), py(n, "placeholder") || o.insert(o.createPositionAfter(i), function (t) {
        const e = t.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return t.setCustomProperty("placeholder", !0, e), e;
      }(o));
    }
    function my(t, e) {
      t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), fy(t, e, "placeholder");
    }
    function py(t, e) {
      for (const n of t.getChildren()) if (n.getCustomProperty(e)) return n;
    }
    function fy(t, e, n) {
      const o = py(t, n);
      o && e.remove(e.createRangeOn(o));
    }
    var ky = Object.defineProperty,
      by = Object.defineProperties,
      wy = Object.getOwnPropertyDescriptors,
      Ay = Object.getOwnPropertySymbols,
      _y = Object.prototype.hasOwnProperty,
      Cy = Object.prototype.propertyIsEnumerable,
      vy = (t, e, n) => e in t ? ky(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n;
    class yy extends Pr {
      refresh() {
        const t = this.editor,
          e = t.plugins.get("ImageUtils"),
          n = t.model.document.selection.getSelectedElement();
        this.isEnabled = e.isImageAllowed() || e.isImage(n);
      }
      execute(t) {
        const e = Ai(t.file),
          n = this.editor.model.document.selection,
          o = this.editor.plugins.get("ImageUtils"),
          i = Object.fromEntries(n.getAttributes());
        e.forEach((t, e) => {
          const r = n.getSelectedElement();
          if (e && r && o.isImage(r)) {
            const e = this.editor.model.createPositionAfter(r);
            this._uploadImage(t, i, e);
          } else this._uploadImage(t, i);
        });
      }
      _uploadImage(t, e, n) {
        const o = this.editor,
          i = o.plugins.get(m_).createLoader(t),
          r = o.plugins.get("ImageUtils");
        var s, a;
        i && r.insertImage((s = ((t, e) => {
          for (var n in e || (e = {})) _y.call(e, n) && vy(t, n, e[n]);
          if (Ay) for (var n of Ay(e)) Cy.call(e, n) && vy(t, n, e[n]);
          return t;
        })({}, e), a = {
          uploadId: i.id
        }, by(s, wy(a))), n);
      }
    }
    class xy extends Br {
      constructor(t) {
        super(t), t.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        }), this._uploadImageElements = new Map();
      }
      static get requires() {
        return [m_, xf, Jb, lv];
      }
      static get pluginName() {
        return "ImageUploadEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.document,
          n = t.conversion,
          o = t.plugins.get(m_),
          i = t.plugins.get("ImageUtils"),
          r = t.plugins.get("ClipboardPipeline"),
          s = ey(t.config.get("image.upload.types")),
          a = new yy(t);
        t.commands.add("uploadImage", a), t.commands.add("imageUpload", a), n.for("upcast").attributeToAttribute({
          view: {
            name: "img",
            key: "uploadId"
          },
          model: "uploadId"
        }), this.listenTo(t.editing.view.document, "clipboardInput", (e, n) => {
          if (o = n.dataTransfer, Array.from(o.types).includes("text/html") && "" !== o.getData("text/html")) return;
          var o;
          const i = Array.from(n.dataTransfer.files).filter(t => !!t && s.test(t.type));
          i.length && (e.stop(), t.model.change(e => {
            n.targetRanges && e.setSelection(n.targetRanges.map(e => t.editing.mapper.toModelRange(e))), t.execute("uploadImage", {
              file: i
            });
          }));
        }), this.listenTo(r, "inputTransformation", (e, n) => {
          const r = Array.from(t.editing.view.createRangeIn(n.content)).map(t => t.item).filter(t => function (t, e) {
            return !(!t.isInlineImageView(e) || !e.getAttribute("src") || !e.getAttribute("src").match(/^data:image\/\w+;base64,/g) && !e.getAttribute("src").match(/^blob:/g));
          }(i, t) && !t.getAttribute("uploadProcessed")).map(t => ({
            promise: ny(t),
            imageElement: t
          }));
          if (!r.length) return;
          const s = new Qh(t.editing.view.document);
          for (const t of r) {
            s.setAttribute("uploadProcessed", !0, t.imageElement);
            const e = o.createLoader(t.promise);
            e && (s.setAttribute("src", "", t.imageElement), s.setAttribute("uploadId", e.id, t.imageElement));
          }
        }), t.editing.view.document.on("dragover", (t, e) => {
          e.preventDefault();
        }), e.on("change", () => {
          const n = e.differ.getChanges({
              includeChangesInGraveyard: !0
            }).reverse(),
            i = new Set();
          for (const e of n) if ("insert" == e.type && "$text" != e.name) {
            const n = e.position.nodeAfter,
              r = "$graveyard" == e.position.root.rootName;
            for (const e of Ey(t, n)) {
              const t = e.getAttribute("uploadId");
              if (!t) continue;
              const n = o.loaders.get(t);
              n && (r ? i.has(t) || n.abort() : (i.add(t), this._uploadImageElements.set(t, e), "idle" == n.status && this._readAndUpload(n)));
            }
          }
        }), this.on("uploadComplete", (t, {
          imageElement: e,
          data: n
        }) => {
          const o = n.urls ? n.urls : n;
          this.editor.model.change(t => {
            t.setAttribute("src", o.default, e), this._parseAndSetSrcsetAttributeOnImage(o, e, t), i.setImageNaturalSizeAttributes(e);
          });
        }, {
          priority: "low"
        });
      }
      afterInit() {
        const t = this.editor.model.schema;
        this.editor.plugins.has("ImageBlockEditing") && t.extend("imageBlock", {
          allowAttributes: ["uploadId", "uploadStatus"]
        }), this.editor.plugins.has("ImageInlineEditing") && t.extend("imageInline", {
          allowAttributes: ["uploadId", "uploadStatus"]
        });
      }
      _readAndUpload(t) {
        const e = this.editor,
          n = e.model,
          o = e.locale.t,
          i = e.plugins.get(m_),
          r = e.plugins.get(xf),
          a = e.plugins.get("ImageUtils"),
          c = this._uploadImageElements;
        return n.enqueueChange({
          isUndoable: !1
        }, e => {
          e.setAttribute("uploadStatus", "reading", c.get(t.id));
        }), t.read().then(() => {
          const i = t.upload(),
            r = c.get(t.id);
          if (s.isSafari) {
            const t = e.editing.mapper.toViewElement(r),
              n = a.findViewImgElement(t);
            e.editing.view.once("render", () => {
              if (!n.parent) return;
              const t = e.editing.view.domConverter.mapViewToDom(n.parent);
              if (!t) return;
              const o = t.style.display;
              t.style.display = "none", t._ckHack = t.offsetHeight, t.style.display = o;
            });
          }
          return e.ui && e.ui.ariaLiveAnnouncer.announce(o("Uploading image")), n.enqueueChange({
            isUndoable: !1
          }, t => {
            t.setAttribute("uploadStatus", "uploading", r);
          }), i;
        }).then(i => {
          n.enqueueChange({
            isUndoable: !1
          }, n => {
            const r = c.get(t.id);
            n.setAttribute("uploadStatus", "complete", r), e.ui && e.ui.ariaLiveAnnouncer.announce(o("Image upload complete")), this.fire("uploadComplete", {
              data: i,
              imageElement: r
            });
          }), l();
        }).catch(i => {
          if (e.ui && e.ui.ariaLiveAnnouncer.announce(o("Error during image upload")), "error" !== t.status && "aborted" !== t.status) throw i;
          "error" == t.status && i && r.showWarning(i, {
            title: o("Upload failed"),
            namespace: "upload"
          }), n.enqueueChange({
            isUndoable: !1
          }, e => {
            e.remove(c.get(t.id));
          }), l();
        });
        function l() {
          n.enqueueChange({
            isUndoable: !1
          }, e => {
            const n = c.get(t.id);
            e.removeAttribute("uploadId", n), e.removeAttribute("uploadStatus", n), c.delete(t.id);
          }), i.destroyLoader(t);
        }
      }
      _parseAndSetSrcsetAttributeOnImage(t, e, n) {
        let o = 0;
        const i = Object.keys(t).filter(t => {
          const e = parseInt(t, 10);
          if (!isNaN(e)) return o = Math.max(o, e), !0;
        }).map(e => `${t[e]} ${e}w`).join(", ");
        if ("" != i) {
          const t = {
            srcset: i
          };
          e.hasAttribute("width") || e.hasAttribute("height") || (t.width = o), n.setAttributes(t, e);
        }
      }
    }
    function Ey(t, e) {
      const n = t.plugins.get("ImageUtils");
      return Array.from(t.model.createRangeOn(e)).filter(t => n.isImage(t.item)).map(t => t.item);
    }
    Dy = Tb;
    var Dy, Iy;
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    var Ty = n(4642),
      My = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ty.A, My);
    Ty.A.locals;
    var Sy = n(3469),
      By = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Sy.A, By);
    Sy.A.locals;
    class Ny extends Pr {
      constructor(t, e) {
        super(t), this._defaultStyles = {
          imageBlock: !1,
          imageInline: !1
        }, this._styles = new Map(e.map(t => {
          if (t.isDefault) for (const e of t.modelElements) this._defaultStyles[e] = t.name;
          return [t.name, t];
        }));
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!t, this.isEnabled ? t.hasAttribute("imageStyle") ? this.value = t.getAttribute("imageStyle") : this.value = this._defaultStyles[t.name] : this.value = !1;
      }
      execute(t = {}) {
        const e = this.editor,
          n = e.model,
          o = e.plugins.get("ImageUtils");
        n.change(e => {
          const i = t.value,
            {
              setImageSizes: r = !0
            } = t;
          let s = o.getClosestSelectedImageElement(n.document.selection);
          i && this.shouldConvertImageType(i, s) && (this.editor.execute(o.isBlockImage(s) ? "imageTypeInline" : "imageTypeBlock", {
            setImageSizes: r
          }), s = o.getClosestSelectedImageElement(n.document.selection)), !i || this._styles.get(i).isDefault ? e.removeAttribute("imageStyle", s) : e.setAttribute("imageStyle", i, s), r && o.setImageNaturalSizeAttributes(s);
        });
      }
      shouldConvertImageType(t, e) {
        return !this._styles.get(t).modelElements.includes(e.name);
      }
    }
    var Py = Object.defineProperty,
      Oy = Object.getOwnPropertySymbols,
      Ly = Object.prototype.hasOwnProperty,
      zy = Object.prototype.propertyIsEnumerable,
      Ry = (t, e, n) => e in t ? Py(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      jy = (t, e) => {
        for (var n in e || (e = {})) Ly.call(e, n) && Ry(t, n, e[n]);
        if (Oy) for (var n of Oy(e)) zy.call(e, n) && Ry(t, n, e[n]);
        return t;
      };
    const {
        objectFullWidth: Fy,
        objectInline: Vy,
        objectLeft: Hy,
        objectRight: Uy,
        objectCenter: qy,
        objectBlockLeft: Gy,
        objectBlockRight: Wy
      } = gg,
      Ky = {
        get inline() {
          return {
            name: "inline",
            title: "In line",
            icon: Vy,
            modelElements: ["imageInline"],
            isDefault: !0
          };
        },
        get alignLeft() {
          return {
            name: "alignLeft",
            title: "Left aligned image",
            icon: Hy,
            modelElements: ["imageBlock", "imageInline"],
            className: "image-style-align-left"
          };
        },
        get alignBlockLeft() {
          return {
            name: "alignBlockLeft",
            title: "Left aligned image",
            icon: Gy,
            modelElements: ["imageBlock"],
            className: "image-style-block-align-left"
          };
        },
        get alignCenter() {
          return {
            name: "alignCenter",
            title: "Centered image",
            icon: qy,
            modelElements: ["imageBlock"],
            className: "image-style-align-center"
          };
        },
        get alignRight() {
          return {
            name: "alignRight",
            title: "Right aligned image",
            icon: Uy,
            modelElements: ["imageBlock", "imageInline"],
            className: "image-style-align-right"
          };
        },
        get alignBlockRight() {
          return {
            name: "alignBlockRight",
            title: "Right aligned image",
            icon: Wy,
            modelElements: ["imageBlock"],
            className: "image-style-block-align-right"
          };
        },
        get block() {
          return {
            name: "block",
            title: "Centered image",
            icon: qy,
            modelElements: ["imageBlock"],
            isDefault: !0
          };
        },
        get side() {
          return {
            name: "side",
            title: "Side image",
            icon: Uy,
            modelElements: ["imageBlock"],
            className: "image-style-side"
          };
        }
      },
      $y = {
        full: Fy,
        left: Gy,
        right: Wy,
        center: qy,
        inlineLeft: Hy,
        inlineRight: Uy,
        inline: Vy
      },
      Yy = [{
        name: "imageStyle:wrapText",
        title: "Wrap text",
        defaultItem: "imageStyle:alignLeft",
        items: ["imageStyle:alignLeft", "imageStyle:alignRight"]
      }, {
        name: "imageStyle:breakText",
        title: "Break text",
        defaultItem: "imageStyle:block",
        items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"]
      }];
    function Qy(t) {
      A("image-style-configuration-definition-invalid", t);
    }
    const Zy = {
      normalizeStyles: function (t) {
        return (t.configuredStyles.options || []).map(t => function (t) {
          t = "string" == typeof t ? Ky[t] ? jy({}, Ky[t]) : {
            name: t
          } : function (t, e) {
            const n = jy({}, e);
            for (const o in t) Object.prototype.hasOwnProperty.call(e, o) || (n[o] = t[o]);
            return n;
          }(Ky[t.name], t);
          "string" == typeof t.icon && (t.icon = $y[t.icon] || t.icon);
          return t;
        }(t)).filter(e => function (t, {
          isBlockPluginLoaded: e,
          isInlinePluginLoaded: n
        }) {
          const {
            modelElements: o,
            name: i
          } = t;
          if (!(o && o.length && i)) return Qy({
            style: t
          }), !1;
          {
            const i = [e ? "imageBlock" : null, n ? "imageInline" : null];
            if (!o.some(t => i.includes(t))) return A("image-style-missing-dependency", {
              style: t,
              missingPlugins: o.map(t => "imageBlock" === t ? "ImageBlockEditing" : "ImageInlineEditing")
            }), !1;
          }
          return !0;
        }(e, t));
      },
      getDefaultStylesConfiguration: function (t, e) {
        return t && e ? {
          options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"]
        } : t ? {
          options: ["block", "side"]
        } : e ? {
          options: ["inline", "alignLeft", "alignRight"]
        } : {};
      },
      getDefaultDropdownDefinitions: function (t) {
        return t.has("ImageBlockEditing") && t.has("ImageInlineEditing") ? [...Yy] : [];
      },
      warnInvalidStyle: Qy,
      DEFAULT_OPTIONS: Ky,
      DEFAULT_ICONS: $y,
      DEFAULT_DROPDOWN_DEFINITIONS: Yy
    };
    function Jy(t, e) {
      for (const n of e) if (n.name === t) return n;
    }
    class Xy extends Br {
      static get pluginName() {
        return "ImageStyleEditing";
      }
      static get requires() {
        return [lv];
      }
      init() {
        const {
            normalizeStyles: t,
            getDefaultStylesConfiguration: e
          } = Zy,
          n = this.editor,
          o = n.plugins.has("ImageBlockEditing"),
          i = n.plugins.has("ImageInlineEditing");
        n.config.define("image.styles", e(o, i)), this.normalizedStyles = t({
          configuredStyles: n.config.get("image.styles"),
          isBlockPluginLoaded: o,
          isInlinePluginLoaded: i
        }), this._setupConversion(o, i), this._setupPostFixer(), n.commands.add("imageStyle", new Ny(n, this.normalizedStyles));
      }
      _setupConversion(t, e) {
        const n = this.editor,
          o = n.model.schema,
          i = (r = this.normalizedStyles, (t, e, n) => {
            if (!n.consumable.consume(e.item, t.name)) return;
            const o = Jy(e.attributeNewValue, r),
              i = Jy(e.attributeOldValue, r),
              s = n.mapper.toViewElement(e.item),
              a = n.writer;
            i && a.removeClass(i.className, s), o && a.addClass(o.className, s);
          });
        var r;
        const s = function (t) {
          const e = {
            imageInline: t.filter(t => !t.isDefault && t.modelElements.includes("imageInline")),
            imageBlock: t.filter(t => !t.isDefault && t.modelElements.includes("imageBlock"))
          };
          return (t, n, o) => {
            if (!n.modelRange) return;
            const i = n.viewItem,
              r = Wi(n.modelRange.getItems());
            if (r && o.schema.checkAttribute(r, "imageStyle")) for (const t of e[r.name]) o.consumable.consume(i, {
              classes: t.className
            }) && o.writer.setAttribute("imageStyle", t.name, r);
          };
        }(this.normalizedStyles);
        n.editing.downcastDispatcher.on("attribute:imageStyle", i), n.data.downcastDispatcher.on("attribute:imageStyle", i), t && (o.extend("imageBlock", {
          allowAttributes: "imageStyle"
        }), n.data.upcastDispatcher.on("element:figure", s, {
          priority: "low"
        })), e && (o.extend("imageInline", {
          allowAttributes: "imageStyle"
        }), n.data.upcastDispatcher.on("element:img", s, {
          priority: "low"
        }));
      }
      _setupPostFixer() {
        const t = this.editor,
          e = t.model.document,
          n = t.plugins.get(lv),
          o = new Map(this.normalizedStyles.map(t => [t.name, t]));
        e.registerPostFixer(t => {
          let i = !1;
          for (const r of e.differ.getChanges()) if ("insert" == r.type || "attribute" == r.type && "imageStyle" == r.attributeKey) {
            let e = "insert" == r.type ? r.position.nodeAfter : r.range.start.nodeAfter;
            if (e && e.is("element", "paragraph") && e.childCount > 0 && (e = e.getChild(0)), !n.isImage(e)) continue;
            const s = e.getAttribute("imageStyle");
            if (!s) continue;
            const a = o.get(s);
            a && a.modelElements.includes(e.name) || (t.removeAttribute("imageStyle", e), i = !0);
          }
          return i;
        });
      }
    }
    var tx = n(6386),
      ex = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(tx.A, ex);
    tx.A.locals;
    class nx extends Br {
      static get requires() {
        return [Xy];
      }
      static get pluginName() {
        return "ImageStyleUI";
      }
      get localizedDefaultStylesTitles() {
        const t = this.editor.t;
        return {
          "Wrap text": t("Wrap text"),
          "Break text": t("Break text"),
          "In line": t("In line"),
          "Full size image": t("Full size image"),
          "Side image": t("Side image"),
          "Left aligned image": t("Left aligned image"),
          "Centered image": t("Centered image"),
          "Right aligned image": t("Right aligned image")
        };
      }
      init() {
        const t = this.editor.plugins,
          e = this.editor.config.get("image.toolbar") || [],
          n = ox(t.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
        for (const t of n) this._createButton(t);
        const o = ox([...e.filter(R), ...Zy.getDefaultDropdownDefinitions(t)], this.localizedDefaultStylesTitles);
        for (const t of o) this._createDropdown(t, n);
      }
      _createDropdown(t, e) {
        const n = this.editor.ui.componentFactory;
        n.add(t.name, o => {
          let i;
          const {
              defaultItem: r,
              items: s,
              title: a
            } = t,
            c = s.filter(t => e.find(({
              name: e
            }) => ix(e) === t)).map(t => {
              const e = n.create(t);
              return t === r && (i = e), e;
            });
          s.length !== c.length && Zy.warnInvalidStyle({
            dropdown: t
          });
          const l = zm(o, Bm),
            d = l.buttonView,
            u = d.arrowView;
          return Rm(l, c, {
            enableActiveItemFocusOnDropdownOpen: !0
          }), d.set({
            label: rx(a, i.label),
            class: null,
            tooltip: !0
          }), u.unbind("label"), u.set({
            label: a
          }), d.bind("icon").toMany(c, "isOn", (...t) => {
            const e = t.findIndex(Ii);
            return e < 0 ? i.icon : c[e].icon;
          }), d.bind("label").toMany(c, "isOn", (...t) => {
            const e = t.findIndex(Ii);
            return rx(a, e < 0 ? i.label : c[e].label);
          }), d.bind("isOn").toMany(c, "isOn", (...t) => t.some(Ii)), d.bind("class").toMany(c, "isOn", (...t) => t.some(Ii) ? "ck-splitbutton_flatten" : void 0), d.on("execute", () => {
            c.some(({
              isOn: t
            }) => t) ? l.isOpen = !l.isOpen : i.fire("execute");
          }), l.bind("isEnabled").toMany(c, "isEnabled", (...t) => t.some(Ii)), this.listenTo(l, "execute", () => {
            this.editor.editing.view.focus();
          }), l;
        });
      }
      _createButton(t) {
        const e = t.name;
        this.editor.ui.componentFactory.add(ix(e), n => {
          const o = this.editor.commands.get("imageStyle"),
            i = new Sg(n);
          return i.set({
            label: t.title,
            icon: t.icon,
            tooltip: !0,
            isToggleable: !0
          }), i.bind("isEnabled").to(o, "isEnabled"), i.bind("isOn").to(o, "value", t => t === e), i.on("execute", this._executeCommand.bind(this, e)), i;
        });
      }
      _executeCommand(t) {
        this.editor.execute("imageStyle", {
          value: t
        }), this.editor.editing.view.focus();
      }
    }
    function ox(t, e) {
      for (const n of t) e[n.title] && (n.title = e[n.title]);
      return t;
    }
    function ix(t) {
      return `imageStyle:${t}`;
    }
    function rx(t, e) {
      return (t ? t + ": " : "") + e;
    }
    class sx extends Br {
      static get pluginName() {
        return "IndentEditing";
      }
      init() {
        const t = this.editor;
        t.commands.add("indent", new Lr(t)), t.commands.add("outdent", new Lr(t));
      }
    }
    class ax extends Br {
      static get pluginName() {
        return "IndentUI";
      }
      init() {
        const t = this.editor,
          e = t.locale,
          n = t.t,
          o = "ltr" == e.uiLanguageDirection ? gg.indent : gg.outdent,
          i = "ltr" == e.uiLanguageDirection ? gg.outdent : gg.indent;
        this._defineButton("indent", n("Increase indent"), o), this._defineButton("outdent", n("Decrease indent"), i);
      }
      _defineButton(t, e, n) {
        const o = this.editor;
        o.ui.componentFactory.add(t, () => {
          const o = this._createButton(Sg, t, e, n);
          return o.set({
            tooltip: !0
          }), o;
        }), o.ui.componentFactory.add("menuBar:" + t, () => this._createButton(Yk, t, e, n));
      }
      _createButton(t, e, n, o) {
        const i = this.editor,
          r = i.commands.get(e),
          s = new t(i.locale);
        return s.set({
          label: n,
          icon: o
        }), s.bind("isEnabled").to(r, "isEnabled"), this.listenTo(s, "execute", () => {
          i.execute(e), i.editing.view.focus();
        }), s;
      }
    }
    class cx {
      constructor() {
        this._definitions = new Set();
      }
      get length() {
        return this._definitions.size;
      }
      add(t) {
        Array.isArray(t) ? t.forEach(t => this._definitions.add(t)) : this._definitions.add(t);
      }
      getDispatcher() {
        return t => {
          t.on("attribute:linkHref", (t, e, n) => {
            if (!n.consumable.test(e.item, "attribute:linkHref")) return;
            if (!e.item.is("selection") && !n.schema.isInline(e.item)) return;
            const o = n.writer,
              i = o.document.selection;
            for (const t of this._definitions) {
              const r = o.createAttributeElement("a", t.attributes, {
                priority: 5
              });
              t.classes && o.addClass(t.classes, r);
              for (const e in t.styles) o.setStyle(e, t.styles[e], r);
              o.setCustomProperty("link", !0, r), t.callback(e.attributeNewValue) ? e.item.is("selection") ? o.wrap(i.getFirstRange(), r) : o.wrap(n.mapper.toViewRange(e.range), r) : o.unwrap(n.mapper.toViewRange(e.range), r);
            }
          }, {
            priority: "high"
          });
        };
      }
      getDispatcherForLinkedImage() {
        return t => {
          t.on("attribute:linkHref:imageBlock", (t, e, {
            writer: n,
            mapper: o
          }) => {
            const i = o.toViewElement(e.item),
              r = Array.from(i.getChildren()).find(t => t.is("element", "a"));
            for (const t of this._definitions) {
              const o = Yi(t.attributes);
              if (t.callback(e.attributeNewValue)) {
                for (const [t, e] of o) "class" === t ? n.addClass(e, r) : n.setAttribute(t, e, r);
                t.classes && n.addClass(t.classes, r);
                for (const e in t.styles) n.setStyle(e, t.styles[e], r);
              } else {
                for (const [t, e] of o) "class" === t ? n.removeClass(e, r) : n.removeAttribute(t, r);
                t.classes && n.removeClass(t.classes, r);
                for (const e in t.styles) n.removeStyle(e, r);
              }
            }
          });
        };
      }
    }
    const lx = function (t, e, n) {
      var o = t.length;
      return n = void 0 === n ? o : n, !e && n >= o ? t : Ts(t, e, n);
    };
    var dx = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    const ux = function (t) {
      return dx.test(t);
    };
    const hx = function (t) {
      return t.split("");
    };
    var gx = "\\ud800-\\udfff",
      mx = "[" + gx + "]",
      px = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      fx = "\\ud83c[\\udffb-\\udfff]",
      kx = "[^" + gx + "]",
      bx = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      wx = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      Ax = "(?:" + px + "|" + fx + ")" + "?",
      _x = "[\\ufe0e\\ufe0f]?",
      Cx = _x + Ax + ("(?:\\u200d(?:" + [kx, bx, wx].join("|") + ")" + _x + Ax + ")*"),
      vx = "(?:" + [kx + px + "?", px, bx, wx, mx].join("|") + ")",
      yx = RegExp(fx + "(?=" + fx + ")|" + vx + Cx, "g");
    const xx = function (t) {
      return t.match(yx) || [];
    };
    const Ex = function (t) {
      return ux(t) ? xx(t) : hx(t);
    };
    const Dx = function (t) {
        return function (e) {
          e = ys(e);
          var n = ux(e) ? Ex(e) : void 0,
            o = n ? n[0] : e.charAt(0),
            i = n ? lx(n, 1).join("") : e.slice(1);
          return o[t]() + i;
        };
      }("toUpperCase"),
      Ix = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
      Tx = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
      Mx = /^((\w+:(\/{2,})?)|(\W))/i,
      Sx = ["https?", "ftps?", "mailto"],
      Bx = "Ctrl+K";
    function Nx(t, {
      writer: e
    }) {
      const n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      return e.setCustomProperty("link", !0, n), n;
    }
    function Px(t, e = Sx) {
      const n = String(t),
        o = e.join("|");
      return function (t, e) {
        const n = t.replace(Ix, "");
        return !!n.match(e);
      }(n, new RegExp(`${"^(?:(?:<protocols>):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))".replace("<protocols>", o)}`, "i")) ? n : "#";
    }
    function Ox(t, e) {
      return !!t && e.checkAttribute(t.name, "linkHref");
    }
    function Lx(t, e) {
      const n = (o = t, Tx.test(o) ? "mailto:" : e);
      var o;
      const i = !!n && !zx(t);
      return t && i ? n + t : t;
    }
    function zx(t) {
      return Mx.test(t);
    }
    function Rx(t) {
      window.open(t, "_blank", "noopener");
    }
    class jx extends Pr {
      constructor() {
        super(...arguments), this.manualDecorators = new Gi(), this.automaticDecorators = new cx();
      }
      restoreManualDecoratorStates() {
        for (const t of this.manualDecorators) t.value = this._getDecoratorStateFromModel(t.id);
      }
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = e.getSelectedElement() || Wi(e.getSelectedBlocks());
        Ox(n, t.schema) ? (this.value = n.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttribute(n, "linkHref")) : (this.value = e.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref"));
        for (const t of this.manualDecorators) t.value = this._getDecoratorStateFromModel(t.id);
      }
      execute(t, e = {}) {
        const n = this.editor.model,
          o = n.document.selection,
          i = [],
          r = [];
        for (const t in e) e[t] ? i.push(t) : r.push(t);
        n.change(e => {
          if (o.isCollapsed) {
            const s = o.getFirstPosition();
            if (o.hasAttribute("linkHref")) {
              const a = Fx(o);
              let c = Mw(s, "linkHref", o.getAttribute("linkHref"), n);
              o.getAttribute("linkHref") === a && (c = this._updateLinkContent(n, e, c, t)), e.setAttribute("linkHref", t, c), i.forEach(t => {
                e.setAttribute(t, !0, c);
              }), r.forEach(t => {
                e.removeAttribute(t, c);
              }), e.setSelection(e.createPositionAfter(c.end.nodeBefore));
            } else if ("" !== t) {
              const r = Yi(o.getAttributes());
              r.set("linkHref", t), i.forEach(t => {
                r.set(t, !0);
              });
              const {
                end: a
              } = n.insertContent(e.createText(t, r), s);
              e.setSelection(a);
            }
            ["linkHref", ...i, ...r].forEach(t => {
              e.removeSelectionAttribute(t);
            });
          } else {
            const s = n.schema.getValidRanges(o.getRanges(), "linkHref"),
              a = [];
            for (const t of o.getSelectedBlocks()) n.schema.checkAttribute(t, "linkHref") && a.push(e.createRangeOn(t));
            const c = a.slice();
            for (const t of s) this._isRangeToUpdate(t, a) && c.push(t);
            for (const s of c) {
              let a = s;
              if (1 === c.length) {
                const i = Fx(o);
                o.getAttribute("linkHref") === i && (a = this._updateLinkContent(n, e, s, t), e.setSelection(e.createSelection(a)));
              }
              e.setAttribute("linkHref", t, a), i.forEach(t => {
                e.setAttribute(t, !0, a);
              }), r.forEach(t => {
                e.removeAttribute(t, a);
              });
            }
          }
        });
      }
      _getDecoratorStateFromModel(t) {
        const e = this.editor.model,
          n = e.document.selection,
          o = n.getSelectedElement();
        return Ox(o, e.schema) ? o.getAttribute(t) : n.getAttribute(t);
      }
      _isRangeToUpdate(t, e) {
        for (const n of e) if (n.containsRange(t)) return !1;
        return !0;
      }
      _updateLinkContent(t, e, n, o) {
        const i = e.createText(o, {
          linkHref: o
        });
        return t.insertContent(i, n);
      }
    }
    function Fx(t) {
      if (t.isCollapsed) {
        const e = t.getFirstPosition();
        return e.textNode && e.textNode.data;
      }
      {
        const e = Array.from(t.getFirstRange().getItems());
        if (e.length > 1) return null;
        const n = e[0];
        return n.is("$text") || n.is("$textProxy") ? n.data : null;
      }
    }
    class Vx extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = e.getSelectedElement();
        Ox(n, t.schema) ? this.isEnabled = t.schema.checkAttribute(n, "linkHref") : this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref");
      }
      execute() {
        const t = this.editor,
          e = this.editor.model,
          n = e.document.selection,
          o = t.commands.get("link");
        e.change(t => {
          const i = n.isCollapsed ? [Mw(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)] : e.schema.getValidRanges(n.getRanges(), "linkHref");
          for (const e of i) if (t.removeAttribute("linkHref", e), o) for (const n of o.manualDecorators) t.removeAttribute(n.id, e);
        });
      }
    }
    class Hx extends G() {
      constructor({
        id: t,
        label: e,
        attributes: n,
        classes: o,
        styles: i,
        defaultValue: r
      }) {
        super(), this.id = t, this.set("value", void 0), this.defaultValue = r, this.label = e, this.attributes = n, this.classes = o, this.styles = i;
      }
      _createPattern() {
        return {
          attributes: this.attributes,
          classes: this.classes,
          styles: this.styles
        };
      }
    }
    var Ux = n(7719),
      qx = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(Ux.A, qx);
    Ux.A.locals;
    var Gx = Object.defineProperty,
      Wx = Object.getOwnPropertySymbols,
      Kx = Object.prototype.hasOwnProperty,
      $x = Object.prototype.propertyIsEnumerable,
      Yx = (t, e, n) => e in t ? Gx(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      Qx = (t, e) => {
        for (var n in e || (e = {})) Kx.call(e, n) && Yx(t, n, e[n]);
        if (Wx) for (var n of Wx(e)) $x.call(e, n) && Yx(t, n, e[n]);
        return t;
      };
    const Zx = "automatic",
      Jx = /^(https?:)?\/\//;
    class Xx extends Br {
      static get pluginName() {
        return "LinkEditing";
      }
      static get requires() {
        return [fw, ow, Jb];
      }
      constructor(t) {
        super(t), t.config.define("link", {
          allowCreatingEmptyLinks: !1,
          addTargetToExternalLinks: !1
        });
      }
      init() {
        const t = this.editor,
          e = this.editor.config.get("link.allowedProtocols");
        t.model.schema.extend("$text", {
          allowAttributes: "linkHref"
        }), t.conversion.for("dataDowncast").attributeToElement({
          model: "linkHref",
          view: Nx
        }), t.conversion.for("editingDowncast").attributeToElement({
          model: "linkHref",
          view: (t, n) => Nx(Px(t, e), n)
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "a",
            attributes: {
              href: !0
            }
          },
          model: {
            key: "linkHref",
            value: t => t.getAttribute("href")
          }
        }), t.commands.add("link", new jx(t)), t.commands.add("unlink", new Vx(t));
        const n = function (t, e) {
          const n = {
            "Open in a new tab": t("Open in a new tab"),
            Downloadable: t("Downloadable")
          };
          return e.forEach(t => ("label" in t && n[t.label] && (t.label = n[t.label]), t)), e;
        }(t.t, function (t) {
          const e = [];
          if (t) for (const [n, o] of Object.entries(t)) {
            const t = Object.assign({}, o, {
              id: `link${Dx(n)}`
            });
            e.push(t);
          }
          return e;
        }(t.config.get("link.decorators")));
        this._enableAutomaticDecorators(n.filter(t => t.mode === Zx)), this._enableManualDecorators(n.filter(t => "manual" === t.mode));
        t.plugins.get(fw).registerAttribute("linkHref"), function (t, e, n, o) {
          const i = t.editing.view,
            r = new Set();
          i.document.registerPostFixer(i => {
            const s = t.model.document.selection;
            let a = !1;
            if (s.hasAttribute(e)) {
              const c = Mw(s.getFirstPosition(), e, s.getAttribute(e), t.model),
                l = t.editing.mapper.toViewRange(c);
              for (const t of l.getItems()) t.is("element", n) && !t.hasClass(o) && (i.addClass(o, t), r.add(t), a = !0);
            }
            return a;
          }), t.conversion.for("editingDowncast").add(t => {
            function e() {
              i.change(t => {
                for (const e of r.values()) t.removeClass(o, e), r.delete(e);
              });
            }
            t.on("insert", e, {
              priority: "highest"
            }), t.on("remove", e, {
              priority: "highest"
            }), t.on("attribute", e, {
              priority: "highest"
            }), t.on("selection", e, {
              priority: "highest"
            });
          });
        }(t, "linkHref", "a", "ck-link_selected"), this._enableLinkOpen(), this._enableSelectionAttributesFixer(), this._enableClipboardIntegration();
      }
      _enableAutomaticDecorators(t) {
        const e = this.editor,
          n = e.commands.get("link").automaticDecorators;
        e.config.get("link.addTargetToExternalLinks") && n.add({
          id: "linkIsExternal",
          mode: Zx,
          callback: t => !!t && Jx.test(t),
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
      }
      _enableManualDecorators(t) {
        if (!t.length) return;
        const e = this.editor,
          n = e.commands.get("link").manualDecorators;
        t.forEach(t => {
          e.model.schema.extend("$text", {
            allowAttributes: t.id
          });
          const o = new Hx(t);
          n.add(o), e.conversion.for("downcast").attributeToElement({
            model: o.id,
            view: (t, {
              writer: e,
              schema: n
            }, {
              item: i
            }) => {
              if ((i.is("selection") || n.isInline(i)) && t) {
                const t = e.createAttributeElement("a", o.attributes, {
                  priority: 5
                });
                o.classes && e.addClass(o.classes, t);
                for (const n in o.styles) e.setStyle(n, o.styles[n], t);
                return e.setCustomProperty("link", !0, t), t;
              }
            }
          }), e.conversion.for("upcast").elementToAttribute({
            view: Qx({
              name: "a"
            }, o._createPattern()),
            model: {
              key: o.id
            }
          });
        });
      }
      _enableLinkOpen() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "click", (t, e) => {
          if (!(s.isMac ? e.domEvent.metaKey : e.domEvent.ctrlKey)) return;
          let n = e.domTarget;
          if ("a" != n.tagName.toLowerCase() && (n = n.closest("a")), !n) return;
          const o = n.getAttribute("href");
          o && (t.stop(), e.preventDefault(), Rx(o));
        }, {
          context: "$capture"
        }), this.listenTo(e, "keydown", (e, n) => {
          const o = t.commands.get("link").value;
          !!o && n.keyCode === mi.enter && n.altKey && (e.stop(), Rx(o));
        });
      }
      _enableSelectionAttributesFixer() {
        const t = this.editor.model,
          e = t.document.selection;
        this.listenTo(e, "change:attribute", (n, {
          attributeKeys: o
        }) => {
          o.includes("linkHref") && !e.hasAttribute("linkHref") && t.change(e => {
            var n;
            !function (t, e) {
              t.removeSelectionAttribute("linkHref");
              for (const n of e) t.removeSelectionAttribute(n);
            }(e, (n = t.schema, n.getDefinition("$text").allowAttributes.filter(t => t.startsWith("link"))));
          });
        });
      }
      _enableClipboardIntegration() {
        const t = this.editor,
          e = t.model,
          n = this.editor.config.get("link.defaultProtocol");
        n && this.listenTo(t.plugins.get("ClipboardPipeline"), "contentInsertion", (t, o) => {
          e.change(t => {
            const e = t.createRangeIn(o.content);
            for (const o of e.getItems()) if (o.hasAttribute("linkHref")) {
              const e = Lx(o.getAttribute("linkHref"), n);
              t.setAttribute("linkHref", e, o);
            }
          });
        });
      }
    }
    var tE = n(3817),
      eE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(tE.A, eE);
    tE.A.locals;
    class nE extends Dr {
      constructor(t, e, n) {
        super(t), this.focusTracker = new Ki(), this.keystrokes = new $i(), this._focusables = new er();
        const o = t.t;
        this._validators = n, this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(o("Save"), gg.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(o("Cancel"), gg.cancel, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(e), this.children = this._createFormChildren(e.manualDecorators), this._focusCycler = new rm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        const i = ["ck", "ck-link-form", "ck-responsive-form"];
        e.manualDecorators.length && i.push("ck-link-form_layout-vertical", "ck-vertical-form"), this.setTemplate({
          tag: "form",
          attributes: {
            class: i,
            tabindex: "-1"
          },
          children: this.children
        });
      }
      getDecoratorSwitchesState() {
        return Array.from(this._manualDecoratorSwitches).reduce((t, e) => (t[e.name] = e.isOn, t), {});
      }
      render() {
        super.render(), Mr({
          view: this
        });
        [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      isValid() {
        this.resetFormStatus();
        for (const t of this._validators) {
          const e = t(this);
          if (e) return this.urlInputView.errorText = e, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.urlInputView.errorText = null;
      }
      _createUrlInput() {
        const t = this.locale.t,
          e = new Gg(this.locale, qm);
        return e.label = t("Link URL"), e;
      }
      _createButton(t, e, n, o) {
        const i = new Sg(this.locale);
        return i.set({
          label: t,
          icon: e,
          tooltip: !0
        }), i.extendTemplate({
          attributes: {
            class: n
          }
        }), o && i.delegate("execute").to(this, o), i;
      }
      _createManualDecoratorSwitches(t) {
        const e = this.createCollection();
        for (const n of t.manualDecorators) {
          const o = new Pg(this.locale);
          o.set({
            name: n.id,
            label: n.label,
            withText: !0
          }), o.bind("isOn").toMany([n, t], "value", (t, e) => void 0 === e && void 0 === t ? !!n.defaultValue : !!t), o.on("execute", () => {
            n.set("value", !o.isOn);
          }), e.add(o);
        }
        return e;
      }
      _createFormChildren(t) {
        const e = this.createCollection();
        if (e.add(this.urlInputView), t.length) {
          const t = new Dr();
          t.setTemplate({
            tag: "ul",
            children: this._manualDecoratorSwitches.map(t => ({
              tag: "li",
              children: [t],
              attributes: {
                class: ["ck", "ck-list__item"]
              }
            })),
            attributes: {
              class: ["ck", "ck-reset", "ck-list"]
            }
          }), e.add(t);
        }
        return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
      }
      get url() {
        const {
          element: t
        } = this.urlInputView.fieldView;
        return t ? t.value.trim() : null;
      }
    }
    var oE = n(8762),
      iE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(oE.A, iE);
    oE.A.locals;
    class rE extends Dr {
      constructor(t, e = {}) {
        super(t), this.focusTracker = new Ki(), this.keystrokes = new $i(), this._focusables = new er();
        const n = t.t;
        this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(n("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), this.editButtonView = this._createButton(n("Edit link"), gg.pencil, "edit"), this.set("href", void 0), this._linkConfig = e, this._focusCycler = new rm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView]
        });
      }
      render() {
        super.render();
        [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createButton(t, e, n) {
        const o = new Sg(this.locale);
        return o.set({
          label: t,
          icon: e,
          tooltip: !0
        }), o.delegate("execute").to(this, n), o;
      }
      _createPreviewButton() {
        const t = new Sg(this.locale),
          e = this.bindTemplate,
          n = this.t;
        return t.set({
          withText: !0,
          tooltip: n("Open link in new tab")
        }), t.extendTemplate({
          attributes: {
            class: ["ck", "ck-link-actions__preview"],
            href: e.to("href", t => t && Px(t, this._linkConfig.allowedProtocols)),
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }), t.bind("label").to(this, "href", t => t || n("This link has no URL")), t.bind("isEnabled").to(this, "href", t => !!t), t.template.tag = "a", t.template.eventListeners = {}, t;
      }
    }
    const sE = "link-ui";
    class aE extends Br {
      constructor() {
        super(...arguments), this.actionsView = null, this.formView = null;
      }
      static get requires() {
        return [Bf];
      }
      static get pluginName() {
        return "LinkUI";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.editing.view.addObserver($h), this._balloon = t.plugins.get(Bf), this._createToolbarLinkButton(), this._enableBalloonActivators(), t.conversion.for("editingDowncast").markerToHighlight({
          model: sE,
          view: {
            classes: ["ck-fake-link-selection"]
          }
        }), t.conversion.for("editingDowncast").markerToElement({
          model: sE,
          view: {
            name: "span",
            classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
          }
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Create link"),
            keystroke: Bx
          }, {
            label: e("Move out of a link"),
            keystroke: [["arrowleft", "arrowleft"], ["arrowright", "arrowright"]]
          }]
        });
      }
      destroy() {
        super.destroy(), this.formView && this.formView.destroy(), this.actionsView && this.actionsView.destroy();
      }
      _createViews() {
        this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._enableUserBalloonInteractions();
      }
      _createActionsView() {
        const t = this.editor,
          e = new rE(t.locale, t.config.get("link")),
          n = t.commands.get("link"),
          o = t.commands.get("unlink");
        return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(o), this.listenTo(e, "edit", () => {
          this._addFormView();
        }), this.listenTo(e, "unlink", () => {
          t.execute("unlink"), this._hideUI();
        }), e.keystrokes.set("Esc", (t, e) => {
          this._hideUI(), e();
        }), e.keystrokes.set(Bx, (t, e) => {
          this._addFormView(), e();
        }), e;
      }
      _createFormView() {
        const t = this.editor,
          e = t.commands.get("link"),
          n = t.config.get("link.defaultProtocol"),
          o = new (Tr(nE))(t.locale, e, function (t) {
            const e = t.t,
              n = t.config.get("link.allowCreatingEmptyLinks");
            return [t => {
              if (!n && !t.url.length) return e("Link URL must not be empty.");
            }];
          }(t));
        return o.urlInputView.fieldView.bind("value").to(e, "value"), o.urlInputView.bind("isEnabled").to(e, "isEnabled"), o.saveButtonView.bind("isEnabled").to(e, "isEnabled"), this.listenTo(o, "submit", () => {
          if (o.isValid()) {
            const {
                value: e
              } = o.urlInputView.fieldView.element,
              i = Lx(e, n);
            t.execute("link", i, o.getDecoratorSwitchesState()), this._closeFormView();
          }
        }), this.listenTo(o.urlInputView, "change:errorText", () => {
          t.ui.update();
        }), this.listenTo(o, "cancel", () => {
          this._closeFormView();
        }), o.keystrokes.set("Esc", (t, e) => {
          this._closeFormView(), e();
        }), o;
      }
      _createToolbarLinkButton() {
        const t = this.editor,
          e = t.commands.get("link");
        t.ui.componentFactory.add("link", () => {
          const t = this._createButton(Sg);
          return t.set({
            tooltip: !0,
            isToggleable: !0
          }), t.bind("isOn").to(e, "value", t => !!t), t;
        }), t.ui.componentFactory.add("menuBar:link", () => this._createButton(Yk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          o = e.commands.get("link"),
          i = new t(e.locale),
          r = n.t;
        return i.set({
          label: r("Link"),
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>',
          keystroke: Bx
        }), i.bind("isEnabled").to(o, "isEnabled"), this.listenTo(i, "execute", () => this._showUI(!0)), i;
      }
      _enableBalloonActivators() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "click", () => {
          this._getSelectedLinkElement() && this._showUI();
        }), t.keystrokes.set(Bx, (e, n) => {
          n(), t.commands.get("link").isEnabled && this._showUI(!0);
        });
      }
      _enableUserBalloonInteractions() {
        this.editor.keystrokes.set("Tab", (t, e) => {
          this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), e());
        }, {
          priority: "high"
        }), this.editor.keystrokes.set("Esc", (t, e) => {
          this._isUIVisible && (this._hideUI(), e());
        }), Ir({
          emitter: this.formView,
          activator: () => this._isUIInPanel,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideUI()
        });
      }
      _addActionsView() {
        this.actionsView || this._createViews(), this._areActionsInPanel || this._balloon.add({
          view: this.actionsView,
          position: this._getBalloonPositionData()
        });
      }
      _addFormView() {
        if (this.formView || this._createViews(), this._isFormInPanel) return;
        const t = this.editor.commands.get("link");
        this.formView.disableCssTransitions(), this.formView.resetFormStatus(), this._balloon.add({
          view: this.formView,
          position: this._getBalloonPositionData()
        }), this.formView.urlInputView.fieldView.value = t.value || "", this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions();
      }
      _closeFormView() {
        const t = this.editor.commands.get("link");
        t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
      }
      _removeFormView() {
        this._isFormInPanel && (this.formView.saveButtonView.focus(), this.formView.urlInputView.fieldView.reset(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
      }
      _showUI(t = !1) {
        this.formView || this._createViews(), this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
      }
      _hideUI() {
        if (!this._isUIInPanel) return;
        const t = this.editor;
        this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
      }
      _startUpdatingUI() {
        const t = this.editor,
          e = t.editing.view.document;
        let n = this._getSelectedLinkElement(),
          o = r();
        const i = () => {
          const t = this._getSelectedLinkElement(),
            e = r();
          n && !t || !n && e !== o ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), n = t, o = e;
        };
        function r() {
          return e.selection.focus.getAncestors().reverse().find(t => t.is("element"));
        }
        this.listenTo(t.ui, "update", i), this.listenTo(this._balloon, "change:visibleView", i);
      }
      get _isFormInPanel() {
        return !!this.formView && this._balloon.hasView(this.formView);
      }
      get _areActionsInPanel() {
        return !!this.actionsView && this._balloon.hasView(this.actionsView);
      }
      get _areActionsVisible() {
        return !!this.actionsView && this._balloon.visibleView === this.actionsView;
      }
      get _isUIInPanel() {
        return this._isFormInPanel || this._areActionsInPanel;
      }
      get _isUIVisible() {
        const t = this._balloon.visibleView;
        return !!this.formView && t == this.formView || this._areActionsVisible;
      }
      _getBalloonPositionData() {
        const t = this.editor.editing.view,
          e = this.editor.model,
          n = t.document;
        let o;
        if (e.markers.has(sE)) {
          const e = Array.from(this.editor.editing.mapper.markerNameToElements(sE)),
            n = t.createRange(t.createPositionBefore(e[0]), t.createPositionAfter(e[e.length - 1]));
          o = t.domConverter.viewRangeToDom(n);
        } else o = () => {
          const e = this._getSelectedLinkElement();
          return e ? t.domConverter.mapViewToDom(e) : t.domConverter.viewRangeToDom(n.selection.getFirstRange());
        };
        return {
          target: o
        };
      }
      _getSelectedLinkElement() {
        const t = this.editor.editing.view,
          e = t.document.selection,
          n = e.getSelectedElement();
        if (e.isCollapsed || n && Yw(n)) return cE(e.getFirstPosition());
        {
          const n = e.getFirstRange().getTrimmed(),
            o = cE(n.start),
            i = cE(n.end);
          return o && o == i && t.createRangeIn(o).getTrimmed().isEqual(n) ? o : null;
        }
      }
      _showFakeVisualSelection() {
        const t = this.editor.model;
        t.change(e => {
          const n = t.document.selection.getFirstRange();
          if (t.markers.has(sE)) e.updateMarker(sE, {
            range: n
          });else if (n.start.isAtEnd) {
            const o = n.start.getLastMatchingPosition(({
              item: e
            }) => !t.schema.isContent(e), {
              boundaries: n
            });
            e.addMarker(sE, {
              usingOperation: !1,
              affectsData: !1,
              range: e.createRange(o, n.end)
            });
          } else e.addMarker(sE, {
            usingOperation: !1,
            affectsData: !1,
            range: n
          });
        });
      }
      _hideFakeVisualSelection() {
        const t = this.editor.model;
        t.markers.has(sE) && t.change(t => {
          t.removeMarker(sE);
        });
      }
    }
    function cE(t) {
      return t.getAncestors().find(t => {
        return (e = t).is("attributeElement") && !!e.getCustomProperty("link");
        var e;
      }) || null;
    }
    const lE = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
    class dE extends Br {
      static get requires() {
        return [hw, Xx];
      }
      static get pluginName() {
        return "AutoLink";
      }
      init() {
        const t = this.editor.model.document.selection;
        t.on("change:range", () => {
          this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
        }), this._enableTypingHandling();
      }
      afterInit() {
        this._enableEnterHandling(), this._enableShiftEnterHandling(), this._enablePasteLinking();
      }
      _expandLinkRange(t, e) {
        return e.textNode && e.textNode.hasAttribute("linkHref") ? Mw(e, "linkHref", e.textNode.getAttribute("linkHref"), t) : null;
      }
      _selectEntireLinks(t, e) {
        const n = this.editor.model,
          o = n.document.selection,
          i = o.getFirstPosition(),
          r = o.getLastPosition();
        let s = e.getJoined(this._expandLinkRange(n, i) || e);
        s && (s = s.getJoined(this._expandLinkRange(n, r) || e)), s && (s.start.isBefore(i) || s.end.isAfter(r)) && t.setSelection(s);
      }
      _enablePasteLinking() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          o = t.plugins.get("ClipboardPipeline"),
          i = t.commands.get("link");
        o.on("inputTransformation", (t, o) => {
          if (!this.isEnabled || !i.isEnabled || n.isCollapsed || "paste" !== o.method) return;
          if (n.rangeCount > 1) return;
          const r = n.getFirstRange(),
            s = o.dataTransfer.getData("text/plain");
          if (!s) return;
          const a = s.match(lE);
          a && a[2] === s && (e.change(t => {
            this._selectEntireLinks(t, r), i.execute(s);
          }), t.stop());
        }, {
          priority: "high"
        });
      }
      _enableTypingHandling() {
        const t = this.editor,
          e = new pw(t.model, t => {
            if (!function (t) {
              return t.length > 4 && " " === t[t.length - 1] && " " !== t[t.length - 2];
            }(t)) return;
            const e = uE(t.substr(0, t.length - 1));
            return e ? {
              url: e
            } : void 0;
          });
        e.on("matched:data", (e, n) => {
          const {
            batch: o,
            range: i,
            url: r
          } = n;
          if (!o.isTyping) return;
          const s = i.end.getShiftedBy(-1),
            a = s.getShiftedBy(-r.length),
            c = t.model.createRange(a, s);
          this._applyAutoLink(r, c);
        }), e.bind("isEnabled").to(this);
      }
      _enableEnterHandling() {
        const t = this.editor,
          e = t.model,
          n = t.commands.get("enter");
        n && n.on("execute", () => {
          const t = e.document.selection.getFirstPosition();
          if (!t.parent.previousSibling) return;
          const n = e.createRangeIn(t.parent.previousSibling);
          this._checkAndApplyAutoLinkOnRange(n);
        });
      }
      _enableShiftEnterHandling() {
        const t = this.editor,
          e = t.model,
          n = t.commands.get("shiftEnter");
        n && n.on("execute", () => {
          const t = e.document.selection.getFirstPosition(),
            n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1));
          this._checkAndApplyAutoLinkOnRange(n);
        });
      }
      _checkAndApplyAutoLinkOnRange(t) {
        const e = this.editor.model,
          {
            text: n,
            range: o
          } = mw(t, e),
          i = uE(n);
        if (i) {
          const t = e.createRange(o.end.getShiftedBy(-i.length), o.end);
          this._applyAutoLink(i, t);
        }
      }
      _applyAutoLink(t, e) {
        const n = this.editor.model,
          o = Lx(t, this.editor.config.get("link.defaultProtocol"));
        this.isEnabled && function (t, e) {
          return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref");
        }(e, n) && zx(o) && !function (t) {
          const e = t.start.nodeAfter;
          return !!e && e.hasAttribute("linkHref");
        }(e) && this._persistAutoLink(o, e);
      }
      _persistAutoLink(t, e) {
        const n = this.editor.model,
          o = this.editor.plugins.get("Delete");
        n.enqueueChange(i => {
          i.setAttribute("linkHref", t, e), n.enqueueChange(() => {
            o.requestUndoOnBackspace();
          });
        });
      }
    }
    function uE(t) {
      const e = lE.exec(t);
      return e ? e[2] : null;
    }
    var hE = n(4808),
      gE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(hE.A, gE);
    hE.A.locals;
    class mE {
      constructor(t, e) {
        this._startElement = t, this._referenceIndent = t.getAttribute("listIndent"), this._isForward = "forward" == e.direction, this._includeSelf = !!e.includeSelf, this._sameAttributes = Ai(e.sameAttributes || []), this._sameIndent = !!e.sameIndent, this._lowerIndent = !!e.lowerIndent, this._higherIndent = !!e.higherIndent;
      }
      static first(t, e) {
        return Wi(new this(t, e)[Symbol.iterator]());
      }
      *[Symbol.iterator]() {
        const t = [];
        for (const {
          node: e
        } of pE(this._getStartNode(), this._isForward ? "forward" : "backward")) {
          const n = e.getAttribute("listIndent");
          if (n < this._referenceIndent) {
            if (!this._lowerIndent) break;
            this._referenceIndent = n;
          } else if (n > this._referenceIndent) {
            if (!this._higherIndent) continue;
            if (!this._isForward) {
              t.push(e);
              continue;
            }
          } else {
            if (!this._sameIndent) {
              if (this._higherIndent) {
                t.length && (yield* t, t.length = 0);
                break;
              }
              continue;
            }
            if (this._sameAttributes.some(t => e.getAttribute(t) !== this._startElement.getAttribute(t))) break;
          }
          t.length && (yield* t, t.length = 0), yield e;
        }
      }
      _getStartNode() {
        return this._includeSelf ? this._startElement : this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
      }
    }
    function* pE(t, e = "forward") {
      const n = "forward" == e,
        o = [];
      let i = null;
      for (; DE(t);) {
        let e = null;
        if (i) {
          const n = t.getAttribute("listIndent"),
            r = i.getAttribute("listIndent");
          n > r ? o[r] = i : n < r ? (e = o[n], o.length = n) : e = i;
        }
        yield {
          node: t,
          previous: i,
          previousNodeInList: e
        }, i = t, t = n ? t.nextSibling : t.previousSibling;
      }
    }
    class fE {
      constructor(t) {
        this._listHead = t;
      }
      [Symbol.iterator]() {
        return pE(this._listHead, "forward");
      }
    }
    var kE = Object.defineProperty,
      bE = Object.defineProperties,
      wE = Object.getOwnPropertyDescriptors,
      AE = Object.getOwnPropertySymbols,
      _E = Object.prototype.hasOwnProperty,
      CE = Object.prototype.propertyIsEnumerable,
      vE = (t, e, n) => e in t ? kE(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      yE = (t, e) => {
        for (var n in e || (e = {})) _E.call(e, n) && vE(t, n, e[n]);
        if (AE) for (var n of AE(e)) CE.call(e, n) && vE(t, n, e[n]);
        return t;
      },
      xE = (t, e) => bE(t, wE(e));
    class EE {
      static next() {
        return p();
      }
    }
    function DE(t) {
      return !!t && t.is("element") && t.hasAttribute("listItemId");
    }
    function IE(t, e = {}) {
      return [...TE(t, xE(yE({}, e), {
        direction: "backward"
      })), ...TE(t, xE(yE({}, e), {
        direction: "forward"
      }))];
    }
    function TE(t, e = {}) {
      const n = "forward" == e.direction,
        o = Array.from(new mE(t, xE(yE({}, e), {
          includeSelf: n,
          sameIndent: !0,
          sameAttributes: "listItemId"
        })));
      return n ? o : o.reverse();
    }
    function ME(t, e) {
      const n = new mE(t, yE({
          sameIndent: !0,
          sameAttributes: "listType"
        }, e)),
        o = new mE(t, yE({
          sameIndent: !0,
          sameAttributes: "listType",
          includeSelf: !0,
          direction: "forward"
        }, e));
      return [...Array.from(n).reverse(), ...o];
    }
    function SE(t) {
      return !mE.first(t, {
        sameIndent: !0,
        sameAttributes: "listItemId"
      });
    }
    function BE(t) {
      return !mE.first(t, {
        direction: "forward",
        sameIndent: !0,
        sameAttributes: "listItemId"
      });
    }
    function NE(t, e = {}) {
      t = Ai(t);
      const n = !1 !== e.withNested,
        o = new Set();
      for (const e of t) for (const t of IE(e, {
        higherIndent: n
      })) o.add(t);
      return FE(o);
    }
    function PE(t) {
      t = Ai(t);
      const e = new Set();
      for (const n of t) for (const t of ME(n)) e.add(t);
      return FE(e);
    }
    function OE(t, e) {
      const n = TE(t, {
          direction: "forward"
        }),
        o = EE.next();
      for (const t of n) e.setAttribute("listItemId", o, t);
      return n;
    }
    function LE(t, e, n) {
      const o = {};
      for (const [t, n] of e.getAttributes()) t.startsWith("list") && (o[t] = n);
      const i = TE(t, {
        direction: "forward"
      });
      for (const t of i) n.setAttributes(o, t);
      return i;
    }
    function zE(t, e, {
      expand: n,
      indentBy: o = 1
    } = {}) {
      t = Ai(t);
      const i = n ? NE(t) : t;
      for (const t of i) {
        const n = t.getAttribute("listIndent") + o;
        n < 0 ? RE(t, e) : e.setAttribute("listIndent", n, t);
      }
      return i;
    }
    function RE(t, e) {
      t = Ai(t);
      for (const n of t) n.is("element", "listItem") && e.rename(n, "paragraph");
      for (const n of t) for (const t of n.getAttributeKeys()) t.startsWith("list") && e.removeAttribute(t, n);
      return t;
    }
    function jE(t) {
      if (!t.length) return !1;
      const e = t[0].getAttribute("listItemId");
      return !!e && !t.some(t => t.getAttribute("listItemId") != e);
    }
    function FE(t) {
      return Array.from(t).filter(t => "$graveyard" !== t.root.rootName).sort((t, e) => t.index - e.index);
    }
    function VE(t) {
      const e = t.document.selection.getSelectedElement();
      return e && t.schema.isObject(e) && t.schema.isBlock(e) ? e : null;
    }
    function HE(t, e) {
      return e.checkChild(t.parent, "listItem") && e.checkChild(t, "$text") && !e.isObject(t);
    }
    function UE(t) {
      return "numbered" == t || "customNumbered" == t;
    }
    function qE(t, e, n) {
      return TE(e, {
        direction: "forward"
      }).pop().index > t.index ? LE(t, e, n) : [];
    }
    class GE extends Pr {
      constructor(t, e) {
        super(t), this._direction = e;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        const t = this.editor.model,
          e = WE(t.document.selection);
        t.change(t => {
          const n = [];
          jE(e) && !SE(e[0]) ? ("forward" == this._direction && n.push(...zE(e, t)), n.push(...OE(e[0], t))) : "forward" == this._direction ? n.push(...zE(e, t, {
            expand: !0
          })) : n.push(...function (t, e) {
            const n = NE(t = Ai(t)),
              o = new Set(),
              i = Math.min(...n.map(t => t.getAttribute("listIndent"))),
              r = new Map();
            for (const t of n) r.set(t, mE.first(t, {
              lowerIndent: !0
            }));
            for (const t of n) {
              if (o.has(t)) continue;
              o.add(t);
              const n = t.getAttribute("listIndent") - 1;
              if (n < 0) RE(t, e);else {
                if (t.getAttribute("listIndent") == i) {
                  const n = qE(t, r.get(t), e);
                  for (const t of n) o.add(t);
                  if (n.length) continue;
                }
                e.setAttribute("listIndent", n, t);
              }
            }
            return FE(o);
          }(e, t));
          for (const e of n) {
            if (!e.hasAttribute("listType")) continue;
            const n = mE.first(e, {
              sameIndent: !0
            });
            n && t.setAttribute("listType", n.getAttribute("listType"), e);
          }
          this._fireAfterExecute(n);
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", FE(new Set(t)));
      }
      _checkEnabled() {
        let t = WE(this.editor.model.document.selection),
          e = t[0];
        if (!e) return !1;
        if ("backward" == this._direction) return !0;
        if (jE(t) && !SE(t[0])) return !0;
        t = NE(t), e = t[0];
        const n = mE.first(e, {
          sameIndent: !0
        });
        return !!n && n.getAttribute("listType") == e.getAttribute("listType");
      }
    }
    function WE(t) {
      const e = Array.from(t.getSelectedBlocks()),
        n = e.findIndex(t => !DE(t));
      return -1 != n && (e.length = n), e;
    }
    var KE = Object.defineProperty,
      $E = Object.defineProperties,
      YE = Object.getOwnPropertyDescriptors,
      QE = Object.getOwnPropertySymbols,
      ZE = Object.prototype.hasOwnProperty,
      JE = Object.prototype.propertyIsEnumerable,
      XE = (t, e, n) => e in t ? KE(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      tD = (t, e) => {
        for (var n in e || (e = {})) ZE.call(e, n) && XE(t, n, e[n]);
        if (QE) for (var n of QE(e)) JE.call(e, n) && XE(t, n, e[n]);
        return t;
      },
      eD = (t, e) => $E(t, YE(e));
    class nD extends Pr {
      constructor(t, e, n = {}) {
        super(t), this.type = e, this._listWalkerOptions = n.multiLevel ? {
          higherIndent: !0,
          lowerIndent: !0,
          sameAttributes: []
        } : void 0;
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute(t = {}) {
        const e = this.editor.model,
          n = e.document,
          o = VE(e),
          i = Array.from(n.selection.getSelectedBlocks()).filter(t => e.schema.checkAttribute(t, "listType") || HE(t, e.schema)),
          r = void 0 !== t.forceValue ? !t.forceValue : this.value;
        e.change(s => {
          if (r) {
            const t = i[i.length - 1],
              e = TE(t, {
                direction: "forward"
              }),
              n = [];
            e.length > 1 && n.push(...OE(e[1], s)), n.push(...RE(i, s)), n.push(...function (t, e) {
              const n = [];
              let o = Number.POSITIVE_INFINITY;
              for (const {
                node: i
              } of pE(t.nextSibling, "forward")) {
                const t = i.getAttribute("listIndent");
                if (0 == t) break;
                t < o && (o = t);
                const r = t - o;
                e.setAttribute("listIndent", r, i), n.push(i);
              }
              return n;
            }(t, s)), this._fireAfterExecute(n);
          } else if ((o || n.selection.isCollapsed) && DE(i[0])) {
            const e = ME(o || i[0], this._listWalkerOptions);
            for (const n of e) s.setAttributes(eD(tD({}, t.additionalAttributes), {
              listType: this.type
            }), n);
            this._fireAfterExecute(e);
          } else {
            const n = [];
            for (const o of i) if (o.hasAttribute("listType")) for (const e of NE(o, {
              withNested: !1
            })) e.getAttribute("listType") != this.type && (s.setAttributes(eD(tD({}, t.additionalAttributes), {
              listType: this.type
            }), e), n.push(e));else !o.is("element", "listItem") && HE(o, e.schema) && s.rename(o, "listItem"), s.setAttributes(eD(tD({}, t.additionalAttributes), {
              listIndent: 0,
              listItemId: EE.next(),
              listType: this.type
            }), o), n.push(o);
            this._fireAfterExecute(n);
          }
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", FE(new Set(t)));
      }
      _getValue() {
        const t = this.editor.model.document.selection,
          e = Array.from(t.getSelectedBlocks());
        if (!e.length) return !1;
        for (const t of e) if (t.getAttribute("listType") != this.type) return !1;
        return !0;
      }
      _checkEnabled() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection,
          o = Array.from(n.getSelectedBlocks());
        if (!o.length) return !1;
        if (this.value) return !0;
        for (const t of o) if (e.checkAttribute(t, "listType") || HE(t, e)) return !0;
        return !1;
      }
    }
    class oD extends Pr {
      constructor(t, e) {
        super(t), this._direction = e;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute({
        shouldMergeOnBlocksContentLevel: t = !1
      } = {}) {
        const e = this.editor.model,
          n = e.document.selection,
          o = [];
        e.change(i => {
          const {
              firstElement: r,
              lastElement: s
            } = this._getMergeSubjectElements(n, t),
            a = r.getAttribute("listIndent") || 0,
            c = s.getAttribute("listIndent"),
            l = s.getAttribute("listItemId");
          if (a != c) {
            const t = (d = s, Array.from(new mE(d, {
              direction: "forward",
              higherIndent: !0
            })));
            o.push(...zE([s, ...t], i, {
              indentBy: a - c,
              expand: a < c
            }));
          }
          var d;
          if (t) {
            let t = n;
            n.isCollapsed && (t = i.createSelection(i.createRange(i.createPositionAt(r, "end"), i.createPositionAt(s, 0)))), e.deleteContent(t, {
              doNotResetEntireContent: n.isCollapsed
            });
            const a = t.getLastPosition().parent,
              c = a.nextSibling;
            o.push(a), c && c !== s && c.getAttribute("listItemId") == l && o.push(...LE(c, a, i));
          } else o.push(...LE(s, r, i));
          this._fireAfterExecute(o);
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", FE(new Set(t)));
      }
      _checkEnabled() {
        const t = this.editor.model,
          e = t.document.selection,
          n = VE(t);
        if (e.isCollapsed || n) {
          const t = n || e.getFirstPosition().parent;
          if (!DE(t)) return !1;
          const o = "backward" == this._direction ? t.previousSibling : t.nextSibling;
          if (!o) return !1;
          if (jE([t, o])) return !1;
        } else {
          const t = e.getLastPosition(),
            n = e.getFirstPosition();
          if (t.parent === n.parent) return !1;
          if (!DE(t.parent)) return !1;
        }
        return !0;
      }
      _getMergeSubjectElements(t, e) {
        const n = VE(this.editor.model);
        let o, i;
        if (t.isCollapsed || n) {
          const r = n || t.getFirstPosition().parent,
            s = SE(r);
          "backward" == this._direction ? (i = r, o = s && !e ? mE.first(r, {
            sameIndent: !0,
            lowerIndent: !0
          }) : r.previousSibling) : (o = r, i = r.nextSibling);
        } else o = t.getFirstPosition().parent, i = t.getLastPosition().parent;
        return {
          firstElement: o,
          lastElement: i
        };
      }
    }
    class iD extends Pr {
      constructor(t, e) {
        super(t), this._direction = e;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        this.editor.model.change(t => {
          const e = OE(this._getStartBlock(), t);
          this._fireAfterExecute(e);
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", FE(new Set(t)));
      }
      _checkEnabled() {
        const t = this.editor.model.document.selection,
          e = this._getStartBlock();
        return t.isCollapsed && DE(e) && !SE(e);
      }
      _getStartBlock() {
        const t = this.editor.model.document.selection.getFirstPosition().parent;
        return "before" == this._direction ? t : t.nextSibling;
      }
    }
    class rD extends Br {
      static get pluginName() {
        return "ListUtils";
      }
      expandListBlocksToCompleteList(t) {
        return PE(t);
      }
      isFirstBlockOfListItem(t) {
        return SE(t);
      }
      isListItemBlock(t) {
        return DE(t);
      }
      expandListBlocksToCompleteItems(t, e = {}) {
        return NE(t, e);
      }
      isNumberedListType(t) {
        return UE(t);
      }
    }
    function sD(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    function aD(t) {
      return t.is("element", "li");
    }
    function cD(t, e, n, o = uD(n, e)) {
      return t.createAttributeElement(dD(n), null, {
        priority: 2 * e / 100 - 100,
        id: o
      });
    }
    function lD(t, e, n) {
      return t.createAttributeElement("li", null, {
        priority: (2 * e + 1) / 100 - 100,
        id: n
      });
    }
    function dD(t) {
      return "numbered" == t || "customNumbered" == t ? "ol" : "ul";
    }
    function uD(t, e) {
      return `list-${t}-${e}`;
    }
    function hD(t, e) {
      const n = t.nodeBefore;
      if (DE(n)) {
        let t = n;
        for (const {
          node: n
        } of pE(t, "backward")) if (t = n, e.has(t)) return;
        e.set(n, t);
      } else {
        const n = t.nodeAfter;
        DE(n) && e.set(n, n);
      }
    }
    function gD() {
      return (t, e, n) => {
        const {
          writer: o,
          schema: i
        } = n;
        if (!e.modelRange) return;
        const r = Array.from(e.modelRange.getItems({
          shallow: !0
        })).filter(t => i.checkAttribute(t, "listItemId"));
        if (!r.length) return;
        const s = EE.next(),
          a = function (t) {
            let e = 0,
              n = t.parent;
            for (; n;) {
              if (aD(n)) e++;else {
                const t = n.previousSibling;
                t && aD(t) && e++;
              }
              n = n.parent;
            }
            return e;
          }(e.viewItem);
        let c = e.viewItem.parent && e.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
        const l = r[0].getAttribute("listType");
        l && (c = l);
        const d = {
          listItemId: s,
          listIndent: a,
          listType: c
        };
        for (const t of r) t.hasAttribute("listItemId") || o.setAttributes(d, t);
        r.length > 1 && r[1].getAttribute("listItemId") != d.listItemId && n.keepEmptyElement(r[0]);
      };
    }
    function mD() {
      return (t, e, n) => {
        if (!n.consumable.test(e.viewItem, {
          name: !0
        })) return;
        const o = new Qh(e.viewItem.document);
        for (const t of Array.from(e.viewItem.getChildren())) aD(t) || sD(t) || o.remove(t);
      };
    }
    function pD(t, e, n, {
      dataPipeline: o
    } = {}) {
      const i = function (t) {
        return (e, n) => {
          const o = [];
          for (const n of t) e.hasAttribute(n) && o.push(`attribute:${n}`);
          return !!o.every(t => !1 !== n.test(e, t)) && (o.forEach(t => n.consume(e, t)), !0);
        };
      }(t);
      return (r, s, a) => {
        const {
            writer: c,
            mapper: l,
            consumable: d
          } = a,
          u = s.item;
        if (!t.includes(s.attributeKey)) return;
        if (!i(u, d)) return;
        const h = function (t, e, n) {
          const o = n.createRangeOn(t),
            i = e.toViewRange(o).getTrimmed();
          return i.end.nodeBefore;
        }(u, l, n);
        kD(h, c, l), function (t, e) {
          let n = t.parent;
          for (; n.is("attributeElement") && ["ul", "ol", "li"].includes(n.name);) {
            const o = n.parent;
            e.unwrap(e.createRangeOn(t), n), n = o;
          }
        }(h, c);
        const g = function (t, e, n, o, {
          dataPipeline: i
        }) {
          let r = o.createRangeOn(e);
          if (!SE(t)) return r;
          for (const s of n) {
            if ("itemMarker" != s.scope) continue;
            const n = s.createElement(o, t, {
              dataPipeline: i
            });
            if (!n) continue;
            if (o.setCustomProperty("listItemMarker", !0, n), s.canInjectMarkerIntoElement && s.canInjectMarkerIntoElement(t) ? o.insert(o.createPositionAt(e, 0), n) : (o.insert(r.start, n), r = o.createRange(o.createPositionBefore(n), o.createPositionAfter(e))), !s.createWrapperElement || !s.canWrapElement) continue;
            const a = s.createWrapperElement(o, t, {
              dataPipeline: i
            });
            o.setCustomProperty("listItemWrapper", !0, a), s.canWrapElement(t) ? r = o.wrap(r, a) : (r = o.wrap(o.createRangeOn(n), a), r = o.createRange(r.start, o.createPositionAfter(e)));
          }
          return r;
        }(u, h, e, c, {
          dataPipeline: o
        });
        !function (t, e, n, o) {
          if (!t.hasAttribute("listIndent")) return;
          const i = t.getAttribute("listIndent");
          let r = t;
          for (let t = i; t >= 0; t--) {
            const i = lD(o, t, r.getAttribute("listItemId")),
              s = cD(o, t, r.getAttribute("listType"));
            for (const t of n) "list" != t.scope && "item" != t.scope || !r.hasAttribute(t.attributeName) || t.setAttributeOnDowncast(o, r.getAttribute(t.attributeName), "list" == t.scope ? s : i);
            if (e = o.wrap(e, i), e = o.wrap(e, s), 0 == t) break;
            if (r = mE.first(r, {
              lowerIndent: !0
            }), !r) break;
          }
        }(u, g, e, c);
      };
    }
    function fD(t, {
      dataPipeline: e
    } = {}) {
      return (n, {
        writer: o
      }) => {
        if (!bD(n, t)) return null;
        if (!e) return o.createContainerElement("span", {
          class: "ck-list-bogus-paragraph"
        });
        const i = o.createContainerElement("p");
        return o.setCustomProperty("dataPipeline:transparentRendering", !0, i), i;
      };
    }
    function kD(t, e, n) {
      for (; t.parent.is("attributeElement") && t.parent.getCustomProperty("listItemWrapper");) e.unwrap(e.createRangeOn(t), t.parent);
      const o = [];
      i(e.createPositionBefore(t).getWalker({
        direction: "backward"
      })), i(e.createRangeIn(t).getWalker());
      for (const t of o) e.remove(t);
      function i(t) {
        for (const {
          item: e
        } of t) {
          if (e.is("element") && n.toModelElement(e)) break;
          e.is("element") && e.getCustomProperty("listItemMarker") && o.push(e);
        }
      }
    }
    function bD(t, e, n = IE(t)) {
      if (!DE(t)) return !1;
      for (const n of t.getAttributeKeys()) if (!n.startsWith("selection:") && !e.includes(n)) return !1;
      return n.length < 2;
    }
    var wD = n(1232),
      AD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(wD.A, AD);
    wD.A.locals;
    var _D = n(6903),
      CD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(_D.A, CD);
    _D.A.locals;
    const vD = ["listType", "listIndent", "listItemId"];
    class yD extends Br {
      constructor(t) {
        super(t), this._downcastStrategies = [], t.config.define("list.multiBlock", !0);
      }
      static get pluginName() {
        return "ListEditing";
      }
      static get requires() {
        return [zw, hw, rD, Jb];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.config.get("list.multiBlock");
        if (t.plugins.has("LegacyListEditing")) throw new w("list-feature-conflict", this, {
          conflictPlugin: "LegacyListEditing"
        });
        e.schema.register("$listItem", {
          allowAttributes: vD
        }), n ? (e.schema.extend("$container", {
          allowAttributesOf: "$listItem"
        }), e.schema.extend("$block", {
          allowAttributesOf: "$listItem"
        }), e.schema.extend("$blockObject", {
          allowAttributesOf: "$listItem"
        })) : e.schema.register("listItem", {
          inheritAllFrom: "$block",
          allowAttributesOf: "$listItem"
        });
        for (const t of vD) e.schema.setAttributeProperties(t, {
          copyOnReplace: !0
        });
        t.commands.add("numberedList", new nD(t, "numbered")), t.commands.add("bulletedList", new nD(t, "bulleted")), t.commands.add("customNumberedList", new nD(t, "customNumbered", {
          multiLevel: !0
        })), t.commands.add("customBulletedList", new nD(t, "customBulleted", {
          multiLevel: !0
        })), t.commands.add("indentList", new GE(t, "forward")), t.commands.add("outdentList", new GE(t, "backward")), t.commands.add("splitListItemBefore", new iD(t, "before")), t.commands.add("splitListItemAfter", new iD(t, "after")), n && (t.commands.add("mergeListItemBackward", new oD(t, "backward")), t.commands.add("mergeListItemForward", new oD(t, "forward"))), this._setupDeleteIntegration(), this._setupEnterIntegration(), this._setupTabIntegration(), this._setupClipboardIntegration(), this._setupAccessibilityIntegration();
      }
      afterInit() {
        const t = this.editor.commands,
          e = t.get("indent"),
          n = t.get("outdent");
        e && e.registerChildCommand(t.get("indentList"), {
          priority: "high"
        }), n && n.registerChildCommand(t.get("outdentList"), {
          priority: "lowest"
        }), this._setupModelPostFixing(), this._setupConversion();
      }
      registerDowncastStrategy(t) {
        this._downcastStrategies.push(t);
      }
      getListAttributeNames() {
        return [...vD, ...this._downcastStrategies.map(t => t.attributeName)];
      }
      _setupDeleteIntegration() {
        const t = this.editor,
          e = t.commands.get("mergeListItemBackward"),
          n = t.commands.get("mergeListItemForward");
        this.listenTo(t.editing.view.document, "delete", (o, i) => {
          const r = t.model.document.selection;
          VE(t.model) || t.model.change(() => {
            const s = r.getFirstPosition();
            if (r.isCollapsed && "backward" == i.direction) {
              if (!s.isAtStart) return;
              const n = s.parent;
              if (!DE(n)) return;
              if (mE.first(n, {
                sameAttributes: "listType",
                sameIndent: !0
              }) || 0 !== n.getAttribute("listIndent")) {
                if (!e || !e.isEnabled) return;
                e.execute({
                  shouldMergeOnBlocksContentLevel: xD(t.model, "backward")
                });
              } else BE(n) || t.execute("splitListItemAfter"), t.execute("outdentList");
              i.preventDefault(), o.stop();
            } else {
              if (r.isCollapsed && !r.getLastPosition().isAtEnd) return;
              if (!n || !n.isEnabled) return;
              n.execute({
                shouldMergeOnBlocksContentLevel: xD(t.model, "forward")
              }), i.preventDefault(), o.stop();
            }
          });
        }, {
          context: "li"
        });
      }
      _setupEnterIntegration() {
        const t = this.editor,
          e = t.model,
          n = t.commands,
          o = n.get("enter");
        this.listenTo(t.editing.view.document, "enter", (n, o) => {
          const i = e.document,
            r = i.selection.getFirstPosition().parent;
          if (i.selection.isCollapsed && DE(r) && r.isEmpty && !o.isSoft) {
            const e = SE(r),
              i = BE(r);
            e && i ? (t.execute("outdentList"), o.preventDefault(), n.stop()) : e && !i ? (t.execute("splitListItemAfter"), o.preventDefault(), n.stop()) : i && (t.execute("splitListItemBefore"), o.preventDefault(), n.stop());
          }
        }, {
          context: "li"
        }), this.listenTo(o, "afterExecute", () => {
          const e = n.get("splitListItemBefore");
          if (e.refresh(), !e.isEnabled) return;
          2 === IE(t.model.document.selection.getLastPosition().parent).length && e.execute();
        });
      }
      _setupTabIntegration() {
        const t = this.editor;
        this.listenTo(t.editing.view.document, "tab", (e, n) => {
          const o = n.shiftKey ? "outdentList" : "indentList";
          this.editor.commands.get(o).isEnabled && (t.execute(o), n.stopPropagation(), n.preventDefault(), e.stop());
        }, {
          context: "li"
        });
      }
      _setupConversion() {
        const t = this.editor,
          e = t.model,
          n = this.getListAttributeNames(),
          o = t.config.get("list.multiBlock"),
          i = o ? "paragraph" : "listItem";
        t.conversion.for("upcast").elementToElement({
          view: "li",
          model: (t, {
            writer: e
          }) => e.createElement(i, {
            listType: ""
          })
        }).elementToElement({
          view: "p",
          model: (t, {
            writer: e
          }) => t.parent && t.parent.is("element", "li") ? e.createElement(i, {
            listType: ""
          }) : null,
          converterPriority: "high"
        }).add(t => {
          t.on("element:li", gD()), t.on("element:ul", mD(), {
            priority: "high"
          }), t.on("element:ol", mD(), {
            priority: "high"
          });
        }), o || t.conversion.for("downcast").elementToElement({
          model: "listItem",
          view: "p"
        }), t.conversion.for("editingDowncast").elementToElement({
          model: i,
          view: fD(n),
          converterPriority: "high"
        }).add(t => {
          var o;
          t.on("attribute", pD(n, this._downcastStrategies, e)), t.on("remove", (o = e.schema, (t, e, n) => {
            const {
                writer: i,
                mapper: r
              } = n,
              s = t.name.split(":")[1];
            if (!o.checkAttribute(s, "listItemId")) return;
            const a = r.toViewPosition(e.position),
              c = e.position.getShiftedBy(e.length),
              l = r.toViewPosition(c, {
                isPhantom: !0
              }),
              d = i.createRange(a, l).getTrimmed().end.nodeBefore;
            d && kD(d, i, r);
          }));
        }), t.conversion.for("dataDowncast").elementToElement({
          model: i,
          view: fD(n, {
            dataPipeline: !0
          }),
          converterPriority: "high"
        }).add(t => {
          t.on("attribute", pD(n, this._downcastStrategies, e, {
            dataPipeline: !0
          }));
        });
        const r = (s = this._downcastStrategies, a = t.editing.view, (t, e) => {
          if (e.modelPosition.offset > 0) return;
          const n = e.modelPosition.parent;
          if (!DE(n)) return;
          if (!s.some(t => "itemMarker" == t.scope && t.canInjectMarkerIntoElement && t.canInjectMarkerIntoElement(n))) return;
          const o = e.mapper.toViewElement(n),
            i = a.createRangeIn(o),
            r = i.getWalker();
          let c = i.start;
          for (const {
            item: t
          } of r) {
            if (t.is("element") && e.mapper.toModelElement(t) || t.is("$textProxy")) break;
            t.is("element") && t.getCustomProperty("listItemMarker") && (c = a.createPositionAfter(t), r.skip(({
              previousPosition: t
            }) => !t.isEqual(c)));
          }
          e.viewPosition = c;
        });
        var s, a;
        t.editing.mapper.on("modelToViewPosition", r), t.data.mapper.on("modelToViewPosition", r), this.listenTo(e.document, "change:data", function (t, e, n, o) {
          return () => {
            const o = t.document.differ.getChanges(),
              s = [],
              a = new Map(),
              c = new Set();
            for (const t of o) if ("insert" == t.type && "$text" != t.name) hD(t.position, a), t.attributes.has("listItemId") ? c.add(t.position.nodeAfter) : hD(t.position.getShiftedBy(t.length), a);else if ("remove" == t.type && t.attributes.has("listItemId")) hD(t.position, a);else if ("attribute" == t.type) {
              const e = t.range.start.nodeAfter;
              n.includes(t.attributeKey) ? (hD(t.range.start, a), null === t.attributeNewValue ? (hD(t.range.start.getShiftedBy(1), a), r(e) && s.push(e)) : c.add(e)) : DE(e) && r(e) && s.push(e);
            }
            for (const t of a.values()) s.push(...i(t, c));
            for (const t of new Set(s)) e.reconvertItem(t);
          };
          function i(t, e) {
            const o = [],
              i = new Set(),
              a = [];
            for (const {
              node: c,
              previous: l
            } of pE(t, "forward")) {
              if (i.has(c)) continue;
              const t = c.getAttribute("listIndent");
              l && t < l.getAttribute("listIndent") && (a.length = t + 1), a[t] = Object.fromEntries(Array.from(c.getAttributes()).filter(([t]) => n.includes(t)));
              const d = TE(c, {
                direction: "forward"
              });
              for (const t of d) i.add(t), (r(t, d) || s(t, a, e)) && o.push(t);
            }
            return o;
          }
          function r(t, i) {
            const r = e.mapper.toViewElement(t);
            if (!r) return !1;
            if (o.fire("checkElement", {
              modelElement: t,
              viewElement: r
            })) return !0;
            if (!t.is("element", "paragraph") && !t.is("element", "listItem")) return !1;
            const s = bD(t, n, i);
            return !(!s || !r.is("element", "p")) || !(s || !r.is("element", "span"));
          }
          function s(t, n, i) {
            if (i.has(t)) return !1;
            const r = e.mapper.toViewElement(t);
            let s = n.length - 1;
            for (let t = r.parent; !t.is("editableElement"); t = t.parent) {
              const e = aD(t),
                i = sD(t);
              if (!i && !e) continue;
              const r = "checkAttributes:" + (e ? "item" : "list");
              if (o.fire(r, {
                viewElement: t,
                modelAttributes: n[s]
              })) break;
              if (i && (s--, s < 0)) return !1;
            }
            return !0;
          }
        }(e, t.editing, n, this), {
          priority: "high"
        }), this.on("checkAttributes:item", (t, {
          viewElement: e,
          modelAttributes: n
        }) => {
          e.id != n.listItemId && (t.return = !0, t.stop());
        }), this.on("checkAttributes:list", (t, {
          viewElement: e,
          modelAttributes: n
        }) => {
          e.name == dD(n.listType) && e.id == uD(n.listType, n.listIndent) || (t.return = !0, t.stop());
        });
      }
      _setupModelPostFixing() {
        const t = this.editor.model,
          e = this.getListAttributeNames();
        t.document.registerPostFixer(n => function (t, e, n, o) {
          const i = t.document.differ.getChanges(),
            r = new Map(),
            s = o.editor.config.get("list.multiBlock");
          let a = !1;
          for (const o of i) {
            if ("insert" == o.type && "$text" != o.name) {
              const i = o.position.nodeAfter;
              if (!t.schema.checkAttribute(i, "listItemId")) for (const t of Array.from(i.getAttributeKeys())) n.includes(t) && (e.removeAttribute(t, i), a = !0);
              hD(o.position, r), o.attributes.has("listItemId") || hD(o.position.getShiftedBy(o.length), r);
              for (const {
                item: e,
                previousPosition: n
              } of t.createRangeIn(i)) DE(e) && hD(n, r);
            } else "remove" == o.type ? hD(o.position, r) : "attribute" == o.type && n.includes(o.attributeKey) && (hD(o.range.start, r), null === o.attributeNewValue && hD(o.range.start.getShiftedBy(1), r));
            if (!s && "attribute" == o.type && vD.includes(o.attributeKey)) {
              const t = o.range.start.nodeAfter;
              null === o.attributeNewValue && t && t.is("element", "listItem") ? (e.rename(t, "paragraph"), a = !0) : null === o.attributeOldValue && t && t.is("element") && "listItem" != t.name && (e.rename(t, "listItem"), a = !0);
            }
          }
          const c = new Set();
          for (const t of r.values()) a = o.fire("postFixer", {
            listNodes: new fE(t),
            listHead: t,
            writer: e,
            seenIds: c
          }) || a;
          return a;
        }(t, n, e, this)), this.on("postFixer", (t, {
          listNodes: e,
          writer: n
        }) => {
          t.return = function (t, e) {
            let n = 0,
              o = -1,
              i = null,
              r = !1;
            for (const {
              node: s
            } of t) {
              const t = s.getAttribute("listIndent");
              if (t > n) {
                let a;
                null === i ? (i = t - n, a = n) : (i > t && (i = t), a = t - i), a > o + 1 && (a = o + 1), e.setAttribute("listIndent", a, s), r = !0, o = a;
              } else i = null, n = t + 1, o = t;
            }
            return r;
          }(e, n) || t.return;
        }, {
          priority: "high"
        }), this.on("postFixer", (t, {
          listNodes: e,
          writer: n,
          seenIds: o
        }) => {
          t.return = function (t, e, n) {
            const o = new Set();
            let i = !1;
            for (const {
              node: r
            } of t) {
              if (o.has(r)) continue;
              let t = r.getAttribute("listType"),
                s = r.getAttribute("listItemId");
              if (e.has(s) && (s = EE.next()), e.add(s), r.is("element", "listItem")) r.getAttribute("listItemId") != s && (n.setAttribute("listItemId", s, r), i = !0);else for (const e of TE(r, {
                direction: "forward"
              })) o.add(e), e.getAttribute("listType") != t && (s = EE.next(), t = e.getAttribute("listType")), e.getAttribute("listItemId") != s && (n.setAttribute("listItemId", s, e), i = !0);
            }
            return i;
          }(e, o, n) || t.return;
        }, {
          priority: "high"
        });
      }
      _setupClipboardIntegration() {
        const t = this.editor.model,
          e = this.editor.plugins.get("ClipboardPipeline");
        this.listenTo(t, "insertContent", function (t) {
          return (e, [n, o]) => {
            const i = n.is("documentFragment") ? Array.from(n.getChildren()) : [n];
            if (!i.length) return;
            const r = (o ? t.createSelection(o) : t.document.selection).getFirstPosition();
            let s;
            if (DE(r.parent)) s = r.parent;else {
              if (!DE(r.nodeBefore)) return;
              s = r.nodeBefore;
            }
            t.change(t => {
              const e = s.getAttribute("listType"),
                n = s.getAttribute("listIndent"),
                o = i[0].getAttribute("listIndent") || 0,
                r = Math.max(n - o, 0);
              for (const n of i) {
                const o = DE(n);
                s.is("element", "listItem") && n.is("element", "paragraph") && t.rename(n, "listItem"), t.setAttributes({
                  listIndent: (o ? n.getAttribute("listIndent") : 0) + r,
                  listItemId: o ? n.getAttribute("listItemId") : EE.next(),
                  listType: e
                }, n);
              }
            });
          };
        }(t), {
          priority: "high"
        }), this.listenTo(e, "outputTransformation", (e, n) => {
          t.change(t => {
            const e = Array.from(n.content.getChildren()),
              o = e[e.length - 1];
            if (e.length > 1 && o.is("element") && o.isEmpty) {
              e.slice(0, -1).every(DE) && t.remove(o);
            }
            if ("copy" == n.method || "cut" == n.method) {
              const e = Array.from(n.content.getChildren());
              jE(e) && RE(e, t);
            }
          });
        });
      }
      _setupAccessibilityIntegration() {
        const t = this.editor,
          e = t.t;
        t.accessibility.addKeystrokeInfoGroup({
          id: "list",
          label: e("Keystrokes that can be used in a list"),
          keystrokes: [{
            label: e("Increase list item indent"),
            keystroke: "Tab"
          }, {
            label: e("Decrease list item indent"),
            keystroke: "Shift+Tab"
          }]
        });
      }
    }
    function xD(t, e) {
      const n = t.document.selection;
      if (!n.isCollapsed) return !VE(t);
      if ("forward" === e) return !0;
      const o = n.getFirstPosition().parent,
        i = o.previousSibling;
      return !t.schema.isObject(i) && (!!i.isEmpty || jE([o, i]));
    }
    function ED(t, e, n, o) {
      t.ui.componentFactory.add(e, () => {
        const i = DD(Sg, t, e, n, o);
        return i.set({
          tooltip: !0,
          isToggleable: !0
        }), i;
      }), t.ui.componentFactory.add(`menuBar:${e}`, () => DD(Yk, t, e, n, o));
    }
    function DD(t, e, n, o, i) {
      const r = e.commands.get(n),
        s = new t(e.locale);
      return s.set({
        label: o,
        icon: i
      }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", () => {
        e.execute(n), e.editing.view.focus();
      }), s;
    }
    class ID extends Br {
      static get pluginName() {
        return "ListUI";
      }
      init() {
        const t = this.editor.t;
        this.editor.ui.componentFactory.has("numberedList") || ED(this.editor, "numberedList", t("Numbered List"), gg.numberedList), this.editor.ui.componentFactory.has("bulletedList") || ED(this.editor, "bulletedList", t("Bulleted List"), gg.bulletedList);
      }
    }
    class TD extends Br {
      static get requires() {
        return [yD, ID];
      }
      static get pluginName() {
        return "List";
      }
    }
    const MD = {},
      SD = {},
      BD = {},
      ND = [{
        listStyle: "disc",
        typeAttribute: "disc",
        listType: "bulleted"
      }, {
        listStyle: "circle",
        typeAttribute: "circle",
        listType: "bulleted"
      }, {
        listStyle: "square",
        typeAttribute: "square",
        listType: "bulleted"
      }, {
        listStyle: "decimal",
        typeAttribute: "1",
        listType: "numbered"
      }, {
        listStyle: "decimal-leading-zero",
        typeAttribute: null,
        listType: "numbered"
      }, {
        listStyle: "lower-roman",
        typeAttribute: "i",
        listType: "numbered"
      }, {
        listStyle: "upper-roman",
        typeAttribute: "I",
        listType: "numbered"
      }, {
        listStyle: "lower-alpha",
        typeAttribute: "a",
        listType: "numbered"
      }, {
        listStyle: "upper-alpha",
        typeAttribute: "A",
        listType: "numbered"
      }, {
        listStyle: "lower-latin",
        typeAttribute: "a",
        listType: "numbered"
      }, {
        listStyle: "upper-latin",
        typeAttribute: "A",
        listType: "numbered"
      }];
    for (const {
      listStyle: t,
      typeAttribute: e,
      listType: n
    } of ND) MD[t] = n, SD[t] = e, e && (BD[e] = t);
    var PD = n(9968),
      OD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(PD.A, OD);
    PD.A.locals;
    var LD = n(7141),
      zD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(LD.A, zD);
    LD.A.locals;
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    ki("Ctrl+Enter");
    var RD = n(8991),
      jD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(RD.A, jD);
    RD.A.locals;
    ki("Ctrl+Enter");
    function FD(t, e) {
      const n = (n, o, i) => {
        if (!i.consumable.consume(o.item, n.name)) return;
        const r = o.attributeNewValue,
          s = i.writer,
          a = i.mapper.toViewElement(o.item),
          c = [...a.getChildren()].find(t => t.getCustomProperty("media-content"));
        s.remove(c);
        const l = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), l);
      };
      return t => {
        t.on("attribute:url:media", n);
      };
    }
    function VD(t, e, n, o) {
      return t.createContainerElement("figure", {
        class: "media"
      }, [e.getMediaViewElement(t, n, o), t.createSlot()]);
    }
    function HD(t) {
      const e = t.getSelectedElement();
      return e && e.is("element", "media") ? e : null;
    }
    function UD(t, e, n, o) {
      t.change(i => {
        const r = i.createElement("media", {
          url: e
        });
        t.insertObject(r, n, null, {
          setSelection: "on",
          findOptimalPosition: o ? "auto" : void 0
        });
      });
    }
    class qD extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = HD(e);
        this.value = n ? n.getAttribute("url") : void 0, this.isEnabled = function (t) {
          const e = t.getSelectedElement();
          return !!e && "media" === e.name;
        }(e) || function (t, e) {
          const n = eA(t, e);
          let o = n.start.parent;
          o.isEmpty && !e.schema.isLimit(o) && (o = o.parent);
          return e.schema.checkChild(o, "media");
        }(e, t);
      }
      execute(t) {
        const e = this.editor.model,
          n = e.document.selection,
          o = HD(n);
        o ? e.change(e => {
          e.setAttribute("url", t, o);
        }) : UD(e, t, n, !0);
      }
    }
    class GD {
      constructor(t, e) {
        const n = e.providers,
          o = e.extraProviders || [],
          i = new Set(e.removeProviders),
          r = n.concat(o).filter(t => {
            const e = t.name;
            return e ? !i.has(e) : (A("media-embed-no-provider-name", {
              provider: t
            }), !1);
          });
        this.locale = t, this.providerDefinitions = r;
      }
      hasMedia(t) {
        return !!this._getMedia(t);
      }
      getMediaViewElement(t, e, n) {
        return this._getMedia(e).getViewElement(t, n);
      }
      _getMedia(t) {
        if (!t) return new WD(this.locale);
        t = t.trim();
        for (const e of this.providerDefinitions) {
          const n = e.html,
            o = Ai(e.url);
          for (const e of o) {
            const o = this._getUrlMatches(t, e);
            if (o) return new WD(this.locale, t, o, n);
          }
        }
        return null;
      }
      _getUrlMatches(t, e) {
        let n = t.match(e);
        if (n) return n;
        let o = t.replace(/^https?:\/\//, "");
        return n = o.match(e), n || (o = o.replace(/^www\./, ""), n = o.match(e), n || null);
      }
    }
    class WD {
      constructor(t, e, n, o) {
        this.url = this._getValidUrl(e), this._locale = t, this._match = n, this._previewRenderer = o;
      }
      getViewElement(t, e) {
        const n = {};
        let o;
        if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
          this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");
          const i = this._getPreviewHtml(e);
          o = t.createRawElement("div", n, (t, e) => {
            e.setContentOf(t, i);
          });
        } else this.url && (n.url = this.url), o = t.createEmptyElement(e.elementName, n);
        return t.setCustomProperty("media-content", !0, o), o;
      }
      _getPreviewHtml(t) {
        return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
      }
      _getPlaceholderHtml() {
        const t = new Dg(),
          e = this._locale.t;
        t.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', t.viewBox = "0 0 64 42";
        return new nr({
          tag: "div",
          attributes: {
            class: "ck ck-reset_all ck-media__placeholder"
          },
          children: [{
            tag: "div",
            attributes: {
              class: "ck-media__placeholder__icon"
            },
            children: [t]
          }, {
            tag: "a",
            attributes: {
              class: "ck-media__placeholder__url",
              target: "_blank",
              rel: "noopener noreferrer",
              href: this.url,
              "data-cke-tooltip-text": e("Open media in new tab")
            },
            children: [{
              tag: "span",
              attributes: {
                class: "ck-media__placeholder__url__text"
              },
              children: [this.url]
            }]
          }]
        }).render().outerHTML;
      }
      _getValidUrl(t) {
        return t ? t.match(/^https?/) ? t : "https://" + t : null;
      }
    }
    var KD = n(7048),
      $D = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(KD.A, $D);
    KD.A.locals;
    class YD extends Br {
      constructor(t) {
        super(t), t.config.define("mediaEmbed", {
          elementName: "oembed",
          providers: [{
            name: "dailymotion",
            url: [/^dailymotion\.com\/video\/(\w+)/, /^dai.ly\/(\w+)/],
            html: t => `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>`
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: t => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/, /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/, /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/],
            html: t => {
              const e = t[1],
                n = t[2];
              return `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${e}${n ? `?start=${n}` : ""}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: t => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), this.registry = new GD(t.locale, t.config.get("mediaEmbed"));
      }
      static get pluginName() {
        return "MediaEmbedEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.t,
          o = t.conversion,
          i = t.config.get("mediaEmbed.previewsInData"),
          r = t.config.get("mediaEmbed.elementName"),
          s = this.registry;
        t.commands.add("mediaEmbed", new qD(t)), e.register("media", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["url"]
        }), o.for("dataDowncast").elementToStructure({
          model: "media",
          view: (t, {
            writer: e
          }) => {
            const n = t.getAttribute("url");
            return VD(e, s, n, {
              elementName: r,
              renderMediaPreview: !!n && i
            });
          }
        }), o.for("dataDowncast").add(FD(s, {
          elementName: r,
          renderMediaPreview: i
        })), o.for("editingDowncast").elementToStructure({
          model: "media",
          view: (t, {
            writer: e
          }) => {
            const o = t.getAttribute("url");
            return function (t, e, n) {
              return e.setCustomProperty("media", !0, t), Qw(t, e, {
                label: n
              });
            }(VD(e, s, o, {
              elementName: r,
              renderForEditingView: !0
            }), e, n("media widget"));
          }
        }), o.for("editingDowncast").add(FD(s, {
          elementName: r,
          renderForEditingView: !0
        })), o.for("upcast").elementToElement({
          view: t => ["oembed", r].includes(t.name) && t.getAttribute("url") ? {
            name: !0
          } : null,
          model: (t, {
            writer: e
          }) => {
            const n = t.getAttribute("url");
            return s.hasMedia(n) ? e.createElement("media", {
              url: n
            }) : null;
          }
        }).elementToElement({
          view: {
            name: "div",
            attributes: {
              "data-oembed-url": !0
            }
          },
          model: (t, {
            writer: e
          }) => {
            const n = t.getAttribute("data-oembed-url");
            return s.hasMedia(n) ? e.createElement("media", {
              url: n
            }) : null;
          }
        }).add(t => {
          t.on("element:figure", (t, e, n) => {
            if (!n.consumable.consume(e.viewItem, {
              name: !0,
              classes: "media"
            })) return;
            const {
              modelRange: o,
              modelCursor: i
            } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = o, e.modelCursor = i;
            Wi(o.getItems()) || n.consumable.revert(e.viewItem, {
              name: !0,
              classes: "media"
            });
          });
        });
      }
    }
    const QD = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
    class ZD extends Br {
      constructor(t) {
        super(t), this._timeoutId = null, this._positionToInsert = null;
      }
      static get requires() {
        return [KA, hw, h_];
      }
      static get pluginName() {
        return "AutoMediaEmbed";
      }
      init() {
        const t = this.editor,
          n = t.model.document,
          o = t.plugins.get("ClipboardPipeline");
        this.listenTo(o, "inputTransformation", () => {
          const t = n.selection.getFirstRange(),
            e = ju.fromPosition(t.start);
          e.stickiness = "toPrevious";
          const o = ju.fromPosition(t.end);
          o.stickiness = "toNext", n.once("change:data", () => {
            this._embedMediaBetweenPositions(e, o), e.detach(), o.detach();
          }, {
            priority: "high"
          });
        });
        t.commands.get("undo").on("execute", () => {
          this._timeoutId && (e.window.clearTimeout(this._timeoutId), this._positionToInsert.detach(), this._timeoutId = null, this._positionToInsert = null);
        }, {
          priority: "high"
        });
      }
      _embedMediaBetweenPositions(t, n) {
        const o = this.editor,
          i = o.plugins.get(YD).registry,
          r = new zl(t, n),
          s = r.getWalker({
            ignoreElementEnd: !0
          });
        let a = "";
        for (const t of s) t.item.is("$textProxy") && (a += t.item.data);
        if (a = a.trim(), !a.match(QD)) return void r.detach();
        if (!i.hasMedia(a)) return void r.detach();
        o.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = ju.fromPosition(t), this._timeoutId = e.window.setTimeout(() => {
          o.model.change(t => {
            this._timeoutId = null, t.remove(r), r.detach();
            let e = null;
            "$graveyard" !== this._positionToInsert.root.rootName && (e = this._positionToInsert), UD(o.model, a, e, !1), this._positionToInsert.detach(), this._positionToInsert = null;
          }), o.plugins.get(hw).requestUndoOnBackspace();
        }, 100)) : r.detach();
      }
    }
    var JD = n(5651),
      XD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(JD.A, XD);
    JD.A.locals;
    class tI extends Dr {
      constructor(t, e) {
        super(e);
        const n = e.t;
        this.focusTracker = new Ki(), this.keystrokes = new $i(), this.set("mediaURLInputValue", ""), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n("Save"), gg.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(n("Cancel"), gg.cancel, "ck-button-cancel", "cancel"), this._focusables = new er(), this._focusCycler = new rm({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this._validators = t, this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.urlInputView, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), Mr({
          view: this
        });
        [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
        const t = t => t.stopPropagation();
        this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      get url() {
        return this.urlInputView.fieldView.element.value.trim();
      }
      set url(t) {
        this.urlInputView.fieldView.element.value = t.trim();
      }
      isValid() {
        this.resetFormStatus();
        for (const t of this._validators) {
          const e = t(this);
          if (e) return this.urlInputView.errorText = e, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
      }
      _createUrlInput() {
        const t = this.locale.t,
          e = new Gg(this.locale, qm),
          n = e.fieldView;
        return this._urlInputViewInfoDefault = t("Paste the media URL in the input."), this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster."), e.label = t("Media URL"), e.infoText = this._urlInputViewInfoDefault, n.on("input", () => {
          e.infoText = n.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault, this.mediaURLInputValue = n.element.value.trim();
        }), e;
      }
      _createButton(t, e, n, o) {
        const i = new Sg(this.locale);
        return i.set({
          label: t,
          icon: e,
          tooltip: !0
        }), i.extendTemplate({
          attributes: {
            class: n
          }
        }), o && i.delegate("execute").to(this, o), i;
      }
    }
    class eI extends Br {
      static get requires() {
        return [YD];
      }
      static get pluginName() {
        return "MediaEmbedUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get("mediaEmbed");
        t.ui.componentFactory.add("mediaEmbed", t => {
          const n = zm(t);
          return this._setUpDropdown(n, e), n;
        });
      }
      _setUpDropdown(t, e) {
        const n = this.editor,
          o = n.t,
          i = t.buttonView,
          r = n.plugins.get(YD).registry;
        t.once("change:isOpen", () => {
          const o = new (Tr(tI))(function (t, e) {
            return [e => {
              if (!e.url.length) return t("The URL must not be empty.");
            }, n => {
              if (!e.hasMedia(n.url)) return t("This media URL is not supported.");
            }];
          }(n.t, r), n.locale);
          t.panelView.children.add(o), i.on("open", () => {
            o.disableCssTransitions(), o.url = e.value || "", o.urlInputView.fieldView.select(), o.enableCssTransitions();
          }, {
            priority: "low"
          }), t.on("submit", () => {
            o.isValid() && (n.execute("mediaEmbed", o.url), n.editing.view.focus());
          }), t.on("change:isOpen", () => o.resetFormStatus()), t.on("cancel", () => {
            n.editing.view.focus();
          }), o.delegate("submit", "cancel").to(t), o.urlInputView.fieldView.bind("value").to(e, "value"), o.urlInputView.on("change:errorText", () => {
            n.ui.update();
          }), o.urlInputView.bind("isEnabled").to(e, "isEnabled");
        }), t.bind("isEnabled").to(e), i.set({
          label: o("Insert media"),
          icon: '<svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.587 1.5c-.612 0-.601-.029-.601.551v14.84c0 .59-.01.559.591.559h18.846c.602 0 .591.03.591-.56V2.052c0-.58.01-.55-.591-.55H1.587Zm.701.971h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-14.24 1h13.008v12H4.467l.029-12Zm-2.208 1h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003l-.029 1h-.974v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h.974v1h-.974v-1Zm16.448 0h1.003v1h-1.003v-1Z"/><path d="M8.374 6.648a.399.399 0 0 1 .395-.4.402.402 0 0 1 .2.049l5.148 2.824a.4.4 0 0 1 0 .7l-5.148 2.824a.403.403 0 0 1-.595-.35V6.648Z"/></svg>',
          tooltip: !0
        });
      }
    }
    var nI = n(70),
      oI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(nI.A, oI);
    nI.A.locals;
    function iI(t) {
      return void 0 !== t && t.endsWith("px");
    }
    function rI(t) {
      return t.toFixed(2).replace(/\.?0+$/, "") + "px";
    }
    var sI = Object.defineProperty,
      aI = Object.defineProperties,
      cI = Object.getOwnPropertyDescriptors,
      lI = Object.getOwnPropertySymbols,
      dI = Object.prototype.hasOwnProperty,
      uI = Object.prototype.propertyIsEnumerable,
      hI = (t, e, n) => e in t ? sI(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      gI = (t, e) => {
        for (var n in e || (e = {})) dI.call(e, n) && hI(t, n, e[n]);
        if (lI) for (var n of lI(e)) uI.call(e, n) && hI(t, n, e[n]);
        return t;
      };
    function mI(t, e, n) {
      if (!t.childCount) return;
      const o = new Qh(t.document),
        i = function (t, e) {
          const n = e.createRangeIn(t),
            o = [],
            i = new Set();
          for (const t of n.getItems()) {
            if (!t.is("element") || !t.name.match(/^(p|h\d+|li|div)$/)) continue;
            let e = CI(t);
            if (void 0 === e || 0 != parseFloat(e) || Array.from(t.getClassNames()).find(t => t.startsWith("MsoList")) || (e = void 0), t.hasStyle("mso-list") || void 0 !== e && i.has(e)) {
              const n = AI(t);
              o.push({
                element: t,
                id: n.id,
                order: n.order,
                indent: n.indent,
                marginLeft: e
              }), void 0 !== e && i.add(e);
            } else i.clear();
          }
          return o;
        }(t, o);
      if (!i.length) return;
      const r = {},
        s = [];
      for (const t of i) if (void 0 !== t.indent) {
        pI(t) || (s.length = 0);
        const i = `${t.id}:${t.indent}`,
          c = Math.min(t.indent - 1, s.length);
        if (c < s.length && s[c].id !== t.id && (s.length = c), c < s.length - 1) s.length = c + 1;else {
          const l = kI(t, e);
          if (c > s.length - 1 || s[c].listElement.name != l.type) {
            0 == c && "ol" == l.type && void 0 !== t.id && r[i] && (l.startIndex = r[i]);
            const e = wI(l, o, n);
            if (iI(t.marginLeft) && (0 == c || iI(s[c - 1].marginLeft))) {
              let n = t.marginLeft;
              c > 0 && (n = rI(parseFloat(n) - parseFloat(s[c - 1].marginLeft))), o.setStyle("padding-left", n, e);
            }
            if (0 == s.length) {
              const n = t.element.parent,
                i = n.getChildIndex(t.element) + 1;
              o.insertChild(i, e, n);
            } else {
              const t = s[c - 1].listItemElements;
              o.appendChild(e, t[t.length - 1]);
            }
            s[c] = (a = gI({}, t), aI(a, cI({
              listElement: e,
              listItemElements: []
            }))), 0 == c && void 0 !== t.id && (r[i] = l.startIndex || 1);
          }
        }
        const l = "li" == t.element.name ? t.element : o.createElement("li");
        o.appendChild(l, s[c].listElement), s[c].listItemElements.push(l), 0 == c && void 0 !== t.id && r[i]++, t.element != l && o.appendChild(t.element, l), _I(t.element, o), o.removeStyle("text-indent", t.element), o.removeStyle("margin-left", t.element);
      } else {
        const e = s.find(e => e.marginLeft == t.marginLeft);
        if (e) {
          const n = e.listItemElements;
          o.appendChild(t.element, n[n.length - 1]), o.removeStyle("margin-left", t.element);
        } else s.length = 0;
      }
      var a;
    }
    function pI(t) {
      const e = t.element.previousSibling;
      return fI(e || t.element.parent);
    }
    function fI(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    function kI(t, e) {
      const n = new RegExp(`@list l${t.id}:level${t.indent}\\s*({[^}]*)`, "gi"),
        o = /mso-level-number-format:([^;]{0,100});/gi,
        i = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
        r = new RegExp(`@list\\s+l${t.id}:level\\d\\s*{[^{]*mso-level-text:"%\\d\\\\.`, "gi"),
        s = new RegExp(`@list l${t.id}:level\\d\\s*{[^{]*mso-level-number-format:`, "gi"),
        a = r.exec(e),
        c = s.exec(e),
        l = a && !c,
        d = n.exec(e);
      let u = "decimal",
        h = "ol",
        g = null;
      if (d && d[1]) {
        const e = o.exec(d[1]);
        if (e && e[1] && (u = e[1].trim(), h = "bullet" !== u && "image" !== u ? "ol" : "ul"), "bullet" === u) {
          const e = function (t) {
            if ("li" == t.name && "ul" == t.parent.name && t.parent.hasAttribute("type")) return t.parent.getAttribute("type");
            const e = function (t) {
              if (t.getChild(0).is("$text")) return null;
              for (const e of t.getChildren()) {
                if (!e.is("element", "span")) continue;
                const t = e.getChild(0);
                if (t) return t.is("$text") ? t : t.getChild(0);
              }
              return null;
            }(t);
            if (!e) return null;
            const n = e._data;
            if ("o" === n) return "circle";
            if ("·" === n) return "disc";
            if ("§" === n) return "square";
            return null;
          }(t.element);
          e && (u = e);
        } else {
          const t = i.exec(d[1]);
          t && t[1] && (g = parseInt(t[1]));
        }
        l && (h = "ol");
      }
      return {
        type: h,
        startIndex: g,
        style: bI(u),
        isLegalStyleList: l
      };
    }
    function bI(t) {
      if (t.startsWith("arabic-leading-zero")) return "decimal-leading-zero";
      switch (t) {
        case "alpha-upper":
          return "upper-alpha";
        case "alpha-lower":
          return "lower-alpha";
        case "roman-upper":
          return "upper-roman";
        case "roman-lower":
          return "lower-roman";
        case "circle":
        case "disc":
        case "square":
          return t;
        default:
          return null;
      }
    }
    function wI(t, e, n) {
      const o = e.createElement(t.type);
      return t.style && e.setStyle("list-style-type", t.style, o), t.startIndex && t.startIndex > 1 && e.setAttribute("start", t.startIndex, o), t.isLegalStyleList && n && e.addClass("legal-list", o), o;
    }
    function AI(t) {
      const e = t.getStyle("mso-list");
      if (void 0 === e) return {};
      const n = e.match(/(^|\s{1,100})l(\d+)/i),
        o = e.match(/\s{0,100}lfo(\d+)/i),
        i = e.match(/\s{0,100}level(\d+)/i);
      return n && o && i ? {
        id: n[2],
        order: o[1],
        indent: parseInt(i[1])
      } : {
        indent: 1
      };
    }
    function _I(t, e) {
      const n = new ss({
          name: "span",
          styles: {
            "mso-list": "Ignore"
          }
        }),
        o = e.createRangeIn(t);
      for (const t of o) "elementStart" === t.type && n.match(t.item) && e.remove(t.item);
    }
    function CI(t) {
      const e = t.getStyle("margin-left");
      return void 0 === e || e.endsWith("px") ? e : function (t) {
        const e = parseFloat(t);
        return t.endsWith("pt") ? rI(96 * e / 72) : t.endsWith("pc") ? rI(12 * e * 96 / 72) : t.endsWith("in") ? rI(96 * e) : t.endsWith("cm") ? rI(96 * e / 2.54) : t.endsWith("mm") ? rI(e / 10 * 96 / 2.54) : t;
      }(e);
    }
    function vI(t, e) {
      if (!t.childCount) return;
      const n = new Qh(t.document),
        o = function (t, e) {
          const n = e.createRangeIn(t),
            o = new ss({
              name: /v:(.+)/
            }),
            i = [];
          for (const t of n) {
            if ("elementStart" != t.type) continue;
            const e = t.item,
              n = e.previousSibling,
              r = n && n.is("element") ? n.name : null,
              s = ["Chart"],
              a = o.match(e),
              c = e.getAttribute("o:gfxdata"),
              l = "v:shapetype" === r,
              d = c && s.some(t => e.getAttribute("id").includes(t));
            a && c && !l && !d && i.push(t.item.getAttribute("id"));
          }
          return i;
        }(t, n);
      !function (t, e, n) {
        const o = n.createRangeIn(e),
          i = new ss({
            name: "img"
          }),
          r = [];
        for (const e of o) if (e.item.is("element") && i.match(e.item)) {
          const n = e.item,
            o = n.getAttribute("v:shapes") ? n.getAttribute("v:shapes").split(" ") : [];
          o.length && o.every(e => t.indexOf(e) > -1) ? r.push(n) : n.getAttribute("src") || r.push(n);
        }
        for (const t of r) n.remove(t);
      }(o, t, n), function (t, e, n) {
        const o = n.createRangeIn(e),
          i = [];
        for (const e of o) if ("elementStart" == e.type && e.item.is("element", "v:shape")) {
          const n = e.item.getAttribute("id");
          if (t.includes(n)) continue;
          r(e.item.parent.getChildren(), n) || i.push(e.item);
        }
        for (const t of i) {
          const e = {
            src: s(t)
          };
          t.hasAttribute("alt") && (e.alt = t.getAttribute("alt"));
          const o = n.createElement("img", e);
          n.insertChild(t.index + 1, o, t.parent);
        }
        function r(t, e) {
          for (const n of t) if (n.is("element")) {
            if ("img" == n.name && n.getAttribute("v:shapes") == e) return !0;
            if (r(n.getChildren(), e)) return !0;
          }
          return !1;
        }
        function s(t) {
          for (const e of t.getChildren()) if (e.is("element") && e.getAttribute("src")) return e.getAttribute("src");
        }
      }(o, t, n), function (t, e) {
        const n = e.createRangeIn(t),
          o = new ss({
            name: /v:(.+)/
          }),
          i = [];
        for (const t of n) "elementStart" == t.type && o.match(t.item) && i.push(t.item);
        for (const t of i) e.remove(t);
      }(t, n);
      const i = function (t, e) {
        const n = e.createRangeIn(t),
          o = new ss({
            name: "img"
          }),
          i = [];
        for (const t of n) t.item.is("element") && o.match(t.item) && t.item.getAttribute("src").startsWith("file://") && i.push(t.item);
        return i;
      }(t, n);
      i.length && function (t, e, n) {
        if (t.length === e.length) for (let o = 0; o < t.length; o++) {
          const i = `data:${e[o].type};base64,${yI(e[o].hex)}`;
          n.setAttribute("src", i, t[o]);
        }
      }(i, function (t) {
        if (!t) return [];
        const e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
          n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
          o = t.match(n),
          i = [];
        if (o) for (const t of o) {
          let n = !1;
          t.includes("\\pngblip") ? n = "image/png" : t.includes("\\jpegblip") && (n = "image/jpeg"), n && i.push({
            hex: t.replace(e, "").replace(/[^\da-fA-F]/g, ""),
            type: n
          });
        }
        return i;
      }(e), n);
    }
    function yI(t) {
      return btoa(t.match(/\w{2}/g).map(t => String.fromCharCode(parseInt(t, 16))).join(""));
    }
    const xI = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
      EI = /xmlns:o="urn:schemas-microsoft-com/i;
    class DI {
      constructor(t, e = !1) {
        this.document = t, this.hasMultiLevelListPlugin = e;
      }
      isActive(t) {
        return xI.test(t) || EI.test(t);
      }
      execute(t) {
        const {
          body: e,
          stylesString: n
        } = t._parsedData;
        mI(e, n, this.hasMultiLevelListPlugin), vI(e, t.dataTransfer.getData("text/rtf")), function (t) {
          const e = [],
            n = new Qh(t.document);
          for (const {
            item: o
          } of n.createRangeIn(t)) if (o.is("element")) {
            for (const t of o.getClassNames()) /\bmso/gi.exec(t) && n.removeClass(t, o);
            for (const t of o.getStyleNames()) /\bmso/gi.exec(t) && n.removeStyle(t, o);
            (o.is("element", "w:sdt") || o.is("element", "w:sdtpr") && o.isEmpty || o.is("element", "o:p") && o.isEmpty) && e.push(o);
          }
          for (const t of e) {
            const e = t.parent,
              o = e.getChildIndex(t);
            n.insertChild(o, t.getChildren(), e), n.remove(t);
          }
        }(e), t.content = e;
      }
    }
    function II(t, e, n, {
      blockElements: o,
      inlineObjectElements: i
    }) {
      let r = n.createPositionAt(t, "forward" == e ? "after" : "before");
      return r = r.getLastMatchingPosition(({
        item: t
      }) => t.is("element") && !o.includes(t.name) && !i.includes(t.name), {
        direction: e
      }), "forward" == e ? r.nodeAfter : r.nodeBefore;
    }
    function TI(t, e) {
      return !!t && t.is("element") && e.includes(t.name);
    }
    const MI = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
    class SI {
      constructor(t) {
        this.document = t;
      }
      isActive(t) {
        return MI.test(t);
      }
      execute(t) {
        const e = new Qh(this.document),
          {
            body: n
          } = t._parsedData;
        !function (t, e) {
          for (const n of t.getChildren()) if (n.is("element", "b") && "normal" === n.getStyle("font-weight")) {
            const o = t.getChildIndex(n);
            e.remove(n), e.insertChild(o, n.getChildren(), t);
          }
        }(n, e), function (t, e) {
          for (const n of e.createRangeIn(t)) {
            const t = n.item;
            if (t.is("element", "li")) {
              const n = t.getChild(0);
              n && n.is("element", "p") && e.unwrapElement(n);
            }
          }
        }(n, e), function (t, e) {
          const n = new sa(e.document.stylesProcessor),
            o = new Za(n, {
              renderingMode: "data"
            }),
            i = o.blockElements,
            r = o.inlineObjectElements,
            s = [];
          for (const n of e.createRangeIn(t)) {
            const t = n.item;
            if (t.is("element", "br")) {
              const n = II(t, "forward", e, {
                  blockElements: i,
                  inlineObjectElements: r
                }),
                o = II(t, "backward", e, {
                  blockElements: i,
                  inlineObjectElements: r
                }),
                a = TI(n, i);
              (TI(o, i) || a) && s.push(t);
            }
          }
          for (const t of s) t.hasClass("Apple-interchange-newline") ? e.remove(t) : e.replace(t, e.createElement("p"));
        }(n, e), t.content = n;
      }
    }
    const BI = /<google-sheets-html-origin/i;
    class NI {
      constructor(t) {
        this.document = t;
      }
      isActive(t) {
        return BI.test(t);
      }
      execute(t) {
        const e = new Qh(this.document),
          {
            body: n
          } = t._parsedData;
        !function (t, e) {
          for (const n of t.getChildren()) if (n.is("element", "google-sheets-html-origin")) {
            const o = t.getChildIndex(n);
            e.remove(n), e.insertChild(o, n.getChildren(), t);
          }
        }(n, e), function (t, e) {
          for (const n of t.getChildren()) n.is("element", "table") && n.hasAttribute("xmlns") && e.removeAttribute("xmlns", n);
        }(n, e), function (t, e) {
          for (const n of t.getChildren()) n.is("element", "table") && "0px" === n.getStyle("width") && e.removeStyle("width", n);
        }(n, e), function (t, e) {
          for (const n of Array.from(t.getChildren())) n.is("element", "style") && e.remove(n);
        }(n, e), t.content = n;
      }
    }
    function PI(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t, e) => 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length));
    }
    function OI(t, e) {
      const n = new DOMParser(),
        o = function (t) {
          return PI(PI(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/(<span\s+style=['"]letter-spacing:[^'"]+?['"]>)[\r\n]+(<\/span>)/g, "$1 $2").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function (t) {
          const e = "</body>",
            n = "</html>",
            o = t.indexOf(e);
          if (o < 0) return t;
          const i = t.indexOf(n, o + e.length);
          return t.substring(0, o + e.length) + (i >= 0 ? t.substring(i) : "");
        }(t = (t = t.replace(/<!--\[if gte vml 1]>/g, "")).replace(/<o:SmartTagType(?:\s+[^\s>=]+(?:="[^"]*")?)*\s*\/?>/gi, ""))),
        i = n.parseFromString(o, "text/html");
      !function (t) {
        t.querySelectorAll("span[style*=spacerun]").forEach(t => {
          const e = t,
            n = e.innerText.length || 0;
          e.innerText = Array(n + 1).join("  ").substr(0, n);
        });
      }(i);
      const r = i.body.innerHTML,
        s = function (t, e) {
          const n = new sa(e),
            o = new Za(n, {
              renderingMode: "data"
            }),
            i = t.createDocumentFragment(),
            r = t.body.childNodes;
          for (; r.length > 0;) i.appendChild(r[0]);
          return o.domToView(i, {
            skipComments: !0
          });
        }(i, e),
        a = function (t) {
          const e = [],
            n = [],
            o = Array.from(t.getElementsByTagName("style"));
          for (const t of o) t.sheet && t.sheet.cssRules && t.sheet.cssRules.length && (e.push(t.sheet), n.push(t.innerHTML));
          return {
            styles: e,
            stylesString: n.join(" ")
          };
        }(i);
      return {
        body: s,
        bodyString: r,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }
    Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    function LI(t, e, n, o, i = 1) {
      null != e && null != i && e > i ? o.setAttribute(t, e, n) : o.removeAttribute(t, n);
    }
    function zI(t, e, n = {}) {
      const o = t.createElement("tableCell", n);
      return t.insertElement("paragraph", o), t.insert(o, e), o;
    }
    function RI(t, e) {
      const n = e.parent.parent,
        o = parseInt(n.getAttribute("headingColumns") || "0"),
        {
          column: i
        } = t.getCellLocation(e);
      return !!o && i < o;
    }
    function jI() {
      return t => {
        t.on("element:table", (t, e, n) => {
          const o = e.viewItem;
          if (!n.consumable.test(o, {
            name: !0
          })) return;
          const {
              rows: i,
              headingRows: r,
              headingColumns: s
            } = function (t) {
              let e,
                n = 0;
              const o = [],
                i = [];
              let r;
              for (const s of Array.from(t.getChildren())) {
                if ("tbody" !== s.name && "thead" !== s.name && "tfoot" !== s.name) continue;
                "thead" !== s.name || r || (r = s);
                const t = Array.from(s.getChildren()).filter(t => t.is("element", "tr"));
                for (const a of t) if (r && s === r || "tbody" === s.name && Array.from(a.getChildren()).length && Array.from(a.getChildren()).every(t => t.is("element", "th"))) n++, o.push(a);else {
                  i.push(a);
                  const t = VI(a);
                  (!e || t < e) && (e = t);
                }
              }
              return {
                headingRows: n,
                headingColumns: e || 0,
                rows: [...o, ...i]
              };
            }(o),
            a = {};
          s && (a.headingColumns = s), r && (a.headingRows = r);
          const c = n.writer.createElement("table", a);
          if (n.safeInsert(c, e.modelCursor)) {
            if (n.consumable.consume(o, {
              name: !0
            }), i.forEach(t => n.convertItem(t, n.writer.createPositionAt(c, "end"))), n.convertChildren(o, n.writer.createPositionAt(c, "end")), c.isEmpty) {
              const t = n.writer.createElement("tableRow");
              n.writer.insert(t, n.writer.createPositionAt(c, "end")), zI(n.writer, n.writer.createPositionAt(t, "end"));
            }
            n.updateConversionResult(c, e);
          }
        });
      };
    }
    function FI(t) {
      return e => {
        e.on(`element:${t}`, (t, e, {
          writer: n
        }) => {
          if (!e.modelRange) return;
          const o = e.modelRange.start.nodeAfter,
            i = n.createPositionAt(o, 0);
          if (e.viewItem.isEmpty) return void n.insertElement("paragraph", i);
          const r = Array.from(o.getChildren());
          if (r.every(t => t.is("element", "$marker"))) {
            const t = n.createElement("paragraph");
            n.insert(t, n.createPositionAt(o, 0));
            for (const e of r) n.move(n.createRangeOn(e), n.createPositionAt(t, "end"));
          }
        }, {
          priority: "low"
        });
      };
    }
    function VI(t) {
      let e = 0,
        n = 0;
      const o = Array.from(t.getChildren()).filter(t => "th" === t.name || "td" === t.name);
      for (; n < o.length && "th" === o[n].name;) {
        const t = o[n];
        e += parseInt(t.getAttribute("colspan") || "1"), n++;
      }
      return e;
    }
    class HI {
      constructor(t, e = {}) {
        this._jumpedToStartRow = !1, this._table = t, this._startRow = void 0 !== e.row ? e.row : e.startRow || 0, this._endRow = void 0 !== e.row ? e.row : e.endRow, this._startColumn = void 0 !== e.column ? e.column : e.startColumn || 0, this._endColumn = void 0 !== e.column ? e.column : e.endColumn, this._includeAllSlots = !!e.includeAllSlots, this._skipRows = new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }
      [Symbol.iterator]() {
        return this;
      }
      next() {
        this._canJumpToStartRow() && this._jumpToNonSpannedRowClosestToStartRow();
        const t = this._table.getChild(this._rowIndex);
        if (!t || this._isOverEndRow()) return {
          done: !0,
          value: void 0
        };
        if (!t.is("element", "tableRow")) return this._rowIndex++, this.next();
        if (this._isOverEndColumn()) return this._advanceToNextRow();
        let e = null;
        const n = this._getSpanned();
        if (n) this._includeAllSlots && !this._shouldSkipSlot() && (e = this._formatOutValue(n.cell, n.row, n.column));else {
          const n = t.getChild(this._cellIndex);
          if (!n) return this._advanceToNextRow();
          const o = parseInt(n.getAttribute("colspan") || "1"),
            i = parseInt(n.getAttribute("rowspan") || "1");
          (o > 1 || i > 1) && this._recordSpans(n, i, o), this._shouldSkipSlot() || (e = this._formatOutValue(n)), this._nextCellAtColumn = this._column + o;
        }
        return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, e || this.next();
      }
      skipRow(t) {
        this._skipRows.add(t);
      }
      _advanceToNextRow() {
        return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
      }
      _isOverEndRow() {
        return void 0 !== this._endRow && this._row > this._endRow;
      }
      _isOverEndColumn() {
        return void 0 !== this._endColumn && this._column > this._endColumn;
      }
      _formatOutValue(t, e = this._row, n = this._column) {
        return {
          done: !1,
          value: new UI(this, t, e, n)
        };
      }
      _shouldSkipSlot() {
        const t = this._skipRows.has(this._row),
          e = this._row < this._startRow,
          n = this._column < this._startColumn,
          o = void 0 !== this._endColumn && this._column > this._endColumn;
        return t || e || n || o;
      }
      _getSpanned() {
        const t = this._spannedCells.get(this._row);
        return t && t.get(this._column) || null;
      }
      _recordSpans(t, e, n) {
        const o = {
          cell: t,
          row: this._row,
          column: this._column
        };
        for (let t = this._row; t < this._row + e; t++) for (let e = this._column; e < this._column + n; e++) t == this._row && e == this._column || this._markSpannedCell(t, e, o);
      }
      _markSpannedCell(t, e, n) {
        this._spannedCells.has(t) || this._spannedCells.set(t, new Map());
        this._spannedCells.get(t).set(e, n);
      }
      _canJumpToStartRow() {
        return !!this._startRow && this._startRow > 0 && !this._jumpedToStartRow;
      }
      _jumpToNonSpannedRowClosestToStartRow() {
        const t = this._getRowLength(0);
        for (let e = this._startRow; !this._jumpedToStartRow; e--) t === this._getRowLength(e) && (this._row = e, this._rowIndex = e, this._jumpedToStartRow = !0);
      }
      _getRowLength(t) {
        return [...this._table.getChild(t).getChildren()].reduce((t, e) => t + parseInt(e.getAttribute("colspan") || "1"), 0);
      }
    }
    class UI {
      constructor(t, e, n, o) {
        this.cell = e, this.row = t._row, this.column = t._column, this.cellAnchorRow = n, this.cellAnchorColumn = o, this._cellIndex = t._cellIndex, this._rowIndex = t._rowIndex, this._table = t._table;
      }
      get isAnchor() {
        return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
      }
      get cellWidth() {
        return parseInt(this.cell.getAttribute("colspan") || "1");
      }
      get cellHeight() {
        return parseInt(this.cell.getAttribute("rowspan") || "1");
      }
      get rowIndex() {
        return this._rowIndex;
      }
      getPositionBefore() {
        return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
      }
    }
    function qI(t, e) {
      return (n, {
        writer: o
      }) => {
        const i = n.getAttribute("headingRows") || 0,
          r = o.createContainerElement("table", null, []),
          s = o.createContainerElement("figure", {
            class: "table"
          }, r);
        i > 0 && o.insert(o.createPositionAt(r, "end"), o.createContainerElement("thead", null, o.createSlot(t => t.is("element", "tableRow") && t.index < i))), i < t.getRows(n) && o.insert(o.createPositionAt(r, "end"), o.createContainerElement("tbody", null, o.createSlot(t => t.is("element", "tableRow") && t.index >= i)));
        for (const {
          positionOffset: t,
          filter: n
        } of e.additionalSlots) o.insert(o.createPositionAt(r, t), o.createSlot(n));
        return o.insert(o.createPositionAt(r, "after"), o.createSlot(t => !t.is("element", "tableRow") && !e.additionalSlots.some(({
          filter: e
        }) => e(t)))), e.asWidget ? function (t, e) {
          return e.setCustomProperty("table", !0, t), Qw(t, e, {
            hasSelectionHandle: !0
          });
        }(s, o) : s;
      };
    }
    function GI(t = {}) {
      return (e, {
        writer: n
      }) => {
        const o = e.parent,
          i = o.parent,
          r = i.getChildIndex(o),
          s = new HI(i, {
            row: r
          }),
          a = i.getAttribute("headingRows") || 0,
          c = i.getAttribute("headingColumns") || 0;
        let l = null;
        for (const o of s) if (o.cell == e) {
          const e = o.row < a || o.column < c ? "th" : "td";
          l = t.asWidget ? tA(n.createEditableElement(e), n) : n.createContainerElement(e);
          break;
        }
        return l;
      };
    }
    function WI(t = {}) {
      return (e, {
        writer: n
      }) => {
        if (!e.parent.is("element", "tableCell")) return null;
        if (!KI(e)) return null;
        if (t.asWidget) return n.createContainerElement("span", {
          class: "ck-table-bogus-paragraph"
        });
        {
          const t = n.createContainerElement("p");
          return n.setCustomProperty("dataPipeline:transparentRendering", !0, t), t;
        }
      };
    }
    function KI(t) {
      return 1 == t.parent.childCount && !!t.getAttributeKeys().next().done;
    }
    class $I extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = t.schema;
        this.isEnabled = function (t, e) {
          const n = t.getFirstPosition().parent,
            o = n === n.root ? n : n.parent;
          return e.checkChild(o, "table");
        }(e, n);
      }
      execute(t = {}) {
        const e = this.editor,
          n = e.model,
          o = e.plugins.get("TableUtils"),
          i = e.config.get("table.defaultHeadings.rows"),
          r = e.config.get("table.defaultHeadings.columns");
        void 0 === t.headingRows && i && (t.headingRows = i), void 0 === t.headingColumns && r && (t.headingColumns = r), n.change(e => {
          const i = o.createTable(e, t);
          n.insertObject(i, null, null, {
            findOptimalPosition: "auto"
          }), e.setSelection(e.createPositionAt(i.getNodeByPath([0, 0, 0]), 0));
        });
      }
    }
    class YI extends Pr {
      constructor(t, e = {}) {
        super(t), this.order = e.order || "below";
      }
      refresh() {
        const t = this.editor.model.document.selection,
          e = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t).length;
        this.isEnabled = e;
      }
      execute() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.plugins.get("TableUtils"),
          o = "above" === this.order,
          i = n.getSelectionAffectedTableCells(e),
          r = n.getRowIndexes(i),
          s = o ? r.first : r.last,
          a = i[0].findAncestor("table");
        n.insertRows(a, {
          at: o ? s : s + 1,
          copyStructureFromAbove: !o
        });
      }
    }
    class QI extends Pr {
      constructor(t, e = {}) {
        super(t), this.order = e.order || "right";
      }
      refresh() {
        const t = this.editor.model.document.selection,
          e = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t).length;
        this.isEnabled = e;
      }
      execute() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.plugins.get("TableUtils"),
          o = "left" === this.order,
          i = n.getSelectionAffectedTableCells(e),
          r = n.getColumnIndexes(i),
          s = o ? r.first : r.last,
          a = i[0].findAncestor("table");
        n.insertColumns(a, {
          columns: 1,
          at: o ? s : s + 1
        });
      }
    }
    class ZI extends Pr {
      constructor(t, e = {}) {
        super(t), this.direction = e.direction || "horizontally";
      }
      refresh() {
        const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = 1 === t.length;
      }
      execute() {
        const t = this.editor.plugins.get("TableUtils"),
          e = t.getSelectionAffectedTableCells(this.editor.model.document.selection)[0];
        "horizontally" === this.direction ? t.splitCellHorizontally(e, 2) : t.splitCellVertically(e, 2);
      }
    }
    function JI(t, e, n) {
      const {
          startRow: o,
          startColumn: i,
          endRow: r,
          endColumn: s
        } = e,
        a = n.createElement("table"),
        c = r - o + 1;
      for (let t = 0; t < c; t++) n.insertElement("tableRow", a, "end");
      const l = [...new HI(t, {
        startRow: o,
        endRow: r,
        startColumn: i,
        endColumn: s,
        includeAllSlots: !0
      })];
      for (const {
        row: t,
        column: e,
        cell: c,
        isAnchor: d,
        cellAnchorRow: u,
        cellAnchorColumn: h
      } of l) {
        const l = t - o,
          g = a.getChild(l);
        if (d) {
          const o = n.cloneElement(c);
          n.append(o, g), oT(o, t, e, r, s, n);
        } else (u < o || h < i) && zI(n, n.createPositionAt(g, "end"));
      }
      return function (t, e, n, o, i) {
        const r = parseInt(e.getAttribute("headingRows") || "0");
        if (r > 0) {
          LI("headingRows", r - n, t, i, 0);
        }
        const s = parseInt(e.getAttribute("headingColumns") || "0");
        if (s > 0) {
          LI("headingColumns", s - o, t, i, 0);
        }
      }(a, t, o, i, n), a;
    }
    function XI(t, e, n = 0) {
      const o = [],
        i = new HI(t, {
          startRow: n,
          endRow: e - 1
        });
      for (const t of i) {
        const {
          row: n,
          cellHeight: i
        } = t;
        n < e && e <= n + i - 1 && o.push(t);
      }
      return o;
    }
    function tT(t, e, n) {
      const o = t.parent,
        i = o.parent,
        r = o.index,
        s = e - r,
        a = {},
        c = parseInt(t.getAttribute("rowspan")) - s;
      c > 1 && (a.rowspan = c);
      const l = parseInt(t.getAttribute("colspan") || "1");
      l > 1 && (a.colspan = l);
      const d = r + s,
        u = [...new HI(i, {
          startRow: r,
          endRow: d,
          includeAllSlots: !0
        })];
      let h,
        g = null;
      for (const e of u) {
        const {
          row: o,
          column: i,
          cell: r
        } = e;
        r === t && void 0 === h && (h = i), void 0 !== h && h === i && o === d && (g = zI(n, e.getPositionBefore(), a));
      }
      return LI("rowspan", s, t, n), g;
    }
    function eT(t, e) {
      const n = [],
        o = new HI(t);
      for (const t of o) {
        const {
          column: o,
          cellWidth: i
        } = t;
        o < e && e <= o + i - 1 && n.push(t);
      }
      return n;
    }
    function nT(t, e, n, o) {
      const i = n - e,
        r = {},
        s = parseInt(t.getAttribute("colspan")) - i;
      s > 1 && (r.colspan = s);
      const a = parseInt(t.getAttribute("rowspan") || "1");
      a > 1 && (r.rowspan = a);
      const c = zI(o, o.createPositionAfter(t), r);
      return LI("colspan", i, t, o), c;
    }
    function oT(t, e, n, o, i, r) {
      const s = parseInt(t.getAttribute("colspan") || "1"),
        a = parseInt(t.getAttribute("rowspan") || "1");
      if (n + s - 1 > i) {
        LI("colspan", i - n + 1, t, r, 1);
      }
      if (e + a - 1 > o) {
        LI("rowspan", o - e + 1, t, r, 1);
      }
    }
    function iT(t, e) {
      const n = e.getColumns(t),
        o = new Array(n).fill(0);
      for (const {
        column: e
      } of new HI(t)) o[e]++;
      const i = o.reduce((t, e, n) => e ? t : [...t, n], []);
      if (i.length > 0) {
        const n = i[i.length - 1];
        return e.removeColumns(t, {
          at: n
        }), !0;
      }
      return !1;
    }
    function rT(t, e) {
      const n = [],
        o = e.getRows(t);
      for (let e = 0; e < o; e++) {
        t.getChild(e).isEmpty && n.push(e);
      }
      if (n.length > 0) {
        const o = n[n.length - 1];
        return e.removeRows(t, {
          at: o
        }), !0;
      }
      return !1;
    }
    function sT(t, e) {
      iT(t, e) || rT(t, e);
    }
    function aT(t, e) {
      const n = Array.from(new HI(t, {
        startColumn: e.firstColumn,
        endColumn: e.lastColumn,
        row: e.lastRow
      }));
      if (n.every(({
        cellHeight: t
      }) => 1 === t)) return e.lastRow;
      const o = n[0].cellHeight - 1;
      return e.lastRow + o;
    }
    function cT(t, e) {
      const n = Array.from(new HI(t, {
        startRow: e.firstRow,
        endRow: e.lastRow,
        column: e.lastColumn
      }));
      if (n.every(({
        cellWidth: t
      }) => 1 === t)) return e.lastColumn;
      const o = n[0].cellWidth - 1;
      return e.lastColumn + o;
    }
    class lT extends Pr {
      constructor(t, e) {
        super(t), this.direction = e.direction, this.isHorizontal = "right" == this.direction || "left" == this.direction;
      }
      refresh() {
        const t = this._getMergeableCell();
        this.value = t, this.isEnabled = !!t;
      }
      execute() {
        const t = this.editor.model,
          e = t.document,
          n = this.editor.plugins.get("TableUtils").getTableCellsContainingSelection(e.selection)[0],
          o = this.value,
          i = this.direction;
        t.change(t => {
          const e = "right" == i || "down" == i,
            r = e ? n : o,
            s = e ? o : n,
            a = s.parent;
          !function (t, e, n) {
            dT(t) || (dT(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
            n.remove(t);
          }(s, r, t);
          const c = this.isHorizontal ? "colspan" : "rowspan",
            l = parseInt(n.getAttribute(c) || "1"),
            d = parseInt(o.getAttribute(c) || "1");
          t.setAttribute(c, l + d, r), t.setSelection(t.createRangeIn(r));
          const u = this.editor.plugins.get("TableUtils");
          sT(a.findAncestor("table"), u);
        });
      }
      _getMergeableCell() {
        const t = this.editor.model.document,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getTableCellsContainingSelection(t.selection)[0];
        if (!n) return;
        const o = this.isHorizontal ? function (t, e, n) {
          const o = t.parent,
            i = o.parent,
            r = "right" == e ? t.nextSibling : t.previousSibling,
            s = (i.getAttribute("headingColumns") || 0) > 0;
          if (!r) return;
          const a = "right" == e ? t : r,
            c = "right" == e ? r : t,
            {
              column: l
            } = n.getCellLocation(a),
            {
              column: d
            } = n.getCellLocation(c),
            u = parseInt(a.getAttribute("colspan") || "1"),
            h = RI(n, a),
            g = RI(n, c);
          if (s && h != g) return;
          return l + u === d ? r : void 0;
        }(n, this.direction, e) : function (t, e, n) {
          const o = t.parent,
            i = o.parent,
            r = i.getChildIndex(o);
          if ("down" == e && r === n.getRows(i) - 1 || "up" == e && 0 === r) return null;
          const s = parseInt(t.getAttribute("rowspan") || "1"),
            a = i.getAttribute("headingRows") || 0,
            c = "down" == e && r + s === a,
            l = "up" == e && r === a;
          if (a && (c || l)) return null;
          const d = parseInt(t.getAttribute("rowspan") || "1"),
            u = "down" == e ? r + d : r,
            h = [...new HI(i, {
              endRow: u
            })],
            g = h.find(e => e.cell === t),
            m = g.column,
            p = h.find(({
              row: t,
              cellHeight: n,
              column: o
            }) => o === m && ("down" == e ? t === u : u === t + n));
          return p && p.cell ? p.cell : null;
        }(n, this.direction, e);
        if (!o) return;
        const i = this.isHorizontal ? "rowspan" : "colspan",
          r = parseInt(n.getAttribute(i) || "1");
        return parseInt(o.getAttribute(i) || "1") === r ? o : void 0;
      }
    }
    function dT(t) {
      const e = t.getChild(0);
      return 1 == t.childCount && e.is("element", "paragraph") && e.isEmpty;
    }
    class uT extends Pr {
      refresh() {
        const t = this.editor.plugins.get("TableUtils"),
          e = t.getSelectionAffectedTableCells(this.editor.model.document.selection),
          n = e[0];
        if (n) {
          const o = n.findAncestor("table"),
            i = t.getRows(o) - 1,
            r = t.getRowIndexes(e),
            s = 0 === r.first && r.last === i;
          this.isEnabled = !s;
        } else this.isEnabled = !1;
      }
      execute() {
        const t = this.editor.model,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getSelectionAffectedTableCells(t.document.selection),
          o = e.getRowIndexes(n),
          i = n[0],
          r = i.findAncestor("table"),
          s = e.getCellLocation(i).column;
        t.change(t => {
          const n = o.last - o.first + 1;
          e.removeRows(r, {
            at: o.first,
            rows: n
          });
          const i = function (t, e, n, o) {
            const i = t.getChild(Math.min(e, o - 1));
            let r = i.getChild(0),
              s = 0;
            for (const t of i.getChildren()) {
              if (s > n) return r;
              r = t, s += parseInt(t.getAttribute("colspan") || "1");
            }
            return r;
          }(r, o.first, s, e.getRows(r));
          t.setSelection(t.createPositionAt(i, 0));
        });
      }
    }
    class hT extends Pr {
      refresh() {
        const t = this.editor.plugins.get("TableUtils"),
          e = t.getSelectionAffectedTableCells(this.editor.model.document.selection),
          n = e[0];
        if (n) {
          const o = n.findAncestor("table"),
            i = t.getColumns(o),
            {
              first: r,
              last: s
            } = t.getColumnIndexes(e);
          this.isEnabled = s - r < i - 1;
        } else this.isEnabled = !1;
      }
      execute() {
        const t = this.editor.plugins.get("TableUtils"),
          [e, n] = function (t, e) {
            const n = e.getSelectionAffectedTableCells(t),
              o = n[0],
              i = n.pop(),
              r = [o, i];
            return o.isBefore(i) ? r : r.reverse();
          }(this.editor.model.document.selection, t),
          o = e.parent.parent,
          i = [...new HI(o)],
          r = {
            first: i.find(t => t.cell === e).column,
            last: i.find(t => t.cell === n).column
          },
          s = function (t, e, n, o) {
            const i = parseInt(n.getAttribute("colspan") || "1");
            return i > 1 ? n : e.previousSibling || n.nextSibling ? n.nextSibling || e.previousSibling : o.first ? t.reverse().find(({
              column: t
            }) => t < o.first).cell : t.reverse().find(({
              column: t
            }) => t > o.last).cell;
          }(i, e, n, r);
        this.editor.model.change(e => {
          const n = r.last - r.first + 1;
          t.removeColumns(o, {
            at: r.first,
            columns: n
          }), e.setSelection(e.createPositionAt(s, 0));
        });
      }
    }
    class gT extends Pr {
      refresh() {
        const t = this.editor.plugins.get("TableUtils"),
          e = this.editor.model,
          n = t.getSelectionAffectedTableCells(e.document.selection),
          o = n.length > 0;
        this.isEnabled = o, this.value = o && n.every(t => this._isInHeading(t, t.parent.parent));
      }
      execute(t = {}) {
        if (t.forceValue === this.value) return;
        const e = this.editor.plugins.get("TableUtils"),
          n = this.editor.model,
          o = e.getSelectionAffectedTableCells(n.document.selection),
          i = o[0].findAncestor("table"),
          {
            first: r,
            last: s
          } = e.getRowIndexes(o),
          a = this.value ? r : s + 1,
          c = i.getAttribute("headingRows") || 0;
        n.change(t => {
          if (a) {
            const e = XI(i, a, a > c ? c : 0);
            for (const {
              cell: n
            } of e) tT(n, a, t);
          }
          LI("headingRows", a, i, t, 0);
        });
      }
      _isInHeading(t, e) {
        const n = parseInt(e.getAttribute("headingRows") || "0");
        return !!n && t.parent.index < n;
      }
    }
    class mT extends Pr {
      refresh() {
        const t = this.editor.model,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getSelectionAffectedTableCells(t.document.selection),
          o = n.length > 0;
        this.isEnabled = o, this.value = o && n.every(t => RI(e, t));
      }
      execute(t = {}) {
        if (t.forceValue === this.value) return;
        const e = this.editor.plugins.get("TableUtils"),
          n = this.editor.model,
          o = e.getSelectionAffectedTableCells(n.document.selection),
          i = o[0].findAncestor("table"),
          {
            first: r,
            last: s
          } = e.getColumnIndexes(o),
          a = this.value ? r : s + 1;
        n.change(t => {
          if (a) {
            const e = eT(i, a);
            for (const {
              cell: n,
              column: o
            } of e) nT(n, o, a, t);
          }
          LI("headingColumns", a, i, t, 0);
        });
      }
    }
    function pT(t) {
      if (t.is("element", "tableColumnGroup")) return t;
      const e = t.getChildren();
      return Array.from(e).find(t => t.is("element", "tableColumnGroup"));
    }
    function fT(t) {
      const e = pT(t);
      return e ? Array.from(e.getChildren()) : [];
    }
    class kT extends Br {
      static get pluginName() {
        return "TableUtils";
      }
      init() {
        this.decorate("insertColumns"), this.decorate("insertRows");
      }
      getCellLocation(t) {
        const e = t.parent,
          n = e.parent,
          o = n.getChildIndex(e),
          i = new HI(n, {
            row: o
          });
        for (const {
          cell: e,
          row: n,
          column: o
        } of i) if (e === t) return {
          row: n,
          column: o
        };
      }
      createTable(t, e) {
        const n = t.createElement("table"),
          o = e.rows || 2,
          i = e.columns || 2;
        return bT(t, n, 0, o, i), e.headingRows && LI("headingRows", Math.min(e.headingRows, o), n, t, 0), e.headingColumns && LI("headingColumns", Math.min(e.headingColumns, i), n, t, 0), n;
      }
      insertRows(t, e = {}) {
        const n = this.editor.model,
          o = e.at || 0,
          i = e.rows || 1,
          r = void 0 !== e.copyStructureFromAbove,
          s = e.copyStructureFromAbove ? o - 1 : o,
          a = this.getRows(t),
          c = this.getColumns(t);
        if (o > a) throw new w("tableutils-insertrows-insert-out-of-range", this, {
          options: e
        });
        n.change(e => {
          const n = t.getAttribute("headingRows") || 0;
          if (n > o && LI("headingRows", n + i, t, e, 0), !r && (0 === o || o === a)) return void bT(e, t, o, i, c);
          const l = r ? Math.max(o, s) : o,
            d = new HI(t, {
              endRow: l
            }),
            u = new Array(c).fill(1);
          for (const {
            row: t,
            column: n,
            cellHeight: a,
            cellWidth: c,
            cell: l
          } of d) {
            const d = t + a - 1,
              h = t <= s && s <= d;
            t < o && o <= d ? (e.setAttribute("rowspan", a + i, l), u[n] = -c) : r && h && (u[n] = c);
          }
          for (let n = 0; n < i; n++) {
            const n = e.createElement("tableRow");
            e.insert(n, t, o);
            for (let t = 0; t < u.length; t++) {
              const o = u[t],
                i = e.createPositionAt(n, "end");
              o > 0 && zI(e, i, o > 1 ? {
                colspan: o
              } : void 0), t += Math.abs(o) - 1;
            }
          }
        });
      }
      insertColumns(t, e = {}) {
        const n = this.editor.model,
          o = e.at || 0,
          i = e.columns || 1;
        n.change(e => {
          const n = t.getAttribute("headingColumns");
          o < n && e.setAttribute("headingColumns", n + i, t);
          const r = this.getColumns(t);
          if (0 === o || r === o) {
            for (const n of t.getChildren()) n.is("element", "tableRow") && wT(i, e, e.createPositionAt(n, o ? "end" : 0));
            return;
          }
          const s = new HI(t, {
            column: o,
            includeAllSlots: !0
          });
          for (const t of s) {
            const {
              row: n,
              cell: r,
              cellAnchorColumn: a,
              cellAnchorRow: c,
              cellWidth: l,
              cellHeight: d
            } = t;
            if (a < o) {
              e.setAttribute("colspan", l + i, r);
              const t = c + d - 1;
              for (let e = n; e <= t; e++) s.skipRow(e);
            } else wT(i, e, t.getPositionBefore());
          }
        });
      }
      removeRows(t, e) {
        const n = this.editor.model,
          o = e.rows || 1,
          i = this.getRows(t),
          r = e.at,
          s = r + o - 1;
        if (s > i - 1) throw new w("tableutils-removerows-row-index-out-of-range", this, {
          table: t,
          options: e
        });
        n.change(e => {
          const n = {
              first: r,
              last: s
            },
            {
              cellsToMove: o,
              cellsToTrim: i
            } = function (t, {
              first: e,
              last: n
            }) {
              const o = new Map(),
                i = [];
              for (const {
                row: r,
                column: s,
                cellHeight: a,
                cell: c
              } of new HI(t, {
                endRow: n
              })) {
                const t = r + a - 1;
                if (r >= e && r <= n && t > n) {
                  const t = a - (n - r + 1);
                  o.set(s, {
                    cell: c,
                    rowspan: t
                  });
                }
                if (r < e && t >= e) {
                  let o;
                  o = t >= n ? n - e + 1 : t - e + 1, i.push({
                    cell: c,
                    rowspan: a - o
                  });
                }
              }
              return {
                cellsToMove: o,
                cellsToTrim: i
              };
            }(t, n);
          if (o.size) {
            !function (t, e, n, o) {
              const i = new HI(t, {
                  includeAllSlots: !0,
                  row: e
                }),
                r = [...i],
                s = t.getChild(e);
              let a;
              for (const {
                column: t,
                cell: e,
                isAnchor: i
              } of r) if (n.has(t)) {
                const {
                    cell: e,
                    rowspan: i
                  } = n.get(t),
                  r = a ? o.createPositionAfter(a) : o.createPositionAt(s, 0);
                o.move(o.createRangeOn(e), r), LI("rowspan", i, e, o), a = e;
              } else i && (a = e);
            }(t, s + 1, o, e);
          }
          for (let n = s; n >= r; n--) e.remove(t.getChild(n));
          for (const {
            rowspan: t,
            cell: n
          } of i) LI("rowspan", t, n, e);
          !function (t, {
            first: e,
            last: n
          }, o) {
            const i = t.getAttribute("headingRows") || 0;
            if (e < i) {
              LI("headingRows", n < i ? i - (n - e + 1) : e, t, o, 0);
            }
          }(t, n, e), iT(t, this) || rT(t, this);
        });
      }
      removeColumns(t, e) {
        const n = this.editor.model,
          o = e.at,
          i = e.columns || 1,
          r = e.at + i - 1;
        n.change(e => {
          !function (t, e, n) {
            const o = t.getAttribute("headingColumns") || 0;
            if (o && e.first < o) {
              const i = Math.min(o - 1, e.last) - e.first + 1;
              n.setAttribute("headingColumns", o - i, t);
            }
          }(t, {
            first: o,
            last: r
          }, e);
          const n = fT(t);
          for (let i = r; i >= o; i--) {
            for (const {
              cell: n,
              column: o,
              cellWidth: r
            } of [...new HI(t)]) o <= i && r > 1 && o + r > i ? LI("colspan", r - 1, n, e) : o === i && e.remove(n);
            if (n[i]) {
              const t = 0 === i ? n[1] : n[i - 1],
                o = parseFloat(n[i].getAttribute("columnWidth")),
                r = parseFloat(t.getAttribute("columnWidth"));
              e.remove(n[i]), e.setAttribute("columnWidth", o + r + "%", t);
            }
          }
          rT(t, this) || iT(t, this);
        });
      }
      splitCellVertically(t, e = 2) {
        const n = this.editor.model,
          o = t.parent.parent,
          i = parseInt(t.getAttribute("rowspan") || "1"),
          r = parseInt(t.getAttribute("colspan") || "1");
        n.change(n => {
          if (r > 1) {
            const {
              newCellsSpan: o,
              updatedSpan: s
            } = AT(r, e);
            LI("colspan", s, t, n);
            const a = {};
            o > 1 && (a.colspan = o), i > 1 && (a.rowspan = i);
            wT(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), a);
          }
          if (r < e) {
            const s = e - r,
              a = [...new HI(o)],
              {
                column: c
              } = a.find(({
                cell: e
              }) => e === t),
              l = a.filter(({
                cell: e,
                cellWidth: n,
                column: o
              }) => e !== t && o === c || o < c && o + n > c);
            for (const {
              cell: t,
              cellWidth: e
            } of l) n.setAttribute("colspan", e + s, t);
            const d = {};
            i > 1 && (d.rowspan = i), wT(s, n, n.createPositionAfter(t), d);
            const u = o.getAttribute("headingColumns") || 0;
            u > c && LI("headingColumns", u + s, o, n);
          }
        });
      }
      splitCellHorizontally(t, e = 2) {
        const n = this.editor.model,
          o = t.parent,
          i = o.parent,
          r = i.getChildIndex(o),
          s = parseInt(t.getAttribute("rowspan") || "1"),
          a = parseInt(t.getAttribute("colspan") || "1");
        n.change(n => {
          if (s > 1) {
            const o = [...new HI(i, {
                startRow: r,
                endRow: r + s - 1,
                includeAllSlots: !0
              })],
              {
                newCellsSpan: c,
                updatedSpan: l
              } = AT(s, e);
            LI("rowspan", l, t, n);
            const {
                column: d
              } = o.find(({
                cell: e
              }) => e === t),
              u = {};
            c > 1 && (u.rowspan = c), a > 1 && (u.colspan = a);
            for (const t of o) {
              const {
                column: e,
                row: o
              } = t;
              o >= r + l && e === d && (o + r + l) % c == 0 && wT(1, n, t.getPositionBefore(), u);
            }
          }
          if (s < e) {
            const o = e - s,
              c = [...new HI(i, {
                startRow: 0,
                endRow: r
              })];
            for (const {
              cell: e,
              cellHeight: i,
              row: s
            } of c) if (e !== t && s + i > r) {
              const t = i + o;
              n.setAttribute("rowspan", t, e);
            }
            const l = {};
            a > 1 && (l.colspan = a), bT(n, i, r + 1, o, 1, l);
            const d = i.getAttribute("headingRows") || 0;
            d > r && LI("headingRows", d + o, i, n);
          }
        });
      }
      getColumns(t) {
        return [...t.getChild(0).getChildren()].filter(t => t.is("element", "tableCell")).reduce((t, e) => t + parseInt(e.getAttribute("colspan") || "1"), 0);
      }
      getRows(t) {
        return Array.from(t.getChildren()).reduce((t, e) => e.is("element", "tableRow") ? t + 1 : t, 0);
      }
      createTableWalker(t, e = {}) {
        return new HI(t, e);
      }
      getSelectedTableCells(t) {
        const e = [];
        for (const n of this.sortRanges(t.getRanges())) {
          const t = n.getContainedElement();
          t && t.is("element", "tableCell") && e.push(t);
        }
        return e;
      }
      getTableCellsContainingSelection(t) {
        const e = [];
        for (const n of t.getRanges()) {
          const t = n.start.findAncestor("tableCell");
          t && e.push(t);
        }
        return e;
      }
      getSelectionAffectedTableCells(t) {
        const e = this.getSelectedTableCells(t);
        return e.length ? e : this.getTableCellsContainingSelection(t);
      }
      getRowIndexes(t) {
        const e = t.map(t => t.parent.index);
        return this._getFirstLastIndexesObject(e);
      }
      getColumnIndexes(t) {
        const e = t[0].findAncestor("table"),
          n = [...new HI(e)].filter(e => t.includes(e.cell)).map(t => t.column);
        return this._getFirstLastIndexesObject(n);
      }
      isSelectionRectangular(t) {
        if (t.length < 2 || !this._areCellInTheSameTableSection(t)) return !1;
        const e = new Set(),
          n = new Set();
        let o = 0;
        for (const i of t) {
          const {
              row: t,
              column: r
            } = this.getCellLocation(i),
            s = parseInt(i.getAttribute("rowspan")) || 1,
            a = parseInt(i.getAttribute("colspan")) || 1;
          e.add(t), n.add(r), s > 1 && e.add(t + s - 1), a > 1 && n.add(r + a - 1), o += s * a;
        }
        const i = function (t, e) {
          const n = Array.from(t.values()),
            o = Array.from(e.values()),
            i = Math.max(...n),
            r = Math.min(...n),
            s = Math.max(...o),
            a = Math.min(...o);
          return (i - r + 1) * (s - a + 1);
        }(e, n);
        return i == o;
      }
      sortRanges(t) {
        return Array.from(t).sort(_T);
      }
      _getFirstLastIndexesObject(t) {
        const e = t.sort((t, e) => t - e);
        return {
          first: e[0],
          last: e[e.length - 1]
        };
      }
      _areCellInTheSameTableSection(t) {
        const e = t[0].findAncestor("table"),
          n = this.getRowIndexes(t),
          o = parseInt(e.getAttribute("headingRows")) || 0;
        if (!this._areIndexesInSameSection(n, o)) return !1;
        const i = this.getColumnIndexes(t),
          r = parseInt(e.getAttribute("headingColumns")) || 0;
        return this._areIndexesInSameSection(i, r);
      }
      _areIndexesInSameSection({
        first: t,
        last: e
      }, n) {
        return t < n === e < n;
      }
    }
    function bT(t, e, n, o, i, r = {}) {
      for (let s = 0; s < o; s++) {
        const o = t.createElement("tableRow");
        t.insert(o, e, n), wT(i, t, t.createPositionAt(o, "end"), r);
      }
    }
    function wT(t, e, n, o = {}) {
      for (let i = 0; i < t; i++) zI(e, n, o);
    }
    function AT(t, e) {
      if (t < e) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      const n = Math.floor(t / e);
      return {
        newCellsSpan: n,
        updatedSpan: t - n * e + n
      };
    }
    function _T(t, e) {
      const n = t.start,
        o = e.start;
      return n.isBefore(o) ? -1 : 1;
    }
    class CT extends Pr {
      refresh() {
        const t = this.editor.plugins.get(kT),
          e = t.getSelectedTableCells(this.editor.model.document.selection);
        this.isEnabled = t.isSelectionRectangular(e);
      }
      execute() {
        const t = this.editor.model,
          e = this.editor.plugins.get(kT);
        t.change(n => {
          const o = e.getSelectedTableCells(t.document.selection),
            i = o.shift(),
            {
              mergeWidth: r,
              mergeHeight: s
            } = function (t, e, n) {
              let o = 0,
                i = 0;
              for (const t of e) {
                const {
                  row: e,
                  column: r
                } = n.getCellLocation(t);
                o = xT(t, r, o, "colspan"), i = xT(t, e, i, "rowspan");
              }
              const {
                  row: r,
                  column: s
                } = n.getCellLocation(t),
                a = o - s,
                c = i - r;
              return {
                mergeWidth: a,
                mergeHeight: c
              };
            }(i, o, e);
          LI("colspan", r, i, n), LI("rowspan", s, i, n);
          for (const t of o) vT(t, i, n);
          sT(i.findAncestor("table"), e), n.setSelection(i, "in");
        });
      }
    }
    function vT(t, e, n) {
      yT(t) || (yT(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end"))), n.remove(t);
    }
    function yT(t) {
      const e = t.getChild(0);
      return 1 == t.childCount && e.is("element", "paragraph") && e.isEmpty;
    }
    function xT(t, e, n, o) {
      const i = parseInt(t.getAttribute(o) || "1");
      return Math.max(n, e + i);
    }
    class ET extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1;
      }
      refresh() {
        const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = t.length > 0;
      }
      execute() {
        const t = this.editor.model,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getSelectionAffectedTableCells(t.document.selection),
          o = e.getRowIndexes(n),
          i = n[0].findAncestor("table"),
          r = [];
        for (let e = o.first; e <= o.last; e++) for (const n of i.getChild(e).getChildren()) r.push(t.createRangeOn(n));
        t.change(t => {
          t.setSelection(r);
        });
      }
    }
    class DT extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1;
      }
      refresh() {
        const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = t.length > 0;
      }
      execute() {
        const t = this.editor.plugins.get("TableUtils"),
          e = this.editor.model,
          n = t.getSelectionAffectedTableCells(e.document.selection),
          o = n[0],
          i = n.pop(),
          r = o.findAncestor("table"),
          s = t.getCellLocation(o),
          a = t.getCellLocation(i),
          c = Math.min(s.column, a.column),
          l = Math.max(s.column, a.column),
          d = [];
        for (const t of new HI(r, {
          startColumn: c,
          endColumn: l
        })) d.push(e.createRangeOn(t.cell));
        e.change(t => {
          t.setSelection(d);
        });
      }
    }
    function IT(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.differ.getChanges();
        let o = !1;
        const i = new Set();
        for (const e of n) {
          let n = null;
          "insert" == e.type && "table" == e.name && (n = e.position.nodeAfter), "insert" != e.type && "remove" != e.type || "tableRow" != e.name && "tableCell" != e.name || (n = e.position.findAncestor("table")), ST(e) && (n = e.range.start.findAncestor("table")), n && !i.has(n) && (o = TT(n, t) || o, o = MT(n, t) || o, i.add(n));
        }
        return o;
      }(e, t));
    }
    function TT(t, e) {
      let n = !1;
      const o = function (t) {
        const e = parseInt(t.getAttribute("headingRows") || "0"),
          n = Array.from(t.getChildren()).reduce((t, e) => e.is("element", "tableRow") ? t + 1 : t, 0),
          o = [];
        for (const {
          row: i,
          cell: r,
          cellHeight: s
        } of new HI(t)) {
          if (s < 2) continue;
          const t = i < e ? e : n;
          if (i + s > t) {
            const e = t - i;
            o.push({
              cell: r,
              rowspan: e
            });
          }
        }
        return o;
      }(t);
      if (o.length) {
        n = !0;
        for (const t of o) LI("rowspan", t.rowspan, t.cell, e, 1);
      }
      return n;
    }
    function MT(t, e) {
      let n = !1;
      const o = function (t) {
          const e = new Array(t.childCount).fill(0);
          for (const {
            rowIndex: n
          } of new HI(t, {
            includeAllSlots: !0
          })) e[n]++;
          return e;
        }(t),
        i = [];
      for (const [e, n] of o.entries()) !n && t.getChild(e).is("element", "tableRow") && i.push(e);
      if (i.length) {
        n = !0;
        for (const n of i.reverse()) e.remove(t.getChild(n)), o.splice(n, 1);
      }
      const r = o.filter((e, n) => t.getChild(n).is("element", "tableRow")),
        s = r[0];
      if (!r.every(t => t === s)) {
        const o = r.reduce((t, e) => e > t ? e : t, 0);
        for (const [i, s] of r.entries()) {
          const r = o - s;
          if (r) {
            for (let n = 0; n < r; n++) zI(e, e.createPositionAt(t.getChild(i), "end"));
            n = !0;
          }
        }
      }
      return n;
    }
    function ST(t) {
      if ("attribute" !== t.type) return !1;
      const e = t.attributeKey;
      return "headingRows" === e || "colspan" === e || "rowspan" === e;
    }
    function BT(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.differ.getChanges();
        let o = !1;
        for (const e of n) "insert" == e.type && "table" == e.name && (o = NT(e.position.nodeAfter, t) || o), "insert" == e.type && "tableRow" == e.name && (o = PT(e.position.nodeAfter, t) || o), "insert" == e.type && "tableCell" == e.name && (o = OT(e.position.nodeAfter, t) || o), "remove" != e.type && "insert" != e.type || !LT(e) || (o = OT(e.position.parent, t) || o);
        return o;
      }(e, t));
    }
    function NT(t, e) {
      let n = !1;
      for (const o of t.getChildren()) o.is("element", "tableRow") && (n = PT(o, e) || n);
      return n;
    }
    function PT(t, e) {
      let n = !1;
      for (const o of t.getChildren()) n = OT(o, e) || n;
      return n;
    }
    function OT(t, e) {
      if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
      const n = Array.from(t.getChildren()).filter(t => t.is("$text"));
      for (const t of n) e.wrap(e.createRangeOn(t), "paragraph");
      return !!n.length;
    }
    function LT(t) {
      return !!t.position.parent.is("element", "tableCell") && ("insert" == t.type && "$text" == t.name || "remove" == t.type);
    }
    function zT(t, e) {
      if (!t.is("element", "paragraph")) return !1;
      const n = e.toViewElement(t);
      return !!n && KI(t) !== n.is("element", "span");
    }
    var RT = n(8137),
      jT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(RT.A, jT);
    RT.A.locals;
    class FT extends Br {
      constructor(t) {
        super(t), this._additionalSlots = [];
      }
      static get pluginName() {
        return "TableEditing";
      }
      static get requires() {
        return [kT];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = e.schema,
          o = t.conversion,
          i = t.plugins.get(kT);
        n.register("table", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["headingRows", "headingColumns"]
        }), n.register("tableRow", {
          allowIn: "table",
          isLimit: !0
        }), n.register("tableCell", {
          allowContentOf: "$container",
          allowIn: "tableRow",
          allowAttributes: ["colspan", "rowspan"],
          isLimit: !0,
          isSelectable: !0
        }), o.for("upcast").add(t => {
          t.on("element:figure", (t, e, n) => {
            if (!n.consumable.test(e.viewItem, {
              name: !0,
              classes: "table"
            })) return;
            const o = function (t) {
              for (const e of t.getChildren()) if (e.is("element", "table")) return e;
            }(e.viewItem);
            if (!o || !n.consumable.test(o, {
              name: !0
            })) return;
            n.consumable.consume(e.viewItem, {
              name: !0,
              classes: "table"
            });
            const i = Wi(n.convertItem(o, e.modelCursor).modelRange.getItems());
            i ? (n.convertChildren(e.viewItem, n.writer.createPositionAt(i, "end")), n.updateConversionResult(i, e)) : n.consumable.revert(e.viewItem, {
              name: !0,
              classes: "table"
            });
          });
        }), o.for("upcast").add(jI()), o.for("editingDowncast").elementToStructure({
          model: {
            name: "table",
            attributes: ["headingRows"]
          },
          view: qI(i, {
            asWidget: !0,
            additionalSlots: this._additionalSlots
          })
        }), o.for("dataDowncast").elementToStructure({
          model: {
            name: "table",
            attributes: ["headingRows"]
          },
          view: qI(i, {
            additionalSlots: this._additionalSlots
          })
        }), o.for("upcast").elementToElement({
          model: "tableRow",
          view: "tr"
        }), o.for("upcast").add(t => {
          t.on("element:tr", (t, e) => {
            e.viewItem.isEmpty && 0 == e.modelCursor.index && t.stop();
          }, {
            priority: "high"
          });
        }), o.for("downcast").elementToElement({
          model: "tableRow",
          view: (t, {
            writer: e
          }) => t.isEmpty ? e.createEmptyElement("tr") : e.createContainerElement("tr")
        }), o.for("upcast").elementToElement({
          model: "tableCell",
          view: "td"
        }), o.for("upcast").elementToElement({
          model: "tableCell",
          view: "th"
        }), o.for("upcast").add(FI("td")), o.for("upcast").add(FI("th")), o.for("editingDowncast").elementToElement({
          model: "tableCell",
          view: GI({
            asWidget: !0
          })
        }), o.for("dataDowncast").elementToElement({
          model: "tableCell",
          view: GI()
        }), o.for("editingDowncast").elementToElement({
          model: "paragraph",
          view: WI({
            asWidget: !0
          }),
          converterPriority: "high"
        }), o.for("dataDowncast").elementToElement({
          model: "paragraph",
          view: WI(),
          converterPriority: "high"
        }), o.for("downcast").attributeToAttribute({
          model: "colspan",
          view: "colspan"
        }), o.for("upcast").attributeToAttribute({
          model: {
            key: "colspan",
            value: VT("colspan")
          },
          view: "colspan"
        }), o.for("downcast").attributeToAttribute({
          model: "rowspan",
          view: "rowspan"
        }), o.for("upcast").attributeToAttribute({
          model: {
            key: "rowspan",
            value: VT("rowspan")
          },
          view: "rowspan"
        }), t.config.define("table.defaultHeadings.rows", 0), t.config.define("table.defaultHeadings.columns", 0), t.commands.add("insertTable", new $I(t)), t.commands.add("insertTableRowAbove", new YI(t, {
          order: "above"
        })), t.commands.add("insertTableRowBelow", new YI(t, {
          order: "below"
        })), t.commands.add("insertTableColumnLeft", new QI(t, {
          order: "left"
        })), t.commands.add("insertTableColumnRight", new QI(t, {
          order: "right"
        })), t.commands.add("removeTableRow", new uT(t)), t.commands.add("removeTableColumn", new hT(t)), t.commands.add("splitTableCellVertically", new ZI(t, {
          direction: "vertically"
        })), t.commands.add("splitTableCellHorizontally", new ZI(t, {
          direction: "horizontally"
        })), t.commands.add("mergeTableCells", new CT(t)), t.commands.add("mergeTableCellRight", new lT(t, {
          direction: "right"
        })), t.commands.add("mergeTableCellLeft", new lT(t, {
          direction: "left"
        })), t.commands.add("mergeTableCellDown", new lT(t, {
          direction: "down"
        })), t.commands.add("mergeTableCellUp", new lT(t, {
          direction: "up"
        })), t.commands.add("setTableColumnHeader", new mT(t)), t.commands.add("setTableRowHeader", new gT(t)), t.commands.add("selectTableRow", new ET(t)), t.commands.add("selectTableColumn", new DT(t)), IT(e), BT(e), this.listenTo(e.document, "change:data", () => {
          !function (t, e) {
            const n = t.document.differ;
            for (const t of n.getChanges()) {
              let n,
                o = !1;
              if ("attribute" == t.type) {
                const e = t.range.start.nodeAfter;
                if (!e || !e.is("element", "table")) continue;
                if ("headingRows" != t.attributeKey && "headingColumns" != t.attributeKey) continue;
                n = e, o = "headingRows" == t.attributeKey;
              } else "tableRow" != t.name && "tableCell" != t.name || (n = t.position.findAncestor("table"), o = "tableRow" == t.name);
              if (!n) continue;
              const i = n.getAttribute("headingRows") || 0,
                r = n.getAttribute("headingColumns") || 0,
                s = new HI(n);
              for (const t of s) {
                const n = t.row < i || t.column < r ? "th" : "td",
                  s = e.mapper.toViewElement(t.cell);
                s && s.is("element") && s.name != n && e.reconvertItem(o ? t.cell.parent : t.cell);
              }
            }
          }(e, t.editing), function (t, e) {
            const n = t.document.differ,
              o = new Set();
            for (const t of n.getChanges()) {
              const e = "attribute" == t.type ? t.range.start.parent : t.position.parent;
              e.is("element", "tableCell") && o.add(e);
            }
            for (const t of o.values()) {
              const n = Array.from(t.getChildren()).filter(t => zT(t, e.mapper));
              for (const t of n) e.reconvertItem(t);
            }
          }(e, t.editing);
        });
      }
      registerAdditionalSlot(t) {
        this._additionalSlots.push(t);
      }
    }
    function VT(t) {
      return e => {
        const n = parseInt(e.getAttribute(t));
        return Number.isNaN(n) || n <= 0 ? null : n;
      };
    }
    var HT = n(5032),
      UT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(HT.A, UT);
    HT.A.locals;
    class qT extends Dr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.items = this._createGridCollection(), this.keystrokes = new $i(), this.focusTracker = new Ki(), this.set("rows", 0), this.set("columns", 0), this.bind("label").to(this, "columns", this, "rows", (t, e) => `${e} × ${t}`), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            on: {
              "mouseover@.ck-insert-table-dropdown-grid-box": e.to("boxover")
            },
            children: this.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-insert-table-dropdown__label"],
              "aria-hidden": !0
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(t => {
              t.preventDefault();
            }),
            click: e.to(() => {
              this.fire("execute");
            })
          }
        }), this.on("boxover", (t, e) => {
          const {
            row: n,
            column: o
          } = e.target.dataset;
          this.items.get(10 * (parseInt(n, 10) - 1) + (parseInt(o, 10) - 1)).focus();
        }), this.focusTracker.on("change:focusedElement", (t, e, n) => {
          if (!n) return;
          const {
            row: o,
            column: i
          } = n.dataset;
          this.set({
            rows: parseInt(o),
            columns: parseInt(i)
          });
        }), this.on("change:columns", () => this._highlightGridBoxes()), this.on("change:rows", () => this._highlightGridBoxes());
      }
      render() {
        super.render(), Sr({
          keystrokeHandler: this.keystrokes,
          focusTracker: this.focusTracker,
          gridItems: this.items,
          numberOfColumns: 10,
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
        for (const t of this.items) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element);
      }
      reset() {
        this.set({
          rows: 1,
          columns: 1
        });
      }
      focus() {
        this.items.get(0).focus();
      }
      focusLast() {
        this.items.get(0).focus();
      }
      _highlightGridBoxes() {
        const t = this.rows,
          e = this.columns;
        this.items.map((n, o) => {
          const i = Math.floor(o / 10) < t && o % 10 < e;
          n.set("isOn", i);
        });
      }
      _createGridButton(t, e, n, o) {
        const i = new Sg(t);
        return i.set({
          label: o,
          class: "ck-insert-table-dropdown-grid-box"
        }), i.extendTemplate({
          attributes: {
            "data-row": e,
            "data-column": n
          }
        }), i;
      }
      _createGridCollection() {
        const t = [];
        for (let e = 0; e < 100; e++) {
          const n = Math.floor(e / 10),
            o = e % 10,
            i = `${n + 1} × ${o + 1}`;
          t.push(this._createGridButton(this.locale, n + 1, o + 1, i));
        }
        return this.createCollection(t);
      }
    }
    class GT extends Br {
      static get pluginName() {
        return "TableUI";
      }
      init() {
        const t = this.editor,
          e = this.editor.t,
          n = "ltr" === t.locale.contentLanguageDirection;
        t.ui.componentFactory.add("insertTable", n => {
          const o = t.commands.get("insertTable"),
            i = zm(n);
          let r;
          return i.bind("isEnabled").to(o), i.buttonView.set({
            icon: gg.table,
            label: e("Insert table"),
            tooltip: !0
          }), i.on("change:isOpen", () => {
            r || (r = new qT(n), i.panelView.children.add(r), r.delegate("execute").to(i), i.on("execute", () => {
              t.execute("insertTable", {
                rows: r.rows,
                columns: r.columns
              }), t.editing.view.focus();
            }));
          }), i;
        }), t.ui.componentFactory.add("menuBar:insertTable", n => {
          const o = t.commands.get("insertTable"),
            i = new Gk(n),
            r = new qT(n);
          return r.delegate("execute").to(i), i.on("change:isOpen", (t, e, n) => {
            n || r.reset();
          }), r.on("execute", () => {
            t.execute("insertTable", {
              rows: r.rows,
              columns: r.columns
            }), t.editing.view.focus();
          }), i.buttonView.set({
            label: e("Table"),
            icon: gg.table
          }), i.panelView.children.add(r), i.bind("isEnabled").to(o), i;
        }), t.ui.componentFactory.add("tableColumn", t => {
          const o = [{
            type: "switchbutton",
            model: {
              commandName: "setTableColumnHeader",
              label: e("Header column"),
              bindIsOn: !0
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: n ? "insertTableColumnLeft" : "insertTableColumnRight",
              label: e("Insert column left")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "insertTableColumnRight" : "insertTableColumnLeft",
              label: e("Insert column right")
            }
          }, {
            type: "button",
            model: {
              commandName: "removeTableColumn",
              label: e("Delete column")
            }
          }, {
            type: "button",
            model: {
              commandName: "selectTableColumn",
              label: e("Select column")
            }
          }];
          return this._prepareDropdown(e("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', o, t);
        }), t.ui.componentFactory.add("tableRow", t => {
          const n = [{
            type: "switchbutton",
            model: {
              commandName: "setTableRowHeader",
              label: e("Header row"),
              bindIsOn: !0
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: "insertTableRowAbove",
              label: e("Insert row above")
            }
          }, {
            type: "button",
            model: {
              commandName: "insertTableRowBelow",
              label: e("Insert row below")
            }
          }, {
            type: "button",
            model: {
              commandName: "removeTableRow",
              label: e("Delete row")
            }
          }, {
            type: "button",
            model: {
              commandName: "selectTableRow",
              label: e("Select row")
            }
          }];
          return this._prepareDropdown(e("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', n, t);
        }), t.ui.componentFactory.add("mergeTableCells", t => {
          const o = [{
            type: "button",
            model: {
              commandName: "mergeTableCellUp",
              label: e("Merge cell up")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "mergeTableCellRight" : "mergeTableCellLeft",
              label: e("Merge cell right")
            }
          }, {
            type: "button",
            model: {
              commandName: "mergeTableCellDown",
              label: e("Merge cell down")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "mergeTableCellLeft" : "mergeTableCellRight",
              label: e("Merge cell left")
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: "splitTableCellVertically",
              label: e("Split cell vertically")
            }
          }, {
            type: "button",
            model: {
              commandName: "splitTableCellHorizontally",
              label: e("Split cell horizontally")
            }
          }];
          return this._prepareMergeSplitButtonDropdown(e("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', o, t);
        });
      }
      _prepareDropdown(t, e, n, o) {
        const i = this.editor,
          r = zm(o),
          s = this._fillDropdownWithListOptions(r, n);
        return r.buttonView.set({
          label: t,
          icon: e,
          tooltip: !0
        }), r.bind("isEnabled").toMany(s, "isEnabled", (...t) => t.some(t => t)), this.listenTo(r, "execute", t => {
          i.execute(t.source.commandName), t.source instanceof Pg || i.editing.view.focus();
        }), r;
      }
      _prepareMergeSplitButtonDropdown(t, e, n, o) {
        const i = this.editor,
          r = zm(o, Bm),
          s = "mergeTableCells",
          a = i.commands.get(s),
          c = this._fillDropdownWithListOptions(r, n);
        return r.buttonView.set({
          label: t,
          icon: e,
          tooltip: !0,
          isEnabled: !0
        }), r.bind("isEnabled").toMany([a, ...c], "isEnabled", (...t) => t.some(t => t)), this.listenTo(r.buttonView, "execute", () => {
          i.execute(s), i.editing.view.focus();
        }), this.listenTo(r, "execute", t => {
          i.execute(t.source.commandName), i.editing.view.focus();
        }), r;
      }
      _fillDropdownWithListOptions(t, e) {
        const n = this.editor,
          o = [],
          i = new Gi();
        for (const t of e) WT(t, n, o, i);
        return Fm(t, i), o;
      }
    }
    function WT(t, e, n, o) {
      if ("button" === t.type || "switchbutton" === t.type) {
        const o = t.model = new Ef(t.model),
          {
            commandName: i,
            bindIsOn: r
          } = t.model,
          s = e.commands.get(i);
        n.push(s), o.set({
          commandName: i
        }), o.bind("isEnabled").to(s), r && o.bind("isOn").to(s, "value"), o.set({
          withText: !0
        });
      }
      o.add(t);
    }
    var KT = n(8423),
      $T = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(KT.A, $T);
    KT.A.locals;
    class YT extends Br {
      static get pluginName() {
        return "TableSelection";
      }
      static get requires() {
        return [kT, kT];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view;
        this.listenTo(e, "deleteContent", (t, e) => this._handleDeleteContent(t, e), {
          priority: "high"
        }), this.listenTo(n.document, "insertText", (t, e) => this._handleInsertTextEvent(t, e), {
          priority: "high"
        }), this._defineSelectionConverter(), this._enablePluginDisabling();
      }
      getSelectedTableCells() {
        const t = this.editor.plugins.get(kT),
          e = this.editor.model.document.selection,
          n = t.getSelectedTableCells(e);
        return 0 == n.length ? null : n;
      }
      getSelectionAsFragment() {
        const t = this.editor.plugins.get(kT),
          e = this.getSelectedTableCells();
        return e ? this.editor.model.change(n => {
          const o = n.createDocumentFragment(),
            {
              first: i,
              last: r
            } = t.getColumnIndexes(e),
            {
              first: s,
              last: a
            } = t.getRowIndexes(e),
            c = e[0].findAncestor("table");
          let l = a,
            d = r;
          if (t.isSelectionRectangular(e)) {
            const t = {
              firstColumn: i,
              lastColumn: r,
              firstRow: s,
              lastRow: a
            };
            l = aT(c, t), d = cT(c, t);
          }
          const u = JI(c, {
            startRow: s,
            startColumn: i,
            endRow: l,
            endColumn: d
          }, n);
          return n.insert(u, o, 0), o;
        }) : null;
      }
      setCellSelection(t, e) {
        const n = this._getCellsToSelect(t, e);
        this.editor.model.change(t => {
          t.setSelection(n.cells.map(e => t.createRangeOn(e)), {
            backward: n.backward
          });
        });
      }
      getFocusCell() {
        const t = [...this.editor.model.document.selection.getRanges()].pop().getContainedElement();
        return t && t.is("element", "tableCell") ? t : null;
      }
      getAnchorCell() {
        const t = Wi(this.editor.model.document.selection.getRanges()).getContainedElement();
        return t && t.is("element", "tableCell") ? t : null;
      }
      _defineSelectionConverter() {
        const t = this.editor,
          e = new Set();
        t.conversion.for("editingDowncast").add(t => t.on("selection", (t, n, o) => {
          const i = o.writer;
          !function (t) {
            for (const n of e) t.removeClass("ck-editor__editable_selected", n);
            e.clear();
          }(i);
          const r = this.getSelectedTableCells();
          if (!r) return;
          for (const t of r) {
            const n = o.mapper.toViewElement(t);
            i.addClass("ck-editor__editable_selected", n), e.add(n);
          }
          const s = o.mapper.toViewElement(r[r.length - 1]);
          i.setSelection(s, 0);
        }, {
          priority: "lowest"
        }));
      }
      _enablePluginDisabling() {
        const t = this.editor;
        this.on("change:isEnabled", () => {
          if (!this.isEnabled) {
            const e = this.getSelectedTableCells();
            if (!e) return;
            t.model.change(n => {
              const o = n.createPositionAt(e[0], 0),
                i = t.model.schema.getNearestSelectionRange(o);
              n.setSelection(i);
            });
          }
        });
      }
      _handleDeleteContent(t, e) {
        const n = this.editor.plugins.get(kT),
          o = e[0],
          i = e[1],
          r = this.editor.model,
          s = !i || "backward" == i.direction,
          a = n.getSelectedTableCells(o);
        a.length && (t.stop(), r.change(t => {
          const e = a[s ? a.length - 1 : 0];
          r.change(t => {
            for (const e of a) r.deleteContent(t.createSelection(e, "in"));
          });
          const n = r.schema.getNearestSelectionRange(t.createPositionAt(e, 0));
          o.is("documentSelection") ? t.setSelection(n) : o.setTo(n);
        }));
      }
      _handleInsertTextEvent(t, e) {
        const n = this.editor,
          o = this.getSelectedTableCells();
        if (!o) return;
        const i = n.editing.view,
          r = n.editing.mapper,
          s = o.map(t => i.createRangeOn(r.toViewElement(t)));
        e.selection = i.createSelection(s);
      }
      _getCellsToSelect(t, e) {
        const n = this.editor.plugins.get("TableUtils"),
          o = n.getCellLocation(t),
          i = n.getCellLocation(e),
          r = Math.min(o.row, i.row),
          s = Math.max(o.row, i.row),
          a = Math.min(o.column, i.column),
          c = Math.max(o.column, i.column),
          l = new Array(s - r + 1).fill(null).map(() => []),
          d = {
            startRow: r,
            endRow: s,
            startColumn: a,
            endColumn: c
          };
        for (const {
          row: e,
          cell: n
        } of new HI(t.findAncestor("table"), d)) l[e - r].push(n);
        const u = i.row < o.row,
          h = i.column < o.column;
        return u && l.reverse(), h && l.forEach(t => t.reverse()), {
          cells: l.flat(),
          backward: u || h
        };
      }
    }
    class QT extends Br {
      static get pluginName() {
        return "TableClipboard";
      }
      static get requires() {
        return [Zb, Jb, YT, kT];
      }
      init() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "copy", (t, e) => this._onCopyCut(t, e)), this.listenTo(e, "cut", (t, e) => this._onCopyCut(t, e)), this.listenTo(t.model, "insertContent", (t, [e, n]) => this._onInsertContent(t, e, n), {
          priority: "high"
        }), this.decorate("_replaceTableSlotCell");
      }
      _onCopyCut(t, e) {
        const n = this.editor.editing.view,
          o = this.editor.plugins.get(YT),
          i = this.editor.plugins.get(Zb);
        o.getSelectedTableCells() && ("cut" != t.name || this.editor.model.canEditAt(this.editor.model.document.selection)) && (e.preventDefault(), t.stop(), this.editor.model.enqueueChange({
          isUndoable: "cut" === t.name
        }, () => {
          const r = i._copySelectedFragmentWithMarkers(t.name, this.editor.model.document.selection, () => o.getSelectionAsFragment());
          n.document.fire("clipboardOutput", {
            dataTransfer: e.dataTransfer,
            content: this.editor.data.toView(r),
            method: t.name
          });
        }));
      }
      _onInsertContent(t, e, n) {
        if (n && !n.is("documentSelection")) return;
        const o = this.editor.model,
          i = this.editor.plugins.get(kT),
          r = this.editor.plugins.get(Zb),
          s = this.getTableIfOnlyTableInContent(e, o);
        if (!s) return;
        const a = i.getSelectionAffectedTableCells(o.document.selection);
        a.length ? (t.stop(), e.is("documentFragment") ? r._pasteMarkersIntoTransformedElement(e.markers, t => this._replaceSelectedCells(s, a, t)) : this.editor.model.change(t => {
          this._replaceSelectedCells(s, a, t);
        })) : sT(s, i);
      }
      _replaceSelectedCells(t, e, n) {
        const o = this.editor.plugins.get(kT),
          i = {
            width: o.getColumns(t),
            height: o.getRows(t)
          },
          r = function (t, e, n, o) {
            const i = t[0].findAncestor("table"),
              r = o.getColumnIndexes(t),
              s = o.getRowIndexes(t),
              a = {
                firstColumn: r.first,
                lastColumn: r.last,
                firstRow: s.first,
                lastRow: s.last
              },
              c = 1 === t.length;
            c && (a.lastRow += e.height - 1, a.lastColumn += e.width - 1, function (t, e, n, o) {
              const i = o.getColumns(t),
                r = o.getRows(t);
              n > i && o.insertColumns(t, {
                at: i,
                columns: n - i
              });
              e > r && o.insertRows(t, {
                at: r,
                rows: e - r
              });
            }(i, a.lastRow + 1, a.lastColumn + 1, o));
            c || !o.isSelectionRectangular(t) ? function (t, e, n) {
              const {
                  firstRow: o,
                  lastRow: i,
                  firstColumn: r,
                  lastColumn: s
                } = e,
                a = {
                  first: o,
                  last: i
                },
                c = {
                  first: r,
                  last: s
                };
              JT(t, r, a, n), JT(t, s + 1, a, n), ZT(t, o, c, n), ZT(t, i + 1, c, n, o);
            }(i, a, n) : (a.lastRow = aT(i, a), a.lastColumn = cT(i, a));
            return a;
          }(e, i, n, o),
          s = r.lastRow - r.firstRow + 1,
          a = r.lastColumn - r.firstColumn + 1;
        t = JI(t, {
          startRow: 0,
          startColumn: 0,
          endRow: Math.min(s, i.height) - 1,
          endColumn: Math.min(a, i.width) - 1
        }, n);
        const c = e[0].findAncestor("table"),
          l = this._replaceSelectedCellsWithPasted(t, i, c, r, n);
        if (this.editor.plugins.get("TableSelection").isEnabled) {
          const t = o.sortRanges(l.map(t => n.createRangeOn(t)));
          n.setSelection(t);
        } else n.setSelection(l[0], 0);
        return c;
      }
      _replaceSelectedCellsWithPasted(t, e, n, o, i) {
        const {
            width: r,
            height: s
          } = e,
          a = function (t, e, n) {
            const o = new Array(n).fill(null).map(() => new Array(e).fill(null));
            for (const {
              column: e,
              row: n,
              cell: i
            } of new HI(t)) o[n][e] = i;
            return o;
          }(t, r, s),
          c = [...new HI(n, {
            startRow: o.firstRow,
            endRow: o.lastRow,
            startColumn: o.firstColumn,
            endColumn: o.lastColumn,
            includeAllSlots: !0
          })],
          l = [];
        let d;
        for (const t of c) {
          const {
            row: e,
            column: n
          } = t;
          n === o.firstColumn && (d = t.getPositionBefore());
          const c = e - o.firstRow,
            u = n - o.firstColumn,
            h = a[c % s][u % r],
            g = h ? i.cloneElement(h) : null,
            m = this._replaceTableSlotCell(t, g, d, i);
          m && (oT(m, e, n, o.lastRow, o.lastColumn, i), l.push(m), d = i.createPositionAfter(m));
        }
        const u = parseInt(n.getAttribute("headingRows") || "0"),
          h = parseInt(n.getAttribute("headingColumns") || "0"),
          g = o.firstRow < u && u <= o.lastRow,
          m = o.firstColumn < h && h <= o.lastColumn;
        if (g) {
          const t = ZT(n, u, {
            first: o.firstColumn,
            last: o.lastColumn
          }, i, o.firstRow);
          l.push(...t);
        }
        if (m) {
          const t = JT(n, h, {
            first: o.firstRow,
            last: o.lastRow
          }, i);
          l.push(...t);
        }
        return l;
      }
      _replaceTableSlotCell(t, e, n, o) {
        const {
          cell: i,
          isAnchor: r
        } = t;
        return r && o.remove(i), e ? (o.insert(e, n), e) : null;
      }
      getTableIfOnlyTableInContent(t, e) {
        if (!t.is("documentFragment") && !t.is("element")) return null;
        if (t.is("element", "table")) return t;
        if (1 == t.childCount && t.getChild(0).is("element", "table")) return t.getChild(0);
        const n = e.createRangeIn(t);
        for (const t of n.getItems()) if (t.is("element", "table")) {
          const o = e.createRange(n.start, e.createPositionBefore(t));
          if (e.hasContent(o, {
            ignoreWhitespaces: !0
          })) return null;
          const i = e.createRange(e.createPositionAfter(t), n.end);
          return e.hasContent(i, {
            ignoreWhitespaces: !0
          }) ? null : t;
        }
        return null;
      }
    }
    function ZT(t, e, n, o, i = 0) {
      if (e < 1) return;
      return XI(t, e, i).filter(({
        column: t,
        cellWidth: e
      }) => XT(t, e, n)).map(({
        cell: t
      }) => tT(t, e, o));
    }
    function JT(t, e, n, o) {
      if (e < 1) return;
      return eT(t, e).filter(({
        row: t,
        cellHeight: e
      }) => XT(t, e, n)).map(({
        cell: t,
        column: n
      }) => nT(t, n, e, o));
    }
    function XT(t, e, n) {
      const o = t + e - 1,
        {
          first: i,
          last: r
        } = n;
      return t >= i && t <= r || t < i && o >= i;
    }
    class tM extends Br {
      static get pluginName() {
        return "TableKeyboard";
      }
      static get requires() {
        return [YT, kT];
      }
      init() {
        const t = this.editor,
          e = t.editing.view.document,
          n = t.t;
        this.listenTo(e, "arrowKey", (...t) => this._onArrowKey(...t), {
          context: "table"
        }), this.listenTo(e, "tab", (...t) => this._handleTabOnSelectedTable(...t), {
          context: "figure"
        }), this.listenTo(e, "tab", (...t) => this._handleTab(...t), {
          context: ["th", "td"]
        }), t.accessibility.addKeystrokeInfoGroup({
          id: "table",
          label: n("Keystrokes that can be used in a table cell"),
          keystrokes: [{
            label: n("Move the selection to the next cell"),
            keystroke: "Tab"
          }, {
            label: n("Move the selection to the previous cell"),
            keystroke: "Shift+Tab"
          }, {
            label: n("Insert a new table row (when in the last cell of a table)"),
            keystroke: "Tab"
          }, {
            label: n("Navigate through the table"),
            keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
          }]
        });
      }
      _handleTabOnSelectedTable(t, e) {
        const n = this.editor,
          o = n.model.document.selection.getSelectedElement();
        o && o.is("element", "table") && (e.preventDefault(), e.stopPropagation(), t.stop(), n.model.change(t => {
          t.setSelection(t.createRangeIn(o.getChild(0).getChild(0)));
        }));
      }
      _handleTab(t, e) {
        const n = this.editor,
          o = this.editor.plugins.get(kT),
          i = this.editor.plugins.get("TableSelection"),
          r = n.model.document.selection,
          s = !e.shiftKey;
        let a = o.getTableCellsContainingSelection(r)[0];
        if (a || (a = i.getFocusCell()), !a) return;
        e.preventDefault(), e.stopPropagation(), t.stop();
        const c = a.parent,
          l = c.parent,
          d = l.getChildIndex(c),
          u = c.getChildIndex(a),
          h = 0 === u;
        if (!s && h && 0 === d) return void n.model.change(t => {
          t.setSelection(t.createRangeOn(l));
        });
        const g = u === c.childCount - 1,
          m = d === o.getRows(l) - 1;
        if (s && m && g && (n.execute("insertTableRowBelow"), d === o.getRows(l) - 1)) return void n.model.change(t => {
          t.setSelection(t.createRangeOn(l));
        });
        let p;
        if (s && g) {
          const t = l.getChild(d + 1);
          p = t.getChild(0);
        } else if (!s && h) {
          const t = l.getChild(d - 1);
          p = t.getChild(t.childCount - 1);
        } else p = c.getChild(u + (s ? 1 : -1));
        n.model.change(t => {
          t.setSelection(t.createRangeIn(p));
        });
      }
      _onArrowKey(t, e) {
        const n = this.editor,
          o = wi(e.keyCode, n.locale.contentLanguageDirection);
        this._handleArrowKeys(o, e.shiftKey) && (e.preventDefault(), e.stopPropagation(), t.stop());
      }
      _handleArrowKeys(t, e) {
        const n = this.editor.plugins.get(kT),
          o = this.editor.plugins.get("TableSelection"),
          i = this.editor.model,
          r = i.document.selection,
          s = ["right", "down"].includes(t),
          a = n.getSelectedTableCells(r);
        if (a.length) {
          let n;
          return n = e ? o.getFocusCell() : s ? a[a.length - 1] : a[0], this._navigateFromCellInDirection(n, t, e), !0;
        }
        const c = r.focus.findAncestor("tableCell");
        if (!c) return !1;
        if (!r.isCollapsed) if (e) {
          if (r.isBackward == s && !r.containsEntireContent(c)) return !1;
        } else {
          const t = r.getSelectedElement();
          if (!t || !i.schema.isObject(t)) return !1;
        }
        return !!this._isSelectionAtCellEdge(r, c, s) && (this._navigateFromCellInDirection(c, t, e), !0);
      }
      _isSelectionAtCellEdge(t, e, n) {
        const o = this.editor.model,
          i = this.editor.model.schema,
          r = n ? t.getLastPosition() : t.getFirstPosition();
        if (!i.getLimitElement(r).is("element", "tableCell")) {
          return o.createPositionAt(e, n ? "end" : 0).isTouching(r);
        }
        const s = o.createSelection(r);
        return o.modifySelection(s, {
          direction: n ? "forward" : "backward"
        }), r.isEqual(s.focus);
      }
      _navigateFromCellInDirection(t, e, n = !1) {
        const o = this.editor.model,
          i = t.findAncestor("table"),
          r = [...new HI(i, {
            includeAllSlots: !0
          })],
          {
            row: s,
            column: a
          } = r[r.length - 1],
          c = r.find(({
            cell: e
          }) => e == t);
        let {
          row: l,
          column: d
        } = c;
        switch (e) {
          case "left":
            d--;
            break;
          case "up":
            l--;
            break;
          case "right":
            d += c.cellWidth;
            break;
          case "down":
            l += c.cellHeight;
        }
        if (l < 0 || l > s || d < 0 && l <= 0 || d > a && l >= s) return void o.change(t => {
          t.setSelection(t.createRangeOn(i));
        });
        d < 0 ? (d = n ? 0 : a, l--) : d > a && (d = n ? a : 0, l++);
        const u = r.find(t => t.row == l && t.column == d).cell,
          h = ["right", "down"].includes(e),
          g = this.editor.plugins.get("TableSelection");
        if (n && g.isEnabled) {
          const e = g.getAnchorCell() || t;
          g.setCellSelection(e, u);
        } else {
          const t = o.createPositionAt(u, h ? 0 : "end");
          o.change(e => {
            e.setSelection(t);
          });
        }
      }
    }
    class eM extends rc {
      constructor() {
        super(...arguments), this.domEventType = ["mousemove", "mouseleave"];
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
    }
    class nM extends Br {
      static get pluginName() {
        return "TableMouse";
      }
      static get requires() {
        return [YT, kT];
      }
      init() {
        this.editor.editing.view.addObserver(eM), this._enableShiftClickSelection(), this._enableMouseDragSelection();
      }
      _enableShiftClickSelection() {
        const t = this.editor,
          e = t.plugins.get(kT);
        let n = !1;
        const o = t.plugins.get(YT);
        this.listenTo(t.editing.view.document, "mousedown", (i, r) => {
          const s = t.model.document.selection;
          if (!this.isEnabled || !o.isEnabled) return;
          if (!r.domEvent.shiftKey) return;
          const a = o.getAnchorCell() || e.getTableCellsContainingSelection(s)[0];
          if (!a) return;
          const c = this._getModelTableCellFromDomEvent(r);
          c && oM(a, c) && (n = !0, o.setCellSelection(a, c), r.preventDefault());
        }), this.listenTo(t.editing.view.document, "mouseup", () => {
          n = !1;
        }), this.listenTo(t.editing.view.document, "selectionChange", t => {
          n && t.stop();
        }, {
          priority: "highest"
        });
      }
      _enableMouseDragSelection() {
        const t = this.editor;
        let e,
          n,
          o = !1,
          i = !1;
        const r = t.plugins.get(YT);
        this.listenTo(t.editing.view.document, "mousedown", (t, n) => {
          this.isEnabled && r.isEnabled && (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey || (e = this._getModelTableCellFromDomEvent(n)));
        }), this.listenTo(t.editing.view.document, "mousemove", (t, s) => {
          if (!s.domEvent.buttons) return;
          if (!e) return;
          const a = this._getModelTableCellFromDomEvent(s);
          a && oM(e, a) && (n = a, o || n == e || (o = !0)), o && (i = !0, r.setCellSelection(e, n), s.preventDefault());
        }), this.listenTo(t.editing.view.document, "mouseup", () => {
          o = !1, i = !1, e = null, n = null;
        }), this.listenTo(t.editing.view.document, "selectionChange", t => {
          i && t.stop();
        }, {
          priority: "highest"
        });
      }
      _getModelTableCellFromDomEvent(t) {
        const e = t.target,
          n = this.editor.editing.view.createPositionAt(e, 0);
        return this.editor.editing.mapper.toModelPosition(n).parent.findAncestor("tableCell", {
          includeSelf: !0
        });
      }
    }
    function oM(t, e) {
      return t.parent.parent == e.parent.parent;
    }
    var iM = n(2329),
      rM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(iM.A, rM);
    iM.A.locals;
    function sM(t) {
      const e = t.getSelectedElement();
      return e && cM(e) ? e : null;
    }
    function aM(t) {
      const e = t.getFirstPosition();
      if (!e) return null;
      let n = e.parent;
      for (; n;) {
        if (n.is("element") && cM(n)) return n;
        n = n.parent;
      }
      return null;
    }
    function cM(t) {
      return !!t.getCustomProperty("table") && Yw(t);
    }
    var lM = n(5506),
      dM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(lM.A, dM);
    lM.A.locals;
    Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    var uM = n(2655),
      hM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(uM.A, hM);
    uM.A.locals;
    var gM = n(4043),
      mM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(gM.A, mM);
    gM.A.locals;
    var pM = n(1623),
      fM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(pM.A, fM);
    pM.A.locals;
    var kM = n(8986),
      bM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(kM.A, bM);
    kM.A.locals;
    const wM = Op.defaultPositions;
    wM.northArrowSouth, wM.northArrowSouthWest, wM.northArrowSouthEast, wM.southArrowNorth, wM.southArrowNorthWest, wM.southArrowNorthEast, wM.viewportStickyNorth;
    Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
    var AM = n(5562),
      _M = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(AM.A, _M);
    AM.A.locals;
    var CM = n(4143),
      vM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(CM.A, vM);
    CM.A.locals;
    var yM = n(8795),
      xM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    yr()(yM.A, xM);
    yM.A.locals;
    var EM = Object.defineProperty,
      DM = Object.getOwnPropertySymbols,
      IM = Object.prototype.hasOwnProperty,
      TM = Object.prototype.propertyIsEnumerable,
      MM = (t, e, n) => e in t ? EM(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }) : t[e] = n,
      SM = (t, e) => {
        for (var n in e || (e = {})) IM.call(e, n) && MM(t, n, e[n]);
        if (DM) for (var n of DM(e)) TM.call(e, n) && MM(t, n, e[n]);
        return t;
      };
    const BM = {
        autoRefresh: !0
      },
      NM = 36e5;
    class PM extends G() {
      constructor(t, e = {}) {
        if (super(), !t) throw new w("token-missing-token-url", this);
        e.initValue && this._validateTokenValue(e.initValue), this.set("value", e.initValue), this._refresh = "function" == typeof t ? t : () => {
          return e = t, new Promise((t, n) => {
            const o = new XMLHttpRequest();
            o.open("GET", e), o.addEventListener("load", () => {
              const e = o.status,
                i = o.response;
              return e < 200 || e > 299 ? n(new w("token-cannot-download-new-token", null)) : t(i);
            }), o.addEventListener("error", () => n(new Error("Network Error"))), o.addEventListener("abort", () => n(new Error("Abort"))), o.send();
          });
          var e;
        }, this._options = SM(SM({}, BM), e);
      }
      init() {
        return new Promise((t, e) => {
          this.value ? (this._options.autoRefresh && this._registerRefreshTokenTimeout(), t(this)) : this.refreshToken().then(t).catch(e);
        });
      }
      refreshToken() {
        return this._refresh().then(t => (this._validateTokenValue(t), this.set("value", t), this._options.autoRefresh && this._registerRefreshTokenTimeout(), this));
      }
      destroy() {
        clearTimeout(this._tokenRefreshTimeout);
      }
      _validateTokenValue(t) {
        const e = "string" == typeof t,
          n = !/^".*"$/.test(t),
          o = e && 3 === t.split(".").length;
        if (!n || !o) throw new w("token-not-in-jwt-format", this);
      }
      _registerRefreshTokenTimeout() {
        const t = this._getTokenRefreshTimeoutTime();
        clearTimeout(this._tokenRefreshTimeout), this._tokenRefreshTimeout = setTimeout(() => {
          this.refreshToken();
        }, t);
      }
      _getTokenRefreshTimeoutTime() {
        try {
          const [, t] = this.value.split("."),
            {
              exp: e
            } = JSON.parse(atob(t));
          if (!e) return NM;
          return Math.floor((1e3 * e - Date.now()) / 2);
        } catch (t) {
          return NM;
        }
      }
      static create(t, e = {}) {
        return new PM(t, e).init();
      }
    }
    const OM = /^data:(\S*?);base64,/;
    class LM extends M() {
      constructor(t, e, n) {
        if (super(), !t) throw new w("fileuploader-missing-file", null);
        if (!e) throw new w("fileuploader-missing-token", null);
        if (!n) throw new w("fileuploader-missing-api-address", null);
        this.file = function (t) {
          if ("string" != typeof t) return !1;
          const e = t.match(OM);
          return !(!e || !e.length);
        }(t) ? function (t, e = 512) {
          try {
            const n = t.match(OM)[1],
              o = atob(t.replace(OM, "")),
              i = [];
            for (let t = 0; t < o.length; t += e) {
              const n = o.slice(t, t + e),
                r = new Array(n.length);
              for (let t = 0; t < n.length; t++) r[t] = n.charCodeAt(t);
              i.push(new Uint8Array(r));
            }
            return new Blob(i, {
              type: n
            });
          } catch (t) {
            throw new w("fileuploader-decoding-image-data-error", null);
          }
        }(t) : t, this._token = e, this._apiAddress = n;
      }
      onProgress(t) {
        return this.on("progress", (e, n) => t(n)), this;
      }
      onError(t) {
        return this.once("error", (e, n) => t(n)), this;
      }
      abort() {
        this.xhr.abort();
      }
      send() {
        return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
      }
      _prepareRequest() {
        const t = new XMLHttpRequest();
        t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
      }
      _attachXHRListeners() {
        const t = this.xhr,
          e = t => () => this.fire("error", t);
        t.addEventListener("error", e("Network Error")), t.addEventListener("abort", e("Abort")), t.upload && t.upload.addEventListener("progress", t => {
          t.lengthComputable && this.fire("progress", {
            total: t.total,
            uploaded: t.loaded
          });
        }), t.addEventListener("load", () => {
          const e = t.status,
            n = t.response;
          if (e < 200 || e > 299) return this.fire("error", n.message || n.error);
        });
      }
      _sendRequest() {
        const t = new FormData(),
          e = this.xhr;
        return t.append("file", this.file), new Promise((n, o) => {
          e.addEventListener("load", () => {
            const t = e.status,
              i = e.response;
            return t < 200 || t > 299 ? i.message ? o(new w("fileuploader-uploading-data-failed", this, {
              message: i.message
            })) : o(i.error) : n(i);
          }), e.addEventListener("error", () => o(new Error("Network Error"))), e.addEventListener("abort", () => o(new Error("Abort"))), e.send(t);
        });
      }
    }
    class zM {
      constructor(t, e) {
        if (!t) throw new w("uploadgateway-missing-token", null);
        if (!e) throw new w("uploadgateway-missing-api-address", null);
        this._token = t, this._apiAddress = e;
      }
      upload(t) {
        return new LM(t, this._token, this._apiAddress);
      }
    }
    class RM extends Hr {
      static get pluginName() {
        return "CloudServicesCore";
      }
      createToken(t, e) {
        return new PM(t, e);
      }
      createUploadGateway(t, e) {
        return new zM(t, e);
      }
    }
    var jM = (t, e, n) => new Promise((o, i) => {
      var r = t => {
          try {
            a(n.next(t));
          } catch (t) {
            i(t);
          }
        },
        s = t => {
          try {
            a(n.throw(t));
          } catch (t) {
            i(t);
          }
        },
        a = t => t.done ? o(t.value) : Promise.resolve(t.value).then(r, s);
      a((n = n.apply(t, e)).next());
    });
    class FM extends Cb {}
    FM.builtinPlugins = [class extends Br {
      static get requires() {
        return [Cg, KA, zw, XA, Vw, gw, h_];
      }
      static get pluginName() {
        return "Essentials";
      }
    }, class extends Br {
      static get requires() {
        return [m_];
      }
      static get pluginName() {
        return "CKFinderUploadAdapter";
      }
      init() {
        const t = this.editor.config.get("ckfinder.uploadUrl");
        t && (this.editor.plugins.get(m_).createUploadAdapter = e => new w_(e, t, this.editor.t));
      }
    }, class extends Br {
      static get requires() {
        return [hw];
      }
      static get pluginName() {
        return "Autoformat";
      }
      afterInit() {
        const t = this.editor,
          e = this.editor.t;
        this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats(), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Revert autoformatting action"),
            keystroke: "Backspace"
          }]
        });
      }
      _addListAutoformats() {
        const t = this.editor.commands;
        t.get("bulletedList") && A_(this.editor, this, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && A_(this.editor, this, /^1[.|)]\s$/, "numberedList"), t.get("todoList") && A_(this.editor, this, /^\[\s?\]\s$/, "todoList"), t.get("checkTodoList") && A_(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
          this.editor.execute("todoList"), this.editor.execute("checkTodoList");
        });
      }
      _addBasicStylesAutoformats() {
        const t = this.editor.commands;
        if (t.get("bold")) {
          const t = v_(this.editor, "bold");
          __(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t), __(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t);
        }
        if (t.get("italic")) {
          const t = v_(this.editor, "italic");
          __(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t), __(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t);
        }
        if (t.get("code")) {
          const t = v_(this.editor, "code");
          __(this.editor, this, /(`)([^`]+)(`)$/g, t);
        }
        if (t.get("strikethrough")) {
          const t = v_(this.editor, "strikethrough");
          __(this.editor, this, /(~~)([^~]+)(~~)$/g, t);
        }
      }
      _addHeadingAutoformats() {
        const t = this.editor.commands.get("heading");
        t && t.modelElements.filter(t => t.match(/^heading[1-6]$/)).forEach(e => {
          const n = e[7],
            o = new RegExp(`^(#{${n}})\\s$`);
          A_(this.editor, this, o, () => {
            if (!t.isEnabled || t.value === e) return !1;
            this.editor.execute("heading", {
              value: e
            });
          });
        });
      }
      _addBlockQuoteAutoformats() {
        this.editor.commands.get("blockQuote") && A_(this.editor, this, /^>\s$/, "blockQuote");
      }
      _addCodeBlockAutoformats() {
        const t = this.editor,
          e = t.model.document.selection;
        t.commands.get("codeBlock") && A_(t, this, /^```$/, () => {
          if (e.getFirstPosition().parent.is("element", "listItem")) return !1;
          this.editor.execute("codeBlock", {
            usePreviousLanguageChoice: !0
          });
        });
      }
      _addHorizontalLineAutoformats() {
        this.editor.commands.get("horizontalLine") && A_(this.editor, this, /^---$/, "horizontalLine");
      }
    }, class extends Br {
      static get requires() {
        return [E_, T_];
      }
      static get pluginName() {
        return "Bold";
      }
    }, class extends Br {
      static get requires() {
        return [N_, O_];
      }
      static get pluginName() {
        return "Italic";
      }
    }, class extends Br {
      static get requires() {
        return [F_, U_];
      }
      static get pluginName() {
        return "BlockQuote";
      }
    }, class extends Br {
      static get pluginName() {
        return "CKBox";
      }
      static get requires() {
        return [EC, q_];
      }
    }, class extends Br {
      static get pluginName() {
        return "CKFinder";
      }
      static get requires() {
        return ["Link", "CKFinderUploadAdapter", LC, NC];
      }
    }, class extends Hr {
      constructor() {
        super(...arguments), this.token = null, this._tokens = new Map();
      }
      static get pluginName() {
        return "CloudServices";
      }
      static get requires() {
        return [RM];
      }
      init() {
        return jM(this, null, function* () {
          const t = this.context.config.get("cloudServices") || {};
          for (const [e, n] of Object.entries(t)) this[e] = n;
          if (!this.tokenUrl) return void (this.token = null);
          const e = this.context.plugins.get("CloudServicesCore");
          this.token = yield e.createToken(this.tokenUrl).init(), this._tokens.set(this.tokenUrl, this.token);
        });
      }
      registerTokenUrl(t) {
        return jM(this, null, function* () {
          if (this._tokens.has(t)) return this.getTokenFor(t);
          const e = this.context.plugins.get("CloudServicesCore"),
            n = yield e.createToken(t).init();
          return this._tokens.set(t, n), n;
        });
      }
      getTokenFor(t) {
        const e = this._tokens.get(t);
        if (!e) throw new w("cloudservices-token-not-registered", this);
        return e;
      }
      destroy() {
        super.destroy();
        for (const t of this._tokens.values()) t.destroy();
      }
    }, class extends Br {
      static get pluginName() {
        return "EasyImage";
      }
      static get requires() {
        return [zC, "ImageUpload"];
      }
      init() {
        const t = this.editor;
        t.plugins.has("ImageBlockEditing") || t.plugins.has("ImageInlineEditing") || A("easy-image-image-feature-missing", t);
      }
    }, class extends Br {
      static get requires() {
        return [KC, QC];
      }
      static get pluginName() {
        return "Heading";
      }
    }, class extends Br {
      static get requires() {
        return [Wv, $v];
      }
      static get pluginName() {
        return "Image";
      }
    }, class extends Br {
      static get requires() {
        return [Zv, Jv];
      }
      static get pluginName() {
        return "ImageCaption";
      }
    }, class extends Br {
      static get requires() {
        return [Xy, nx];
      }
      static get pluginName() {
        return "ImageStyle";
      }
    }, class extends Br {
      static get requires() {
        return [wA, lv];
      }
      static get pluginName() {
        return "ImageToolbar";
      }
      afterInit() {
        const t = this.editor,
          e = t.t,
          n = t.plugins.get(wA),
          o = t.plugins.get("ImageUtils");
        var i;
        n.register("image", {
          ariaLabel: e("Image toolbar"),
          items: (i = t.config.get("image.toolbar") || [], i.map(t => R(t) ? t.name : t)),
          getRelatedElement: t => o.getClosestSelectedImageWidget(t)
        });
      }
    }, class extends Br {
      static get pluginName() {
        return "ImageUpload";
      }
      static get requires() {
        return [xy, iy, uy];
      }
    }, class extends Br {
      static get pluginName() {
        return "Indent";
      }
      static get requires() {
        return [sx, ax];
      }
    }, class extends Br {
      static get requires() {
        return [Xx, aE, dE];
      }
      static get pluginName() {
        return "Link";
      }
    }, TD, class extends Br {
      static get requires() {
        return [YD, eI, ZD, kA];
      }
      static get pluginName() {
        return "MediaEmbed";
      }
    }, UC, class extends Br {
      static get pluginName() {
        return "PasteFromOffice";
      }
      static get requires() {
        return [Jb];
      }
      init() {
        const t = this.editor,
          e = t.plugins.get("ClipboardPipeline"),
          n = t.editing.view.document,
          o = [],
          i = this.editor.plugins.has("MultiLevelList");
        o.push(new DI(n, i)), o.push(new SI(n)), o.push(new NI(n)), e.on("inputTransformation", (e, i) => {
          if (i._isTransformedWithPasteFromOffice) return;
          if (t.model.document.selection.getFirstPosition().parent.is("element", "codeBlock")) return;
          const r = i.dataTransfer.getData("text/html"),
            s = o.find(t => t.isActive(r));
          s && (i._parsedData || (i._parsedData = OI(r, n.stylesProcessor)), s.execute(i), i._isTransformedWithPasteFromOffice = !0);
        }, {
          priority: "high"
        });
      }
    }, class extends Br {
      static get requires() {
        return [Bv, lv];
      }
      static get pluginName() {
        return "PictureEditing";
      }
      afterInit() {
        const t = this.editor;
        t.plugins.has("ImageBlockEditing") && t.model.schema.extend("imageBlock", {
          allowAttributes: ["sources"]
        }), t.plugins.has("ImageInlineEditing") && t.model.schema.extend("imageInline", {
          allowAttributes: ["sources"]
        }), this._setupConversion(), this._setupImageUploadEditingIntegration();
      }
      _setupConversion() {
        const t = this.editor,
          e = t.conversion,
          n = t.plugins.get("ImageUtils");
        e.for("upcast").add(function (t) {
          const e = ["srcset", "media", "type", "sizes"],
            n = (n, o, i) => {
              const r = o.viewItem;
              if (!i.consumable.test(r, {
                name: !0
              })) return;
              const s = new Map();
              for (const t of r.getChildren()) if (t.is("element", "source")) {
                const n = {};
                for (const o of e) t.hasAttribute(o) && i.consumable.test(t, {
                  attributes: o
                }) && (n[o] = t.getAttribute(o));
                Object.keys(n).length && s.set(t, n);
              }
              const a = t.findViewImgElement(r);
              if (!a) return;
              let c = o.modelCursor.parent;
              if (!c.is("element", "imageBlock")) {
                const t = i.convertItem(a, o.modelCursor);
                o.modelRange = t.modelRange, o.modelCursor = t.modelCursor, c = Wi(t.modelRange.getItems());
              }
              i.consumable.consume(r, {
                name: !0
              });
              for (const [t, e] of s) i.consumable.consume(t, {
                attributes: Object.keys(e)
              });
              s.size && i.writer.setAttribute("sources", Array.from(s.values()), c), i.convertChildren(r, c);
            };
          return t => {
            t.on("element:picture", n);
          };
        }(n)), e.for("downcast").add(function (t) {
          const e = (e, n, o) => {
            if (!o.consumable.consume(n.item, e.name)) return;
            const i = o.writer,
              r = o.mapper.toViewElement(n.item),
              s = t.findViewImgElement(r),
              a = n.attributeNewValue;
            if (a && a.length) {
              const t = i.createContainerElement("picture", null, a.map(t => i.createEmptyElement("source", t))),
                e = [];
              let n = s.parent;
              for (; n && n.is("attributeElement");) {
                const t = n.parent;
                i.unwrap(i.createRangeOn(s), n), e.unshift(n), n = t;
              }
              i.insert(i.createPositionBefore(s), t), i.move(i.createRangeOn(s), i.createPositionAt(t, "end"));
              for (const n of e) i.wrap(i.createRangeOn(t), n);
            } else if (s.parent.is("element", "picture")) {
              const t = s.parent;
              i.move(i.createRangeOn(s), i.createPositionBefore(t)), i.remove(t);
            }
          };
          return t => {
            t.on("attribute:sources:imageBlock", e), t.on("attribute:sources:imageInline", e);
          };
        }(n));
      }
      _setupImageUploadEditingIntegration() {
        const t = this.editor;
        if (!t.plugins.has("ImageUploadEditing")) return;
        const e = t.plugins.get("ImageUploadEditing");
        this.listenTo(e, "uploadComplete", (e, {
          imageElement: n,
          data: o
        }) => {
          const i = o.sources;
          i && t.model.change(t => {
            t.setAttributes({
              sources: i
            }, n);
          });
        });
      }
    }, class extends Br {
      static get requires() {
        return [FT, GT, YT, nM, tM, QT, kA];
      }
      static get pluginName() {
        return "Table";
      }
    }, class extends Br {
      static get requires() {
        return [wA];
      }
      static get pluginName() {
        return "TableToolbar";
      }
      afterInit() {
        const t = this.editor,
          e = t.t,
          n = t.plugins.get(wA),
          o = t.config.get("table.contentToolbar"),
          i = t.config.get("table.tableToolbar");
        o && n.register("tableContent", {
          ariaLabel: e("Table toolbar"),
          items: o,
          getRelatedElement: aM
        }), i && n.register("table", {
          ariaLabel: e("Table toolbar"),
          items: i,
          getRelatedElement: sM
        });
      }
    }, class extends Br {
      static get requires() {
        return ["Delete", "Input"];
      }
      static get pluginName() {
        return "TextTransformation";
      }
      constructor(t) {
        super(t), t.config.define("typing", {
          transformations: {
            include: xw
          }
        });
      }
      init() {
        const t = this.editor.model.document.selection;
        t.on("change:range", () => {
          this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
        }), this._enableTransformationWatchers();
      }
      _enableTransformationWatchers() {
        const t = this.editor,
          e = t.model,
          n = t.plugins.get("Delete"),
          o = function (t) {
            const e = t.extra || [],
              n = t.remove || [],
              o = t => !n.includes(t);
            return function (t) {
              const e = new Set();
              for (const n of t) if ("string" == typeof n && yw[n]) for (const t of yw[n]) e.add(t);else e.add(n);
              return Array.from(e);
            }(t.include.concat(e).filter(o)).filter(o).map(t => "string" == typeof t && vw[t] ? vw[t] : t).filter(t => "object" == typeof t).map(t => ({
              from: Ew(t.from),
              to: Dw(t.to)
            }));
          }(t.config.get("typing.transformations")),
          i = new pw(t.model, t => {
            for (const e of o) {
              if (e.from.test(t)) return {
                normalizedTransformation: e
              };
            }
          });
        i.on("matched:data", (t, o) => {
          if (!o.batch.isTyping) return;
          const {
              from: i,
              to: r
            } = o.normalizedTransformation,
            s = i.exec(o.text),
            a = r(s.slice(1)),
            c = o.range;
          let l = s.index;
          e.enqueueChange(t => {
            for (let n = 1; n < s.length; n++) {
              const o = s[n],
                i = a[n - 1];
              if (null == i) {
                l += o.length;
                continue;
              }
              const r = c.start.getShiftedBy(l),
                d = e.createRange(r, r.getShiftedBy(o.length)),
                u = Iw(r);
              e.insertContent(t.createText(i, u), d), l += i.length;
            }
            e.enqueueChange(() => {
              n.requestUndoOnBackspace();
            });
          });
        }), i.bind("isEnabled").to(this);
      }
    }], FM.defaultConfig = {
      toolbar: {
        items: ["undo", "redo", "|", "heading", "|", "bold", "italic", "|", "link", "uploadImage", "insertTable", "blockQuote", "mediaEmbed", "|", "bulletedList", "numberedList", "outdent", "indent"]
      },
      image: {
        toolbar: ["imageStyle:inline", "imageStyle:block", "imageStyle:side", "|", "toggleImageCaption", "imageTextAlternative"]
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
      },
      language: "en"
    };
  })(), o = o.default;
})());
